//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.3.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Ai_Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    ask(authorization: any | undefined, body: KSLPlusAskRequest | undefined): Promise<RagAnswer> {
        let url_ = this.baseUrl + "/api/Ai/ask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAsk(_response);
        });
    }

    protected processAsk(response: Response): Promise<RagAnswer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RagAnswer.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RagAnswer>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    daten(authorization: any | undefined, body: DatenFrageRequest | undefined): Promise<DatenFrageAntwort> {
        let url_ = this.baseUrl + "/api/Ai/daten";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDaten(_response);
        });
    }

    protected processDaten(response: Response): Promise<DatenFrageAntwort> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DatenFrageAntwort.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DatenFrageAntwort>(null as any);
    }

    /**
     * @param app (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    chats(app: string | undefined, authorization: any | undefined): Promise<ChatUebersicht[]> {
        let url_ = this.baseUrl + "/api/Ai/chats?";
        if (app === null)
            throw new Error("The parameter 'app' cannot be null.");
        else if (app !== undefined)
            url_ += "app=" + encodeURIComponent("" + app) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChats(_response);
        });
    }

    protected processChats(response: Response): Promise<ChatUebersicht[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChatUebersicht.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChatUebersicht[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    chat(threadID: string, authorization: any | undefined): Promise<ChatNachricht[]> {
        let url_ = this.baseUrl + "/api/Ai/chat/{threadID}";
        if (threadID === undefined || threadID === null)
            throw new Error("The parameter 'threadID' must be defined.");
        url_ = url_.replace("{threadID}", encodeURIComponent("" + threadID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChat(_response);
        });
    }

    protected processChat(response: Response): Promise<ChatNachricht[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChatNachricht.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChatNachricht[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return No Content
     */
    chatUmbenennen(threadID: string, authorization: any | undefined, body: ChatUmbenennenRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Ai/chatUmbenennen/{threadID}";
        if (threadID === undefined || threadID === null)
            throw new Error("The parameter 'threadID' must be defined.");
        url_ = url_.replace("{threadID}", encodeURIComponent("" + threadID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChatUmbenennen(_response);
        });
    }

    protected processChatUmbenennen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return No Content
     */
    chatLoeschen(threadID: string, authorization: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Ai/chatLoeschen/{threadID}";
        if (threadID === undefined || threadID === null)
            throw new Error("The parameter 'threadID' must be defined.");
        url_ = url_.replace("{threadID}", encodeURIComponent("" + threadID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChatLoeschen(_response);
        });
    }

    protected processChatLoeschen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param wert (optional) 
     * @param threadID (optional) 
     * @param authorization (optional) 
     * @return No Content
     */
    bewerten(historieID: number, wert: number | undefined, threadID: string | undefined, authorization: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Ai/bewerten/{historieID}?";
        if (historieID === undefined || historieID === null)
            throw new Error("The parameter 'historieID' must be defined.");
        url_ = url_.replace("{historieID}", encodeURIComponent("" + historieID));
        if (wert === null)
            throw new Error("The parameter 'wert' cannot be null.");
        else if (wert !== undefined)
            url_ += "wert=" + encodeURIComponent("" + wert) + "&";
        if (threadID === null)
            throw new Error("The parameter 'threadID' cannot be null.");
        else if (threadID !== undefined)
            url_ += "threadID=" + encodeURIComponent("" + threadID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBewerten(_response);
        });
    }

    protected processBewerten(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param pfad (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    dokument(pfad: string | undefined, authorization: any | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Ai/dokument?";
        if (pfad === null)
            throw new Error("The parameter 'pfad' cannot be null.");
        else if (pfad !== undefined)
            url_ += "pfad=" + encodeURIComponent("" + pfad) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDokument(_response);
        });
    }

    protected processDokument(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param pfad (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    bild(pfad: string | undefined, authorization: any | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Ai/bild?";
        if (pfad === null)
            throw new Error("The parameter 'pfad' cannot be null.");
        else if (pfad !== undefined)
            url_ += "pfad=" + encodeURIComponent("" + pfad) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBild(_response);
        });
    }

    protected processBild(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    sprachToken(authorization: any | undefined): Promise<SprachToken> {
        let url_ = this.baseUrl + "/api/Ai/sprachToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSprachToken(_response);
        });
    }

    protected processSprachToken(response: Response): Promise<SprachToken> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SprachToken.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status === 502) {
            return response.text().then((_responseText) => {
            return throwException("Bad Gateway", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SprachToken>(null as any);
    }
}

export class Authenticate_Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    login(authorization: any | undefined, body: LoginModel | undefined): Promise<LoginResponse> {
        let url_ = this.baseUrl + "/api/Authenticate/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<LoginResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginResponse>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    refreshToken(authorization: any | undefined, body: RefreshTokenModel | undefined): Promise<LoginResponse> {
        let url_ = this.baseUrl + "/api/Authenticate/RefreshToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRefreshToken(_response);
        });
    }

    protected processRefreshToken(response: Response): Promise<LoginResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginResponse>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    register(authorization: any | undefined, body: RegisterModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Authenticate/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    registerAdmin(authorization: any | undefined, body: RegisterModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Authenticate/register-admin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegisterAdmin(_response);
        });
    }

    protected processRegisterAdmin(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    registerCustomeradmin(authorization: any | undefined, body: RegisterModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Authenticate/register-customeradmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegisterCustomeradmin(_response);
        });
    }

    protected processRegisterCustomeradmin(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    registerCustomeruser(authorization: any | undefined, body: RegisterModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Authenticate/register-customeruser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegisterCustomeruser(_response);
        });
    }

    protected processRegisterCustomeruser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    registerUser(authorization: any | undefined, body: RegisterModel | undefined): Promise<AuthResponse> {
        let url_ = this.baseUrl + "/api/Authenticate/RegisterUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegisterUser(_response);
        });
    }

    protected processRegisterUser(response: Response): Promise<AuthResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AuthResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthResponse>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyUser(authorization: any | undefined, body: ModifyUserModel | undefined): Promise<AuthResponse> {
        let url_ = this.baseUrl + "/api/Authenticate/ModifyUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyUser(_response);
        });
    }

    protected processModifyUser(response: Response): Promise<AuthResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = AuthResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthResponse>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    deleteUser(user: string, authorization: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Authenticate/DeleteUser/{user}";
        if (user === undefined || user === null)
            throw new Error("The parameter 'user' must be defined.");
        url_ = url_.replace("{user}", encodeURIComponent("" + user));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteUser(_response);
        });
    }

    protected processDeleteUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    getAvailableRoles(kunde: number | undefined, authorization: any | undefined): Promise<AspNetRole[]> {
        let url_ = this.baseUrl + "/api/Authenticate/GetAvailableRoles?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAvailableRoles(_response);
        });
    }

    protected processGetAvailableRoles(response: Response): Promise<AspNetRole[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AspNetRole.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AspNetRole[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addRole(authorization: any | undefined, body: AddRoleModel | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Authenticate/AddRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddRole(_response);
        });
    }

    protected processAddRole(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param role (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    removeRole(kunde: number | undefined, role: string | undefined, authorization: any | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Authenticate/RemoveRole?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (role === null)
            throw new Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveRole(_response);
        });
    }

    protected processRemoveRole(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getUsers(kunde: number, withownuser: boolean, checkRoles: boolean, authorization: any | undefined): Promise<RegisteredUserModel[]> {
        let url_ = this.baseUrl + "/api/Authenticate/GetUsers/{kunde}/{withownuser}/{checkRoles}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (withownuser === undefined || withownuser === null)
            throw new Error("The parameter 'withownuser' must be defined.");
        url_ = url_.replace("{withownuser}", encodeURIComponent("" + withownuser));
        if (checkRoles === undefined || checkRoles === null)
            throw new Error("The parameter 'checkRoles' must be defined.");
        url_ = url_.replace("{checkRoles}", encodeURIComponent("" + checkRoles));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: Response): Promise<RegisteredUserModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegisteredUserModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegisteredUserModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    sendPasswordResetToken(user: string, authorization: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Authenticate/SendPasswordResetToken/{user}";
        if (user === undefined || user === null)
            throw new Error("The parameter 'user' must be defined.");
        url_ = url_.replace("{user}", encodeURIComponent("" + user));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendPasswordResetToken(_response);
        });
    }

    protected processSendPasswordResetToken(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getOwnPasswordResetToken(authorization: any | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Authenticate/GetOwnPasswordResetToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOwnPasswordResetToken(_response);
        });
    }

    protected processGetOwnPasswordResetToken(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    resetPassword(authorization: any | undefined, body: ResetPasswordModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Authenticate/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    changePassword(authorization: any | undefined, body: ChangePasswordModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Authenticate/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getRechte(authorization: any | undefined): Promise<Rechte[]> {
        let url_ = this.baseUrl + "/api/Authenticate/GetRechte";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRechte(_response);
        });
    }

    protected processGetRechte(response: Response): Promise<Rechte[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Rechte.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Rechte[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getRechteByRole(kunde: number, role: string, authorization: any | undefined): Promise<Rechte2Role[]> {
        let url_ = this.baseUrl + "/api/Authenticate/GetRechteByRole/{kunde}/{role}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (role === undefined || role === null)
            throw new Error("The parameter 'role' must be defined.");
        url_ = url_.replace("{role}", encodeURIComponent("" + role));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRechteByRole(_response);
        });
    }

    protected processGetRechteByRole(response: Response): Promise<Rechte2Role[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Rechte2Role.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Rechte2Role[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setRechteByRole(authorization: any | undefined, body: Rechte2Role[] | undefined): Promise<Rechte2Role[]> {
        let url_ = this.baseUrl + "/api/Authenticate/SetRechteByRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetRechteByRole(_response);
        });
    }

    protected processSetRechteByRole(response: Response): Promise<Rechte2Role[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Rechte2Role.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Rechte2Role[]>(null as any);
    }
}

export class Backup_Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    elemente(authorization: any | undefined): Promise<BackupElementModel[]> {
        let url_ = this.baseUrl + "/api/backup/elemente";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processElemente(_response);
        });
    }

    protected processElemente(response: Response): Promise<BackupElementModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BackupElementModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BackupElementModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    zeitplan(kunde: number, authorization: any | undefined): Promise<BackupZeitplanModel> {
        let url_ = this.baseUrl + "/api/backup/zeitplan/{kunde}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processZeitplan(_response);
        });
    }

    protected processZeitplan(response: Response): Promise<BackupZeitplanModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BackupZeitplanModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BackupZeitplanModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    zeitplanSpeichern(kunde: number, authorization: any | undefined, body: BackupZeitplanModel | undefined): Promise<BackupZeitplanModel> {
        let url_ = this.baseUrl + "/api/backup/zeitplanSpeichern/{kunde}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processZeitplanSpeichern(_response);
        });
    }

    protected processZeitplanSpeichern(response: Response): Promise<BackupZeitplanModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BackupZeitplanModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BackupZeitplanModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    jetztSichern(kunde: number, authorization: any | undefined): Promise<BackupLaufModel> {
        let url_ = this.baseUrl + "/api/backup/jetztSichern/{kunde}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processJetztSichern(_response);
        });
    }

    protected processJetztSichern(response: Response): Promise<BackupLaufModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BackupLaufModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BackupLaufModel>(null as any);
    }

    /**
     * @param anzahl (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    laeufe(kunde: number, anzahl: number | undefined, authorization: any | undefined): Promise<BackupLaufModel[]> {
        let url_ = this.baseUrl + "/api/backup/laeufe/{kunde}?";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (anzahl === null)
            throw new Error("The parameter 'anzahl' cannot be null.");
        else if (anzahl !== undefined)
            url_ += "anzahl=" + encodeURIComponent("" + anzahl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLaeufe(_response);
        });
    }

    protected processLaeufe(response: Response): Promise<BackupLaufModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BackupLaufModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BackupLaufModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    lauf(id: number, authorization: any | undefined): Promise<BackupLaufModel> {
        let url_ = this.baseUrl + "/api/backup/lauf/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLauf(_response);
        });
    }

    protected processLauf(response: Response): Promise<BackupLaufModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BackupLaufModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BackupLaufModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    manifest(kunde: number, authorization: any | undefined): Promise<BackupManifestModel[]> {
        let url_ = this.baseUrl + "/api/backup/manifest/{kunde}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processManifest(_response);
        });
    }

    protected processManifest(response: Response): Promise<BackupManifestModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BackupManifestModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BackupManifestModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    staende(kunde: number, authorization: any | undefined): Promise<BackupStandModel[]> {
        let url_ = this.baseUrl + "/api/backup/staende/{kunde}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStaende(_response);
        });
    }

    protected processStaende(response: Response): Promise<BackupStandModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BackupStandModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BackupStandModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    standAktivieren(kunde: number, standId: number, authorization: any | undefined): Promise<BackupLaufModel> {
        let url_ = this.baseUrl + "/api/backup/standAktivieren/{kunde}/{standId}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (standId === undefined || standId === null)
            throw new Error("The parameter 'standId' must be defined.");
        url_ = url_.replace("{standId}", encodeURIComponent("" + standId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStandAktivieren(_response);
        });
    }

    protected processStandAktivieren(response: Response): Promise<BackupLaufModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BackupLaufModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BackupLaufModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    standLoeschen(kunde: number, standId: number, authorization: any | undefined): Promise<BackupLaufModel> {
        let url_ = this.baseUrl + "/api/backup/standLoeschen/{kunde}/{standId}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (standId === undefined || standId === null)
            throw new Error("The parameter 'standId' must be defined.");
        url_ = url_.replace("{standId}", encodeURIComponent("" + standId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStandLoeschen(_response);
        });
    }

    protected processStandLoeschen(response: Response): Promise<BackupLaufModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BackupLaufModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BackupLaufModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    restoreVorschau(kunde: number, authorization: any | undefined, body: RestoreAnfrageModel | undefined): Promise<RestoreVorschauModel> {
        let url_ = this.baseUrl + "/api/backup/restoreVorschau/{kunde}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRestoreVorschau(_response);
        });
    }

    protected processRestoreVorschau(response: Response): Promise<RestoreVorschauModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RestoreVorschauModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RestoreVorschauModel>(null as any);
    }

    /**
     * @param element (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    restoreEintraege(kunde: number, element: string | undefined, gemeinde: number | undefined, jahr: number | undefined, authorization: any | undefined): Promise<RestoreEintragModel[]> {
        let url_ = this.baseUrl + "/api/backup/restoreEintraege/{kunde}?";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (element === null)
            throw new Error("The parameter 'element' cannot be null.");
        else if (element !== undefined)
            url_ += "element=" + encodeURIComponent("" + element) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRestoreEintraege(_response);
        });
    }

    protected processRestoreEintraege(response: Response): Promise<RestoreEintragModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RestoreEintragModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RestoreEintragModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    restoreAusfuehren(kunde: number, authorization: any | undefined, body: RestoreAnfrageModel | undefined): Promise<BackupLaufModel> {
        let url_ = this.baseUrl + "/api/backup/restoreAusfuehren/{kunde}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRestoreAusfuehren(_response);
        });
    }

    protected processRestoreAusfuehren(response: Response): Promise<BackupLaufModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BackupLaufModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BackupLaufModel>(null as any);
    }

    /**
     * @param bestaetigung (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    rueckgaengig(id: number, bestaetigung: string | undefined, authorization: any | undefined): Promise<BackupLaufModel> {
        let url_ = this.baseUrl + "/api/backup/rueckgaengig/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (bestaetigung === null)
            throw new Error("The parameter 'bestaetigung' cannot be null.");
        else if (bestaetigung !== undefined)
            url_ += "bestaetigung=" + encodeURIComponent("" + bestaetigung) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRueckgaengig(_response);
        });
    }

    protected processRueckgaengig(response: Response): Promise<BackupLaufModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BackupLaufModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BackupLaufModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    transferSchritte(authorization: any | undefined): Promise<TransferSchrittModel[]> {
        let url_ = this.baseUrl + "/api/backup/transferSchritte";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTransferSchritte(_response);
        });
    }

    protected processTransferSchritte(response: Response): Promise<TransferSchrittModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransferSchrittModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransferSchrittModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    transferZiele(authorization: any | undefined): Promise<TransferZielModel[]> {
        let url_ = this.baseUrl + "/api/backup/transferZiele";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTransferZiele(_response);
        });
    }

    protected processTransferZiele(response: Response): Promise<TransferZielModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransferZielModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransferZielModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    transferVorschau(kunde: number, authorization: any | undefined, body: TransferAnfrageModel | undefined): Promise<TransferVorschauModel> {
        let url_ = this.baseUrl + "/api/backup/transferVorschau/{kunde}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTransferVorschau(_response);
        });
    }

    protected processTransferVorschau(response: Response): Promise<TransferVorschauModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransferVorschauModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransferVorschauModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    transferAusfuehren(kunde: number, authorization: any | undefined, body: TransferAnfrageModel | undefined): Promise<BackupLaufModel[]> {
        let url_ = this.baseUrl + "/api/backup/transferAusfuehren/{kunde}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTransferAusfuehren(_response);
        });
    }

    protected processTransferAusfuehren(response: Response): Promise<BackupLaufModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BackupLaufModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BackupLaufModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    status(authorization: any | undefined): Promise<BackupStatusModel> {
        let url_ = this.baseUrl + "/api/backup/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStatus(_response);
        });
    }

    protected processStatus(response: Response): Promise<BackupStatusModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BackupStatusModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BackupStatusModel>(null as any);
    }
}

export class Design_Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param ansicht (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    draftGet(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, ansicht: number | undefined, authorization: any | undefined): Promise<DesignConfigResponse> {
        let url_ = this.baseUrl + "/api/Design/draft?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (ansicht === null)
            throw new Error("The parameter 'ansicht' cannot be null.");
        else if (ansicht !== undefined)
            url_ += "ansicht=" + encodeURIComponent("" + ansicht) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDraftGet(_response);
        });
    }

    protected processDraftGet(response: Response): Promise<DesignConfigResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DesignConfigResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DesignConfigResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    draftPut(body: SaveDesignConfigRequest | undefined): Promise<DesignConfigResponse> {
        let url_ = this.baseUrl + "/api/Design/draft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDraftPut(_response);
        });
    }

    protected processDraftPut(response: Response): Promise<DesignConfigResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DesignConfigResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DesignConfigResponse>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param ansicht (optional) 
     * @return OK
     */
    draftDelete(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, ansicht: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Design/draft?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (ansicht === null)
            throw new Error("The parameter 'ansicht' cannot be null.");
        else if (ansicht !== undefined)
            url_ += "ansicht=" + encodeURIComponent("" + ansicht) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDraftDelete(_response);
        });
    }

    protected processDraftDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param ansicht (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    configGet(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, ansicht: number | undefined, authorization: any | undefined): Promise<DesignConfigResponse> {
        let url_ = this.baseUrl + "/api/Design/config?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (ansicht === null)
            throw new Error("The parameter 'ansicht' cannot be null.");
        else if (ansicht !== undefined)
            url_ += "ansicht=" + encodeURIComponent("" + ansicht) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConfigGet(_response);
        });
    }

    protected processConfigGet(response: Response): Promise<DesignConfigResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DesignConfigResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DesignConfigResponse>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    configPost(authorization: any | undefined, body: SaveDesignConfigRequest | undefined): Promise<DesignConfigResponse> {
        let url_ = this.baseUrl + "/api/Design/config";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConfigPost(_response);
        });
    }

    protected processConfigPost(response: Response): Promise<DesignConfigResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DesignConfigResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DesignConfigResponse>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param ansicht (optional) 
     * @return OK
     */
    configDelete(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, ansicht: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Design/config?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (ansicht === null)
            throw new Error("The parameter 'ansicht' cannot be null.");
        else if (ansicht !== undefined)
            url_ += "ansicht=" + encodeURIComponent("" + ansicht) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConfigDelete(_response);
        });
    }

    protected processConfigDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    activate(authorization: any | undefined, body: ActivateDesignRequest | undefined): Promise<DesignConfigResponse> {
        let url_ = this.baseUrl + "/api/Design/activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivate(_response);
        });
    }

    protected processActivate(response: Response): Promise<DesignConfigResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DesignConfigResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DesignConfigResponse>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param ansicht (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    versionsGet(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, ansicht: number | undefined, authorization: any | undefined): Promise<DesignVersionInfo[]> {
        let url_ = this.baseUrl + "/api/Design/versions?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (ansicht === null)
            throw new Error("The parameter 'ansicht' cannot be null.");
        else if (ansicht !== undefined)
            url_ += "ansicht=" + encodeURIComponent("" + ansicht) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVersionsGet(_response);
        });
    }

    protected processVersionsGet(response: Response): Promise<DesignVersionInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DesignVersionInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DesignVersionInfo[]>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param ansicht (optional) 
     * @return OK
     */
    versionsDelete(version: number, kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, ansicht: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Design/versions/{version}?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (ansicht === null)
            throw new Error("The parameter 'ansicht' cannot be null.");
        else if (ansicht !== undefined)
            url_ += "ansicht=" + encodeURIComponent("" + ansicht) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVersionsDelete(_response);
        });
    }

    protected processVersionsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param ansicht (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    history(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, ansicht: number | undefined, authorization: any | undefined): Promise<DesignVersionInfo[]> {
        let url_ = this.baseUrl + "/api/Design/history?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (ansicht === null)
            throw new Error("The parameter 'ansicht' cannot be null.");
        else if (ansicht !== undefined)
            url_ += "ansicht=" + encodeURIComponent("" + ansicht) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHistory(_response);
        });
    }

    protected processHistory(response: Response): Promise<DesignVersionInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DesignVersionInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DesignVersionInfo[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    rollback(authorization: any | undefined, body: RollbackRequest | undefined): Promise<DesignConfigResponse> {
        let url_ = this.baseUrl + "/api/Design/rollback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRollback(_response);
        });
    }

    protected processRollback(response: Response): Promise<DesignConfigResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DesignConfigResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DesignConfigResponse>(null as any);
    }

    /**
     * @param kategorie (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    templates(kategorie: string | undefined, authorization: any | undefined): Promise<DesignTemplateResponse[]> {
        let url_ = this.baseUrl + "/api/Design/templates?";
        if (kategorie === null)
            throw new Error("The parameter 'kategorie' cannot be null.");
        else if (kategorie !== undefined)
            url_ += "kategorie=" + encodeURIComponent("" + kategorie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTemplates(_response);
        });
    }

    protected processTemplates(response: Response): Promise<DesignTemplateResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DesignTemplateResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DesignTemplateResponse[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    template(id: number, authorization: any | undefined): Promise<DesignTemplateResponse> {
        let url_ = this.baseUrl + "/api/Design/template/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTemplate(_response);
        });
    }

    protected processTemplate(response: Response): Promise<DesignTemplateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DesignTemplateResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DesignTemplateResponse>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    gemeinden(kunde: number | undefined, gemeinde: number | undefined, authorization: any | undefined): Promise<DesignGemeindeInfo[]> {
        let url_ = this.baseUrl + "/api/Design/gemeinden?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGemeinden(_response);
        });
    }

    protected processGemeinden(response: Response): Promise<DesignGemeindeInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DesignGemeindeInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DesignGemeindeInfo[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    transfer(authorization: any | undefined, body: TransferDesignRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Design/transfer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTransfer(_response);
        });
    }

    protected processTransfer(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    allKunden(authorization: any | undefined): Promise<DesignKundeInfo[]> {
        let url_ = this.baseUrl + "/api/Design/all-kunden";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAllKunden(_response);
        });
    }

    protected processAllKunden(response: Response): Promise<DesignKundeInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DesignKundeInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DesignKundeInfo[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    transferExtern(authorization: any | undefined, body: ExternTransferDesignRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Design/transfer-extern";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTransferExtern(_response);
        });
    }

    protected processTransferExtern(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class Config_Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param ansicht (optional) 
     * @param version (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    preview(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, ansicht: number | undefined, version: number | undefined, authorization: any | undefined): Promise<DesignConfigResponse> {
        let url_ = this.baseUrl + "/api/Design/config/preview?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (ansicht === null)
            throw new Error("The parameter 'ansicht' cannot be null.");
        else if (ansicht !== undefined)
            url_ += "ansicht=" + encodeURIComponent("" + ansicht) + "&";
        if (version === null)
            throw new Error("The parameter 'version' cannot be null.");
        else if (version !== undefined)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPreview(_response);
        });
    }

    protected processPreview(response: Response): Promise<DesignConfigResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DesignConfigResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DesignConfigResponse>(null as any);
    }
}

export class Templates_Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    apply(authorization: any | undefined, body: ApplyTemplateRequest | undefined): Promise<DesignConfigResponse> {
        let url_ = this.baseUrl + "/api/Design/templates/apply";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApply(_response);
        });
    }

    protected processApply(response: Response): Promise<DesignConfigResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DesignConfigResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DesignConfigResponse>(null as any);
    }
}

export class DigitalHoushold_Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    customers(authorization: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/customers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomers(_response);
        });
    }

    protected processCustomers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getHaushaltByGruppierung(authorization: any | undefined, body: HaushaltRequest | undefined): Promise<HaushaltsEbene> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/GetHaushaltByGruppierung";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHaushaltByGruppierung(_response);
        });
    }

    protected processGetHaushaltByGruppierung(response: Response): Promise<HaushaltsEbene> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsEbene.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsEbene>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getFilteredHaushaltByGruppierung(authorization: any | undefined, body: HaushaltRequest | undefined): Promise<HaushaltsEbene> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/GetFilteredHaushaltByGruppierung";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFilteredHaushaltByGruppierung(_response);
        });
    }

    protected processGetFilteredHaushaltByGruppierung(response: Response): Promise<HaushaltsEbene> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsEbene.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsEbene>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getHaushaltByGliederung(authorization: any | undefined, body: HaushaltRequest | undefined): Promise<HaushaltsEbene> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/GetHaushaltByGliederung";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHaushaltByGliederung(_response);
        });
    }

    protected processGetHaushaltByGliederung(response: Response): Promise<HaushaltsEbene> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsEbene.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsEbene>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getFilteredHaushaltByGliederung(authorization: any | undefined, body: HaushaltRequest | undefined): Promise<HaushaltsEbene> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/GetFilteredHaushaltByGliederung";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFilteredHaushaltByGliederung(_response);
        });
    }

    protected processGetFilteredHaushaltByGliederung(response: Response): Promise<HaushaltsEbene> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsEbene.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsEbene>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getFilteredHaushaltByEbene(authorization: any | undefined, body: HaushaltRequest | undefined): Promise<HaushaltsEbene> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/GetFilteredHaushaltByEbene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFilteredHaushaltByEbene(_response);
        });
    }

    protected processGetFilteredHaushaltByEbene(response: Response): Promise<HaushaltsEbene> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsEbene.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsEbene>(null as any);
    }

    /**
     * @param plantyp (optional) 
     * @param planstufe (optional) 
     * @param vm (optional) 
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    toplevelebenen(plantyp: number | undefined, planstufe: number | undefined, vm: boolean | undefined, authorization: any | undefined, body: JahrModel | undefined): Promise<Ebenen[]> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/toplevelebenen?";
        if (plantyp === null)
            throw new Error("The parameter 'plantyp' cannot be null.");
        else if (plantyp !== undefined)
            url_ += "plantyp=" + encodeURIComponent("" + plantyp) + "&";
        if (planstufe === null)
            throw new Error("The parameter 'planstufe' cannot be null.");
        else if (planstufe !== undefined)
            url_ += "planstufe=" + encodeURIComponent("" + planstufe) + "&";
        if (vm === null)
            throw new Error("The parameter 'vm' cannot be null.");
        else if (vm !== undefined)
            url_ += "vm=" + encodeURIComponent("" + vm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processToplevelebenen(_response);
        });
    }

    protected processToplevelebenen(response: Response): Promise<Ebenen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Ebenen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Ebenen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getHaushaltByEbene(authorization: any | undefined, body: HaushaltRequest | undefined): Promise<HaushaltsEbene> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/GetHaushaltByEbene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHaushaltByEbene(_response);
        });
    }

    protected processGetHaushaltByEbene(response: Response): Promise<HaushaltsEbene> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsEbene.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsEbene>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getFilteredHaushaltsEbeneByGruppierung(authorization: any | undefined, body: HaushaltRequest | undefined): Promise<HaushaltsEbene> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/GetFilteredHaushaltsEbeneByGruppierung";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFilteredHaushaltsEbeneByGruppierung(_response);
        });
    }

    protected processGetFilteredHaushaltsEbeneByGruppierung(response: Response): Promise<HaushaltsEbene> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsEbene.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsEbene>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    bilder(kunde: number, gemeinde: number, jahr: number, typ: number, authorization: any | undefined): Promise<Bilder[]> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/bilder/{kunde}/{gemeinde}/{jahr}/{typ}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (typ === undefined || typ === null)
            throw new Error("The parameter 'typ' must be defined.");
        url_ = url_.replace("{typ}", encodeURIComponent("" + typ));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBilder(_response);
        });
    }

    protected processBilder(response: Response): Promise<Bilder[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Bilder.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Bilder[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    dokumente(kunde: number, gemeinde: number, jahr: number, typ: number, modul: number, authorization: any | undefined): Promise<Dokumente[]> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/dokumente/{kunde}/{gemeinde}/{jahr}/{typ}/{modul}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (typ === undefined || typ === null)
            throw new Error("The parameter 'typ' must be defined.");
        url_ = url_.replace("{typ}", encodeURIComponent("" + typ));
        if (modul === undefined || modul === null)
            throw new Error("The parameter 'modul' must be defined.");
        url_ = url_.replace("{modul}", encodeURIComponent("" + modul));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDokumente(_response);
        });
    }

    protected processDokumente(response: Response): Promise<Dokumente[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Dokumente.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Dokumente[]>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param modul (optional) 
     * @param verwaltung (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    dokumenttree(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, modul: number | undefined, verwaltung: boolean | undefined, authorization: any | undefined): Promise<DokTreeModel> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/dokumenttree?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (modul === null)
            throw new Error("The parameter 'modul' cannot be null.");
        else if (modul !== undefined)
            url_ += "modul=" + encodeURIComponent("" + modul) + "&";
        if (verwaltung === null)
            throw new Error("The parameter 'verwaltung' cannot be null.");
        else if (verwaltung !== undefined)
            url_ += "verwaltung=" + encodeURIComponent("" + verwaltung) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDokumenttree(_response);
        });
    }

    protected processDokumenttree(response: Response): Promise<DokTreeModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DokTreeModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DokTreeModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    datensaetze(kunde: number, gemeinde: number, jahr: number, typ: number, modul: number, plantyp: number, planstufe: number, authorization: any | undefined): Promise<Datensaetze[]> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/datensaetze/{kunde}/{gemeinde}/{jahr}/{typ}/{modul}/{plantyp}/{planstufe}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (typ === undefined || typ === null)
            throw new Error("The parameter 'typ' must be defined.");
        url_ = url_.replace("{typ}", encodeURIComponent("" + typ));
        if (modul === undefined || modul === null)
            throw new Error("The parameter 'modul' must be defined.");
        url_ = url_.replace("{modul}", encodeURIComponent("" + modul));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDatensaetze(_response);
        });
    }

    protected processDatensaetze(response: Response): Promise<Datensaetze[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Datensaetze.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Datensaetze[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    texte(kunde: number, gemeinde: number, jahr: number, typ: number, authorization: any | undefined): Promise<Texte[]> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/texte/{kunde}/{gemeinde}/{jahr}/{typ}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (typ === undefined || typ === null)
            throw new Error("The parameter 'typ' must be defined.");
        url_ = url_.replace("{typ}", encodeURIComponent("" + typ));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTexte(_response);
        });
    }

    protected processTexte(response: Response): Promise<Texte[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Texte.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Texte[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    planstufe(kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, authorization: any | undefined): Promise<Planstufen> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/planstufe/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPlanstufe(_response);
        });
    }

    protected processPlanstufe(response: Response): Promise<Planstufen> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Planstufen.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Planstufen>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param nurOeffentliche (optional) 
     * @param jr (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    getVglPlanstufen(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, nurOeffentliche: boolean | undefined, jr: boolean | undefined, authorization: any | undefined): Promise<Planstufen[]> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/GetVglPlanstufen?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (nurOeffentliche === null)
            throw new Error("The parameter 'nurOeffentliche' cannot be null.");
        else if (nurOeffentliche !== undefined)
            url_ += "nurOeffentliche=" + encodeURIComponent("" + nurOeffentliche) + "&";
        if (jr === null)
            throw new Error("The parameter 'jr' cannot be null.");
        else if (jr !== undefined)
            url_ += "jr=" + encodeURIComponent("" + jr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVglPlanstufen(_response);
        });
    }

    protected processGetVglPlanstufen(response: Response): Promise<Planstufen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Planstufen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Planstufen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    settings(kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, modul: number, verwaltung: boolean, authorization: any | undefined): Promise<SettingsModel> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/settings/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}/{modul}/{verwaltung}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (modul === undefined || modul === null)
            throw new Error("The parameter 'modul' must be defined.");
        url_ = url_.replace("{modul}", encodeURIComponent("" + modul));
        if (verwaltung === undefined || verwaltung === null)
            throw new Error("The parameter 'verwaltung' must be defined.");
        url_ = url_.replace("{verwaltung}", encodeURIComponent("" + verwaltung));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSettings(_response);
        });
    }

    protected processSettings(response: Response): Promise<SettingsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SettingsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SettingsModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    needsLogin(kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/NeedsLogin/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processNeedsLogin(_response);
        });
    }

    protected processNeedsLogin(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getUHConfigs(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<UhConfigModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/GetUHConfigs/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUHConfigs(_response);
        });
    }

    protected processGetUHConfigs(response: Response): Promise<UhConfigModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UhConfigModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UhConfigModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getInvestSettings(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<InvestSettingModel> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/GetInvestSettings/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInvestSettings(_response);
        });
    }

    protected processGetInvestSettings(response: Response): Promise<InvestSettingModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvestSettingModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvestSettingModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getInvestitionen(plantyp: number, planstufe: number, uhconfig: number, authorization: any | undefined, body: JahrModel | undefined): Promise<InvestitionsModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/GetInvestitionen/{plantyp}/{planstufe}/{uhconfig}";
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (uhconfig === undefined || uhconfig === null)
            throw new Error("The parameter 'uhconfig' must be defined.");
        url_ = url_.replace("{uhconfig}", encodeURIComponent("" + uhconfig));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInvestitionen(_response);
        });
    }

    protected processGetInvestitionen(response: Response): Promise<InvestitionsModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvestitionsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvestitionsModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getKassenReste(plantyp: number, planstufe: number, authorization: any | undefined, body: JahrModel | undefined): Promise<KREbene> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/GetKassenReste/{plantyp}/{planstufe}";
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetKassenReste(_response);
        });
    }

    protected processGetKassenReste(response: Response): Promise<KREbene> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KREbene.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KREbene>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getHaushaltsReste(plantyp: number, planstufe: number, authorization: any | undefined, body: JahrModel | undefined): Promise<HREbene> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/GetHaushaltsReste/{plantyp}/{planstufe}";
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHaushaltsReste(_response);
        });
    }

    protected processGetHaushaltsReste(response: Response): Promise<HREbene> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HREbene.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HREbene>(null as any);
    }

    /**
     * @param plantyp (optional) 
     * @param planstufe (optional) 
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getVE(plantyp: number | undefined, planstufe: number | undefined, authorization: any | undefined, body: JahrModel | undefined): Promise<HaushaltsEbene> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/GetVE?";
        if (plantyp === null)
            throw new Error("The parameter 'plantyp' cannot be null.");
        else if (plantyp !== undefined)
            url_ += "plantyp=" + encodeURIComponent("" + plantyp) + "&";
        if (planstufe === null)
            throw new Error("The parameter 'planstufe' cannot be null.");
        else if (planstufe !== undefined)
            url_ += "planstufe=" + encodeURIComponent("" + planstufe) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVE(_response);
        });
    }

    protected processGetVE(response: Response): Promise<HaushaltsEbene> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsEbene.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsEbene>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getMassnahmen(authorization: any | undefined, body: JahrModel | undefined): Promise<Massnahman[]> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/GetMassnahmen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMassnahmen(_response);
        });
    }

    protected processGetMassnahmen(response: Response): Promise<Massnahman[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Massnahman.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Massnahman[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    tabs(kunde: number, gemeinde: number, jahr: number, tabtyp: number, modul: number, authorization: any | undefined): Promise<Vbtab[]> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/Tabs/{kunde}/{gemeinde}/{jahr}/{tabtyp}/{modul}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (tabtyp === undefined || tabtyp === null)
            throw new Error("The parameter 'tabtyp' must be defined.");
        url_ = url_.replace("{tabtyp}", encodeURIComponent("" + tabtyp));
        if (modul === undefined || modul === null)
            throw new Error("The parameter 'modul' must be defined.");
        url_ = url_.replace("{modul}", encodeURIComponent("" + modul));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTabs(_response);
        });
    }

    protected processTabs(response: Response): Promise<Vbtab[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Vbtab.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Vbtab[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    vBTabs(kunde: number, gemeinde: number, jahr: number, maintabs: boolean, modul: number, authorization: any | undefined): Promise<Vbtab[]> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/VBTabs/{kunde}/{gemeinde}/{jahr}/{maintabs}/{modul}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (maintabs === undefined || maintabs === null)
            throw new Error("The parameter 'maintabs' must be defined.");
        url_ = url_.replace("{maintabs}", encodeURIComponent("" + maintabs));
        if (modul === undefined || modul === null)
            throw new Error("The parameter 'modul' must be defined.");
        url_ = url_.replace("{modul}", encodeURIComponent("" + modul));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVBTabs(_response);
        });
    }

    protected processVBTabs(response: Response): Promise<Vbtab[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Vbtab.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Vbtab[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getTabTexte(kunde: number, gemeinde: number, jahr: number, tabId: string, authorization: any | undefined): Promise<Texte[]> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/GetTabTexte/{kunde}/{gemeinde}/{jahr}/{tabId}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (tabId === undefined || tabId === null)
            throw new Error("The parameter 'tabId' must be defined.");
        url_ = url_.replace("{tabId}", encodeURIComponent("" + tabId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTabTexte(_response);
        });
    }

    protected processGetTabTexte(response: Response): Promise<Texte[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Texte.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Texte[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    tabsByMainTab(kunde: number, gemeinde: number, jahr: number, maintab: string, modul: number, authorization: any | undefined): Promise<Vbtab[]> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/TabsByMainTab/{kunde}/{gemeinde}/{jahr}/{maintab}/{modul}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (maintab === undefined || maintab === null)
            throw new Error("The parameter 'maintab' must be defined.");
        url_ = url_.replace("{maintab}", encodeURIComponent("" + maintab));
        if (modul === undefined || modul === null)
            throw new Error("The parameter 'modul' must be defined.");
        url_ = url_.replace("{modul}", encodeURIComponent("" + modul));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTabsByMainTab(_response);
        });
    }

    protected processTabsByMainTab(response: Response): Promise<Vbtab[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Vbtab.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Vbtab[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    tab(kunde: number, gemeinde: number, jahr: number, tabid: string, authorization: any | undefined): Promise<Vbtab> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/Tab/{kunde}/{gemeinde}/{jahr}/{tabid}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (tabid === undefined || tabid === null)
            throw new Error("The parameter 'tabid' must be defined.");
        url_ = url_.replace("{tabid}", encodeURIComponent("" + tabid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTab(_response);
        });
    }

    protected processTab(response: Response): Promise<Vbtab> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Vbtab.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Vbtab>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    grundzahlen(kunde: number, gemeinde: number, jahr: number, modul: number, produkt: string, authorization: any | undefined): Promise<DatensatzModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/Grundzahlen/{kunde}/{gemeinde}/{jahr}/{modul}/{produkt}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (modul === undefined || modul === null)
            throw new Error("The parameter 'modul' must be defined.");
        url_ = url_.replace("{modul}", encodeURIComponent("" + modul));
        if (produkt === undefined || produkt === null)
            throw new Error("The parameter 'produkt' must be defined.");
        url_ = url_.replace("{produkt}", encodeURIComponent("" + produkt));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGrundzahlen(_response);
        });
    }

    protected processGrundzahlen(response: Response): Promise<DatensatzModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DatensatzModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DatensatzModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getKennzahlErgebnisse(authorization: any | undefined, body: KennzahlRequest | undefined): Promise<KennzahlModel> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/GetKennzahlErgebnisse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetKennzahlErgebnisse(_response);
        });
    }

    protected processGetKennzahlErgebnisse(response: Response): Promise<KennzahlModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KennzahlModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KennzahlModel>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param plantyp (optional) 
     * @param planstufe (optional) 
     * @param uhconfig (optional) 
     * @param verwaltungsansicht (optional) 
     * @param ebenen (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    aBCAnalysis(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, plantyp: number | undefined, planstufe: number | undefined, uhconfig: number | undefined, verwaltungsansicht: boolean | undefined, ebenen: string | undefined, authorization: any | undefined): Promise<ABCResult> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/ABCAnalysis?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (plantyp === null)
            throw new Error("The parameter 'plantyp' cannot be null.");
        else if (plantyp !== undefined)
            url_ += "plantyp=" + encodeURIComponent("" + plantyp) + "&";
        if (planstufe === null)
            throw new Error("The parameter 'planstufe' cannot be null.");
        else if (planstufe !== undefined)
            url_ += "planstufe=" + encodeURIComponent("" + planstufe) + "&";
        if (uhconfig === null)
            throw new Error("The parameter 'uhconfig' cannot be null.");
        else if (uhconfig !== undefined)
            url_ += "uhconfig=" + encodeURIComponent("" + uhconfig) + "&";
        if (verwaltungsansicht === null)
            throw new Error("The parameter 'verwaltungsansicht' cannot be null.");
        else if (verwaltungsansicht !== undefined)
            url_ += "verwaltungsansicht=" + encodeURIComponent("" + verwaltungsansicht) + "&";
        if (ebenen === null)
            throw new Error("The parameter 'ebenen' cannot be null.");
        else if (ebenen !== undefined)
            url_ += "ebenen=" + encodeURIComponent("" + ebenen) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processABCAnalysis(_response);
        });
    }

    protected processABCAnalysis(response: Response): Promise<ABCResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ABCResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ABCResult>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    topEAAnalysis(kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, vmh: boolean, uhconfig: number, authorization: any | undefined): Promise<TopEAResult> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/TopEAAnalysis/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}/{vmh}/{uhconfig}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (vmh === undefined || vmh === null)
            throw new Error("The parameter 'vmh' must be defined.");
        url_ = url_.replace("{vmh}", encodeURIComponent("" + vmh));
        if (uhconfig === undefined || uhconfig === null)
            throw new Error("The parameter 'uhconfig' must be defined.");
        url_ = url_.replace("{uhconfig}", encodeURIComponent("" + uhconfig));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTopEAAnalysis(_response);
        });
    }

    protected processTopEAAnalysis(response: Response): Promise<TopEAResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TopEAResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TopEAResult>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    topEAAnalyses(kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, verwaltung: boolean, uhconfig: number, authorization: any | undefined): Promise<TopEAResult[]> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/TopEAAnalyses/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}/{verwaltung}/{uhconfig}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (verwaltung === undefined || verwaltung === null)
            throw new Error("The parameter 'verwaltung' must be defined.");
        url_ = url_.replace("{verwaltung}", encodeURIComponent("" + verwaltung));
        if (uhconfig === undefined || uhconfig === null)
            throw new Error("The parameter 'uhconfig' must be defined.");
        url_ = url_.replace("{uhconfig}", encodeURIComponent("" + uhconfig));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTopEAAnalyses(_response);
        });
    }

    protected processTopEAAnalyses(response: Response): Promise<TopEAResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TopEAResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TopEAResult[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getRedisCacheKeys(authorization: any | undefined): Promise<RedisKey[]> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/GetRedisCacheKeys";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRedisCacheKeys(_response);
        });
    }

    protected processGetRedisCacheKeys(response: Response): Promise<RedisKey[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RedisKey.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RedisKey[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    clearRedisCacheByKey(key: string, authorization: any | undefined): Promise<{ [key: string]: number; }> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/ClearRedisCacheByKey/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processClearRedisCacheByKey(_response);
        });
    }

    protected processClearRedisCacheByKey(response: Response): Promise<{ [key: string]: number; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: number; }>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getRedisCacheInfo(authorization: any | undefined): Promise<{ [key: string]: number; }> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/GetRedisCacheInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRedisCacheInfo(_response);
        });
    }

    protected processGetRedisCacheInfo(response: Response): Promise<{ [key: string]: number; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: number; }>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    clearRedisCache(authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/ClearRedisCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processClearRedisCache(_response);
        });
    }

    protected processClearRedisCache(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    vBDatasets4Kennzahl(kennzahl: number, vgl: boolean, modul: number, authorization: any | undefined): Promise<DatensatzModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/VBDatasets4Kennzahl/{kennzahl}/{vgl}/{modul}";
        if (kennzahl === undefined || kennzahl === null)
            throw new Error("The parameter 'kennzahl' must be defined.");
        url_ = url_.replace("{kennzahl}", encodeURIComponent("" + kennzahl));
        if (vgl === undefined || vgl === null)
            throw new Error("The parameter 'vgl' must be defined.");
        url_ = url_.replace("{vgl}", encodeURIComponent("" + vgl));
        if (modul === undefined || modul === null)
            throw new Error("The parameter 'modul' must be defined.");
        url_ = url_.replace("{modul}", encodeURIComponent("" + modul));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVBDatasets4Kennzahl(_response);
        });
    }

    protected processVBDatasets4Kennzahl(response: Response): Promise<DatensatzModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DatensatzModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DatensatzModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    gZDatasets4Kennzahl(kennzahl: number, vgl: boolean, modul: number, authorization: any | undefined): Promise<DatensatzModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/GZDatasets4Kennzahl/{kennzahl}/{vgl}/{modul}";
        if (kennzahl === undefined || kennzahl === null)
            throw new Error("The parameter 'kennzahl' must be defined.");
        url_ = url_.replace("{kennzahl}", encodeURIComponent("" + kennzahl));
        if (vgl === undefined || vgl === null)
            throw new Error("The parameter 'vgl' must be defined.");
        url_ = url_.replace("{vgl}", encodeURIComponent("" + vgl));
        if (modul === undefined || modul === null)
            throw new Error("The parameter 'modul' must be defined.");
        url_ = url_.replace("{modul}", encodeURIComponent("" + modul));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGZDatasets4Kennzahl(_response);
        });
    }

    protected processGZDatasets4Kennzahl(response: Response): Promise<DatensatzModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DatensatzModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DatensatzModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    vBTabs4Kennzahl(kennzahl: number, vgl: boolean, modul: number, authorization: any | undefined): Promise<Vbtab[]> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/VBTabs4Kennzahl/{kennzahl}/{vgl}/{modul}";
        if (kennzahl === undefined || kennzahl === null)
            throw new Error("The parameter 'kennzahl' must be defined.");
        url_ = url_.replace("{kennzahl}", encodeURIComponent("" + kennzahl));
        if (vgl === undefined || vgl === null)
            throw new Error("The parameter 'vgl' must be defined.");
        url_ = url_.replace("{vgl}", encodeURIComponent("" + vgl));
        if (modul === undefined || modul === null)
            throw new Error("The parameter 'modul' must be defined.");
        url_ = url_.replace("{modul}", encodeURIComponent("" + modul));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVBTabs4Kennzahl(_response);
        });
    }

    protected processVBTabs4Kennzahl(response: Response): Promise<Vbtab[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Vbtab.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Vbtab[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    gZEbenen4Kennzahl(kennzahl: number, vgl: boolean, modul: number, authorization: any | undefined): Promise<Gzebene[]> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/GZEbenen4Kennzahl/{kennzahl}/{vgl}/{modul}";
        if (kennzahl === undefined || kennzahl === null)
            throw new Error("The parameter 'kennzahl' must be defined.");
        url_ = url_.replace("{kennzahl}", encodeURIComponent("" + kennzahl));
        if (vgl === undefined || vgl === null)
            throw new Error("The parameter 'vgl' must be defined.");
        url_ = url_.replace("{vgl}", encodeURIComponent("" + vgl));
        if (modul === undefined || modul === null)
            throw new Error("The parameter 'modul' must be defined.");
        url_ = url_.replace("{modul}", encodeURIComponent("" + modul));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGZEbenen4Kennzahl(_response);
        });
    }

    protected processGZEbenen4Kennzahl(response: Response): Promise<Gzebene[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Gzebene.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Gzebene[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getHaushaltVglByGliederung(plantypVgl: number, planstufeVgl: number, authorization: any | undefined, body: HaushaltRequest | undefined): Promise<HaushaltsEbene> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/GetHaushaltVglByGliederung/{plantypVgl}/{planstufeVgl}";
        if (plantypVgl === undefined || plantypVgl === null)
            throw new Error("The parameter 'plantypVgl' must be defined.");
        url_ = url_.replace("{plantypVgl}", encodeURIComponent("" + plantypVgl));
        if (planstufeVgl === undefined || planstufeVgl === null)
            throw new Error("The parameter 'planstufeVgl' must be defined.");
        url_ = url_.replace("{planstufeVgl}", encodeURIComponent("" + planstufeVgl));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHaushaltVglByGliederung(_response);
        });
    }

    protected processGetHaushaltVglByGliederung(response: Response): Promise<HaushaltsEbene> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsEbene.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsEbene>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getHaushaltVglByGruppierung(plantypVgl: number, planstufeVgl: number, authorization: any | undefined, body: HaushaltRequest | undefined): Promise<HaushaltsEbene> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/GetHaushaltVglByGruppierung/{plantypVgl}/{planstufeVgl}";
        if (plantypVgl === undefined || plantypVgl === null)
            throw new Error("The parameter 'plantypVgl' must be defined.");
        url_ = url_.replace("{plantypVgl}", encodeURIComponent("" + plantypVgl));
        if (planstufeVgl === undefined || planstufeVgl === null)
            throw new Error("The parameter 'planstufeVgl' must be defined.");
        url_ = url_.replace("{planstufeVgl}", encodeURIComponent("" + planstufeVgl));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHaushaltVglByGruppierung(_response);
        });
    }

    protected processGetHaushaltVglByGruppierung(response: Response): Promise<HaushaltsEbene> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsEbene.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsEbene>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getHaushaltVglByEbene(plantypVgl: number, planstufeVgl: number, authorization: any | undefined, body: HaushaltRequest | undefined): Promise<HaushaltsEbene> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/GetHaushaltVglByEbene/{plantypVgl}/{planstufeVgl}";
        if (plantypVgl === undefined || plantypVgl === null)
            throw new Error("The parameter 'plantypVgl' must be defined.");
        url_ = url_.replace("{plantypVgl}", encodeURIComponent("" + plantypVgl));
        if (planstufeVgl === undefined || planstufeVgl === null)
            throw new Error("The parameter 'planstufeVgl' must be defined.");
        url_ = url_.replace("{planstufeVgl}", encodeURIComponent("" + planstufeVgl));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHaushaltVglByEbene(_response);
        });
    }

    protected processGetHaushaltVglByEbene(response: Response): Promise<HaushaltsEbene> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsEbene.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsEbene>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getFilteredHaushaltVglByGruppierung(plantypVgl: number, planstufeVgl: number, authorization: any | undefined, body: HaushaltRequest | undefined): Promise<HaushaltsEbene> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/GetFilteredHaushaltVglByGruppierung/{plantypVgl}/{planstufeVgl}";
        if (plantypVgl === undefined || plantypVgl === null)
            throw new Error("The parameter 'plantypVgl' must be defined.");
        url_ = url_.replace("{plantypVgl}", encodeURIComponent("" + plantypVgl));
        if (planstufeVgl === undefined || planstufeVgl === null)
            throw new Error("The parameter 'planstufeVgl' must be defined.");
        url_ = url_.replace("{planstufeVgl}", encodeURIComponent("" + planstufeVgl));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFilteredHaushaltVglByGruppierung(_response);
        });
    }

    protected processGetFilteredHaushaltVglByGruppierung(response: Response): Promise<HaushaltsEbene> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsEbene.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsEbene>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getFilteredHaushaltVglByGliederung(plantypVgl: number, planstufeVgl: number, authorization: any | undefined, body: HaushaltRequest | undefined): Promise<HaushaltsEbene> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/GetFilteredHaushaltVglByGliederung/{plantypVgl}/{planstufeVgl}";
        if (plantypVgl === undefined || plantypVgl === null)
            throw new Error("The parameter 'plantypVgl' must be defined.");
        url_ = url_.replace("{plantypVgl}", encodeURIComponent("" + plantypVgl));
        if (planstufeVgl === undefined || planstufeVgl === null)
            throw new Error("The parameter 'planstufeVgl' must be defined.");
        url_ = url_.replace("{planstufeVgl}", encodeURIComponent("" + planstufeVgl));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFilteredHaushaltVglByGliederung(_response);
        });
    }

    protected processGetFilteredHaushaltVglByGliederung(response: Response): Promise<HaushaltsEbene> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsEbene.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsEbene>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getFilteredHaushaltVglByEbene(plantypVgl: number, planstufeVgl: number, authorization: any | undefined, body: HaushaltRequest | undefined): Promise<HaushaltsEbene> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/GetFilteredHaushaltVglByEbene/{plantypVgl}/{planstufeVgl}";
        if (plantypVgl === undefined || plantypVgl === null)
            throw new Error("The parameter 'plantypVgl' must be defined.");
        url_ = url_.replace("{plantypVgl}", encodeURIComponent("" + plantypVgl));
        if (planstufeVgl === undefined || planstufeVgl === null)
            throw new Error("The parameter 'planstufeVgl' must be defined.");
        url_ = url_.replace("{planstufeVgl}", encodeURIComponent("" + planstufeVgl));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFilteredHaushaltVglByEbene(_response);
        });
    }

    protected processGetFilteredHaushaltVglByEbene(response: Response): Promise<HaushaltsEbene> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsEbene.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsEbene>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getFilteredHaushaltsEbeneVglByGruppierung(plantypVgl: number, planstufeVgl: number, authorization: any | undefined, body: HaushaltRequest | undefined): Promise<HaushaltsEbene> {
        let url_ = this.baseUrl + "/api/DigitalHoushold/GetFilteredHaushaltsEbeneVglByGruppierung/{plantypVgl}/{planstufeVgl}";
        if (plantypVgl === undefined || plantypVgl === null)
            throw new Error("The parameter 'plantypVgl' must be defined.");
        url_ = url_.replace("{plantypVgl}", encodeURIComponent("" + plantypVgl));
        if (planstufeVgl === undefined || planstufeVgl === null)
            throw new Error("The parameter 'planstufeVgl' must be defined.");
        url_ = url_.replace("{planstufeVgl}", encodeURIComponent("" + planstufeVgl));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFilteredHaushaltsEbeneVglByGruppierung(_response);
        });
    }

    protected processGetFilteredHaushaltsEbeneVglByGruppierung(response: Response): Promise<HaushaltsEbene> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsEbene.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsEbene>(null as any);
    }
}

export class DigitalHousholdAdmin_Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getUser2Amt(userId: string, jahr: number, authorization: any | undefined): Promise<User2AmtModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetUser2Amt/{userId}/{jahr}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUser2Amt(_response);
        });
    }

    protected processGetUser2Amt(response: Response): Promise<User2AmtModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(User2AmtModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User2AmtModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setUser2Amt(userId: string, authorization: any | undefined, body: User2AmtModel[] | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/SetUser2Amt/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetUser2Amt(_response);
        });
    }

    protected processSetUser2Amt(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getImportFormate(authorization: any | undefined): Promise<ImportFormate[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetImportFormate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetImportFormate(_response);
        });
    }

    protected processGetImportFormate(response: Response): Promise<ImportFormate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImportFormate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportFormate[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    bundeslaender(authorization: any | undefined): Promise<Bundeslaender[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/bundeslaender";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBundeslaender(_response);
        });
    }

    protected processBundeslaender(response: Response): Promise<Bundeslaender[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Bundeslaender.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Bundeslaender[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    kundentypen(authorization: any | undefined): Promise<Kundentypen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/kundentypen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKundentypen(_response);
        });
    }

    protected processKundentypen(response: Response): Promise<Kundentypen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Kundentypen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Kundentypen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    kommunentypen(authorization: any | undefined): Promise<Kommunentypen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/kommunentypen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKommunentypen(_response);
        });
    }

    protected processKommunentypen(response: Response): Promise<Kommunentypen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Kommunentypen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Kommunentypen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    dokumententypen(authorization: any | undefined): Promise<Documententypen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/dokumententypen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDokumententypen(_response);
        });
    }

    protected processDokumententypen(response: Response): Promise<Documententypen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Documententypen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Documententypen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    vBTabTypen(authorization: any | undefined): Promise<VbtabTypen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/VBTabTypen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVBTabTypen(_response);
        });
    }

    protected processVBTabTypen(response: Response): Promise<VbtabTypen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VbtabTypen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VbtabTypen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    texttypen(authorization: any | undefined): Promise<Texttypen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/texttypen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTexttypen(_response);
        });
    }

    protected processTexttypen(response: Response): Promise<Texttypen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Texttypen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Texttypen[]>(null as any);
    }

    /**
     * @param doppisch (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    getTabTextOptionen(doppisch: boolean | undefined, authorization: any | undefined): Promise<TabTextBezeichnungsOptionen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetTabTextOptionen?";
        if (doppisch === null)
            throw new Error("The parameter 'doppisch' cannot be null.");
        else if (doppisch !== undefined)
            url_ += "doppisch=" + encodeURIComponent("" + doppisch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTabTextOptionen(_response);
        });
    }

    protected processGetTabTextOptionen(response: Response): Promise<TabTextBezeichnungsOptionen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TabTextBezeichnungsOptionen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TabTextBezeichnungsOptionen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    bildertypen(authorization: any | undefined): Promise<Bildertypen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/bildertypen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBildertypen(_response);
        });
    }

    protected processBildertypen(response: Response): Promise<Bildertypen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Bildertypen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Bildertypen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    datensatztypen(authorization: any | undefined): Promise<Datensatztypen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/datensatztypen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDatensatztypen(_response);
        });
    }

    protected processDatensatztypen(response: Response): Promise<Datensatztypen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Datensatztypen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Datensatztypen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    diagrammtypen(authorization: any | undefined): Promise<Diagrammtypen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/diagrammtypen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDiagrammtypen(_response);
        });
    }

    protected processDiagrammtypen(response: Response): Promise<Diagrammtypen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Diagrammtypen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Diagrammtypen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    zusatzangaben(authorization: any | undefined): Promise<Zusatzangaben[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/zusatzangaben";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processZusatzangaben(_response);
        });
    }

    protected processZusatzangaben(response: Response): Promise<Zusatzangaben[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Zusatzangaben.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Zusatzangaben[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    vermoegensarten(authorization: any | undefined): Promise<Vermoegensart[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/vermoegensarten";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVermoegensarten(_response);
        });
    }

    protected processVermoegensarten(response: Response): Promise<Vermoegensart[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Vermoegensart.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Vermoegensart[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    investitionsarten(authorization: any | undefined): Promise<Investitionsarten[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/investitionsarten";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInvestitionsarten(_response);
        });
    }

    protected processInvestitionsarten(response: Response): Promise<Investitionsarten[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Investitionsarten.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Investitionsarten[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    gemeinden(authorization: any | undefined, body: Kunden | undefined): Promise<Gemeinden[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/gemeinden";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGemeinden(_response);
        });
    }

    protected processGemeinden(response: Response): Promise<Gemeinden[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Gemeinden.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Gemeinden[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    allegemeinden(proJahr: boolean, kunde: number, authorization: any | undefined): Promise<GemeindeModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/allegemeinden/{proJahr}/{kunde}";
        if (proJahr === undefined || proJahr === null)
            throw new Error("The parameter 'proJahr' must be defined.");
        url_ = url_.replace("{proJahr}", encodeURIComponent("" + proJahr));
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAllegemeinden(_response);
        });
    }

    protected processAllegemeinden(response: Response): Promise<GemeindeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GemeindeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GemeindeModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    module(kunde: number, authorization: any | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/module/{kunde}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModule(_response);
        });
    }

    protected processModule(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    jahre(authorization: any | undefined, body: Gemeinden | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/jahre";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processJahre(_response);
        });
    }

    protected processJahre(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    freiesJahr(kunde: number, gemeinde: number, authorization: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/FreiesJahr/{kunde}/{gemeinde}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFreiesJahr(_response);
        });
    }

    protected processFreiesJahr(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getKundenCode(authorization: any | undefined, body: Kunden | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetKundenCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetKundenCode(_response);
        });
    }

    protected processGetKundenCode(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addKunde(authorization: any | undefined, body: Kunden | undefined): Promise<Kunden> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddKunde";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddKunde(_response);
        });
    }

    protected processAddKunde(response: Response): Promise<Kunden> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Kunden.fromJS(resultData200);
            return result200;
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            let resultData423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result423 = ProblemDetails.fromJS(resultData423);
            return throwException("Locked", status, _responseText, _headers, result423);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Kunden>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyKunde(jr: boolean, uh: boolean, authorization: any | undefined, body: Kunden | undefined): Promise<Kunden> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ModifyKunde/{jr}/{uh}";
        if (jr === undefined || jr === null)
            throw new Error("The parameter 'jr' must be defined.");
        url_ = url_.replace("{jr}", encodeURIComponent("" + jr));
        if (uh === undefined || uh === null)
            throw new Error("The parameter 'uh' must be defined.");
        url_ = url_.replace("{uh}", encodeURIComponent("" + uh));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyKunde(_response);
        });
    }

    protected processModifyKunde(response: Response): Promise<Kunden> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Kunden.fromJS(resultData200);
            return result200;
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            let resultData423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result423 = ProblemDetails.fromJS(resultData423);
            return throwException("Locked", status, _responseText, _headers, result423);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Kunden>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    hasAdminKIBot(kunde: number | undefined, authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/HasAdminKIBot?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHasAdminKIBot(_response);
        });
    }

    protected processHasAdminKIBot(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            let resultData423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result423 = ProblemDetails.fromJS(resultData423);
            return throwException("Locked", status, _responseText, _headers, result423);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    isBackupConfigured(authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/IsBackupConfigured";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsBackupConfigured(_response);
        });
    }

    protected processIsBackupConfigured(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            let resultData423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result423 = ProblemDetails.fromJS(resultData423);
            return throwException("Locked", status, _responseText, _headers, result423);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    freieKundennummer(authorization: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/FreieKundennummer";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFreieKundennummer(_response);
        });
    }

    protected processFreieKundennummer(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addGemeinde(authorization: any | undefined, body: Gemeinden | undefined): Promise<Gemeinden> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddGemeinde";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddGemeinde(_response);
        });
    }

    protected processAddGemeinde(response: Response): Promise<Gemeinden> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Gemeinden.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Gemeinden>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyGemeinde(authorization: any | undefined, body: Gemeinden | undefined): Promise<Gemeinden> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ModifyGemeinde";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyGemeinde(_response);
        });
    }

    protected processModifyGemeinde(response: Response): Promise<Gemeinden> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Gemeinden.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Gemeinden>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    getHauptFTPGemeinde(kunde: number | undefined, authorization: any | undefined): Promise<Gemeinden> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetHauptFTPGemeinde?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHauptFTPGemeinde(_response);
        });
    }

    protected processGetHauptFTPGemeinde(response: Response): Promise<Gemeinden> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Gemeinden.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Gemeinden>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setImportFormat(authorization: any | undefined, body: Gemeinden | undefined): Promise<Gemeinden> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/SetImportFormat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetImportFormat(_response);
        });
    }

    protected processSetImportFormat(response: Response): Promise<Gemeinden> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Gemeinden.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Gemeinden>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    createSFTPAccess(authorization: any | undefined, body: Gemeinden | undefined): Promise<Gemeinden> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/CreateSFTPAccess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateSFTPAccess(_response);
        });
    }

    protected processCreateSFTPAccess(response: Response): Promise<Gemeinden> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Gemeinden.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Gemeinden>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    freieGemeindenummer(kunde: number, authorization: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/FreieGemeindenummer/{kunde}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFreieGemeindenummer(_response);
        });
    }

    protected processFreieGemeindenummer(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    kunden(authorization: any | undefined): Promise<Kunden[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/kunden";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKunden(_response);
        });
    }

    protected processKunden(response: Response): Promise<Kunden[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Kunden.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Kunden[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addEbene(authorization: any | undefined, body: Ebenen | undefined): Promise<Ebenen> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddEbene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddEbene(_response);
        });
    }

    protected processAddEbene(response: Response): Promise<Ebenen> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Ebenen.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Ebenen>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeEbene(authorization: any | undefined, body: Ebenen | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveEbene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveEbene(_response);
        });
    }

    protected processRemoveEbene(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyEbene(authorization: any | undefined, body: Ebenen | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ModifyEbene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyEbene(_response);
        });
    }

    protected processModifyEbene(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadEbenenBin(kunde: number, gemeinde: number, jahr: number, format: number, oberebene: string, nummernspalte: string, namensspalte: string, dateiname: string, authorization: any | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/UploadEbenenBin/{kunde}/{gemeinde}/{jahr}/{format}/{oberebene}/{namensspalte}/{nummernspalte}/{dateiname}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (oberebene === undefined || oberebene === null)
            throw new Error("The parameter 'oberebene' must be defined.");
        url_ = url_.replace("{oberebene}", encodeURIComponent("" + oberebene));
        if (nummernspalte === undefined || nummernspalte === null)
            throw new Error("The parameter 'nummernspalte' must be defined.");
        url_ = url_.replace("{nummernspalte}", encodeURIComponent("" + nummernspalte));
        if (namensspalte === undefined || namensspalte === null)
            throw new Error("The parameter 'namensspalte' must be defined.");
        url_ = url_.replace("{namensspalte}", encodeURIComponent("" + namensspalte));
        if (dateiname === undefined || dateiname === null)
            throw new Error("The parameter 'dateiname' must be defined.");
        url_ = url_.replace("{dateiname}", encodeURIComponent("" + dateiname));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadEbenenBin(_response);
        });
    }

    protected processUploadEbenenBin(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushEbenen(authorization: any | undefined, body: PushEbenenModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/PushEbenen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushEbenen(_response);
        });
    }

    protected processPushEbenen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param fileData (optional) 
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @return OK
     */
    uploadEbenen(authorization: any | undefined, fileData: string | undefined, kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined): Promise<Ebenen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/UploadEbenen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileData === null || fileData === undefined)
            throw new Error("The parameter 'fileData' cannot be null.");
        else
            content_.append("fileData", fileData.toString());
        if (kunde === null || kunde === undefined)
            throw new Error("The parameter 'kunde' cannot be null.");
        else
            content_.append("kunde", kunde.toString());
        if (gemeinde === null || gemeinde === undefined)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else
            content_.append("gemeinde", gemeinde.toString());
        if (jahr === null || jahr === undefined)
            throw new Error("The parameter 'jahr' cannot be null.");
        else
            content_.append("jahr", jahr.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadEbenen(_response);
        });
    }

    protected processUploadEbenen(response: Response): Promise<Ebenen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Ebenen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Ebenen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    ebenen(authorization: any | undefined, body: JahrModel | undefined): Promise<Ebenen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ebenen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEbenen(_response);
        });
    }

    protected processEbenen(response: Response): Promise<Ebenen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Ebenen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Ebenen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    attributebenen(authorization: any | undefined, body: JahrModel | undefined): Promise<Ebenen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/attributebenen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAttributebenen(_response);
        });
    }

    protected processAttributebenen(response: Response): Promise<Ebenen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Ebenen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Ebenen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    amtebenen(authorization: any | undefined, body: JahrModel | undefined): Promise<AmtEbenenModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/amtebenen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAmtebenen(_response);
        });
    }

    protected processAmtebenen(response: Response): Promise<AmtEbenenModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AmtEbenenModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AmtEbenenModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    toplevelebenen(authorization: any | undefined, body: JahrModel | undefined): Promise<Ebenen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/toplevelebenen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processToplevelebenen(_response);
        });
    }

    protected processToplevelebenen(response: Response): Promise<Ebenen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Ebenen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Ebenen[]>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    getHaushaltsstellen2Ebene(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, authorization: any | undefined): Promise<Haushaltsstelle2Ebene[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetHaushaltsstellen2Ebene?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHaushaltsstellen2Ebene(_response);
        });
    }

    protected processGetHaushaltsstellen2Ebene(response: Response): Promise<Haushaltsstelle2Ebene[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Haushaltsstelle2Ebene.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Haushaltsstelle2Ebene[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param ebenenId (optional) 
     * @param jahr (optional) 
     * @param kunde (optional) 
     * @return OK
     */
    getAssignedHaushaltsstellen(authorization: any | undefined, ebenenId: string | undefined, jahr: number | undefined, kunde: number | undefined): Promise<Haushaltsstellen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetAssignedHaushaltsstellen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (ebenenId === null || ebenenId === undefined)
            throw new Error("The parameter 'ebenenId' cannot be null.");
        else
            content_.append("ebenenId", ebenenId.toString());
        if (jahr === null || jahr === undefined)
            throw new Error("The parameter 'jahr' cannot be null.");
        else
            content_.append("jahr", jahr.toString());
        if (kunde === null || kunde === undefined)
            throw new Error("The parameter 'kunde' cannot be null.");
        else
            content_.append("kunde", kunde.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignedHaushaltsstellen(_response);
        });
    }

    protected processGetAssignedHaushaltsstellen(response: Response): Promise<Haushaltsstellen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Haushaltsstellen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Haushaltsstellen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setAssignedHaushaltsstellen(authorization: any | undefined, body: AssignedHHSModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/SetAssignedHaushaltsstellen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetAssignedHaushaltsstellen(_response);
        });
    }

    protected processSetAssignedHaushaltsstellen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param hhS (optional) 
     * @param jahr (optional) 
     * @param kunde (optional) 
     * @return OK
     */
    getassignedebenen(authorization: any | undefined, hhS: number | undefined, jahr: number | undefined, kunde: number | undefined): Promise<EbenenModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/getassignedebenen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (hhS === null || hhS === undefined)
            throw new Error("The parameter 'hhS' cannot be null.");
        else
            content_.append("hhS", hhS.toString());
        if (jahr === null || jahr === undefined)
            throw new Error("The parameter 'jahr' cannot be null.");
        else
            content_.append("jahr", jahr.toString());
        if (kunde === null || kunde === undefined)
            throw new Error("The parameter 'kunde' cannot be null.");
        else
            content_.append("kunde", kunde.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetassignedebenen(_response);
        });
    }

    protected processGetassignedebenen(response: Response): Promise<EbenenModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EbenenModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EbenenModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setassignedebenen(authorization: any | undefined, body: AssignedEbenenModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/setassignedebenen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetassignedebenen(_response);
        });
    }

    protected processSetassignedebenen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param ebenenId (optional) 
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @return OK
     */
    getUnassignedHaushaltsstellen(authorization: any | undefined, ebenenId: string | undefined, kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined): Promise<Haushaltsstellen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetUnassignedHaushaltsstellen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (ebenenId === null || ebenenId === undefined)
            throw new Error("The parameter 'ebenenId' cannot be null.");
        else
            content_.append("ebenenId", ebenenId.toString());
        if (kunde === null || kunde === undefined)
            throw new Error("The parameter 'kunde' cannot be null.");
        else
            content_.append("kunde", kunde.toString());
        if (gemeinde === null || gemeinde === undefined)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else
            content_.append("gemeinde", gemeinde.toString());
        if (jahr === null || jahr === undefined)
            throw new Error("The parameter 'jahr' cannot be null.");
        else
            content_.append("jahr", jahr.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUnassignedHaushaltsstellen(_response);
        });
    }

    protected processGetUnassignedHaushaltsstellen(response: Response): Promise<Haushaltsstellen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Haushaltsstellen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Haushaltsstellen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addMassnahme(authorization: any | undefined, body: Massnahman | undefined): Promise<Massnahman> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddMassnahme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddMassnahme(_response);
        });
    }

    protected processAddMassnahme(response: Response): Promise<Massnahman> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Massnahman.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Massnahman>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeMassnahme(authorization: any | undefined, body: Massnahman | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveMassnahme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveMassnahme(_response);
        });
    }

    protected processRemoveMassnahme(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyMassnahme(authorization: any | undefined, body: Massnahman | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ModifyMassnahme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyMassnahme(_response);
        });
    }

    protected processModifyMassnahme(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addGliederungsebene(authorization: any | undefined, body: Gliederungsebenen | undefined): Promise<Gliederungsebenen> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddGliederungsebene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddGliederungsebene(_response);
        });
    }

    protected processAddGliederungsebene(response: Response): Promise<Gliederungsebenen> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Gliederungsebenen.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Gliederungsebenen>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeGliederungsebene(authorization: any | undefined, body: Gliederungsebenen | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveGliederungsebene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveGliederungsebene(_response);
        });
    }

    protected processRemoveGliederungsebene(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyGliederungsebene(authorization: any | undefined, body: Gliederungsebenen | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ModifyGliederungsebene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyGliederungsebene(_response);
        });
    }

    protected processModifyGliederungsebene(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addGruppierungsebene(authorization: any | undefined, body: Gruppierungsebenen | undefined): Promise<Gruppierungsebenen> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddGruppierungsebene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddGruppierungsebene(_response);
        });
    }

    protected processAddGruppierungsebene(response: Response): Promise<Gruppierungsebenen> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Gruppierungsebenen.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Gruppierungsebenen>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeGruppierungsebene(authorization: any | undefined, body: Gruppierungsebenen | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveGruppierungsebene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveGruppierungsebene(_response);
        });
    }

    protected processRemoveGruppierungsebene(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyGruppierungsebene(authorization: any | undefined, body: Gruppierungsebenen | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ModifyGruppierungsebene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyGruppierungsebene(_response);
        });
    }

    protected processModifyGruppierungsebene(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addGZEbene(authorization: any | undefined, body: GZEbenenModel | undefined): Promise<GZEbenenModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddGZEbene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddGZEbene(_response);
        });
    }

    protected processAddGZEbene(response: Response): Promise<GZEbenenModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GZEbenenModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GZEbenenModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeGZEbene(includeSubEbenen: boolean, includeData: boolean, authorization: any | undefined, body: GZEbenenModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveGZEbene/{includeSubEbenen}/{includeData}";
        if (includeSubEbenen === undefined || includeSubEbenen === null)
            throw new Error("The parameter 'includeSubEbenen' must be defined.");
        url_ = url_.replace("{includeSubEbenen}", encodeURIComponent("" + includeSubEbenen));
        if (includeData === undefined || includeData === null)
            throw new Error("The parameter 'includeData' must be defined.");
        url_ = url_.replace("{includeData}", encodeURIComponent("" + includeData));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveGZEbene(_response);
        });
    }

    protected processRemoveGZEbene(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyGZEbene(setPR2DS: boolean, authorization: any | undefined, body: GZEbenenModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ModifyGZEbene/{setPR2DS}";
        if (setPR2DS === undefined || setPR2DS === null)
            throw new Error("The parameter 'setPR2DS' must be defined.");
        url_ = url_.replace("{setPR2DS}", encodeURIComponent("" + setPR2DS));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyGZEbene(_response);
        });
    }

    protected processModifyGZEbene(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    gZEbenen(authorization: any | undefined, body: JahrModel | undefined): Promise<GZEbenenModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GZEbenen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGZEbenen(_response);
        });
    }

    protected processGZEbenen(response: Response): Promise<GZEbenenModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GZEbenenModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GZEbenenModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    gZEbenenHierarchie(authorization: any | undefined, body: JahrModel | undefined): Promise<GZEbenenModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GZEbenenHierarchie";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGZEbenenHierarchie(_response);
        });
    }

    protected processGZEbenenHierarchie(response: Response): Promise<GZEbenenModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GZEbenenModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GZEbenenModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    gZDataEbenen(authorization: any | undefined, body: JahrModel | undefined): Promise<GZEbenenModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GZDataEbenen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGZDataEbenen(_response);
        });
    }

    protected processGZDataEbenen(response: Response): Promise<GZEbenenModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GZEbenenModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GZEbenenModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setGZEbene2Amt(kunde: number, gemeinde: number, jahr: number, ebeneId: string, authorization: any | undefined, body: Ebenen[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/SetGZEbene2Amt/{kunde}/{gemeinde}/{jahr}/{ebeneId}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (ebeneId === undefined || ebeneId === null)
            throw new Error("The parameter 'ebeneId' must be defined.");
        url_ = url_.replace("{ebeneId}", encodeURIComponent("" + ebeneId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetGZEbene2Amt(_response);
        });
    }

    protected processSetGZEbene2Amt(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getGZEbene2Amt(kunde: number, gemeinde: number, jahr: number, ebeneId: string, authorization: any | undefined): Promise<Ebenen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetGZEbene2Amt/{kunde}/{gemeinde}/{jahr}/{ebeneId}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (ebeneId === undefined || ebeneId === null)
            throw new Error("The parameter 'ebeneId' must be defined.");
        url_ = url_.replace("{ebeneId}", encodeURIComponent("" + ebeneId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetGZEbene2Amt(_response);
        });
    }

    protected processGetGZEbene2Amt(response: Response): Promise<Ebenen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Ebenen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Ebenen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addVBTab(authorization: any | undefined, body: Vbtab | undefined): Promise<Vbtab> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddVBTab";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddVBTab(_response);
        });
    }

    protected processAddVBTab(response: Response): Promise<Vbtab> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Vbtab.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Vbtab>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeVBTab(includeSubTabs: boolean, includeData: boolean, authorization: any | undefined, body: Vbtab | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveVBTab/{includeSubTabs}/{includeData}";
        if (includeSubTabs === undefined || includeSubTabs === null)
            throw new Error("The parameter 'includeSubTabs' must be defined.");
        url_ = url_.replace("{includeSubTabs}", encodeURIComponent("" + includeSubTabs));
        if (includeData === undefined || includeData === null)
            throw new Error("The parameter 'includeData' must be defined.");
        url_ = url_.replace("{includeData}", encodeURIComponent("" + includeData));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveVBTab(_response);
        });
    }

    protected processRemoveVBTab(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyVBTab(authorization: any | undefined, body: Vbtab | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ModifyVBTab";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyVBTab(_response);
        });
    }

    protected processModifyVBTab(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    vBTabs(authorization: any | undefined, body: JahrModel | undefined): Promise<Vbtab[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/VBTabs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVBTabs(_response);
        });
    }

    protected processVBTabs(response: Response): Promise<Vbtab[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Vbtab.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Vbtab[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    vBDataTabs(authorization: any | undefined, body: JahrModel | undefined): Promise<Vbtab[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/VBDataTabs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVBDataTabs(_response);
        });
    }

    protected processVBDataTabs(response: Response): Promise<Vbtab[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Vbtab.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Vbtab[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setVBTabTexte(kunde: number, gemeinde: number, jahr: number, tabId: string, authorization: any | undefined, body: FreiTextModel[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/SetVBTabTexte/{kunde}/{gemeinde}/{jahr}/{tabId}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (tabId === undefined || tabId === null)
            throw new Error("The parameter 'tabId' must be defined.");
        url_ = url_.replace("{tabId}", encodeURIComponent("" + tabId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetVBTabTexte(_response);
        });
    }

    protected processSetVBTabTexte(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getVBTabTexte(kunde: number, gemeinde: number, jahr: number, tabId: string, authorization: any | undefined): Promise<FreiTextModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetVBTabTexte/{kunde}/{gemeinde}/{jahr}/{tabId}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (tabId === undefined || tabId === null)
            throw new Error("The parameter 'tabId' must be defined.");
        url_ = url_.replace("{tabId}", encodeURIComponent("" + tabId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVBTabTexte(_response);
        });
    }

    protected processGetVBTabTexte(response: Response): Promise<FreiTextModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FreiTextModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FreiTextModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getVBTabTextBezeichner(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetVBTabTextBezeichner/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVBTabTextBezeichner(_response);
        });
    }

    protected processGetVBTabTextBezeichner(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addDokOrdner(authorization: any | undefined, body: DokOrdner | undefined): Promise<DokOrdner> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddDokOrdner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddDokOrdner(_response);
        });
    }

    protected processAddDokOrdner(response: Response): Promise<DokOrdner> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DokOrdner.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DokOrdner>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeDokOrdner(authorization: any | undefined, body: DokOrdner | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveDokOrdner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveDokOrdner(_response);
        });
    }

    protected processRemoveDokOrdner(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyDokOrdner(authorization: any | undefined, body: DokOrdner | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ModifyDokOrdner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyDokOrdner(_response);
        });
    }

    protected processModifyDokOrdner(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    dokordner(authorization: any | undefined, body: JahrModel | undefined): Promise<DokOrdner[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/dokordner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDokordner(_response);
        });
    }

    protected processDokordner(response: Response): Promise<DokOrdner[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DokOrdner.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DokOrdner[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addDokument(authorization: any | undefined, body: Dokumente | undefined): Promise<Dokumente> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddDokument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddDokument(_response);
        });
    }

    protected processAddDokument(response: Response): Promise<Dokumente> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Dokumente.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Dokumente>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeDokument(authorization: any | undefined, body: Dokumente | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveDokument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveDokument(_response);
        });
    }

    protected processRemoveDokument(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyDokument(authorization: any | undefined, body: Dokumente | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ModifyDokument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyDokument(_response);
        });
    }

    protected processModifyDokument(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    dokumente(authorization: any | undefined, body: JahrModel | undefined): Promise<Dokumente[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/dokumente";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDokumente(_response);
        });
    }

    protected processDokumente(response: Response): Promise<Dokumente[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Dokumente.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Dokumente[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushDokumente(authorization: any | undefined, body: PushDokumenteModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/PushDokumente";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushDokumente(_response);
        });
    }

    protected processPushDokumente(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addUmbuchung(authorization: any | undefined, body: Umbuchungen | undefined): Promise<Umbuchungen> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddUmbuchung";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddUmbuchung(_response);
        });
    }

    protected processAddUmbuchung(response: Response): Promise<Umbuchungen> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Umbuchungen.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Umbuchungen>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeUmbuchung(authorization: any | undefined, body: Umbuchungen | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveUmbuchung";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveUmbuchung(_response);
        });
    }

    protected processRemoveUmbuchung(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyUmbuchung(authorization: any | undefined, body: Umbuchungen | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ModifyUmbuchung";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyUmbuchung(_response);
        });
    }

    protected processModifyUmbuchung(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    umbuchungen(authorization: any | undefined, body: JahrModel | undefined): Promise<Umbuchungen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/umbuchungen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUmbuchungen(_response);
        });
    }

    protected processUmbuchungen(response: Response): Promise<Umbuchungen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Umbuchungen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Umbuchungen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addHilfe(authorization: any | undefined, body: Hilfe | undefined): Promise<Hilfe> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddHilfe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddHilfe(_response);
        });
    }

    protected processAddHilfe(response: Response): Promise<Hilfe> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Hilfe.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Hilfe>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeHilfe(authorization: any | undefined, body: Hilfe | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveHilfe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveHilfe(_response);
        });
    }

    protected processRemoveHilfe(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyHilfe(authorization: any | undefined, body: Hilfe | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ModifyHilfe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyHilfe(_response);
        });
    }

    protected processModifyHilfe(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    hilfe(buchungsart: number, authorization: any | undefined): Promise<Hilfe[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/hilfe/{buchungsart}";
        if (buchungsart === undefined || buchungsart === null)
            throw new Error("The parameter 'buchungsart' must be defined.");
        url_ = url_.replace("{buchungsart}", encodeURIComponent("" + buchungsart));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHilfe(_response);
        });
    }

    protected processHilfe(response: Response): Promise<Hilfe[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Hilfe.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Hilfe[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getKIBotDokMetaFelder(authorization: any | undefined): Promise<KibotDokumentMetaFeld[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetKIBotDokMetaFelder";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetKIBotDokMetaFelder(_response);
        });
    }

    protected processGetKIBotDokMetaFelder(response: Response): Promise<KibotDokumentMetaFeld[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KibotDokumentMetaFeld.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KibotDokumentMetaFeld[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getKIBotDoks(authorization: any | undefined): Promise<KibotDokumentModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetKIBotDoks";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetKIBotDoks(_response);
        });
    }

    protected processGetKIBotDoks(response: Response): Promise<KibotDokumentModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KibotDokumentModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KibotDokumentModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyKIBotDokument(authorization: any | undefined, body: KibotDokumentModel | undefined): Promise<KibotDokumentModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ModifyKIBotDokument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyKIBotDokument(_response);
        });
    }

    protected processModifyKIBotDokument(response: Response): Promise<KibotDokumentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KibotDokumentModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KibotDokumentModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param id (optional) 
     * @param bezeichnung (optional) 
     * @param menuPfad (optional) 
     * @param metaJson (optional) 
     * @param datei (optional) 
     * @return OK
     */
    addAndSplitKIBotDokument(authorization: any | undefined, id: number | undefined, bezeichnung: string | undefined, menuPfad: string | undefined, metaJson: string | undefined, datei: FileParameter | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddAndSplitKIBotDokument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (bezeichnung === null || bezeichnung === undefined)
            throw new Error("The parameter 'bezeichnung' cannot be null.");
        else
            content_.append("Bezeichnung", bezeichnung.toString());
        if (menuPfad === null || menuPfad === undefined)
            throw new Error("The parameter 'menuPfad' cannot be null.");
        else
            content_.append("MenuPfad", menuPfad.toString());
        if (metaJson === null || metaJson === undefined)
            throw new Error("The parameter 'metaJson' cannot be null.");
        else
            content_.append("MetaJson", metaJson.toString());
        if (datei === null || datei === undefined)
            throw new Error("The parameter 'datei' cannot be null.");
        else
            content_.append("Datei", datei.data, datei.fileName ? datei.fileName : "Datei");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddAndSplitKIBotDokument(_response);
        });
    }

    protected processAddAndSplitKIBotDokument(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 202) {
            return response.text().then((_responseText) => {
            return throwException("Accepted", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param id (optional) 
     * @param bezeichnung (optional) 
     * @param menuPfad (optional) 
     * @param metaJson (optional) 
     * @param datei (optional) 
     * @return OK
     */
    addKIBotDokument(authorization: any | undefined, id: number | undefined, bezeichnung: string | undefined, menuPfad: string | undefined, metaJson: string | undefined, datei: FileParameter | undefined): Promise<KibotDokumentModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddKIBotDokument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (bezeichnung === null || bezeichnung === undefined)
            throw new Error("The parameter 'bezeichnung' cannot be null.");
        else
            content_.append("Bezeichnung", bezeichnung.toString());
        if (menuPfad === null || menuPfad === undefined)
            throw new Error("The parameter 'menuPfad' cannot be null.");
        else
            content_.append("MenuPfad", menuPfad.toString());
        if (metaJson === null || metaJson === undefined)
            throw new Error("The parameter 'metaJson' cannot be null.");
        else
            content_.append("MetaJson", metaJson.toString());
        if (datei === null || datei === undefined)
            throw new Error("The parameter 'datei' cannot be null.");
        else
            content_.append("Datei", datei.data, datei.fileName ? datei.fileName : "Datei");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddKIBotDokument(_response);
        });
    }

    protected processAddKIBotDokument(response: Response): Promise<KibotDokumentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KibotDokumentModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KibotDokumentModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeKIBotDokument(authorization: any | undefined, body: KibotDokumentModel | undefined): Promise<KibotDokumentModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveKIBotDokument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveKIBotDokument(_response);
        });
    }

    protected processRemoveKIBotDokument(response: Response): Promise<KibotDokumentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KibotDokumentModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KibotDokumentModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    kIBotDokumentJobStatus(jobId: string, authorization: any | undefined): Promise<KibotDokumentJobModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/KIBotDokumentJobStatus/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKIBotDokumentJobStatus(_response);
        });
    }

    protected processKIBotDokumentJobStatus(response: Response): Promise<KibotDokumentJobModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KibotDokumentJobModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KibotDokumentJobModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    downloadKIBotDokument(authorization: any | undefined, body: KibotDokumentModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/DownloadKIBotDokument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadKIBotDokument(_response);
        });
    }

    protected processDownloadKIBotDokument(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param id (optional) 
     * @param bezeichnung (optional) 
     * @param menuPfad (optional) 
     * @param metaJson (optional) 
     * @param datei (optional) 
     * @return OK
     */
    updateKIBotDokument(authorization: any | undefined, id: number | undefined, bezeichnung: string | undefined, menuPfad: string | undefined, metaJson: string | undefined, datei: FileParameter | undefined): Promise<KibotDokumentModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/UpdateKIBotDokument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (bezeichnung === null || bezeichnung === undefined)
            throw new Error("The parameter 'bezeichnung' cannot be null.");
        else
            content_.append("Bezeichnung", bezeichnung.toString());
        if (menuPfad === null || menuPfad === undefined)
            throw new Error("The parameter 'menuPfad' cannot be null.");
        else
            content_.append("MenuPfad", menuPfad.toString());
        if (metaJson === null || metaJson === undefined)
            throw new Error("The parameter 'metaJson' cannot be null.");
        else
            content_.append("MetaJson", metaJson.toString());
        if (datei === null || datei === undefined)
            throw new Error("The parameter 'datei' cannot be null.");
        else
            content_.append("Datei", datei.data, datei.fileName ? datei.fileName : "Datei");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateKIBotDokument(_response);
        });
    }

    protected processUpdateKIBotDokument(response: Response): Promise<KibotDokumentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KibotDokumentModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KibotDokumentModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getKIBotDokumentHtml(id: number, authorization: any | undefined): Promise<KibotDokumentHtmlModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetKIBotDokumentHtml/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetKIBotDokumentHtml(_response);
        });
    }

    protected processGetKIBotDokumentHtml(response: Response): Promise<KibotDokumentHtmlModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KibotDokumentHtmlModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KibotDokumentHtmlModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    saveKIBotDokumentHtml(authorization: any | undefined, body: KibotDokumentHtmlModel | undefined): Promise<KibotDokumentModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/SaveKIBotDokumentHtml";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveKIBotDokumentHtml(_response);
        });
    }

    protected processSaveKIBotDokumentHtml(response: Response): Promise<KibotDokumentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KibotDokumentModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KibotDokumentModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getKIBotHandbuchPdf(ursprung: string, authorization: any | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetKIBotHandbuchPdf/{ursprung}";
        if (ursprung === undefined || ursprung === null)
            throw new Error("The parameter 'ursprung' must be defined.");
        url_ = url_.replace("{ursprung}", encodeURIComponent("" + ursprung));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetKIBotHandbuchPdf(_response);
        });
    }

    protected processGetKIBotHandbuchPdf(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getKIBotHandbuchWord(ursprung: string, authorization: any | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetKIBotHandbuchWord/{ursprung}";
        if (ursprung === undefined || ursprung === null)
            throw new Error("The parameter 'ursprung' must be defined.");
        url_ = url_.replace("{ursprung}", encodeURIComponent("" + ursprung));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetKIBotHandbuchWord(_response);
        });
    }

    protected processGetKIBotHandbuchWord(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addDatensatz(authorization: any | undefined, body: DatensatzModel | undefined): Promise<DatensatzModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddDatensatz";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddDatensatz(_response);
        });
    }

    protected processAddDatensatz(response: Response): Promise<DatensatzModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DatensatzModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DatensatzModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getDatensatzData(authorization: any | undefined, body: DatensatzModel | undefined): Promise<Daten[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetDatensatzData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDatensatzData(_response);
        });
    }

    protected processGetDatensatzData(response: Response): Promise<Daten[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Daten.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Daten[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    duplicateDatensatz(authorization: any | undefined, body: DatensatzModel | undefined): Promise<DatensatzModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/DuplicateDatensatz";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDuplicateDatensatz(_response);
        });
    }

    protected processDuplicateDatensatz(response: Response): Promise<DatensatzModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DatensatzModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DatensatzModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeDatensatz(authorization: any | undefined, body: DatensatzModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveDatensatz";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveDatensatz(_response);
        });
    }

    protected processRemoveDatensatz(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyDatensatz(authorization: any | undefined, body: DatensatzModel | undefined): Promise<DatensatzModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ModifyDatensatz";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyDatensatz(_response);
        });
    }

    protected processModifyDatensatz(response: Response): Promise<DatensatzModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DatensatzModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DatensatzModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    datensaetze(authorization: any | undefined, body: JahrModel | undefined): Promise<DatensatzModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/datensaetze";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDatensaetze(_response);
        });
    }

    protected processDatensaetze(response: Response): Promise<DatensatzModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DatensatzModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DatensatzModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getTexte(kunde: number, gemeinde: number, jahr: number, typ: number, authorization: any | undefined): Promise<Texte[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetTexte/{kunde}/{gemeinde}/{jahr}/{typ}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (typ === undefined || typ === null)
            throw new Error("The parameter 'typ' must be defined.");
        url_ = url_.replace("{typ}", encodeURIComponent("" + typ));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTexte(_response);
        });
    }

    protected processGetTexte(response: Response): Promise<Texte[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Texte.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Texte[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addText(authorization: any | undefined, body: Texte | undefined): Promise<Texte> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddText(_response);
        });
    }

    protected processAddText(response: Response): Promise<Texte> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Texte.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Texte>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeText(authorization: any | undefined, body: Texte | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveText(_response);
        });
    }

    protected processRemoveText(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyText(authorization: any | undefined, body: Texte | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ModifyText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyText(_response);
        });
    }

    protected processModifyText(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getTTTexte(kunde: number, gemeinde: number, jahr: number, modul: number, authorization: any | undefined): Promise<Texte[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetTTTexte/{kunde}/{gemeinde}/{jahr}/{modul}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (modul === undefined || modul === null)
            throw new Error("The parameter 'modul' must be defined.");
        url_ = url_.replace("{modul}", encodeURIComponent("" + modul));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTTTexte(_response);
        });
    }

    protected processGetTTTexte(response: Response): Promise<Texte[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Texte.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Texte[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getTabTexte(kunde: number, gemeinde: number, jahr: number, modul: number, authorization: any | undefined): Promise<Texte[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetTabTexte/{kunde}/{gemeinde}/{jahr}/{modul}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (modul === undefined || modul === null)
            throw new Error("The parameter 'modul' must be defined.");
        url_ = url_.replace("{modul}", encodeURIComponent("" + modul));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTabTexte(_response);
        });
    }

    protected processGetTabTexte(response: Response): Promise<Texte[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Texte.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Texte[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setGLTexte(kunde: number, gemeinde: number, jahr: number, stellen: number, nummer: number, authorization: any | undefined, body: FreiTextModel[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/SetGLTexte/{kunde}/{gemeinde}/{jahr}/{stellen}/{nummer}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (stellen === undefined || stellen === null)
            throw new Error("The parameter 'stellen' must be defined.");
        url_ = url_.replace("{stellen}", encodeURIComponent("" + stellen));
        if (nummer === undefined || nummer === null)
            throw new Error("The parameter 'nummer' must be defined.");
        url_ = url_.replace("{nummer}", encodeURIComponent("" + nummer));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetGLTexte(_response);
        });
    }

    protected processSetGLTexte(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getGLTexte(kunde: number, gemeinde: number, jahr: number, stellen: number, nummer: number, authorization: any | undefined): Promise<FreiTextModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetGLTexte/{kunde}/{gemeinde}/{jahr}/{stellen}/{nummer}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (stellen === undefined || stellen === null)
            throw new Error("The parameter 'stellen' must be defined.");
        url_ = url_.replace("{stellen}", encodeURIComponent("" + stellen));
        if (nummer === undefined || nummer === null)
            throw new Error("The parameter 'nummer' must be defined.");
        url_ = url_.replace("{nummer}", encodeURIComponent("" + nummer));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetGLTexte(_response);
        });
    }

    protected processGetGLTexte(response: Response): Promise<FreiTextModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FreiTextModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FreiTextModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getGLTextBezeichner(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetGLTextBezeichner/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetGLTextBezeichner(_response);
        });
    }

    protected processGetGLTextBezeichner(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setGRTexte(kunde: number, gemeinde: number, jahr: number, stellen: number, nummer: number, authorization: any | undefined, body: FreiTextModel[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/SetGRTexte/{kunde}/{gemeinde}/{jahr}/{stellen}/{nummer}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (stellen === undefined || stellen === null)
            throw new Error("The parameter 'stellen' must be defined.");
        url_ = url_.replace("{stellen}", encodeURIComponent("" + stellen));
        if (nummer === undefined || nummer === null)
            throw new Error("The parameter 'nummer' must be defined.");
        url_ = url_.replace("{nummer}", encodeURIComponent("" + nummer));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetGRTexte(_response);
        });
    }

    protected processSetGRTexte(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getGRTexte(kunde: number, gemeinde: number, jahr: number, stellen: number, nummer: number, authorization: any | undefined): Promise<FreiTextModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetGRTexte/{kunde}/{gemeinde}/{jahr}/{stellen}/{nummer}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (stellen === undefined || stellen === null)
            throw new Error("The parameter 'stellen' must be defined.");
        url_ = url_.replace("{stellen}", encodeURIComponent("" + stellen));
        if (nummer === undefined || nummer === null)
            throw new Error("The parameter 'nummer' must be defined.");
        url_ = url_.replace("{nummer}", encodeURIComponent("" + nummer));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetGRTexte(_response);
        });
    }

    protected processGetGRTexte(response: Response): Promise<FreiTextModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FreiTextModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FreiTextModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getGRTextBezeichner(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetGRTextBezeichner/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetGRTextBezeichner(_response);
        });
    }

    protected processGetGRTextBezeichner(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setEbenenTexte(kunde: number, gemeinde: number, jahr: number, ebenenId: string, authorization: any | undefined, body: FreiTextModel[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/SetEbenenTexte/{kunde}/{gemeinde}/{jahr}/{ebenenId}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (ebenenId === undefined || ebenenId === null)
            throw new Error("The parameter 'ebenenId' must be defined.");
        url_ = url_.replace("{ebenenId}", encodeURIComponent("" + ebenenId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetEbenenTexte(_response);
        });
    }

    protected processSetEbenenTexte(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getEbenenTexte(jahr: number, ebenenId: string, authorization: any | undefined): Promise<FreiTextModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetEbenenTexte/{jahr}/{ebenenId}";
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (ebenenId === undefined || ebenenId === null)
            throw new Error("The parameter 'ebenenId' must be defined.");
        url_ = url_.replace("{ebenenId}", encodeURIComponent("" + ebenenId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEbenenTexte(_response);
        });
    }

    protected processGetEbenenTexte(response: Response): Promise<FreiTextModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FreiTextModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FreiTextModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getEbenenTextBezeichner(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetEbenenTextBezeichner/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEbenenTextBezeichner(_response);
        });
    }

    protected processGetEbenenTextBezeichner(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setHHTexte(kunde: number, gemeinde: number, jahr: number, hhstelle: number, authorization: any | undefined, body: FreiTextModel[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/SetHHTexte/{kunde}/{gemeinde}/{jahr}/{hhstelle}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (hhstelle === undefined || hhstelle === null)
            throw new Error("The parameter 'hhstelle' must be defined.");
        url_ = url_.replace("{hhstelle}", encodeURIComponent("" + hhstelle));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetHHTexte(_response);
        });
    }

    protected processSetHHTexte(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getHHTexte(kunde: number, gemeinde: number, jahr: number, hhstelle: number, authorization: any | undefined): Promise<FreiTextModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetHHTexte/{kunde}/{gemeinde}/{jahr}/{hhstelle}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (hhstelle === undefined || hhstelle === null)
            throw new Error("The parameter 'hhstelle' must be defined.");
        url_ = url_.replace("{hhstelle}", encodeURIComponent("" + hhstelle));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHHTexte(_response);
        });
    }

    protected processGetHHTexte(response: Response): Promise<FreiTextModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FreiTextModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FreiTextModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getHHTextBezeichner(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetHHTextBezeichner/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHHTextBezeichner(_response);
        });
    }

    protected processGetHHTextBezeichner(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    texte(authorization: any | undefined, body: JahrModel | undefined): Promise<Texte[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/texte";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTexte(_response);
        });
    }

    protected processTexte(response: Response): Promise<Texte[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Texte.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Texte[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addBild(authorization: any | undefined, body: Bilder | undefined): Promise<Bilder> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddBild";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddBild(_response);
        });
    }

    protected processAddBild(response: Response): Promise<Bilder> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Bilder.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Bilder>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeBild(authorization: any | undefined, body: Bilder | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveBild";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveBild(_response);
        });
    }

    protected processRemoveBild(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyBild(authorization: any | undefined, body: Bilder | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ModifyBild";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyBild(_response);
        });
    }

    protected processModifyBild(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    bilder(authorization: any | undefined, body: JahrModel | undefined): Promise<Bilder[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/bilder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBilder(_response);
        });
    }

    protected processBilder(response: Response): Promise<Bilder[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Bilder.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Bilder[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    updategliederung(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined, body: GliederungsModel[] | undefined): Promise<GliederungsModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/{kunde}/{gemeinde}/{jahr}/updategliederung";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdategliederung(_response);
        });
    }

    protected processUpdategliederung(response: Response): Promise<GliederungsModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GliederungsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GliederungsModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addPrognosekurve(authorization: any | undefined, body: Prognosekurven | undefined): Promise<Prognosekurven> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddPrognosekurve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddPrognosekurve(_response);
        });
    }

    protected processAddPrognosekurve(response: Response): Promise<Prognosekurven> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Prognosekurven.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Prognosekurven>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removePrognosekurve(authorization: any | undefined, body: Prognosekurven | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemovePrognosekurve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemovePrognosekurve(_response);
        });
    }

    protected processRemovePrognosekurve(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyPrognosekurve(authorization: any | undefined, body: Prognosekurven | undefined): Promise<Prognosekurven> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ModifyPrognosekurve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyPrognosekurve(_response);
        });
    }

    protected processModifyPrognosekurve(response: Response): Promise<Prognosekurven> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Prognosekurven.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Prognosekurven>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushPrognosekurven(authorization: any | undefined, body: PushPrognosekurvenModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/PushPrognosekurven";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushPrognosekurven(_response);
        });
    }

    protected processPushPrognosekurven(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushPrognosemodelle(authorization: any | undefined, body: PushPrognoseModelModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/PushPrognosemodelle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushPrognosemodelle(_response);
        });
    }

    protected processPushPrognosemodelle(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    prognosekurven(authorization: any | undefined, body: JahrModel | undefined): Promise<Prognosekurven[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/prognosekurven";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPrognosekurven(_response);
        });
    }

    protected processPrognosekurven(response: Response): Promise<Prognosekurven[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Prognosekurven.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Prognosekurven[]>(null as any);
    }

    setPk2HHS(uhconfig: number, hhs: number, pk: number): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/SetPk2HHS/{uhconfig}/{hhs}/{pk}";
        if (uhconfig === undefined || uhconfig === null)
            throw new Error("The parameter 'uhconfig' must be defined.");
        url_ = url_.replace("{uhconfig}", encodeURIComponent("" + uhconfig));
        if (hhs === undefined || hhs === null)
            throw new Error("The parameter 'hhs' must be defined.");
        url_ = url_.replace("{hhs}", encodeURIComponent("" + hhs));
        if (pk === undefined || pk === null)
            throw new Error("The parameter 'pk' must be defined.");
        url_ = url_.replace("{pk}", encodeURIComponent("" + pk));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetPk2HHS(_response);
        });
    }

    protected processSetPk2HHS(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addPlanstufe(copyprog: boolean, authorization: any | undefined, body: Planstufen | undefined): Promise<Planstufen> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddPlanstufe/{copyprog}";
        if (copyprog === undefined || copyprog === null)
            throw new Error("The parameter 'copyprog' must be defined.");
        url_ = url_.replace("{copyprog}", encodeURIComponent("" + copyprog));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddPlanstufe(_response);
        });
    }

    protected processAddPlanstufe(response: Response): Promise<Planstufen> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Planstufen.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Planstufen>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    copyPlanstufe(authorization: any | undefined, body: Planstufen | undefined): Promise<Planstufen> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/CopyPlanstufe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCopyPlanstufe(_response);
        });
    }

    protected processCopyPlanstufe(response: Response): Promise<Planstufen> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Planstufen.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Planstufen>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removePlanstufe(authorization: any | undefined, body: Planstufen | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemovePlanstufe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemovePlanstufe(_response);
        });
    }

    protected processRemovePlanstufe(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyPlanstufe(authorization: any | undefined, body: Planstufen | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ModifyPlanstufe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyPlanstufe(_response);
        });
    }

    protected processModifyPlanstufe(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    planstufen(authorization: any | undefined, body: JahrModel | undefined): Promise<Planstufen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/planstufen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPlanstufen(_response);
        });
    }

    protected processPlanstufen(response: Response): Promise<Planstufen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Planstufen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Planstufen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getPlanstufenHiddenTabs(authorization: any | undefined, body: Planstufen | undefined): Promise<PlanstufenHiddenTabsModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetPlanstufenHiddenTabs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlanstufenHiddenTabs(_response);
        });
    }

    protected processGetPlanstufenHiddenTabs(response: Response): Promise<PlanstufenHiddenTabsModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlanstufenHiddenTabsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlanstufenHiddenTabsModel[]>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param plantyp (optional) 
     * @param planstufe (optional) 
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setPlanstufenHiddenTabs(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, plantyp: number | undefined, planstufe: number | undefined, authorization: any | undefined, body: PlanstufenHiddenTabsModel[] | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/SetPlanstufenHiddenTabs?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (plantyp === null)
            throw new Error("The parameter 'plantyp' cannot be null.");
        else if (plantyp !== undefined)
            url_ += "plantyp=" + encodeURIComponent("" + plantyp) + "&";
        if (planstufe === null)
            throw new Error("The parameter 'planstufe' cannot be null.");
        else if (planstufe !== undefined)
            url_ += "planstufe=" + encodeURIComponent("" + planstufe) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetPlanstufenHiddenTabs(_response);
        });
    }

    protected processSetPlanstufenHiddenTabs(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    importschedules(authorization: any | undefined, body: GemeindeModel | undefined): Promise<ImportSchedule[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/importschedules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImportschedules(_response);
        });
    }

    protected processImportschedules(response: Response): Promise<ImportSchedule[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImportSchedule.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportSchedule[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addImportSchedule(authorization: any | undefined, body: ImportSchedule | undefined): Promise<ImportSchedule> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddImportSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddImportSchedule(_response);
        });
    }

    protected processAddImportSchedule(response: Response): Promise<ImportSchedule> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportSchedule.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportSchedule>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeImportSchedule(authorization: any | undefined, body: ImportSchedule | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveImportSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveImportSchedule(_response);
        });
    }

    protected processRemoveImportSchedule(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyImportSchedule(authorization: any | undefined, body: ImportSchedule | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ModifyImportSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyImportSchedule(_response);
        });
    }

    protected processModifyImportSchedule(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeJahr(authorization: any | undefined, body: JahrModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveJahr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveJahr(_response);
        });
    }

    protected processRemoveJahr(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyKennzahltemplate(authorization: any | undefined, body: TemplateKennzahlen | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ModifyKennzahltemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyKennzahltemplate(_response);
        });
    }

    protected processModifyKennzahltemplate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getKennzahltemplatesByGemeinde(kunde: number, gemeinde: number, authorization: any | undefined): Promise<TemplateKennzahlen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetKennzahltemplatesByGemeinde/{kunde}/{gemeinde}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetKennzahltemplatesByGemeinde(_response);
        });
    }

    protected processGetKennzahltemplatesByGemeinde(response: Response): Promise<TemplateKennzahlen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateKennzahlen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateKennzahlen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getKennzahltemplates(authorization: any | undefined): Promise<TemplateKennzahlen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetKennzahltemplates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetKennzahltemplates(_response);
        });
    }

    protected processGetKennzahltemplates(response: Response): Promise<TemplateKennzahlen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateKennzahlen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateKennzahlen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeKennzahltemplate(authorization: any | undefined, body: TemplateKennzahlen | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveKennzahltemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveKennzahltemplate(_response);
        });
    }

    protected processRemoveKennzahltemplate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addKennzahltemplate(authorization: any | undefined, body: TemplateKennzahlen | undefined): Promise<TemplateKennzahlen> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddKennzahltemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddKennzahltemplate(_response);
        });
    }

    protected processAddKennzahltemplate(response: Response): Promise<TemplateKennzahlen> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemplateKennzahlen.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateKennzahlen>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setTemplateKennzahlzeilen(kennzahl: number, authorization: any | undefined, body: TemplateKennzahlzeilen[] | undefined): Promise<TemplateKennzahlzeilen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/SetTemplateKennzahlzeilen/{kennzahl}";
        if (kennzahl === undefined || kennzahl === null)
            throw new Error("The parameter 'kennzahl' must be defined.");
        url_ = url_.replace("{kennzahl}", encodeURIComponent("" + kennzahl));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetTemplateKennzahlzeilen(_response);
        });
    }

    protected processSetTemplateKennzahlzeilen(response: Response): Promise<TemplateKennzahlzeilen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateKennzahlzeilen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateKennzahlzeilen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getTemplateKennzahlzeilen(kennzahl: number, authorization: any | undefined): Promise<TemplateKennzahlzeilen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetTemplateKennzahlzeilen/{kennzahl}";
        if (kennzahl === undefined || kennzahl === null)
            throw new Error("The parameter 'kennzahl' must be defined.");
        url_ = url_.replace("{kennzahl}", encodeURIComponent("" + kennzahl));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTemplateKennzahlzeilen(_response);
        });
    }

    protected processGetTemplateKennzahlzeilen(response: Response): Promise<TemplateKennzahlzeilen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateKennzahlzeilen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateKennzahlzeilen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyKennzahl(authorization: any | undefined, body: Kennzahlen | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ModifyKennzahl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyKennzahl(_response);
        });
    }

    protected processModifyKennzahl(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    duplicateKennzahl(authorization: any | undefined, body: Kennzahlen | undefined): Promise<Kennzahlen> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/DuplicateKennzahl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDuplicateKennzahl(_response);
        });
    }

    protected processDuplicateKennzahl(response: Response): Promise<Kennzahlen> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Kennzahlen.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Kennzahlen>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getKennzahlen(authorization: any | undefined, body: JahrModel | undefined): Promise<Kennzahlen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetKennzahlen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetKennzahlen(_response);
        });
    }

    protected processGetKennzahlen(response: Response): Promise<Kennzahlen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Kennzahlen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Kennzahlen[]>(null as any);
    }

    /**
     * @param produkt (optional) 
     * @param hHTyp (optional) 
     * @param plantyp (optional) 
     * @param planstufe (optional) 
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getProduktKennzahlen(produkt: string | undefined, hHTyp: number | undefined, plantyp: number | undefined, planstufe: number | undefined, authorization: any | undefined, body: JahrModel | undefined): Promise<Kennzahlen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetProduktKennzahlen?";
        if (produkt === null)
            throw new Error("The parameter 'produkt' cannot be null.");
        else if (produkt !== undefined)
            url_ += "produkt=" + encodeURIComponent("" + produkt) + "&";
        if (hHTyp === null)
            throw new Error("The parameter 'hHTyp' cannot be null.");
        else if (hHTyp !== undefined)
            url_ += "HHTyp=" + encodeURIComponent("" + hHTyp) + "&";
        if (plantyp === null)
            throw new Error("The parameter 'plantyp' cannot be null.");
        else if (plantyp !== undefined)
            url_ += "plantyp=" + encodeURIComponent("" + plantyp) + "&";
        if (planstufe === null)
            throw new Error("The parameter 'planstufe' cannot be null.");
        else if (planstufe !== undefined)
            url_ += "planstufe=" + encodeURIComponent("" + planstufe) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProduktKennzahlen(_response);
        });
    }

    protected processGetProduktKennzahlen(response: Response): Promise<Kennzahlen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Kennzahlen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Kennzahlen[]>(null as any);
    }

    /**
     * @param plantyp (optional) 
     * @param planstufe (optional) 
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getAllgemeineKennzahlen(plantyp: number | undefined, planstufe: number | undefined, authorization: any | undefined, body: JahrModel | undefined): Promise<Kennzahlen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetAllgemeineKennzahlen?";
        if (plantyp === null)
            throw new Error("The parameter 'plantyp' cannot be null.");
        else if (plantyp !== undefined)
            url_ += "plantyp=" + encodeURIComponent("" + plantyp) + "&";
        if (planstufe === null)
            throw new Error("The parameter 'planstufe' cannot be null.");
        else if (planstufe !== undefined)
            url_ += "planstufe=" + encodeURIComponent("" + planstufe) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllgemeineKennzahlen(_response);
        });
    }

    protected processGetAllgemeineKennzahlen(response: Response): Promise<Kennzahlen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Kennzahlen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Kennzahlen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeKennzahl(authorization: any | undefined, body: Kennzahlen | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveKennzahl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveKennzahl(_response);
        });
    }

    protected processRemoveKennzahl(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addKennzahl(authorization: any | undefined, body: Kennzahlen | undefined): Promise<Kennzahlen> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddKennzahl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddKennzahl(_response);
        });
    }

    protected processAddKennzahl(response: Response): Promise<Kennzahlen> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Kennzahlen.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Kennzahlen>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    addKennzahlFromTemplate(kunde: number, gemeinde: number, jahr: number, templatekennzahl: number, authorization: any | undefined): Promise<Kennzahlen> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddKennzahlFromTemplate/{kunde}/{gemeinde}/{jahr}/{templatekennzahl}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (templatekennzahl === undefined || templatekennzahl === null)
            throw new Error("The parameter 'templatekennzahl' must be defined.");
        url_ = url_.replace("{templatekennzahl}", encodeURIComponent("" + templatekennzahl));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddKennzahlFromTemplate(_response);
        });
    }

    protected processAddKennzahlFromTemplate(response: Response): Promise<Kennzahlen> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Kennzahlen.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Kennzahlen>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setKennzahlzeilen(kennzahl: number, authorization: any | undefined, body: Kennzahlzeilen[] | undefined): Promise<Kennzahlzeilen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/SetKennzahlzeilen/{kennzahl}";
        if (kennzahl === undefined || kennzahl === null)
            throw new Error("The parameter 'kennzahl' must be defined.");
        url_ = url_.replace("{kennzahl}", encodeURIComponent("" + kennzahl));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetKennzahlzeilen(_response);
        });
    }

    protected processSetKennzahlzeilen(response: Response): Promise<Kennzahlzeilen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Kennzahlzeilen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Kennzahlzeilen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getKennzahlzeilen(kennzahl: number, authorization: any | undefined): Promise<Kennzahlzeilen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetKennzahlzeilen/{kennzahl}";
        if (kennzahl === undefined || kennzahl === null)
            throw new Error("The parameter 'kennzahl' must be defined.");
        url_ = url_.replace("{kennzahl}", encodeURIComponent("" + kennzahl));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetKennzahlzeilen(_response);
        });
    }

    protected processGetKennzahlzeilen(response: Response): Promise<Kennzahlzeilen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Kennzahlzeilen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Kennzahlzeilen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyInvestition(authorization: any | undefined, body: Investitionen | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ModifyInvestition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyInvestition(_response);
        });
    }

    protected processModifyInvestition(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getInvestitionen(authorization: any | undefined, body: JahrModel | undefined): Promise<Investitionen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetInvestitionen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInvestitionen(_response);
        });
    }

    protected processGetInvestitionen(response: Response): Promise<Investitionen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Investitionen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Investitionen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeInvestition(authorization: any | undefined, body: Investitionen | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveInvestition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveInvestition(_response);
        });
    }

    protected processRemoveInvestition(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addInvestition(authorization: any | undefined, body: Investitionen | undefined): Promise<Investitionen> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddInvestition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddInvestition(_response);
        });
    }

    protected processAddInvestition(response: Response): Promise<Investitionen> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Investitionen.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Investitionen>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    autoCreateInvestitionen(kunde: number, gemeinde: number, jahr: number, overwrite: boolean, grenze: number, anzFJahre: number, datenTyp: number, uHConfig: number, authorization: any | undefined): Promise<Investitionen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AutoCreateInvestitionen/{Kunde}/{Gemeinde}/{Jahr}/{Overwrite}/{Grenze}/{AnzFJahre}/{DatenTyp}/{UHConfig}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{Kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{Gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{Jahr}", encodeURIComponent("" + jahr));
        if (overwrite === undefined || overwrite === null)
            throw new Error("The parameter 'overwrite' must be defined.");
        url_ = url_.replace("{Overwrite}", encodeURIComponent("" + overwrite));
        if (grenze === undefined || grenze === null)
            throw new Error("The parameter 'grenze' must be defined.");
        url_ = url_.replace("{Grenze}", encodeURIComponent("" + grenze));
        if (anzFJahre === undefined || anzFJahre === null)
            throw new Error("The parameter 'anzFJahre' must be defined.");
        url_ = url_.replace("{AnzFJahre}", encodeURIComponent("" + anzFJahre));
        if (datenTyp === undefined || datenTyp === null)
            throw new Error("The parameter 'datenTyp' must be defined.");
        url_ = url_.replace("{DatenTyp}", encodeURIComponent("" + datenTyp));
        if (uHConfig === undefined || uHConfig === null)
            throw new Error("The parameter 'uHConfig' must be defined.");
        url_ = url_.replace("{UHConfig}", encodeURIComponent("" + uHConfig));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAutoCreateInvestitionen(_response);
        });
    }

    protected processAutoCreateInvestitionen(response: Response): Promise<Investitionen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Investitionen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Investitionen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setInvestTexte(kunde: number, gemeinde: number, jahr: number, invest: number, authorization: any | undefined, body: FreiTextModel[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/SetInvestTexte/{kunde}/{gemeinde}/{jahr}/{invest}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (invest === undefined || invest === null)
            throw new Error("The parameter 'invest' must be defined.");
        url_ = url_.replace("{invest}", encodeURIComponent("" + invest));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetInvestTexte(_response);
        });
    }

    protected processSetInvestTexte(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getInvestTexte(kunde: number, gemeinde: number, jahr: number, invest: number, authorization: any | undefined): Promise<FreiTextModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetInvestTexte/{kunde}/{gemeinde}/{jahr}/{invest}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (invest === undefined || invest === null)
            throw new Error("The parameter 'invest' must be defined.");
        url_ = url_.replace("{invest}", encodeURIComponent("" + invest));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInvestTexte(_response);
        });
    }

    protected processGetInvestTexte(response: Response): Promise<FreiTextModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FreiTextModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FreiTextModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getInvestTextBezeichner(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetInvestTextBezeichner/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInvestTextBezeichner(_response);
        });
    }

    protected processGetInvestTextBezeichner(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setInvestHaushaltsstellen(kunde: number, gemeinde: number, jahr: number, invest: number, authorization: any | undefined, body: InvestmentHaushaltsstellen | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/SetInvestHaushaltsstellen/{kunde}/{gemeinde}/{jahr}/{invest}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (invest === undefined || invest === null)
            throw new Error("The parameter 'invest' must be defined.");
        url_ = url_.replace("{invest}", encodeURIComponent("" + invest));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetInvestHaushaltsstellen(_response);
        });
    }

    protected processSetInvestHaushaltsstellen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getInvestHaushaltsstellen(kunde: number, gemeinde: number, jahr: number, invest: number, authorization: any | undefined): Promise<InvestmentHaushaltsstellen> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetInvestHaushaltsstellen/{kunde}/{gemeinde}/{jahr}/{invest}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (invest === undefined || invest === null)
            throw new Error("The parameter 'invest' must be defined.");
        url_ = url_.replace("{invest}", encodeURIComponent("" + invest));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInvestHaushaltsstellen(_response);
        });
    }

    protected processGetInvestHaushaltsstellen(response: Response): Promise<InvestmentHaushaltsstellen> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvestmentHaushaltsstellen.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvestmentHaushaltsstellen>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    gruppen(authorization: any | undefined, body: JahrModel | undefined): Promise<GruppierungsModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/gruppen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGruppen(_response);
        });
    }

    protected processGruppen(response: Response): Promise<GruppierungsModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GruppierungsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GruppierungsModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    updategruppen(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined, body: GruppierungsModel[] | undefined): Promise<GruppierungsModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/{kunde}/{gemeinde}/{jahr}/updategruppen";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdategruppen(_response);
        });
    }

    protected processUpdategruppen(response: Response): Promise<GruppierungsModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GruppierungsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GruppierungsModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushGRSuchTexte(authorization: any | undefined, body: PushKoPrGrGlModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/PushGRSuchTexte";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushGRSuchTexte(_response);
        });
    }

    protected processPushGRSuchTexte(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushGruppierung(authorization: any | undefined, body: PushGruppierungModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/PushGruppierung";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushGruppierung(_response);
        });
    }

    protected processPushGruppierung(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushGLSuchTexte(authorization: any | undefined, body: PushKoPrGrGlModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/PushGLSuchTexte";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushGLSuchTexte(_response);
        });
    }

    protected processPushGLSuchTexte(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushGliederung(authorization: any | undefined, body: PushGliederungModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/PushGliederung";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushGliederung(_response);
        });
    }

    protected processPushGliederung(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    duplicateGRSuchTexte(zielKunde: number, zielGemeinde: number, zielJahr: number, authorization: any | undefined, body: JahrModel | undefined): Promise<GruppierungsModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/DuplicateGRSuchTexte/{ZielKunde}/{ZielGemeinde}/{ZielJahr}";
        if (zielKunde === undefined || zielKunde === null)
            throw new Error("The parameter 'zielKunde' must be defined.");
        url_ = url_.replace("{ZielKunde}", encodeURIComponent("" + zielKunde));
        if (zielGemeinde === undefined || zielGemeinde === null)
            throw new Error("The parameter 'zielGemeinde' must be defined.");
        url_ = url_.replace("{ZielGemeinde}", encodeURIComponent("" + zielGemeinde));
        if (zielJahr === undefined || zielJahr === null)
            throw new Error("The parameter 'zielJahr' must be defined.");
        url_ = url_.replace("{ZielJahr}", encodeURIComponent("" + zielJahr));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDuplicateGRSuchTexte(_response);
        });
    }

    protected processDuplicateGRSuchTexte(response: Response): Promise<GruppierungsModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GruppierungsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GruppierungsModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    gruppierungsebenen(authorization: any | undefined, body: JahrModel | undefined): Promise<GruppierungsebenenModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/gruppierungsebenen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGruppierungsebenen(_response);
        });
    }

    protected processGruppierungsebenen(response: Response): Promise<GruppierungsebenenModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GruppierungsebenenModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GruppierungsebenenModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getGruppierungsBuchungsebene(authorization: any | undefined, body: JahrModel | undefined): Promise<GruppierungsebenenModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetGruppierungsBuchungsebene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetGruppierungsBuchungsebene(_response);
        });
    }

    protected processGetGruppierungsBuchungsebene(response: Response): Promise<GruppierungsebenenModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GruppierungsebenenModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GruppierungsebenenModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    updategruppierungsebenen(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined, body: GruppierungsebenenModel[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/{kunde}/{gemeinde}/{jahr}/updategruppierungsebenen";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdategruppierungsebenen(_response);
        });
    }

    protected processUpdategruppierungsebenen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    gliederung(authorization: any | undefined, body: JahrModel | undefined): Promise<GliederungsModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/gliederung";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGliederung(_response);
        });
    }

    protected processGliederung(response: Response): Promise<GliederungsModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GliederungsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GliederungsModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getFarben(authorization: any | undefined, body: JahrModel | undefined): Promise<Farben[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetFarben";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFarben(_response);
        });
    }

    protected processGetFarben(response: Response): Promise<Farben[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Farben.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Farben[]>(null as any);
    }

    updateFarben(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, authorization: any | undefined, body: Farben[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/UpdateFarben?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateFarben(_response);
        });
    }

    protected processUpdateFarben(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushFarben(authorization: any | undefined, body: PushFarbenModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/PushFarben";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushFarben(_response);
        });
    }

    protected processPushFarben(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    duplicateGLSuchTexte(zielKunde: number, zielGemeinde: number, zielJahr: number, authorization: any | undefined, body: JahrModel | undefined): Promise<GliederungsModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/DuplicateGLSuchTexte/{ZielKunde}/{ZielGemeinde}/{ZielJahr}";
        if (zielKunde === undefined || zielKunde === null)
            throw new Error("The parameter 'zielKunde' must be defined.");
        url_ = url_.replace("{ZielKunde}", encodeURIComponent("" + zielKunde));
        if (zielGemeinde === undefined || zielGemeinde === null)
            throw new Error("The parameter 'zielGemeinde' must be defined.");
        url_ = url_.replace("{ZielGemeinde}", encodeURIComponent("" + zielGemeinde));
        if (zielJahr === undefined || zielJahr === null)
            throw new Error("The parameter 'zielJahr' must be defined.");
        url_ = url_.replace("{ZielJahr}", encodeURIComponent("" + zielJahr));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDuplicateGLSuchTexte(_response);
        });
    }

    protected processDuplicateGLSuchTexte(response: Response): Promise<GliederungsModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GliederungsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GliederungsModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    gliederungsebenen(authorization: any | undefined, body: JahrModel | undefined): Promise<GliederungsebenenModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/gliederungsebenen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGliederungsebenen(_response);
        });
    }

    protected processGliederungsebenen(response: Response): Promise<GliederungsebenenModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GliederungsebenenModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GliederungsebenenModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getGliederungsBuchungsebene(authorization: any | undefined, body: JahrModel | undefined): Promise<GliederungsebenenModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetGliederungsBuchungsebene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetGliederungsBuchungsebene(_response);
        });
    }

    protected processGetGliederungsBuchungsebene(response: Response): Promise<GliederungsebenenModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GliederungsebenenModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GliederungsebenenModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    updategliederungsebenen(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined, body: GliederungsebenenModel[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/{kunde}/{gemeinde}/{jahr}/updategliederungsebenen";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdategliederungsebenen(_response);
        });
    }

    protected processUpdategliederungsebenen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addJahr(authorization: any | undefined, body: JahrModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddJahr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddJahr(_response);
        });
    }

    protected processAddJahr(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    duplicateKennzahlen(zielKunde: number, zielGemeinde: number, zielJahr: number, authorization: any | undefined, body: JahrModel | undefined): Promise<Kennzahlen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/DuplicateKennzahlen/{ZielKunde}/{ZielGemeinde}/{ZielJahr}";
        if (zielKunde === undefined || zielKunde === null)
            throw new Error("The parameter 'zielKunde' must be defined.");
        url_ = url_.replace("{ZielKunde}", encodeURIComponent("" + zielKunde));
        if (zielGemeinde === undefined || zielGemeinde === null)
            throw new Error("The parameter 'zielGemeinde' must be defined.");
        url_ = url_.replace("{ZielGemeinde}", encodeURIComponent("" + zielGemeinde));
        if (zielJahr === undefined || zielJahr === null)
            throw new Error("The parameter 'zielJahr' must be defined.");
        url_ = url_.replace("{ZielJahr}", encodeURIComponent("" + zielJahr));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDuplicateKennzahlen(_response);
        });
    }

    protected processDuplicateKennzahlen(response: Response): Promise<Kennzahlen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Kennzahlen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Kennzahlen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushKennzahlen(authorization: any | undefined, body: PushKennzahlenModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/PushKennzahlen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushKennzahlen(_response);
        });
    }

    protected processPushKennzahlen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushDSHP(authorization: any | undefined, body: PushDSHP | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/PushDSHP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushDSHP(_response);
        });
    }

    protected processPushDSHP(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushHHSettings(authorization: any | undefined, body: PushHHSettingsModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/PushHHSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushHHSettings(_response);
        });
    }

    protected processPushHHSettings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushInvestSettings(authorization: any | undefined, body: PushInvestSettingsModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/PushInvestSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushInvestSettings(_response);
        });
    }

    protected processPushInvestSettings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushABC(authorization: any | undefined, body: PushABCModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/PushABC";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushABC(_response);
        });
    }

    protected processPushABC(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushChangeSettings(authorization: any | undefined, body: PushChangeSettingsModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/PushChangeSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushChangeSettings(_response);
        });
    }

    protected processPushChangeSettings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushTexte(authorization: any | undefined, body: PushTexteModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/PushTexte";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushTexte(_response);
        });
    }

    protected processPushTexte(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    duplicateVB(zielKunde: number, zielGemeinde: number, zielJahr: number, includeFreeSets: boolean, authorization: any | undefined, body: JahrModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/DuplicateVB/{ZielKunde}/{ZielGemeinde}/{ZielJahr}/{IncludeFreeSets}";
        if (zielKunde === undefined || zielKunde === null)
            throw new Error("The parameter 'zielKunde' must be defined.");
        url_ = url_.replace("{ZielKunde}", encodeURIComponent("" + zielKunde));
        if (zielGemeinde === undefined || zielGemeinde === null)
            throw new Error("The parameter 'zielGemeinde' must be defined.");
        url_ = url_.replace("{ZielGemeinde}", encodeURIComponent("" + zielGemeinde));
        if (zielJahr === undefined || zielJahr === null)
            throw new Error("The parameter 'zielJahr' must be defined.");
        url_ = url_.replace("{ZielJahr}", encodeURIComponent("" + zielJahr));
        if (includeFreeSets === undefined || includeFreeSets === null)
            throw new Error("The parameter 'includeFreeSets' must be defined.");
        url_ = url_.replace("{IncludeFreeSets}", encodeURIComponent("" + includeFreeSets));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDuplicateVB(_response);
        });
    }

    protected processDuplicateVB(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    duplicateGZ(zielKunde: number, zielGemeinde: number, zielJahr: number, authorization: any | undefined, body: JahrModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/DuplicateGZ/{ZielKunde}/{ZielGemeinde}/{ZielJahr}";
        if (zielKunde === undefined || zielKunde === null)
            throw new Error("The parameter 'zielKunde' must be defined.");
        url_ = url_.replace("{ZielKunde}", encodeURIComponent("" + zielKunde));
        if (zielGemeinde === undefined || zielGemeinde === null)
            throw new Error("The parameter 'zielGemeinde' must be defined.");
        url_ = url_.replace("{ZielGemeinde}", encodeURIComponent("" + zielGemeinde));
        if (zielJahr === undefined || zielJahr === null)
            throw new Error("The parameter 'zielJahr' must be defined.");
        url_ = url_.replace("{ZielJahr}", encodeURIComponent("" + zielJahr));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDuplicateGZ(_response);
        });
    }

    protected processDuplicateGZ(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushGZEbenen(authorization: any | undefined, body: PushGZEbenenModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/PushGZEbenen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushGZEbenen(_response);
        });
    }

    protected processPushGZEbenen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushVBTabs(authorization: any | undefined, body: PushVBTabsModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/PushVBTabs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushVBTabs(_response);
        });
    }

    protected processPushVBTabs(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    duplicateVBPlatzhalter(zielKunde: number, zielGemeinde: number, ueberschreiben: boolean, quellberichttyp: number, zielberichttyp: number, authorization: any | undefined, body: JahrModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/DuplicateVBPlatzhalter/{ZielKunde}/{ZielGemeinde}/{Ueberschreiben}/{quellberichttyp}/{zielberichttyp}";
        if (zielKunde === undefined || zielKunde === null)
            throw new Error("The parameter 'zielKunde' must be defined.");
        url_ = url_.replace("{ZielKunde}", encodeURIComponent("" + zielKunde));
        if (zielGemeinde === undefined || zielGemeinde === null)
            throw new Error("The parameter 'zielGemeinde' must be defined.");
        url_ = url_.replace("{ZielGemeinde}", encodeURIComponent("" + zielGemeinde));
        if (ueberschreiben === undefined || ueberschreiben === null)
            throw new Error("The parameter 'ueberschreiben' must be defined.");
        url_ = url_.replace("{Ueberschreiben}", encodeURIComponent("" + ueberschreiben));
        if (quellberichttyp === undefined || quellberichttyp === null)
            throw new Error("The parameter 'quellberichttyp' must be defined.");
        url_ = url_.replace("{quellberichttyp}", encodeURIComponent("" + quellberichttyp));
        if (zielberichttyp === undefined || zielberichttyp === null)
            throw new Error("The parameter 'zielberichttyp' must be defined.");
        url_ = url_.replace("{zielberichttyp}", encodeURIComponent("" + zielberichttyp));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDuplicateVBPlatzhalter(_response);
        });
    }

    protected processDuplicateVBPlatzhalter(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushVBPlatzhalter(authorization: any | undefined, body: PushVBPlatzhalterKameralModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/PushVBPlatzhalter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushVBPlatzhalter(_response);
        });
    }

    protected processPushVBPlatzhalter(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushSystemVBPlatzhalter(authorization: any | undefined, body: PushVBPlatzhalterKameralModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/PushSystemVBPlatzhalter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushSystemVBPlatzhalter(_response);
        });
    }

    protected processPushSystemVBPlatzhalter(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushSystemVBPlatzhalterUeberschreibungen(authorization: any | undefined, body: PushVBPlatzhalterKameralModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/PushSystemVBPlatzhalterUeberschreibungen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushSystemVBPlatzhalterUeberschreibungen(_response);
        });
    }

    protected processPushSystemVBPlatzhalterUeberschreibungen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    duplicateJahr(zielKunde: number, zielGemeinde: number, authorization: any | undefined, body: JahrModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/DuplicateJahr/{ZielKunde}/{ZielGemeinde}";
        if (zielKunde === undefined || zielKunde === null)
            throw new Error("The parameter 'zielKunde' must be defined.");
        url_ = url_.replace("{ZielKunde}", encodeURIComponent("" + zielKunde));
        if (zielGemeinde === undefined || zielGemeinde === null)
            throw new Error("The parameter 'zielGemeinde' must be defined.");
        url_ = url_.replace("{ZielGemeinde}", encodeURIComponent("" + zielGemeinde));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDuplicateJahr(_response);
        });
    }

    protected processDuplicateJahr(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadHHStellenBinA(kunde: number, gemeinde: number, jahr: number, format: number, dateiname: string, authorization: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/UploadHHStellenBinA/{kunde}/{gemeinde}/{jahr}/{format}/{dateiname}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (dateiname === undefined || dateiname === null)
            throw new Error("The parameter 'dateiname' must be defined.");
        url_ = url_.replace("{dateiname}", encodeURIComponent("" + dateiname));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadHHStellenBinA(_response);
        });
    }

    protected processUploadHHStellenBinA(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadHHStellenBin(kunde: number, gemeinde: number, jahr: number, format: number, authorization: any | undefined): Promise<ImportHHSResult> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/UploadHHStellenBin/{kunde}/{gemeinde}/{jahr}/{format}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadHHStellenBin(_response);
        });
    }

    protected processUploadHHStellenBin(response: Response): Promise<ImportHHSResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportHHSResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportHHSResult>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadHHJRDatenBinA(kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, format: number, importjahr: number, dateiname: string, authorization: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/UploadHHJRDatenBinA/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}/{format}/{importjahr}/{dateiname}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (importjahr === undefined || importjahr === null)
            throw new Error("The parameter 'importjahr' must be defined.");
        url_ = url_.replace("{importjahr}", encodeURIComponent("" + importjahr));
        if (dateiname === undefined || dateiname === null)
            throw new Error("The parameter 'dateiname' must be defined.");
        url_ = url_.replace("{dateiname}", encodeURIComponent("" + dateiname));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadHHJRDatenBinA(_response);
        });
    }

    protected processUploadHHJRDatenBinA(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadHHJRDatenBin(kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, format: number, importjahr: number, authorization: any | undefined): Promise<ImportHHDResult> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/UploadHHJRDatenBin/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}/{format}/{importjahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (importjahr === undefined || importjahr === null)
            throw new Error("The parameter 'importjahr' must be defined.");
        url_ = url_.replace("{importjahr}", encodeURIComponent("" + importjahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadHHJRDatenBin(_response);
        });
    }

    protected processUploadHHJRDatenBin(response: Response): Promise<ImportHHDResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportHHDResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportHHDResult>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadHHUHDatenBinA(kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, format: number, importjahr: number, dateiname: string, authorization: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/UploadHHUHDatenBinA/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}/{format}/{importjahr}/{dateiname}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (importjahr === undefined || importjahr === null)
            throw new Error("The parameter 'importjahr' must be defined.");
        url_ = url_.replace("{importjahr}", encodeURIComponent("" + importjahr));
        if (dateiname === undefined || dateiname === null)
            throw new Error("The parameter 'dateiname' must be defined.");
        url_ = url_.replace("{dateiname}", encodeURIComponent("" + dateiname));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadHHUHDatenBinA(_response);
        });
    }

    protected processUploadHHUHDatenBinA(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    haushaltsstellen(authorization: any | undefined, body: JahrModel | undefined): Promise<HaushaltsstelleKameralModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/haushaltsstellen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHaushaltsstellen(_response);
        });
    }

    protected processHaushaltsstellen(response: Response): Promise<HaushaltsstelleKameralModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HaushaltsstelleKameralModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsstelleKameralModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    checkUHHS(uhconfig: number, planstufe: number, authorization: any | undefined, body: JahrModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/CheckUHHS/{uhconfig}/{planstufe}";
        if (uhconfig === undefined || uhconfig === null)
            throw new Error("The parameter 'uhconfig' must be defined.");
        url_ = url_.replace("{uhconfig}", encodeURIComponent("" + uhconfig));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckUHHS(_response);
        });
    }

    protected processCheckUHHS(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getUHHS(uhconfig: number, planstufe: number, authorization: any | undefined, body: JahrModel | undefined): Promise<UHHSKameralModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetUHHS/{uhconfig}/{planstufe}";
        if (uhconfig === undefined || uhconfig === null)
            throw new Error("The parameter 'uhconfig' must be defined.");
        url_ = url_.replace("{uhconfig}", encodeURIComponent("" + uhconfig));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUHHS(_response);
        });
    }

    protected processGetUHHS(response: Response): Promise<UHHSKameralModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UHHSKameralModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UHHSKameralModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setUHHS(uhconfig: number, planstufe: number, authorization: any | undefined, body: UHHSKameralModel | undefined): Promise<UHHSKameralModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/SetUHHS/{uhconfig}/{planstufe}";
        if (uhconfig === undefined || uhconfig === null)
            throw new Error("The parameter 'uhconfig' must be defined.");
        url_ = url_.replace("{uhconfig}", encodeURIComponent("" + uhconfig));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetUHHS(_response);
        });
    }

    protected processSetUHHS(response: Response): Promise<UHHSKameralModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UHHSKameralModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UHHSKameralModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setUHHSArray(uhconfig: number, planstufe: number, authorization: any | undefined, body: UHHSKameralModel[] | undefined): Promise<UHHSKameralModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/SetUHHSArray/{uhconfig}/{planstufe}";
        if (uhconfig === undefined || uhconfig === null)
            throw new Error("The parameter 'uhconfig' must be defined.");
        url_ = url_.replace("{uhconfig}", encodeURIComponent("" + uhconfig));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetUHHSArray(_response);
        });
    }

    protected processSetUHHSArray(response: Response): Promise<UHHSKameralModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UHHSKameralModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UHHSKameralModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushPrognosekurvenZuweisungen(authorization: any | undefined, body: PushPrognosekurvenZuweisungenModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/PushPrognosekurvenZuweisungen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushPrognosekurvenZuweisungen(_response);
        });
    }

    protected processPushPrognosekurvenZuweisungen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    calcProgMan(authorization: any | undefined, body: CalcPMKameralModel | undefined): Promise<UHHSKameralModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/CalcProgMan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCalcProgMan(_response);
        });
    }

    protected processCalcProgMan(response: Response): Promise<UHHSKameralModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UHHSKameralModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UHHSKameralModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    haushaltsAusgleich(planstufe: number, uhconfig: number, authorization: any | undefined, body: JahrModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/HaushaltsAusgleich/{planstufe}/{uhconfig}";
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (uhconfig === undefined || uhconfig === null)
            throw new Error("The parameter 'uhconfig' must be defined.");
        url_ = url_.replace("{uhconfig}", encodeURIComponent("" + uhconfig));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHaushaltsAusgleich(_response);
        });
    }

    protected processHaushaltsAusgleich(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getVMEinnahmeHaushaltsstellen(authorization: any | undefined, body: JahrModel | undefined): Promise<Haushaltsstellen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetVMEinnahmeHaushaltsstellen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVMEinnahmeHaushaltsstellen(_response);
        });
    }

    protected processGetVMEinnahmeHaushaltsstellen(response: Response): Promise<Haushaltsstellen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Haushaltsstellen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Haushaltsstellen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getVMAusgabeHaushaltsstellen(authorization: any | undefined, body: JahrModel | undefined): Promise<Haushaltsstellen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetVMAusgabeHaushaltsstellen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVMAusgabeHaushaltsstellen(_response);
        });
    }

    protected processGetVMAusgabeHaushaltsstellen(response: Response): Promise<Haushaltsstellen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Haushaltsstellen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Haushaltsstellen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    cleanUpHHStellen(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/CleanUpHHStellen/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCleanUpHHStellen(_response);
        });
    }

    protected processCleanUpHHStellen(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadHHBeschreibungenBinA(kunde: number, gemeinde: number, jahr: number, dateiname: string, authorization: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/UploadHHBeschreibungenBinA/{kunde}/{gemeinde}/{jahr}/{dateiname}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (dateiname === undefined || dateiname === null)
            throw new Error("The parameter 'dateiname' must be defined.");
        url_ = url_.replace("{dateiname}", encodeURIComponent("" + dateiname));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadHHBeschreibungenBinA(_response);
        });
    }

    protected processUploadHHBeschreibungenBinA(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadHHBeschreibungenBin(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/UploadHHBeschreibungenBin/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadHHBeschreibungenBin(_response);
        });
    }

    protected processUploadHHBeschreibungenBin(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateHaushaltsstellen(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined, body: HaushaltsstelleKameralModel[] | undefined): Promise<HaushaltsstelleKameralModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/{kunde}/{gemeinde}/{jahr}/UpdateHaushaltsstellen";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateHaushaltsstellen(_response);
        });
    }

    protected processUpdateHaushaltsstellen(response: Response): Promise<HaushaltsstelleKameralModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HaushaltsstelleKameralModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsstelleKameralModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadHHDatenBinA(kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, format: number, dateiname: string, authorization: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/UploadHHDatenBinA/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}/{format}/{dateiname}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (dateiname === undefined || dateiname === null)
            throw new Error("The parameter 'dateiname' must be defined.");
        url_ = url_.replace("{dateiname}", encodeURIComponent("" + dateiname));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadHHDatenBinA(_response);
        });
    }

    protected processUploadHHDatenBinA(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadHHDatenBin(kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, format: number, authorization: any | undefined): Promise<ImportHHDResult> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/UploadHHDatenBin/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}/{format}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadHHDatenBin(_response);
        });
    }

    protected processUploadHHDatenBin(response: Response): Promise<ImportHHDResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportHHDResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportHHDResult>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param fileData (optional) 
     * @param bundesland (optional) 
     * @return OK
     */
    uploadGruppierungsTemplate(authorization: any | undefined, fileData: string | undefined, bundesland: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/UploadGruppierungsTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileData === null || fileData === undefined)
            throw new Error("The parameter 'fileData' cannot be null.");
        else
            content_.append("fileData", fileData.toString());
        if (bundesland === null || bundesland === undefined)
            throw new Error("The parameter 'bundesland' cannot be null.");
        else
            content_.append("bundesland", bundesland.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadGruppierungsTemplate(_response);
        });
    }

    protected processUploadGruppierungsTemplate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    applyGruppierungsTemplate(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ApplyGruppierungsTemplate/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApplyGruppierungsTemplate(_response);
        });
    }

    protected processApplyGruppierungsTemplate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    applyGliederungsTemplate(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ApplyGliederungsTemplate/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApplyGliederungsTemplate(_response);
        });
    }

    protected processApplyGliederungsTemplate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param fileData (optional) 
     * @param bundesland (optional) 
     * @return OK
     */
    uploadGliederungsTemplate(authorization: any | undefined, fileData: string | undefined, bundesland: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/UploadGliederungsTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileData === null || fileData === undefined)
            throw new Error("The parameter 'fileData' cannot be null.");
        else
            content_.append("fileData", fileData.toString());
        if (bundesland === null || bundesland === undefined)
            throw new Error("The parameter 'bundesland' cannot be null.");
        else
            content_.append("bundesland", bundesland.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadGliederungsTemplate(_response);
        });
    }

    protected processUploadGliederungsTemplate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setABCAnalysis(authorization: any | undefined, body: Abcanalyse | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/SetABCAnalysis";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetABCAnalysis(_response);
        });
    }

    protected processSetABCAnalysis(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getABCAnalysis(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<Abcanalyse> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetABCAnalysis/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetABCAnalysis(_response);
        });
    }

    protected processGetABCAnalysis(response: Response): Promise<Abcanalyse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Abcanalyse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Abcanalyse>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyTopEA(authorization: any | undefined, body: TopEaflex | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ModifyTopEA";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyTopEA(_response);
        });
    }

    protected processModifyTopEA(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getTopEA(vm: boolean, authorization: any | undefined, body: JahrModel | undefined): Promise<TopEaflex[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetTopEA/{vm}";
        if (vm === undefined || vm === null)
            throw new Error("The parameter 'vm' must be defined.");
        url_ = url_.replace("{vm}", encodeURIComponent("" + vm));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTopEA(_response);
        });
    }

    protected processGetTopEA(response: Response): Promise<TopEaflex[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TopEaflex.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TopEaflex[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    duplicateTopEA(authorization: any | undefined, body: TopEaflex | undefined): Promise<TopEaflex> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/DuplicateTopEA";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDuplicateTopEA(_response);
        });
    }

    protected processDuplicateTopEA(response: Response): Promise<TopEaflex> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TopEaflex.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TopEaflex>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushTopEA(authorization: any | undefined, body: PushTopEAModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/PushTopEA";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushTopEA(_response);
        });
    }

    protected processPushTopEA(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    migrateTopEA(authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/MigrateTopEA";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMigrateTopEA(_response);
        });
    }

    protected processMigrateTopEA(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeTopEA(authorization: any | undefined, body: TopEaflex | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveTopEA";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveTopEA(_response);
        });
    }

    protected processRemoveTopEA(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addTopEA(authorization: any | undefined, body: TopEaflex | undefined): Promise<TopEaflex> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddTopEA";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddTopEA(_response);
        });
    }

    protected processAddTopEA(response: Response): Promise<TopEaflex> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TopEaflex.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TopEaflex>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setTopEAsAnalysis(authorization: any | undefined, body: TopEa | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/SetTopEAsAnalysis";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetTopEAsAnalysis(_response);
        });
    }

    protected processSetTopEAsAnalysis(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getTopEAsAnalysis(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<TopEa> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetTopEAsAnalysis/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTopEAsAnalysis(_response);
        });
    }

    protected processGetTopEAsAnalysis(response: Response): Promise<TopEa> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TopEa.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TopEa>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setInvestSettings(authorization: any | undefined, body: InvestSettingModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/SetInvestSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetInvestSettings(_response);
        });
    }

    protected processSetInvestSettings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getInvestSettings(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<InvestSettingModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetInvestSettings/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInvestSettings(_response);
        });
    }

    protected processGetInvestSettings(response: Response): Promise<InvestSettingModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvestSettingModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvestSettingModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getChangeSettings(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<ChangeSetting> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetChangeSettings/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetChangeSettings(_response);
        });
    }

    protected processGetChangeSettings(response: Response): Promise<ChangeSetting> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeSetting.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeSetting>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setChangeSettings(authorization: any | undefined, body: ChangeSetting | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/SetChangeSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetChangeSettings(_response);
        });
    }

    protected processSetChangeSettings(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getHPSettings(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<Hpsetting> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetHPSettings/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHPSettings(_response);
        });
    }

    protected processGetHPSettings(response: Response): Promise<Hpsetting> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Hpsetting.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Hpsetting>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setHPSettings(authorization: any | undefined, body: Hpsetting | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/SetHPSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetHPSettings(_response);
        });
    }

    protected processSetHPSettings(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getJRSettings(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<JRSettingModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetJRSettings/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJRSettings(_response);
        });
    }

    protected processGetJRSettings(response: Response): Promise<JRSettingModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JRSettingModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JRSettingModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setJRSettings(authorization: any | undefined, body: JRSettingModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/SetJRSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetJRSettings(_response);
        });
    }

    protected processSetJRSettings(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushJRSettings(authorization: any | undefined, body: PushJRSettingsModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/PushJRSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushJRSettings(_response);
        });
    }

    protected processPushJRSettings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getUBWSettings(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<Ubwsetting> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetUBWSettings/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUBWSettings(_response);
        });
    }

    protected processGetUBWSettings(response: Response): Promise<Ubwsetting> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Ubwsetting.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Ubwsetting>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setUBWSettings(authorization: any | undefined, body: Ubwsetting | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/SetUBWSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetUBWSettings(_response);
        });
    }

    protected processSetUBWSettings(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getUHConfigs(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<UhConfigModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetUHConfigs/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUHConfigs(_response);
        });
    }

    protected processGetUHConfigs(response: Response): Promise<UhConfigModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UhConfigModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UhConfigModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addUHConfig(authorization: any | undefined, body: UhConfigModel | undefined): Promise<Uhconfig> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddUHConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddUHConfig(_response);
        });
    }

    protected processAddUHConfig(response: Response): Promise<Uhconfig> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Uhconfig.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Uhconfig>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    copyUHPkSettings(uhsrc: number, authorization: any | undefined, body: UhConfigModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/CopyUHPkSettings/{uhsrc}";
        if (uhsrc === undefined || uhsrc === null)
            throw new Error("The parameter 'uhsrc' must be defined.");
        url_ = url_.replace("{uhsrc}", encodeURIComponent("" + uhsrc));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCopyUHPkSettings(_response);
        });
    }

    protected processCopyUHPkSettings(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyUHConfig(authorization: any | undefined, body: UhConfigModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ModifyUHConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyUHConfig(_response);
        });
    }

    protected processModifyUHConfig(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    removeUHConfig(authorization: any | undefined, body: UhConfigModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveUHConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveUHConfig(_response);
        });
    }

    protected processRemoveUHConfig(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadFile(kunde: number, gemeinde: number, jahr: number, path: string, filename: string, authorization: any | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/UploadFile/{kunde}/{gemeinde}/{jahr}/{path}/{filename}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadFile(_response);
        });
    }

    protected processUploadFile(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    downloadPrivateFile(kunde: number, gemeinde: number, jahr: number, filename: string, authorization: any | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/DownloadPrivateFile/{kunde}/{gemeinde}/{jahr}/{filename}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadPrivateFile(_response);
        });
    }

    protected processDownloadPrivateFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getUploads(kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, typ: number, authorization: any | undefined): Promise<Upload[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetUploads/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}/{typ}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (typ === undefined || typ === null)
            throw new Error("The parameter 'typ' must be defined.");
        url_ = url_.replace("{typ}", encodeURIComponent("" + typ));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUploads(_response);
        });
    }

    protected processGetUploads(response: Response): Promise<Upload[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Upload.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Upload[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getUploadStatus(id: number, authorization: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetUploadStatus/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUploadStatus(_response);
        });
    }

    protected processGetUploadStatus(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getImportMessage(id: number, authorization: any | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetImportMessage/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetImportMessage(_response);
        });
    }

    protected processGetImportMessage(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getImportHHResult(id: number, authorization: any | undefined): Promise<ImportHHSResult> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetImportHHResult/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetImportHHResult(_response);
        });
    }

    protected processGetImportHHResult(response: Response): Promise<ImportHHSResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportHHSResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportHHSResult>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getImportHHDResult(id: number, authorization: any | undefined): Promise<ImportHHDResult> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetImportHHDResult/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetImportHHDResult(_response);
        });
    }

    protected processGetImportHHDResult(response: Response): Promise<ImportHHDResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportHHDResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportHHDResult>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadInternesDokument(kunde: number, gemeinde: number, filename: string, authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/UploadInternesDokument/{kunde}/{gemeinde}/{filename}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadInternesDokument(_response);
        });
    }

    protected processUploadInternesDokument(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeInternesDokument(authorization: any | undefined, body: InterneDokumente | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveInternesDokument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveInternesDokument(_response);
        });
    }

    protected processRemoveInternesDokument(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getInterneDokumente(kunde: number, gemeinde: number, authorization: any | undefined): Promise<InterneDokumente[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetInterneDokumente/{kunde}/{gemeinde}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInterneDokumente(_response);
        });
    }

    protected processGetInterneDokumente(response: Response): Promise<InterneDokumente[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InterneDokumente.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InterneDokumente[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    downloadInternesDokument(kunde: number, gemeinde: number, filename: string, authorization: any | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/DownloadInternesDokument/{kunde}/{gemeinde}/{filename}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadInternesDokument(_response);
        });
    }

    protected processDownloadInternesDokument(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadVBTemplate(kunde: number, gemeinde: number, jahr: number, filename: string, authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/UploadVBTemplate/{kunde}/{gemeinde}/{jahr}/{filename}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadVBTemplate(_response);
        });
    }

    protected processUploadVBTemplate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadSystemVBTemplate(jahr: number, filename: string, bundesland: string, authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/UploadSystemVBTemplate/{jahr}/{filename}/{bundesland}";
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        if (bundesland === undefined || bundesland === null)
            throw new Error("The parameter 'bundesland' must be defined.");
        url_ = url_.replace("{bundesland}", encodeURIComponent("" + bundesland));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadSystemVBTemplate(_response);
        });
    }

    protected processUploadSystemVBTemplate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadLBTemplate(kunde: number, gemeinde: number, jahr: number, filename: string, authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/UploadLBTemplate/{kunde}/{gemeinde}/{jahr}/{filename}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadLBTemplate(_response);
        });
    }

    protected processUploadLBTemplate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadSystemLBTemplate(jahr: number, filename: string, bundesland: string, authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/UploadSystemLBTemplate/{jahr}/{filename}/{bundesland}";
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        if (bundesland === undefined || bundesland === null)
            throw new Error("The parameter 'bundesland' must be defined.");
        url_ = url_.replace("{bundesland}", encodeURIComponent("" + bundesland));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadSystemLBTemplate(_response);
        });
    }

    protected processUploadSystemLBTemplate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadUHBTemplate(kunde: number, gemeinde: number, jahr: number, filename: string, authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/UploadUHBTemplate/{kunde}/{gemeinde}/{jahr}/{filename}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadUHBTemplate(_response);
        });
    }

    protected processUploadUHBTemplate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadSystemUHBTemplate(jahr: number, filename: string, bundesland: string, authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/UploadSystemUHBTemplate/{jahr}/{filename}/{bundesland}";
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        if (bundesland === undefined || bundesland === null)
            throw new Error("The parameter 'bundesland' must be defined.");
        url_ = url_.replace("{bundesland}", encodeURIComponent("" + bundesland));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadSystemUHBTemplate(_response);
        });
    }

    protected processUploadSystemUHBTemplate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadUniTemplate(kunde: number, gemeinde: number, jahr: number, filename: string, authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/UploadUniTemplate/{kunde}/{gemeinde}/{jahr}/{filename}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadUniTemplate(_response);
        });
    }

    protected processUploadUniTemplate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    removeVBTemplate(kunde: number, gemeinde: number, jahr: number, filename: string, authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveVBTemplate/{kunde}/{gemeinde}/{jahr}/{filename}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveVBTemplate(_response);
        });
    }

    protected processRemoveVBTemplate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param jahr (optional) 
     * @param filename (optional) 
     * @param bundesland (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    removeSystemVBTemplate(jahr: number | undefined, filename: string | undefined, bundesland: string | undefined, authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveSystemVBTemplate?";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (filename === null)
            throw new Error("The parameter 'filename' cannot be null.");
        else if (filename !== undefined)
            url_ += "filename=" + encodeURIComponent("" + filename) + "&";
        if (bundesland === null)
            throw new Error("The parameter 'bundesland' cannot be null.");
        else if (bundesland !== undefined)
            url_ += "bundesland=" + encodeURIComponent("" + bundesland) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveSystemVBTemplate(_response);
        });
    }

    protected processRemoveSystemVBTemplate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    removeLBTemplate(kunde: number, gemeinde: number, jahr: number, filename: string, authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveLBTemplate/{kunde}/{gemeinde}/{jahr}/{filename}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveLBTemplate(_response);
        });
    }

    protected processRemoveLBTemplate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param jahr (optional) 
     * @param filename (optional) 
     * @param bundesland (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    removeSystemLBTemplate(jahr: number | undefined, filename: string | undefined, bundesland: string | undefined, authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveSystemLBTemplate?";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (filename === null)
            throw new Error("The parameter 'filename' cannot be null.");
        else if (filename !== undefined)
            url_ += "filename=" + encodeURIComponent("" + filename) + "&";
        if (bundesland === null)
            throw new Error("The parameter 'bundesland' cannot be null.");
        else if (bundesland !== undefined)
            url_ += "bundesland=" + encodeURIComponent("" + bundesland) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveSystemLBTemplate(_response);
        });
    }

    protected processRemoveSystemLBTemplate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    removeUHBTemplate(kunde: number, gemeinde: number, jahr: number, filename: string, authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveUHBTemplate/{kunde}/{gemeinde}/{jahr}/{filename}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveUHBTemplate(_response);
        });
    }

    protected processRemoveUHBTemplate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param jahr (optional) 
     * @param filename (optional) 
     * @param bundesland (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    removeSystemUHTemplate(jahr: number | undefined, filename: string | undefined, bundesland: string | undefined, authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveSystemUHTemplate?";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (filename === null)
            throw new Error("The parameter 'filename' cannot be null.");
        else if (filename !== undefined)
            url_ += "filename=" + encodeURIComponent("" + filename) + "&";
        if (bundesland === null)
            throw new Error("The parameter 'bundesland' cannot be null.");
        else if (bundesland !== undefined)
            url_ += "bundesland=" + encodeURIComponent("" + bundesland) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveSystemUHTemplate(_response);
        });
    }

    protected processRemoveSystemUHTemplate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    removeUniTemplate(kunde: number, gemeinde: number, jahr: number, filename: string, authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveUniTemplate/{kunde}/{gemeinde}/{jahr}/{filename}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveUniTemplate(_response);
        });
    }

    protected processRemoveUniTemplate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushBerichtsTemplates(authorization: any | undefined, body: PushBerichtsvorlagenModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/PushBerichtsTemplates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushBerichtsTemplates(_response);
        });
    }

    protected processPushBerichtsTemplates(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param nursystem (optional) 
     * @param bundesland (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    getVBTemplates(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, nursystem: boolean | undefined, bundesland: string | undefined, authorization: any | undefined): Promise<BerichtsvorlageModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetVBTemplates?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (nursystem === null)
            throw new Error("The parameter 'nursystem' cannot be null.");
        else if (nursystem !== undefined)
            url_ += "nursystem=" + encodeURIComponent("" + nursystem) + "&";
        if (bundesland === null)
            throw new Error("The parameter 'bundesland' cannot be null.");
        else if (bundesland !== undefined)
            url_ += "bundesland=" + encodeURIComponent("" + bundesland) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVBTemplates(_response);
        });
    }

    protected processGetVBTemplates(response: Response): Promise<BerichtsvorlageModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BerichtsvorlageModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BerichtsvorlageModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    templates2Jahre(authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/Templates2Jahre";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTemplates2Jahre(_response);
        });
    }

    protected processTemplates2Jahre(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param nursystem (optional) 
     * @param bundesland (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    getLBTemplates(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, nursystem: boolean | undefined, bundesland: string | undefined, authorization: any | undefined): Promise<BerichtsvorlageModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetLBTemplates?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (nursystem === null)
            throw new Error("The parameter 'nursystem' cannot be null.");
        else if (nursystem !== undefined)
            url_ += "nursystem=" + encodeURIComponent("" + nursystem) + "&";
        if (bundesland === null)
            throw new Error("The parameter 'bundesland' cannot be null.");
        else if (bundesland !== undefined)
            url_ += "bundesland=" + encodeURIComponent("" + bundesland) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLBTemplates(_response);
        });
    }

    protected processGetLBTemplates(response: Response): Promise<BerichtsvorlageModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BerichtsvorlageModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BerichtsvorlageModel[]>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param nursystem (optional) 
     * @param bundesland (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    getUHBTemplates(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, nursystem: boolean | undefined, bundesland: string | undefined, authorization: any | undefined): Promise<BerichtsvorlageModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetUHBTemplates?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (nursystem === null)
            throw new Error("The parameter 'nursystem' cannot be null.");
        else if (nursystem !== undefined)
            url_ += "nursystem=" + encodeURIComponent("" + nursystem) + "&";
        if (bundesland === null)
            throw new Error("The parameter 'bundesland' cannot be null.");
        else if (bundesland !== undefined)
            url_ += "bundesland=" + encodeURIComponent("" + bundesland) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUHBTemplates(_response);
        });
    }

    protected processGetUHBTemplates(response: Response): Promise<BerichtsvorlageModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BerichtsvorlageModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BerichtsvorlageModel[]>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    getUniTemplates(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, authorization: any | undefined): Promise<BerichtsvorlageModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetUniTemplates?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUniTemplates(_response);
        });
    }

    protected processGetUniTemplates(response: Response): Promise<BerichtsvorlageModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BerichtsvorlageModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BerichtsvorlageModel[]>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param bundesland (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    hasVBTemplate(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, bundesland: string | undefined, authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/HasVBTemplate?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (bundesland === null)
            throw new Error("The parameter 'bundesland' cannot be null.");
        else if (bundesland !== undefined)
            url_ += "bundesland=" + encodeURIComponent("" + bundesland) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHasVBTemplate(_response);
        });
    }

    protected processHasVBTemplate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param bundesland (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    hasLBTemplate(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, bundesland: string | undefined, authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/HasLBTemplate?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (bundesland === null)
            throw new Error("The parameter 'bundesland' cannot be null.");
        else if (bundesland !== undefined)
            url_ += "bundesland=" + encodeURIComponent("" + bundesland) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHasLBTemplate(_response);
        });
    }

    protected processHasLBTemplate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param bundesland (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    hasUHBTemplate(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, bundesland: string | undefined, authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/HasUHBTemplate?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (bundesland === null)
            throw new Error("The parameter 'bundesland' cannot be null.");
        else if (bundesland !== undefined)
            url_ += "bundesland=" + encodeURIComponent("" + bundesland) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHasUHBTemplate(_response);
        });
    }

    protected processHasUHBTemplate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    hasUniTemplate(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/HasUniTemplate?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHasUniTemplate(_response);
        });
    }

    protected processHasUniTemplate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setHHSettings(authorization: any | undefined, body: HaushaltsSetting | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/SetHHSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetHHSettings(_response);
        });
    }

    protected processSetHHSettings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getHHSettings(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<HaushaltsSetting> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetHHSettings/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHHSettings(_response);
        });
    }

    protected processGetHHSettings(response: Response): Promise<HaushaltsSetting> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsSetting.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsSetting>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setHPDarstellungsSettings(authorization: any | undefined, body: DarstellungHp | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/SetHPDarstellungsSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetHPDarstellungsSettings(_response);
        });
    }

    protected processSetHPDarstellungsSettings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getHPDarstellungsSettings(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<DarstellungHp> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetHPDarstellungsSettings/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHPDarstellungsSettings(_response);
        });
    }

    protected processGetHPDarstellungsSettings(response: Response): Promise<DarstellungHp> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DarstellungHp.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DarstellungHp>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyODTCellEigenschaft(authorization: any | undefined, body: ODTCellEigenschaftenModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ModifyODTCellEigenschaft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyODTCellEigenschaft(_response);
        });
    }

    protected processModifyODTCellEigenschaft(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getODTCellEigenschaften(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<ODTCellEigenschaftenModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetODTCellEigenschaften/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetODTCellEigenschaften(_response);
        });
    }

    protected processGetODTCellEigenschaften(response: Response): Promise<ODTCellEigenschaftenModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ODTCellEigenschaftenModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ODTCellEigenschaftenModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getODTCellEigenschaft(kunde: number, gemeinde: number, jahr: number, bezeichnung: string, authorization: any | undefined): Promise<ODTCellEigenschaftenModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetODTCellEigenschaft/{kunde}/{gemeinde}/{jahr}/{bezeichnung}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (bezeichnung === undefined || bezeichnung === null)
            throw new Error("The parameter 'bezeichnung' must be defined.");
        url_ = url_.replace("{bezeichnung}", encodeURIComponent("" + bezeichnung));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetODTCellEigenschaft(_response);
        });
    }

    protected processGetODTCellEigenschaft(response: Response): Promise<ODTCellEigenschaftenModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODTCellEigenschaftenModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ODTCellEigenschaftenModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeODTCellEigenschaft(authorization: any | undefined, body: ODTCellEigenschaftenModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveODTCellEigenschaft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveODTCellEigenschaft(_response);
        });
    }

    protected processRemoveODTCellEigenschaft(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addODTCellEigenschaft(authorization: any | undefined, body: ODTCellEigenschaftenModel | undefined): Promise<ODTCellEigenschaftenModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddODTCellEigenschaft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddODTCellEigenschaft(_response);
        });
    }

    protected processAddODTCellEigenschaft(response: Response): Promise<ODTCellEigenschaftenModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODTCellEigenschaftenModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ODTCellEigenschaftenModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    duplicateODTCellEigenschaften(zielKunde: number, zielGemeinde: number, zielJahr: number, authorization: any | undefined, body: JahrModel | undefined): Promise<Odteigenschaften[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/DuplicateODTCellEigenschaften/{ZielKunde}/{ZielGemeinde}/{ZielJahr}";
        if (zielKunde === undefined || zielKunde === null)
            throw new Error("The parameter 'zielKunde' must be defined.");
        url_ = url_.replace("{ZielKunde}", encodeURIComponent("" + zielKunde));
        if (zielGemeinde === undefined || zielGemeinde === null)
            throw new Error("The parameter 'zielGemeinde' must be defined.");
        url_ = url_.replace("{ZielGemeinde}", encodeURIComponent("" + zielGemeinde));
        if (zielJahr === undefined || zielJahr === null)
            throw new Error("The parameter 'zielJahr' must be defined.");
        url_ = url_.replace("{ZielJahr}", encodeURIComponent("" + zielJahr));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDuplicateODTCellEigenschaften(_response);
        });
    }

    protected processDuplicateODTCellEigenschaften(response: Response): Promise<Odteigenschaften[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Odteigenschaften.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Odteigenschaften[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyTabellenBezeichner(authorization: any | undefined, body: TabellenBezeichner | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ModifyTabellenBezeichner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyTabellenBezeichner(_response);
        });
    }

    protected processModifyTabellenBezeichner(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getTabellenBezeichner(kunde: number, gemeinde: number, jahr: number, typ: number, authorization: any | undefined): Promise<TabellenBezeichner[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetTabellenBezeichner/{kunde}/{gemeinde}/{jahr}/{typ}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (typ === undefined || typ === null)
            throw new Error("The parameter 'typ' must be defined.");
        url_ = url_.replace("{typ}", encodeURIComponent("" + typ));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTabellenBezeichner(_response);
        });
    }

    protected processGetTabellenBezeichner(response: Response): Promise<TabellenBezeichner[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TabellenBezeichner.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TabellenBezeichner[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    duplicateTabellenBezeichner(zielKunde: number, zielGemeinde: number, zielJahr: number, typ: number, authorization: any | undefined, body: JahrModel | undefined): Promise<TabellenBezeichner[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/DuplicateTabellenBezeichner/{ZielKunde}/{ZielGemeinde}/{ZielJahr}/{typ}";
        if (zielKunde === undefined || zielKunde === null)
            throw new Error("The parameter 'zielKunde' must be defined.");
        url_ = url_.replace("{ZielKunde}", encodeURIComponent("" + zielKunde));
        if (zielGemeinde === undefined || zielGemeinde === null)
            throw new Error("The parameter 'zielGemeinde' must be defined.");
        url_ = url_.replace("{ZielGemeinde}", encodeURIComponent("" + zielGemeinde));
        if (zielJahr === undefined || zielJahr === null)
            throw new Error("The parameter 'zielJahr' must be defined.");
        url_ = url_.replace("{ZielJahr}", encodeURIComponent("" + zielJahr));
        if (typ === undefined || typ === null)
            throw new Error("The parameter 'typ' must be defined.");
        url_ = url_.replace("{typ}", encodeURIComponent("" + typ));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDuplicateTabellenBezeichner(_response);
        });
    }

    protected processDuplicateTabellenBezeichner(response: Response): Promise<TabellenBezeichner[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TabellenBezeichner.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TabellenBezeichner[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getFontNames(authorization: any | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetFontNames";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFontNames(_response);
        });
    }

    protected processGetFontNames(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addVBBildstandard(kunde: number, gemeinde: number, jahr: number, typ: string, authorization: any | undefined, body: BildEinstellungen | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddVBBildstandard/{kunde}/{gemeinde}/{jahr}/{typ}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (typ === undefined || typ === null)
            throw new Error("The parameter 'typ' must be defined.");
        url_ = url_.replace("{typ}", encodeURIComponent("" + typ));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddVBBildstandard(_response);
        });
    }

    protected processAddVBBildstandard(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getVBBildstandard(kunde: number, gemeinde: number, jahr: number, typ: string, authorization: any | undefined): Promise<BildEinstellungen> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetVBBildstandard/{kunde}/{gemeinde}/{jahr}/{typ}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (typ === undefined || typ === null)
            throw new Error("The parameter 'typ' must be defined.");
        url_ = url_.replace("{typ}", encodeURIComponent("" + typ));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVBBildstandard(_response);
        });
    }

    protected processGetVBBildstandard(response: Response): Promise<BildEinstellungen> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BildEinstellungen.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BildEinstellungen>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addVBTabellenstandard(kunde: number, gemeinde: number, jahr: number, typ: string, authorization: any | undefined, body: TabellenEinstellungen | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddVBTabellenstandard/{kunde}/{gemeinde}/{jahr}/{typ}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (typ === undefined || typ === null)
            throw new Error("The parameter 'typ' must be defined.");
        url_ = url_.replace("{typ}", encodeURIComponent("" + typ));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddVBTabellenstandard(_response);
        });
    }

    protected processAddVBTabellenstandard(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getVBTabellenstandard(kunde: number, gemeinde: number, jahr: number, typ: string, authorization: any | undefined): Promise<TabellenEinstellungen> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetVBTabellenstandard/{kunde}/{gemeinde}/{jahr}/{typ}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (typ === undefined || typ === null)
            throw new Error("The parameter 'typ' must be defined.");
        url_ = url_.replace("{typ}", encodeURIComponent("" + typ));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVBTabellenstandard(_response);
        });
    }

    protected processGetVBTabellenstandard(response: Response): Promise<TabellenEinstellungen> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TabellenEinstellungen.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TabellenEinstellungen>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addVBInveststandard(kunde: number, gemeinde: number, jahr: number, typ: string, authorization: any | undefined, body: InvestEinstellungen | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddVBInveststandard/{kunde}/{gemeinde}/{jahr}/{typ}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (typ === undefined || typ === null)
            throw new Error("The parameter 'typ' must be defined.");
        url_ = url_.replace("{typ}", encodeURIComponent("" + typ));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddVBInveststandard(_response);
        });
    }

    protected processAddVBInveststandard(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getVBInveststandard(kunde: number, gemeinde: number, jahr: number, typ: string, authorization: any | undefined): Promise<InvestEinstellungen> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetVBInveststandard/{kunde}/{gemeinde}/{jahr}/{typ}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (typ === undefined || typ === null)
            throw new Error("The parameter 'typ' must be defined.");
        url_ = url_.replace("{typ}", encodeURIComponent("" + typ));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVBInveststandard(_response);
        });
    }

    protected processGetVBInveststandard(response: Response): Promise<InvestEinstellungen> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvestEinstellungen.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvestEinstellungen>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    duplicateSingleVBPlatzhalter(authorization: any | undefined, body: VBPlatzhalterKameralModel | undefined): Promise<VBPlatzhalterKameralModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/DuplicateSingleVBPlatzhalter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDuplicateSingleVBPlatzhalter(_response);
        });
    }

    protected processDuplicateSingleVBPlatzhalter(response: Response): Promise<VBPlatzhalterKameralModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VBPlatzhalterKameralModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VBPlatzhalterKameralModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addVBPlatzhalter(jahr: number, authorization: any | undefined, body: VBPlatzhalterKameralModel | undefined): Promise<VBPlatzhalterKameralModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddVBPlatzhalter/{jahr}";
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddVBPlatzhalter(_response);
        });
    }

    protected processAddVBPlatzhalter(response: Response): Promise<VBPlatzhalterKameralModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VBPlatzhalterKameralModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VBPlatzhalterKameralModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeVBPlatzhalter(authorization: any | undefined, body: VBPlatzhalterKameralModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveVBPlatzhalter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveVBPlatzhalter(_response);
        });
    }

    protected processRemoveVBPlatzhalter(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyVBPlatzhalter(authorization: any | undefined, body: VBPlatzhalterKameralModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ModifyVBPlatzhalter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyVBPlatzhalter(_response);
        });
    }

    protected processModifyVBPlatzhalter(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addVBPlatzhalterUeberschreibung(kunde: number | undefined, gemeinde: number | undefined, authorization: any | undefined, body: VBPlatzhalterKameralModel | undefined): Promise<VBDataDefinitionKameral[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddVBPlatzhalterUeberschreibung?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddVBPlatzhalterUeberschreibung(_response);
        });
    }

    protected processAddVBPlatzhalterUeberschreibung(response: Response): Promise<VBDataDefinitionKameral[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VBDataDefinitionKameral.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VBDataDefinitionKameral[]>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeVBPlatzhalterUeberschreibung(kunde: number | undefined, gemeinde: number | undefined, authorization: any | undefined, body: VBPlatzhalterKameralModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveVBPlatzhalterUeberschreibung?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveVBPlatzhalterUeberschreibung(_response);
        });
    }

    protected processRemoveVBPlatzhalterUeberschreibung(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyVBPlatzhalterUeberschreibung(kunde: number | undefined, gemeinde: number | undefined, authorization: any | undefined, body: VBPlatzhalterKameralModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ModifyVBPlatzhalterUeberschreibung?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyVBPlatzhalterUeberschreibung(_response);
        });
    }

    protected processModifyVBPlatzhalterUeberschreibung(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    getVBPlatzhalterZuordnungen(kunde: number | undefined, gemeinde: number | undefined, authorization: any | undefined): Promise<VbplatzhalterZuordnungKameral[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetVBPlatzhalterZuordnungen?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVBPlatzhalterZuordnungen(_response);
        });
    }

    protected processGetVBPlatzhalterZuordnungen(response: Response): Promise<VbplatzhalterZuordnungKameral[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VbplatzhalterZuordnungKameral.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VbplatzhalterZuordnungKameral[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addVBPlatzhalterZuordnung(authorization: any | undefined, body: VbplatzhalterZuordnungKameral | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddVBPlatzhalterZuordnung";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddVBPlatzhalterZuordnung(_response);
        });
    }

    protected processAddVBPlatzhalterZuordnung(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeVBPlatzhalterZuordnung(authorization: any | undefined, body: VbplatzhalterZuordnungKameral | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveVBPlatzhalterZuordnung";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveVBPlatzhalterZuordnung(_response);
        });
    }

    protected processRemoveVBPlatzhalterZuordnung(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param modul (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    removeAllVBPlatzhalter(kunde: number | undefined, gemeinde: number | undefined, modul: number | undefined, authorization: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveAllVBPlatzhalter?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (modul === null)
            throw new Error("The parameter 'modul' cannot be null.");
        else if (modul !== undefined)
            url_ += "modul=" + encodeURIComponent("" + modul) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveAllVBPlatzhalter(_response);
        });
    }

    protected processRemoveAllVBPlatzhalter(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getVBPlatzhalter(kunde: number, gemeinde: number, berichttyp: number, authorization: any | undefined): Promise<VBPlatzhalterKameralModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetVBPlatzhalter/{kunde}/{gemeinde}/{berichttyp}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (berichttyp === undefined || berichttyp === null)
            throw new Error("The parameter 'berichttyp' must be defined.");
        url_ = url_.replace("{berichttyp}", encodeURIComponent("" + berichttyp));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVBPlatzhalter(_response);
        });
    }

    protected processGetVBPlatzhalter(response: Response): Promise<VBPlatzhalterKameralModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VBPlatzhalterKameralModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VBPlatzhalterKameralModel[]>(null as any);
    }

    /**
     * @param berichttyp (optional) 
     * @param bundesland (optional) 
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    getSystemVBPlatzhalter(berichttyp: number | undefined, bundesland: string | undefined, kunde: number | undefined, gemeinde: number | undefined, authorization: any | undefined): Promise<VBPlatzhalterKameralModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetSystemVBPlatzhalter?";
        if (berichttyp === null)
            throw new Error("The parameter 'berichttyp' cannot be null.");
        else if (berichttyp !== undefined)
            url_ += "berichttyp=" + encodeURIComponent("" + berichttyp) + "&";
        if (bundesland === null)
            throw new Error("The parameter 'bundesland' cannot be null.");
        else if (bundesland !== undefined)
            url_ += "bundesland=" + encodeURIComponent("" + bundesland) + "&";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSystemVBPlatzhalter(_response);
        });
    }

    protected processGetSystemVBPlatzhalter(response: Response): Promise<VBPlatzhalterKameralModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VBPlatzhalterKameralModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VBPlatzhalterKameralModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    setBerichtsFarben2VBPlatzhalter(kunde: number, gemeinde: number, berichttyp: number, authorization: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/SetBerichtsFarben2VBPlatzhalter/{kunde}/{gemeinde}/{berichttyp}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (berichttyp === undefined || berichttyp === null)
            throw new Error("The parameter 'berichttyp' must be defined.");
        url_ = url_.replace("{berichttyp}", encodeURIComponent("" + berichttyp));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetBerichtsFarben2VBPlatzhalter(_response);
        });
    }

    protected processSetBerichtsFarben2VBPlatzhalter(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param system (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    getVBPlatzhaltertypen(system: boolean | undefined, authorization: any | undefined): Promise<VbplatzhalterTypenKameral[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetVBPlatzhaltertypen?";
        if (system === null)
            throw new Error("The parameter 'system' cannot be null.");
        else if (system !== undefined)
            url_ += "system=" + encodeURIComponent("" + system) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVBPlatzhaltertypen(_response);
        });
    }

    protected processGetVBPlatzhaltertypen(response: Response): Promise<VbplatzhalterTypenKameral[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VbplatzhalterTypenKameral.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VbplatzhalterTypenKameral[]>(null as any);
    }

    /**
     * @param system (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    getLBPlatzhaltertypen(system: boolean | undefined, authorization: any | undefined): Promise<LbplatzhalterTypenKameral[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetLBPlatzhaltertypen?";
        if (system === null)
            throw new Error("The parameter 'system' cannot be null.");
        else if (system !== undefined)
            url_ += "system=" + encodeURIComponent("" + system) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLBPlatzhaltertypen(_response);
        });
    }

    protected processGetLBPlatzhaltertypen(response: Response): Promise<LbplatzhalterTypenKameral[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LbplatzhalterTypenKameral.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LbplatzhalterTypenKameral[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getVBPlatzhalterbetrachtungstypen(authorization: any | undefined): Promise<VbplatzhalterBetrachtungsTypenKameral[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetVBPlatzhalterbetrachtungstypen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVBPlatzhalterbetrachtungstypen(_response);
        });
    }

    protected processGetVBPlatzhalterbetrachtungstypen(response: Response): Promise<VbplatzhalterBetrachtungsTypenKameral[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VbplatzhalterBetrachtungsTypenKameral.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VbplatzhalterBetrachtungsTypenKameral[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getLBPlatzhalterbetrachtungstypen(authorization: any | undefined): Promise<LbplatzhalterBetrachtungsTypenKameral[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetLBPlatzhalterbetrachtungstypen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLBPlatzhalterbetrachtungstypen(_response);
        });
    }

    protected processGetLBPlatzhalterbetrachtungstypen(response: Response): Promise<LbplatzhalterBetrachtungsTypenKameral[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LbplatzhalterBetrachtungsTypenKameral.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LbplatzhalterBetrachtungsTypenKameral[]>(null as any);
    }

    /**
     * @param system (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    getUHPlatzhaltertypen(system: boolean | undefined, authorization: any | undefined): Promise<UhplatzhalterTypenKameral[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetUHPlatzhaltertypen?";
        if (system === null)
            throw new Error("The parameter 'system' cannot be null.");
        else if (system !== undefined)
            url_ += "system=" + encodeURIComponent("" + system) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUHPlatzhaltertypen(_response);
        });
    }

    protected processGetUHPlatzhaltertypen(response: Response): Promise<UhplatzhalterTypenKameral[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UhplatzhalterTypenKameral.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UhplatzhalterTypenKameral[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getUHPlatzhalterbetrachtungstypen(authorization: any | undefined): Promise<UhplatzhalterBetrachtungsTypenKameral[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetUHPlatzhalterbetrachtungstypen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUHPlatzhalterbetrachtungstypen(_response);
        });
    }

    protected processGetUHPlatzhalterbetrachtungstypen(response: Response): Promise<UhplatzhalterBetrachtungsTypenKameral[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UhplatzhalterBetrachtungsTypenKameral.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UhplatzhalterBetrachtungsTypenKameral[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getVBPlatzhalterjahre(authorization: any | undefined): Promise<VbplatzhalterJahre[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetVBPlatzhalterjahre";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVBPlatzhalterjahre(_response);
        });
    }

    protected processGetVBPlatzhalterjahre(response: Response): Promise<VbplatzhalterJahre[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VbplatzhalterJahre.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VbplatzhalterJahre[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getLBPlatzhalterjahre(authorization: any | undefined): Promise<LbplatzhalterJahre[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetLBPlatzhalterjahre";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLBPlatzhalterjahre(_response);
        });
    }

    protected processGetLBPlatzhalterjahre(response: Response): Promise<LbplatzhalterJahre[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LbplatzhalterJahre.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LbplatzhalterJahre[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getUHPlatzhalterjahre(authorization: any | undefined): Promise<UhplatzhalterJahre[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetUHPlatzhalterjahre";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUHPlatzhalterjahre(_response);
        });
    }

    protected processGetUHPlatzhalterjahre(response: Response): Promise<UhplatzhalterJahre[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UhplatzhalterJahre.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UhplatzhalterJahre[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getVBFile(kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, filename: string, nurvorlage: boolean, plantypvgl: number, planstufevgl: number, planstufeJR: number, jahrJR: number, system: boolean, bundesland: string, authorization: any | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetVBFile/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}/{filename}/{nurvorlage}/{plantypvgl}/{planstufevgl}/{planstufeJR}/{jahrJR}/{system}/{bundesland}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        if (nurvorlage === undefined || nurvorlage === null)
            throw new Error("The parameter 'nurvorlage' must be defined.");
        url_ = url_.replace("{nurvorlage}", encodeURIComponent("" + nurvorlage));
        if (plantypvgl === undefined || plantypvgl === null)
            throw new Error("The parameter 'plantypvgl' must be defined.");
        url_ = url_.replace("{plantypvgl}", encodeURIComponent("" + plantypvgl));
        if (planstufevgl === undefined || planstufevgl === null)
            throw new Error("The parameter 'planstufevgl' must be defined.");
        url_ = url_.replace("{planstufevgl}", encodeURIComponent("" + planstufevgl));
        if (planstufeJR === undefined || planstufeJR === null)
            throw new Error("The parameter 'planstufeJR' must be defined.");
        url_ = url_.replace("{planstufeJR}", encodeURIComponent("" + planstufeJR));
        if (jahrJR === undefined || jahrJR === null)
            throw new Error("The parameter 'jahrJR' must be defined.");
        url_ = url_.replace("{jahrJR}", encodeURIComponent("" + jahrJR));
        if (system === undefined || system === null)
            throw new Error("The parameter 'system' must be defined.");
        url_ = url_.replace("{system}", encodeURIComponent("" + system));
        if (bundesland === undefined || bundesland === null)
            throw new Error("The parameter 'bundesland' must be defined.");
        url_ = url_.replace("{bundesland}", encodeURIComponent("" + bundesland));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVBFile(_response);
        });
    }

    protected processGetVBFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getLBFile(kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, filename: string, nurvorlage: boolean, system: boolean, bundesland: string, authorization: any | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetLBFile/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}/{filename}/{nurvorlage}/{system}/{bundesland}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        if (nurvorlage === undefined || nurvorlage === null)
            throw new Error("The parameter 'nurvorlage' must be defined.");
        url_ = url_.replace("{nurvorlage}", encodeURIComponent("" + nurvorlage));
        if (system === undefined || system === null)
            throw new Error("The parameter 'system' must be defined.");
        url_ = url_.replace("{system}", encodeURIComponent("" + system));
        if (bundesland === undefined || bundesland === null)
            throw new Error("The parameter 'bundesland' must be defined.");
        url_ = url_.replace("{bundesland}", encodeURIComponent("" + bundesland));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLBFile(_response);
        });
    }

    protected processGetLBFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getUHBFile(kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, uhconfig: number, filename: string, nurvorlage: boolean, system: boolean, bundesland: string, authorization: any | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetUHBFile/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}/{uhconfig}/{filename}/{nurvorlage}/{system}/{bundesland}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (uhconfig === undefined || uhconfig === null)
            throw new Error("The parameter 'uhconfig' must be defined.");
        url_ = url_.replace("{uhconfig}", encodeURIComponent("" + uhconfig));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        if (nurvorlage === undefined || nurvorlage === null)
            throw new Error("The parameter 'nurvorlage' must be defined.");
        url_ = url_.replace("{nurvorlage}", encodeURIComponent("" + nurvorlage));
        if (system === undefined || system === null)
            throw new Error("The parameter 'system' must be defined.");
        url_ = url_.replace("{system}", encodeURIComponent("" + system));
        if (bundesland === undefined || bundesland === null)
            throw new Error("The parameter 'bundesland' must be defined.");
        url_ = url_.replace("{bundesland}", encodeURIComponent("" + bundesland));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUHBFile(_response);
        });
    }

    protected processGetUHBFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param plantyp (optional) 
     * @param planstufe (optional) 
     * @param platzhalter (optional) 
     * @param plantypvgl (optional) 
     * @param planstufevgl (optional) 
     * @param bundesland (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    vBPlatzhalterVorschau(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, plantyp: number | undefined, planstufe: number | undefined, platzhalter: number | undefined, plantypvgl: number | undefined, planstufevgl: number | undefined, bundesland: string | undefined, authorization: any | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/VBPlatzhalterVorschau?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (plantyp === null)
            throw new Error("The parameter 'plantyp' cannot be null.");
        else if (plantyp !== undefined)
            url_ += "plantyp=" + encodeURIComponent("" + plantyp) + "&";
        if (planstufe === null)
            throw new Error("The parameter 'planstufe' cannot be null.");
        else if (planstufe !== undefined)
            url_ += "planstufe=" + encodeURIComponent("" + planstufe) + "&";
        if (platzhalter === null)
            throw new Error("The parameter 'platzhalter' cannot be null.");
        else if (platzhalter !== undefined)
            url_ += "platzhalter=" + encodeURIComponent("" + platzhalter) + "&";
        if (plantypvgl === null)
            throw new Error("The parameter 'plantypvgl' cannot be null.");
        else if (plantypvgl !== undefined)
            url_ += "plantypvgl=" + encodeURIComponent("" + plantypvgl) + "&";
        if (planstufevgl === null)
            throw new Error("The parameter 'planstufevgl' cannot be null.");
        else if (planstufevgl !== undefined)
            url_ += "planstufevgl=" + encodeURIComponent("" + planstufevgl) + "&";
        if (bundesland === null)
            throw new Error("The parameter 'bundesland' cannot be null.");
        else if (bundesland !== undefined)
            url_ += "bundesland=" + encodeURIComponent("" + bundesland) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVBPlatzhalterVorschau(_response);
        });
    }

    protected processVBPlatzhalterVorschau(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param plantyp (optional) 
     * @param planstufe (optional) 
     * @param platzhalter (optional) 
     * @param bundesland (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    lBPlatzhalterVorschau(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, plantyp: number | undefined, planstufe: number | undefined, platzhalter: number | undefined, bundesland: string | undefined, authorization: any | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/LBPlatzhalterVorschau?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (plantyp === null)
            throw new Error("The parameter 'plantyp' cannot be null.");
        else if (plantyp !== undefined)
            url_ += "plantyp=" + encodeURIComponent("" + plantyp) + "&";
        if (planstufe === null)
            throw new Error("The parameter 'planstufe' cannot be null.");
        else if (planstufe !== undefined)
            url_ += "planstufe=" + encodeURIComponent("" + planstufe) + "&";
        if (platzhalter === null)
            throw new Error("The parameter 'platzhalter' cannot be null.");
        else if (platzhalter !== undefined)
            url_ += "platzhalter=" + encodeURIComponent("" + platzhalter) + "&";
        if (bundesland === null)
            throw new Error("The parameter 'bundesland' cannot be null.");
        else if (bundesland !== undefined)
            url_ += "bundesland=" + encodeURIComponent("" + bundesland) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLBPlatzhalterVorschau(_response);
        });
    }

    protected processLBPlatzhalterVorschau(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param plantyp (optional) 
     * @param planstufe (optional) 
     * @param uhconfig (optional) 
     * @param platzhalter (optional) 
     * @param bundesland (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    uHBPlatzhalterVorschau(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, plantyp: number | undefined, planstufe: number | undefined, uhconfig: number | undefined, platzhalter: number | undefined, bundesland: string | undefined, authorization: any | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/UHBPlatzhalterVorschau?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (plantyp === null)
            throw new Error("The parameter 'plantyp' cannot be null.");
        else if (plantyp !== undefined)
            url_ += "plantyp=" + encodeURIComponent("" + plantyp) + "&";
        if (planstufe === null)
            throw new Error("The parameter 'planstufe' cannot be null.");
        else if (planstufe !== undefined)
            url_ += "planstufe=" + encodeURIComponent("" + planstufe) + "&";
        if (uhconfig === null)
            throw new Error("The parameter 'uhconfig' cannot be null.");
        else if (uhconfig !== undefined)
            url_ += "uhconfig=" + encodeURIComponent("" + uhconfig) + "&";
        if (platzhalter === null)
            throw new Error("The parameter 'platzhalter' cannot be null.");
        else if (platzhalter !== undefined)
            url_ += "platzhalter=" + encodeURIComponent("" + platzhalter) + "&";
        if (bundesland === null)
            throw new Error("The parameter 'bundesland' cannot be null.");
        else if (bundesland !== undefined)
            url_ += "bundesland=" + encodeURIComponent("" + bundesland) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUHBPlatzhalterVorschau(_response);
        });
    }

    protected processUHBPlatzhalterVorschau(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    copyStammdaten(authorization: any | undefined, body: CopyModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/CopyStammdaten";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCopyStammdaten(_response);
        });
    }

    protected processCopyStammdaten(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addBerichtsFarbe(authorization: any | undefined, body: BerichtsFarben | undefined): Promise<BerichtsFarben> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddBerichtsFarbe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddBerichtsFarbe(_response);
        });
    }

    protected processAddBerichtsFarbe(response: Response): Promise<BerichtsFarben> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BerichtsFarben.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BerichtsFarben>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeBerichtsFarbe(authorization: any | undefined, body: BerichtsFarben | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveBerichtsFarbe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveBerichtsFarbe(_response);
        });
    }

    protected processRemoveBerichtsFarbe(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyBerichtsFarbe(authorization: any | undefined, body: BerichtsFarben | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ModifyBerichtsFarbe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyBerichtsFarbe(_response);
        });
    }

    protected processModifyBerichtsFarbe(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getBerichtsFarben(typ: string, authorization: any | undefined, body: GemeindeModel | undefined): Promise<BerichtsFarben[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetBerichtsFarben/{typ}";
        if (typ === undefined || typ === null)
            throw new Error("The parameter 'typ' must be defined.");
        url_ = url_.replace("{typ}", encodeURIComponent("" + typ));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBerichtsFarben(_response);
        });
    }

    protected processGetBerichtsFarben(response: Response): Promise<BerichtsFarben[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BerichtsFarben.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BerichtsFarben[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    duplicateBerichtsfarben(zielKunde: number, zielGemeinde: number, authorization: any | undefined, body: GemeindeModel | undefined): Promise<BerichtsFarben[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/DuplicateBerichtsfarben/{ZielKunde}/{ZielGemeinde}";
        if (zielKunde === undefined || zielKunde === null)
            throw new Error("The parameter 'zielKunde' must be defined.");
        url_ = url_.replace("{ZielKunde}", encodeURIComponent("" + zielKunde));
        if (zielGemeinde === undefined || zielGemeinde === null)
            throw new Error("The parameter 'zielGemeinde' must be defined.");
        url_ = url_.replace("{ZielGemeinde}", encodeURIComponent("" + zielGemeinde));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDuplicateBerichtsfarben(_response);
        });
    }

    protected processDuplicateBerichtsfarben(response: Response): Promise<BerichtsFarben[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BerichtsFarben.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BerichtsFarben[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    setIDs(authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/SetIDs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetIDs(_response);
        });
    }

    protected processSetIDs(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addKennzahlenVergleichskreis(authorization: any | undefined, body: KennzahlenVergleichskreise | undefined): Promise<KennzahlenVergleichskreise> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddKennzahlenVergleichskreis";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddKennzahlenVergleichskreis(_response);
        });
    }

    protected processAddKennzahlenVergleichskreis(response: Response): Promise<KennzahlenVergleichskreise> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KennzahlenVergleichskreise.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KennzahlenVergleichskreise>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeKennzahlenVergleichskreis(authorization: any | undefined, body: KennzahlenVergleichskreise | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveKennzahlenVergleichskreis";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveKennzahlenVergleichskreis(_response);
        });
    }

    protected processRemoveKennzahlenVergleichskreis(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyKennzahlenVergleichskreis(authorization: any | undefined, body: KennzahlenVergleichskreise | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ModifyKennzahlenVergleichskreis";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyKennzahlenVergleichskreis(_response);
        });
    }

    protected processModifyKennzahlenVergleichskreis(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getKennzahlenVergleichskreise(authorization: any | undefined): Promise<KennzahlenVergleichskreise[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetKennzahlenVergleichskreise";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetKennzahlenVergleichskreise(_response);
        });
    }

    protected processGetKennzahlenVergleichskreise(response: Response): Promise<KennzahlenVergleichskreise[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KennzahlenVergleichskreise.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KennzahlenVergleichskreise[]>(null as any);
    }

    /**
     * @param kreis (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    getGemeinden4Vergleichskreis(kreis: number | undefined, authorization: any | undefined): Promise<Gemeinden[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetGemeinden4Vergleichskreis?";
        if (kreis === null)
            throw new Error("The parameter 'kreis' cannot be null.");
        else if (kreis !== undefined)
            url_ += "kreis=" + encodeURIComponent("" + kreis) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetGemeinden4Vergleichskreis(_response);
        });
    }

    protected processGetGemeinden4Vergleichskreis(response: Response): Promise<Gemeinden[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Gemeinden.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Gemeinden[]>(null as any);
    }

    /**
     * @param kreis (optional) 
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setGemeinden4Vergleichskreis(kreis: number | undefined, authorization: any | undefined, body: Gemeinden[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/SetGemeinden4Vergleichskreis?";
        if (kreis === null)
            throw new Error("The parameter 'kreis' cannot be null.");
        else if (kreis !== undefined)
            url_ += "kreis=" + encodeURIComponent("" + kreis) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetGemeinden4Vergleichskreis(_response);
        });
    }

    protected processSetGemeinden4Vergleichskreis(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addKennzahl2Gzebene(authorization: any | undefined, body: Kennzahl2Gzebene | undefined): Promise<Kennzahl2Gzebene> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddKennzahl2Gzebene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddKennzahl2Gzebene(_response);
        });
    }

    protected processAddKennzahl2Gzebene(response: Response): Promise<Kennzahl2Gzebene> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Kennzahl2Gzebene.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Kennzahl2Gzebene>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeKennzahl2Gzebene(authorization: any | undefined, body: Kennzahl2Gzebene | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveKennzahl2Gzebene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveKennzahl2Gzebene(_response);
        });
    }

    protected processRemoveKennzahl2Gzebene(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyKennzahl2Gzebene(authorization: any | undefined, body: Kennzahl2Gzebene | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ModifyKennzahl2Gzebene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyKennzahl2Gzebene(_response);
        });
    }

    protected processModifyKennzahl2Gzebene(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getKennzahl2Gzebene(authorization: any | undefined, body: Kennzahlen | undefined): Promise<Kennzahl2Gzebene[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetKennzahl2Gzebene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetKennzahl2Gzebene(_response);
        });
    }

    protected processGetKennzahl2Gzebene(response: Response): Promise<Kennzahl2Gzebene[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Kennzahl2Gzebene.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Kennzahl2Gzebene[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addKennzahl2VBTab(authorization: any | undefined, body: Kennzahl2Vbtab | undefined): Promise<Kennzahl2Vbtab> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddKennzahl2VBTab";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddKennzahl2VBTab(_response);
        });
    }

    protected processAddKennzahl2VBTab(response: Response): Promise<Kennzahl2Vbtab> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Kennzahl2Vbtab.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Kennzahl2Vbtab>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeKennzahl2VBTab(authorization: any | undefined, body: Kennzahl2Vbtab | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveKennzahl2VBTab";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveKennzahl2VBTab(_response);
        });
    }

    protected processRemoveKennzahl2VBTab(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyKennzahl2VBTab(authorization: any | undefined, body: Kennzahl2Vbtab | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ModifyKennzahl2VBTab";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyKennzahl2VBTab(_response);
        });
    }

    protected processModifyKennzahl2VBTab(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getKennzahl2VBTab(authorization: any | undefined, body: Kennzahlen | undefined): Promise<Kennzahl2Vbtab[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetKennzahl2VBTab";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetKennzahl2VBTab(_response);
        });
    }

    protected processGetKennzahl2VBTab(response: Response): Promise<Kennzahl2Vbtab[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Kennzahl2Vbtab.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Kennzahl2Vbtab[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    fixText(authorization: any | undefined): Promise<Kennzahl2Vbtab[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/FixText";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFixText(_response);
        });
    }

    protected processFixText(response: Response): Promise<Kennzahl2Vbtab[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Kennzahl2Vbtab.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Kennzahl2Vbtab[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    fixTextPlatzhalter(authorization: any | undefined): Promise<VBPlatzhalterDoppischModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/FixTextPlatzhalter";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFixTextPlatzhalter(_response);
        });
    }

    protected processFixTextPlatzhalter(response: Response): Promise<VBPlatzhalterDoppischModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VBPlatzhalterDoppischModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VBPlatzhalterDoppischModel>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    createErlTextZuordnungen(kunde: number | undefined, authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/CreateErlTextZuordnungen?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateErlTextZuordnungen(_response);
        });
    }

    protected processCreateErlTextZuordnungen(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    requests(authorization: any | undefined): Promise<Request[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/requests";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRequests(_response);
        });
    }

    protected processRequests(response: Response): Promise<Request[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Request.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Request[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getHHSPlan(plantyp: number, planstufe: number, authorization: any | undefined, body: JahrModel | undefined): Promise<HHSPlanKameralModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetHHSPlan/{plantyp}/{planstufe}";
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHHSPlan(_response);
        });
    }

    protected processGetHHSPlan(response: Response): Promise<HHSPlanKameralModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HHSPlanKameralModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HHSPlanKameralModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getSingleHHSPlan(plantyp: number, planstufe: number, authorization: any | undefined, body: HHSPlanKameralModel | undefined): Promise<HHSPlanKameralModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetSingleHHSPlan/{plantyp}/{planstufe}";
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSingleHHSPlan(_response);
        });
    }

    protected processGetSingleHHSPlan(response: Response): Promise<HHSPlanKameralModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HHSPlanKameralModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HHSPlanKameralModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setHHSPlan(plantyp: number, planstufe: number, authorization: any | undefined, body: HHSPlanKameralModel | undefined): Promise<HHSPlanKameralModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/SetHHSPlan/{plantyp}/{planstufe}";
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetHHSPlan(_response);
        });
    }

    protected processSetHHSPlan(response: Response): Promise<HHSPlanKameralModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HHSPlanKameralModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HHSPlanKameralModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    calcPlanByTimeGen(authorization: any | undefined, body: CalcPlanKameralModel | undefined): Promise<HHSPlanKameralModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/CalcPlanByTimeGen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCalcPlanByTimeGen(_response);
        });
    }

    protected processCalcPlanByTimeGen(response: Response): Promise<HHSPlanKameralModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HHSPlanKameralModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HHSPlanKameralModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    calcPlan(authorization: any | undefined, body: CalcPlanKameralModel | undefined): Promise<HHSPlanKameralModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/CalcPlan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCalcPlan(_response);
        });
    }

    protected processCalcPlan(response: Response): Promise<HHSPlanKameralModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HHSPlanKameralModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HHSPlanKameralModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    startCalcPlanByTimeGen(authorization: any | undefined, body: CalcPlanKameralModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/StartCalcPlanByTimeGen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStartCalcPlanByTimeGen(_response);
        });
    }

    protected processStartCalcPlanByTimeGen(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getJobStatus(id: number, authorization: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetJobStatus/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJobStatus(_response);
        });
    }

    protected processGetJobStatus(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    restoreHHSPlan(plantyp: number, planstufe: number, authorization: any | undefined, body: HHSPlanKameralModel[] | undefined): Promise<HHSPlanKameralModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RestoreHHSPlan/{plantyp}/{planstufe}";
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRestoreHHSPlan(_response);
        });
    }

    protected processRestoreHHSPlan(response: Response): Promise<HHSPlanKameralModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HHSPlanKameralModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HHSPlanKameralModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateHHSPlan(plantyp: number, planstufe: number, jobid: number, authorization: any | undefined, body: HHSPlanKameralModel[] | undefined): Promise<HHSPlanKameralModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/UpdateHHSPlan/{plantyp}/{planstufe}/{jobid}";
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (jobid === undefined || jobid === null)
            throw new Error("The parameter 'jobid' must be defined.");
        url_ = url_.replace("{jobid}", encodeURIComponent("" + jobid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateHHSPlan(_response);
        });
    }

    protected processUpdateHHSPlan(response: Response): Promise<HHSPlanKameralModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HHSPlanKameralModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HHSPlanKameralModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    exportHHSP(authorization: any | undefined, body: ExportPlanKameralModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/ExportHHSP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportHHSP(_response);
        });
    }

    protected processExportHHSP(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getVerfuegbareKennzahlen(test: string, authorization: any | undefined, body: JahrModel | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetVerfuegbareKennzahlen/{Test}";
        if (test === undefined || test === null)
            throw new Error("The parameter 'test' must be defined.");
        url_ = url_.replace("{Test}", encodeURIComponent("" + test));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVerfuegbareKennzahlen(_response);
        });
    }

    protected processGetVerfuegbareKennzahlen(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addKommentarEmpfaenger(authorization: any | undefined, body: KommentarEmpfaengerModel | undefined): Promise<KommentarEmpfaengerModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddKommentarEmpfaenger";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddKommentarEmpfaenger(_response);
        });
    }

    protected processAddKommentarEmpfaenger(response: Response): Promise<KommentarEmpfaengerModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KommentarEmpfaengerModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KommentarEmpfaengerModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeKommentarEmpfaenger(authorization: any | undefined, body: KommentarEmpfaengerModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveKommentarEmpfaenger";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveKommentarEmpfaenger(_response);
        });
    }

    protected processRemoveKommentarEmpfaenger(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getKommentarEmpfaenger(kunde: number, gemeinde: number, authorization: any | undefined): Promise<KommentarEmpfaengerModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetKommentarEmpfaenger/{Kunde}/{Gemeinde}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{Kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{Gemeinde}", encodeURIComponent("" + gemeinde));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetKommentarEmpfaenger(_response);
        });
    }

    protected processGetKommentarEmpfaenger(response: Response): Promise<KommentarEmpfaengerModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KommentarEmpfaengerModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KommentarEmpfaengerModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addKommentar(authorization: any | undefined, body: KommentarModel | undefined): Promise<KommentarModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/AddKommentar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddKommentar(_response);
        });
    }

    protected processAddKommentar(response: Response): Promise<KommentarModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KommentarModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KommentarModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeKommentar(authorization: any | undefined, body: Kommentare | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/RemoveKommentar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveKommentar(_response);
        });
    }

    protected processRemoveKommentar(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getKommentare(kunde: number, gemeinde: number, authorization: any | undefined): Promise<KommentarModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdAdmin/GetKommentare/{Kunde}/{Gemeinde}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{Kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{Gemeinde}", encodeURIComponent("" + gemeinde));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetKommentare(_response);
        });
    }

    protected processGetKommentare(response: Response): Promise<KommentarModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KommentarModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KommentarModel[]>(null as any);
    }
}

export class DigitalHousholdDoppik_Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    customers(authorization: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/customers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomers(_response);
        });
    }

    protected processCustomers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getBilanz(authorization: any | undefined, body: HaushaltRequestDoppik | undefined): Promise<HaushaltsEbeneDoppik> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetBilanz";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBilanz(_response);
        });
    }

    protected processGetBilanz(response: Response): Promise<HaushaltsEbeneDoppik> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsEbeneDoppik.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsEbeneDoppik>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getHaushaltByKonto(authorization: any | undefined, body: HaushaltRequestDoppik | undefined): Promise<HaushaltsEbeneDoppik> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetHaushaltByKonto";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHaushaltByKonto(_response);
        });
    }

    protected processGetHaushaltByKonto(response: Response): Promise<HaushaltsEbeneDoppik> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsEbeneDoppik.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsEbeneDoppik>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getFilteredHaushaltByKonto1(authorization: any | undefined, body: HaushaltRequestDoppik | undefined): Promise<HaushaltsEbeneDoppik> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetFilteredHaushaltByKonto1";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFilteredHaushaltByKonto1(_response);
        });
    }

    protected processGetFilteredHaushaltByKonto1(response: Response): Promise<HaushaltsEbeneDoppik> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsEbeneDoppik.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsEbeneDoppik>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getHaushaltByProdukt(authorization: any | undefined, body: HaushaltRequestDoppik | undefined): Promise<HaushaltsEbeneDoppik> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetHaushaltByProdukt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHaushaltByProdukt(_response);
        });
    }

    protected processGetHaushaltByProdukt(response: Response): Promise<HaushaltsEbeneDoppik> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsEbeneDoppik.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsEbeneDoppik>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getFilteredHaushaltByProdukt1(authorization: any | undefined, body: HaushaltRequestDoppik | undefined): Promise<HaushaltsEbene> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetFilteredHaushaltByProdukt1";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFilteredHaushaltByProdukt1(_response);
        });
    }

    protected processGetFilteredHaushaltByProdukt1(response: Response): Promise<HaushaltsEbene> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsEbene.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsEbene>(null as any);
    }

    /**
     * @param plantyp (optional) 
     * @param planstufe (optional) 
     * @param fh (optional) 
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    toplevelebenen(plantyp: number | undefined, planstufe: number | undefined, fh: boolean | undefined, authorization: any | undefined, body: JahrModel | undefined): Promise<Ebenen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/toplevelebenen?";
        if (plantyp === null)
            throw new Error("The parameter 'plantyp' cannot be null.");
        else if (plantyp !== undefined)
            url_ += "plantyp=" + encodeURIComponent("" + plantyp) + "&";
        if (planstufe === null)
            throw new Error("The parameter 'planstufe' cannot be null.");
        else if (planstufe !== undefined)
            url_ += "planstufe=" + encodeURIComponent("" + planstufe) + "&";
        if (fh === null)
            throw new Error("The parameter 'fh' cannot be null.");
        else if (fh !== undefined)
            url_ += "fh=" + encodeURIComponent("" + fh) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processToplevelebenen(_response);
        });
    }

    protected processToplevelebenen(response: Response): Promise<Ebenen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Ebenen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Ebenen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getHaushaltByEbene(authorization: any | undefined, body: HaushaltRequestDoppik | undefined): Promise<HaushaltsEbeneDoppik> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetHaushaltByEbene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHaushaltByEbene(_response);
        });
    }

    protected processGetHaushaltByEbene(response: Response): Promise<HaushaltsEbeneDoppik> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsEbeneDoppik.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsEbeneDoppik>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getFilteredHaushaltsEbeneByKonto(authorization: any | undefined, body: HaushaltRequestDoppik | undefined): Promise<HaushaltsEbeneDoppik> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetFilteredHaushaltsEbeneByKonto";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFilteredHaushaltsEbeneByKonto(_response);
        });
    }

    protected processGetFilteredHaushaltsEbeneByKonto(response: Response): Promise<HaushaltsEbeneDoppik> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsEbeneDoppik.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsEbeneDoppik>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getAktivaSummiert(authorization: any | undefined, body: HaushaltRequestDoppik | undefined): Promise<HaushaltSummiert> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetAktivaSummiert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAktivaSummiert(_response);
        });
    }

    protected processGetAktivaSummiert(response: Response): Promise<HaushaltSummiert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltSummiert.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltSummiert>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getPassivaSummiert(authorization: any | undefined, body: HaushaltRequestDoppik | undefined): Promise<HaushaltSummiert> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetPassivaSummiert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPassivaSummiert(_response);
        });
    }

    protected processGetPassivaSummiert(response: Response): Promise<HaushaltSummiert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltSummiert.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltSummiert>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getAktivaDetailliert(authorization: any | undefined, body: HaushaltRequestDoppik | undefined): Promise<HaushaltSummiert> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetAktivaDetailliert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAktivaDetailliert(_response);
        });
    }

    protected processGetAktivaDetailliert(response: Response): Promise<HaushaltSummiert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltSummiert.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltSummiert>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getPassivaDetailliert(authorization: any | undefined, body: HaushaltRequestDoppik | undefined): Promise<HaushaltSummiert> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetPassivaDetailliert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPassivaDetailliert(_response);
        });
    }

    protected processGetPassivaDetailliert(response: Response): Promise<HaushaltSummiert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltSummiert.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltSummiert>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getOffenePostenForderungen(authorization: any | undefined, body: HaushaltRequestDoppik | undefined): Promise<HaushaltSummiert> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetOffenePostenForderungen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOffenePostenForderungen(_response);
        });
    }

    protected processGetOffenePostenForderungen(response: Response): Promise<HaushaltSummiert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltSummiert.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltSummiert>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getOffenePostenVerbindlichkeiten(authorization: any | undefined, body: HaushaltRequestDoppik | undefined): Promise<HaushaltSummiert> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetOffenePostenVerbindlichkeiten";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOffenePostenVerbindlichkeiten(_response);
        });
    }

    protected processGetOffenePostenVerbindlichkeiten(response: Response): Promise<HaushaltSummiert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltSummiert.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltSummiert>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getErgebnishaushaltSummiert(authorization: any | undefined, body: HaushaltRequestDoppik | undefined): Promise<HaushaltSummiert> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetErgebnishaushaltSummiert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetErgebnishaushaltSummiert(_response);
        });
    }

    protected processGetErgebnishaushaltSummiert(response: Response): Promise<HaushaltSummiert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltSummiert.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltSummiert>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getFinanzhaushaltSummiert(authorization: any | undefined, body: HaushaltRequestDoppik | undefined): Promise<HaushaltSummiert> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetFinanzhaushaltSummiert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFinanzhaushaltSummiert(_response);
        });
    }

    protected processGetFinanzhaushaltSummiert(response: Response): Promise<HaushaltSummiert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltSummiert.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltSummiert>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getInvestASummiert(authorization: any | undefined, body: HaushaltRequestDoppik | undefined): Promise<HaushaltSummiert> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetInvestASummiert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInvestASummiert(_response);
        });
    }

    protected processGetInvestASummiert(response: Response): Promise<HaushaltSummiert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltSummiert.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltSummiert>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getInvestADetailliert(authorization: any | undefined, body: HaushaltRequestDoppik | undefined): Promise<HaushaltSummiert> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetInvestADetailliert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInvestADetailliert(_response);
        });
    }

    protected processGetInvestADetailliert(response: Response): Promise<HaushaltSummiert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltSummiert.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltSummiert>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getInvestPSummiert(authorization: any | undefined, body: HaushaltRequestDoppik | undefined): Promise<HaushaltSummiert> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetInvestPSummiert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInvestPSummiert(_response);
        });
    }

    protected processGetInvestPSummiert(response: Response): Promise<HaushaltSummiert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltSummiert.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltSummiert>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getInvestPDetailliert(authorization: any | undefined, body: HaushaltRequestDoppik | undefined): Promise<HaushaltSummiert> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetInvestPDetailliert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInvestPDetailliert(_response);
        });
    }

    protected processGetInvestPDetailliert(response: Response): Promise<HaushaltSummiert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltSummiert.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltSummiert>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getInvestitionen(plantyp: number, planstufe: number, uhconfig: number, authorization: any | undefined, body: JahrModel | undefined): Promise<InvestitionsModelDoppik[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetInvestitionen/{plantyp}/{planstufe}/{uhconfig}";
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (uhconfig === undefined || uhconfig === null)
            throw new Error("The parameter 'uhconfig' must be defined.");
        url_ = url_.replace("{uhconfig}", encodeURIComponent("" + uhconfig));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInvestitionen(_response);
        });
    }

    protected processGetInvestitionen(response: Response): Promise<InvestitionsModelDoppik[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvestitionsModelDoppik.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvestitionsModelDoppik[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getKennzahlErgebnisse(authorization: any | undefined, body: KennzahlRequest | undefined): Promise<KennzahlModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetKennzahlErgebnisse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetKennzahlErgebnisse(_response);
        });
    }

    protected processGetKennzahlErgebnisse(response: Response): Promise<KennzahlModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KennzahlModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KennzahlModel>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param plantyp (optional) 
     * @param planstufe (optional) 
     * @param uhconfig (optional) 
     * @param verwaltungsansicht (optional) 
     * @param ebenen (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    aBCAnalysis(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, plantyp: number | undefined, planstufe: number | undefined, uhconfig: number | undefined, verwaltungsansicht: boolean | undefined, ebenen: string | undefined, authorization: any | undefined): Promise<ABCResult> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/ABCAnalysis?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (plantyp === null)
            throw new Error("The parameter 'plantyp' cannot be null.");
        else if (plantyp !== undefined)
            url_ += "plantyp=" + encodeURIComponent("" + plantyp) + "&";
        if (planstufe === null)
            throw new Error("The parameter 'planstufe' cannot be null.");
        else if (planstufe !== undefined)
            url_ += "planstufe=" + encodeURIComponent("" + planstufe) + "&";
        if (uhconfig === null)
            throw new Error("The parameter 'uhconfig' cannot be null.");
        else if (uhconfig !== undefined)
            url_ += "uhconfig=" + encodeURIComponent("" + uhconfig) + "&";
        if (verwaltungsansicht === null)
            throw new Error("The parameter 'verwaltungsansicht' cannot be null.");
        else if (verwaltungsansicht !== undefined)
            url_ += "verwaltungsansicht=" + encodeURIComponent("" + verwaltungsansicht) + "&";
        if (ebenen === null)
            throw new Error("The parameter 'ebenen' cannot be null.");
        else if (ebenen !== undefined)
            url_ += "ebenen=" + encodeURIComponent("" + ebenen) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processABCAnalysis(_response);
        });
    }

    protected processABCAnalysis(response: Response): Promise<ABCResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ABCResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ABCResult>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    topEAAnalysis(kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, uhconfig: number, authorization: any | undefined): Promise<TopEAResult> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/TopEAAnalysis/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}/{uhconfig}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (uhconfig === undefined || uhconfig === null)
            throw new Error("The parameter 'uhconfig' must be defined.");
        url_ = url_.replace("{uhconfig}", encodeURIComponent("" + uhconfig));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTopEAAnalysis(_response);
        });
    }

    protected processTopEAAnalysis(response: Response): Promise<TopEAResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TopEAResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TopEAResult>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    topEAAnalyses(kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, verwaltung: boolean, uhconfig: number, authorization: any | undefined): Promise<TopEAResult[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/TopEAAnalyses/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}/{verwaltung}/{uhconfig}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (verwaltung === undefined || verwaltung === null)
            throw new Error("The parameter 'verwaltung' must be defined.");
        url_ = url_.replace("{verwaltung}", encodeURIComponent("" + verwaltung));
        if (uhconfig === undefined || uhconfig === null)
            throw new Error("The parameter 'uhconfig' must be defined.");
        url_ = url_.replace("{uhconfig}", encodeURIComponent("" + uhconfig));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTopEAAnalyses(_response);
        });
    }

    protected processTopEAAnalyses(response: Response): Promise<TopEAResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TopEAResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TopEAResult[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getFilteredHaushaltByKonto(authorization: any | undefined, body: HaushaltFilterRequestDoppik | undefined): Promise<HaushaltsSummeDoppik> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetFilteredHaushaltByKonto";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFilteredHaushaltByKonto(_response);
        });
    }

    protected processGetFilteredHaushaltByKonto(response: Response): Promise<HaushaltsSummeDoppik> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsSummeDoppik.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsSummeDoppik>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getFilteredHaushaltByProdukt(authorization: any | undefined, body: HaushaltFilterRequestDoppik | undefined): Promise<HaushaltsSummeDoppik> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetFilteredHaushaltByProdukt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFilteredHaushaltByProdukt(_response);
        });
    }

    protected processGetFilteredHaushaltByProdukt(response: Response): Promise<HaushaltsSummeDoppik> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsSummeDoppik.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsSummeDoppik>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getFilteredHaushaltByEbene(authorization: any | undefined, body: HaushaltFilterRequestDoppik | undefined): Promise<HaushaltsSummeDoppik> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetFilteredHaushaltByEbene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFilteredHaushaltByEbene(_response);
        });
    }

    protected processGetFilteredHaushaltByEbene(response: Response): Promise<HaushaltsSummeDoppik> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsSummeDoppik.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsSummeDoppik>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getHaushaltsHierarchieByProdukt(authorization: any | undefined, body: HaushaltRequestDoppik | undefined): Promise<HaushaltsHiearchieDoppik> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetHaushaltsHierarchieByProdukt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHaushaltsHierarchieByProdukt(_response);
        });
    }

    protected processGetHaushaltsHierarchieByProdukt(response: Response): Promise<HaushaltsHiearchieDoppik> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsHiearchieDoppik.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsHiearchieDoppik>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getHaushaltsHierarchieByEbene(authorization: any | undefined, body: HaushaltRequestDoppik | undefined): Promise<HaushaltsHiearchieDoppik> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetHaushaltsHierarchieByEbene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHaushaltsHierarchieByEbene(_response);
        });
    }

    protected processGetHaushaltsHierarchieByEbene(response: Response): Promise<HaushaltsHiearchieDoppik> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsHiearchieDoppik.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsHiearchieDoppik>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getHaushaltsHierarchieByKonto(authorization: any | undefined, body: HaushaltRequestDoppik | undefined): Promise<HaushaltsHiearchieDoppik> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetHaushaltsHierarchieByKonto";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHaushaltsHierarchieByKonto(_response);
        });
    }

    protected processGetHaushaltsHierarchieByKonto(response: Response): Promise<HaushaltsHiearchieDoppik> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsHiearchieDoppik.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsHiearchieDoppik>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getHaushaltsSummeByProdukt(authorization: any | undefined, body: HaushaltSummenRequest | undefined): Promise<HaushaltSummiert> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetHaushaltsSummeByProdukt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHaushaltsSummeByProdukt(_response);
        });
    }

    protected processGetHaushaltsSummeByProdukt(response: Response): Promise<HaushaltSummiert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltSummiert.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltSummiert>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getHaushaltsSummeByEbene(authorization: any | undefined, body: HaushaltSummenRequest | undefined): Promise<HaushaltSummiert> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetHaushaltsSummeByEbene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHaushaltsSummeByEbene(_response);
        });
    }

    protected processGetHaushaltsSummeByEbene(response: Response): Promise<HaushaltSummiert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltSummiert.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltSummiert>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getHaushaltsSumme(typ: number, kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, uhConfig: number, verwaltungsansicht: boolean, authorization: any | undefined): Promise<HaushaltSummiert> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetHaushaltsSumme/{typ}/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}/{uhConfig}/{verwaltungsansicht}";
        if (typ === undefined || typ === null)
            throw new Error("The parameter 'typ' must be defined.");
        url_ = url_.replace("{Typ}", encodeURIComponent("" + typ));
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{Kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{Gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{Jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (uhConfig === undefined || uhConfig === null)
            throw new Error("The parameter 'uhConfig' must be defined.");
        url_ = url_.replace("{uhConfig}", encodeURIComponent("" + uhConfig));
        if (verwaltungsansicht === undefined || verwaltungsansicht === null)
            throw new Error("The parameter 'verwaltungsansicht' must be defined.");
        url_ = url_.replace("{verwaltungsansicht}", encodeURIComponent("" + verwaltungsansicht));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHaushaltsSumme(_response);
        });
    }

    protected processGetHaushaltsSumme(response: Response): Promise<HaushaltSummiert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltSummiert.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltSummiert>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getErmaechtigungen(plantyp: number, planstufe: number, invest: boolean, einnahmen: boolean, authorization: any | undefined, body: JahrModel | undefined): Promise<ErmEbene> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetErmaechtigungen/{plantyp}/{planstufe}/{invest}/{einnahmen}";
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (invest === undefined || invest === null)
            throw new Error("The parameter 'invest' must be defined.");
        url_ = url_.replace("{invest}", encodeURIComponent("" + invest));
        if (einnahmen === undefined || einnahmen === null)
            throw new Error("The parameter 'einnahmen' must be defined.");
        url_ = url_.replace("{einnahmen}", encodeURIComponent("" + einnahmen));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetErmaechtigungen(_response);
        });
    }

    protected processGetErmaechtigungen(response: Response): Promise<ErmEbene> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ErmEbene.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ErmEbene>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getKassenReste(plantyp: number, planstufe: number, authorization: any | undefined, body: JahrModel | undefined): Promise<KREbene> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetKassenReste/{plantyp}/{planstufe}";
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetKassenReste(_response);
        });
    }

    protected processGetKassenReste(response: Response): Promise<KREbene> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KREbene.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KREbene>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getHaushaltsReste(plantyp: number, planstufe: number, authorization: any | undefined, body: JahrModel | undefined): Promise<HREbene> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetHaushaltsReste/{plantyp}/{planstufe}";
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHaushaltsReste(_response);
        });
    }

    protected processGetHaushaltsReste(response: Response): Promise<HREbene> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HREbene.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HREbene>(null as any);
    }

    /**
     * @param plantyp (optional) 
     * @param planstufe (optional) 
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getVE(plantyp: number | undefined, planstufe: number | undefined, authorization: any | undefined, body: JahrModel | undefined): Promise<HaushaltsEbeneDoppik> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetVE?";
        if (plantyp === null)
            throw new Error("The parameter 'plantyp' cannot be null.");
        else if (plantyp !== undefined)
            url_ += "plantyp=" + encodeURIComponent("" + plantyp) + "&";
        if (planstufe === null)
            throw new Error("The parameter 'planstufe' cannot be null.");
        else if (planstufe !== undefined)
            url_ += "planstufe=" + encodeURIComponent("" + planstufe) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVE(_response);
        });
    }

    protected processGetVE(response: Response): Promise<HaushaltsEbeneDoppik> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsEbeneDoppik.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsEbeneDoppik>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getCacheHits(authorization: any | undefined): Promise<{ [key: string]: number; }> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetCacheHits";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCacheHits(_response);
        });
    }

    protected processGetCacheHits(response: Response): Promise<{ [key: string]: number; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: number; }>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getHaushaltsHierarchieVglByProdukt(plantypVgl: number, planstufeVgl: number, authorization: any | undefined, body: HaushaltRequestDoppik | undefined): Promise<HaushaltsHiearchieDoppik> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetHaushaltsHierarchieVglByProdukt/{plantypVgl}/{planstufeVgl}";
        if (plantypVgl === undefined || plantypVgl === null)
            throw new Error("The parameter 'plantypVgl' must be defined.");
        url_ = url_.replace("{plantypVgl}", encodeURIComponent("" + plantypVgl));
        if (planstufeVgl === undefined || planstufeVgl === null)
            throw new Error("The parameter 'planstufeVgl' must be defined.");
        url_ = url_.replace("{planstufeVgl}", encodeURIComponent("" + planstufeVgl));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHaushaltsHierarchieVglByProdukt(_response);
        });
    }

    protected processGetHaushaltsHierarchieVglByProdukt(response: Response): Promise<HaushaltsHiearchieDoppik> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsHiearchieDoppik.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsHiearchieDoppik>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getHaushaltsHierarchieVglByKonto(plantypVgl: number, planstufeVgl: number, authorization: any | undefined, body: HaushaltRequestDoppik | undefined): Promise<HaushaltsHiearchieDoppik> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetHaushaltsHierarchieVglByKonto/{plantypVgl}/{planstufeVgl}";
        if (plantypVgl === undefined || plantypVgl === null)
            throw new Error("The parameter 'plantypVgl' must be defined.");
        url_ = url_.replace("{plantypVgl}", encodeURIComponent("" + plantypVgl));
        if (planstufeVgl === undefined || planstufeVgl === null)
            throw new Error("The parameter 'planstufeVgl' must be defined.");
        url_ = url_.replace("{planstufeVgl}", encodeURIComponent("" + planstufeVgl));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHaushaltsHierarchieVglByKonto(_response);
        });
    }

    protected processGetHaushaltsHierarchieVglByKonto(response: Response): Promise<HaushaltsHiearchieDoppik> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsHiearchieDoppik.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsHiearchieDoppik>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getHaushaltsHierarchieVglByEbene(plantypVgl: number, planstufeVgl: number, authorization: any | undefined, body: HaushaltRequestDoppik | undefined): Promise<HaushaltsHiearchieDoppik> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetHaushaltsHierarchieVglByEbene/{plantypVgl}/{planstufeVgl}";
        if (plantypVgl === undefined || plantypVgl === null)
            throw new Error("The parameter 'plantypVgl' must be defined.");
        url_ = url_.replace("{plantypVgl}", encodeURIComponent("" + plantypVgl));
        if (planstufeVgl === undefined || planstufeVgl === null)
            throw new Error("The parameter 'planstufeVgl' must be defined.");
        url_ = url_.replace("{planstufeVgl}", encodeURIComponent("" + planstufeVgl));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHaushaltsHierarchieVglByEbene(_response);
        });
    }

    protected processGetHaushaltsHierarchieVglByEbene(response: Response): Promise<HaushaltsHiearchieDoppik> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsHiearchieDoppik.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsHiearchieDoppik>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getHaushaltsSummeVglByProdukt(plantypVgl: number, planstufeVgl: number, authorization: any | undefined, body: HaushaltSummenRequest | undefined): Promise<HaushaltSummiert> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetHaushaltsSummeVglByProdukt/{plantypVgl}/{planstufeVgl}";
        if (plantypVgl === undefined || plantypVgl === null)
            throw new Error("The parameter 'plantypVgl' must be defined.");
        url_ = url_.replace("{plantypVgl}", encodeURIComponent("" + plantypVgl));
        if (planstufeVgl === undefined || planstufeVgl === null)
            throw new Error("The parameter 'planstufeVgl' must be defined.");
        url_ = url_.replace("{planstufeVgl}", encodeURIComponent("" + planstufeVgl));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHaushaltsSummeVglByProdukt(_response);
        });
    }

    protected processGetHaushaltsSummeVglByProdukt(response: Response): Promise<HaushaltSummiert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltSummiert.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltSummiert>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getHaushaltsSummeVglByEbene(plantypVgl: number, planstufeVgl: number, authorization: any | undefined, body: HaushaltSummenRequest | undefined): Promise<HaushaltSummiert> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetHaushaltsSummeVglByEbene/{plantypVgl}/{planstufeVgl}";
        if (plantypVgl === undefined || plantypVgl === null)
            throw new Error("The parameter 'plantypVgl' must be defined.");
        url_ = url_.replace("{plantypVgl}", encodeURIComponent("" + plantypVgl));
        if (planstufeVgl === undefined || planstufeVgl === null)
            throw new Error("The parameter 'planstufeVgl' must be defined.");
        url_ = url_.replace("{planstufeVgl}", encodeURIComponent("" + planstufeVgl));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHaushaltsSummeVglByEbene(_response);
        });
    }

    protected processGetHaushaltsSummeVglByEbene(response: Response): Promise<HaushaltSummiert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltSummiert.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltSummiert>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getFilteredHaushaltVglByEbene(plantypVgl: number, planstufeVgl: number, authorization: any | undefined, body: HaushaltFilterRequestDoppik | undefined): Promise<HaushaltsSummeDoppik> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetFilteredHaushaltVglByEbene/{plantypVgl}/{planstufeVgl}";
        if (plantypVgl === undefined || plantypVgl === null)
            throw new Error("The parameter 'plantypVgl' must be defined.");
        url_ = url_.replace("{plantypVgl}", encodeURIComponent("" + plantypVgl));
        if (planstufeVgl === undefined || planstufeVgl === null)
            throw new Error("The parameter 'planstufeVgl' must be defined.");
        url_ = url_.replace("{planstufeVgl}", encodeURIComponent("" + planstufeVgl));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFilteredHaushaltVglByEbene(_response);
        });
    }

    protected processGetFilteredHaushaltVglByEbene(response: Response): Promise<HaushaltsSummeDoppik> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsSummeDoppik.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsSummeDoppik>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getFilteredHaushaltVglByProdukt(plantypVgl: number, planstufeVgl: number, authorization: any | undefined, body: HaushaltFilterRequestDoppik | undefined): Promise<HaushaltsSummeDoppik> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppik/GetFilteredHaushaltVglByProdukt/{plantypVgl}/{planstufeVgl}";
        if (plantypVgl === undefined || plantypVgl === null)
            throw new Error("The parameter 'plantypVgl' must be defined.");
        url_ = url_.replace("{plantypVgl}", encodeURIComponent("" + plantypVgl));
        if (planstufeVgl === undefined || planstufeVgl === null)
            throw new Error("The parameter 'planstufeVgl' must be defined.");
        url_ = url_.replace("{planstufeVgl}", encodeURIComponent("" + planstufeVgl));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFilteredHaushaltVglByProdukt(_response);
        });
    }

    protected processGetFilteredHaushaltVglByProdukt(response: Response): Promise<HaushaltsSummeDoppik> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsSummeDoppik.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsSummeDoppik>(null as any);
    }
}

export class DigitalHousholdDoppikAdmin_Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getImportFormate(authorization: any | undefined): Promise<ImportFormate[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetImportFormate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetImportFormate(_response);
        });
    }

    protected processGetImportFormate(response: Response): Promise<ImportFormate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImportFormate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportFormate[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    vBTabTypen(authorization: any | undefined): Promise<VbtabTypenDoppisch[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/VBTabTypen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVBTabTypen(_response);
        });
    }

    protected processVBTabTypen(response: Response): Promise<VbtabTypenDoppisch[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VbtabTypenDoppisch.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VbtabTypenDoppisch[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    datensatztypen(kunde: number, authorization: any | undefined): Promise<Datensatztypen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/datensatztypen/{kunde}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDatensatztypen(_response);
        });
    }

    protected processDatensatztypen(response: Response): Promise<Datensatztypen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Datensatztypen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Datensatztypen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    datensatztypenbybl(bundesland: string, authorization: any | undefined): Promise<Datensatztypen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/datensatztypenbybl/{bundesland}";
        if (bundesland === undefined || bundesland === null)
            throw new Error("The parameter 'bundesland' must be defined.");
        url_ = url_.replace("{bundesland}", encodeURIComponent("" + bundesland));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDatensatztypenbybl(_response);
        });
    }

    protected processDatensatztypenbybl(response: Response): Promise<Datensatztypen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Datensatztypen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Datensatztypen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    vermoegensarten(kunde: number, authorization: any | undefined): Promise<VermoegensartDoppisch[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/vermoegensarten/{kunde}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVermoegensarten(_response);
        });
    }

    protected processVermoegensarten(response: Response): Promise<VermoegensartDoppisch[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VermoegensartDoppisch.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VermoegensartDoppisch[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    investitionsarten(authorization: any | undefined): Promise<Investitionsarten[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/investitionsarten";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInvestitionsarten(_response);
        });
    }

    protected processInvestitionsarten(response: Response): Promise<Investitionsarten[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Investitionsarten.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Investitionsarten[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    gemeinden(authorization: any | undefined, body: Kunden | undefined): Promise<Gemeinden[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/gemeinden";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGemeinden(_response);
        });
    }

    protected processGemeinden(response: Response): Promise<Gemeinden[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Gemeinden.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Gemeinden[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    jahre(authorization: any | undefined, body: Gemeinden | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/jahre";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processJahre(_response);
        });
    }

    protected processJahre(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    freiesJahr(kunde: number, gemeinde: number, authorization: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/FreiesJahr/{kunde}/{gemeinde}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFreiesJahr(_response);
        });
    }

    protected processFreiesJahr(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addEbene(authorization: any | undefined, body: Ebenen | undefined): Promise<Ebenen> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/AddEbene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddEbene(_response);
        });
    }

    protected processAddEbene(response: Response): Promise<Ebenen> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Ebenen.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Ebenen>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeEbene(authorization: any | undefined, body: Ebenen | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/RemoveEbene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveEbene(_response);
        });
    }

    protected processRemoveEbene(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyEbene(authorization: any | undefined, body: Ebenen | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/ModifyEbene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyEbene(_response);
        });
    }

    protected processModifyEbene(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param fileData (optional) 
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @return OK
     */
    uploadEbenen(authorization: any | undefined, fileData: string | undefined, kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined): Promise<Ebenen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/UploadEbenen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileData === null || fileData === undefined)
            throw new Error("The parameter 'fileData' cannot be null.");
        else
            content_.append("fileData", fileData.toString());
        if (kunde === null || kunde === undefined)
            throw new Error("The parameter 'kunde' cannot be null.");
        else
            content_.append("kunde", kunde.toString());
        if (gemeinde === null || gemeinde === undefined)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else
            content_.append("gemeinde", gemeinde.toString());
        if (jahr === null || jahr === undefined)
            throw new Error("The parameter 'jahr' cannot be null.");
        else
            content_.append("jahr", jahr.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadEbenen(_response);
        });
    }

    protected processUploadEbenen(response: Response): Promise<Ebenen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Ebenen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Ebenen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    ebenen(authorization: any | undefined, body: JahrModel | undefined): Promise<Ebenen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/ebenen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEbenen(_response);
        });
    }

    protected processEbenen(response: Response): Promise<Ebenen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Ebenen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Ebenen[]>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    getHaushaltsstellen2Ebene(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, authorization: any | undefined): Promise<Haushaltsstelle2EbeneDoppisch[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetHaushaltsstellen2Ebene?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHaushaltsstellen2Ebene(_response);
        });
    }

    protected processGetHaushaltsstellen2Ebene(response: Response): Promise<Haushaltsstelle2EbeneDoppisch[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Haushaltsstelle2EbeneDoppisch.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Haushaltsstelle2EbeneDoppisch[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param ebenenId (optional) 
     * @param jahr (optional) 
     * @param kunde (optional) 
     * @return OK
     */
    getAssignedHaushaltsstellen(authorization: any | undefined, ebenenId: string | undefined, jahr: number | undefined, kunde: number | undefined): Promise<HaushaltsstellenDoppisch[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetAssignedHaushaltsstellen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (ebenenId === null || ebenenId === undefined)
            throw new Error("The parameter 'ebenenId' cannot be null.");
        else
            content_.append("ebenenId", ebenenId.toString());
        if (jahr === null || jahr === undefined)
            throw new Error("The parameter 'jahr' cannot be null.");
        else
            content_.append("jahr", jahr.toString());
        if (kunde === null || kunde === undefined)
            throw new Error("The parameter 'kunde' cannot be null.");
        else
            content_.append("kunde", kunde.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignedHaushaltsstellen(_response);
        });
    }

    protected processGetAssignedHaushaltsstellen(response: Response): Promise<HaushaltsstellenDoppisch[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HaushaltsstellenDoppisch.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsstellenDoppisch[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setAssignedHaushaltsstellen(authorization: any | undefined, body: AssignedHHSModelDoppik | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/SetAssignedHaushaltsstellen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetAssignedHaushaltsstellen(_response);
        });
    }

    protected processSetAssignedHaushaltsstellen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param hhS (optional) 
     * @param jahr (optional) 
     * @param kunde (optional) 
     * @return OK
     */
    getassignedebenen(authorization: any | undefined, hhS: number | undefined, jahr: number | undefined, kunde: number | undefined): Promise<EbenenModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/getassignedebenen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (hhS === null || hhS === undefined)
            throw new Error("The parameter 'hhS' cannot be null.");
        else
            content_.append("hhS", hhS.toString());
        if (jahr === null || jahr === undefined)
            throw new Error("The parameter 'jahr' cannot be null.");
        else
            content_.append("jahr", jahr.toString());
        if (kunde === null || kunde === undefined)
            throw new Error("The parameter 'kunde' cannot be null.");
        else
            content_.append("kunde", kunde.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetassignedebenen(_response);
        });
    }

    protected processGetassignedebenen(response: Response): Promise<EbenenModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EbenenModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EbenenModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setassignedebenen(authorization: any | undefined, body: AssignedEbenenModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/setassignedebenen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetassignedebenen(_response);
        });
    }

    protected processSetassignedebenen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param ebenenId (optional) 
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @return OK
     */
    getUnassignedHaushaltsstellen(authorization: any | undefined, ebenenId: string | undefined, kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined): Promise<HaushaltsstellenDoppisch[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetUnassignedHaushaltsstellen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (ebenenId === null || ebenenId === undefined)
            throw new Error("The parameter 'ebenenId' cannot be null.");
        else
            content_.append("ebenenId", ebenenId.toString());
        if (kunde === null || kunde === undefined)
            throw new Error("The parameter 'kunde' cannot be null.");
        else
            content_.append("kunde", kunde.toString());
        if (gemeinde === null || gemeinde === undefined)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else
            content_.append("gemeinde", gemeinde.toString());
        if (jahr === null || jahr === undefined)
            throw new Error("The parameter 'jahr' cannot be null.");
        else
            content_.append("jahr", jahr.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUnassignedHaushaltsstellen(_response);
        });
    }

    protected processGetUnassignedHaushaltsstellen(response: Response): Promise<HaushaltsstellenDoppisch[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HaushaltsstellenDoppisch.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsstellenDoppisch[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addMassnahme(authorization: any | undefined, body: Massnahman | undefined): Promise<Massnahman> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/AddMassnahme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddMassnahme(_response);
        });
    }

    protected processAddMassnahme(response: Response): Promise<Massnahman> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Massnahman.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Massnahman>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeMassnahme(authorization: any | undefined, body: Massnahman | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/RemoveMassnahme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveMassnahme(_response);
        });
    }

    protected processRemoveMassnahme(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateMassnahmen(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined, body: MassnahmenDoppisch[] | undefined): Promise<MassnahmenDoppisch[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/{kunde}/{gemeinde}/{jahr}/UpdateMassnahmen";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateMassnahmen(_response);
        });
    }

    protected processUpdateMassnahmen(response: Response): Promise<MassnahmenDoppisch[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MassnahmenDoppisch.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MassnahmenDoppisch[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyMassnahme(authorization: any | undefined, body: Massnahman | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/ModifyMassnahme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyMassnahme(_response);
        });
    }

    protected processModifyMassnahme(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addProduktebene(authorization: any | undefined, body: Produktebenen | undefined): Promise<Produktebenen> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/AddProduktebene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddProduktebene(_response);
        });
    }

    protected processAddProduktebene(response: Response): Promise<Produktebenen> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Produktebenen.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Produktebenen>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeProduktebene(authorization: any | undefined, body: Produktebenen | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/RemoveProduktebene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveProduktebene(_response);
        });
    }

    protected processRemoveProduktebene(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyProduktebene(authorization: any | undefined, body: Produktebenen | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/ModifyProduktebene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyProduktebene(_response);
        });
    }

    protected processModifyProduktebene(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addKontenebene(authorization: any | undefined, body: Kontenebenen | undefined): Promise<Kontenebenen> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/AddKontenebene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddKontenebene(_response);
        });
    }

    protected processAddKontenebene(response: Response): Promise<Kontenebenen> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Kontenebenen.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Kontenebenen>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeKontenebene(authorization: any | undefined, body: Kontenebenen | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/RemoveKontenebene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveKontenebene(_response);
        });
    }

    protected processRemoveKontenebene(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyKontenebene(authorization: any | undefined, body: Kontenebenen | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/ModifyKontenebene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyKontenebene(_response);
        });
    }

    protected processModifyKontenebene(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setProduktTexte(kunde: number, gemeinde: number, jahr: number, stellen: number, nummer: number, authorization: any | undefined, body: FreiTextModel[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/SetProduktTexte/{kunde}/{gemeinde}/{jahr}/{stellen}/{nummer}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (stellen === undefined || stellen === null)
            throw new Error("The parameter 'stellen' must be defined.");
        url_ = url_.replace("{stellen}", encodeURIComponent("" + stellen));
        if (nummer === undefined || nummer === null)
            throw new Error("The parameter 'nummer' must be defined.");
        url_ = url_.replace("{nummer}", encodeURIComponent("" + nummer));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetProduktTexte(_response);
        });
    }

    protected processSetProduktTexte(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getProduktTexte(kunde: number, gemeinde: number, jahr: number, stellen: number, nummer: number, authorization: any | undefined): Promise<FreiTextModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetProduktTexte/{kunde}/{gemeinde}/{jahr}/{stellen}/{nummer}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (stellen === undefined || stellen === null)
            throw new Error("The parameter 'stellen' must be defined.");
        url_ = url_.replace("{stellen}", encodeURIComponent("" + stellen));
        if (nummer === undefined || nummer === null)
            throw new Error("The parameter 'nummer' must be defined.");
        url_ = url_.replace("{nummer}", encodeURIComponent("" + nummer));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProduktTexte(_response);
        });
    }

    protected processGetProduktTexte(response: Response): Promise<FreiTextModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FreiTextModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FreiTextModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getProduktTextBezeichner(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetProduktTextBezeichner/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProduktTextBezeichner(_response);
        });
    }

    protected processGetProduktTextBezeichner(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setKontenTexte(kunde: number, gemeinde: number, jahr: number, stellen: number, nummer: number, authorization: any | undefined, body: FreiTextModel[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/SetKontenTexte/{kunde}/{gemeinde}/{jahr}/{stellen}/{nummer}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (stellen === undefined || stellen === null)
            throw new Error("The parameter 'stellen' must be defined.");
        url_ = url_.replace("{stellen}", encodeURIComponent("" + stellen));
        if (nummer === undefined || nummer === null)
            throw new Error("The parameter 'nummer' must be defined.");
        url_ = url_.replace("{nummer}", encodeURIComponent("" + nummer));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetKontenTexte(_response);
        });
    }

    protected processSetKontenTexte(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getKontenTexte(kunde: number, gemeinde: number, jahr: number, stellen: number, nummer: number, authorization: any | undefined): Promise<FreiTextModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetKontenTexte/{kunde}/{gemeinde}/{jahr}/{stellen}/{nummer}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (stellen === undefined || stellen === null)
            throw new Error("The parameter 'stellen' must be defined.");
        url_ = url_.replace("{stellen}", encodeURIComponent("" + stellen));
        if (nummer === undefined || nummer === null)
            throw new Error("The parameter 'nummer' must be defined.");
        url_ = url_.replace("{nummer}", encodeURIComponent("" + nummer));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetKontenTexte(_response);
        });
    }

    protected processGetKontenTexte(response: Response): Promise<FreiTextModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FreiTextModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FreiTextModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getKontenTextBezeichner(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetKontenTextBezeichner/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetKontenTextBezeichner(_response);
        });
    }

    protected processGetKontenTextBezeichner(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setHHTexte(kunde: number, gemeinde: number, jahr: number, hhstelle: number, authorization: any | undefined, body: FreiTextModel[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/SetHHTexte/{kunde}/{gemeinde}/{jahr}/{hhstelle}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (hhstelle === undefined || hhstelle === null)
            throw new Error("The parameter 'hhstelle' must be defined.");
        url_ = url_.replace("{hhstelle}", encodeURIComponent("" + hhstelle));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetHHTexte(_response);
        });
    }

    protected processSetHHTexte(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getHHTexte(kunde: number, gemeinde: number, jahr: number, hhstelle: number, authorization: any | undefined): Promise<FreiTextModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetHHTexte/{kunde}/{gemeinde}/{jahr}/{hhstelle}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (hhstelle === undefined || hhstelle === null)
            throw new Error("The parameter 'hhstelle' must be defined.");
        url_ = url_.replace("{hhstelle}", encodeURIComponent("" + hhstelle));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHHTexte(_response);
        });
    }

    protected processGetHHTexte(response: Response): Promise<FreiTextModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FreiTextModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FreiTextModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getHHTextBezeichner(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetHHTextBezeichner/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHHTextBezeichner(_response);
        });
    }

    protected processGetHHTextBezeichner(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    setPk2HHS(uhconfig: number, hhs: number, soll: boolean, pk: number): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/SetPk2HHS/{uhconfig}/{hhs}/{soll}/{pk}";
        if (uhconfig === undefined || uhconfig === null)
            throw new Error("The parameter 'uhconfig' must be defined.");
        url_ = url_.replace("{uhconfig}", encodeURIComponent("" + uhconfig));
        if (hhs === undefined || hhs === null)
            throw new Error("The parameter 'hhs' must be defined.");
        url_ = url_.replace("{hhs}", encodeURIComponent("" + hhs));
        if (soll === undefined || soll === null)
            throw new Error("The parameter 'soll' must be defined.");
        url_ = url_.replace("{soll}", encodeURIComponent("" + soll));
        if (pk === undefined || pk === null)
            throw new Error("The parameter 'pk' must be defined.");
        url_ = url_.replace("{pk}", encodeURIComponent("" + pk));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetPk2HHS(_response);
        });
    }

    protected processSetPk2HHS(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    setPk2MN(uhconfig: number, mn: number, soll: boolean, pk: number): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/SetPk2MN/{uhconfig}/{mn}/{soll}/{pk}";
        if (uhconfig === undefined || uhconfig === null)
            throw new Error("The parameter 'uhconfig' must be defined.");
        url_ = url_.replace("{uhconfig}", encodeURIComponent("" + uhconfig));
        if (mn === undefined || mn === null)
            throw new Error("The parameter 'mn' must be defined.");
        url_ = url_.replace("{mn}", encodeURIComponent("" + mn));
        if (soll === undefined || soll === null)
            throw new Error("The parameter 'soll' must be defined.");
        url_ = url_.replace("{soll}", encodeURIComponent("" + soll));
        if (pk === undefined || pk === null)
            throw new Error("The parameter 'pk' must be defined.");
        url_ = url_.replace("{pk}", encodeURIComponent("" + pk));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetPk2MN(_response);
        });
    }

    protected processSetPk2MN(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setInvestHaushaltsstellen(kunde: number, gemeinde: number, jahr: number, invest: number, authorization: any | undefined, body: InvestmentHaushaltsstellenDoppisch | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/SetInvestHaushaltsstellen/{kunde}/{gemeinde}/{jahr}/{invest}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (invest === undefined || invest === null)
            throw new Error("The parameter 'invest' must be defined.");
        url_ = url_.replace("{invest}", encodeURIComponent("" + invest));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetInvestHaushaltsstellen(_response);
        });
    }

    protected processSetInvestHaushaltsstellen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getInvestHaushaltsstellen(kunde: number, gemeinde: number, jahr: number, invest: number, authorization: any | undefined): Promise<InvestmentHaushaltsstellenDoppisch> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetInvestHaushaltsstellen/{kunde}/{gemeinde}/{jahr}/{invest}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (invest === undefined || invest === null)
            throw new Error("The parameter 'invest' must be defined.");
        url_ = url_.replace("{invest}", encodeURIComponent("" + invest));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInvestHaushaltsstellen(_response);
        });
    }

    protected processGetInvestHaushaltsstellen(response: Response): Promise<InvestmentHaushaltsstellenDoppisch> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvestmentHaushaltsstellenDoppisch.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvestmentHaushaltsstellenDoppisch>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    kontenplan(authorization: any | undefined, body: JahrModel | undefined): Promise<KontenModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/kontenplan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKontenplan(_response);
        });
    }

    protected processKontenplan(response: Response): Promise<KontenModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KontenModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KontenModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    updatekontoplan(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined, body: KontenModel[] | undefined): Promise<KontenModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/{kunde}/{gemeinde}/{jahr}/updatekontoplan";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatekontoplan(_response);
        });
    }

    protected processUpdatekontoplan(response: Response): Promise<KontenModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KontenModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KontenModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushKontenSuchTexte(authorization: any | undefined, body: PushKoPrGrGlModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/PushKontenSuchTexte";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushKontenSuchTexte(_response);
        });
    }

    protected processPushKontenSuchTexte(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushKonten(authorization: any | undefined, body: PushKontenModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/PushKonten";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushKonten(_response);
        });
    }

    protected processPushKonten(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushProduktSuchTexte(authorization: any | undefined, body: PushKoPrGrGlModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/PushProduktSuchTexte";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushProduktSuchTexte(_response);
        });
    }

    protected processPushProduktSuchTexte(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushProdukte(authorization: any | undefined, body: PushProdukteModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/PushProdukte";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushProdukte(_response);
        });
    }

    protected processPushProdukte(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    duplicateKontenSuchTexte(zielKunde: number, zielGemeinde: number, zielJahr: number, authorization: any | undefined, body: JahrModel | undefined): Promise<KontenModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/DuplicateKontenSuchTexte/{ZielKunde}/{ZielGemeinde}/{ZielJahr}";
        if (zielKunde === undefined || zielKunde === null)
            throw new Error("The parameter 'zielKunde' must be defined.");
        url_ = url_.replace("{ZielKunde}", encodeURIComponent("" + zielKunde));
        if (zielGemeinde === undefined || zielGemeinde === null)
            throw new Error("The parameter 'zielGemeinde' must be defined.");
        url_ = url_.replace("{ZielGemeinde}", encodeURIComponent("" + zielGemeinde));
        if (zielJahr === undefined || zielJahr === null)
            throw new Error("The parameter 'zielJahr' must be defined.");
        url_ = url_.replace("{ZielJahr}", encodeURIComponent("" + zielJahr));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDuplicateKontenSuchTexte(_response);
        });
    }

    protected processDuplicateKontenSuchTexte(response: Response): Promise<KontenModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KontenModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KontenModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushKontenSettings(authorization: any | undefined, body: PushKontenSettingsModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/PushKontenSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushKontenSettings(_response);
        });
    }

    protected processPushKontenSettings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    kontenebenen(authorization: any | undefined, body: JahrModel | undefined): Promise<KontenebenenModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/kontenebenen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKontenebenen(_response);
        });
    }

    protected processKontenebenen(response: Response): Promise<KontenebenenModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KontenebenenModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KontenebenenModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getKontenBuchungsebene(authorization: any | undefined, body: JahrModel | undefined): Promise<KontenebenenModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetKontenBuchungsebene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetKontenBuchungsebene(_response);
        });
    }

    protected processGetKontenBuchungsebene(response: Response): Promise<KontenebenenModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KontenebenenModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KontenebenenModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    updatekontenebenen(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined, body: KontenebenenModel[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/{kunde}/{gemeinde}/{jahr}/updatekontenebenen";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatekontenebenen(_response);
        });
    }

    protected processUpdatekontenebenen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    produkte(authorization: any | undefined, body: JahrModel | undefined): Promise<ProduktModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/produkte";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProdukte(_response);
        });
    }

    protected processProdukte(response: Response): Promise<ProduktModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProduktModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProduktModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateprodukte(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined, body: ProduktModel[] | undefined): Promise<ProduktModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/{kunde}/{gemeinde}/{jahr}/updateprodukte";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateprodukte(_response);
        });
    }

    protected processUpdateprodukte(response: Response): Promise<ProduktModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProduktModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProduktModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    duplicateProduktSuchTexte(zielKunde: number, zielGemeinde: number, zielJahr: number, authorization: any | undefined, body: JahrModel | undefined): Promise<ProduktModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/DuplicateProduktSuchTexte/{ZielKunde}/{ZielGemeinde}/{ZielJahr}";
        if (zielKunde === undefined || zielKunde === null)
            throw new Error("The parameter 'zielKunde' must be defined.");
        url_ = url_.replace("{ZielKunde}", encodeURIComponent("" + zielKunde));
        if (zielGemeinde === undefined || zielGemeinde === null)
            throw new Error("The parameter 'zielGemeinde' must be defined.");
        url_ = url_.replace("{ZielGemeinde}", encodeURIComponent("" + zielGemeinde));
        if (zielJahr === undefined || zielJahr === null)
            throw new Error("The parameter 'zielJahr' must be defined.");
        url_ = url_.replace("{ZielJahr}", encodeURIComponent("" + zielJahr));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDuplicateProduktSuchTexte(_response);
        });
    }

    protected processDuplicateProduktSuchTexte(response: Response): Promise<ProduktModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProduktModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProduktModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    produktebenen(authorization: any | undefined, body: JahrModel | undefined): Promise<ProduktebenenModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/produktebenen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProduktebenen(_response);
        });
    }

    protected processProduktebenen(response: Response): Promise<ProduktebenenModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProduktebenenModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProduktebenenModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getProduktBuchungsebene(authorization: any | undefined, body: JahrModel | undefined): Promise<ProduktebenenModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetProduktBuchungsebene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProduktBuchungsebene(_response);
        });
    }

    protected processGetProduktBuchungsebene(response: Response): Promise<ProduktebenenModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProduktebenenModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProduktebenenModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateproduktebenen(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined, body: ProduktebenenModel[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/{kunde}/{gemeinde}/{jahr}/updateproduktebenen";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateproduktebenen(_response);
        });
    }

    protected processUpdateproduktebenen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addJahr(authorization: any | undefined, body: JahrModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/AddJahr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddJahr(_response);
        });
    }

    protected processAddJahr(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    duplicateVB(zielKunde: number, zielGemeinde: number, authorization: any | undefined, body: JahrModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/DuplicateVB/{ZielKunde}/{ZielGemeinde}";
        if (zielKunde === undefined || zielKunde === null)
            throw new Error("The parameter 'zielKunde' must be defined.");
        url_ = url_.replace("{ZielKunde}", encodeURIComponent("" + zielKunde));
        if (zielGemeinde === undefined || zielGemeinde === null)
            throw new Error("The parameter 'zielGemeinde' must be defined.");
        url_ = url_.replace("{ZielGemeinde}", encodeURIComponent("" + zielGemeinde));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDuplicateVB(_response);
        });
    }

    protected processDuplicateVB(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    duplicateVBPlatzhalter(zielKunde: number, zielGemeinde: number, ueberschreiben: boolean, quellberichttyp: number, zielberichttyp: number, authorization: any | undefined, body: JahrModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/DuplicateVBPlatzhalter/{ZielKunde}/{ZielGemeinde}/{Ueberschreiben}/{quellberichttyp}/{zielberichttyp}";
        if (zielKunde === undefined || zielKunde === null)
            throw new Error("The parameter 'zielKunde' must be defined.");
        url_ = url_.replace("{ZielKunde}", encodeURIComponent("" + zielKunde));
        if (zielGemeinde === undefined || zielGemeinde === null)
            throw new Error("The parameter 'zielGemeinde' must be defined.");
        url_ = url_.replace("{ZielGemeinde}", encodeURIComponent("" + zielGemeinde));
        if (ueberschreiben === undefined || ueberschreiben === null)
            throw new Error("The parameter 'ueberschreiben' must be defined.");
        url_ = url_.replace("{Ueberschreiben}", encodeURIComponent("" + ueberschreiben));
        if (quellberichttyp === undefined || quellberichttyp === null)
            throw new Error("The parameter 'quellberichttyp' must be defined.");
        url_ = url_.replace("{quellberichttyp}", encodeURIComponent("" + quellberichttyp));
        if (zielberichttyp === undefined || zielberichttyp === null)
            throw new Error("The parameter 'zielberichttyp' must be defined.");
        url_ = url_.replace("{zielberichttyp}", encodeURIComponent("" + zielberichttyp));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDuplicateVBPlatzhalter(_response);
        });
    }

    protected processDuplicateVBPlatzhalter(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushVBPlatzhalter(authorization: any | undefined, body: PushVBPlatzhalterDoppischModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/PushVBPlatzhalter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushVBPlatzhalter(_response);
        });
    }

    protected processPushVBPlatzhalter(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushSystemVBPlatzhalter(authorization: any | undefined, body: PushVBPlatzhalterDoppischModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/PushSystemVBPlatzhalter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushSystemVBPlatzhalter(_response);
        });
    }

    protected processPushSystemVBPlatzhalter(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushSystemVBPlatzhalterUeberschreibungen(authorization: any | undefined, body: PushVBPlatzhalterDoppischModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/PushSystemVBPlatzhalterUeberschreibungen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushSystemVBPlatzhalterUeberschreibungen(_response);
        });
    }

    protected processPushSystemVBPlatzhalterUeberschreibungen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadProduktTexteBin(kunde: number, gemeinde: number, jahr: number, format: number, authorization: any | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/UploadProduktTexteBin/{kunde}/{gemeinde}/{jahr}/{format}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadProduktTexteBin(_response);
        });
    }

    protected processUploadProduktTexteBin(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadProdukteBin(kunde: number, gemeinde: number, jahr: number, format: number, authorization: any | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/UploadProdukteBin/{kunde}/{gemeinde}/{jahr}/{format}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadProdukteBin(_response);
        });
    }

    protected processUploadProdukteBin(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadKontenBin(kunde: number, gemeinde: number, jahr: number, format: number, authorization: any | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/UploadKontenBin/{kunde}/{gemeinde}/{jahr}/{format}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadKontenBin(_response);
        });
    }

    protected processUploadKontenBin(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadMassnahmenBezBin(kunde: number, gemeinde: number, jahr: number, format: number, authorization: any | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/UploadMassnahmenBezBin/{kunde}/{gemeinde}/{jahr}/{format}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadMassnahmenBezBin(_response);
        });
    }

    protected processUploadMassnahmenBezBin(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadEbenenBin(kunde: number, gemeinde: number, jahr: number, format: number, oberebene: string, nummernspalte: string, namensspalte: string, dateiname: string, authorization: any | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/UploadEbenenBin/{kunde}/{gemeinde}/{jahr}/{format}/{oberebene}/{namensspalte}/{nummernspalte}/{dateiname}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (oberebene === undefined || oberebene === null)
            throw new Error("The parameter 'oberebene' must be defined.");
        url_ = url_.replace("{oberebene}", encodeURIComponent("" + oberebene));
        if (nummernspalte === undefined || nummernspalte === null)
            throw new Error("The parameter 'nummernspalte' must be defined.");
        url_ = url_.replace("{nummernspalte}", encodeURIComponent("" + nummernspalte));
        if (namensspalte === undefined || namensspalte === null)
            throw new Error("The parameter 'namensspalte' must be defined.");
        url_ = url_.replace("{namensspalte}", encodeURIComponent("" + namensspalte));
        if (dateiname === undefined || dateiname === null)
            throw new Error("The parameter 'dateiname' must be defined.");
        url_ = url_.replace("{dateiname}", encodeURIComponent("" + dateiname));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadEbenenBin(_response);
        });
    }

    protected processUploadEbenenBin(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadHHStellenBinA(kunde: number, gemeinde: number, jahr: number, format: number, dateiname: string, authorization: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/UploadHHStellenBinA/{kunde}/{gemeinde}/{jahr}/{format}/{dateiname}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (dateiname === undefined || dateiname === null)
            throw new Error("The parameter 'dateiname' must be defined.");
        url_ = url_.replace("{dateiname}", encodeURIComponent("" + dateiname));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadHHStellenBinA(_response);
        });
    }

    protected processUploadHHStellenBinA(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getImportHHResult(id: number, authorization: any | undefined): Promise<ImportHHSResultDoppisch> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetImportHHResult/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetImportHHResult(_response);
        });
    }

    protected processGetImportHHResult(response: Response): Promise<ImportHHSResultDoppisch> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportHHSResultDoppisch.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportHHSResultDoppisch>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadHHStellenBin(kunde: number, gemeinde: number, jahr: number, format: number, authorization: any | undefined): Promise<ImportHHSResultDoppisch> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/UploadHHStellenBin/{kunde}/{gemeinde}/{jahr}/{format}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadHHStellenBin(_response);
        });
    }

    protected processUploadHHStellenBin(response: Response): Promise<ImportHHSResultDoppisch> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportHHSResultDoppisch.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportHHSResultDoppisch>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateHaushaltsstellen(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined, body: HaushaltsstellenDoppisch[] | undefined): Promise<HaushaltsstellenDoppisch[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/{kunde}/{gemeinde}/{jahr}/UpdateHaushaltsstellen";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateHaushaltsstellen(_response);
        });
    }

    protected processUpdateHaushaltsstellen(response: Response): Promise<HaushaltsstellenDoppisch[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HaushaltsstellenDoppisch.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsstellenDoppisch[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    haushaltsstellen(authorization: any | undefined, body: JahrModel | undefined): Promise<HaushaltsstellenDoppisch[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/haushaltsstellen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHaushaltsstellen(_response);
        });
    }

    protected processHaushaltsstellen(response: Response): Promise<HaushaltsstellenDoppisch[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HaushaltsstellenDoppisch.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsstellenDoppisch[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    checkUHHS(uhconfig: number, planstufe: number, authorization: any | undefined, body: JahrModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/CheckUHHS/{uhconfig}/{planstufe}";
        if (uhconfig === undefined || uhconfig === null)
            throw new Error("The parameter 'uhconfig' must be defined.");
        url_ = url_.replace("{uhconfig}", encodeURIComponent("" + uhconfig));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckUHHS(_response);
        });
    }

    protected processCheckUHHS(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getUHHS(uhconfig: number, planstufe: number, authorization: any | undefined, body: JahrModel | undefined): Promise<UHHSDoppischModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetUHHS/{uhconfig}/{planstufe}";
        if (uhconfig === undefined || uhconfig === null)
            throw new Error("The parameter 'uhconfig' must be defined.");
        url_ = url_.replace("{uhconfig}", encodeURIComponent("" + uhconfig));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUHHS(_response);
        });
    }

    protected processGetUHHS(response: Response): Promise<UHHSDoppischModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UHHSDoppischModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UHHSDoppischModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setUHHS(uhconfig: number, planstufe: number, authorization: any | undefined, body: UHHSDoppischModel | undefined): Promise<UHHSDoppischModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/SetUHHS/{uhconfig}/{planstufe}";
        if (uhconfig === undefined || uhconfig === null)
            throw new Error("The parameter 'uhconfig' must be defined.");
        url_ = url_.replace("{uhconfig}", encodeURIComponent("" + uhconfig));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetUHHS(_response);
        });
    }

    protected processSetUHHS(response: Response): Promise<UHHSDoppischModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UHHSDoppischModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UHHSDoppischModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    calcUHHS(uhconfig: number, planstufe: number, authorization: any | undefined, body: UHHSDoppischModel | undefined): Promise<UHHSDoppischModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/CalcUHHS/{uhconfig}/{planstufe}";
        if (uhconfig === undefined || uhconfig === null)
            throw new Error("The parameter 'uhconfig' must be defined.");
        url_ = url_.replace("{uhconfig}", encodeURIComponent("" + uhconfig));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCalcUHHS(_response);
        });
    }

    protected processCalcUHHS(response: Response): Promise<UHHSDoppischModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UHHSDoppischModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UHHSDoppischModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setUHMN(uhconfig: number, planstufe: number, authorization: any | undefined, body: UHMNDoppischModel | undefined): Promise<UHMNDoppischModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/SetUHMN/{uhconfig}/{planstufe}";
        if (uhconfig === undefined || uhconfig === null)
            throw new Error("The parameter 'uhconfig' must be defined.");
        url_ = url_.replace("{uhconfig}", encodeURIComponent("" + uhconfig));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetUHMN(_response);
        });
    }

    protected processSetUHMN(response: Response): Promise<UHMNDoppischModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UHMNDoppischModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UHMNDoppischModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setUHHSArray(uhconfig: number, planstufe: number, authorization: any | undefined, body: UHHSDoppischModel[] | undefined): Promise<UHHSDoppischModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/SetUHHSArray/{uhconfig}/{planstufe}";
        if (uhconfig === undefined || uhconfig === null)
            throw new Error("The parameter 'uhconfig' must be defined.");
        url_ = url_.replace("{uhconfig}", encodeURIComponent("" + uhconfig));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetUHHSArray(_response);
        });
    }

    protected processSetUHHSArray(response: Response): Promise<UHHSDoppischModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UHHSDoppischModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UHHSDoppischModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setUHMNArray(uhconfig: number, planstufe: number, authorization: any | undefined, body: UHMNDoppischModel[] | undefined): Promise<UHMNDoppischModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/SetUHMNArray/{uhconfig}/{planstufe}";
        if (uhconfig === undefined || uhconfig === null)
            throw new Error("The parameter 'uhconfig' must be defined.");
        url_ = url_.replace("{uhconfig}", encodeURIComponent("" + uhconfig));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetUHMNArray(_response);
        });
    }

    protected processSetUHMNArray(response: Response): Promise<UHMNDoppischModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UHMNDoppischModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UHMNDoppischModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushPrognosekurvenZuweisungen(authorization: any | undefined, body: PushPrognosekurvenZuweisungenModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/PushPrognosekurvenZuweisungen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushPrognosekurvenZuweisungen(_response);
        });
    }

    protected processPushPrognosekurvenZuweisungen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    calcProgMan(authorization: any | undefined, body: CalcPMDoppischModel | undefined): Promise<UHHSDoppischModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/CalcProgMan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCalcProgMan(_response);
        });
    }

    protected processCalcProgMan(response: Response): Promise<UHHSDoppischModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UHHSDoppischModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UHHSDoppischModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    calcProgManMN(authorization: any | undefined, body: CalcPMDoppischModel | undefined): Promise<UHMNDoppischModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/CalcProgManMN";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCalcProgManMN(_response);
        });
    }

    protected processCalcProgManMN(response: Response): Promise<UHMNDoppischModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UHMNDoppischModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UHMNDoppischModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getInvestEinnahmeHaushaltsstellen(authorization: any | undefined, body: JahrModel | undefined): Promise<InvestitionsHHStelleDoppisch[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetInvestEinnahmeHaushaltsstellen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInvestEinnahmeHaushaltsstellen(_response);
        });
    }

    protected processGetInvestEinnahmeHaushaltsstellen(response: Response): Promise<InvestitionsHHStelleDoppisch[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvestitionsHHStelleDoppisch.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvestitionsHHStelleDoppisch[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getInvestAusgabeHaushaltsstellen(authorization: any | undefined, body: JahrModel | undefined): Promise<InvestitionsHHStelleDoppisch[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetInvestAusgabeHaushaltsstellen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInvestAusgabeHaushaltsstellen(_response);
        });
    }

    protected processGetInvestAusgabeHaushaltsstellen(response: Response): Promise<InvestitionsHHStelleDoppisch[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvestitionsHHStelleDoppisch.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvestitionsHHStelleDoppisch[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadHHBeschreibungenBinA(kunde: number, gemeinde: number, jahr: number, dateiname: string, authorization: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/UploadHHBeschreibungenBinA/{kunde}/{gemeinde}/{jahr}/{dateiname}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (dateiname === undefined || dateiname === null)
            throw new Error("The parameter 'dateiname' must be defined.");
        url_ = url_.replace("{dateiname}", encodeURIComponent("" + dateiname));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadHHBeschreibungenBinA(_response);
        });
    }

    protected processUploadHHBeschreibungenBinA(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadHHBeschreibungenBin(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/UploadHHBeschreibungenBin/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadHHBeschreibungenBin(_response);
        });
    }

    protected processUploadHHBeschreibungenBin(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadMassnahmenBinA(kunde: number, gemeinde: number, jahr: number, format: number, dateiname: string, authorization: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/UploadMassnahmenBinA/{kunde}/{gemeinde}/{jahr}/{format}/{dateiname}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (dateiname === undefined || dateiname === null)
            throw new Error("The parameter 'dateiname' must be defined.");
        url_ = url_.replace("{dateiname}", encodeURIComponent("" + dateiname));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadMassnahmenBinA(_response);
        });
    }

    protected processUploadMassnahmenBinA(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadMassnahmenBin(kunde: number, gemeinde: number, jahr: number, format: number, authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/UploadMassnahmenBin/{kunde}/{gemeinde}/{jahr}/{format}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadMassnahmenBin(_response);
        });
    }

    protected processUploadMassnahmenBin(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    autoCreateInvestitionen(kunde: number, gemeinde: number, jahr: number, overwrite: boolean, grenze: number, anzFJahre: number, datenTyp: number, uHConfig: number, mitErfolgskonten: boolean, authorization: any | undefined): Promise<Investitionen[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/AutoCreateInvestitionen/{Kunde}/{Gemeinde}/{Jahr}/{Overwrite}/{Grenze}/{AnzFJahre}/{DatenTyp}/{UHConfig}/{MitErfolgskonten}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{Kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{Gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{Jahr}", encodeURIComponent("" + jahr));
        if (overwrite === undefined || overwrite === null)
            throw new Error("The parameter 'overwrite' must be defined.");
        url_ = url_.replace("{Overwrite}", encodeURIComponent("" + overwrite));
        if (grenze === undefined || grenze === null)
            throw new Error("The parameter 'grenze' must be defined.");
        url_ = url_.replace("{Grenze}", encodeURIComponent("" + grenze));
        if (anzFJahre === undefined || anzFJahre === null)
            throw new Error("The parameter 'anzFJahre' must be defined.");
        url_ = url_.replace("{AnzFJahre}", encodeURIComponent("" + anzFJahre));
        if (datenTyp === undefined || datenTyp === null)
            throw new Error("The parameter 'datenTyp' must be defined.");
        url_ = url_.replace("{DatenTyp}", encodeURIComponent("" + datenTyp));
        if (uHConfig === undefined || uHConfig === null)
            throw new Error("The parameter 'uHConfig' must be defined.");
        url_ = url_.replace("{UHConfig}", encodeURIComponent("" + uHConfig));
        if (mitErfolgskonten === undefined || mitErfolgskonten === null)
            throw new Error("The parameter 'mitErfolgskonten' must be defined.");
        url_ = url_.replace("{MitErfolgskonten}", encodeURIComponent("" + mitErfolgskonten));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAutoCreateInvestitionen(_response);
        });
    }

    protected processAutoCreateInvestitionen(response: Response): Promise<Investitionen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Investitionen.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Investitionen[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    massnahmen(authorization: any | undefined, body: JahrModel | undefined): Promise<MassnahmenDoppisch[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/massnahmen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMassnahmen(_response);
        });
    }

    protected processMassnahmen(response: Response): Promise<MassnahmenDoppisch[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MassnahmenDoppisch.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MassnahmenDoppisch[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadHHDatenBinA(kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, format: number, dateiname: string, loeschen: number, authorization: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/UploadHHDatenBinA/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}/{format}/{dateiname}/{loeschen}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (dateiname === undefined || dateiname === null)
            throw new Error("The parameter 'dateiname' must be defined.");
        url_ = url_.replace("{dateiname}", encodeURIComponent("" + dateiname));
        if (loeschen === undefined || loeschen === null)
            throw new Error("The parameter 'loeschen' must be defined.");
        url_ = url_.replace("{loeschen}", encodeURIComponent("" + loeschen));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadHHDatenBinA(_response);
        });
    }

    protected processUploadHHDatenBinA(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadHHDatenBin(kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, format: number, authorization: any | undefined): Promise<ImportHHDResult> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/UploadHHDatenBin/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}/{format}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadHHDatenBin(_response);
        });
    }

    protected processUploadHHDatenBin(response: Response): Promise<ImportHHDResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportHHDResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportHHDResult>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadHHUHDatenBinA(kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, format: number, importjahr: number, dateiname: string, authorization: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/UploadHHUHDatenBinA/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}/{format}/{importjahr}/{dateiname}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (importjahr === undefined || importjahr === null)
            throw new Error("The parameter 'importjahr' must be defined.");
        url_ = url_.replace("{importjahr}", encodeURIComponent("" + importjahr));
        if (dateiname === undefined || dateiname === null)
            throw new Error("The parameter 'dateiname' must be defined.");
        url_ = url_.replace("{dateiname}", encodeURIComponent("" + dateiname));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadHHUHDatenBinA(_response);
        });
    }

    protected processUploadHHUHDatenBinA(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadHHUHDatenBin(kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, format: number, importjahr: number, authorization: any | undefined): Promise<ImportHHDResult> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/UploadHHUHDatenBin/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}/{format}/{importjahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (importjahr === undefined || importjahr === null)
            throw new Error("The parameter 'importjahr' must be defined.");
        url_ = url_.replace("{importjahr}", encodeURIComponent("" + importjahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadHHUHDatenBin(_response);
        });
    }

    protected processUploadHHUHDatenBin(response: Response): Promise<ImportHHDResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportHHDResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportHHDResult>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadHHJRDatenBinA(kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, format: number, importjahr: number, dateiname: string, authorization: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/UploadHHJRDatenBinA/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}/{format}/{importjahr}/{dateiname}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (importjahr === undefined || importjahr === null)
            throw new Error("The parameter 'importjahr' must be defined.");
        url_ = url_.replace("{importjahr}", encodeURIComponent("" + importjahr));
        if (dateiname === undefined || dateiname === null)
            throw new Error("The parameter 'dateiname' must be defined.");
        url_ = url_.replace("{dateiname}", encodeURIComponent("" + dateiname));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadHHJRDatenBinA(_response);
        });
    }

    protected processUploadHHJRDatenBinA(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadHHJRDatenBin(kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, format: number, importjahr: number, authorization: any | undefined): Promise<ImportHHDResult> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/UploadHHJRDatenBin/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}/{format}/{importjahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (importjahr === undefined || importjahr === null)
            throw new Error("The parameter 'importjahr' must be defined.");
        url_ = url_.replace("{importjahr}", encodeURIComponent("" + importjahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadHHJRDatenBin(_response);
        });
    }

    protected processUploadHHJRDatenBin(response: Response): Promise<ImportHHDResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportHHDResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportHHDResult>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadBilanzJRDatenBinA(kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, format: number, importjahr: number, dateiname: string, authorization: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/UploadBilanzJRDatenBinA/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}/{format}/{importjahr}/{dateiname}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (importjahr === undefined || importjahr === null)
            throw new Error("The parameter 'importjahr' must be defined.");
        url_ = url_.replace("{importjahr}", encodeURIComponent("" + importjahr));
        if (dateiname === undefined || dateiname === null)
            throw new Error("The parameter 'dateiname' must be defined.");
        url_ = url_.replace("{dateiname}", encodeURIComponent("" + dateiname));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadBilanzJRDatenBinA(_response);
        });
    }

    protected processUploadBilanzJRDatenBinA(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadBilanzJRDatenBin(kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, format: number, importjahr: number, authorization: any | undefined): Promise<ImportHHDResult> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/UploadBilanzJRDatenBin/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}/{format}/{importjahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (importjahr === undefined || importjahr === null)
            throw new Error("The parameter 'importjahr' must be defined.");
        url_ = url_.replace("{importjahr}", encodeURIComponent("" + importjahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadBilanzJRDatenBin(_response);
        });
    }

    protected processUploadBilanzJRDatenBin(response: Response): Promise<ImportHHDResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportHHDResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportHHDResult>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadMassnahmenDatenBinA(kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, format: number, dateiname: string, authorization: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/UploadMassnahmenDatenBinA/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}/{format}/{dateiname}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (dateiname === undefined || dateiname === null)
            throw new Error("The parameter 'dateiname' must be defined.");
        url_ = url_.replace("{dateiname}", encodeURIComponent("" + dateiname));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadMassnahmenDatenBinA(_response);
        });
    }

    protected processUploadMassnahmenDatenBinA(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadMassnahmenDatenBin(kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, format: number, authorization: any | undefined): Promise<ImportHHDResult> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/UploadMassnahmenDatenBin/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}/{format}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadMassnahmenDatenBin(_response);
        });
    }

    protected processUploadMassnahmenDatenBin(response: Response): Promise<ImportHHDResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportHHDResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportHHDResult>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadMassnahmenJRDatenBinA(kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, format: number, importjahr: number, dateiname: string, authorization: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/UploadMassnahmenJRDatenBinA/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}/{format}/{importjahr}/{dateiname}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (importjahr === undefined || importjahr === null)
            throw new Error("The parameter 'importjahr' must be defined.");
        url_ = url_.replace("{importjahr}", encodeURIComponent("" + importjahr));
        if (dateiname === undefined || dateiname === null)
            throw new Error("The parameter 'dateiname' must be defined.");
        url_ = url_.replace("{dateiname}", encodeURIComponent("" + dateiname));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadMassnahmenJRDatenBinA(_response);
        });
    }

    protected processUploadMassnahmenJRDatenBinA(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadMassnahmenUHDatenBinA(kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, format: number, importjahr: number, dateiname: string, authorization: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/UploadMassnahmenUHDatenBinA/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}/{format}/{importjahr}/{dateiname}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (importjahr === undefined || importjahr === null)
            throw new Error("The parameter 'importjahr' must be defined.");
        url_ = url_.replace("{importjahr}", encodeURIComponent("" + importjahr));
        if (dateiname === undefined || dateiname === null)
            throw new Error("The parameter 'dateiname' must be defined.");
        url_ = url_.replace("{dateiname}", encodeURIComponent("" + dateiname));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadMassnahmenUHDatenBinA(_response);
        });
    }

    protected processUploadMassnahmenUHDatenBinA(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadMassnahmenJRDatenBin(kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, format: number, importjahr: number, authorization: any | undefined): Promise<ImportHHDResult> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/UploadMassnahmenJRDatenBin/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}/{format}/{importjahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (importjahr === undefined || importjahr === null)
            throw new Error("The parameter 'importjahr' must be defined.");
        url_ = url_.replace("{importjahr}", encodeURIComponent("" + importjahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadMassnahmenJRDatenBin(_response);
        });
    }

    protected processUploadMassnahmenJRDatenBin(response: Response): Promise<ImportHHDResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportHHDResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportHHDResult>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param fileData (optional) 
     * @param bundesland (optional) 
     * @return OK
     */
    uploadKontenplanTemplate(authorization: any | undefined, fileData: string | undefined, bundesland: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/UploadKontenplanTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileData === null || fileData === undefined)
            throw new Error("The parameter 'fileData' cannot be null.");
        else
            content_.append("fileData", fileData.toString());
        if (bundesland === null || bundesland === undefined)
            throw new Error("The parameter 'bundesland' cannot be null.");
        else
            content_.append("bundesland", bundesland.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadKontenplanTemplate(_response);
        });
    }

    protected processUploadKontenplanTemplate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param fileData (optional) 
     * @param bundesland (optional) 
     * @return OK
     */
    uploadProduktTemplate(authorization: any | undefined, fileData: string | undefined, bundesland: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/UploadProduktTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileData === null || fileData === undefined)
            throw new Error("The parameter 'fileData' cannot be null.");
        else
            content_.append("fileData", fileData.toString());
        if (bundesland === null || bundesland === undefined)
            throw new Error("The parameter 'bundesland' cannot be null.");
        else
            content_.append("bundesland", bundesland.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadProduktTemplate(_response);
        });
    }

    protected processUploadProduktTemplate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param fileData (optional) 
     * @return OK
     */
    addProdukte(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined, fileData: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/AddProdukte/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileData === null || fileData === undefined)
            throw new Error("The parameter 'fileData' cannot be null.");
        else
            content_.append("fileData", fileData.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddProdukte(_response);
        });
    }

    protected processAddProdukte(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setABCAnalysis(authorization: any | undefined, body: Abcanalyse | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/SetABCAnalysis";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetABCAnalysis(_response);
        });
    }

    protected processSetABCAnalysis(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getABCAnalysis(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<Abcanalyse> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetABCAnalysis/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetABCAnalysis(_response);
        });
    }

    protected processGetABCAnalysis(response: Response): Promise<Abcanalyse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Abcanalyse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Abcanalyse>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    overWriteBundeslandSettings(authorization: any | undefined, body: Bundeslaender | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/OverWriteBundeslandSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOverWriteBundeslandSettings(_response);
        });
    }

    protected processOverWriteBundeslandSettings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getBundesland(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<Bundeslaender> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetBundesland/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBundesland(_response);
        });
    }

    protected processGetBundesland(response: Response): Promise<Bundeslaender> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Bundeslaender.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Bundeslaender>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setTopEAsAnalysis(authorization: any | undefined, body: TopEa | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/SetTopEAsAnalysis";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetTopEAsAnalysis(_response);
        });
    }

    protected processSetTopEAsAnalysis(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getTopEAsAnalysis(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<TopEa> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetTopEAsAnalysis/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTopEAsAnalysis(_response);
        });
    }

    protected processGetTopEAsAnalysis(response: Response): Promise<TopEa> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TopEa.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TopEa>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setInvestSettings(authorization: any | undefined, body: InvestSettingModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/SetInvestSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetInvestSettings(_response);
        });
    }

    protected processSetInvestSettings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uploadFile(kunde: number, gemeinde: number, jahr: number, path: string, filename: string, authorization: any | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/UploadFile/{kunde}/{gemeinde}/{jahr}/{path}/{filename}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadFile(_response);
        });
    }

    protected processUploadFile(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyHaushaltsTemplate(authorization: any | undefined, body: HaushaltsTemplate | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/ModifyHaushaltsTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyHaushaltsTemplate(_response);
        });
    }

    protected processModifyHaushaltsTemplate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getHaushaltsTemplates(authorization: any | undefined): Promise<HaushaltsTemplate[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetHaushaltsTemplates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHaushaltsTemplates(_response);
        });
    }

    protected processGetHaushaltsTemplates(response: Response): Promise<HaushaltsTemplate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HaushaltsTemplate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsTemplate[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getEffectiveHaushaltsTemplate(kunde: number, gemeinde: number, jahr: number, typ: number, authorization: any | undefined): Promise<HaushaltsSummenTemplate> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetEffectiveHaushaltsTemplate/{kunde}/{gemeinde}/{jahr}/{typ}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (typ === undefined || typ === null)
            throw new Error("The parameter 'typ' must be defined.");
        url_ = url_.replace("{typ}", encodeURIComponent("" + typ));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEffectiveHaushaltsTemplate(_response);
        });
    }

    protected processGetEffectiveHaushaltsTemplate(response: Response): Promise<HaushaltsSummenTemplate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsSummenTemplate.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsSummenTemplate>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getHaushaltsTemplate(typ: number, bundesland: string, authorization: any | undefined): Promise<HaushaltsTemplate> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetHaushaltsTemplate/{typ}/{bundesland}";
        if (typ === undefined || typ === null)
            throw new Error("The parameter 'typ' must be defined.");
        url_ = url_.replace("{typ}", encodeURIComponent("" + typ));
        if (bundesland === undefined || bundesland === null)
            throw new Error("The parameter 'bundesland' must be defined.");
        url_ = url_.replace("{bundesland}", encodeURIComponent("" + bundesland));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHaushaltsTemplate(_response);
        });
    }

    protected processGetHaushaltsTemplate(response: Response): Promise<HaushaltsTemplate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsTemplate.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsTemplate>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeHaushaltsTemplate(authorization: any | undefined, body: HaushaltsTemplate | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/RemoveHaushaltsTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveHaushaltsTemplate(_response);
        });
    }

    protected processRemoveHaushaltsTemplate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addHaushaltsTemplate(authorization: any | undefined, body: HaushaltsTemplate | undefined): Promise<HaushaltsTemplate> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/AddHaushaltsTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddHaushaltsTemplate(_response);
        });
    }

    protected processAddHaushaltsTemplate(response: Response): Promise<HaushaltsTemplate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsTemplate.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsTemplate>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyHaushaltsTemplateOverride(authorization: any | undefined, body: HaushaltsTemplate | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/ModifyHaushaltsTemplateOverride";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyHaushaltsTemplateOverride(_response);
        });
    }

    protected processModifyHaushaltsTemplateOverride(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getHaushaltsTemplateOverrides(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<HaushaltsTemplate[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetHaushaltsTemplateOverrides/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHaushaltsTemplateOverrides(_response);
        });
    }

    protected processGetHaushaltsTemplateOverrides(response: Response): Promise<HaushaltsTemplate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HaushaltsTemplate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsTemplate[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getHaushaltsTemplateOverride(typ: number, kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<HaushaltsTemplate> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetHaushaltsTemplateOverride/{typ}/{kunde}/{gemeinde}/{jahr}";
        if (typ === undefined || typ === null)
            throw new Error("The parameter 'typ' must be defined.");
        url_ = url_.replace("{typ}", encodeURIComponent("" + typ));
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHaushaltsTemplateOverride(_response);
        });
    }

    protected processGetHaushaltsTemplateOverride(response: Response): Promise<HaushaltsTemplate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsTemplate.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsTemplate>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeHaushaltsTemplateOverride(authorization: any | undefined, body: HaushaltsTemplate | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/RemoveHaushaltsTemplateOverride";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveHaushaltsTemplateOverride(_response);
        });
    }

    protected processRemoveHaushaltsTemplateOverride(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addHaushaltsTemplateOverride(authorization: any | undefined, body: HaushaltsTemplate | undefined): Promise<HaushaltsTemplate> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/AddHaushaltsTemplateOverride";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddHaushaltsTemplateOverride(_response);
        });
    }

    protected processAddHaushaltsTemplateOverride(response: Response): Promise<HaushaltsTemplate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaushaltsTemplate.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HaushaltsTemplate>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getTemplatePlatzhalter(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<TemplatePlatzhalter[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetTemplatePlatzhalter/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTemplatePlatzhalter(_response);
        });
    }

    protected processGetTemplatePlatzhalter(response: Response): Promise<TemplatePlatzhalter[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplatePlatzhalter.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplatePlatzhalter[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setTemplatePlatzhalter(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined, body: TemplatePlatzhalter[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/SetTemplatePlatzhalter/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetTemplatePlatzhalter(_response);
        });
    }

    protected processSetTemplatePlatzhalter(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getTemplateZeilenInfo(kunde: number, gemeinde: number, jahr: number, typ: number, authorization: any | undefined): Promise<TemplateZeilenInfo[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetTemplateZeilenInfo/{kunde}/{gemeinde}/{jahr}/{typ}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (typ === undefined || typ === null)
            throw new Error("The parameter 'typ' must be defined.");
        url_ = url_.replace("{typ}", encodeURIComponent("" + typ));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTemplateZeilenInfo(_response);
        });
    }

    protected processGetTemplateZeilenInfo(response: Response): Promise<TemplateZeilenInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateZeilenInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateZeilenInfo[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setTemplateZeilenInfo(kunde: number, gemeinde: number, jahr: number, typ: number, authorization: any | undefined, body: TemplateZeilenInfo[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/SetTemplateZeilenInfo/{kunde}/{gemeinde}/{jahr}/{typ}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (typ === undefined || typ === null)
            throw new Error("The parameter 'typ' must be defined.");
        url_ = url_.replace("{typ}", encodeURIComponent("" + typ));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetTemplateZeilenInfo(_response);
        });
    }

    protected processSetTemplateZeilenInfo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    pushTemplateZeileninfo(authorization: any | undefined, body: PushTemplateZeileninfoModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/PushTemplateZeileninfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPushTemplateZeileninfo(_response);
        });
    }

    protected processPushTemplateZeileninfo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    testTemplatesByKunde(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<TemplateAbweichungenGemeinde> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/TestTemplatesByKunde/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTestTemplatesByKunde(_response);
        });
    }

    protected processTestTemplatesByKunde(response: Response): Promise<TemplateAbweichungenGemeinde> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemplateAbweichungenGemeinde.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateAbweichungenGemeinde>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    testTemplates(jahr: number, authorization: any | undefined): Promise<TemplateAbweichungenGemeinde[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/TestTemplates/{jahr}";
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTestTemplates(_response);
        });
    }

    protected processTestTemplates(response: Response): Promise<TemplateAbweichungenGemeinde[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateAbweichungenGemeinde.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateAbweichungenGemeinde[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getGlobalTemplateZeilenInfo(bundesland: string, typ: number, authorization: any | undefined): Promise<TemplateZeilenInfo[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetGlobalTemplateZeilenInfo/{bundesland}/{typ}";
        if (bundesland === undefined || bundesland === null)
            throw new Error("The parameter 'bundesland' must be defined.");
        url_ = url_.replace("{bundesland}", encodeURIComponent("" + bundesland));
        if (typ === undefined || typ === null)
            throw new Error("The parameter 'typ' must be defined.");
        url_ = url_.replace("{typ}", encodeURIComponent("" + typ));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetGlobalTemplateZeilenInfo(_response);
        });
    }

    protected processGetGlobalTemplateZeilenInfo(response: Response): Promise<TemplateZeilenInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateZeilenInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateZeilenInfo[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setGlobalTemplateZeilenInfo(bundesland: string, typ: number, authorization: any | undefined, body: TemplateZeilenInfo[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/SetGlobalTemplateZeilenInfo/{bundesland}/{typ}";
        if (bundesland === undefined || bundesland === null)
            throw new Error("The parameter 'bundesland' must be defined.");
        url_ = url_.replace("{bundesland}", encodeURIComponent("" + bundesland));
        if (typ === undefined || typ === null)
            throw new Error("The parameter 'typ' must be defined.");
        url_ = url_.replace("{typ}", encodeURIComponent("" + typ));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetGlobalTemplateZeilenInfo(_response);
        });
    }

    protected processSetGlobalTemplateZeilenInfo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    applyKontenTemplate(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/ApplyKontenTemplate/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApplyKontenTemplate(_response);
        });
    }

    protected processApplyKontenTemplate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    applyProduktTemplate(kunde: number, gemeinde: number, jahr: number, authorization: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/ApplyProduktTemplate/{kunde}/{gemeinde}/{jahr}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApplyProduktTemplate(_response);
        });
    }

    protected processApplyProduktTemplate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    duplicateSingleVBPlatzhalter(authorization: any | undefined, body: VBPlatzhalterDoppischModel | undefined): Promise<VBPlatzhalterDoppischModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/DuplicateSingleVBPlatzhalter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDuplicateSingleVBPlatzhalter(_response);
        });
    }

    protected processDuplicateSingleVBPlatzhalter(response: Response): Promise<VBPlatzhalterDoppischModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VBPlatzhalterDoppischModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VBPlatzhalterDoppischModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addVBPlatzhalter(jahr: number, authorization: any | undefined, body: VBPlatzhalterDoppischModel | undefined): Promise<VBPlatzhalterDoppischModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/AddVBPlatzhalter/{jahr}";
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddVBPlatzhalter(_response);
        });
    }

    protected processAddVBPlatzhalter(response: Response): Promise<VBPlatzhalterDoppischModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VBPlatzhalterDoppischModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VBPlatzhalterDoppischModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeVBPlatzhalter(authorization: any | undefined, body: VBPlatzhalterDoppischModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/RemoveVBPlatzhalter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveVBPlatzhalter(_response);
        });
    }

    protected processRemoveVBPlatzhalter(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyVBPlatzhalter(authorization: any | undefined, body: VBPlatzhalterDoppischModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/ModifyVBPlatzhalter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyVBPlatzhalter(_response);
        });
    }

    protected processModifyVBPlatzhalter(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addVBPlatzhalterUeberschreibung(kunde: number | undefined, gemeinde: number | undefined, authorization: any | undefined, body: VBPlatzhalterDoppischModel | undefined): Promise<VBDataDefinitionDoppisch[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/AddVBPlatzhalterUeberschreibung?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddVBPlatzhalterUeberschreibung(_response);
        });
    }

    protected processAddVBPlatzhalterUeberschreibung(response: Response): Promise<VBDataDefinitionDoppisch[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VBDataDefinitionDoppisch.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VBDataDefinitionDoppisch[]>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeVBPlatzhalterUeberschreibung(kunde: number | undefined, gemeinde: number | undefined, authorization: any | undefined, body: VBPlatzhalterDoppischModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/RemoveVBPlatzhalterUeberschreibung?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveVBPlatzhalterUeberschreibung(_response);
        });
    }

    protected processRemoveVBPlatzhalterUeberschreibung(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    modifyVBPlatzhalterUeberschreibung(kunde: number | undefined, gemeinde: number | undefined, authorization: any | undefined, body: VBPlatzhalterDoppischModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/ModifyVBPlatzhalterUeberschreibung?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processModifyVBPlatzhalterUeberschreibung(_response);
        });
    }

    protected processModifyVBPlatzhalterUeberschreibung(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    getVBPlatzhalterZuordnungen(kunde: number | undefined, gemeinde: number | undefined, authorization: any | undefined): Promise<VbplatzhalterZuordnungDoppisch[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetVBPlatzhalterZuordnungen?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVBPlatzhalterZuordnungen(_response);
        });
    }

    protected processGetVBPlatzhalterZuordnungen(response: Response): Promise<VbplatzhalterZuordnungDoppisch[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VbplatzhalterZuordnungDoppisch.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VbplatzhalterZuordnungDoppisch[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    addVBPlatzhalterZuordnung(authorization: any | undefined, body: VbplatzhalterZuordnungDoppisch | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/AddVBPlatzhalterZuordnung";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddVBPlatzhalterZuordnung(_response);
        });
    }

    protected processAddVBPlatzhalterZuordnung(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    removeVBPlatzhalterZuordnung(authorization: any | undefined, body: VbplatzhalterZuordnungDoppisch | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/RemoveVBPlatzhalterZuordnung";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveVBPlatzhalterZuordnung(_response);
        });
    }

    protected processRemoveVBPlatzhalterZuordnung(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param modul (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    removeAllVBPlatzhalter(kunde: number | undefined, gemeinde: number | undefined, modul: number | undefined, authorization: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/RemoveAllVBPlatzhalter?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (modul === null)
            throw new Error("The parameter 'modul' cannot be null.");
        else if (modul !== undefined)
            url_ += "modul=" + encodeURIComponent("" + modul) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveAllVBPlatzhalter(_response);
        });
    }

    protected processRemoveAllVBPlatzhalter(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getVBPlatzhalter(kunde: number, gemeinde: number, berichttyp: number, authorization: any | undefined): Promise<VBPlatzhalterDoppischModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetVBPlatzhalter/{kunde}/{gemeinde}/{berichttyp}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (berichttyp === undefined || berichttyp === null)
            throw new Error("The parameter 'berichttyp' must be defined.");
        url_ = url_.replace("{berichttyp}", encodeURIComponent("" + berichttyp));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVBPlatzhalter(_response);
        });
    }

    protected processGetVBPlatzhalter(response: Response): Promise<VBPlatzhalterDoppischModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VBPlatzhalterDoppischModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VBPlatzhalterDoppischModel[]>(null as any);
    }

    /**
     * @param berichttyp (optional) 
     * @param bundesland (optional) 
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    getSystemVBPlatzhalter(berichttyp: number | undefined, bundesland: string | undefined, kunde: number | undefined, gemeinde: number | undefined, authorization: any | undefined): Promise<VBPlatzhalterDoppischModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetSystemVBPlatzhalter?";
        if (berichttyp === null)
            throw new Error("The parameter 'berichttyp' cannot be null.");
        else if (berichttyp !== undefined)
            url_ += "berichttyp=" + encodeURIComponent("" + berichttyp) + "&";
        if (bundesland === null)
            throw new Error("The parameter 'bundesland' cannot be null.");
        else if (bundesland !== undefined)
            url_ += "bundesland=" + encodeURIComponent("" + bundesland) + "&";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSystemVBPlatzhalter(_response);
        });
    }

    protected processGetSystemVBPlatzhalter(response: Response): Promise<VBPlatzhalterDoppischModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VBPlatzhalterDoppischModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VBPlatzhalterDoppischModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    setBerichtsFarben2VBPlatzhalter(kunde: number, gemeinde: number, berichttyp: number, authorization: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/SetBerichtsFarben2VBPlatzhalter/{kunde}/{gemeinde}/{berichttyp}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (berichttyp === undefined || berichttyp === null)
            throw new Error("The parameter 'berichttyp' must be defined.");
        url_ = url_.replace("{berichttyp}", encodeURIComponent("" + berichttyp));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetBerichtsFarben2VBPlatzhalter(_response);
        });
    }

    protected processSetBerichtsFarben2VBPlatzhalter(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getVBFile(kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, filename: string, nurvorlage: boolean, plantypvgl: number, planstufevgl: number, planstufeJR: number, jahrJR: number, system: boolean, bundesland: string, authorization: any | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetVBFile/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}/{filename}/{nurvorlage}/{plantypvgl}/{planstufevgl}/{planstufeJR}/{jahrJR}/{system}/{bundesland}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        if (nurvorlage === undefined || nurvorlage === null)
            throw new Error("The parameter 'nurvorlage' must be defined.");
        url_ = url_.replace("{nurvorlage}", encodeURIComponent("" + nurvorlage));
        if (plantypvgl === undefined || plantypvgl === null)
            throw new Error("The parameter 'plantypvgl' must be defined.");
        url_ = url_.replace("{plantypvgl}", encodeURIComponent("" + plantypvgl));
        if (planstufevgl === undefined || planstufevgl === null)
            throw new Error("The parameter 'planstufevgl' must be defined.");
        url_ = url_.replace("{planstufevgl}", encodeURIComponent("" + planstufevgl));
        if (planstufeJR === undefined || planstufeJR === null)
            throw new Error("The parameter 'planstufeJR' must be defined.");
        url_ = url_.replace("{planstufeJR}", encodeURIComponent("" + planstufeJR));
        if (jahrJR === undefined || jahrJR === null)
            throw new Error("The parameter 'jahrJR' must be defined.");
        url_ = url_.replace("{jahrJR}", encodeURIComponent("" + jahrJR));
        if (system === undefined || system === null)
            throw new Error("The parameter 'system' must be defined.");
        url_ = url_.replace("{system}", encodeURIComponent("" + system));
        if (bundesland === undefined || bundesland === null)
            throw new Error("The parameter 'bundesland' must be defined.");
        url_ = url_.replace("{bundesland}", encodeURIComponent("" + bundesland));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVBFile(_response);
        });
    }

    protected processGetVBFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getLBFile(kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, filename: string, nurvorlage: boolean, system: boolean, bundesland: string, authorization: any | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetLBFile/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}/{filename}/{nurvorlage}/{system}/{bundesland}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        if (nurvorlage === undefined || nurvorlage === null)
            throw new Error("The parameter 'nurvorlage' must be defined.");
        url_ = url_.replace("{nurvorlage}", encodeURIComponent("" + nurvorlage));
        if (system === undefined || system === null)
            throw new Error("The parameter 'system' must be defined.");
        url_ = url_.replace("{system}", encodeURIComponent("" + system));
        if (bundesland === undefined || bundesland === null)
            throw new Error("The parameter 'bundesland' must be defined.");
        url_ = url_.replace("{bundesland}", encodeURIComponent("" + bundesland));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLBFile(_response);
        });
    }

    protected processGetLBFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getUniBFile(kunde: number, gemeinde: number, jahr: number, plantypHP: number, planstufeHP: number, plantypJR: number, planstufeJR: number, filename: string, nurvorlage: boolean, authorization: any | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetUniBFile/{kunde}/{gemeinde}/{jahr}/{plantypHP}/{planstufeHP}/{plantypJR}/{planstufeJR}/{filename}/{nurvorlage}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantypHP === undefined || plantypHP === null)
            throw new Error("The parameter 'plantypHP' must be defined.");
        url_ = url_.replace("{plantypHP}", encodeURIComponent("" + plantypHP));
        if (planstufeHP === undefined || planstufeHP === null)
            throw new Error("The parameter 'planstufeHP' must be defined.");
        url_ = url_.replace("{planstufeHP}", encodeURIComponent("" + planstufeHP));
        if (plantypJR === undefined || plantypJR === null)
            throw new Error("The parameter 'plantypJR' must be defined.");
        url_ = url_.replace("{plantypJR}", encodeURIComponent("" + plantypJR));
        if (planstufeJR === undefined || planstufeJR === null)
            throw new Error("The parameter 'planstufeJR' must be defined.");
        url_ = url_.replace("{planstufeJR}", encodeURIComponent("" + planstufeJR));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        if (nurvorlage === undefined || nurvorlage === null)
            throw new Error("The parameter 'nurvorlage' must be defined.");
        url_ = url_.replace("{nurvorlage}", encodeURIComponent("" + nurvorlage));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUniBFile(_response);
        });
    }

    protected processGetUniBFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getUHBFile(kunde: number, gemeinde: number, jahr: number, plantyp: number, planstufe: number, uhconfig: number, filename: string, nurvorlage: boolean, system: boolean, bundesland: string, authorization: any | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetUHBFile/{kunde}/{gemeinde}/{jahr}/{plantyp}/{planstufe}/{uhconfig}/{filename}/{nurvorlage}/{system}/{bundesland}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (uhconfig === undefined || uhconfig === null)
            throw new Error("The parameter 'uhconfig' must be defined.");
        url_ = url_.replace("{uhconfig}", encodeURIComponent("" + uhconfig));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        if (nurvorlage === undefined || nurvorlage === null)
            throw new Error("The parameter 'nurvorlage' must be defined.");
        url_ = url_.replace("{nurvorlage}", encodeURIComponent("" + nurvorlage));
        if (system === undefined || system === null)
            throw new Error("The parameter 'system' must be defined.");
        url_ = url_.replace("{system}", encodeURIComponent("" + system));
        if (bundesland === undefined || bundesland === null)
            throw new Error("The parameter 'bundesland' must be defined.");
        url_ = url_.replace("{bundesland}", encodeURIComponent("" + bundesland));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUHBFile(_response);
        });
    }

    protected processGetUHBFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param plantyp (optional) 
     * @param planstufe (optional) 
     * @param platzhalter (optional) 
     * @param plantypvgl (optional) 
     * @param planstufevgl (optional) 
     * @param bundesland (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    vBPlatzhalterVorschau(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, plantyp: number | undefined, planstufe: number | undefined, platzhalter: number | undefined, plantypvgl: number | undefined, planstufevgl: number | undefined, bundesland: string | undefined, authorization: any | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/VBPlatzhalterVorschau?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (plantyp === null)
            throw new Error("The parameter 'plantyp' cannot be null.");
        else if (plantyp !== undefined)
            url_ += "plantyp=" + encodeURIComponent("" + plantyp) + "&";
        if (planstufe === null)
            throw new Error("The parameter 'planstufe' cannot be null.");
        else if (planstufe !== undefined)
            url_ += "planstufe=" + encodeURIComponent("" + planstufe) + "&";
        if (platzhalter === null)
            throw new Error("The parameter 'platzhalter' cannot be null.");
        else if (platzhalter !== undefined)
            url_ += "platzhalter=" + encodeURIComponent("" + platzhalter) + "&";
        if (plantypvgl === null)
            throw new Error("The parameter 'plantypvgl' cannot be null.");
        else if (plantypvgl !== undefined)
            url_ += "plantypvgl=" + encodeURIComponent("" + plantypvgl) + "&";
        if (planstufevgl === null)
            throw new Error("The parameter 'planstufevgl' cannot be null.");
        else if (planstufevgl !== undefined)
            url_ += "planstufevgl=" + encodeURIComponent("" + planstufevgl) + "&";
        if (bundesland === null)
            throw new Error("The parameter 'bundesland' cannot be null.");
        else if (bundesland !== undefined)
            url_ += "bundesland=" + encodeURIComponent("" + bundesland) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVBPlatzhalterVorschau(_response);
        });
    }

    protected processVBPlatzhalterVorschau(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    migrateDataDefs(jahr: number, authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/MigrateDataDefs/{jahr}";
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMigrateDataDefs(_response);
        });
    }

    protected processMigrateDataDefs(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param plantyp (optional) 
     * @param planstufe (optional) 
     * @param platzhalter (optional) 
     * @param bundesland (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    lBPlatzhalterVorschau(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, plantyp: number | undefined, planstufe: number | undefined, platzhalter: number | undefined, bundesland: string | undefined, authorization: any | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/LBPlatzhalterVorschau?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (plantyp === null)
            throw new Error("The parameter 'plantyp' cannot be null.");
        else if (plantyp !== undefined)
            url_ += "plantyp=" + encodeURIComponent("" + plantyp) + "&";
        if (planstufe === null)
            throw new Error("The parameter 'planstufe' cannot be null.");
        else if (planstufe !== undefined)
            url_ += "planstufe=" + encodeURIComponent("" + planstufe) + "&";
        if (platzhalter === null)
            throw new Error("The parameter 'platzhalter' cannot be null.");
        else if (platzhalter !== undefined)
            url_ += "platzhalter=" + encodeURIComponent("" + platzhalter) + "&";
        if (bundesland === null)
            throw new Error("The parameter 'bundesland' cannot be null.");
        else if (bundesland !== undefined)
            url_ += "bundesland=" + encodeURIComponent("" + bundesland) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLBPlatzhalterVorschau(_response);
        });
    }

    protected processLBPlatzhalterVorschau(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    uniBPlatzhalterVorschau(kunde: number, gemeinde: number, jahr: number, plantypHP: number, planstufeHP: number, plantypJR: number, planstufeJR: number, platzhalter: number, authorization: any | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/UniBPlatzhalterVorschau/{kunde}/{gemeinde}/{jahr}/{plantypHP}/{planstufeHP}/{plantypJR}/{planstufeJR}/{platzhalter}";
        if (kunde === undefined || kunde === null)
            throw new Error("The parameter 'kunde' must be defined.");
        url_ = url_.replace("{kunde}", encodeURIComponent("" + kunde));
        if (gemeinde === undefined || gemeinde === null)
            throw new Error("The parameter 'gemeinde' must be defined.");
        url_ = url_.replace("{gemeinde}", encodeURIComponent("" + gemeinde));
        if (jahr === undefined || jahr === null)
            throw new Error("The parameter 'jahr' must be defined.");
        url_ = url_.replace("{jahr}", encodeURIComponent("" + jahr));
        if (plantypHP === undefined || plantypHP === null)
            throw new Error("The parameter 'plantypHP' must be defined.");
        url_ = url_.replace("{plantypHP}", encodeURIComponent("" + plantypHP));
        if (planstufeHP === undefined || planstufeHP === null)
            throw new Error("The parameter 'planstufeHP' must be defined.");
        url_ = url_.replace("{planstufeHP}", encodeURIComponent("" + planstufeHP));
        if (plantypJR === undefined || plantypJR === null)
            throw new Error("The parameter 'plantypJR' must be defined.");
        url_ = url_.replace("{plantypJR}", encodeURIComponent("" + plantypJR));
        if (planstufeJR === undefined || planstufeJR === null)
            throw new Error("The parameter 'planstufeJR' must be defined.");
        url_ = url_.replace("{planstufeJR}", encodeURIComponent("" + planstufeJR));
        if (platzhalter === undefined || platzhalter === null)
            throw new Error("The parameter 'platzhalter' must be defined.");
        url_ = url_.replace("{platzhalter}", encodeURIComponent("" + platzhalter));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUniBPlatzhalterVorschau(_response);
        });
    }

    protected processUniBPlatzhalterVorschau(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param plantyp (optional) 
     * @param planstufe (optional) 
     * @param uhconfig (optional) 
     * @param platzhalter (optional) 
     * @param bundesland (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    uHBPlatzhalterVorschau(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, plantyp: number | undefined, planstufe: number | undefined, uhconfig: number | undefined, platzhalter: number | undefined, bundesland: string | undefined, authorization: any | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/UHBPlatzhalterVorschau?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (plantyp === null)
            throw new Error("The parameter 'plantyp' cannot be null.");
        else if (plantyp !== undefined)
            url_ += "plantyp=" + encodeURIComponent("" + plantyp) + "&";
        if (planstufe === null)
            throw new Error("The parameter 'planstufe' cannot be null.");
        else if (planstufe !== undefined)
            url_ += "planstufe=" + encodeURIComponent("" + planstufe) + "&";
        if (uhconfig === null)
            throw new Error("The parameter 'uhconfig' cannot be null.");
        else if (uhconfig !== undefined)
            url_ += "uhconfig=" + encodeURIComponent("" + uhconfig) + "&";
        if (platzhalter === null)
            throw new Error("The parameter 'platzhalter' cannot be null.");
        else if (platzhalter !== undefined)
            url_ += "platzhalter=" + encodeURIComponent("" + platzhalter) + "&";
        if (bundesland === null)
            throw new Error("The parameter 'bundesland' cannot be null.");
        else if (bundesland !== undefined)
            url_ += "bundesland=" + encodeURIComponent("" + bundesland) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUHBPlatzhalterVorschau(_response);
        });
    }

    protected processUHBPlatzhalterVorschau(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    duplicateVAVT(bundeslandSrc: string, bundeslandDest: string, authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/DuplicateVAVT/{bundeslandSrc}/{bundeslandDest}";
        if (bundeslandSrc === undefined || bundeslandSrc === null)
            throw new Error("The parameter 'bundeslandSrc' must be defined.");
        url_ = url_.replace("{bundeslandSrc}", encodeURIComponent("" + bundeslandSrc));
        if (bundeslandDest === undefined || bundeslandDest === null)
            throw new Error("The parameter 'bundeslandDest' must be defined.");
        url_ = url_.replace("{bundeslandDest}", encodeURIComponent("" + bundeslandDest));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDuplicateVAVT(_response);
        });
    }

    protected processDuplicateVAVT(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param system (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    getUHPlatzhaltertypen(system: boolean | undefined, authorization: any | undefined): Promise<UhplatzhalterTypenDoppisch[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetUHPlatzhaltertypen?";
        if (system === null)
            throw new Error("The parameter 'system' cannot be null.");
        else if (system !== undefined)
            url_ += "system=" + encodeURIComponent("" + system) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUHPlatzhaltertypen(_response);
        });
    }

    protected processGetUHPlatzhaltertypen(response: Response): Promise<UhplatzhalterTypenDoppisch[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UhplatzhalterTypenDoppisch.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UhplatzhalterTypenDoppisch[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getUHPlatzhalterbetrachtungstypen(authorization: any | undefined): Promise<UhplatzhalterBetrachtungsTypenDoppisch[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetUHPlatzhalterbetrachtungstypen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUHPlatzhalterbetrachtungstypen(_response);
        });
    }

    protected processGetUHPlatzhalterbetrachtungstypen(response: Response): Promise<UhplatzhalterBetrachtungsTypenDoppisch[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UhplatzhalterBetrachtungsTypenDoppisch.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UhplatzhalterBetrachtungsTypenDoppisch[]>(null as any);
    }

    /**
     * @param system (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    getLBPlatzhaltertypen(system: boolean | undefined, authorization: any | undefined): Promise<LbplatzhalterTypenDoppisch[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetLBPlatzhaltertypen?";
        if (system === null)
            throw new Error("The parameter 'system' cannot be null.");
        else if (system !== undefined)
            url_ += "system=" + encodeURIComponent("" + system) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLBPlatzhaltertypen(_response);
        });
    }

    protected processGetLBPlatzhaltertypen(response: Response): Promise<LbplatzhalterTypenDoppisch[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LbplatzhalterTypenDoppisch.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LbplatzhalterTypenDoppisch[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getLBPlatzhalterbetrachtungstypen(authorization: any | undefined): Promise<LbplatzhalterBetrachtungsTypenDoppisch[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetLBPlatzhalterbetrachtungstypen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLBPlatzhalterbetrachtungstypen(_response);
        });
    }

    protected processGetLBPlatzhalterbetrachtungstypen(response: Response): Promise<LbplatzhalterBetrachtungsTypenDoppisch[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LbplatzhalterBetrachtungsTypenDoppisch.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LbplatzhalterBetrachtungsTypenDoppisch[]>(null as any);
    }

    /**
     * @param system (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    getVBPlatzhaltertypen(system: boolean | undefined, authorization: any | undefined): Promise<VbplatzhalterTypenDoppisch[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetVBPlatzhaltertypen?";
        if (system === null)
            throw new Error("The parameter 'system' cannot be null.");
        else if (system !== undefined)
            url_ += "system=" + encodeURIComponent("" + system) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVBPlatzhaltertypen(_response);
        });
    }

    protected processGetVBPlatzhaltertypen(response: Response): Promise<VbplatzhalterTypenDoppisch[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VbplatzhalterTypenDoppisch.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VbplatzhalterTypenDoppisch[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getVBPlatzhalterbetrachtungstypen(authorization: any | undefined): Promise<VbplatzhalterBetrachtungsTypenDoppisch[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetVBPlatzhalterbetrachtungstypen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVBPlatzhalterbetrachtungstypen(_response);
        });
    }

    protected processGetVBPlatzhalterbetrachtungstypen(response: Response): Promise<VbplatzhalterBetrachtungsTypenDoppisch[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VbplatzhalterBetrachtungsTypenDoppisch.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VbplatzhalterBetrachtungsTypenDoppisch[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getVBPlatzhalterjahre(authorization: any | undefined): Promise<VbplatzhalterJahre[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetVBPlatzhalterjahre";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVBPlatzhalterjahre(_response);
        });
    }

    protected processGetVBPlatzhalterjahre(response: Response): Promise<VbplatzhalterJahre[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VbplatzhalterJahre.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VbplatzhalterJahre[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getLBPlatzhalterjahre(authorization: any | undefined): Promise<LbplatzhalterJahre[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetLBPlatzhalterjahre";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLBPlatzhalterjahre(_response);
        });
    }

    protected processGetLBPlatzhalterjahre(response: Response): Promise<LbplatzhalterJahre[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LbplatzhalterJahre.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LbplatzhalterJahre[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getUHPlatzhalterjahre(authorization: any | undefined): Promise<UhplatzhalterJahre[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetUHPlatzhalterjahre";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUHPlatzhalterjahre(_response);
        });
    }

    protected processGetUHPlatzhalterjahre(response: Response): Promise<UhplatzhalterJahre[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UhplatzhalterJahre.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UhplatzhalterJahre[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getUniversalPlatzhaltertypen(authorization: any | undefined): Promise<UniversalPlatzhalterTypenDoppisch[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetUniversalPlatzhaltertypen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUniversalPlatzhaltertypen(_response);
        });
    }

    protected processGetUniversalPlatzhaltertypen(response: Response): Promise<UniversalPlatzhalterTypenDoppisch[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UniversalPlatzhalterTypenDoppisch.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UniversalPlatzhalterTypenDoppisch[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getUniversalPlatzhalterbetrachtungstypen(authorization: any | undefined): Promise<UniversalPlatzhalterBetrachtungsTypenDoppisch[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetUniversalPlatzhalterbetrachtungstypen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUniversalPlatzhalterbetrachtungstypen(_response);
        });
    }

    protected processGetUniversalPlatzhalterbetrachtungstypen(response: Response): Promise<UniversalPlatzhalterBetrachtungsTypenDoppisch[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UniversalPlatzhalterBetrachtungsTypenDoppisch.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UniversalPlatzhalterBetrachtungsTypenDoppisch[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getUniversalPlatzhalterjahre(authorization: any | undefined): Promise<UniversalPlatzhalterJahre[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetUniversalPlatzhalterjahre";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUniversalPlatzhalterjahre(_response);
        });
    }

    protected processGetUniversalPlatzhalterjahre(response: Response): Promise<UniversalPlatzhalterJahre[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UniversalPlatzhalterJahre.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UniversalPlatzhalterJahre[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setPlanVorschlagTerms(authorization: any | undefined, body: SetPlanVorschagTermsDoppischModel | undefined): Promise<HHSPlanDoppischModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/SetPlanVorschlagTerms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetPlanVorschlagTerms(_response);
        });
    }

    protected processSetPlanVorschlagTerms(response: Response): Promise<HHSPlanDoppischModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HHSPlanDoppischModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HHSPlanDoppischModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setMNPlanVorschlagTerms(authorization: any | undefined, body: SetPlanVorschagTermsDoppischModel | undefined): Promise<MNPlanDoppischModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/SetMNPlanVorschlagTerms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetMNPlanVorschlagTerms(_response);
        });
    }

    protected processSetMNPlanVorschlagTerms(response: Response): Promise<MNPlanDoppischModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MNPlanDoppischModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MNPlanDoppischModel[]>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param plantyp (optional) 
     * @param planstufe (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    getVorschlagsTerms(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, plantyp: number | undefined, planstufe: number | undefined, authorization: any | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetVorschlagsTerms?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (plantyp === null)
            throw new Error("The parameter 'plantyp' cannot be null.");
        else if (plantyp !== undefined)
            url_ += "plantyp=" + encodeURIComponent("" + plantyp) + "&";
        if (planstufe === null)
            throw new Error("The parameter 'planstufe' cannot be null.");
        else if (planstufe !== undefined)
            url_ += "planstufe=" + encodeURIComponent("" + planstufe) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVorschlagsTerms(_response);
        });
    }

    protected processGetVorschlagsTerms(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getHHSPlan(plantyp: number, planstufe: number, authorization: any | undefined, body: JahrModel | undefined): Promise<HHSPlanDoppischModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetHHSPlan/{plantyp}/{planstufe}";
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHHSPlan(_response);
        });
    }

    protected processGetHHSPlan(response: Response): Promise<HHSPlanDoppischModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HHSPlanDoppischModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HHSPlanDoppischModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getSingleHHSPlan(plantyp: number, planstufe: number, authorization: any | undefined, body: HHSPlanDoppischModel | undefined): Promise<HHSPlanDoppischModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetSingleHHSPlan/{plantyp}/{planstufe}";
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSingleHHSPlan(_response);
        });
    }

    protected processGetSingleHHSPlan(response: Response): Promise<HHSPlanDoppischModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HHSPlanDoppischModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HHSPlanDoppischModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setHHSPlan(plantyp: number, planstufe: number, authorization: any | undefined, body: HHSPlanDoppischModel | undefined): Promise<HHSPlanDoppischModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/SetHHSPlan/{plantyp}/{planstufe}";
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetHHSPlan(_response);
        });
    }

    protected processSetHHSPlan(response: Response): Promise<HHSPlanDoppischModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HHSPlanDoppischModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HHSPlanDoppischModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    setMNPlan(plantyp: number, planstufe: number, authorization: any | undefined, body: MNPlanDoppischModel | undefined): Promise<MNPlanDoppischModel> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/SetMNPlan/{plantyp}/{planstufe}";
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetMNPlan(_response);
        });
    }

    protected processSetMNPlan(response: Response): Promise<MNPlanDoppischModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MNPlanDoppischModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MNPlanDoppischModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    calcPlan(authorization: any | undefined, body: CalcPlanDoppischModel | undefined): Promise<HHSPlanDoppischModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/CalcPlan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCalcPlan(_response);
        });
    }

    protected processCalcPlan(response: Response): Promise<HHSPlanDoppischModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HHSPlanDoppischModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HHSPlanDoppischModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    calcPlanByTimeGen(authorization: any | undefined, body: CalcPlanDoppischModel | undefined): Promise<HHSPlanDoppischModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/CalcPlanByTimeGen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCalcPlanByTimeGen(_response);
        });
    }

    protected processCalcPlanByTimeGen(response: Response): Promise<HHSPlanDoppischModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HHSPlanDoppischModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HHSPlanDoppischModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    startCalcPlanByTimeGen(authorization: any | undefined, body: CalcPlanDoppischModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/StartCalcPlanByTimeGen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStartCalcPlanByTimeGen(_response);
        });
    }

    protected processStartCalcPlanByTimeGen(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    getJobStatus(id: number, authorization: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/GetJobStatus/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJobStatus(_response);
        });
    }

    protected processGetJobStatus(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    calcMNPlan(authorization: any | undefined, body: CalcPlanDoppischModel | undefined): Promise<MNPlanDoppischModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/CalcMNPlan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCalcMNPlan(_response);
        });
    }

    protected processCalcMNPlan(response: Response): Promise<MNPlanDoppischModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MNPlanDoppischModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MNPlanDoppischModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    calcMNPlanByTimeGen(authorization: any | undefined, body: CalcPlanDoppischModel | undefined): Promise<MNPlanDoppischModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/CalcMNPlanByTimeGen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCalcMNPlanByTimeGen(_response);
        });
    }

    protected processCalcMNPlanByTimeGen(response: Response): Promise<MNPlanDoppischModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MNPlanDoppischModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MNPlanDoppischModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    startCalcMNPlanByTimeGen(authorization: any | undefined, body: CalcPlanDoppischModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/StartCalcMNPlanByTimeGen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStartCalcMNPlanByTimeGen(_response);
        });
    }

    protected processStartCalcMNPlanByTimeGen(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    restoreHHSPlan(plantyp: number, planstufe: number, authorization: any | undefined, body: HHSPlanDoppischModel[] | undefined): Promise<HHSPlanDoppischModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/RestoreHHSPlan/{plantyp}/{planstufe}";
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRestoreHHSPlan(_response);
        });
    }

    protected processRestoreHHSPlan(response: Response): Promise<HHSPlanDoppischModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HHSPlanDoppischModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HHSPlanDoppischModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateHHSPlan(plantyp: number, planstufe: number, jobid: number, authorization: any | undefined, body: HHSPlanDoppischModel[] | undefined): Promise<HHSPlanDoppischModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/UpdateHHSPlan/{plantyp}/{planstufe}/{jobid}";
        if (plantyp === undefined || plantyp === null)
            throw new Error("The parameter 'plantyp' must be defined.");
        url_ = url_.replace("{plantyp}", encodeURIComponent("" + plantyp));
        if (planstufe === undefined || planstufe === null)
            throw new Error("The parameter 'planstufe' must be defined.");
        url_ = url_.replace("{planstufe}", encodeURIComponent("" + planstufe));
        if (jobid === undefined || jobid === null)
            throw new Error("The parameter 'jobid' must be defined.");
        url_ = url_.replace("{jobid}", encodeURIComponent("" + jobid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateHHSPlan(_response);
        });
    }

    protected processUpdateHHSPlan(response: Response): Promise<HHSPlanDoppischModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HHSPlanDoppischModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HHSPlanDoppischModel[]>(null as any);
    }

    /**
     * @param plantyp (optional) 
     * @param planstufe (optional) 
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    applyVorschlagswerte(plantyp: number | undefined, planstufe: number | undefined, authorization: any | undefined, body: HHSPlanDoppischModel[] | undefined): Promise<HHSPlanDoppischModel[]> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/ApplyVorschlagswerte?";
        if (plantyp === null)
            throw new Error("The parameter 'plantyp' cannot be null.");
        else if (plantyp !== undefined)
            url_ += "plantyp=" + encodeURIComponent("" + plantyp) + "&";
        if (planstufe === null)
            throw new Error("The parameter 'planstufe' cannot be null.");
        else if (planstufe !== undefined)
            url_ += "planstufe=" + encodeURIComponent("" + planstufe) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApplyVorschlagswerte(_response);
        });
    }

    protected processApplyVorschlagswerte(response: Response): Promise<HHSPlanDoppischModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HHSPlanDoppischModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HHSPlanDoppischModel[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    exportHHSP(authorization: any | undefined, body: ExportPlanDoppischModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DigitalHousholdDoppikAdmin/ExportHHSP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportHHSP(_response);
        });
    }

    protected processExportHHSP(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class Kennzahlenvergleich_Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param kreis (optional) 
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    saveUserSettings(kreis: number | undefined, authorization: any | undefined, body: UserKennzahlenVglSettingsModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/kennzahlenvergleich/SaveUserSettings?";
        if (kreis === null)
            throw new Error("The parameter 'kreis' cannot be null.");
        else if (kreis !== undefined)
            url_ += "kreis=" + encodeURIComponent("" + kreis) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveUserSettings(_response);
        });
    }

    protected processSaveUserSettings(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param vgljahr (optional) 
     * @param kundeReq (optional) 
     * @param kreis (optional) 
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    exportKennzahlenVergleich(vgljahr: number | undefined, kundeReq: number | undefined, kreis: number | undefined, authorization: any | undefined, body: UserKennzahlenVglSettingsModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/kennzahlenvergleich/ExportKennzahlenVergleich?";
        if (vgljahr === null)
            throw new Error("The parameter 'vgljahr' cannot be null.");
        else if (vgljahr !== undefined)
            url_ += "vgljahr=" + encodeURIComponent("" + vgljahr) + "&";
        if (kundeReq === null)
            throw new Error("The parameter 'kundeReq' cannot be null.");
        else if (kundeReq !== undefined)
            url_ += "kundeReq=" + encodeURIComponent("" + kundeReq) + "&";
        if (kreis === null)
            throw new Error("The parameter 'kreis' cannot be null.");
        else if (kreis !== undefined)
            url_ += "kreis=" + encodeURIComponent("" + kreis) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportKennzahlenVergleich(_response);
        });
    }

    protected processExportKennzahlenVergleich(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param vgljahr (optional) 
     * @param kundeReq (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    getKennzahlenVergleich(vgljahr: number | undefined, kundeReq: number | undefined, authorization: any | undefined): Promise<KennzahlenVergleichModel> {
        let url_ = this.baseUrl + "/api/kennzahlenvergleich/GetKennzahlenVergleich?";
        if (vgljahr === null)
            throw new Error("The parameter 'vgljahr' cannot be null.");
        else if (vgljahr !== undefined)
            url_ += "vgljahr=" + encodeURIComponent("" + vgljahr) + "&";
        if (kundeReq === null)
            throw new Error("The parameter 'kundeReq' cannot be null.");
        else if (kundeReq !== undefined)
            url_ += "kundeReq=" + encodeURIComponent("" + kundeReq) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetKennzahlenVergleich(_response);
        });
    }

    protected processGetKennzahlenVergleich(response: Response): Promise<KennzahlenVergleichModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KennzahlenVergleichModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KennzahlenVergleichModel>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param plantyp (optional) 
     * @param planstufe (optional) 
     * @param kennzahl (optional) 
     * @param buchungsart (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    getKennzahl(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, plantyp: number | undefined, planstufe: number | undefined, kennzahl: number | undefined, buchungsart: number | undefined, authorization: any | undefined): Promise<KennzahlModel> {
        let url_ = this.baseUrl + "/api/kennzahlenvergleich/GetKennzahl?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (plantyp === null)
            throw new Error("The parameter 'plantyp' cannot be null.");
        else if (plantyp !== undefined)
            url_ += "plantyp=" + encodeURIComponent("" + plantyp) + "&";
        if (planstufe === null)
            throw new Error("The parameter 'planstufe' cannot be null.");
        else if (planstufe !== undefined)
            url_ += "planstufe=" + encodeURIComponent("" + planstufe) + "&";
        if (kennzahl === null)
            throw new Error("The parameter 'kennzahl' cannot be null.");
        else if (kennzahl !== undefined)
            url_ += "kennzahl=" + encodeURIComponent("" + kennzahl) + "&";
        if (buchungsart === null)
            throw new Error("The parameter 'buchungsart' cannot be null.");
        else if (buchungsart !== undefined)
            url_ += "buchungsart=" + encodeURIComponent("" + buchungsart) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetKennzahl(_response);
        });
    }

    protected processGetKennzahl(response: Response): Promise<KennzahlModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KennzahlModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KennzahlModel>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    setKommunentypen(authorization: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/kennzahlenvergleich/SetKommunentypen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetKommunentypen(_response);
        });
    }

    protected processSetKommunentypen(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class Sdg_Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    ebenen(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, authorization: any | undefined): Promise<SdgEbeneDto[]> {
        let url_ = this.baseUrl + "/api/sdg/ebenen?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEbenen(_response);
        });
    }

    protected processEbenen(response: Response): Promise<SdgEbeneDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SdgEbeneDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdgEbeneDto[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    ebenePost(authorization: any | undefined, body: SdgEbeneDto | undefined): Promise<SdgEbeneDto> {
        let url_ = this.baseUrl + "/api/sdg/ebene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEbenePost(_response);
        });
    }

    protected processEbenePost(response: Response): Promise<SdgEbeneDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdgEbeneDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdgEbeneDto>(null as any);
    }

    /**
     * @return No Content
     */
    ebeneDelete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/sdg/ebene/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEbeneDelete(_response);
        });
    }

    protected processEbeneDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    indikatoren(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, authorization: any | undefined): Promise<SdgIndikatorDto[]> {
        let url_ = this.baseUrl + "/api/sdg/indikatoren?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIndikatoren(_response);
        });
    }

    protected processIndikatoren(response: Response): Promise<SdgIndikatorDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SdgIndikatorDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdgIndikatorDto[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    indikatorPost(authorization: any | undefined, body: SdgIndikatorDto | undefined): Promise<SdgIndikatorDto> {
        let url_ = this.baseUrl + "/api/sdg/indikator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIndikatorPost(_response);
        });
    }

    protected processIndikatorPost(response: Response): Promise<SdgIndikatorDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdgIndikatorDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdgIndikatorDto>(null as any);
    }

    /**
     * @param grundzahlen (optional) 
     * @return OK
     */
    indikatorDelete(id: number, grundzahlen: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/sdg/indikator/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (grundzahlen === null)
            throw new Error("The parameter 'grundzahlen' cannot be null.");
        else if (grundzahlen !== undefined)
            url_ += "grundzahlen=" + encodeURIComponent("" + grundzahlen) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIndikatorDelete(_response);
        });
    }

    protected processIndikatorDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    cleanupWaisen(kunde: number | undefined, gemeinde: number | undefined, authorization: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/sdg/cleanup-waisen?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCleanupWaisen(_response);
        });
    }

    protected processCleanupWaisen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    repariereEingaben(kunde: number | undefined, gemeinde: number | undefined, authorization: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/sdg/repariere-eingaben?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRepariereEingaben(_response);
        });
    }

    protected processRepariereEingaben(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    katalog(authorization: any | undefined): Promise<SdgMasterIndikator[]> {
        let url_ = this.baseUrl + "/api/sdg/katalog";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKatalog(_response);
        });
    }

    protected processKatalog(response: Response): Promise<SdgMasterIndikator[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SdgMasterIndikator.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdgMasterIndikator[]>(null as any);
    }

    /**
     * @param indikatorNr (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    katalogEingaben(indikatorNr: number | undefined, authorization: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/sdg/katalog-eingaben?";
        if (indikatorNr === null)
            throw new Error("The parameter 'indikatorNr' cannot be null.");
        else if (indikatorNr !== undefined)
            url_ += "indikatorNr=" + encodeURIComponent("" + indikatorNr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKatalogEingaben(_response);
        });
    }

    protected processKatalogEingaben(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    indikatorAusKatalog(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, authorization: any | undefined, body: SdgPickItemDto[] | undefined): Promise<SdgIndikatorDto[]> {
        let url_ = this.baseUrl + "/api/sdg/indikator-aus-katalog?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIndikatorAusKatalog(_response);
        });
    }

    protected processIndikatorAusKatalog(response: Response): Promise<SdgIndikatorDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SdgIndikatorDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdgIndikatorDto[]>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    grundzahlKandidaten(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, authorization: any | undefined): Promise<SdgGrundzahlKandidatDto[]> {
        let url_ = this.baseUrl + "/api/sdg/grundzahl-kandidaten?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGrundzahlKandidaten(_response);
        });
    }

    protected processGrundzahlKandidaten(response: Response): Promise<SdgGrundzahlKandidatDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SdgGrundzahlKandidatDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdgGrundzahlKandidatDto[]>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    verknuepfteGrundzahlen(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, authorization: any | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/api/sdg/verknuepfte-grundzahlen?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVerknuepfteGrundzahlen(_response);
        });
    }

    protected processVerknuepfteGrundzahlen(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    report(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, authorization: any | undefined): Promise<SdgReportDto> {
        let url_ = this.baseUrl + "/api/sdg/report?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReport(_response);
        });
    }

    protected processReport(response: Response): Promise<SdgReportDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdgReportDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdgReportDto>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    wappen(kunde: number | undefined, gemeinde: number | undefined, authorization: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/sdg/wappen?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWappen(_response);
        });
    }

    protected processWappen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param suche (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    wappenSuche(kunde: number | undefined, gemeinde: number | undefined, suche: string | undefined, authorization: any | undefined): Promise<SdgWappenSucheDto> {
        let url_ = this.baseUrl + "/api/sdg/wappen-suche?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (suche === null)
            throw new Error("The parameter 'suche' cannot be null.");
        else if (suche !== undefined)
            url_ += "suche=" + encodeURIComponent("" + suche) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWappenSuche(_response);
        });
    }

    protected processWappenSuche(response: Response): Promise<SdgWappenSucheDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdgWappenSucheDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdgWappenSucheDto>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    wappenUebernehmen(authorization: any | undefined, body: SdgWappenUebernahmeDto | undefined): Promise<SdgWappenInfoDto> {
        let url_ = this.baseUrl + "/api/sdg/wappen-uebernehmen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWappenUebernehmen(_response);
        });
    }

    protected processWappenUebernehmen(response: Response): Promise<SdgWappenInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdgWappenInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdgWappenInfoDto>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    wappenAutomatisch(kunde: number | undefined, gemeinde: number | undefined, authorization: any | undefined): Promise<SdgWappenInfoDto> {
        let url_ = this.baseUrl + "/api/sdg/wappen-automatisch?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWappenAutomatisch(_response);
        });
    }

    protected processWappenAutomatisch(response: Response): Promise<SdgWappenInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdgWappenInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("No Content", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdgWappenInfoDto>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param authorization (optional) 
     * @return No Content
     */
    wappenVerwerfen(kunde: number | undefined, gemeinde: number | undefined, authorization: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/sdg/wappen-verwerfen?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWappenVerwerfen(_response);
        });
    }

    protected processWappenVerwerfen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param rechts (optional) 
     * @param authorization (optional) 
     * @return No Content
     */
    wappenAnordnung(kunde: number | undefined, gemeinde: number | undefined, rechts: boolean | undefined, authorization: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/sdg/wappen-anordnung?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (rechts === null)
            throw new Error("The parameter 'rechts' cannot be null.");
        else if (rechts !== undefined)
            url_ += "rechts=" + encodeURIComponent("" + rechts) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWappenAnordnung(_response);
        });
    }

    protected processWappenAnordnung(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param bild (optional) 
     * @param authorization (optional) 
     * @return No Content
     */
    wappenAlternative(kunde: number | undefined, gemeinde: number | undefined, bild: string | undefined, authorization: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/sdg/wappen-alternative?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (bild === null)
            throw new Error("The parameter 'bild' cannot be null.");
        else if (bild !== undefined)
            url_ += "bild=" + encodeURIComponent("" + bild) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWappenAlternative(_response);
        });
    }

    protected processWappenAlternative(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    konfigGet(kunde: number | undefined, gemeinde: number | undefined, authorization: any | undefined): Promise<SdgKonfigDto> {
        let url_ = this.baseUrl + "/api/sdg/konfig?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKonfigGet(_response);
        });
    }

    protected processKonfigGet(response: Response): Promise<SdgKonfigDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdgKonfigDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdgKonfigDto>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    konfigPost(authorization: any | undefined, body: SdgKonfigDto | undefined): Promise<SdgKonfigDto> {
        let url_ = this.baseUrl + "/api/sdg/konfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKonfigPost(_response);
        });
    }

    protected processKonfigPost(response: Response): Promise<SdgKonfigDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdgKonfigDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdgKonfigDto>(null as any);
    }

    /**
     * @param name (optional) 
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    praesentationZugang(name: string | undefined, kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, authorization: any | undefined): Promise<SdgPraesentationZugangDto> {
        let url_ = this.baseUrl + "/api/sdg/praesentation-zugang?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPraesentationZugang(_response);
        });
    }

    protected processPraesentationZugang(response: Response): Promise<SdgPraesentationZugangDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdgPraesentationZugangDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdgPraesentationZugangDto>(null as any);
    }

    /**
     * @param name (optional) 
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    praesentationReport(name: string | undefined, kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, authorization: any | undefined): Promise<SdgReportDto> {
        let url_ = this.baseUrl + "/api/sdg/praesentation-report?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPraesentationReport(_response);
        });
    }

    protected processPraesentationReport(response: Response): Promise<SdgReportDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdgReportDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdgReportDto>(null as any);
    }

    /**
     * @param name (optional) 
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    praesentationKopf(name: string | undefined, kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, authorization: any | undefined): Promise<SdgKopfDto> {
        let url_ = this.baseUrl + "/api/sdg/praesentation-kopf?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPraesentationKopf(_response);
        });
    }

    protected processPraesentationKopf(response: Response): Promise<SdgKopfDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdgKopfDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdgKopfDto>(null as any);
    }

    /**
     * @param name (optional) 
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param quelle (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    praesentationWappen(name: string | undefined, kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, quelle: string | undefined, authorization: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/sdg/praesentation-wappen?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (quelle === null)
            throw new Error("The parameter 'quelle' cannot be null.");
        else if (quelle !== undefined)
            url_ += "quelle=" + encodeURIComponent("" + quelle) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPraesentationWappen(_response);
        });
    }

    protected processPraesentationWappen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param name (optional) 
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param ids (optional) 
     * @param reihenfolge (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    praesentationWord(name: string | undefined, kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, ids: string | undefined, reihenfolge: string | undefined, authorization: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/sdg/praesentation-word?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            url_ += "ids=" + encodeURIComponent("" + ids) + "&";
        if (reihenfolge === null)
            throw new Error("The parameter 'reihenfolge' cannot be null.");
        else if (reihenfolge !== undefined)
            url_ += "reihenfolge=" + encodeURIComponent("" + reihenfolge) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPraesentationWord(_response);
        });
    }

    protected processPraesentationWord(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param name (optional) 
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param ids (optional) 
     * @param reihenfolge (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    praesentationPdf(name: string | undefined, kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, ids: string | undefined, reihenfolge: string | undefined, authorization: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/sdg/praesentation-pdf?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            url_ += "ids=" + encodeURIComponent("" + ids) + "&";
        if (reihenfolge === null)
            throw new Error("The parameter 'reihenfolge' cannot be null.");
        else if (reihenfolge !== undefined)
            url_ += "reihenfolge=" + encodeURIComponent("" + reihenfolge) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPraesentationPdf(_response);
        });
    }

    protected processPraesentationPdf(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param kurzname (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    praesentationFreigabe(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, kurzname: string | undefined, authorization: any | undefined): Promise<SdgKonfigDto> {
        let url_ = this.baseUrl + "/api/sdg/praesentation-freigabe?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (kurzname === null)
            throw new Error("The parameter 'kurzname' cannot be null.");
        else if (kurzname !== undefined)
            url_ += "kurzname=" + encodeURIComponent("" + kurzname) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPraesentationFreigabe(_response);
        });
    }

    protected processPraesentationFreigabe(response: Response): Promise<SdgKonfigDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdgKonfigDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdgKonfigDto>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param name (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    praesentationKurzname(kunde: number | undefined, gemeinde: number | undefined, name: string | undefined, authorization: any | undefined): Promise<SdgKonfigDto> {
        let url_ = this.baseUrl + "/api/sdg/praesentation-kurzname?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPraesentationKurzname(_response);
        });
    }

    protected processPraesentationKurzname(response: Response): Promise<SdgKonfigDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdgKonfigDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdgKonfigDto>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    vorlagen(kunde: number | undefined, gemeinde: number | undefined, authorization: any | undefined): Promise<SdgBerichtVorlageDto[]> {
        let url_ = this.baseUrl + "/api/sdg/vorlagen?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVorlagen(_response);
        });
    }

    protected processVorlagen(response: Response): Promise<SdgBerichtVorlageDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SdgBerichtVorlageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdgBerichtVorlageDto[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    vorlagePost(authorization: any | undefined, body: SdgBerichtVorlageDto | undefined): Promise<SdgBerichtVorlageDto> {
        let url_ = this.baseUrl + "/api/sdg/vorlage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVorlagePost(_response);
        });
    }

    protected processVorlagePost(response: Response): Promise<SdgBerichtVorlageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdgBerichtVorlageDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdgBerichtVorlageDto>(null as any);
    }

    /**
     * @return No Content
     */
    vorlageDelete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/sdg/vorlage/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVorlageDelete(_response);
        });
    }

    protected processVorlageDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    eingabewerte(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, authorization: any | undefined): Promise<SdgEingabewertZeileDto[]> {
        let url_ = this.baseUrl + "/api/sdg/eingabewerte?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEingabewerte(_response);
        });
    }

    protected processEingabewerte(response: Response): Promise<SdgEingabewertZeileDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SdgEingabewertZeileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdgEingabewertZeileDto[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    eingabewert(authorization: any | undefined, body: SdgEingabewertSaveDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/sdg/eingabewert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEingabewert(_response);
        });
    }

    protected processEingabewert(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    eingabewertEinheit(authorization: any | undefined, body: SdgEingabewertSaveDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/sdg/eingabewert-einheit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEingabewertEinheit(_response);
        });
    }

    protected processEingabewertEinheit(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    eingabewertLink(authorization: any | undefined, body: SdgEingabewertLinkDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/sdg/eingabewert-link";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEingabewertLink(_response);
        });
    }

    protected processEingabewertLink(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class Master_Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    promote(sdgIndikatorId: number, authorization: any | undefined): Promise<SdgMasterIndikator> {
        let url_ = this.baseUrl + "/api/sdg/master/promote/{sdgIndikatorId}";
        if (sdgIndikatorId === undefined || sdgIndikatorId === null)
            throw new Error("The parameter 'sdgIndikatorId' must be defined.");
        url_ = url_.replace("{sdgIndikatorId}", encodeURIComponent("" + sdgIndikatorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPromote(_response);
        });
    }

    protected processPromote(response: Response): Promise<SdgMasterIndikator> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdgMasterIndikator.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdgMasterIndikator>(null as any);
    }
}

export class Report_Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param ids (optional) 
     * @param reihenfolge (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    word(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, ids: string | undefined, reihenfolge: string | undefined, authorization: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/sdg/report/word?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            url_ += "ids=" + encodeURIComponent("" + ids) + "&";
        if (reihenfolge === null)
            throw new Error("The parameter 'reihenfolge' cannot be null.");
        else if (reihenfolge !== undefined)
            url_ += "reihenfolge=" + encodeURIComponent("" + reihenfolge) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWord(_response);
        });
    }

    protected processWord(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param ids (optional) 
     * @param reihenfolge (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    pdf(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, ids: string | undefined, reihenfolge: string | undefined, authorization: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/sdg/report/pdf?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            url_ += "ids=" + encodeURIComponent("" + ids) + "&";
        if (reihenfolge === null)
            throw new Error("The parameter 'reihenfolge' cannot be null.");
        else if (reihenfolge !== undefined)
            url_ += "reihenfolge=" + encodeURIComponent("" + reihenfolge) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPdf(_response);
        });
    }

    protected processPdf(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class Eingabewert_Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    werteLoeschen(authorization: any | undefined, body: SdgEingabewertSaveDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/sdg/eingabewert/werte-loeschen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWerteLoeschen(_response);
        });
    }

    protected processWerteLoeschen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class Wegweiser_Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    gemeinden(authorization: any | undefined): Promise<GemeindeDto[]> {
        let url_ = this.baseUrl + "/api/wegweiser/gemeinden";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGemeinden(_response);
        });
    }

    protected processGemeinden(response: Response): Promise<GemeindeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GemeindeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GemeindeDto[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    indikatoren(authorization: any | undefined): Promise<IndikatorDto[]> {
        let url_ = this.baseUrl + "/api/wegweiser/indikatoren";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIndikatoren(_response);
        });
    }

    protected processIndikatoren(response: Response): Promise<IndikatorDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IndikatorDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IndikatorDto[]>(null as any);
    }

    /**
     * @param datensatzId (optional) 
     * @param overwrite (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    syncIndikatorDaten(datensatzId: number | undefined, overwrite: boolean | undefined, authorization: any | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/wegweiser/syncIndikatorDaten?";
        if (datensatzId === null)
            throw new Error("The parameter 'datensatzId' cannot be null.");
        else if (datensatzId !== undefined)
            url_ += "datensatzId=" + encodeURIComponent("" + datensatzId) + "&";
        if (overwrite === null)
            throw new Error("The parameter 'overwrite' cannot be null.");
        else if (overwrite !== undefined)
            url_ += "overwrite=" + encodeURIComponent("" + overwrite) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSyncIndikatorDaten(_response);
        });
    }

    protected processSyncIndikatorDaten(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param overwrite (optional) 
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    getSyncedIndikatorDaten(overwrite: boolean | undefined, authorization: any | undefined, body: Datensaetze | undefined): Promise<Daten[]> {
        let url_ = this.baseUrl + "/api/wegweiser/getSyncedIndikatorDaten?";
        if (overwrite === null)
            throw new Error("The parameter 'overwrite' cannot be null.");
        else if (overwrite !== undefined)
            url_ += "overwrite=" + encodeURIComponent("" + overwrite) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSyncedIndikatorDaten(_response);
        });
    }

    protected processGetSyncedIndikatorDaten(response: Response): Promise<Daten[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Daten.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Daten[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    syncGemeinden(authorization: any | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/wegweiser/syncGemeinden";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSyncGemeinden(_response);
        });
    }

    protected processSyncGemeinden(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    syncGemeinde(kunde: number | undefined, gemeinde: number | undefined, authorization: any | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/wegweiser/syncGemeinde?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSyncGemeinde(_response);
        });
    }

    protected processSyncGemeinde(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param search (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    getWegweiserGemeinden(search: string | undefined, authorization: any | undefined): Promise<WegweiserGemeinden[]> {
        let url_ = this.baseUrl + "/api/wegweiser/GetWegweiserGemeinden?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWegweiserGemeinden(_response);
        });
    }

    protected processGetWegweiserGemeinden(response: Response): Promise<WegweiserGemeinden[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WegweiserGemeinden.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WegweiserGemeinden[]>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param jahr (optional) 
     * @param includeImported (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    getCachedIndicators(kunde: number | undefined, gemeinde: number | undefined, jahr: number | undefined, includeImported: boolean | undefined, authorization: any | undefined): Promise<WegweiserIndikator[]> {
        let url_ = this.baseUrl + "/api/wegweiser/getCachedIndicators?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        if (jahr === null)
            throw new Error("The parameter 'jahr' cannot be null.");
        else if (jahr !== undefined)
            url_ += "jahr=" + encodeURIComponent("" + jahr) + "&";
        if (includeImported === null)
            throw new Error("The parameter 'includeImported' cannot be null.");
        else if (includeImported !== undefined)
            url_ += "includeImported=" + encodeURIComponent("" + includeImported) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCachedIndicators(_response);
        });
    }

    protected processGetCachedIndicators(response: Response): Promise<WegweiserIndikator[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WegweiserIndikator.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WegweiserIndikator[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @param body (optional) 
     * @return OK
     */
    import(authorization: any | undefined, body: ImportWegweiserKommuneDataRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/wegweiser/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param kunde (optional) 
     * @param gemeinde (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    getIndicatorDetailsForGemeinde(kunde: number | undefined, gemeinde: number | undefined, authorization: any | undefined): Promise<WegweiserIndikator[]> {
        let url_ = this.baseUrl + "/api/wegweiser/GetIndicatorDetailsForGemeinde?";
        if (kunde === null)
            throw new Error("The parameter 'kunde' cannot be null.");
        else if (kunde !== undefined)
            url_ += "kunde=" + encodeURIComponent("" + kunde) + "&";
        if (gemeinde === null)
            throw new Error("The parameter 'gemeinde' cannot be null.");
        else if (gemeinde !== undefined)
            url_ += "gemeinde=" + encodeURIComponent("" + gemeinde) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetIndicatorDetailsForGemeinde(_response);
        });
    }

    protected processGetIndicatorDetailsForGemeinde(response: Response): Promise<WegweiserIndikator[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WegweiserIndikator.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WegweiserIndikator[]>(null as any);
    }

    /**
     * @param authorization (optional) 
     * @return OK
     */
    listAutoUpdateDatasets(authorization: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/wegweiser/listAutoUpdateDatasets";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListAutoUpdateDatasets(_response);
        });
    }

    protected processListAutoUpdateDatasets(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class Indikator_Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param indikatorId (optional) 
     * @param wegweiserGemeindeId (optional) 
     * @param friendlyUrl (optional) 
     * @param authorization (optional) 
     * @return OK
     */
    completeData(indikatorId: number | undefined, wegweiserGemeindeId: number | undefined, friendlyUrl: string | undefined, authorization: any | undefined): Promise<IndicatorValueDto[]> {
        let url_ = this.baseUrl + "/api/wegweiser/indikator/completeData?";
        if (indikatorId === null)
            throw new Error("The parameter 'indikatorId' cannot be null.");
        else if (indikatorId !== undefined)
            url_ += "indikatorId=" + encodeURIComponent("" + indikatorId) + "&";
        if (wegweiserGemeindeId === null)
            throw new Error("The parameter 'wegweiserGemeindeId' cannot be null.");
        else if (wegweiserGemeindeId !== undefined)
            url_ += "wegweiserGemeindeId=" + encodeURIComponent("" + wegweiserGemeindeId) + "&";
        if (friendlyUrl === null)
            throw new Error("The parameter 'friendlyUrl' cannot be null.");
        else if (friendlyUrl !== undefined)
            url_ += "friendlyUrl=" + encodeURIComponent("" + friendlyUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCompleteData(_response);
        });
    }

    protected processCompleteData(response: Response): Promise<IndicatorValueDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IndicatorValueDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IndicatorValueDto[]>(null as any);
    }
}

export class ABCResult implements IABCResult {
    negResults?: ABCResultEbene[] | undefined;
    negResultAbs?: number;
    posResults?: ABCResultEbene[] | undefined;
    posResultAbs?: number;
    textOben?: string | undefined;
    textMitte?: string | undefined;
    textUnten?: string | undefined;
    farbeA?: string | undefined;
    farbeB?: string | undefined;
    farbeC?: string | undefined;
    farbePos?: string | undefined;
    ebenen?: string | undefined;

    constructor(data?: IABCResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["negResults"])) {
                this.negResults = [] as any;
                for (let item of _data["negResults"])
                    this.negResults!.push(ABCResultEbene.fromJS(item));
            }
            this.negResultAbs = _data["negResultAbs"];
            if (Array.isArray(_data["posResults"])) {
                this.posResults = [] as any;
                for (let item of _data["posResults"])
                    this.posResults!.push(ABCResultEbene.fromJS(item));
            }
            this.posResultAbs = _data["posResultAbs"];
            this.textOben = _data["textOben"];
            this.textMitte = _data["textMitte"];
            this.textUnten = _data["textUnten"];
            this.farbeA = _data["farbeA"];
            this.farbeB = _data["farbeB"];
            this.farbeC = _data["farbeC"];
            this.farbePos = _data["farbePos"];
            this.ebenen = _data["ebenen"];
        }
    }

    static fromJS(data: any): ABCResult {
        data = typeof data === 'object' ? data : {};
        let result = new ABCResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.negResults)) {
            data["negResults"] = [];
            for (let item of this.negResults)
                data["negResults"].push(item.toJSON());
        }
        data["negResultAbs"] = this.negResultAbs;
        if (Array.isArray(this.posResults)) {
            data["posResults"] = [];
            for (let item of this.posResults)
                data["posResults"].push(item.toJSON());
        }
        data["posResultAbs"] = this.posResultAbs;
        data["textOben"] = this.textOben;
        data["textMitte"] = this.textMitte;
        data["textUnten"] = this.textUnten;
        data["farbeA"] = this.farbeA;
        data["farbeB"] = this.farbeB;
        data["farbeC"] = this.farbeC;
        data["farbePos"] = this.farbePos;
        data["ebenen"] = this.ebenen;
        return data;
    }
}

export interface IABCResult {
    negResults?: ABCResultEbene[] | undefined;
    negResultAbs?: number;
    posResults?: ABCResultEbene[] | undefined;
    posResultAbs?: number;
    textOben?: string | undefined;
    textMitte?: string | undefined;
    textUnten?: string | undefined;
    farbeA?: string | undefined;
    farbeB?: string | undefined;
    farbeC?: string | undefined;
    farbePos?: string | undefined;
    ebenen?: string | undefined;
}

export class ABCResultEbene implements IABCResultEbene {
    id?: number;
    resultAbs?: number;
    resultRel?: number;
    resultRelKumuliert?: number;
    klassifikation?: string;
    uaFmt?: string | undefined;
    uaText?: string | undefined;

    constructor(data?: IABCResultEbene) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.resultAbs = _data["resultAbs"];
            this.resultRel = _data["resultRel"];
            this.resultRelKumuliert = _data["resultRelKumuliert"];
            this.klassifikation = _data["klassifikation"];
            this.uaFmt = _data["uaFmt"];
            this.uaText = _data["uaText"];
        }
    }

    static fromJS(data: any): ABCResultEbene {
        data = typeof data === 'object' ? data : {};
        let result = new ABCResultEbene();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["resultAbs"] = this.resultAbs;
        data["resultRel"] = this.resultRel;
        data["resultRelKumuliert"] = this.resultRelKumuliert;
        data["klassifikation"] = this.klassifikation;
        data["uaFmt"] = this.uaFmt;
        data["uaText"] = this.uaText;
        return data;
    }
}

export interface IABCResultEbene {
    id?: number;
    resultAbs?: number;
    resultRel?: number;
    resultRelKumuliert?: number;
    klassifikation?: string;
    uaFmt?: string | undefined;
    uaText?: string | undefined;
}

export class Abcanalyse implements IAbcanalyse {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    anzeigen?: boolean;
    grenzeA?: number | undefined;
    grenzeB?: number | undefined;
    grenzeC?: number | undefined;
    textOben?: string | undefined;
    textMitte?: string | undefined;
    textUnten?: string | undefined;
    farbeA?: string | undefined;
    farbeB?: string | undefined;
    farbeC?: string | undefined;
    farbePos?: string | undefined;
    anzeigenJr?: boolean | undefined;
    grenzeAjr?: number | undefined;
    grenzeBjr?: number | undefined;
    grenzeCjr?: number | undefined;
    textObenJr?: string | undefined;
    textMitteJr?: string | undefined;
    textUntenJr?: string | undefined;
    farbeAjr?: string | undefined;
    farbeBjr?: string | undefined;
    farbeCjr?: string | undefined;
    farbePosJr?: string | undefined;
    anzeigenUh?: boolean | undefined;
    grenzeAuh?: number | undefined;
    grenzeBuh?: number | undefined;
    grenzeCuh?: number | undefined;
    textObenUh?: string | undefined;
    textMitteUh?: string | undefined;
    textUntenUh?: string | undefined;
    farbeAuh?: string | undefined;
    farbeBuh?: string | undefined;
    farbeCuh?: string | undefined;
    farbePosUh?: string | undefined;
    exkludiert?: string | undefined;
    exkludiertJr?: string | undefined;
    exkludiertUh?: string | undefined;
    basis?: string | undefined;
    basisJr?: string | undefined;
    basisUh?: string | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    oeffentlichJr?: boolean | undefined;
    oeffentlichVerwaltungJr?: boolean | undefined;
    oeffentlichUh?: boolean | undefined;
    oeffentlichVerwaltungUh?: boolean | undefined;
    ebenen?: string | undefined;
    ebenenJr?: string | undefined;
    ebenenUh?: string | undefined;

    constructor(data?: IAbcanalyse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.anzeigen = _data["anzeigen"];
            this.grenzeA = _data["grenzeA"];
            this.grenzeB = _data["grenzeB"];
            this.grenzeC = _data["grenzeC"];
            this.textOben = _data["textOben"];
            this.textMitte = _data["textMitte"];
            this.textUnten = _data["textUnten"];
            this.farbeA = _data["farbeA"];
            this.farbeB = _data["farbeB"];
            this.farbeC = _data["farbeC"];
            this.farbePos = _data["farbePos"];
            this.anzeigenJr = _data["anzeigenJr"];
            this.grenzeAjr = _data["grenzeAjr"];
            this.grenzeBjr = _data["grenzeBjr"];
            this.grenzeCjr = _data["grenzeCjr"];
            this.textObenJr = _data["textObenJr"];
            this.textMitteJr = _data["textMitteJr"];
            this.textUntenJr = _data["textUntenJr"];
            this.farbeAjr = _data["farbeAjr"];
            this.farbeBjr = _data["farbeBjr"];
            this.farbeCjr = _data["farbeCjr"];
            this.farbePosJr = _data["farbePosJr"];
            this.anzeigenUh = _data["anzeigenUh"];
            this.grenzeAuh = _data["grenzeAuh"];
            this.grenzeBuh = _data["grenzeBuh"];
            this.grenzeCuh = _data["grenzeCuh"];
            this.textObenUh = _data["textObenUh"];
            this.textMitteUh = _data["textMitteUh"];
            this.textUntenUh = _data["textUntenUh"];
            this.farbeAuh = _data["farbeAuh"];
            this.farbeBuh = _data["farbeBuh"];
            this.farbeCuh = _data["farbeCuh"];
            this.farbePosUh = _data["farbePosUh"];
            this.exkludiert = _data["exkludiert"];
            this.exkludiertJr = _data["exkludiertJr"];
            this.exkludiertUh = _data["exkludiertUh"];
            this.basis = _data["basis"];
            this.basisJr = _data["basisJr"];
            this.basisUh = _data["basisUh"];
            this.oeffentlich = _data["oeffentlich"];
            this.oeffentlichVerwaltung = _data["oeffentlichVerwaltung"];
            this.oeffentlichJr = _data["oeffentlichJr"];
            this.oeffentlichVerwaltungJr = _data["oeffentlichVerwaltungJr"];
            this.oeffentlichUh = _data["oeffentlichUh"];
            this.oeffentlichVerwaltungUh = _data["oeffentlichVerwaltungUh"];
            this.ebenen = _data["ebenen"];
            this.ebenenJr = _data["ebenenJr"];
            this.ebenenUh = _data["ebenenUh"];
        }
    }

    static fromJS(data: any): Abcanalyse {
        data = typeof data === 'object' ? data : {};
        let result = new Abcanalyse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["anzeigen"] = this.anzeigen;
        data["grenzeA"] = this.grenzeA;
        data["grenzeB"] = this.grenzeB;
        data["grenzeC"] = this.grenzeC;
        data["textOben"] = this.textOben;
        data["textMitte"] = this.textMitte;
        data["textUnten"] = this.textUnten;
        data["farbeA"] = this.farbeA;
        data["farbeB"] = this.farbeB;
        data["farbeC"] = this.farbeC;
        data["farbePos"] = this.farbePos;
        data["anzeigenJr"] = this.anzeigenJr;
        data["grenzeAjr"] = this.grenzeAjr;
        data["grenzeBjr"] = this.grenzeBjr;
        data["grenzeCjr"] = this.grenzeCjr;
        data["textObenJr"] = this.textObenJr;
        data["textMitteJr"] = this.textMitteJr;
        data["textUntenJr"] = this.textUntenJr;
        data["farbeAjr"] = this.farbeAjr;
        data["farbeBjr"] = this.farbeBjr;
        data["farbeCjr"] = this.farbeCjr;
        data["farbePosJr"] = this.farbePosJr;
        data["anzeigenUh"] = this.anzeigenUh;
        data["grenzeAuh"] = this.grenzeAuh;
        data["grenzeBuh"] = this.grenzeBuh;
        data["grenzeCuh"] = this.grenzeCuh;
        data["textObenUh"] = this.textObenUh;
        data["textMitteUh"] = this.textMitteUh;
        data["textUntenUh"] = this.textUntenUh;
        data["farbeAuh"] = this.farbeAuh;
        data["farbeBuh"] = this.farbeBuh;
        data["farbeCuh"] = this.farbeCuh;
        data["farbePosUh"] = this.farbePosUh;
        data["exkludiert"] = this.exkludiert;
        data["exkludiertJr"] = this.exkludiertJr;
        data["exkludiertUh"] = this.exkludiertUh;
        data["basis"] = this.basis;
        data["basisJr"] = this.basisJr;
        data["basisUh"] = this.basisUh;
        data["oeffentlich"] = this.oeffentlich;
        data["oeffentlichVerwaltung"] = this.oeffentlichVerwaltung;
        data["oeffentlichJr"] = this.oeffentlichJr;
        data["oeffentlichVerwaltungJr"] = this.oeffentlichVerwaltungJr;
        data["oeffentlichUh"] = this.oeffentlichUh;
        data["oeffentlichVerwaltungUh"] = this.oeffentlichVerwaltungUh;
        data["ebenen"] = this.ebenen;
        data["ebenenJr"] = this.ebenenJr;
        data["ebenenUh"] = this.ebenenUh;
        return data;
    }
}

export interface IAbcanalyse {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    anzeigen?: boolean;
    grenzeA?: number | undefined;
    grenzeB?: number | undefined;
    grenzeC?: number | undefined;
    textOben?: string | undefined;
    textMitte?: string | undefined;
    textUnten?: string | undefined;
    farbeA?: string | undefined;
    farbeB?: string | undefined;
    farbeC?: string | undefined;
    farbePos?: string | undefined;
    anzeigenJr?: boolean | undefined;
    grenzeAjr?: number | undefined;
    grenzeBjr?: number | undefined;
    grenzeCjr?: number | undefined;
    textObenJr?: string | undefined;
    textMitteJr?: string | undefined;
    textUntenJr?: string | undefined;
    farbeAjr?: string | undefined;
    farbeBjr?: string | undefined;
    farbeCjr?: string | undefined;
    farbePosJr?: string | undefined;
    anzeigenUh?: boolean | undefined;
    grenzeAuh?: number | undefined;
    grenzeBuh?: number | undefined;
    grenzeCuh?: number | undefined;
    textObenUh?: string | undefined;
    textMitteUh?: string | undefined;
    textUntenUh?: string | undefined;
    farbeAuh?: string | undefined;
    farbeBuh?: string | undefined;
    farbeCuh?: string | undefined;
    farbePosUh?: string | undefined;
    exkludiert?: string | undefined;
    exkludiertJr?: string | undefined;
    exkludiertUh?: string | undefined;
    basis?: string | undefined;
    basisJr?: string | undefined;
    basisUh?: string | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    oeffentlichJr?: boolean | undefined;
    oeffentlichVerwaltungJr?: boolean | undefined;
    oeffentlichUh?: boolean | undefined;
    oeffentlichVerwaltungUh?: boolean | undefined;
    ebenen?: string | undefined;
    ebenenJr?: string | undefined;
    ebenenUh?: string | undefined;
}

export class ActivateDesignRequest implements IActivateDesignRequest {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    ansicht?: number;
    version?: number;

    constructor(data?: IActivateDesignRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.ansicht = _data["ansicht"];
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): ActivateDesignRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateDesignRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["ansicht"] = this.ansicht;
        data["version"] = this.version;
        return data;
    }
}

export interface IActivateDesignRequest {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    ansicht?: number;
    version?: number;
}

export class AddRoleModel implements IAddRoleModel {
    kunde?: number;
    roleName?: string | undefined;
    copyFromRole?: string | undefined;

    constructor(data?: IAddRoleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.roleName = _data["roleName"];
            this.copyFromRole = _data["copyFromRole"];
        }
    }

    static fromJS(data: any): AddRoleModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddRoleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["roleName"] = this.roleName;
        data["copyFromRole"] = this.copyFromRole;
        return data;
    }
}

export interface IAddRoleModel {
    kunde?: number;
    roleName?: string | undefined;
    copyFromRole?: string | undefined;
}

export class AmtEbenenModel implements IAmtEbenenModel {
    ebenenId?: string | undefined;
    bezeichnung?: string | undefined;

    constructor(data?: IAmtEbenenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ebenenId = _data["ebenenId"];
            this.bezeichnung = _data["bezeichnung"];
        }
    }

    static fromJS(data: any): AmtEbenenModel {
        data = typeof data === 'object' ? data : {};
        let result = new AmtEbenenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ebenenId"] = this.ebenenId;
        data["bezeichnung"] = this.bezeichnung;
        return data;
    }
}

export interface IAmtEbenenModel {
    ebenenId?: string | undefined;
    bezeichnung?: string | undefined;
}

export class AntwortBlock implements IAntwortBlock {
    typ?: string | undefined;
    inhalt?: string | undefined;
    art?: string | undefined;
    tabelle?: ErgebnisTabelle;
    diagramm?: DiagrammDaten;
    farben?: string[] | undefined;
    achseVon?: number | undefined;
    achseBis?: number | undefined;

    constructor(data?: IAntwortBlock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typ = _data["typ"];
            this.inhalt = _data["inhalt"];
            this.art = _data["art"];
            this.tabelle = _data["tabelle"] ? ErgebnisTabelle.fromJS(_data["tabelle"]) : <any>undefined;
            this.diagramm = _data["diagramm"] ? DiagrammDaten.fromJS(_data["diagramm"]) : <any>undefined;
            if (Array.isArray(_data["farben"])) {
                this.farben = [] as any;
                for (let item of _data["farben"])
                    this.farben!.push(item);
            }
            this.achseVon = _data["achseVon"];
            this.achseBis = _data["achseBis"];
        }
    }

    static fromJS(data: any): AntwortBlock {
        data = typeof data === 'object' ? data : {};
        let result = new AntwortBlock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typ"] = this.typ;
        data["inhalt"] = this.inhalt;
        data["art"] = this.art;
        data["tabelle"] = this.tabelle ? this.tabelle.toJSON() : <any>undefined;
        data["diagramm"] = this.diagramm ? this.diagramm.toJSON() : <any>undefined;
        if (Array.isArray(this.farben)) {
            data["farben"] = [];
            for (let item of this.farben)
                data["farben"].push(item);
        }
        data["achseVon"] = this.achseVon;
        data["achseBis"] = this.achseBis;
        return data;
    }
}

export interface IAntwortBlock {
    typ?: string | undefined;
    inhalt?: string | undefined;
    art?: string | undefined;
    tabelle?: ErgebnisTabelle;
    diagramm?: DiagrammDaten;
    farben?: string[] | undefined;
    achseVon?: number | undefined;
    achseBis?: number | undefined;
}

export class AntwortQuelle implements IAntwortQuelle {
    nummer?: number;
    titel?: string | undefined;
    quelle?: string | undefined;

    constructor(data?: IAntwortQuelle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nummer = _data["nummer"];
            this.titel = _data["titel"];
            this.quelle = _data["quelle"];
        }
    }

    static fromJS(data: any): AntwortQuelle {
        data = typeof data === 'object' ? data : {};
        let result = new AntwortQuelle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nummer"] = this.nummer;
        data["titel"] = this.titel;
        data["quelle"] = this.quelle;
        return data;
    }
}

export interface IAntwortQuelle {
    nummer?: number;
    titel?: string | undefined;
    quelle?: string | undefined;
}

export class ApplyTemplateRequest implements IApplyTemplateRequest {
    templateId?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    ansicht?: number;

    constructor(data?: IApplyTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.ansicht = _data["ansicht"];
        }
    }

    static fromJS(data: any): ApplyTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApplyTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["ansicht"] = this.ansicht;
        return data;
    }
}

export interface IApplyTemplateRequest {
    templateId?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    ansicht?: number;
}

export class AspNetRole implements IAspNetRole {
    id?: string | undefined;
    name?: string | undefined;
    normalizedName?: string | undefined;
    concurrencyStamp?: string | undefined;
    kunde?: number | undefined;
    aspNetRoleClaims?: AspNetRoleClaim[] | undefined;
    users?: AspNetUser[] | undefined;

    constructor(data?: IAspNetRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.normalizedName = _data["normalizedName"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.kunde = _data["kunde"];
            if (Array.isArray(_data["aspNetRoleClaims"])) {
                this.aspNetRoleClaims = [] as any;
                for (let item of _data["aspNetRoleClaims"])
                    this.aspNetRoleClaims!.push(AspNetRoleClaim.fromJS(item));
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(AspNetUser.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AspNetRole {
        data = typeof data === 'object' ? data : {};
        let result = new AspNetRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["normalizedName"] = this.normalizedName;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["kunde"] = this.kunde;
        if (Array.isArray(this.aspNetRoleClaims)) {
            data["aspNetRoleClaims"] = [];
            for (let item of this.aspNetRoleClaims)
                data["aspNetRoleClaims"].push(item.toJSON());
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAspNetRole {
    id?: string | undefined;
    name?: string | undefined;
    normalizedName?: string | undefined;
    concurrencyStamp?: string | undefined;
    kunde?: number | undefined;
    aspNetRoleClaims?: AspNetRoleClaim[] | undefined;
    users?: AspNetUser[] | undefined;
}

export class AspNetRoleClaim implements IAspNetRoleClaim {
    id?: number;
    roleId?: string | undefined;
    claimType?: string | undefined;
    claimValue?: string | undefined;
    role?: AspNetRole;

    constructor(data?: IAspNetRoleClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.roleId = _data["roleId"];
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
            this.role = _data["role"] ? AspNetRole.fromJS(_data["role"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AspNetRoleClaim {
        data = typeof data === 'object' ? data : {};
        let result = new AspNetRoleClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["roleId"] = this.roleId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAspNetRoleClaim {
    id?: number;
    roleId?: string | undefined;
    claimType?: string | undefined;
    claimValue?: string | undefined;
    role?: AspNetRole;
}

export class AspNetUser implements IAspNetUser {
    id?: string | undefined;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: Date | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
    customer?: number | undefined;
    needNewPassword?: boolean | undefined;
    zuname?: string | undefined;
    vorname?: string | undefined;
    aspNetUserClaims?: AspNetUserClaim[] | undefined;
    aspNetUserLogins?: AspNetUserLogin[] | undefined;
    aspNetUserTokens?: AspNetUserToken[] | undefined;
    roles?: AspNetRole[] | undefined;

    constructor(data?: IAspNetUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.email = _data["email"];
            this.normalizedEmail = _data["normalizedEmail"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.passwordHash = _data["passwordHash"];
            this.securityStamp = _data["securityStamp"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : <any>undefined;
            this.lockoutEnabled = _data["lockoutEnabled"];
            this.accessFailedCount = _data["accessFailedCount"];
            this.customer = _data["customer"];
            this.needNewPassword = _data["needNewPassword"];
            this.zuname = _data["zuname"];
            this.vorname = _data["vorname"];
            if (Array.isArray(_data["aspNetUserClaims"])) {
                this.aspNetUserClaims = [] as any;
                for (let item of _data["aspNetUserClaims"])
                    this.aspNetUserClaims!.push(AspNetUserClaim.fromJS(item));
            }
            if (Array.isArray(_data["aspNetUserLogins"])) {
                this.aspNetUserLogins = [] as any;
                for (let item of _data["aspNetUserLogins"])
                    this.aspNetUserLogins!.push(AspNetUserLogin.fromJS(item));
            }
            if (Array.isArray(_data["aspNetUserTokens"])) {
                this.aspNetUserTokens = [] as any;
                for (let item of _data["aspNetUserTokens"])
                    this.aspNetUserTokens!.push(AspNetUserToken.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(AspNetRole.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AspNetUser {
        data = typeof data === 'object' ? data : {};
        let result = new AspNetUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["normalizedUserName"] = this.normalizedUserName;
        data["email"] = this.email;
        data["normalizedEmail"] = this.normalizedEmail;
        data["emailConfirmed"] = this.emailConfirmed;
        data["passwordHash"] = this.passwordHash;
        data["securityStamp"] = this.securityStamp;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : <any>undefined;
        data["lockoutEnabled"] = this.lockoutEnabled;
        data["accessFailedCount"] = this.accessFailedCount;
        data["customer"] = this.customer;
        data["needNewPassword"] = this.needNewPassword;
        data["zuname"] = this.zuname;
        data["vorname"] = this.vorname;
        if (Array.isArray(this.aspNetUserClaims)) {
            data["aspNetUserClaims"] = [];
            for (let item of this.aspNetUserClaims)
                data["aspNetUserClaims"].push(item.toJSON());
        }
        if (Array.isArray(this.aspNetUserLogins)) {
            data["aspNetUserLogins"] = [];
            for (let item of this.aspNetUserLogins)
                data["aspNetUserLogins"].push(item.toJSON());
        }
        if (Array.isArray(this.aspNetUserTokens)) {
            data["aspNetUserTokens"] = [];
            for (let item of this.aspNetUserTokens)
                data["aspNetUserTokens"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAspNetUser {
    id?: string | undefined;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: Date | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
    customer?: number | undefined;
    needNewPassword?: boolean | undefined;
    zuname?: string | undefined;
    vorname?: string | undefined;
    aspNetUserClaims?: AspNetUserClaim[] | undefined;
    aspNetUserLogins?: AspNetUserLogin[] | undefined;
    aspNetUserTokens?: AspNetUserToken[] | undefined;
    roles?: AspNetRole[] | undefined;
}

export class AspNetUserClaim implements IAspNetUserClaim {
    id?: number;
    userId?: string | undefined;
    claimType?: string | undefined;
    claimValue?: string | undefined;
    user?: AspNetUser;

    constructor(data?: IAspNetUserClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
            this.user = _data["user"] ? AspNetUser.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AspNetUserClaim {
        data = typeof data === 'object' ? data : {};
        let result = new AspNetUserClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAspNetUserClaim {
    id?: number;
    userId?: string | undefined;
    claimType?: string | undefined;
    claimValue?: string | undefined;
    user?: AspNetUser;
}

export class AspNetUserLogin implements IAspNetUserLogin {
    loginProvider?: string | undefined;
    providerKey?: string | undefined;
    providerDisplayName?: string | undefined;
    userId?: string | undefined;
    user?: AspNetUser;

    constructor(data?: IAspNetUserLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loginProvider = _data["loginProvider"];
            this.providerKey = _data["providerKey"];
            this.providerDisplayName = _data["providerDisplayName"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? AspNetUser.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AspNetUserLogin {
        data = typeof data === 'object' ? data : {};
        let result = new AspNetUserLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        data["providerDisplayName"] = this.providerDisplayName;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAspNetUserLogin {
    loginProvider?: string | undefined;
    providerKey?: string | undefined;
    providerDisplayName?: string | undefined;
    userId?: string | undefined;
    user?: AspNetUser;
}

export class AspNetUserToken implements IAspNetUserToken {
    userId?: string | undefined;
    loginProvider?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    user?: AspNetUser;

    constructor(data?: IAspNetUserToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.user = _data["user"] ? AspNetUser.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AspNetUserToken {
        data = typeof data === 'object' ? data : {};
        let result = new AspNetUserToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["name"] = this.name;
        data["value"] = this.value;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAspNetUserToken {
    userId?: string | undefined;
    loginProvider?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    user?: AspNetUser;
}

export class AssignedEbenenModel implements IAssignedEbenenModel {
    kunde?: number | undefined;
    haushaltsstelle?: number;
    jahr?: number;
    ebenen?: EbenenModel[] | undefined;

    constructor(data?: IAssignedEbenenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.haushaltsstelle = _data["haushaltsstelle"];
            this.jahr = _data["jahr"];
            if (Array.isArray(_data["ebenen"])) {
                this.ebenen = [] as any;
                for (let item of _data["ebenen"])
                    this.ebenen!.push(EbenenModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssignedEbenenModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssignedEbenenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["haushaltsstelle"] = this.haushaltsstelle;
        data["jahr"] = this.jahr;
        if (Array.isArray(this.ebenen)) {
            data["ebenen"] = [];
            for (let item of this.ebenen)
                data["ebenen"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAssignedEbenenModel {
    kunde?: number | undefined;
    haushaltsstelle?: number;
    jahr?: number;
    ebenen?: EbenenModel[] | undefined;
}

export class AssignedHHSModel implements IAssignedHHSModel {
    kunde?: number | undefined;
    ebenenId?: string | undefined;
    jahr?: number;
    haushaltsstellen?: Haushaltsstellen[] | undefined;

    constructor(data?: IAssignedHHSModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.ebenenId = _data["ebenenId"];
            this.jahr = _data["jahr"];
            if (Array.isArray(_data["haushaltsstellen"])) {
                this.haushaltsstellen = [] as any;
                for (let item of _data["haushaltsstellen"])
                    this.haushaltsstellen!.push(Haushaltsstellen.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssignedHHSModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssignedHHSModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["ebenenId"] = this.ebenenId;
        data["jahr"] = this.jahr;
        if (Array.isArray(this.haushaltsstellen)) {
            data["haushaltsstellen"] = [];
            for (let item of this.haushaltsstellen)
                data["haushaltsstellen"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAssignedHHSModel {
    kunde?: number | undefined;
    ebenenId?: string | undefined;
    jahr?: number;
    haushaltsstellen?: Haushaltsstellen[] | undefined;
}

export class AssignedHHSModelDoppik implements IAssignedHHSModelDoppik {
    kunde?: number | undefined;
    ebenenId?: string | undefined;
    jahr?: number;
    haushaltsstellen?: HaushaltsstellenDoppisch[] | undefined;

    constructor(data?: IAssignedHHSModelDoppik) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.ebenenId = _data["ebenenId"];
            this.jahr = _data["jahr"];
            if (Array.isArray(_data["haushaltsstellen"])) {
                this.haushaltsstellen = [] as any;
                for (let item of _data["haushaltsstellen"])
                    this.haushaltsstellen!.push(HaushaltsstellenDoppisch.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssignedHHSModelDoppik {
        data = typeof data === 'object' ? data : {};
        let result = new AssignedHHSModelDoppik();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["ebenenId"] = this.ebenenId;
        data["jahr"] = this.jahr;
        if (Array.isArray(this.haushaltsstellen)) {
            data["haushaltsstellen"] = [];
            for (let item of this.haushaltsstellen)
                data["haushaltsstellen"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAssignedHHSModelDoppik {
    kunde?: number | undefined;
    ebenenId?: string | undefined;
    jahr?: number;
    haushaltsstellen?: HaushaltsstellenDoppisch[] | undefined;
}

export class AuthResponse implements IAuthResponse {
    status?: string | undefined;
    message?: string | undefined;

    constructor(data?: IAuthResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): AuthResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        return data;
    }
}

export interface IAuthResponse {
    status?: string | undefined;
    message?: string | undefined;
}

export class BackgroundImage implements IBackgroundImage {
    location?: string | undefined;
    type?: string | undefined;
    show?: string | undefined;
    actuate?: string | undefined;
    repetition?: Repetition;
    position?: string | undefined;
    filter?: string | undefined;
    opacity?: number;
    fileName?: string | undefined;
    buffer?: string | undefined;

    constructor(data?: IBackgroundImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"];
            this.type = _data["type"];
            this.show = _data["show"];
            this.actuate = _data["actuate"];
            this.repetition = _data["repetition"];
            this.position = _data["position"];
            this.filter = _data["filter"];
            this.opacity = _data["opacity"];
            this.fileName = _data["fileName"];
            this.buffer = _data["buffer"];
        }
    }

    static fromJS(data: any): BackgroundImage {
        data = typeof data === 'object' ? data : {};
        let result = new BackgroundImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location;
        data["type"] = this.type;
        data["show"] = this.show;
        data["actuate"] = this.actuate;
        data["repetition"] = this.repetition;
        data["position"] = this.position;
        data["filter"] = this.filter;
        data["opacity"] = this.opacity;
        data["fileName"] = this.fileName;
        data["buffer"] = this.buffer;
        return data;
    }
}

export interface IBackgroundImage {
    location?: string | undefined;
    type?: string | undefined;
    show?: string | undefined;
    actuate?: string | undefined;
    repetition?: Repetition;
    position?: string | undefined;
    filter?: string | undefined;
    opacity?: number;
    fileName?: string | undefined;
    buffer?: string | undefined;
}

export class BackupElementModel implements IBackupElementModel {
    key?: string | undefined;
    anzeige?: string | undefined;
    scope?: string | undefined;
    restore?: string | undefined;
    transferErlaubt?: boolean;
    nurKomplettRestore?: boolean;
    sichern?: boolean;
    tabellen?: number;
    dateien?: boolean;
    eintraegeWaehlbar?: boolean;

    constructor(data?: IBackupElementModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.anzeige = _data["anzeige"];
            this.scope = _data["scope"];
            this.restore = _data["restore"];
            this.transferErlaubt = _data["transferErlaubt"];
            this.nurKomplettRestore = _data["nurKomplettRestore"];
            this.sichern = _data["sichern"];
            this.tabellen = _data["tabellen"];
            this.dateien = _data["dateien"];
            this.eintraegeWaehlbar = _data["eintraegeWaehlbar"];
        }
    }

    static fromJS(data: any): BackupElementModel {
        data = typeof data === 'object' ? data : {};
        let result = new BackupElementModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["anzeige"] = this.anzeige;
        data["scope"] = this.scope;
        data["restore"] = this.restore;
        data["transferErlaubt"] = this.transferErlaubt;
        data["nurKomplettRestore"] = this.nurKomplettRestore;
        data["sichern"] = this.sichern;
        data["tabellen"] = this.tabellen;
        data["dateien"] = this.dateien;
        data["eintraegeWaehlbar"] = this.eintraegeWaehlbar;
        return data;
    }
}

export interface IBackupElementModel {
    key?: string | undefined;
    anzeige?: string | undefined;
    scope?: string | undefined;
    restore?: string | undefined;
    transferErlaubt?: boolean;
    nurKomplettRestore?: boolean;
    sichern?: boolean;
    tabellen?: number;
    dateien?: boolean;
    eintraegeWaehlbar?: boolean;
}

export class BackupLaufElementModel implements IBackupLaufElementModel {
    elementTyp?: string | undefined;
    anzeige?: string | undefined;
    gemeinde?: number | undefined;
    jahr?: number | undefined;
    zeilen?: number;
    dateienAnzahl?: number;
    bytes?: number;
    status?: number;
    meldung?: string | undefined;
    start?: Date | undefined;
    ende?: Date | undefined;

    constructor(data?: IBackupLaufElementModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.elementTyp = _data["elementTyp"];
            this.anzeige = _data["anzeige"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.zeilen = _data["zeilen"];
            this.dateienAnzahl = _data["dateienAnzahl"];
            this.bytes = _data["bytes"];
            this.status = _data["status"];
            this.meldung = _data["meldung"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.ende = _data["ende"] ? new Date(_data["ende"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BackupLaufElementModel {
        data = typeof data === 'object' ? data : {};
        let result = new BackupLaufElementModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["elementTyp"] = this.elementTyp;
        data["anzeige"] = this.anzeige;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["zeilen"] = this.zeilen;
        data["dateienAnzahl"] = this.dateienAnzahl;
        data["bytes"] = this.bytes;
        data["status"] = this.status;
        data["meldung"] = this.meldung;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["ende"] = this.ende ? this.ende.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBackupLaufElementModel {
    elementTyp?: string | undefined;
    anzeige?: string | undefined;
    gemeinde?: number | undefined;
    jahr?: number | undefined;
    zeilen?: number;
    dateienAnzahl?: number;
    bytes?: number;
    status?: number;
    meldung?: string | undefined;
    start?: Date | undefined;
    ende?: Date | undefined;
}

export class BackupLaufModel implements IBackupLaufModel {
    id?: number;
    kunde?: number;
    typ?: number;
    ausloeser?: number;
    umfang?: number;
    start?: Date;
    ende?: Date | undefined;
    status?: number;
    ausgeloestVon?: string | undefined;
    fehlertext?: string | undefined;
    beschreibung?: string | undefined;
    undoVerfuegbar?: boolean;
    undoBis?: Date | undefined;
    undoVonLauf?: number | undefined;
    elemente?: BackupLaufElementModel[] | undefined;

    constructor(data?: IBackupLaufModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.typ = _data["typ"];
            this.ausloeser = _data["ausloeser"];
            this.umfang = _data["umfang"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.ende = _data["ende"] ? new Date(_data["ende"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.ausgeloestVon = _data["ausgeloestVon"];
            this.fehlertext = _data["fehlertext"];
            this.beschreibung = _data["beschreibung"];
            this.undoVerfuegbar = _data["undoVerfuegbar"];
            this.undoBis = _data["undoBis"] ? new Date(_data["undoBis"].toString()) : <any>undefined;
            this.undoVonLauf = _data["undoVonLauf"];
            if (Array.isArray(_data["elemente"])) {
                this.elemente = [] as any;
                for (let item of _data["elemente"])
                    this.elemente!.push(BackupLaufElementModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BackupLaufModel {
        data = typeof data === 'object' ? data : {};
        let result = new BackupLaufModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["typ"] = this.typ;
        data["ausloeser"] = this.ausloeser;
        data["umfang"] = this.umfang;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["ende"] = this.ende ? this.ende.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["ausgeloestVon"] = this.ausgeloestVon;
        data["fehlertext"] = this.fehlertext;
        data["beschreibung"] = this.beschreibung;
        data["undoVerfuegbar"] = this.undoVerfuegbar;
        data["undoBis"] = this.undoBis ? this.undoBis.toISOString() : <any>undefined;
        data["undoVonLauf"] = this.undoVonLauf;
        if (Array.isArray(this.elemente)) {
            data["elemente"] = [];
            for (let item of this.elemente)
                data["elemente"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBackupLaufModel {
    id?: number;
    kunde?: number;
    typ?: number;
    ausloeser?: number;
    umfang?: number;
    start?: Date;
    ende?: Date | undefined;
    status?: number;
    ausgeloestVon?: string | undefined;
    fehlertext?: string | undefined;
    beschreibung?: string | undefined;
    undoVerfuegbar?: boolean;
    undoBis?: Date | undefined;
    undoVonLauf?: number | undefined;
    elemente?: BackupLaufElementModel[] | undefined;
}

export class BackupManifestModel implements IBackupManifestModel {
    kunde?: number;
    gemeinde?: number;
    gemeindeName?: string | undefined;
    jahr?: number;
    elementTyp?: string | undefined;
    anzeige?: string | undefined;
    stand?: Date;
    laufId?: number;
    zeilen?: number;
    schemaMigration?: string | undefined;

    constructor(data?: IBackupManifestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.gemeindeName = _data["gemeindeName"];
            this.jahr = _data["jahr"];
            this.elementTyp = _data["elementTyp"];
            this.anzeige = _data["anzeige"];
            this.stand = _data["stand"] ? new Date(_data["stand"].toString()) : <any>undefined;
            this.laufId = _data["laufId"];
            this.zeilen = _data["zeilen"];
            this.schemaMigration = _data["schemaMigration"];
        }
    }

    static fromJS(data: any): BackupManifestModel {
        data = typeof data === 'object' ? data : {};
        let result = new BackupManifestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["gemeindeName"] = this.gemeindeName;
        data["jahr"] = this.jahr;
        data["elementTyp"] = this.elementTyp;
        data["anzeige"] = this.anzeige;
        data["stand"] = this.stand ? this.stand.toISOString() : <any>undefined;
        data["laufId"] = this.laufId;
        data["zeilen"] = this.zeilen;
        data["schemaMigration"] = this.schemaMigration;
        return data;
    }
}

export interface IBackupManifestModel {
    kunde?: number;
    gemeinde?: number;
    gemeindeName?: string | undefined;
    jahr?: number;
    elementTyp?: string | undefined;
    anzeige?: string | undefined;
    stand?: Date;
    laufId?: number;
    zeilen?: number;
    schemaMigration?: string | undefined;
}

export class BackupStandModel implements IBackupStandModel {
    id?: number;
    kunde?: number;
    stand?: Date;
    laufId?: number;
    zeilen?: number;
    bytes?: number;
    schemaMigration?: string | undefined;
    aktiv?: boolean;
    aktivSeit?: Date | undefined;
    paketVorhanden?: boolean;
    bemerkung?: string | undefined;

    constructor(data?: IBackupStandModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.stand = _data["stand"] ? new Date(_data["stand"].toString()) : <any>undefined;
            this.laufId = _data["laufId"];
            this.zeilen = _data["zeilen"];
            this.bytes = _data["bytes"];
            this.schemaMigration = _data["schemaMigration"];
            this.aktiv = _data["aktiv"];
            this.aktivSeit = _data["aktivSeit"] ? new Date(_data["aktivSeit"].toString()) : <any>undefined;
            this.paketVorhanden = _data["paketVorhanden"];
            this.bemerkung = _data["bemerkung"];
        }
    }

    static fromJS(data: any): BackupStandModel {
        data = typeof data === 'object' ? data : {};
        let result = new BackupStandModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["stand"] = this.stand ? this.stand.toISOString() : <any>undefined;
        data["laufId"] = this.laufId;
        data["zeilen"] = this.zeilen;
        data["bytes"] = this.bytes;
        data["schemaMigration"] = this.schemaMigration;
        data["aktiv"] = this.aktiv;
        data["aktivSeit"] = this.aktivSeit ? this.aktivSeit.toISOString() : <any>undefined;
        data["paketVorhanden"] = this.paketVorhanden;
        data["bemerkung"] = this.bemerkung;
        return data;
    }
}

export interface IBackupStandModel {
    id?: number;
    kunde?: number;
    stand?: Date;
    laufId?: number;
    zeilen?: number;
    bytes?: number;
    schemaMigration?: string | undefined;
    aktiv?: boolean;
    aktivSeit?: Date | undefined;
    paketVorhanden?: boolean;
    bemerkung?: string | undefined;
}

export class BackupStatusModel implements IBackupStatusModel {
    serviceAktiv?: boolean;
    backupKonfiguriert?: boolean;
    dateienSpiegeln?: boolean;
    paketAblageVerfuegbar?: boolean;
    paketAblage?: string | undefined;
    undoAufbewahrungTage?: number;
    staendeStandard?: number;
    staendeMax?: number;
    schema?: SchemaStand;
    sperreAktiv?: boolean;
    sperreSeit?: Date | undefined;
    geplanteLaeufe?: number;
    fehlerMailEingerichtet?: boolean;
    fehlerMailEmpfaenger?: string | undefined;
    naechsteZeitplaene?: BackupZeitplanModel[] | undefined;
    storagePath?: string | undefined;
    speicherorte?: SpeicherortModel[] | undefined;

    constructor(data?: IBackupStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceAktiv = _data["serviceAktiv"];
            this.backupKonfiguriert = _data["backupKonfiguriert"];
            this.dateienSpiegeln = _data["dateienSpiegeln"];
            this.paketAblageVerfuegbar = _data["paketAblageVerfuegbar"];
            this.paketAblage = _data["paketAblage"];
            this.undoAufbewahrungTage = _data["undoAufbewahrungTage"];
            this.staendeStandard = _data["staendeStandard"];
            this.staendeMax = _data["staendeMax"];
            this.schema = _data["schema"] ? SchemaStand.fromJS(_data["schema"]) : <any>undefined;
            this.sperreAktiv = _data["sperreAktiv"];
            this.sperreSeit = _data["sperreSeit"] ? new Date(_data["sperreSeit"].toString()) : <any>undefined;
            this.geplanteLaeufe = _data["geplanteLaeufe"];
            this.fehlerMailEingerichtet = _data["fehlerMailEingerichtet"];
            this.fehlerMailEmpfaenger = _data["fehlerMailEmpfaenger"];
            if (Array.isArray(_data["naechsteZeitplaene"])) {
                this.naechsteZeitplaene = [] as any;
                for (let item of _data["naechsteZeitplaene"])
                    this.naechsteZeitplaene!.push(BackupZeitplanModel.fromJS(item));
            }
            this.storagePath = _data["storagePath"];
            if (Array.isArray(_data["speicherorte"])) {
                this.speicherorte = [] as any;
                for (let item of _data["speicherorte"])
                    this.speicherorte!.push(SpeicherortModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BackupStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new BackupStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceAktiv"] = this.serviceAktiv;
        data["backupKonfiguriert"] = this.backupKonfiguriert;
        data["dateienSpiegeln"] = this.dateienSpiegeln;
        data["paketAblageVerfuegbar"] = this.paketAblageVerfuegbar;
        data["paketAblage"] = this.paketAblage;
        data["undoAufbewahrungTage"] = this.undoAufbewahrungTage;
        data["staendeStandard"] = this.staendeStandard;
        data["staendeMax"] = this.staendeMax;
        data["schema"] = this.schema ? this.schema.toJSON() : <any>undefined;
        data["sperreAktiv"] = this.sperreAktiv;
        data["sperreSeit"] = this.sperreSeit ? this.sperreSeit.toISOString() : <any>undefined;
        data["geplanteLaeufe"] = this.geplanteLaeufe;
        data["fehlerMailEingerichtet"] = this.fehlerMailEingerichtet;
        data["fehlerMailEmpfaenger"] = this.fehlerMailEmpfaenger;
        if (Array.isArray(this.naechsteZeitplaene)) {
            data["naechsteZeitplaene"] = [];
            for (let item of this.naechsteZeitplaene)
                data["naechsteZeitplaene"].push(item.toJSON());
        }
        data["storagePath"] = this.storagePath;
        if (Array.isArray(this.speicherorte)) {
            data["speicherorte"] = [];
            for (let item of this.speicherorte)
                data["speicherorte"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBackupStatusModel {
    serviceAktiv?: boolean;
    backupKonfiguriert?: boolean;
    dateienSpiegeln?: boolean;
    paketAblageVerfuegbar?: boolean;
    paketAblage?: string | undefined;
    undoAufbewahrungTage?: number;
    staendeStandard?: number;
    staendeMax?: number;
    schema?: SchemaStand;
    sperreAktiv?: boolean;
    sperreSeit?: Date | undefined;
    geplanteLaeufe?: number;
    fehlerMailEingerichtet?: boolean;
    fehlerMailEmpfaenger?: string | undefined;
    naechsteZeitplaene?: BackupZeitplanModel[] | undefined;
    storagePath?: string | undefined;
    speicherorte?: SpeicherortModel[] | undefined;
}

export class BackupZeitplanModel implements IBackupZeitplanModel {
    kunde?: number;
    intervall?: number;
    wochentag?: number | undefined;
    tagImMonat?: number | undefined;
    stunde?: number;
    minute?: number;
    aktiv?: boolean;
    sicherungVorImport?: boolean;
    anzahlStaende?: number;
    letzterLauf?: Date | undefined;
    naechsterLauf?: Date | undefined;
    geaendertVon?: string | undefined;
    geaendertAm?: Date | undefined;

    constructor(data?: IBackupZeitplanModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.intervall = _data["intervall"];
            this.wochentag = _data["wochentag"];
            this.tagImMonat = _data["tagImMonat"];
            this.stunde = _data["stunde"];
            this.minute = _data["minute"];
            this.aktiv = _data["aktiv"];
            this.sicherungVorImport = _data["sicherungVorImport"];
            this.anzahlStaende = _data["anzahlStaende"];
            this.letzterLauf = _data["letzterLauf"] ? new Date(_data["letzterLauf"].toString()) : <any>undefined;
            this.naechsterLauf = _data["naechsterLauf"] ? new Date(_data["naechsterLauf"].toString()) : <any>undefined;
            this.geaendertVon = _data["geaendertVon"];
            this.geaendertAm = _data["geaendertAm"] ? new Date(_data["geaendertAm"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BackupZeitplanModel {
        data = typeof data === 'object' ? data : {};
        let result = new BackupZeitplanModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["intervall"] = this.intervall;
        data["wochentag"] = this.wochentag;
        data["tagImMonat"] = this.tagImMonat;
        data["stunde"] = this.stunde;
        data["minute"] = this.minute;
        data["aktiv"] = this.aktiv;
        data["sicherungVorImport"] = this.sicherungVorImport;
        data["anzahlStaende"] = this.anzahlStaende;
        data["letzterLauf"] = this.letzterLauf ? this.letzterLauf.toISOString() : <any>undefined;
        data["naechsterLauf"] = this.naechsterLauf ? this.naechsterLauf.toISOString() : <any>undefined;
        data["geaendertVon"] = this.geaendertVon;
        data["geaendertAm"] = this.geaendertAm ? this.geaendertAm.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBackupZeitplanModel {
    kunde?: number;
    intervall?: number;
    wochentag?: number | undefined;
    tagImMonat?: number | undefined;
    stunde?: number;
    minute?: number;
    aktiv?: boolean;
    sicherungVorImport?: boolean;
    anzahlStaende?: number;
    letzterLauf?: Date | undefined;
    naechsterLauf?: Date | undefined;
    geaendertVon?: string | undefined;
    geaendertAm?: Date | undefined;
}

export class BerichtsFarben implements IBerichtsFarben {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    farbe?: string | undefined;
    order?: number;
    typ?: string | undefined;

    constructor(data?: IBerichtsFarben) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.farbe = _data["farbe"];
            this.order = _data["order"];
            this.typ = _data["typ"];
        }
    }

    static fromJS(data: any): BerichtsFarben {
        data = typeof data === 'object' ? data : {};
        let result = new BerichtsFarben();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["farbe"] = this.farbe;
        data["order"] = this.order;
        data["typ"] = this.typ;
        return data;
    }
}

export interface IBerichtsFarben {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    farbe?: string | undefined;
    order?: number;
    typ?: string | undefined;
}

export class BerichtsvorlageModel implements IBerichtsvorlageModel {
    id?: string | undefined;
    system?: boolean;
    filename?: string | undefined;

    constructor(data?: IBerichtsvorlageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.system = _data["system"];
            this.filename = _data["filename"];
        }
    }

    static fromJS(data: any): BerichtsvorlageModel {
        data = typeof data === 'object' ? data : {};
        let result = new BerichtsvorlageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["system"] = this.system;
        data["filename"] = this.filename;
        return data;
    }
}

export interface IBerichtsvorlageModel {
    id?: string | undefined;
    system?: boolean;
    filename?: string | undefined;
}

export class BildEinstellungen implements IBildEinstellungen {
    hoehe?: number;
    breite?: number;
    hoeheDiagram?: number;
    breiteDiagram?: number;
    xDiagram?: number;
    yDiagram?: number;
    xLegende?: number;
    yLegende?: number;
    legendenFont?: string | undefined;
    legendenFontSize?: number;
    legendenFarbe?: string | undefined;
    legendeMaxBreite?: number;
    legendenBoxFarbe?: string | undefined;
    labelFont?: string | undefined;
    labelFontSize?: number;
    labelFarbe?: string | undefined;
    labelFontAngle?: number;
    yLabelFont?: string | undefined;
    yLabelFontSize?: number;
    yLabelFarbe?: string | undefined;
    yLabelFontAngle?: number;
    mitHHStellen?: boolean;
    eaType?: number;
    pieLabelsSeitlich?: boolean;
    pieFlat?: boolean;
    pieText?: string | undefined;
    ohneKEDiagrammen?: boolean;
    titel?: string | undefined;
    titelFont?: string | undefined;
    titelFontSize?: number;
    titelFarbe?: string | undefined;
    hintergrundFarbe?: string | undefined;
    ubwDisplayValPj?: number;

    constructor(data?: IBildEinstellungen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hoehe = _data["hoehe"];
            this.breite = _data["breite"];
            this.hoeheDiagram = _data["hoeheDiagram"];
            this.breiteDiagram = _data["breiteDiagram"];
            this.xDiagram = _data["xDiagram"];
            this.yDiagram = _data["yDiagram"];
            this.xLegende = _data["xLegende"];
            this.yLegende = _data["yLegende"];
            this.legendenFont = _data["legendenFont"];
            this.legendenFontSize = _data["legendenFontSize"];
            this.legendenFarbe = _data["legendenFarbe"];
            this.legendeMaxBreite = _data["legendeMaxBreite"];
            this.legendenBoxFarbe = _data["legendenBoxFarbe"];
            this.labelFont = _data["labelFont"];
            this.labelFontSize = _data["labelFontSize"];
            this.labelFarbe = _data["labelFarbe"];
            this.labelFontAngle = _data["labelFontAngle"];
            this.yLabelFont = _data["yLabelFont"];
            this.yLabelFontSize = _data["yLabelFontSize"];
            this.yLabelFarbe = _data["yLabelFarbe"];
            this.yLabelFontAngle = _data["yLabelFontAngle"];
            this.mitHHStellen = _data["mitHHStellen"];
            this.eaType = _data["eaType"];
            this.pieLabelsSeitlich = _data["pieLabelsSeitlich"];
            this.pieFlat = _data["pieFlat"];
            this.pieText = _data["pieText"];
            this.ohneKEDiagrammen = _data["ohneKEDiagrammen"];
            this.titel = _data["titel"];
            this.titelFont = _data["titelFont"];
            this.titelFontSize = _data["titelFontSize"];
            this.titelFarbe = _data["titelFarbe"];
            this.hintergrundFarbe = _data["hintergrundFarbe"];
            this.ubwDisplayValPj = _data["ubwDisplayValPj"];
        }
    }

    static fromJS(data: any): BildEinstellungen {
        data = typeof data === 'object' ? data : {};
        let result = new BildEinstellungen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hoehe"] = this.hoehe;
        data["breite"] = this.breite;
        data["hoeheDiagram"] = this.hoeheDiagram;
        data["breiteDiagram"] = this.breiteDiagram;
        data["xDiagram"] = this.xDiagram;
        data["yDiagram"] = this.yDiagram;
        data["xLegende"] = this.xLegende;
        data["yLegende"] = this.yLegende;
        data["legendenFont"] = this.legendenFont;
        data["legendenFontSize"] = this.legendenFontSize;
        data["legendenFarbe"] = this.legendenFarbe;
        data["legendeMaxBreite"] = this.legendeMaxBreite;
        data["legendenBoxFarbe"] = this.legendenBoxFarbe;
        data["labelFont"] = this.labelFont;
        data["labelFontSize"] = this.labelFontSize;
        data["labelFarbe"] = this.labelFarbe;
        data["labelFontAngle"] = this.labelFontAngle;
        data["yLabelFont"] = this.yLabelFont;
        data["yLabelFontSize"] = this.yLabelFontSize;
        data["yLabelFarbe"] = this.yLabelFarbe;
        data["yLabelFontAngle"] = this.yLabelFontAngle;
        data["mitHHStellen"] = this.mitHHStellen;
        data["eaType"] = this.eaType;
        data["pieLabelsSeitlich"] = this.pieLabelsSeitlich;
        data["pieFlat"] = this.pieFlat;
        data["pieText"] = this.pieText;
        data["ohneKEDiagrammen"] = this.ohneKEDiagrammen;
        data["titel"] = this.titel;
        data["titelFont"] = this.titelFont;
        data["titelFontSize"] = this.titelFontSize;
        data["titelFarbe"] = this.titelFarbe;
        data["hintergrundFarbe"] = this.hintergrundFarbe;
        data["ubwDisplayValPj"] = this.ubwDisplayValPj;
        return data;
    }
}

export interface IBildEinstellungen {
    hoehe?: number;
    breite?: number;
    hoeheDiagram?: number;
    breiteDiagram?: number;
    xDiagram?: number;
    yDiagram?: number;
    xLegende?: number;
    yLegende?: number;
    legendenFont?: string | undefined;
    legendenFontSize?: number;
    legendenFarbe?: string | undefined;
    legendeMaxBreite?: number;
    legendenBoxFarbe?: string | undefined;
    labelFont?: string | undefined;
    labelFontSize?: number;
    labelFarbe?: string | undefined;
    labelFontAngle?: number;
    yLabelFont?: string | undefined;
    yLabelFontSize?: number;
    yLabelFarbe?: string | undefined;
    yLabelFontAngle?: number;
    mitHHStellen?: boolean;
    eaType?: number;
    pieLabelsSeitlich?: boolean;
    pieFlat?: boolean;
    pieText?: string | undefined;
    ohneKEDiagrammen?: boolean;
    titel?: string | undefined;
    titelFont?: string | undefined;
    titelFontSize?: number;
    titelFarbe?: string | undefined;
    hintergrundFarbe?: string | undefined;
    ubwDisplayValPj?: number;
}

export class Bilder implements IBilder {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    typ?: number;
    url?: string | undefined;

    constructor(data?: IBilder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.bezeichnung = _data["bezeichnung"];
            this.typ = _data["typ"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): Bilder {
        data = typeof data === 'object' ? data : {};
        let result = new Bilder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["bezeichnung"] = this.bezeichnung;
        data["typ"] = this.typ;
        data["url"] = this.url;
        return data;
    }
}

export interface IBilder {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    typ?: number;
    url?: string | undefined;
}

export class Bildertypen implements IBildertypen {
    id?: number | undefined;
    bezeichnung?: string | undefined;

    constructor(data?: IBildertypen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
        }
    }

    static fromJS(data: any): Bildertypen {
        data = typeof data === 'object' ? data : {};
        let result = new Bildertypen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        return data;
    }
}

export interface IBildertypen {
    id?: number | undefined;
    bezeichnung?: string | undefined;
}

export class Border implements IBorder {
    width?: Size;
    style?: BorderStyle;
    color?: string | undefined;

    constructor(data?: IBorder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.width = _data["width"] ? Size.fromJS(_data["width"]) : <any>undefined;
            this.style = _data["style"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): Border {
        data = typeof data === 'object' ? data : {};
        let result = new Border();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["width"] = this.width ? this.width.toJSON() : <any>undefined;
        data["style"] = this.style;
        data["color"] = this.color;
        return data;
    }
}

export interface IBorder {
    width?: Size;
    style?: BorderStyle;
    color?: string | undefined;
}

export class BorderLineWidth implements IBorderLineWidth {
    innerLineWidth?: Size;
    distance?: Size;
    outerLineWidth?: Size;

    constructor(data?: IBorderLineWidth) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.innerLineWidth = _data["innerLineWidth"] ? Size.fromJS(_data["innerLineWidth"]) : <any>undefined;
            this.distance = _data["distance"] ? Size.fromJS(_data["distance"]) : <any>undefined;
            this.outerLineWidth = _data["outerLineWidth"] ? Size.fromJS(_data["outerLineWidth"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BorderLineWidth {
        data = typeof data === 'object' ? data : {};
        let result = new BorderLineWidth();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["innerLineWidth"] = this.innerLineWidth ? this.innerLineWidth.toJSON() : <any>undefined;
        data["distance"] = this.distance ? this.distance.toJSON() : <any>undefined;
        data["outerLineWidth"] = this.outerLineWidth ? this.outerLineWidth.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBorderLineWidth {
    innerLineWidth?: Size;
    distance?: Size;
    outerLineWidth?: Size;
}

export enum BorderStyle {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
}

export enum Break {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class Bundeslaender implements IBundeslaender {
    bundesland?: string | undefined;
    ertragskonten?: string | undefined;
    aufwendungskonten?: string | undefined;
    einzahlungskonten?: string | undefined;
    auszahlungskonten?: string | undefined;
    sollkonten?: string | undefined;
    habenkonten?: string | undefined;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    passivakonten?: string | undefined;
    aktivakonten?: string | undefined;
    nichtPlanbar?: string | undefined;
    pseudoKontoE?: string | undefined;
    pseudoKontoA?: string | undefined;
    nichtFprelevant?: string | undefined;
    invertKonten?: string | undefined;
    inAnsNaAr?: string | undefined;
    erfolgsKontenInv?: string | undefined;
    bilanzKontenInv?: string | undefined;
    bestandsAuszahlungsKonten?: string | undefined;
    bestandsEinzahlungsKonten?: string | undefined;
    glMinAw?: string | undefined;
    doppisch?: boolean | undefined;
    kameral?: boolean | undefined;

    constructor(data?: IBundeslaender) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bundesland = _data["bundesland"];
            this.ertragskonten = _data["ertragskonten"];
            this.aufwendungskonten = _data["aufwendungskonten"];
            this.einzahlungskonten = _data["einzahlungskonten"];
            this.auszahlungskonten = _data["auszahlungskonten"];
            this.sollkonten = _data["sollkonten"];
            this.habenkonten = _data["habenkonten"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.passivakonten = _data["passivakonten"];
            this.aktivakonten = _data["aktivakonten"];
            this.nichtPlanbar = _data["nichtPlanbar"];
            this.pseudoKontoE = _data["pseudoKontoE"];
            this.pseudoKontoA = _data["pseudoKontoA"];
            this.nichtFprelevant = _data["nichtFprelevant"];
            this.invertKonten = _data["invertKonten"];
            this.inAnsNaAr = _data["inAnsNaAr"];
            this.erfolgsKontenInv = _data["erfolgsKontenInv"];
            this.bilanzKontenInv = _data["bilanzKontenInv"];
            this.bestandsAuszahlungsKonten = _data["bestandsAuszahlungsKonten"];
            this.bestandsEinzahlungsKonten = _data["bestandsEinzahlungsKonten"];
            this.glMinAw = _data["glMinAw"];
            this.doppisch = _data["doppisch"];
            this.kameral = _data["kameral"];
        }
    }

    static fromJS(data: any): Bundeslaender {
        data = typeof data === 'object' ? data : {};
        let result = new Bundeslaender();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bundesland"] = this.bundesland;
        data["ertragskonten"] = this.ertragskonten;
        data["aufwendungskonten"] = this.aufwendungskonten;
        data["einzahlungskonten"] = this.einzahlungskonten;
        data["auszahlungskonten"] = this.auszahlungskonten;
        data["sollkonten"] = this.sollkonten;
        data["habenkonten"] = this.habenkonten;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["passivakonten"] = this.passivakonten;
        data["aktivakonten"] = this.aktivakonten;
        data["nichtPlanbar"] = this.nichtPlanbar;
        data["pseudoKontoE"] = this.pseudoKontoE;
        data["pseudoKontoA"] = this.pseudoKontoA;
        data["nichtFprelevant"] = this.nichtFprelevant;
        data["invertKonten"] = this.invertKonten;
        data["inAnsNaAr"] = this.inAnsNaAr;
        data["erfolgsKontenInv"] = this.erfolgsKontenInv;
        data["bilanzKontenInv"] = this.bilanzKontenInv;
        data["bestandsAuszahlungsKonten"] = this.bestandsAuszahlungsKonten;
        data["bestandsEinzahlungsKonten"] = this.bestandsEinzahlungsKonten;
        data["glMinAw"] = this.glMinAw;
        data["doppisch"] = this.doppisch;
        data["kameral"] = this.kameral;
        return data;
    }
}

export interface IBundeslaender {
    bundesland?: string | undefined;
    ertragskonten?: string | undefined;
    aufwendungskonten?: string | undefined;
    einzahlungskonten?: string | undefined;
    auszahlungskonten?: string | undefined;
    sollkonten?: string | undefined;
    habenkonten?: string | undefined;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    passivakonten?: string | undefined;
    aktivakonten?: string | undefined;
    nichtPlanbar?: string | undefined;
    pseudoKontoE?: string | undefined;
    pseudoKontoA?: string | undefined;
    nichtFprelevant?: string | undefined;
    invertKonten?: string | undefined;
    inAnsNaAr?: string | undefined;
    erfolgsKontenInv?: string | undefined;
    bilanzKontenInv?: string | undefined;
    bestandsAuszahlungsKonten?: string | undefined;
    bestandsEinzahlungsKonten?: string | undefined;
    glMinAw?: string | undefined;
    doppisch?: boolean | undefined;
    kameral?: boolean | undefined;
}

export class CalcPMDoppischModel implements ICalcPMDoppischModel {
    uhConfig?: number;
    planstufe?: number;
    kommentar?: string | undefined;
    kommentarMode?: number;
    kommentarTrenn?: string | undefined;
    term?: string | undefined;
    uhhsList?: UHHSDoppischModel[] | undefined;
    uhmnList?: UHMNDoppischModel[] | undefined;

    constructor(data?: ICalcPMDoppischModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uhConfig = _data["uhConfig"];
            this.planstufe = _data["planstufe"];
            this.kommentar = _data["kommentar"];
            this.kommentarMode = _data["kommentarMode"];
            this.kommentarTrenn = _data["kommentarTrenn"];
            this.term = _data["term"];
            if (Array.isArray(_data["uhhsList"])) {
                this.uhhsList = [] as any;
                for (let item of _data["uhhsList"])
                    this.uhhsList!.push(UHHSDoppischModel.fromJS(item));
            }
            if (Array.isArray(_data["uhmnList"])) {
                this.uhmnList = [] as any;
                for (let item of _data["uhmnList"])
                    this.uhmnList!.push(UHMNDoppischModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CalcPMDoppischModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalcPMDoppischModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uhConfig"] = this.uhConfig;
        data["planstufe"] = this.planstufe;
        data["kommentar"] = this.kommentar;
        data["kommentarMode"] = this.kommentarMode;
        data["kommentarTrenn"] = this.kommentarTrenn;
        data["term"] = this.term;
        if (Array.isArray(this.uhhsList)) {
            data["uhhsList"] = [];
            for (let item of this.uhhsList)
                data["uhhsList"].push(item.toJSON());
        }
        if (Array.isArray(this.uhmnList)) {
            data["uhmnList"] = [];
            for (let item of this.uhmnList)
                data["uhmnList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICalcPMDoppischModel {
    uhConfig?: number;
    planstufe?: number;
    kommentar?: string | undefined;
    kommentarMode?: number;
    kommentarTrenn?: string | undefined;
    term?: string | undefined;
    uhhsList?: UHHSDoppischModel[] | undefined;
    uhmnList?: UHMNDoppischModel[] | undefined;
}

export class CalcPMKameralModel implements ICalcPMKameralModel {
    uhConfig?: number;
    planstufe?: number;
    kommentar?: string | undefined;
    kommentarMode?: number;
    kommentarTrenn?: string | undefined;
    term?: string | undefined;
    uhhsList?: UHHSKameralModel[] | undefined;

    constructor(data?: ICalcPMKameralModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uhConfig = _data["uhConfig"];
            this.planstufe = _data["planstufe"];
            this.kommentar = _data["kommentar"];
            this.kommentarMode = _data["kommentarMode"];
            this.kommentarTrenn = _data["kommentarTrenn"];
            this.term = _data["term"];
            if (Array.isArray(_data["uhhsList"])) {
                this.uhhsList = [] as any;
                for (let item of _data["uhhsList"])
                    this.uhhsList!.push(UHHSKameralModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CalcPMKameralModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalcPMKameralModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uhConfig"] = this.uhConfig;
        data["planstufe"] = this.planstufe;
        data["kommentar"] = this.kommentar;
        data["kommentarMode"] = this.kommentarMode;
        data["kommentarTrenn"] = this.kommentarTrenn;
        data["term"] = this.term;
        if (Array.isArray(this.uhhsList)) {
            data["uhhsList"] = [];
            for (let item of this.uhhsList)
                data["uhhsList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICalcPMKameralModel {
    uhConfig?: number;
    planstufe?: number;
    kommentar?: string | undefined;
    kommentarMode?: number;
    kommentarTrenn?: string | undefined;
    term?: string | undefined;
    uhhsList?: UHHSKameralModel[] | undefined;
}

export class CalcPlanDoppischModel implements ICalcPlanDoppischModel {
    plantyp?: number;
    planstufe?: number;
    basisJahr?: number;
    endJahr?: number;
    operator?: string;
    zinseszins?: boolean;
    updateBasisJahr?: boolean;
    term?: string | undefined;
    hhspList?: HHSPlanDoppischModel[] | undefined;
    mnpList?: MNPlanDoppischModel[] | undefined;
    jahr?: number;

    constructor(data?: ICalcPlanDoppischModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plantyp = _data["plantyp"];
            this.planstufe = _data["planstufe"];
            this.basisJahr = _data["basisJahr"];
            this.endJahr = _data["endJahr"];
            this.operator = _data["operator"];
            this.zinseszins = _data["zinseszins"];
            this.updateBasisJahr = _data["updateBasisJahr"];
            this.term = _data["term"];
            if (Array.isArray(_data["hhspList"])) {
                this.hhspList = [] as any;
                for (let item of _data["hhspList"])
                    this.hhspList!.push(HHSPlanDoppischModel.fromJS(item));
            }
            if (Array.isArray(_data["mnpList"])) {
                this.mnpList = [] as any;
                for (let item of _data["mnpList"])
                    this.mnpList!.push(MNPlanDoppischModel.fromJS(item));
            }
            this.jahr = _data["jahr"];
        }
    }

    static fromJS(data: any): CalcPlanDoppischModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalcPlanDoppischModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plantyp"] = this.plantyp;
        data["planstufe"] = this.planstufe;
        data["basisJahr"] = this.basisJahr;
        data["endJahr"] = this.endJahr;
        data["operator"] = this.operator;
        data["zinseszins"] = this.zinseszins;
        data["updateBasisJahr"] = this.updateBasisJahr;
        data["term"] = this.term;
        if (Array.isArray(this.hhspList)) {
            data["hhspList"] = [];
            for (let item of this.hhspList)
                data["hhspList"].push(item.toJSON());
        }
        if (Array.isArray(this.mnpList)) {
            data["mnpList"] = [];
            for (let item of this.mnpList)
                data["mnpList"].push(item.toJSON());
        }
        data["jahr"] = this.jahr;
        return data;
    }
}

export interface ICalcPlanDoppischModel {
    plantyp?: number;
    planstufe?: number;
    basisJahr?: number;
    endJahr?: number;
    operator?: string;
    zinseszins?: boolean;
    updateBasisJahr?: boolean;
    term?: string | undefined;
    hhspList?: HHSPlanDoppischModel[] | undefined;
    mnpList?: MNPlanDoppischModel[] | undefined;
    jahr?: number;
}

export class CalcPlanKameralModel implements ICalcPlanKameralModel {
    plantyp?: number;
    planstufe?: number;
    basisJahr?: number;
    endJahr?: number;
    operator?: string;
    zinseszins?: boolean;
    updateBasisJahr?: boolean;
    term?: string | undefined;
    hhspList?: HHSPlanKameralModel[] | undefined;
    jahr?: number;

    constructor(data?: ICalcPlanKameralModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plantyp = _data["plantyp"];
            this.planstufe = _data["planstufe"];
            this.basisJahr = _data["basisJahr"];
            this.endJahr = _data["endJahr"];
            this.operator = _data["operator"];
            this.zinseszins = _data["zinseszins"];
            this.updateBasisJahr = _data["updateBasisJahr"];
            this.term = _data["term"];
            if (Array.isArray(_data["hhspList"])) {
                this.hhspList = [] as any;
                for (let item of _data["hhspList"])
                    this.hhspList!.push(HHSPlanKameralModel.fromJS(item));
            }
            this.jahr = _data["jahr"];
        }
    }

    static fromJS(data: any): CalcPlanKameralModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalcPlanKameralModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plantyp"] = this.plantyp;
        data["planstufe"] = this.planstufe;
        data["basisJahr"] = this.basisJahr;
        data["endJahr"] = this.endJahr;
        data["operator"] = this.operator;
        data["zinseszins"] = this.zinseszins;
        data["updateBasisJahr"] = this.updateBasisJahr;
        data["term"] = this.term;
        if (Array.isArray(this.hhspList)) {
            data["hhspList"] = [];
            for (let item of this.hhspList)
                data["hhspList"].push(item.toJSON());
        }
        data["jahr"] = this.jahr;
        return data;
    }
}

export interface ICalcPlanKameralModel {
    plantyp?: number;
    planstufe?: number;
    basisJahr?: number;
    endJahr?: number;
    operator?: string;
    zinseszins?: boolean;
    updateBasisJahr?: boolean;
    term?: string | undefined;
    hhspList?: HHSPlanKameralModel[] | undefined;
    jahr?: number;
}

export class Cell implements ICell {
    readonly content?: ICellContent[] | undefined;
    numberOfRepeatedCells?: number;
    spannedColumnsCount?: number;
    spannedRowsCount?: number;
    matrixColumnsSpannedCount?: number;
    matrixRowsSpannedCount?: number;
    formula?: string | undefined;
    currency?: string | undefined;
    style?: string | undefined;
    contentValidation?: string | undefined;
    type?: CellValueType;
    value?: string | undefined;

    constructor(data?: ICell) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["content"])) {
                (<any>this).content = [] as any;
                for (let item of _data["content"])
                    (<any>this).content!.push(ICellContent.fromJS(item));
            }
            this.numberOfRepeatedCells = _data["numberOfRepeatedCells"];
            this.spannedColumnsCount = _data["spannedColumnsCount"];
            this.spannedRowsCount = _data["spannedRowsCount"];
            this.matrixColumnsSpannedCount = _data["matrixColumnsSpannedCount"];
            this.matrixRowsSpannedCount = _data["matrixRowsSpannedCount"];
            this.formula = _data["formula"];
            this.currency = _data["currency"];
            this.style = _data["style"];
            this.contentValidation = _data["contentValidation"];
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Cell {
        data = typeof data === 'object' ? data : {};
        let result = new Cell();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.content)) {
            data["content"] = [];
            for (let item of this.content)
                data["content"].push(item.toJSON());
        }
        data["numberOfRepeatedCells"] = this.numberOfRepeatedCells;
        data["spannedColumnsCount"] = this.spannedColumnsCount;
        data["spannedRowsCount"] = this.spannedRowsCount;
        data["matrixColumnsSpannedCount"] = this.matrixColumnsSpannedCount;
        data["matrixRowsSpannedCount"] = this.matrixRowsSpannedCount;
        data["formula"] = this.formula;
        data["currency"] = this.currency;
        data["style"] = this.style;
        data["contentValidation"] = this.contentValidation;
        data["type"] = this.type;
        data["value"] = this.value;
        return data;
    }
}

export interface ICell {
    content?: ICellContent[] | undefined;
    numberOfRepeatedCells?: number;
    spannedColumnsCount?: number;
    spannedRowsCount?: number;
    matrixColumnsSpannedCount?: number;
    matrixRowsSpannedCount?: number;
    formula?: string | undefined;
    currency?: string | undefined;
    style?: string | undefined;
    contentValidation?: string | undefined;
    type?: CellValueType;
    value?: string | undefined;
}

export class CellPropertiesModel implements ICellPropertiesModel {
    verticalAlignment?: CellVerticalAlignment;
    backgroundColor?: string | undefined;
    border?: Border;
    leftBorder?: Border;
    rightBorder?: Border;
    topBorder?: Border;
    bottomBorder?: Border;
    borderLineWidth?: BorderLineWidth;
    leftBorderLineWidth?: BorderLineWidth;
    rightBorderLineWidth?: BorderLineWidth;
    topBorderLineWidth?: BorderLineWidth;
    bottomBorderLineWidth?: BorderLineWidth;
    padding?: Size;
    leftPadding?: Size;
    rightPadding?: Size;
    topPadding?: Size;
    bottomPadding?: Size;
    margin?: Size;
    leftMargin?: Size;
    rightMargin?: Size;
    topMargin?: Size;
    bottomMargin?: Size;
    textAlignmentSource?: TextAlignmentSource;
    direction?: Direction;
    verticalGlyphOrientation?: VerticalGlyphOrientation;
    shrinkToFit?: boolean;
    repeatContent?: boolean;
    decimalPlaces?: number;
    printContent?: boolean;
    cellProtect?: CellProtectType;
    rotationAlignment?: RotationAlignment;
    rotationAngle?: number;
    enableWrap?: boolean;
    shadow?: string | undefined;
    writingMode?: WritingMode;
    backgroundImage?: BackgroundImage;

    constructor(data?: ICellPropertiesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verticalAlignment = _data["verticalAlignment"];
            this.backgroundColor = _data["backgroundColor"];
            this.border = _data["border"] ? Border.fromJS(_data["border"]) : <any>undefined;
            this.leftBorder = _data["leftBorder"] ? Border.fromJS(_data["leftBorder"]) : <any>undefined;
            this.rightBorder = _data["rightBorder"] ? Border.fromJS(_data["rightBorder"]) : <any>undefined;
            this.topBorder = _data["topBorder"] ? Border.fromJS(_data["topBorder"]) : <any>undefined;
            this.bottomBorder = _data["bottomBorder"] ? Border.fromJS(_data["bottomBorder"]) : <any>undefined;
            this.borderLineWidth = _data["borderLineWidth"] ? BorderLineWidth.fromJS(_data["borderLineWidth"]) : <any>undefined;
            this.leftBorderLineWidth = _data["leftBorderLineWidth"] ? BorderLineWidth.fromJS(_data["leftBorderLineWidth"]) : <any>undefined;
            this.rightBorderLineWidth = _data["rightBorderLineWidth"] ? BorderLineWidth.fromJS(_data["rightBorderLineWidth"]) : <any>undefined;
            this.topBorderLineWidth = _data["topBorderLineWidth"] ? BorderLineWidth.fromJS(_data["topBorderLineWidth"]) : <any>undefined;
            this.bottomBorderLineWidth = _data["bottomBorderLineWidth"] ? BorderLineWidth.fromJS(_data["bottomBorderLineWidth"]) : <any>undefined;
            this.padding = _data["padding"] ? Size.fromJS(_data["padding"]) : <any>undefined;
            this.leftPadding = _data["leftPadding"] ? Size.fromJS(_data["leftPadding"]) : <any>undefined;
            this.rightPadding = _data["rightPadding"] ? Size.fromJS(_data["rightPadding"]) : <any>undefined;
            this.topPadding = _data["topPadding"] ? Size.fromJS(_data["topPadding"]) : <any>undefined;
            this.bottomPadding = _data["bottomPadding"] ? Size.fromJS(_data["bottomPadding"]) : <any>undefined;
            this.margin = _data["margin"] ? Size.fromJS(_data["margin"]) : <any>undefined;
            this.leftMargin = _data["leftMargin"] ? Size.fromJS(_data["leftMargin"]) : <any>undefined;
            this.rightMargin = _data["rightMargin"] ? Size.fromJS(_data["rightMargin"]) : <any>undefined;
            this.topMargin = _data["topMargin"] ? Size.fromJS(_data["topMargin"]) : <any>undefined;
            this.bottomMargin = _data["bottomMargin"] ? Size.fromJS(_data["bottomMargin"]) : <any>undefined;
            this.textAlignmentSource = _data["textAlignmentSource"];
            this.direction = _data["direction"];
            this.verticalGlyphOrientation = _data["verticalGlyphOrientation"];
            this.shrinkToFit = _data["shrinkToFit"];
            this.repeatContent = _data["repeatContent"];
            this.decimalPlaces = _data["decimalPlaces"];
            this.printContent = _data["printContent"];
            this.cellProtect = _data["cellProtect"];
            this.rotationAlignment = _data["rotationAlignment"];
            this.rotationAngle = _data["rotationAngle"];
            this.enableWrap = _data["enableWrap"];
            this.shadow = _data["shadow"];
            this.writingMode = _data["writingMode"];
            this.backgroundImage = _data["backgroundImage"] ? BackgroundImage.fromJS(_data["backgroundImage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CellPropertiesModel {
        data = typeof data === 'object' ? data : {};
        let result = new CellPropertiesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verticalAlignment"] = this.verticalAlignment;
        data["backgroundColor"] = this.backgroundColor;
        data["border"] = this.border ? this.border.toJSON() : <any>undefined;
        data["leftBorder"] = this.leftBorder ? this.leftBorder.toJSON() : <any>undefined;
        data["rightBorder"] = this.rightBorder ? this.rightBorder.toJSON() : <any>undefined;
        data["topBorder"] = this.topBorder ? this.topBorder.toJSON() : <any>undefined;
        data["bottomBorder"] = this.bottomBorder ? this.bottomBorder.toJSON() : <any>undefined;
        data["borderLineWidth"] = this.borderLineWidth ? this.borderLineWidth.toJSON() : <any>undefined;
        data["leftBorderLineWidth"] = this.leftBorderLineWidth ? this.leftBorderLineWidth.toJSON() : <any>undefined;
        data["rightBorderLineWidth"] = this.rightBorderLineWidth ? this.rightBorderLineWidth.toJSON() : <any>undefined;
        data["topBorderLineWidth"] = this.topBorderLineWidth ? this.topBorderLineWidth.toJSON() : <any>undefined;
        data["bottomBorderLineWidth"] = this.bottomBorderLineWidth ? this.bottomBorderLineWidth.toJSON() : <any>undefined;
        data["padding"] = this.padding ? this.padding.toJSON() : <any>undefined;
        data["leftPadding"] = this.leftPadding ? this.leftPadding.toJSON() : <any>undefined;
        data["rightPadding"] = this.rightPadding ? this.rightPadding.toJSON() : <any>undefined;
        data["topPadding"] = this.topPadding ? this.topPadding.toJSON() : <any>undefined;
        data["bottomPadding"] = this.bottomPadding ? this.bottomPadding.toJSON() : <any>undefined;
        data["margin"] = this.margin ? this.margin.toJSON() : <any>undefined;
        data["leftMargin"] = this.leftMargin ? this.leftMargin.toJSON() : <any>undefined;
        data["rightMargin"] = this.rightMargin ? this.rightMargin.toJSON() : <any>undefined;
        data["topMargin"] = this.topMargin ? this.topMargin.toJSON() : <any>undefined;
        data["bottomMargin"] = this.bottomMargin ? this.bottomMargin.toJSON() : <any>undefined;
        data["textAlignmentSource"] = this.textAlignmentSource;
        data["direction"] = this.direction;
        data["verticalGlyphOrientation"] = this.verticalGlyphOrientation;
        data["shrinkToFit"] = this.shrinkToFit;
        data["repeatContent"] = this.repeatContent;
        data["decimalPlaces"] = this.decimalPlaces;
        data["printContent"] = this.printContent;
        data["cellProtect"] = this.cellProtect;
        data["rotationAlignment"] = this.rotationAlignment;
        data["rotationAngle"] = this.rotationAngle;
        data["enableWrap"] = this.enableWrap;
        data["shadow"] = this.shadow;
        data["writingMode"] = this.writingMode;
        data["backgroundImage"] = this.backgroundImage ? this.backgroundImage.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICellPropertiesModel {
    verticalAlignment?: CellVerticalAlignment;
    backgroundColor?: string | undefined;
    border?: Border;
    leftBorder?: Border;
    rightBorder?: Border;
    topBorder?: Border;
    bottomBorder?: Border;
    borderLineWidth?: BorderLineWidth;
    leftBorderLineWidth?: BorderLineWidth;
    rightBorderLineWidth?: BorderLineWidth;
    topBorderLineWidth?: BorderLineWidth;
    bottomBorderLineWidth?: BorderLineWidth;
    padding?: Size;
    leftPadding?: Size;
    rightPadding?: Size;
    topPadding?: Size;
    bottomPadding?: Size;
    margin?: Size;
    leftMargin?: Size;
    rightMargin?: Size;
    topMargin?: Size;
    bottomMargin?: Size;
    textAlignmentSource?: TextAlignmentSource;
    direction?: Direction;
    verticalGlyphOrientation?: VerticalGlyphOrientation;
    shrinkToFit?: boolean;
    repeatContent?: boolean;
    decimalPlaces?: number;
    printContent?: boolean;
    cellProtect?: CellProtectType;
    rotationAlignment?: RotationAlignment;
    rotationAngle?: number;
    enableWrap?: boolean;
    shadow?: string | undefined;
    writingMode?: WritingMode;
    backgroundImage?: BackgroundImage;
}

export enum CellProtectType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum CellValueType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export enum CellVerticalAlignment {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class ChangePasswordModel implements IChangePasswordModel {
    oldPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordModel {
    oldPassword: string;
    newPassword: string;
}

export class ChangeSetting implements IChangeSetting {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    lowValue?: number | undefined;
    medLowValue?: number | undefined;
    medHighValue?: number | undefined;
    highValue?: number | undefined;
    lowColor?: string | undefined;
    medLowColor?: string | undefined;
    evenColor?: string | undefined;
    medHighColor?: string | undefined;
    highColor?: string | undefined;
    lowValueA?: number | undefined;
    medLowValueA?: number | undefined;
    medHighValueA?: number | undefined;
    highValueA?: number | undefined;
    lowColorA?: string | undefined;
    medLowColorA?: string | undefined;
    evenColorA?: string | undefined;
    medHighColorA?: string | undefined;
    highColorA?: string | undefined;
    invertGr?: string | undefined;
    nichtFuerMn?: boolean | undefined;

    constructor(data?: IChangeSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.lowValue = _data["lowValue"];
            this.medLowValue = _data["medLowValue"];
            this.medHighValue = _data["medHighValue"];
            this.highValue = _data["highValue"];
            this.lowColor = _data["lowColor"];
            this.medLowColor = _data["medLowColor"];
            this.evenColor = _data["evenColor"];
            this.medHighColor = _data["medHighColor"];
            this.highColor = _data["highColor"];
            this.lowValueA = _data["lowValueA"];
            this.medLowValueA = _data["medLowValueA"];
            this.medHighValueA = _data["medHighValueA"];
            this.highValueA = _data["highValueA"];
            this.lowColorA = _data["lowColorA"];
            this.medLowColorA = _data["medLowColorA"];
            this.evenColorA = _data["evenColorA"];
            this.medHighColorA = _data["medHighColorA"];
            this.highColorA = _data["highColorA"];
            this.invertGr = _data["invertGr"];
            this.nichtFuerMn = _data["nichtFuerMn"];
        }
    }

    static fromJS(data: any): ChangeSetting {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["lowValue"] = this.lowValue;
        data["medLowValue"] = this.medLowValue;
        data["medHighValue"] = this.medHighValue;
        data["highValue"] = this.highValue;
        data["lowColor"] = this.lowColor;
        data["medLowColor"] = this.medLowColor;
        data["evenColor"] = this.evenColor;
        data["medHighColor"] = this.medHighColor;
        data["highColor"] = this.highColor;
        data["lowValueA"] = this.lowValueA;
        data["medLowValueA"] = this.medLowValueA;
        data["medHighValueA"] = this.medHighValueA;
        data["highValueA"] = this.highValueA;
        data["lowColorA"] = this.lowColorA;
        data["medLowColorA"] = this.medLowColorA;
        data["evenColorA"] = this.evenColorA;
        data["medHighColorA"] = this.medHighColorA;
        data["highColorA"] = this.highColorA;
        data["invertGr"] = this.invertGr;
        data["nichtFuerMn"] = this.nichtFuerMn;
        return data;
    }
}

export interface IChangeSetting {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    lowValue?: number | undefined;
    medLowValue?: number | undefined;
    medHighValue?: number | undefined;
    highValue?: number | undefined;
    lowColor?: string | undefined;
    medLowColor?: string | undefined;
    evenColor?: string | undefined;
    medHighColor?: string | undefined;
    highColor?: string | undefined;
    lowValueA?: number | undefined;
    medLowValueA?: number | undefined;
    medHighValueA?: number | undefined;
    highValueA?: number | undefined;
    lowColorA?: string | undefined;
    medLowColorA?: string | undefined;
    evenColorA?: string | undefined;
    medHighColorA?: string | undefined;
    highColorA?: string | undefined;
    invertGr?: string | undefined;
    nichtFuerMn?: boolean | undefined;
}

export class ChatNachricht implements IChatNachricht {
    frage?: string | undefined;
    answer?: string | undefined;
    confidence?: number;
    sources?: RagSource[] | undefined;
    datum?: Date;
    historieID?: number;
    bewertung?: number | undefined;
    daten?: DatenInhalt;

    constructor(data?: IChatNachricht) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.frage = _data["frage"];
            this.answer = _data["answer"];
            this.confidence = _data["confidence"];
            if (Array.isArray(_data["sources"])) {
                this.sources = [] as any;
                for (let item of _data["sources"])
                    this.sources!.push(RagSource.fromJS(item));
            }
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
            this.historieID = _data["historieID"];
            this.bewertung = _data["bewertung"];
            this.daten = _data["daten"] ? DatenInhalt.fromJS(_data["daten"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChatNachricht {
        data = typeof data === 'object' ? data : {};
        let result = new ChatNachricht();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["frage"] = this.frage;
        data["answer"] = this.answer;
        data["confidence"] = this.confidence;
        if (Array.isArray(this.sources)) {
            data["sources"] = [];
            for (let item of this.sources)
                data["sources"].push(item.toJSON());
        }
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        data["historieID"] = this.historieID;
        data["bewertung"] = this.bewertung;
        data["daten"] = this.daten ? this.daten.toJSON() : <any>undefined;
        return data;
    }
}

export interface IChatNachricht {
    frage?: string | undefined;
    answer?: string | undefined;
    confidence?: number;
    sources?: RagSource[] | undefined;
    datum?: Date;
    historieID?: number;
    bewertung?: number | undefined;
    daten?: DatenInhalt;
}

export class ChatUebersicht implements IChatUebersicht {
    threadID?: string | undefined;
    titel?: string | undefined;
    letzteAktivitaet?: Date;

    constructor(data?: IChatUebersicht) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.threadID = _data["threadID"];
            this.titel = _data["titel"];
            this.letzteAktivitaet = _data["letzteAktivitaet"] ? new Date(_data["letzteAktivitaet"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChatUebersicht {
        data = typeof data === 'object' ? data : {};
        let result = new ChatUebersicht();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["threadID"] = this.threadID;
        data["titel"] = this.titel;
        data["letzteAktivitaet"] = this.letzteAktivitaet ? this.letzteAktivitaet.toISOString() : <any>undefined;
        return data;
    }
}

export interface IChatUebersicht {
    threadID?: string | undefined;
    titel?: string | undefined;
    letzteAktivitaet?: Date;
}

export class ChatUmbenennenRequest implements IChatUmbenennenRequest {
    titel?: string | undefined;

    constructor(data?: IChatUmbenennenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titel = _data["titel"];
        }
    }

    static fromJS(data: any): ChatUmbenennenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChatUmbenennenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titel"] = this.titel;
        return data;
    }
}

export interface IChatUmbenennenRequest {
    titel?: string | undefined;
}

export class CopyModel implements ICopyModel {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    srcKunde?: number;
    srcGemeinde?: number;
    srcJahr?: number;
    prGl?: boolean;
    koGr?: boolean;
    suchTexte?: boolean;
    dokOrdner?: boolean;
    changeSettings?: boolean;
    hauptTexte?: boolean;
    menuTexte?: boolean;
    jrSettings?: boolean;
    kontenSettings?: boolean;
    hhsSettings?: boolean;
    templates?: boolean;
    abcSettings?: boolean;
    topEASettings?: boolean;
    investSettings?: boolean;
    dshp?: boolean;

    constructor(data?: ICopyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.srcKunde = _data["srcKunde"];
            this.srcGemeinde = _data["srcGemeinde"];
            this.srcJahr = _data["srcJahr"];
            this.prGl = _data["prGl"];
            this.koGr = _data["koGr"];
            this.suchTexte = _data["suchTexte"];
            this.dokOrdner = _data["dokOrdner"];
            this.changeSettings = _data["changeSettings"];
            this.hauptTexte = _data["hauptTexte"];
            this.menuTexte = _data["menuTexte"];
            this.jrSettings = _data["jrSettings"];
            this.kontenSettings = _data["kontenSettings"];
            this.hhsSettings = _data["hhsSettings"];
            this.templates = _data["templates"];
            this.abcSettings = _data["abcSettings"];
            this.topEASettings = _data["topEASettings"];
            this.investSettings = _data["investSettings"];
            this.dshp = _data["dshp"];
        }
    }

    static fromJS(data: any): CopyModel {
        data = typeof data === 'object' ? data : {};
        let result = new CopyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["srcKunde"] = this.srcKunde;
        data["srcGemeinde"] = this.srcGemeinde;
        data["srcJahr"] = this.srcJahr;
        data["prGl"] = this.prGl;
        data["koGr"] = this.koGr;
        data["suchTexte"] = this.suchTexte;
        data["dokOrdner"] = this.dokOrdner;
        data["changeSettings"] = this.changeSettings;
        data["hauptTexte"] = this.hauptTexte;
        data["menuTexte"] = this.menuTexte;
        data["jrSettings"] = this.jrSettings;
        data["kontenSettings"] = this.kontenSettings;
        data["hhsSettings"] = this.hhsSettings;
        data["templates"] = this.templates;
        data["abcSettings"] = this.abcSettings;
        data["topEASettings"] = this.topEASettings;
        data["investSettings"] = this.investSettings;
        data["dshp"] = this.dshp;
        return data;
    }
}

export interface ICopyModel {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    srcKunde?: number;
    srcGemeinde?: number;
    srcJahr?: number;
    prGl?: boolean;
    koGr?: boolean;
    suchTexte?: boolean;
    dokOrdner?: boolean;
    changeSettings?: boolean;
    hauptTexte?: boolean;
    menuTexte?: boolean;
    jrSettings?: boolean;
    kontenSettings?: boolean;
    hhsSettings?: boolean;
    templates?: boolean;
    abcSettings?: boolean;
    topEASettings?: boolean;
    investSettings?: boolean;
    dshp?: boolean;
}

export class DarstellungHp implements IDarstellungHp {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    hfarbePjhp?: string | undefined;
    vfarbePjhp?: string | undefined;
    startJahrHp?: number | undefined;
    endJahrHp?: number | undefined;
    hfarbeSumPjhp?: string | undefined;
    ansatzOhneDs?: boolean | undefined;
    nullAchseAnzeigen?: boolean | undefined;
    pjfarbenFuerBericht?: boolean | undefined;
    ansatzOhneDsfurBericht?: boolean | undefined;
    nullAchseAnzeigenFuerBericht?: boolean | undefined;
    tdtext?: string | undefined;
    tdfontSize?: number | undefined;
    tdlegend?: string | undefined;
    td3d?: boolean | undefined;
    pjfarbeFuerHover?: boolean | undefined;
    hfarbePjjr?: string | undefined;
    vfarbePjjr?: string | undefined;
    hfarbeSumPjjr?: string | undefined;
    jrfarbenFuerBericht?: boolean | undefined;
    jrfarbeFuerHover?: boolean | undefined;
    pvinBa?: boolean | undefined;
    pvinVa?: boolean | undefined;
    startJahrPv?: number | undefined;
    endJahrPv?: number | undefined;
    startJahrPlanung?: number | undefined;
    endJahrPlanung?: number | undefined;
    startJahrNa?: number | undefined;
    endJahrNa?: number | undefined;
    vjergAnzHp?: boolean | undefined;
    vjergAnzHpinBa?: boolean | undefined;
    pvnurAenderungen?: boolean | undefined;
    pvmarkAenderungen?: boolean | undefined;
    pvvfarbeAenderung?: string | undefined;
    pvhfarbeAenderung?: string | undefined;
    keinePrognose?: boolean | undefined;
    veinBa?: boolean | undefined;
    veinVa?: boolean | undefined;
    startJahrJr?: number | undefined;
    trendlinieAnzeigen?: boolean | undefined;
    rvnurAenderungen?: boolean | undefined;
    rvmarkAenderungen?: boolean | undefined;
    rvvfarbeAenderung?: string | undefined;
    rvhfarbeAenderung?: string | undefined;
    rvinBa?: boolean | undefined;
    rvinVa?: boolean | undefined;
    hpvorschlag?: boolean | undefined;
    berichtErstellenAnzeigen?: boolean | undefined;
    startJahrUbw?: number | undefined;
    keinVerfuegbarEinz?: boolean | undefined;
    fortAnsVjanz?: boolean | undefined;
    keineProgErrechnet?: boolean | undefined;
    historieVw?: boolean | undefined;
    vvjausJr?: boolean | undefined;
    ubwinTeur?: boolean | undefined;
    ubwNk?: number | undefined;
    jrVjaus?: boolean | undefined;
    pjm3ausJrhp?: boolean | undefined;

    constructor(data?: IDarstellungHp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.hfarbePjhp = _data["hfarbePjhp"];
            this.vfarbePjhp = _data["vfarbePjhp"];
            this.startJahrHp = _data["startJahrHp"];
            this.endJahrHp = _data["endJahrHp"];
            this.hfarbeSumPjhp = _data["hfarbeSumPjhp"];
            this.ansatzOhneDs = _data["ansatzOhneDs"];
            this.nullAchseAnzeigen = _data["nullAchseAnzeigen"];
            this.pjfarbenFuerBericht = _data["pjfarbenFuerBericht"];
            this.ansatzOhneDsfurBericht = _data["ansatzOhneDsfurBericht"];
            this.nullAchseAnzeigenFuerBericht = _data["nullAchseAnzeigenFuerBericht"];
            this.tdtext = _data["tdtext"];
            this.tdfontSize = _data["tdfontSize"];
            this.tdlegend = _data["tdlegend"];
            this.td3d = _data["td3d"];
            this.pjfarbeFuerHover = _data["pjfarbeFuerHover"];
            this.hfarbePjjr = _data["hfarbePjjr"];
            this.vfarbePjjr = _data["vfarbePjjr"];
            this.hfarbeSumPjjr = _data["hfarbeSumPjjr"];
            this.jrfarbenFuerBericht = _data["jrfarbenFuerBericht"];
            this.jrfarbeFuerHover = _data["jrfarbeFuerHover"];
            this.pvinBa = _data["pvinBa"];
            this.pvinVa = _data["pvinVa"];
            this.startJahrPv = _data["startJahrPv"];
            this.endJahrPv = _data["endJahrPv"];
            this.startJahrPlanung = _data["startJahrPlanung"];
            this.endJahrPlanung = _data["endJahrPlanung"];
            this.startJahrNa = _data["startJahrNa"];
            this.endJahrNa = _data["endJahrNa"];
            this.vjergAnzHp = _data["vjergAnzHp"];
            this.vjergAnzHpinBa = _data["vjergAnzHpinBa"];
            this.pvnurAenderungen = _data["pvnurAenderungen"];
            this.pvmarkAenderungen = _data["pvmarkAenderungen"];
            this.pvvfarbeAenderung = _data["pvvfarbeAenderung"];
            this.pvhfarbeAenderung = _data["pvhfarbeAenderung"];
            this.keinePrognose = _data["keinePrognose"];
            this.veinBa = _data["veinBa"];
            this.veinVa = _data["veinVa"];
            this.startJahrJr = _data["startJahrJr"];
            this.trendlinieAnzeigen = _data["trendlinieAnzeigen"];
            this.rvnurAenderungen = _data["rvnurAenderungen"];
            this.rvmarkAenderungen = _data["rvmarkAenderungen"];
            this.rvvfarbeAenderung = _data["rvvfarbeAenderung"];
            this.rvhfarbeAenderung = _data["rvhfarbeAenderung"];
            this.rvinBa = _data["rvinBa"];
            this.rvinVa = _data["rvinVa"];
            this.hpvorschlag = _data["hpvorschlag"];
            this.berichtErstellenAnzeigen = _data["berichtErstellenAnzeigen"];
            this.startJahrUbw = _data["startJahrUbw"];
            this.keinVerfuegbarEinz = _data["keinVerfuegbarEinz"];
            this.fortAnsVjanz = _data["fortAnsVjanz"];
            this.keineProgErrechnet = _data["keineProgErrechnet"];
            this.historieVw = _data["historieVw"];
            this.vvjausJr = _data["vvjausJr"];
            this.ubwinTeur = _data["ubwinTeur"];
            this.ubwNk = _data["ubwNk"];
            this.jrVjaus = _data["jrVjaus"];
            this.pjm3ausJrhp = _data["pjm3ausJrhp"];
        }
    }

    static fromJS(data: any): DarstellungHp {
        data = typeof data === 'object' ? data : {};
        let result = new DarstellungHp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["hfarbePjhp"] = this.hfarbePjhp;
        data["vfarbePjhp"] = this.vfarbePjhp;
        data["startJahrHp"] = this.startJahrHp;
        data["endJahrHp"] = this.endJahrHp;
        data["hfarbeSumPjhp"] = this.hfarbeSumPjhp;
        data["ansatzOhneDs"] = this.ansatzOhneDs;
        data["nullAchseAnzeigen"] = this.nullAchseAnzeigen;
        data["pjfarbenFuerBericht"] = this.pjfarbenFuerBericht;
        data["ansatzOhneDsfurBericht"] = this.ansatzOhneDsfurBericht;
        data["nullAchseAnzeigenFuerBericht"] = this.nullAchseAnzeigenFuerBericht;
        data["tdtext"] = this.tdtext;
        data["tdfontSize"] = this.tdfontSize;
        data["tdlegend"] = this.tdlegend;
        data["td3d"] = this.td3d;
        data["pjfarbeFuerHover"] = this.pjfarbeFuerHover;
        data["hfarbePjjr"] = this.hfarbePjjr;
        data["vfarbePjjr"] = this.vfarbePjjr;
        data["hfarbeSumPjjr"] = this.hfarbeSumPjjr;
        data["jrfarbenFuerBericht"] = this.jrfarbenFuerBericht;
        data["jrfarbeFuerHover"] = this.jrfarbeFuerHover;
        data["pvinBa"] = this.pvinBa;
        data["pvinVa"] = this.pvinVa;
        data["startJahrPv"] = this.startJahrPv;
        data["endJahrPv"] = this.endJahrPv;
        data["startJahrPlanung"] = this.startJahrPlanung;
        data["endJahrPlanung"] = this.endJahrPlanung;
        data["startJahrNa"] = this.startJahrNa;
        data["endJahrNa"] = this.endJahrNa;
        data["vjergAnzHp"] = this.vjergAnzHp;
        data["vjergAnzHpinBa"] = this.vjergAnzHpinBa;
        data["pvnurAenderungen"] = this.pvnurAenderungen;
        data["pvmarkAenderungen"] = this.pvmarkAenderungen;
        data["pvvfarbeAenderung"] = this.pvvfarbeAenderung;
        data["pvhfarbeAenderung"] = this.pvhfarbeAenderung;
        data["keinePrognose"] = this.keinePrognose;
        data["veinBa"] = this.veinBa;
        data["veinVa"] = this.veinVa;
        data["startJahrJr"] = this.startJahrJr;
        data["trendlinieAnzeigen"] = this.trendlinieAnzeigen;
        data["rvnurAenderungen"] = this.rvnurAenderungen;
        data["rvmarkAenderungen"] = this.rvmarkAenderungen;
        data["rvvfarbeAenderung"] = this.rvvfarbeAenderung;
        data["rvhfarbeAenderung"] = this.rvhfarbeAenderung;
        data["rvinBa"] = this.rvinBa;
        data["rvinVa"] = this.rvinVa;
        data["hpvorschlag"] = this.hpvorschlag;
        data["berichtErstellenAnzeigen"] = this.berichtErstellenAnzeigen;
        data["startJahrUbw"] = this.startJahrUbw;
        data["keinVerfuegbarEinz"] = this.keinVerfuegbarEinz;
        data["fortAnsVjanz"] = this.fortAnsVjanz;
        data["keineProgErrechnet"] = this.keineProgErrechnet;
        data["historieVw"] = this.historieVw;
        data["vvjausJr"] = this.vvjausJr;
        data["ubwinTeur"] = this.ubwinTeur;
        data["ubwNk"] = this.ubwNk;
        data["jrVjaus"] = this.jrVjaus;
        data["pjm3ausJrhp"] = this.pjm3ausJrhp;
        return data;
    }
}

export interface IDarstellungHp {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    hfarbePjhp?: string | undefined;
    vfarbePjhp?: string | undefined;
    startJahrHp?: number | undefined;
    endJahrHp?: number | undefined;
    hfarbeSumPjhp?: string | undefined;
    ansatzOhneDs?: boolean | undefined;
    nullAchseAnzeigen?: boolean | undefined;
    pjfarbenFuerBericht?: boolean | undefined;
    ansatzOhneDsfurBericht?: boolean | undefined;
    nullAchseAnzeigenFuerBericht?: boolean | undefined;
    tdtext?: string | undefined;
    tdfontSize?: number | undefined;
    tdlegend?: string | undefined;
    td3d?: boolean | undefined;
    pjfarbeFuerHover?: boolean | undefined;
    hfarbePjjr?: string | undefined;
    vfarbePjjr?: string | undefined;
    hfarbeSumPjjr?: string | undefined;
    jrfarbenFuerBericht?: boolean | undefined;
    jrfarbeFuerHover?: boolean | undefined;
    pvinBa?: boolean | undefined;
    pvinVa?: boolean | undefined;
    startJahrPv?: number | undefined;
    endJahrPv?: number | undefined;
    startJahrPlanung?: number | undefined;
    endJahrPlanung?: number | undefined;
    startJahrNa?: number | undefined;
    endJahrNa?: number | undefined;
    vjergAnzHp?: boolean | undefined;
    vjergAnzHpinBa?: boolean | undefined;
    pvnurAenderungen?: boolean | undefined;
    pvmarkAenderungen?: boolean | undefined;
    pvvfarbeAenderung?: string | undefined;
    pvhfarbeAenderung?: string | undefined;
    keinePrognose?: boolean | undefined;
    veinBa?: boolean | undefined;
    veinVa?: boolean | undefined;
    startJahrJr?: number | undefined;
    trendlinieAnzeigen?: boolean | undefined;
    rvnurAenderungen?: boolean | undefined;
    rvmarkAenderungen?: boolean | undefined;
    rvvfarbeAenderung?: string | undefined;
    rvhfarbeAenderung?: string | undefined;
    rvinBa?: boolean | undefined;
    rvinVa?: boolean | undefined;
    hpvorschlag?: boolean | undefined;
    berichtErstellenAnzeigen?: boolean | undefined;
    startJahrUbw?: number | undefined;
    keinVerfuegbarEinz?: boolean | undefined;
    fortAnsVjanz?: boolean | undefined;
    keineProgErrechnet?: boolean | undefined;
    historieVw?: boolean | undefined;
    vvjausJr?: boolean | undefined;
    ubwinTeur?: boolean | undefined;
    ubwNk?: number | undefined;
    jrVjaus?: boolean | undefined;
    pjm3ausJrhp?: boolean | undefined;
}

export class Daten implements IDaten {
    id?: number;
    datensatz?: number;
    x?: number;
    y?: number;
    label?: string | undefined;
    datensatzNavigation?: Datensaetze;
    sdgDatenMetum?: SdgDatenMetum;

    constructor(data?: IDaten) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.datensatz = _data["datensatz"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.label = _data["label"];
            this.datensatzNavigation = _data["datensatzNavigation"] ? Datensaetze.fromJS(_data["datensatzNavigation"]) : <any>undefined;
            this.sdgDatenMetum = _data["sdgDatenMetum"] ? SdgDatenMetum.fromJS(_data["sdgDatenMetum"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Daten {
        data = typeof data === 'object' ? data : {};
        let result = new Daten();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["datensatz"] = this.datensatz;
        data["x"] = this.x;
        data["y"] = this.y;
        data["label"] = this.label;
        data["datensatzNavigation"] = this.datensatzNavigation ? this.datensatzNavigation.toJSON() : <any>undefined;
        data["sdgDatenMetum"] = this.sdgDatenMetum ? this.sdgDatenMetum.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDaten {
    id?: number;
    datensatz?: number;
    x?: number;
    y?: number;
    label?: string | undefined;
    datensatzNavigation?: Datensaetze;
    sdgDatenMetum?: SdgDatenMetum;
}

export class DatenFrageAntwort implements IDatenFrageAntwort {
    threadID?: string | undefined;
    historieID?: number;
    titel?: string | undefined;
    bloecke?: AntwortBlock[] | undefined;
    vorschlaege?: string[] | undefined;
    abgefragt?: string[] | undefined;
    quellen?: AntwortQuelle[] | undefined;

    constructor(data?: IDatenFrageAntwort) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.threadID = _data["threadID"];
            this.historieID = _data["historieID"];
            this.titel = _data["titel"];
            if (Array.isArray(_data["bloecke"])) {
                this.bloecke = [] as any;
                for (let item of _data["bloecke"])
                    this.bloecke!.push(AntwortBlock.fromJS(item));
            }
            if (Array.isArray(_data["vorschlaege"])) {
                this.vorschlaege = [] as any;
                for (let item of _data["vorschlaege"])
                    this.vorschlaege!.push(item);
            }
            if (Array.isArray(_data["abgefragt"])) {
                this.abgefragt = [] as any;
                for (let item of _data["abgefragt"])
                    this.abgefragt!.push(item);
            }
            if (Array.isArray(_data["quellen"])) {
                this.quellen = [] as any;
                for (let item of _data["quellen"])
                    this.quellen!.push(AntwortQuelle.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DatenFrageAntwort {
        data = typeof data === 'object' ? data : {};
        let result = new DatenFrageAntwort();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["threadID"] = this.threadID;
        data["historieID"] = this.historieID;
        data["titel"] = this.titel;
        if (Array.isArray(this.bloecke)) {
            data["bloecke"] = [];
            for (let item of this.bloecke)
                data["bloecke"].push(item.toJSON());
        }
        if (Array.isArray(this.vorschlaege)) {
            data["vorschlaege"] = [];
            for (let item of this.vorschlaege)
                data["vorschlaege"].push(item);
        }
        if (Array.isArray(this.abgefragt)) {
            data["abgefragt"] = [];
            for (let item of this.abgefragt)
                data["abgefragt"].push(item);
        }
        if (Array.isArray(this.quellen)) {
            data["quellen"] = [];
            for (let item of this.quellen)
                data["quellen"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDatenFrageAntwort {
    threadID?: string | undefined;
    historieID?: number;
    titel?: string | undefined;
    bloecke?: AntwortBlock[] | undefined;
    vorschlaege?: string[] | undefined;
    abgefragt?: string[] | undefined;
    quellen?: AntwortQuelle[] | undefined;
}

export class DatenFrageRequest implements IDatenFrageRequest {
    threadID?: string | undefined;
    frage?: string | undefined;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    plantyp?: number;
    planstufe?: number;
    verwaltung?: boolean;
    uhConfig?: number;

    constructor(data?: IDatenFrageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.threadID = _data["threadID"];
            this.frage = _data["frage"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.plantyp = _data["plantyp"];
            this.planstufe = _data["planstufe"];
            this.verwaltung = _data["verwaltung"];
            this.uhConfig = _data["uhConfig"];
        }
    }

    static fromJS(data: any): DatenFrageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DatenFrageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["threadID"] = this.threadID;
        data["frage"] = this.frage;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["plantyp"] = this.plantyp;
        data["planstufe"] = this.planstufe;
        data["verwaltung"] = this.verwaltung;
        data["uhConfig"] = this.uhConfig;
        return data;
    }
}

export interface IDatenFrageRequest {
    threadID?: string | undefined;
    frage?: string | undefined;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    plantyp?: number;
    planstufe?: number;
    verwaltung?: boolean;
    uhConfig?: number;
}

export class DatenInhalt implements IDatenInhalt {
    bloecke?: AntwortBlock[] | undefined;
    abgefragt?: string[] | undefined;
    vorschlaege?: string[] | undefined;
    plan?: string | undefined;

    constructor(data?: IDatenInhalt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["bloecke"])) {
                this.bloecke = [] as any;
                for (let item of _data["bloecke"])
                    this.bloecke!.push(AntwortBlock.fromJS(item));
            }
            if (Array.isArray(_data["abgefragt"])) {
                this.abgefragt = [] as any;
                for (let item of _data["abgefragt"])
                    this.abgefragt!.push(item);
            }
            if (Array.isArray(_data["vorschlaege"])) {
                this.vorschlaege = [] as any;
                for (let item of _data["vorschlaege"])
                    this.vorschlaege!.push(item);
            }
            this.plan = _data["plan"];
        }
    }

    static fromJS(data: any): DatenInhalt {
        data = typeof data === 'object' ? data : {};
        let result = new DatenInhalt();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bloecke)) {
            data["bloecke"] = [];
            for (let item of this.bloecke)
                data["bloecke"].push(item.toJSON());
        }
        if (Array.isArray(this.abgefragt)) {
            data["abgefragt"] = [];
            for (let item of this.abgefragt)
                data["abgefragt"].push(item);
        }
        if (Array.isArray(this.vorschlaege)) {
            data["vorschlaege"] = [];
            for (let item of this.vorschlaege)
                data["vorschlaege"].push(item);
        }
        data["plan"] = this.plan;
        return data;
    }
}

export interface IDatenInhalt {
    bloecke?: AntwortBlock[] | undefined;
    abgefragt?: string[] | undefined;
    vorschlaege?: string[] | undefined;
    plan?: string | undefined;
}

export class Datensaetze implements IDatensaetze {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    typ?: number;
    einheit?: string | undefined;
    tabId?: string | undefined;
    nachkommastellen?: number | undefined;
    gruppen?: string | undefined;
    proEinwohner?: boolean | undefined;
    keinDiagramm?: boolean | undefined;
    order?: number | undefined;
    axis?: number | undefined;
    nichtHp?: boolean | undefined;
    nichtJr?: boolean | undefined;
    gzebene?: string | undefined;
    produkt?: string | undefined;
    berechnung?: string | undefined;
    berechnungJr?: string | undefined;
    exogeneVar?: boolean | undefined;
    setId?: string | undefined;
    autoUpdateEnabled?: boolean | undefined;
    overwriteExisting?: boolean | undefined;
    lastAutoUpdate?: Date | undefined;
    lastDataHash?: string | undefined;
    updatedAt?: Date | undefined;
    wegweiserIndikatorId?: number | undefined;
    datens?: Daten[] | undefined;
    gemeinden?: Gemeinden;
    sdgEingabewertLinks?: SdgEingabewertLink[] | undefined;
    sdgIndikatorEingabes?: SdgIndikatorEingabe[] | undefined;
    sdgIndikators?: SdgIndikator[] | undefined;
    wegweiserIndikator?: WegweiserIndikator;

    constructor(data?: IDatensaetze) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.bezeichnung = _data["bezeichnung"];
            this.typ = _data["typ"];
            this.einheit = _data["einheit"];
            this.tabId = _data["tabId"];
            this.nachkommastellen = _data["nachkommastellen"];
            this.gruppen = _data["gruppen"];
            this.proEinwohner = _data["proEinwohner"];
            this.keinDiagramm = _data["keinDiagramm"];
            this.order = _data["order"];
            this.axis = _data["axis"];
            this.nichtHp = _data["nichtHp"];
            this.nichtJr = _data["nichtJr"];
            this.gzebene = _data["gzebene"];
            this.produkt = _data["produkt"];
            this.berechnung = _data["berechnung"];
            this.berechnungJr = _data["berechnungJr"];
            this.exogeneVar = _data["exogeneVar"];
            this.setId = _data["setId"];
            this.autoUpdateEnabled = _data["autoUpdateEnabled"];
            this.overwriteExisting = _data["overwriteExisting"];
            this.lastAutoUpdate = _data["lastAutoUpdate"] ? new Date(_data["lastAutoUpdate"].toString()) : <any>undefined;
            this.lastDataHash = _data["lastDataHash"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.wegweiserIndikatorId = _data["wegweiserIndikatorId"];
            if (Array.isArray(_data["datens"])) {
                this.datens = [] as any;
                for (let item of _data["datens"])
                    this.datens!.push(Daten.fromJS(item));
            }
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
            if (Array.isArray(_data["sdgEingabewertLinks"])) {
                this.sdgEingabewertLinks = [] as any;
                for (let item of _data["sdgEingabewertLinks"])
                    this.sdgEingabewertLinks!.push(SdgEingabewertLink.fromJS(item));
            }
            if (Array.isArray(_data["sdgIndikatorEingabes"])) {
                this.sdgIndikatorEingabes = [] as any;
                for (let item of _data["sdgIndikatorEingabes"])
                    this.sdgIndikatorEingabes!.push(SdgIndikatorEingabe.fromJS(item));
            }
            if (Array.isArray(_data["sdgIndikators"])) {
                this.sdgIndikators = [] as any;
                for (let item of _data["sdgIndikators"])
                    this.sdgIndikators!.push(SdgIndikator.fromJS(item));
            }
            this.wegweiserIndikator = _data["wegweiserIndikator"] ? WegweiserIndikator.fromJS(_data["wegweiserIndikator"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Datensaetze {
        data = typeof data === 'object' ? data : {};
        let result = new Datensaetze();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["bezeichnung"] = this.bezeichnung;
        data["typ"] = this.typ;
        data["einheit"] = this.einheit;
        data["tabId"] = this.tabId;
        data["nachkommastellen"] = this.nachkommastellen;
        data["gruppen"] = this.gruppen;
        data["proEinwohner"] = this.proEinwohner;
        data["keinDiagramm"] = this.keinDiagramm;
        data["order"] = this.order;
        data["axis"] = this.axis;
        data["nichtHp"] = this.nichtHp;
        data["nichtJr"] = this.nichtJr;
        data["gzebene"] = this.gzebene;
        data["produkt"] = this.produkt;
        data["berechnung"] = this.berechnung;
        data["berechnungJr"] = this.berechnungJr;
        data["exogeneVar"] = this.exogeneVar;
        data["setId"] = this.setId;
        data["autoUpdateEnabled"] = this.autoUpdateEnabled;
        data["overwriteExisting"] = this.overwriteExisting;
        data["lastAutoUpdate"] = this.lastAutoUpdate ? this.lastAutoUpdate.toISOString() : <any>undefined;
        data["lastDataHash"] = this.lastDataHash;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["wegweiserIndikatorId"] = this.wegweiserIndikatorId;
        if (Array.isArray(this.datens)) {
            data["datens"] = [];
            for (let item of this.datens)
                data["datens"].push(item.toJSON());
        }
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        if (Array.isArray(this.sdgEingabewertLinks)) {
            data["sdgEingabewertLinks"] = [];
            for (let item of this.sdgEingabewertLinks)
                data["sdgEingabewertLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.sdgIndikatorEingabes)) {
            data["sdgIndikatorEingabes"] = [];
            for (let item of this.sdgIndikatorEingabes)
                data["sdgIndikatorEingabes"].push(item.toJSON());
        }
        if (Array.isArray(this.sdgIndikators)) {
            data["sdgIndikators"] = [];
            for (let item of this.sdgIndikators)
                data["sdgIndikators"].push(item.toJSON());
        }
        data["wegweiserIndikator"] = this.wegweiserIndikator ? this.wegweiserIndikator.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDatensaetze {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    typ?: number;
    einheit?: string | undefined;
    tabId?: string | undefined;
    nachkommastellen?: number | undefined;
    gruppen?: string | undefined;
    proEinwohner?: boolean | undefined;
    keinDiagramm?: boolean | undefined;
    order?: number | undefined;
    axis?: number | undefined;
    nichtHp?: boolean | undefined;
    nichtJr?: boolean | undefined;
    gzebene?: string | undefined;
    produkt?: string | undefined;
    berechnung?: string | undefined;
    berechnungJr?: string | undefined;
    exogeneVar?: boolean | undefined;
    setId?: string | undefined;
    autoUpdateEnabled?: boolean | undefined;
    overwriteExisting?: boolean | undefined;
    lastAutoUpdate?: Date | undefined;
    lastDataHash?: string | undefined;
    updatedAt?: Date | undefined;
    wegweiserIndikatorId?: number | undefined;
    datens?: Daten[] | undefined;
    gemeinden?: Gemeinden;
    sdgEingabewertLinks?: SdgEingabewertLink[] | undefined;
    sdgIndikatorEingabes?: SdgIndikatorEingabe[] | undefined;
    sdgIndikators?: SdgIndikator[] | undefined;
    wegweiserIndikator?: WegweiserIndikator;
}

export class DatensatzModel implements IDatensatzModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    typ?: number;
    einheit?: string | undefined;
    tabId?: string | undefined;
    nachkommastellen?: number | undefined;
    gruppen?: string | undefined;
    proEinwohner?: boolean | undefined;
    keinDiagramm?: boolean | undefined;
    order?: number | undefined;
    axis?: number | undefined;
    nichtHp?: boolean | undefined;
    nichtJr?: boolean | undefined;
    gzebene?: string | undefined;
    produkt?: string | undefined;
    berechnung?: string | undefined;
    berechnungJr?: string | undefined;
    exogeneVar?: boolean | undefined;
    setId?: string | undefined;
    autoUpdateEnabled?: boolean | undefined;
    overwriteExisting?: boolean | undefined;
    lastAutoUpdate?: Date | undefined;
    lastDataHash?: string | undefined;
    updatedAt?: Date | undefined;
    wegweiserIndikatorId?: number | undefined;
    datens?: Daten[] | undefined;
    gemeinden?: Gemeinden;
    sdgEingabewertLinks?: SdgEingabewertLink[] | undefined;
    sdgIndikatorEingabes?: SdgIndikatorEingabe[] | undefined;
    sdgIndikators?: SdgIndikator[] | undefined;
    wegweiserIndikator?: WegweiserIndikator;
    gzEbeneBez?: string | undefined;
    edit?: boolean;

    constructor(data?: IDatensatzModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.bezeichnung = _data["bezeichnung"];
            this.typ = _data["typ"];
            this.einheit = _data["einheit"];
            this.tabId = _data["tabId"];
            this.nachkommastellen = _data["nachkommastellen"];
            this.gruppen = _data["gruppen"];
            this.proEinwohner = _data["proEinwohner"];
            this.keinDiagramm = _data["keinDiagramm"];
            this.order = _data["order"];
            this.axis = _data["axis"];
            this.nichtHp = _data["nichtHp"];
            this.nichtJr = _data["nichtJr"];
            this.gzebene = _data["gzebene"];
            this.produkt = _data["produkt"];
            this.berechnung = _data["berechnung"];
            this.berechnungJr = _data["berechnungJr"];
            this.exogeneVar = _data["exogeneVar"];
            this.setId = _data["setId"];
            this.autoUpdateEnabled = _data["autoUpdateEnabled"];
            this.overwriteExisting = _data["overwriteExisting"];
            this.lastAutoUpdate = _data["lastAutoUpdate"] ? new Date(_data["lastAutoUpdate"].toString()) : <any>undefined;
            this.lastDataHash = _data["lastDataHash"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.wegweiserIndikatorId = _data["wegweiserIndikatorId"];
            if (Array.isArray(_data["datens"])) {
                this.datens = [] as any;
                for (let item of _data["datens"])
                    this.datens!.push(Daten.fromJS(item));
            }
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
            if (Array.isArray(_data["sdgEingabewertLinks"])) {
                this.sdgEingabewertLinks = [] as any;
                for (let item of _data["sdgEingabewertLinks"])
                    this.sdgEingabewertLinks!.push(SdgEingabewertLink.fromJS(item));
            }
            if (Array.isArray(_data["sdgIndikatorEingabes"])) {
                this.sdgIndikatorEingabes = [] as any;
                for (let item of _data["sdgIndikatorEingabes"])
                    this.sdgIndikatorEingabes!.push(SdgIndikatorEingabe.fromJS(item));
            }
            if (Array.isArray(_data["sdgIndikators"])) {
                this.sdgIndikators = [] as any;
                for (let item of _data["sdgIndikators"])
                    this.sdgIndikators!.push(SdgIndikator.fromJS(item));
            }
            this.wegweiserIndikator = _data["wegweiserIndikator"] ? WegweiserIndikator.fromJS(_data["wegweiserIndikator"]) : <any>undefined;
            this.gzEbeneBez = _data["gzEbeneBez"];
            this.edit = _data["edit"];
        }
    }

    static fromJS(data: any): DatensatzModel {
        data = typeof data === 'object' ? data : {};
        let result = new DatensatzModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["bezeichnung"] = this.bezeichnung;
        data["typ"] = this.typ;
        data["einheit"] = this.einheit;
        data["tabId"] = this.tabId;
        data["nachkommastellen"] = this.nachkommastellen;
        data["gruppen"] = this.gruppen;
        data["proEinwohner"] = this.proEinwohner;
        data["keinDiagramm"] = this.keinDiagramm;
        data["order"] = this.order;
        data["axis"] = this.axis;
        data["nichtHp"] = this.nichtHp;
        data["nichtJr"] = this.nichtJr;
        data["gzebene"] = this.gzebene;
        data["produkt"] = this.produkt;
        data["berechnung"] = this.berechnung;
        data["berechnungJr"] = this.berechnungJr;
        data["exogeneVar"] = this.exogeneVar;
        data["setId"] = this.setId;
        data["autoUpdateEnabled"] = this.autoUpdateEnabled;
        data["overwriteExisting"] = this.overwriteExisting;
        data["lastAutoUpdate"] = this.lastAutoUpdate ? this.lastAutoUpdate.toISOString() : <any>undefined;
        data["lastDataHash"] = this.lastDataHash;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["wegweiserIndikatorId"] = this.wegweiserIndikatorId;
        if (Array.isArray(this.datens)) {
            data["datens"] = [];
            for (let item of this.datens)
                data["datens"].push(item.toJSON());
        }
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        if (Array.isArray(this.sdgEingabewertLinks)) {
            data["sdgEingabewertLinks"] = [];
            for (let item of this.sdgEingabewertLinks)
                data["sdgEingabewertLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.sdgIndikatorEingabes)) {
            data["sdgIndikatorEingabes"] = [];
            for (let item of this.sdgIndikatorEingabes)
                data["sdgIndikatorEingabes"].push(item.toJSON());
        }
        if (Array.isArray(this.sdgIndikators)) {
            data["sdgIndikators"] = [];
            for (let item of this.sdgIndikators)
                data["sdgIndikators"].push(item.toJSON());
        }
        data["wegweiserIndikator"] = this.wegweiserIndikator ? this.wegweiserIndikator.toJSON() : <any>undefined;
        data["gzEbeneBez"] = this.gzEbeneBez;
        data["edit"] = this.edit;
        return data;
    }
}

export interface IDatensatzModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    typ?: number;
    einheit?: string | undefined;
    tabId?: string | undefined;
    nachkommastellen?: number | undefined;
    gruppen?: string | undefined;
    proEinwohner?: boolean | undefined;
    keinDiagramm?: boolean | undefined;
    order?: number | undefined;
    axis?: number | undefined;
    nichtHp?: boolean | undefined;
    nichtJr?: boolean | undefined;
    gzebene?: string | undefined;
    produkt?: string | undefined;
    berechnung?: string | undefined;
    berechnungJr?: string | undefined;
    exogeneVar?: boolean | undefined;
    setId?: string | undefined;
    autoUpdateEnabled?: boolean | undefined;
    overwriteExisting?: boolean | undefined;
    lastAutoUpdate?: Date | undefined;
    lastDataHash?: string | undefined;
    updatedAt?: Date | undefined;
    wegweiserIndikatorId?: number | undefined;
    datens?: Daten[] | undefined;
    gemeinden?: Gemeinden;
    sdgEingabewertLinks?: SdgEingabewertLink[] | undefined;
    sdgIndikatorEingabes?: SdgIndikatorEingabe[] | undefined;
    sdgIndikators?: SdgIndikator[] | undefined;
    wegweiserIndikator?: WegweiserIndikator;
    gzEbeneBez?: string | undefined;
    edit?: boolean;
}

export class Datensatztypen implements IDatensatztypen {
    id?: number | undefined;
    bezeichnung?: string | undefined;

    constructor(data?: IDatensatztypen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
        }
    }

    static fromJS(data: any): Datensatztypen {
        data = typeof data === 'object' ? data : {};
        let result = new Datensatztypen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        return data;
    }
}

export interface IDatensatztypen {
    id?: number | undefined;
    bezeichnung?: string | undefined;
}

export class DesignConfigModel implements IDesignConfigModel {
    websiteBackgroundColor?: string | undefined;
    fontFamily?: string | undefined;
    textColor?: string | undefined;
    headingColor?: string | undefined;
    headingBold?: boolean;
    headerBgColor?: string | undefined;
    headerHeight?: number;
    headerGradientEnabled?: boolean;
    headerGradientColor?: string | undefined;
    headerGradientAngle?: number;
    headerGradientToWhite?: boolean;
    headlineMainColor?: string | undefined;
    headlineSecondColor?: string | undefined;
    tabStyle?: string | undefined;
    tabBorderColor?: string | undefined;
    tabTop?: TabLevelColors;
    tabMiddle?: TabLevelColors;
    tabBottom?: TabLevelColors;
    tabVeryBottom?: TabLevelColors;
    accordionBgColor?: string | undefined;
    accordionActiveBgColor?: string | undefined;
    accordionTextColor?: string | undefined;
    accordionContentBgColor?: string | undefined;
    accordionContentTextColor?: string | undefined;
    accordionMatchHeader?: boolean;
    buttonBgColor?: string | undefined;
    buttonHoverColor?: string | undefined;
    buttonTextColor?: string | undefined;
    logoUrl?: string | undefined;
    logoWidth?: number;
    logoHeight?: number;

    constructor(data?: IDesignConfigModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.websiteBackgroundColor = _data["websiteBackgroundColor"];
            this.fontFamily = _data["fontFamily"];
            this.textColor = _data["textColor"];
            this.headingColor = _data["headingColor"];
            this.headingBold = _data["headingBold"];
            this.headerBgColor = _data["headerBgColor"];
            this.headerHeight = _data["headerHeight"];
            this.headerGradientEnabled = _data["headerGradientEnabled"];
            this.headerGradientColor = _data["headerGradientColor"];
            this.headerGradientAngle = _data["headerGradientAngle"];
            this.headerGradientToWhite = _data["headerGradientToWhite"];
            this.headlineMainColor = _data["headlineMainColor"];
            this.headlineSecondColor = _data["headlineSecondColor"];
            this.tabStyle = _data["tabStyle"];
            this.tabBorderColor = _data["tabBorderColor"];
            this.tabTop = _data["tabTop"] ? TabLevelColors.fromJS(_data["tabTop"]) : <any>undefined;
            this.tabMiddle = _data["tabMiddle"] ? TabLevelColors.fromJS(_data["tabMiddle"]) : <any>undefined;
            this.tabBottom = _data["tabBottom"] ? TabLevelColors.fromJS(_data["tabBottom"]) : <any>undefined;
            this.tabVeryBottom = _data["tabVeryBottom"] ? TabLevelColors.fromJS(_data["tabVeryBottom"]) : <any>undefined;
            this.accordionBgColor = _data["accordionBgColor"];
            this.accordionActiveBgColor = _data["accordionActiveBgColor"];
            this.accordionTextColor = _data["accordionTextColor"];
            this.accordionContentBgColor = _data["accordionContentBgColor"];
            this.accordionContentTextColor = _data["accordionContentTextColor"];
            this.accordionMatchHeader = _data["accordionMatchHeader"];
            this.buttonBgColor = _data["buttonBgColor"];
            this.buttonHoverColor = _data["buttonHoverColor"];
            this.buttonTextColor = _data["buttonTextColor"];
            this.logoUrl = _data["logoUrl"];
            this.logoWidth = _data["logoWidth"];
            this.logoHeight = _data["logoHeight"];
        }
    }

    static fromJS(data: any): DesignConfigModel {
        data = typeof data === 'object' ? data : {};
        let result = new DesignConfigModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["websiteBackgroundColor"] = this.websiteBackgroundColor;
        data["fontFamily"] = this.fontFamily;
        data["textColor"] = this.textColor;
        data["headingColor"] = this.headingColor;
        data["headingBold"] = this.headingBold;
        data["headerBgColor"] = this.headerBgColor;
        data["headerHeight"] = this.headerHeight;
        data["headerGradientEnabled"] = this.headerGradientEnabled;
        data["headerGradientColor"] = this.headerGradientColor;
        data["headerGradientAngle"] = this.headerGradientAngle;
        data["headerGradientToWhite"] = this.headerGradientToWhite;
        data["headlineMainColor"] = this.headlineMainColor;
        data["headlineSecondColor"] = this.headlineSecondColor;
        data["tabStyle"] = this.tabStyle;
        data["tabBorderColor"] = this.tabBorderColor;
        data["tabTop"] = this.tabTop ? this.tabTop.toJSON() : <any>undefined;
        data["tabMiddle"] = this.tabMiddle ? this.tabMiddle.toJSON() : <any>undefined;
        data["tabBottom"] = this.tabBottom ? this.tabBottom.toJSON() : <any>undefined;
        data["tabVeryBottom"] = this.tabVeryBottom ? this.tabVeryBottom.toJSON() : <any>undefined;
        data["accordionBgColor"] = this.accordionBgColor;
        data["accordionActiveBgColor"] = this.accordionActiveBgColor;
        data["accordionTextColor"] = this.accordionTextColor;
        data["accordionContentBgColor"] = this.accordionContentBgColor;
        data["accordionContentTextColor"] = this.accordionContentTextColor;
        data["accordionMatchHeader"] = this.accordionMatchHeader;
        data["buttonBgColor"] = this.buttonBgColor;
        data["buttonHoverColor"] = this.buttonHoverColor;
        data["buttonTextColor"] = this.buttonTextColor;
        data["logoUrl"] = this.logoUrl;
        data["logoWidth"] = this.logoWidth;
        data["logoHeight"] = this.logoHeight;
        return data;
    }
}

export interface IDesignConfigModel {
    websiteBackgroundColor?: string | undefined;
    fontFamily?: string | undefined;
    textColor?: string | undefined;
    headingColor?: string | undefined;
    headingBold?: boolean;
    headerBgColor?: string | undefined;
    headerHeight?: number;
    headerGradientEnabled?: boolean;
    headerGradientColor?: string | undefined;
    headerGradientAngle?: number;
    headerGradientToWhite?: boolean;
    headlineMainColor?: string | undefined;
    headlineSecondColor?: string | undefined;
    tabStyle?: string | undefined;
    tabBorderColor?: string | undefined;
    tabTop?: TabLevelColors;
    tabMiddle?: TabLevelColors;
    tabBottom?: TabLevelColors;
    tabVeryBottom?: TabLevelColors;
    accordionBgColor?: string | undefined;
    accordionActiveBgColor?: string | undefined;
    accordionTextColor?: string | undefined;
    accordionContentBgColor?: string | undefined;
    accordionContentTextColor?: string | undefined;
    accordionMatchHeader?: boolean;
    buttonBgColor?: string | undefined;
    buttonHoverColor?: string | undefined;
    buttonTextColor?: string | undefined;
    logoUrl?: string | undefined;
    logoWidth?: number;
    logoHeight?: number;
}

export class DesignConfigResponse implements IDesignConfigResponse {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    ansicht?: number;
    konfiguration?: DesignConfigModel;
    konfigurationJson?: string | undefined;
    css?: string | undefined;
    version?: number;
    istLive?: boolean;
    istDraft?: boolean;
    erstelltAm?: Date;
    geaendertAm?: Date | undefined;

    constructor(data?: IDesignConfigResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.ansicht = _data["ansicht"];
            this.konfiguration = _data["konfiguration"] ? DesignConfigModel.fromJS(_data["konfiguration"]) : <any>undefined;
            this.konfigurationJson = _data["konfigurationJson"];
            this.css = _data["css"];
            this.version = _data["version"];
            this.istLive = _data["istLive"];
            this.istDraft = _data["istDraft"];
            this.erstelltAm = _data["erstelltAm"] ? new Date(_data["erstelltAm"].toString()) : <any>undefined;
            this.geaendertAm = _data["geaendertAm"] ? new Date(_data["geaendertAm"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DesignConfigResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DesignConfigResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["ansicht"] = this.ansicht;
        data["konfiguration"] = this.konfiguration ? this.konfiguration.toJSON() : <any>undefined;
        data["konfigurationJson"] = this.konfigurationJson;
        data["css"] = this.css;
        data["version"] = this.version;
        data["istLive"] = this.istLive;
        data["istDraft"] = this.istDraft;
        data["erstelltAm"] = this.erstelltAm ? this.erstelltAm.toISOString() : <any>undefined;
        data["geaendertAm"] = this.geaendertAm ? this.geaendertAm.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDesignConfigResponse {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    ansicht?: number;
    konfiguration?: DesignConfigModel;
    konfigurationJson?: string | undefined;
    css?: string | undefined;
    version?: number;
    istLive?: boolean;
    istDraft?: boolean;
    erstelltAm?: Date;
    geaendertAm?: Date | undefined;
}

export class DesignGemeindeInfo implements IDesignGemeindeInfo {
    gemeinde?: number;
    name?: string | undefined;

    constructor(data?: IDesignGemeindeInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gemeinde = _data["gemeinde"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): DesignGemeindeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DesignGemeindeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gemeinde"] = this.gemeinde;
        data["name"] = this.name;
        return data;
    }
}

export interface IDesignGemeindeInfo {
    gemeinde?: number;
    name?: string | undefined;
}

export class DesignKundeInfo implements IDesignKundeInfo {
    kunde?: number;
    name?: string | undefined;
    gemeinden?: DesignGemeindeInfo[] | undefined;

    constructor(data?: IDesignKundeInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.name = _data["name"];
            if (Array.isArray(_data["gemeinden"])) {
                this.gemeinden = [] as any;
                for (let item of _data["gemeinden"])
                    this.gemeinden!.push(DesignGemeindeInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DesignKundeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DesignKundeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["name"] = this.name;
        if (Array.isArray(this.gemeinden)) {
            data["gemeinden"] = [];
            for (let item of this.gemeinden)
                data["gemeinden"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDesignKundeInfo {
    kunde?: number;
    name?: string | undefined;
    gemeinden?: DesignGemeindeInfo[] | undefined;
}

export class DesignTemplateResponse implements IDesignTemplateResponse {
    id?: number;
    name?: string | undefined;
    beschreibung?: string | undefined;
    kategorie?: string | undefined;
    tags?: string | undefined;
    vorschaubild?: string | undefined;
    konfiguration?: DesignConfigModel;
    konfigurationJson?: string | undefined;

    constructor(data?: IDesignTemplateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.beschreibung = _data["beschreibung"];
            this.kategorie = _data["kategorie"];
            this.tags = _data["tags"];
            this.vorschaubild = _data["vorschaubild"];
            this.konfiguration = _data["konfiguration"] ? DesignConfigModel.fromJS(_data["konfiguration"]) : <any>undefined;
            this.konfigurationJson = _data["konfigurationJson"];
        }
    }

    static fromJS(data: any): DesignTemplateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DesignTemplateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["beschreibung"] = this.beschreibung;
        data["kategorie"] = this.kategorie;
        data["tags"] = this.tags;
        data["vorschaubild"] = this.vorschaubild;
        data["konfiguration"] = this.konfiguration ? this.konfiguration.toJSON() : <any>undefined;
        data["konfigurationJson"] = this.konfigurationJson;
        return data;
    }
}

export interface IDesignTemplateResponse {
    id?: number;
    name?: string | undefined;
    beschreibung?: string | undefined;
    kategorie?: string | undefined;
    tags?: string | undefined;
    vorschaubild?: string | undefined;
    konfiguration?: DesignConfigModel;
    konfigurationJson?: string | undefined;
}

export class DesignVersionInfo implements IDesignVersionInfo {
    version?: number;
    erstelltAm?: Date;
    geaendertAm?: Date;
    geaendertVon?: string | undefined;
    isCurrent?: boolean;
    istLive?: boolean;
    konfigurationJson?: string | undefined;

    constructor(data?: IDesignVersionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.erstelltAm = _data["erstelltAm"] ? new Date(_data["erstelltAm"].toString()) : <any>undefined;
            this.geaendertAm = _data["geaendertAm"] ? new Date(_data["geaendertAm"].toString()) : <any>undefined;
            this.geaendertVon = _data["geaendertVon"];
            this.isCurrent = _data["isCurrent"];
            this.istLive = _data["istLive"];
            this.konfigurationJson = _data["konfigurationJson"];
        }
    }

    static fromJS(data: any): DesignVersionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DesignVersionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["erstelltAm"] = this.erstelltAm ? this.erstelltAm.toISOString() : <any>undefined;
        data["geaendertAm"] = this.geaendertAm ? this.geaendertAm.toISOString() : <any>undefined;
        data["geaendertVon"] = this.geaendertVon;
        data["isCurrent"] = this.isCurrent;
        data["istLive"] = this.istLive;
        data["konfigurationJson"] = this.konfigurationJson;
        return data;
    }
}

export interface IDesignVersionInfo {
    version?: number;
    erstelltAm?: Date;
    geaendertAm?: Date;
    geaendertVon?: string | undefined;
    isCurrent?: boolean;
    istLive?: boolean;
    konfigurationJson?: string | undefined;
}

export class DiagrammDaten implements IDiagrammDaten {
    art?: string | undefined;
    titel?: string | undefined;
    kategorien?: string[] | undefined;
    kategorieArten?: string[] | undefined;
    reihen?: DiagrammReihe[] | undefined;
    einheit?: string | undefined;
    einheitRechts?: string | undefined;
    gestapelt?: boolean;
    waagerecht?: boolean;
    von?: number[] | undefined;
    bis?: number[] | undefined;
    legende?: string[] | undefined;
    farben?: string[] | undefined;
    achseVon?: number | undefined;
    achseBis?: number | undefined;
    hinweise?: string[] | undefined;

    constructor(data?: IDiagrammDaten) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.art = _data["art"];
            this.titel = _data["titel"];
            if (Array.isArray(_data["kategorien"])) {
                this.kategorien = [] as any;
                for (let item of _data["kategorien"])
                    this.kategorien!.push(item);
            }
            if (Array.isArray(_data["kategorieArten"])) {
                this.kategorieArten = [] as any;
                for (let item of _data["kategorieArten"])
                    this.kategorieArten!.push(item);
            }
            if (Array.isArray(_data["reihen"])) {
                this.reihen = [] as any;
                for (let item of _data["reihen"])
                    this.reihen!.push(DiagrammReihe.fromJS(item));
            }
            this.einheit = _data["einheit"];
            this.einheitRechts = _data["einheitRechts"];
            this.gestapelt = _data["gestapelt"];
            this.waagerecht = _data["waagerecht"];
            if (Array.isArray(_data["von"])) {
                this.von = [] as any;
                for (let item of _data["von"])
                    this.von!.push(item);
            }
            if (Array.isArray(_data["bis"])) {
                this.bis = [] as any;
                for (let item of _data["bis"])
                    this.bis!.push(item);
            }
            if (Array.isArray(_data["legende"])) {
                this.legende = [] as any;
                for (let item of _data["legende"])
                    this.legende!.push(item);
            }
            if (Array.isArray(_data["farben"])) {
                this.farben = [] as any;
                for (let item of _data["farben"])
                    this.farben!.push(item);
            }
            this.achseVon = _data["achseVon"];
            this.achseBis = _data["achseBis"];
            if (Array.isArray(_data["hinweise"])) {
                this.hinweise = [] as any;
                for (let item of _data["hinweise"])
                    this.hinweise!.push(item);
            }
        }
    }

    static fromJS(data: any): DiagrammDaten {
        data = typeof data === 'object' ? data : {};
        let result = new DiagrammDaten();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["art"] = this.art;
        data["titel"] = this.titel;
        if (Array.isArray(this.kategorien)) {
            data["kategorien"] = [];
            for (let item of this.kategorien)
                data["kategorien"].push(item);
        }
        if (Array.isArray(this.kategorieArten)) {
            data["kategorieArten"] = [];
            for (let item of this.kategorieArten)
                data["kategorieArten"].push(item);
        }
        if (Array.isArray(this.reihen)) {
            data["reihen"] = [];
            for (let item of this.reihen)
                data["reihen"].push(item.toJSON());
        }
        data["einheit"] = this.einheit;
        data["einheitRechts"] = this.einheitRechts;
        data["gestapelt"] = this.gestapelt;
        data["waagerecht"] = this.waagerecht;
        if (Array.isArray(this.von)) {
            data["von"] = [];
            for (let item of this.von)
                data["von"].push(item);
        }
        if (Array.isArray(this.bis)) {
            data["bis"] = [];
            for (let item of this.bis)
                data["bis"].push(item);
        }
        if (Array.isArray(this.legende)) {
            data["legende"] = [];
            for (let item of this.legende)
                data["legende"].push(item);
        }
        if (Array.isArray(this.farben)) {
            data["farben"] = [];
            for (let item of this.farben)
                data["farben"].push(item);
        }
        data["achseVon"] = this.achseVon;
        data["achseBis"] = this.achseBis;
        if (Array.isArray(this.hinweise)) {
            data["hinweise"] = [];
            for (let item of this.hinweise)
                data["hinweise"].push(item);
        }
        return data;
    }
}

export interface IDiagrammDaten {
    art?: string | undefined;
    titel?: string | undefined;
    kategorien?: string[] | undefined;
    kategorieArten?: string[] | undefined;
    reihen?: DiagrammReihe[] | undefined;
    einheit?: string | undefined;
    einheitRechts?: string | undefined;
    gestapelt?: boolean;
    waagerecht?: boolean;
    von?: number[] | undefined;
    bis?: number[] | undefined;
    legende?: string[] | undefined;
    farben?: string[] | undefined;
    achseVon?: number | undefined;
    achseBis?: number | undefined;
    hinweise?: string[] | undefined;
}

export class DiagrammReihe implements IDiagrammReihe {
    name?: string | undefined;
    werte?: number[] | undefined;
    form?: string | undefined;
    achse?: number;
    einheit?: string | undefined;
    anzeige?: string[] | undefined;

    constructor(data?: IDiagrammReihe) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["werte"])) {
                this.werte = [] as any;
                for (let item of _data["werte"])
                    this.werte!.push(item);
            }
            this.form = _data["form"];
            this.achse = _data["achse"];
            this.einheit = _data["einheit"];
            if (Array.isArray(_data["anzeige"])) {
                this.anzeige = [] as any;
                for (let item of _data["anzeige"])
                    this.anzeige!.push(item);
            }
        }
    }

    static fromJS(data: any): DiagrammReihe {
        data = typeof data === 'object' ? data : {};
        let result = new DiagrammReihe();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.werte)) {
            data["werte"] = [];
            for (let item of this.werte)
                data["werte"].push(item);
        }
        data["form"] = this.form;
        data["achse"] = this.achse;
        data["einheit"] = this.einheit;
        if (Array.isArray(this.anzeige)) {
            data["anzeige"] = [];
            for (let item of this.anzeige)
                data["anzeige"].push(item);
        }
        return data;
    }
}

export interface IDiagrammReihe {
    name?: string | undefined;
    werte?: number[] | undefined;
    form?: string | undefined;
    achse?: number;
    einheit?: string | undefined;
    anzeige?: string[] | undefined;
}

export class Diagrammtypen implements IDiagrammtypen {
    id?: number;
    bezeichnung?: string | undefined;
    kennzahlzeilenDarstellungNavigations?: Kennzahlzeilen[] | undefined;
    kennzahlzeilenDarstellungZusatzangabeNavigations?: Kennzahlzeilen[] | undefined;
    templateKennzahlzeilenDarstellungNavigations?: TemplateKennzahlzeilen[] | undefined;
    templateKennzahlzeilenDarstellungZusatzangabeNavigations?: TemplateKennzahlzeilen[] | undefined;

    constructor(data?: IDiagrammtypen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
            if (Array.isArray(_data["kennzahlzeilenDarstellungNavigations"])) {
                this.kennzahlzeilenDarstellungNavigations = [] as any;
                for (let item of _data["kennzahlzeilenDarstellungNavigations"])
                    this.kennzahlzeilenDarstellungNavigations!.push(Kennzahlzeilen.fromJS(item));
            }
            if (Array.isArray(_data["kennzahlzeilenDarstellungZusatzangabeNavigations"])) {
                this.kennzahlzeilenDarstellungZusatzangabeNavigations = [] as any;
                for (let item of _data["kennzahlzeilenDarstellungZusatzangabeNavigations"])
                    this.kennzahlzeilenDarstellungZusatzangabeNavigations!.push(Kennzahlzeilen.fromJS(item));
            }
            if (Array.isArray(_data["templateKennzahlzeilenDarstellungNavigations"])) {
                this.templateKennzahlzeilenDarstellungNavigations = [] as any;
                for (let item of _data["templateKennzahlzeilenDarstellungNavigations"])
                    this.templateKennzahlzeilenDarstellungNavigations!.push(TemplateKennzahlzeilen.fromJS(item));
            }
            if (Array.isArray(_data["templateKennzahlzeilenDarstellungZusatzangabeNavigations"])) {
                this.templateKennzahlzeilenDarstellungZusatzangabeNavigations = [] as any;
                for (let item of _data["templateKennzahlzeilenDarstellungZusatzangabeNavigations"])
                    this.templateKennzahlzeilenDarstellungZusatzangabeNavigations!.push(TemplateKennzahlzeilen.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Diagrammtypen {
        data = typeof data === 'object' ? data : {};
        let result = new Diagrammtypen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        if (Array.isArray(this.kennzahlzeilenDarstellungNavigations)) {
            data["kennzahlzeilenDarstellungNavigations"] = [];
            for (let item of this.kennzahlzeilenDarstellungNavigations)
                data["kennzahlzeilenDarstellungNavigations"].push(item.toJSON());
        }
        if (Array.isArray(this.kennzahlzeilenDarstellungZusatzangabeNavigations)) {
            data["kennzahlzeilenDarstellungZusatzangabeNavigations"] = [];
            for (let item of this.kennzahlzeilenDarstellungZusatzangabeNavigations)
                data["kennzahlzeilenDarstellungZusatzangabeNavigations"].push(item.toJSON());
        }
        if (Array.isArray(this.templateKennzahlzeilenDarstellungNavigations)) {
            data["templateKennzahlzeilenDarstellungNavigations"] = [];
            for (let item of this.templateKennzahlzeilenDarstellungNavigations)
                data["templateKennzahlzeilenDarstellungNavigations"].push(item.toJSON());
        }
        if (Array.isArray(this.templateKennzahlzeilenDarstellungZusatzangabeNavigations)) {
            data["templateKennzahlzeilenDarstellungZusatzangabeNavigations"] = [];
            for (let item of this.templateKennzahlzeilenDarstellungZusatzangabeNavigations)
                data["templateKennzahlzeilenDarstellungZusatzangabeNavigations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDiagrammtypen {
    id?: number;
    bezeichnung?: string | undefined;
    kennzahlzeilenDarstellungNavigations?: Kennzahlzeilen[] | undefined;
    kennzahlzeilenDarstellungZusatzangabeNavigations?: Kennzahlzeilen[] | undefined;
    templateKennzahlzeilenDarstellungNavigations?: TemplateKennzahlzeilen[] | undefined;
    templateKennzahlzeilenDarstellungZusatzangabeNavigations?: TemplateKennzahlzeilen[] | undefined;
}

export enum Direction {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class Documententypen implements IDocumententypen {
    id?: number | undefined;
    bezeichnung?: string | undefined;

    constructor(data?: IDocumententypen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
        }
    }

    static fromJS(data: any): Documententypen {
        data = typeof data === 'object' ? data : {};
        let result = new Documententypen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        return data;
    }
}

export interface IDocumententypen {
    id?: number | undefined;
    bezeichnung?: string | undefined;
}

export class DokOrdner implements IDokOrdner {
    ordnerId?: string | undefined;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    istObereOrdner?: boolean;
    oberordner?: string | undefined;
    modul?: number | undefined;
    order?: number | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;

    constructor(data?: IDokOrdner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ordnerId = _data["ordnerId"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.bezeichnung = _data["bezeichnung"];
            this.istObereOrdner = _data["istObereOrdner"];
            this.oberordner = _data["oberordner"];
            this.modul = _data["modul"];
            this.order = _data["order"];
            this.oeffentlich = _data["oeffentlich"];
            this.oeffentlichVerwaltung = _data["oeffentlichVerwaltung"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DokOrdner {
        data = typeof data === 'object' ? data : {};
        let result = new DokOrdner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordnerId"] = this.ordnerId;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["bezeichnung"] = this.bezeichnung;
        data["istObereOrdner"] = this.istObereOrdner;
        data["oberordner"] = this.oberordner;
        data["modul"] = this.modul;
        data["order"] = this.order;
        data["oeffentlich"] = this.oeffentlich;
        data["oeffentlichVerwaltung"] = this.oeffentlichVerwaltung;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDokOrdner {
    ordnerId?: string | undefined;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    istObereOrdner?: boolean;
    oberordner?: string | undefined;
    modul?: number | undefined;
    order?: number | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;
}

export class DokTreeModel implements IDokTreeModel {
    dokOrdner?: DokOrdner;
    unterordner?: DokTreeModel[] | undefined;
    dokumente?: Dokumente[] | undefined;

    constructor(data?: IDokTreeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dokOrdner = _data["dokOrdner"] ? DokOrdner.fromJS(_data["dokOrdner"]) : <any>undefined;
            if (Array.isArray(_data["unterordner"])) {
                this.unterordner = [] as any;
                for (let item of _data["unterordner"])
                    this.unterordner!.push(DokTreeModel.fromJS(item));
            }
            if (Array.isArray(_data["dokumente"])) {
                this.dokumente = [] as any;
                for (let item of _data["dokumente"])
                    this.dokumente!.push(Dokumente.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DokTreeModel {
        data = typeof data === 'object' ? data : {};
        let result = new DokTreeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dokOrdner"] = this.dokOrdner ? this.dokOrdner.toJSON() : <any>undefined;
        if (Array.isArray(this.unterordner)) {
            data["unterordner"] = [];
            for (let item of this.unterordner)
                data["unterordner"].push(item.toJSON());
        }
        if (Array.isArray(this.dokumente)) {
            data["dokumente"] = [];
            for (let item of this.dokumente)
                data["dokumente"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDokTreeModel {
    dokOrdner?: DokOrdner;
    unterordner?: DokTreeModel[] | undefined;
    dokumente?: Dokumente[] | undefined;
}

export class Dokumente implements IDokumente {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    typ?: number;
    url?: string | undefined;
    ordner?: string | undefined;
    modul?: number | undefined;
    order?: number | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;

    constructor(data?: IDokumente) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.bezeichnung = _data["bezeichnung"];
            this.typ = _data["typ"];
            this.url = _data["url"];
            this.ordner = _data["ordner"];
            this.modul = _data["modul"];
            this.order = _data["order"];
            this.oeffentlich = _data["oeffentlich"];
            this.oeffentlichVerwaltung = _data["oeffentlichVerwaltung"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Dokumente {
        data = typeof data === 'object' ? data : {};
        let result = new Dokumente();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["bezeichnung"] = this.bezeichnung;
        data["typ"] = this.typ;
        data["url"] = this.url;
        data["ordner"] = this.ordner;
        data["modul"] = this.modul;
        data["order"] = this.order;
        data["oeffentlich"] = this.oeffentlich;
        data["oeffentlichVerwaltung"] = this.oeffentlichVerwaltung;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDokumente {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    typ?: number;
    url?: string | undefined;
    ordner?: string | undefined;
    modul?: number | undefined;
    order?: number | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;
}

export class Ebenen implements IEbenen {
    ebenenId?: string | undefined;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    nummer?: number | undefined;
    istObereEbene?: boolean;
    oberebene?: string | undefined;
    stellen?: number | undefined;
    summenVerbergen?: boolean | undefined;
    nichtHp?: boolean | undefined;
    nichtJr?: boolean | undefined;
    nichtUh?: boolean | undefined;
    attribut?: boolean | undefined;
    amt?: boolean | undefined;
    numFeld?: string | undefined;
    bezFeld?: string | undefined;
    nachKonten?: boolean | undefined;
    filter?: boolean | undefined;
    keineNummer?: boolean | undefined;
    gemeinden?: Gemeinden;

    constructor(data?: IEbenen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ebenenId = _data["ebenenId"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.bezeichnung = _data["bezeichnung"];
            this.nummer = _data["nummer"];
            this.istObereEbene = _data["istObereEbene"];
            this.oberebene = _data["oberebene"];
            this.stellen = _data["stellen"];
            this.summenVerbergen = _data["summenVerbergen"];
            this.nichtHp = _data["nichtHp"];
            this.nichtJr = _data["nichtJr"];
            this.nichtUh = _data["nichtUh"];
            this.attribut = _data["attribut"];
            this.amt = _data["amt"];
            this.numFeld = _data["numFeld"];
            this.bezFeld = _data["bezFeld"];
            this.nachKonten = _data["nachKonten"];
            this.filter = _data["filter"];
            this.keineNummer = _data["keineNummer"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Ebenen {
        data = typeof data === 'object' ? data : {};
        let result = new Ebenen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ebenenId"] = this.ebenenId;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["bezeichnung"] = this.bezeichnung;
        data["nummer"] = this.nummer;
        data["istObereEbene"] = this.istObereEbene;
        data["oberebene"] = this.oberebene;
        data["stellen"] = this.stellen;
        data["summenVerbergen"] = this.summenVerbergen;
        data["nichtHp"] = this.nichtHp;
        data["nichtJr"] = this.nichtJr;
        data["nichtUh"] = this.nichtUh;
        data["attribut"] = this.attribut;
        data["amt"] = this.amt;
        data["numFeld"] = this.numFeld;
        data["bezFeld"] = this.bezFeld;
        data["nachKonten"] = this.nachKonten;
        data["filter"] = this.filter;
        data["keineNummer"] = this.keineNummer;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEbenen {
    ebenenId?: string | undefined;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    nummer?: number | undefined;
    istObereEbene?: boolean;
    oberebene?: string | undefined;
    stellen?: number | undefined;
    summenVerbergen?: boolean | undefined;
    nichtHp?: boolean | undefined;
    nichtJr?: boolean | undefined;
    nichtUh?: boolean | undefined;
    attribut?: boolean | undefined;
    amt?: boolean | undefined;
    numFeld?: string | undefined;
    bezFeld?: string | undefined;
    nachKonten?: boolean | undefined;
    filter?: boolean | undefined;
    keineNummer?: boolean | undefined;
    gemeinden?: Gemeinden;
}

export class EbenenModel implements IEbenenModel {
    kunde?: number | undefined;
    haushaltsstelle?: number;
    jahr?: number;
    ebene?: string | undefined;

    constructor(data?: IEbenenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.haushaltsstelle = _data["haushaltsstelle"];
            this.jahr = _data["jahr"];
            this.ebene = _data["ebene"];
        }
    }

    static fromJS(data: any): EbenenModel {
        data = typeof data === 'object' ? data : {};
        let result = new EbenenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["haushaltsstelle"] = this.haushaltsstelle;
        data["jahr"] = this.jahr;
        data["ebene"] = this.ebene;
        return data;
    }
}

export interface IEbenenModel {
    kunde?: number | undefined;
    haushaltsstelle?: number;
    jahr?: number;
    ebene?: string | undefined;
}

export class ErgebnisTabelle implements IErgebnisTabelle {
    id?: string | undefined;
    titel?: string | undefined;
    abgefragt?: string | undefined;
    diagrammArt?: string | undefined;
    spalten?: TabellenSpalte[] | undefined;
    zeilen?: TabellenZelle[][] | undefined;
    hinweise?: string[] | undefined;
    torteGrund?: string | undefined;
    ganzesGrund?: string | undefined;
    summenZeile?: boolean;
    gekuerzt?: boolean;
    gesamt?: number[] | undefined;
    saldo?: boolean;
    wirkung?: number[] | undefined;
    teileGrund?: string | undefined;
    ganzesName?: string | undefined;

    constructor(data?: IErgebnisTabelle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.titel = _data["titel"];
            this.abgefragt = _data["abgefragt"];
            this.diagrammArt = _data["diagrammArt"];
            if (Array.isArray(_data["spalten"])) {
                this.spalten = [] as any;
                for (let item of _data["spalten"])
                    this.spalten!.push(TabellenSpalte.fromJS(item));
            }
            if (Array.isArray(_data["zeilen"])) {
                this.zeilen = [] as any;
                for (let item of _data["zeilen"])
                    this.zeilen!.push(item);
            }
            if (Array.isArray(_data["hinweise"])) {
                this.hinweise = [] as any;
                for (let item of _data["hinweise"])
                    this.hinweise!.push(item);
            }
            this.torteGrund = _data["torteGrund"];
            this.ganzesGrund = _data["ganzesGrund"];
            this.summenZeile = _data["summenZeile"];
            this.gekuerzt = _data["gekuerzt"];
            if (Array.isArray(_data["gesamt"])) {
                this.gesamt = [] as any;
                for (let item of _data["gesamt"])
                    this.gesamt!.push(item);
            }
            this.saldo = _data["saldo"];
            if (Array.isArray(_data["wirkung"])) {
                this.wirkung = [] as any;
                for (let item of _data["wirkung"])
                    this.wirkung!.push(item);
            }
            this.teileGrund = _data["teileGrund"];
            this.ganzesName = _data["ganzesName"];
        }
    }

    static fromJS(data: any): ErgebnisTabelle {
        data = typeof data === 'object' ? data : {};
        let result = new ErgebnisTabelle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["titel"] = this.titel;
        data["abgefragt"] = this.abgefragt;
        data["diagrammArt"] = this.diagrammArt;
        if (Array.isArray(this.spalten)) {
            data["spalten"] = [];
            for (let item of this.spalten)
                data["spalten"].push(item.toJSON());
        }
        if (Array.isArray(this.zeilen)) {
            data["zeilen"] = [];
            for (let item of this.zeilen)
                data["zeilen"].push(item);
        }
        if (Array.isArray(this.hinweise)) {
            data["hinweise"] = [];
            for (let item of this.hinweise)
                data["hinweise"].push(item);
        }
        data["torteGrund"] = this.torteGrund;
        data["ganzesGrund"] = this.ganzesGrund;
        data["summenZeile"] = this.summenZeile;
        data["gekuerzt"] = this.gekuerzt;
        if (Array.isArray(this.gesamt)) {
            data["gesamt"] = [];
            for (let item of this.gesamt)
                data["gesamt"].push(item);
        }
        data["saldo"] = this.saldo;
        if (Array.isArray(this.wirkung)) {
            data["wirkung"] = [];
            for (let item of this.wirkung)
                data["wirkung"].push(item);
        }
        data["teileGrund"] = this.teileGrund;
        data["ganzesName"] = this.ganzesName;
        return data;
    }
}

export interface IErgebnisTabelle {
    id?: string | undefined;
    titel?: string | undefined;
    abgefragt?: string | undefined;
    diagrammArt?: string | undefined;
    spalten?: TabellenSpalte[] | undefined;
    zeilen?: TabellenZelle[][] | undefined;
    hinweise?: string[] | undefined;
    torteGrund?: string | undefined;
    ganzesGrund?: string | undefined;
    summenZeile?: boolean;
    gekuerzt?: boolean;
    gesamt?: number[] | undefined;
    saldo?: boolean;
    wirkung?: number[] | undefined;
    teileGrund?: string | undefined;
    ganzesName?: string | undefined;
}

export class ErmEbene implements IErmEbene {
    id?: string | undefined;
    isBilanz?: boolean;
    isHHS?: boolean;
    verbergen?: boolean;
    gesamtSumme?: boolean;
    produkt?: number;
    pStellen?: number;
    produktEbene?: string | undefined;
    massnahme?: number | undefined;
    konto?: number;
    kStellen?: number;
    unterkonto?: number;
    bezeichnung?: string | undefined;
    produktText?: string | undefined;
    kontoText?: string | undefined;
    beschreibung?: string | undefined;
    investNr?: string | undefined;
    beginnJahr?: number | undefined;
    endJahr?: number | undefined;
    hrfJ_soll?: number;
    hrfJ_haben?: number;
    hrfJ_PJM1_soll?: number;
    hrfJ_PJM1_haben?: number;
    hrfJ_PJM2_soll?: number;
    hrfJ_PJM2_haben?: number;
    hrfJ_PJM3_soll?: number;
    hrfJ_PJM3_haben?: number;
    hrfJ_PJM4_soll?: number;
    hrfJ_PJM4_haben?: number;
    hrfJ_Bilanz_passiva?: number;
    hrfJ_Bilanz_aktiva?: number;
    hrfJ_Erg_soll?: number;
    hrfJ_Erg_haben?: number;
    hrfJ_PJM1_Bilanz_passiva?: number;
    hrfJ_PJM1_Bilanz_aktiva?: number;
    hrfJ_PJM1_Erg_soll?: number;
    hrfJ_PJM1_Erg_haben?: number;
    hrfJ_PJM2_Bilanz_passiva?: number;
    hrfJ_PJM2_Bilanz_aktiva?: number;
    hrfJ_PJM2_Erg_soll?: number;
    hrfJ_PJM2_Erg_haben?: number;
    hrfJ_PJM3_Bilanz_passiva?: number;
    hrfJ_PJM3_Bilanz_aktiva?: number;
    hrfJ_PJM3_Erg_soll?: number;
    hrfJ_PJM3_Erg_haben?: number;
    hrfJ_PJM4_Bilanz_passiva?: number;
    hrfJ_PJM4_Bilanz_aktiva?: number;
    hrfJ_PJM4_Erg_soll?: number;
    hrfJ_PJM4_Erg_haben?: number;
    unterEbenen?: ErmEbene[] | undefined;
    jahre?: number[] | undefined;
    istEinnahme?: boolean;

    constructor(data?: IErmEbene) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isBilanz = _data["isBilanz"];
            this.isHHS = _data["isHHS"];
            this.verbergen = _data["verbergen"];
            this.gesamtSumme = _data["gesamtSumme"];
            this.produkt = _data["produkt"];
            this.pStellen = _data["pStellen"];
            this.produktEbene = _data["produktEbene"];
            this.massnahme = _data["massnahme"];
            this.konto = _data["konto"];
            this.kStellen = _data["kStellen"];
            this.unterkonto = _data["unterkonto"];
            this.bezeichnung = _data["bezeichnung"];
            this.produktText = _data["produktText"];
            this.kontoText = _data["kontoText"];
            this.beschreibung = _data["beschreibung"];
            this.investNr = _data["investNr"];
            this.beginnJahr = _data["beginnJahr"];
            this.endJahr = _data["endJahr"];
            this.hrfJ_soll = _data["hrfJ_soll"];
            this.hrfJ_haben = _data["hrfJ_haben"];
            this.hrfJ_PJM1_soll = _data["hrfJ_PJM1_soll"];
            this.hrfJ_PJM1_haben = _data["hrfJ_PJM1_haben"];
            this.hrfJ_PJM2_soll = _data["hrfJ_PJM2_soll"];
            this.hrfJ_PJM2_haben = _data["hrfJ_PJM2_haben"];
            this.hrfJ_PJM3_soll = _data["hrfJ_PJM3_soll"];
            this.hrfJ_PJM3_haben = _data["hrfJ_PJM3_haben"];
            this.hrfJ_PJM4_soll = _data["hrfJ_PJM4_soll"];
            this.hrfJ_PJM4_haben = _data["hrfJ_PJM4_haben"];
            this.hrfJ_Bilanz_passiva = _data["hrfJ_Bilanz_passiva"];
            this.hrfJ_Bilanz_aktiva = _data["hrfJ_Bilanz_aktiva"];
            this.hrfJ_Erg_soll = _data["hrfJ_Erg_soll"];
            this.hrfJ_Erg_haben = _data["hrfJ_Erg_haben"];
            this.hrfJ_PJM1_Bilanz_passiva = _data["hrfJ_PJM1_Bilanz_passiva"];
            this.hrfJ_PJM1_Bilanz_aktiva = _data["hrfJ_PJM1_Bilanz_aktiva"];
            this.hrfJ_PJM1_Erg_soll = _data["hrfJ_PJM1_Erg_soll"];
            this.hrfJ_PJM1_Erg_haben = _data["hrfJ_PJM1_Erg_haben"];
            this.hrfJ_PJM2_Bilanz_passiva = _data["hrfJ_PJM2_Bilanz_passiva"];
            this.hrfJ_PJM2_Bilanz_aktiva = _data["hrfJ_PJM2_Bilanz_aktiva"];
            this.hrfJ_PJM2_Erg_soll = _data["hrfJ_PJM2_Erg_soll"];
            this.hrfJ_PJM2_Erg_haben = _data["hrfJ_PJM2_Erg_haben"];
            this.hrfJ_PJM3_Bilanz_passiva = _data["hrfJ_PJM3_Bilanz_passiva"];
            this.hrfJ_PJM3_Bilanz_aktiva = _data["hrfJ_PJM3_Bilanz_aktiva"];
            this.hrfJ_PJM3_Erg_soll = _data["hrfJ_PJM3_Erg_soll"];
            this.hrfJ_PJM3_Erg_haben = _data["hrfJ_PJM3_Erg_haben"];
            this.hrfJ_PJM4_Bilanz_passiva = _data["hrfJ_PJM4_Bilanz_passiva"];
            this.hrfJ_PJM4_Bilanz_aktiva = _data["hrfJ_PJM4_Bilanz_aktiva"];
            this.hrfJ_PJM4_Erg_soll = _data["hrfJ_PJM4_Erg_soll"];
            this.hrfJ_PJM4_Erg_haben = _data["hrfJ_PJM4_Erg_haben"];
            if (Array.isArray(_data["unterEbenen"])) {
                this.unterEbenen = [] as any;
                for (let item of _data["unterEbenen"])
                    this.unterEbenen!.push(ErmEbene.fromJS(item));
            }
            if (Array.isArray(_data["jahre"])) {
                this.jahre = [] as any;
                for (let item of _data["jahre"])
                    this.jahre!.push(item);
            }
            this.istEinnahme = _data["istEinnahme"];
        }
    }

    static fromJS(data: any): ErmEbene {
        data = typeof data === 'object' ? data : {};
        let result = new ErmEbene();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isBilanz"] = this.isBilanz;
        data["isHHS"] = this.isHHS;
        data["verbergen"] = this.verbergen;
        data["gesamtSumme"] = this.gesamtSumme;
        data["produkt"] = this.produkt;
        data["pStellen"] = this.pStellen;
        data["produktEbene"] = this.produktEbene;
        data["massnahme"] = this.massnahme;
        data["konto"] = this.konto;
        data["kStellen"] = this.kStellen;
        data["unterkonto"] = this.unterkonto;
        data["bezeichnung"] = this.bezeichnung;
        data["produktText"] = this.produktText;
        data["kontoText"] = this.kontoText;
        data["beschreibung"] = this.beschreibung;
        data["investNr"] = this.investNr;
        data["beginnJahr"] = this.beginnJahr;
        data["endJahr"] = this.endJahr;
        data["hrfJ_soll"] = this.hrfJ_soll;
        data["hrfJ_haben"] = this.hrfJ_haben;
        data["hrfJ_PJM1_soll"] = this.hrfJ_PJM1_soll;
        data["hrfJ_PJM1_haben"] = this.hrfJ_PJM1_haben;
        data["hrfJ_PJM2_soll"] = this.hrfJ_PJM2_soll;
        data["hrfJ_PJM2_haben"] = this.hrfJ_PJM2_haben;
        data["hrfJ_PJM3_soll"] = this.hrfJ_PJM3_soll;
        data["hrfJ_PJM3_haben"] = this.hrfJ_PJM3_haben;
        data["hrfJ_PJM4_soll"] = this.hrfJ_PJM4_soll;
        data["hrfJ_PJM4_haben"] = this.hrfJ_PJM4_haben;
        data["hrfJ_Bilanz_passiva"] = this.hrfJ_Bilanz_passiva;
        data["hrfJ_Bilanz_aktiva"] = this.hrfJ_Bilanz_aktiva;
        data["hrfJ_Erg_soll"] = this.hrfJ_Erg_soll;
        data["hrfJ_Erg_haben"] = this.hrfJ_Erg_haben;
        data["hrfJ_PJM1_Bilanz_passiva"] = this.hrfJ_PJM1_Bilanz_passiva;
        data["hrfJ_PJM1_Bilanz_aktiva"] = this.hrfJ_PJM1_Bilanz_aktiva;
        data["hrfJ_PJM1_Erg_soll"] = this.hrfJ_PJM1_Erg_soll;
        data["hrfJ_PJM1_Erg_haben"] = this.hrfJ_PJM1_Erg_haben;
        data["hrfJ_PJM2_Bilanz_passiva"] = this.hrfJ_PJM2_Bilanz_passiva;
        data["hrfJ_PJM2_Bilanz_aktiva"] = this.hrfJ_PJM2_Bilanz_aktiva;
        data["hrfJ_PJM2_Erg_soll"] = this.hrfJ_PJM2_Erg_soll;
        data["hrfJ_PJM2_Erg_haben"] = this.hrfJ_PJM2_Erg_haben;
        data["hrfJ_PJM3_Bilanz_passiva"] = this.hrfJ_PJM3_Bilanz_passiva;
        data["hrfJ_PJM3_Bilanz_aktiva"] = this.hrfJ_PJM3_Bilanz_aktiva;
        data["hrfJ_PJM3_Erg_soll"] = this.hrfJ_PJM3_Erg_soll;
        data["hrfJ_PJM3_Erg_haben"] = this.hrfJ_PJM3_Erg_haben;
        data["hrfJ_PJM4_Bilanz_passiva"] = this.hrfJ_PJM4_Bilanz_passiva;
        data["hrfJ_PJM4_Bilanz_aktiva"] = this.hrfJ_PJM4_Bilanz_aktiva;
        data["hrfJ_PJM4_Erg_soll"] = this.hrfJ_PJM4_Erg_soll;
        data["hrfJ_PJM4_Erg_haben"] = this.hrfJ_PJM4_Erg_haben;
        if (Array.isArray(this.unterEbenen)) {
            data["unterEbenen"] = [];
            for (let item of this.unterEbenen)
                data["unterEbenen"].push(item.toJSON());
        }
        if (Array.isArray(this.jahre)) {
            data["jahre"] = [];
            for (let item of this.jahre)
                data["jahre"].push(item);
        }
        data["istEinnahme"] = this.istEinnahme;
        return data;
    }
}

export interface IErmEbene {
    id?: string | undefined;
    isBilanz?: boolean;
    isHHS?: boolean;
    verbergen?: boolean;
    gesamtSumme?: boolean;
    produkt?: number;
    pStellen?: number;
    produktEbene?: string | undefined;
    massnahme?: number | undefined;
    konto?: number;
    kStellen?: number;
    unterkonto?: number;
    bezeichnung?: string | undefined;
    produktText?: string | undefined;
    kontoText?: string | undefined;
    beschreibung?: string | undefined;
    investNr?: string | undefined;
    beginnJahr?: number | undefined;
    endJahr?: number | undefined;
    hrfJ_soll?: number;
    hrfJ_haben?: number;
    hrfJ_PJM1_soll?: number;
    hrfJ_PJM1_haben?: number;
    hrfJ_PJM2_soll?: number;
    hrfJ_PJM2_haben?: number;
    hrfJ_PJM3_soll?: number;
    hrfJ_PJM3_haben?: number;
    hrfJ_PJM4_soll?: number;
    hrfJ_PJM4_haben?: number;
    hrfJ_Bilanz_passiva?: number;
    hrfJ_Bilanz_aktiva?: number;
    hrfJ_Erg_soll?: number;
    hrfJ_Erg_haben?: number;
    hrfJ_PJM1_Bilanz_passiva?: number;
    hrfJ_PJM1_Bilanz_aktiva?: number;
    hrfJ_PJM1_Erg_soll?: number;
    hrfJ_PJM1_Erg_haben?: number;
    hrfJ_PJM2_Bilanz_passiva?: number;
    hrfJ_PJM2_Bilanz_aktiva?: number;
    hrfJ_PJM2_Erg_soll?: number;
    hrfJ_PJM2_Erg_haben?: number;
    hrfJ_PJM3_Bilanz_passiva?: number;
    hrfJ_PJM3_Bilanz_aktiva?: number;
    hrfJ_PJM3_Erg_soll?: number;
    hrfJ_PJM3_Erg_haben?: number;
    hrfJ_PJM4_Bilanz_passiva?: number;
    hrfJ_PJM4_Bilanz_aktiva?: number;
    hrfJ_PJM4_Erg_soll?: number;
    hrfJ_PJM4_Erg_haben?: number;
    unterEbenen?: ErmEbene[] | undefined;
    jahre?: number[] | undefined;
    istEinnahme?: boolean;
}

export class ExportPlanDoppischModel implements IExportPlanDoppischModel {
    format?: number;
    nurModifizierte?: boolean;
    nurManuelle?: boolean;
    hhspList?: HHSPlanDoppischModel[] | undefined;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    plantyp?: number;
    planstufe?: number;

    constructor(data?: IExportPlanDoppischModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.format = _data["format"];
            this.nurModifizierte = _data["nurModifizierte"];
            this.nurManuelle = _data["nurManuelle"];
            if (Array.isArray(_data["hhspList"])) {
                this.hhspList = [] as any;
                for (let item of _data["hhspList"])
                    this.hhspList!.push(HHSPlanDoppischModel.fromJS(item));
            }
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.plantyp = _data["plantyp"];
            this.planstufe = _data["planstufe"];
        }
    }

    static fromJS(data: any): ExportPlanDoppischModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExportPlanDoppischModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["format"] = this.format;
        data["nurModifizierte"] = this.nurModifizierte;
        data["nurManuelle"] = this.nurManuelle;
        if (Array.isArray(this.hhspList)) {
            data["hhspList"] = [];
            for (let item of this.hhspList)
                data["hhspList"].push(item.toJSON());
        }
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["plantyp"] = this.plantyp;
        data["planstufe"] = this.planstufe;
        return data;
    }
}

export interface IExportPlanDoppischModel {
    format?: number;
    nurModifizierte?: boolean;
    nurManuelle?: boolean;
    hhspList?: HHSPlanDoppischModel[] | undefined;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    plantyp?: number;
    planstufe?: number;
}

export class ExportPlanKameralModel implements IExportPlanKameralModel {
    format?: number;
    nurModifizierte?: boolean;
    nurManuelle?: boolean;
    hhspList?: HHSPlanKameralModel[] | undefined;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    plantyp?: number;
    planstufe?: number;

    constructor(data?: IExportPlanKameralModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.format = _data["format"];
            this.nurModifizierte = _data["nurModifizierte"];
            this.nurManuelle = _data["nurManuelle"];
            if (Array.isArray(_data["hhspList"])) {
                this.hhspList = [] as any;
                for (let item of _data["hhspList"])
                    this.hhspList!.push(HHSPlanKameralModel.fromJS(item));
            }
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.plantyp = _data["plantyp"];
            this.planstufe = _data["planstufe"];
        }
    }

    static fromJS(data: any): ExportPlanKameralModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExportPlanKameralModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["format"] = this.format;
        data["nurModifizierte"] = this.nurModifizierte;
        data["nurManuelle"] = this.nurManuelle;
        if (Array.isArray(this.hhspList)) {
            data["hhspList"] = [];
            for (let item of this.hhspList)
                data["hhspList"].push(item.toJSON());
        }
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["plantyp"] = this.plantyp;
        data["planstufe"] = this.planstufe;
        return data;
    }
}

export interface IExportPlanKameralModel {
    format?: number;
    nurModifizierte?: boolean;
    nurManuelle?: boolean;
    hhspList?: HHSPlanKameralModel[] | undefined;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    plantyp?: number;
    planstufe?: number;
}

export class ExternTransferDesignRequest implements IExternTransferDesignRequest {
    quelleKunde?: number;
    quelleGemeinde?: number;
    quelleJahr?: number;
    quelleVersion?: number | undefined;
    quelleTemplateId?: number | undefined;
    zielKunde?: number;
    zielGemeinden?: number[] | undefined;

    constructor(data?: IExternTransferDesignRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quelleKunde = _data["quelleKunde"];
            this.quelleGemeinde = _data["quelleGemeinde"];
            this.quelleJahr = _data["quelleJahr"];
            this.quelleVersion = _data["quelleVersion"];
            this.quelleTemplateId = _data["quelleTemplateId"];
            this.zielKunde = _data["zielKunde"];
            if (Array.isArray(_data["zielGemeinden"])) {
                this.zielGemeinden = [] as any;
                for (let item of _data["zielGemeinden"])
                    this.zielGemeinden!.push(item);
            }
        }
    }

    static fromJS(data: any): ExternTransferDesignRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExternTransferDesignRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quelleKunde"] = this.quelleKunde;
        data["quelleGemeinde"] = this.quelleGemeinde;
        data["quelleJahr"] = this.quelleJahr;
        data["quelleVersion"] = this.quelleVersion;
        data["quelleTemplateId"] = this.quelleTemplateId;
        data["zielKunde"] = this.zielKunde;
        if (Array.isArray(this.zielGemeinden)) {
            data["zielGemeinden"] = [];
            for (let item of this.zielGemeinden)
                data["zielGemeinden"].push(item);
        }
        return data;
    }
}

export interface IExternTransferDesignRequest {
    quelleKunde?: number;
    quelleGemeinde?: number;
    quelleJahr?: number;
    quelleVersion?: number | undefined;
    quelleTemplateId?: number | undefined;
    zielKunde?: number;
    zielGemeinden?: number[] | undefined;
}

export class Farben implements IFarben {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    typ?: string | undefined;
    farbe?: string | undefined;
    order?: number | undefined;
    bezId?: string | undefined;
    typId?: string | undefined;

    constructor(data?: IFarben) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.bezeichnung = _data["bezeichnung"];
            this.typ = _data["typ"];
            this.farbe = _data["farbe"];
            this.order = _data["order"];
            this.bezId = _data["bezId"];
            this.typId = _data["typId"];
        }
    }

    static fromJS(data: any): Farben {
        data = typeof data === 'object' ? data : {};
        let result = new Farben();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["bezeichnung"] = this.bezeichnung;
        data["typ"] = this.typ;
        data["farbe"] = this.farbe;
        data["order"] = this.order;
        data["bezId"] = this.bezId;
        data["typId"] = this.typId;
        return data;
    }
}

export interface IFarben {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    typ?: string | undefined;
    farbe?: string | undefined;
    order?: number | undefined;
    bezId?: string | undefined;
    typId?: string | undefined;
}

export enum FontPitch {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum FontRelief {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum FontStyleType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum FontVariant {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum FontWeight {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
}

export class FreiTextModel implements IFreiTextModel {
    id?: number;
    order?: number | undefined;
    text?: Texte;

    constructor(data?: IFreiTextModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.order = _data["order"];
            this.text = _data["text"] ? Texte.fromJS(_data["text"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FreiTextModel {
        data = typeof data === 'object' ? data : {};
        let result = new FreiTextModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["order"] = this.order;
        data["text"] = this.text ? this.text.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFreiTextModel {
    id?: number;
    order?: number | undefined;
    text?: Texte;
}

export class GZEbenenModel implements IGZEbenenModel {
    ebeneId?: string | undefined;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    istOberEbene?: boolean;
    oberebene?: string | undefined;
    order?: number | undefined;
    produkt?: string | undefined;
    gemeinden?: Gemeinden;
    unterEbenen?: GZEbenenModel[] | undefined;
    datensaetze?: Datensaetze[] | undefined;
    edit?: boolean;

    constructor(data?: IGZEbenenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ebeneId = _data["ebeneId"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.bezeichnung = _data["bezeichnung"];
            this.istOberEbene = _data["istOberEbene"];
            this.oberebene = _data["oberebene"];
            this.order = _data["order"];
            this.produkt = _data["produkt"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
            if (Array.isArray(_data["unterEbenen"])) {
                this.unterEbenen = [] as any;
                for (let item of _data["unterEbenen"])
                    this.unterEbenen!.push(GZEbenenModel.fromJS(item));
            }
            if (Array.isArray(_data["datensaetze"])) {
                this.datensaetze = [] as any;
                for (let item of _data["datensaetze"])
                    this.datensaetze!.push(Datensaetze.fromJS(item));
            }
            this.edit = _data["edit"];
        }
    }

    static fromJS(data: any): GZEbenenModel {
        data = typeof data === 'object' ? data : {};
        let result = new GZEbenenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ebeneId"] = this.ebeneId;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["bezeichnung"] = this.bezeichnung;
        data["istOberEbene"] = this.istOberEbene;
        data["oberebene"] = this.oberebene;
        data["order"] = this.order;
        data["produkt"] = this.produkt;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        if (Array.isArray(this.unterEbenen)) {
            data["unterEbenen"] = [];
            for (let item of this.unterEbenen)
                data["unterEbenen"].push(item.toJSON());
        }
        if (Array.isArray(this.datensaetze)) {
            data["datensaetze"] = [];
            for (let item of this.datensaetze)
                data["datensaetze"].push(item.toJSON());
        }
        data["edit"] = this.edit;
        return data;
    }
}

export interface IGZEbenenModel {
    ebeneId?: string | undefined;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    istOberEbene?: boolean;
    oberebene?: string | undefined;
    order?: number | undefined;
    produkt?: string | undefined;
    gemeinden?: Gemeinden;
    unterEbenen?: GZEbenenModel[] | undefined;
    datensaetze?: Datensaetze[] | undefined;
    edit?: boolean;
}

export class GemeindeDto implements IGemeindeDto {
    id?: string | undefined;
    name?: string | undefined;
    friendlyUrl?: string | undefined;

    constructor(data?: IGemeindeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.friendlyUrl = _data["friendlyUrl"];
        }
    }

    static fromJS(data: any): GemeindeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GemeindeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["friendlyUrl"] = this.friendlyUrl;
        return data;
    }
}

export interface IGemeindeDto {
    id?: string | undefined;
    name?: string | undefined;
    friendlyUrl?: string | undefined;
}

export class GemeindeKennzahlenModel implements IGemeindeKennzahlenModel {
    kunde?: number;
    gemeinde?: number;
    name?: string | undefined;
    buchungsart?: number | undefined;
    inaktiv?: boolean | undefined;
    pubMode?: number | undefined;
    sftpuser?: string | undefined;
    sftphost?: string | undefined;
    sftppw?: string | undefined;
    importFormat?: number | undefined;
    gemeindetyp?: number | undefined;
    keVglMg?: boolean | undefined;
    keVglGt?: boolean | undefined;
    wegweiserGemeindeId?: number | undefined;
    mandant?: number | undefined;
    hauptFtp?: boolean | undefined;
    datensaetzes?: Datensaetze[] | undefined;
    dokOrdners?: DokOrdner[] | undefined;
    dokumentes?: Dokumente[] | undefined;
    ebenens?: Ebenen[] | undefined;
    gliederungs?: Gliederung[] | undefined;
    gliederungsebenens?: Gliederungsebenen[] | undefined;
    gruppierungs?: Gruppierung[] | undefined;
    gruppierungsebenens?: Gruppierungsebenen[] | undefined;
    gzebenes?: Gzebene[] | undefined;
    haushaltsstellenDoppisches?: HaushaltsstellenDoppisch[] | undefined;
    haushaltsstellens?: Haushaltsstellen[] | undefined;
    kennzahlens?: Kennzahlen[] | undefined;
    kontenebenens?: Kontenebenen[] | undefined;
    kontenplans?: Kontenplan[] | undefined;
    kundeNavigation?: Kunden;
    massnahmen?: Massnahman[] | undefined;
    massnahmenDoppisches?: MassnahmenDoppisch[] | undefined;
    planstufens?: Planstufen[] | undefined;
    produktebenens?: Produktebenen[] | undefined;
    produktes?: Produkte[] | undefined;
    textes?: Texte[] | undefined;
    uhconfigs?: Uhconfig[] | undefined;
    vbtabs?: Vbtab[] | undefined;
    wegweiserGemeinde?: WegweiserGemeinden;
    guid?: string | undefined;
    kundenName?: string | undefined;
    jahr?: number;
    einwohner?: number;
    kundenObj?: KundenModel;
    settings?: SettingsModel;
    kennzahlenWerte?: { [key: string]: KennzahlWert; } | undefined;
    vergleichskreise?: Ktvergleichskreise[] | undefined;

    constructor(data?: IGemeindeKennzahlenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.name = _data["name"];
            this.buchungsart = _data["buchungsart"];
            this.inaktiv = _data["inaktiv"];
            this.pubMode = _data["pubMode"];
            this.sftpuser = _data["sftpuser"];
            this.sftphost = _data["sftphost"];
            this.sftppw = _data["sftppw"];
            this.importFormat = _data["importFormat"];
            this.gemeindetyp = _data["gemeindetyp"];
            this.keVglMg = _data["keVglMg"];
            this.keVglGt = _data["keVglGt"];
            this.wegweiserGemeindeId = _data["wegweiserGemeindeId"];
            this.mandant = _data["mandant"];
            this.hauptFtp = _data["hauptFtp"];
            if (Array.isArray(_data["datensaetzes"])) {
                this.datensaetzes = [] as any;
                for (let item of _data["datensaetzes"])
                    this.datensaetzes!.push(Datensaetze.fromJS(item));
            }
            if (Array.isArray(_data["dokOrdners"])) {
                this.dokOrdners = [] as any;
                for (let item of _data["dokOrdners"])
                    this.dokOrdners!.push(DokOrdner.fromJS(item));
            }
            if (Array.isArray(_data["dokumentes"])) {
                this.dokumentes = [] as any;
                for (let item of _data["dokumentes"])
                    this.dokumentes!.push(Dokumente.fromJS(item));
            }
            if (Array.isArray(_data["ebenens"])) {
                this.ebenens = [] as any;
                for (let item of _data["ebenens"])
                    this.ebenens!.push(Ebenen.fromJS(item));
            }
            if (Array.isArray(_data["gliederungs"])) {
                this.gliederungs = [] as any;
                for (let item of _data["gliederungs"])
                    this.gliederungs!.push(Gliederung.fromJS(item));
            }
            if (Array.isArray(_data["gliederungsebenens"])) {
                this.gliederungsebenens = [] as any;
                for (let item of _data["gliederungsebenens"])
                    this.gliederungsebenens!.push(Gliederungsebenen.fromJS(item));
            }
            if (Array.isArray(_data["gruppierungs"])) {
                this.gruppierungs = [] as any;
                for (let item of _data["gruppierungs"])
                    this.gruppierungs!.push(Gruppierung.fromJS(item));
            }
            if (Array.isArray(_data["gruppierungsebenens"])) {
                this.gruppierungsebenens = [] as any;
                for (let item of _data["gruppierungsebenens"])
                    this.gruppierungsebenens!.push(Gruppierungsebenen.fromJS(item));
            }
            if (Array.isArray(_data["gzebenes"])) {
                this.gzebenes = [] as any;
                for (let item of _data["gzebenes"])
                    this.gzebenes!.push(Gzebene.fromJS(item));
            }
            if (Array.isArray(_data["haushaltsstellenDoppisches"])) {
                this.haushaltsstellenDoppisches = [] as any;
                for (let item of _data["haushaltsstellenDoppisches"])
                    this.haushaltsstellenDoppisches!.push(HaushaltsstellenDoppisch.fromJS(item));
            }
            if (Array.isArray(_data["haushaltsstellens"])) {
                this.haushaltsstellens = [] as any;
                for (let item of _data["haushaltsstellens"])
                    this.haushaltsstellens!.push(Haushaltsstellen.fromJS(item));
            }
            if (Array.isArray(_data["kennzahlens"])) {
                this.kennzahlens = [] as any;
                for (let item of _data["kennzahlens"])
                    this.kennzahlens!.push(Kennzahlen.fromJS(item));
            }
            if (Array.isArray(_data["kontenebenens"])) {
                this.kontenebenens = [] as any;
                for (let item of _data["kontenebenens"])
                    this.kontenebenens!.push(Kontenebenen.fromJS(item));
            }
            if (Array.isArray(_data["kontenplans"])) {
                this.kontenplans = [] as any;
                for (let item of _data["kontenplans"])
                    this.kontenplans!.push(Kontenplan.fromJS(item));
            }
            this.kundeNavigation = _data["kundeNavigation"] ? Kunden.fromJS(_data["kundeNavigation"]) : <any>undefined;
            if (Array.isArray(_data["massnahmen"])) {
                this.massnahmen = [] as any;
                for (let item of _data["massnahmen"])
                    this.massnahmen!.push(Massnahman.fromJS(item));
            }
            if (Array.isArray(_data["massnahmenDoppisches"])) {
                this.massnahmenDoppisches = [] as any;
                for (let item of _data["massnahmenDoppisches"])
                    this.massnahmenDoppisches!.push(MassnahmenDoppisch.fromJS(item));
            }
            if (Array.isArray(_data["planstufens"])) {
                this.planstufens = [] as any;
                for (let item of _data["planstufens"])
                    this.planstufens!.push(Planstufen.fromJS(item));
            }
            if (Array.isArray(_data["produktebenens"])) {
                this.produktebenens = [] as any;
                for (let item of _data["produktebenens"])
                    this.produktebenens!.push(Produktebenen.fromJS(item));
            }
            if (Array.isArray(_data["produktes"])) {
                this.produktes = [] as any;
                for (let item of _data["produktes"])
                    this.produktes!.push(Produkte.fromJS(item));
            }
            if (Array.isArray(_data["textes"])) {
                this.textes = [] as any;
                for (let item of _data["textes"])
                    this.textes!.push(Texte.fromJS(item));
            }
            if (Array.isArray(_data["uhconfigs"])) {
                this.uhconfigs = [] as any;
                for (let item of _data["uhconfigs"])
                    this.uhconfigs!.push(Uhconfig.fromJS(item));
            }
            if (Array.isArray(_data["vbtabs"])) {
                this.vbtabs = [] as any;
                for (let item of _data["vbtabs"])
                    this.vbtabs!.push(Vbtab.fromJS(item));
            }
            this.wegweiserGemeinde = _data["wegweiserGemeinde"] ? WegweiserGemeinden.fromJS(_data["wegweiserGemeinde"]) : <any>undefined;
            this.guid = _data["guid"];
            this.kundenName = _data["kundenName"];
            this.jahr = _data["jahr"];
            this.einwohner = _data["einwohner"];
            this.kundenObj = _data["kundenObj"] ? KundenModel.fromJS(_data["kundenObj"]) : <any>undefined;
            this.settings = _data["settings"] ? SettingsModel.fromJS(_data["settings"]) : <any>undefined;
            if (_data["kennzahlenWerte"]) {
                this.kennzahlenWerte = {} as any;
                for (let key in _data["kennzahlenWerte"]) {
                    if (_data["kennzahlenWerte"].hasOwnProperty(key))
                        (<any>this.kennzahlenWerte)![key] = _data["kennzahlenWerte"][key] ? KennzahlWert.fromJS(_data["kennzahlenWerte"][key]) : new KennzahlWert();
                }
            }
            if (Array.isArray(_data["vergleichskreise"])) {
                this.vergleichskreise = [] as any;
                for (let item of _data["vergleichskreise"])
                    this.vergleichskreise!.push(Ktvergleichskreise.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GemeindeKennzahlenModel {
        data = typeof data === 'object' ? data : {};
        let result = new GemeindeKennzahlenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["name"] = this.name;
        data["buchungsart"] = this.buchungsart;
        data["inaktiv"] = this.inaktiv;
        data["pubMode"] = this.pubMode;
        data["sftpuser"] = this.sftpuser;
        data["sftphost"] = this.sftphost;
        data["sftppw"] = this.sftppw;
        data["importFormat"] = this.importFormat;
        data["gemeindetyp"] = this.gemeindetyp;
        data["keVglMg"] = this.keVglMg;
        data["keVglGt"] = this.keVglGt;
        data["wegweiserGemeindeId"] = this.wegweiserGemeindeId;
        data["mandant"] = this.mandant;
        data["hauptFtp"] = this.hauptFtp;
        if (Array.isArray(this.datensaetzes)) {
            data["datensaetzes"] = [];
            for (let item of this.datensaetzes)
                data["datensaetzes"].push(item.toJSON());
        }
        if (Array.isArray(this.dokOrdners)) {
            data["dokOrdners"] = [];
            for (let item of this.dokOrdners)
                data["dokOrdners"].push(item.toJSON());
        }
        if (Array.isArray(this.dokumentes)) {
            data["dokumentes"] = [];
            for (let item of this.dokumentes)
                data["dokumentes"].push(item.toJSON());
        }
        if (Array.isArray(this.ebenens)) {
            data["ebenens"] = [];
            for (let item of this.ebenens)
                data["ebenens"].push(item.toJSON());
        }
        if (Array.isArray(this.gliederungs)) {
            data["gliederungs"] = [];
            for (let item of this.gliederungs)
                data["gliederungs"].push(item.toJSON());
        }
        if (Array.isArray(this.gliederungsebenens)) {
            data["gliederungsebenens"] = [];
            for (let item of this.gliederungsebenens)
                data["gliederungsebenens"].push(item.toJSON());
        }
        if (Array.isArray(this.gruppierungs)) {
            data["gruppierungs"] = [];
            for (let item of this.gruppierungs)
                data["gruppierungs"].push(item.toJSON());
        }
        if (Array.isArray(this.gruppierungsebenens)) {
            data["gruppierungsebenens"] = [];
            for (let item of this.gruppierungsebenens)
                data["gruppierungsebenens"].push(item.toJSON());
        }
        if (Array.isArray(this.gzebenes)) {
            data["gzebenes"] = [];
            for (let item of this.gzebenes)
                data["gzebenes"].push(item.toJSON());
        }
        if (Array.isArray(this.haushaltsstellenDoppisches)) {
            data["haushaltsstellenDoppisches"] = [];
            for (let item of this.haushaltsstellenDoppisches)
                data["haushaltsstellenDoppisches"].push(item.toJSON());
        }
        if (Array.isArray(this.haushaltsstellens)) {
            data["haushaltsstellens"] = [];
            for (let item of this.haushaltsstellens)
                data["haushaltsstellens"].push(item.toJSON());
        }
        if (Array.isArray(this.kennzahlens)) {
            data["kennzahlens"] = [];
            for (let item of this.kennzahlens)
                data["kennzahlens"].push(item.toJSON());
        }
        if (Array.isArray(this.kontenebenens)) {
            data["kontenebenens"] = [];
            for (let item of this.kontenebenens)
                data["kontenebenens"].push(item.toJSON());
        }
        if (Array.isArray(this.kontenplans)) {
            data["kontenplans"] = [];
            for (let item of this.kontenplans)
                data["kontenplans"].push(item.toJSON());
        }
        data["kundeNavigation"] = this.kundeNavigation ? this.kundeNavigation.toJSON() : <any>undefined;
        if (Array.isArray(this.massnahmen)) {
            data["massnahmen"] = [];
            for (let item of this.massnahmen)
                data["massnahmen"].push(item.toJSON());
        }
        if (Array.isArray(this.massnahmenDoppisches)) {
            data["massnahmenDoppisches"] = [];
            for (let item of this.massnahmenDoppisches)
                data["massnahmenDoppisches"].push(item.toJSON());
        }
        if (Array.isArray(this.planstufens)) {
            data["planstufens"] = [];
            for (let item of this.planstufens)
                data["planstufens"].push(item.toJSON());
        }
        if (Array.isArray(this.produktebenens)) {
            data["produktebenens"] = [];
            for (let item of this.produktebenens)
                data["produktebenens"].push(item.toJSON());
        }
        if (Array.isArray(this.produktes)) {
            data["produktes"] = [];
            for (let item of this.produktes)
                data["produktes"].push(item.toJSON());
        }
        if (Array.isArray(this.textes)) {
            data["textes"] = [];
            for (let item of this.textes)
                data["textes"].push(item.toJSON());
        }
        if (Array.isArray(this.uhconfigs)) {
            data["uhconfigs"] = [];
            for (let item of this.uhconfigs)
                data["uhconfigs"].push(item.toJSON());
        }
        if (Array.isArray(this.vbtabs)) {
            data["vbtabs"] = [];
            for (let item of this.vbtabs)
                data["vbtabs"].push(item.toJSON());
        }
        data["wegweiserGemeinde"] = this.wegweiserGemeinde ? this.wegweiserGemeinde.toJSON() : <any>undefined;
        data["guid"] = this.guid;
        data["kundenName"] = this.kundenName;
        data["jahr"] = this.jahr;
        data["einwohner"] = this.einwohner;
        data["kundenObj"] = this.kundenObj ? this.kundenObj.toJSON() : <any>undefined;
        data["settings"] = this.settings ? this.settings.toJSON() : <any>undefined;
        if (this.kennzahlenWerte) {
            data["kennzahlenWerte"] = {};
            for (let key in this.kennzahlenWerte) {
                if (this.kennzahlenWerte.hasOwnProperty(key))
                    (<any>data["kennzahlenWerte"])[key] = this.kennzahlenWerte[key] ? this.kennzahlenWerte[key].toJSON() : <any>undefined;
            }
        }
        if (Array.isArray(this.vergleichskreise)) {
            data["vergleichskreise"] = [];
            for (let item of this.vergleichskreise)
                data["vergleichskreise"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGemeindeKennzahlenModel {
    kunde?: number;
    gemeinde?: number;
    name?: string | undefined;
    buchungsart?: number | undefined;
    inaktiv?: boolean | undefined;
    pubMode?: number | undefined;
    sftpuser?: string | undefined;
    sftphost?: string | undefined;
    sftppw?: string | undefined;
    importFormat?: number | undefined;
    gemeindetyp?: number | undefined;
    keVglMg?: boolean | undefined;
    keVglGt?: boolean | undefined;
    wegweiserGemeindeId?: number | undefined;
    mandant?: number | undefined;
    hauptFtp?: boolean | undefined;
    datensaetzes?: Datensaetze[] | undefined;
    dokOrdners?: DokOrdner[] | undefined;
    dokumentes?: Dokumente[] | undefined;
    ebenens?: Ebenen[] | undefined;
    gliederungs?: Gliederung[] | undefined;
    gliederungsebenens?: Gliederungsebenen[] | undefined;
    gruppierungs?: Gruppierung[] | undefined;
    gruppierungsebenens?: Gruppierungsebenen[] | undefined;
    gzebenes?: Gzebene[] | undefined;
    haushaltsstellenDoppisches?: HaushaltsstellenDoppisch[] | undefined;
    haushaltsstellens?: Haushaltsstellen[] | undefined;
    kennzahlens?: Kennzahlen[] | undefined;
    kontenebenens?: Kontenebenen[] | undefined;
    kontenplans?: Kontenplan[] | undefined;
    kundeNavigation?: Kunden;
    massnahmen?: Massnahman[] | undefined;
    massnahmenDoppisches?: MassnahmenDoppisch[] | undefined;
    planstufens?: Planstufen[] | undefined;
    produktebenens?: Produktebenen[] | undefined;
    produktes?: Produkte[] | undefined;
    textes?: Texte[] | undefined;
    uhconfigs?: Uhconfig[] | undefined;
    vbtabs?: Vbtab[] | undefined;
    wegweiserGemeinde?: WegweiserGemeinden;
    guid?: string | undefined;
    kundenName?: string | undefined;
    jahr?: number;
    einwohner?: number;
    kundenObj?: KundenModel;
    settings?: SettingsModel;
    kennzahlenWerte?: { [key: string]: KennzahlWert; } | undefined;
    vergleichskreise?: Ktvergleichskreise[] | undefined;
}

export class GemeindeModel implements IGemeindeModel {
    kunde?: number;
    gemeinde?: number;
    name?: string | undefined;
    buchungsart?: number | undefined;
    inaktiv?: boolean | undefined;
    pubMode?: number | undefined;
    sftpuser?: string | undefined;
    sftphost?: string | undefined;
    sftppw?: string | undefined;
    importFormat?: number | undefined;
    gemeindetyp?: number | undefined;
    keVglMg?: boolean | undefined;
    keVglGt?: boolean | undefined;
    wegweiserGemeindeId?: number | undefined;
    mandant?: number | undefined;
    hauptFtp?: boolean | undefined;
    datensaetzes?: Datensaetze[] | undefined;
    dokOrdners?: DokOrdner[] | undefined;
    dokumentes?: Dokumente[] | undefined;
    ebenens?: Ebenen[] | undefined;
    gliederungs?: Gliederung[] | undefined;
    gliederungsebenens?: Gliederungsebenen[] | undefined;
    gruppierungs?: Gruppierung[] | undefined;
    gruppierungsebenens?: Gruppierungsebenen[] | undefined;
    gzebenes?: Gzebene[] | undefined;
    haushaltsstellenDoppisches?: HaushaltsstellenDoppisch[] | undefined;
    haushaltsstellens?: Haushaltsstellen[] | undefined;
    kennzahlens?: Kennzahlen[] | undefined;
    kontenebenens?: Kontenebenen[] | undefined;
    kontenplans?: Kontenplan[] | undefined;
    kundeNavigation?: Kunden;
    massnahmen?: Massnahman[] | undefined;
    massnahmenDoppisches?: MassnahmenDoppisch[] | undefined;
    planstufens?: Planstufen[] | undefined;
    produktebenens?: Produktebenen[] | undefined;
    produktes?: Produkte[] | undefined;
    textes?: Texte[] | undefined;
    uhconfigs?: Uhconfig[] | undefined;
    vbtabs?: Vbtab[] | undefined;
    wegweiserGemeinde?: WegweiserGemeinden;
    guid?: string | undefined;
    kundenName?: string | undefined;
    bundesland?: string | undefined;
    jahr?: number;

    constructor(data?: IGemeindeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.name = _data["name"];
            this.buchungsart = _data["buchungsart"];
            this.inaktiv = _data["inaktiv"];
            this.pubMode = _data["pubMode"];
            this.sftpuser = _data["sftpuser"];
            this.sftphost = _data["sftphost"];
            this.sftppw = _data["sftppw"];
            this.importFormat = _data["importFormat"];
            this.gemeindetyp = _data["gemeindetyp"];
            this.keVglMg = _data["keVglMg"];
            this.keVglGt = _data["keVglGt"];
            this.wegweiserGemeindeId = _data["wegweiserGemeindeId"];
            this.mandant = _data["mandant"];
            this.hauptFtp = _data["hauptFtp"];
            if (Array.isArray(_data["datensaetzes"])) {
                this.datensaetzes = [] as any;
                for (let item of _data["datensaetzes"])
                    this.datensaetzes!.push(Datensaetze.fromJS(item));
            }
            if (Array.isArray(_data["dokOrdners"])) {
                this.dokOrdners = [] as any;
                for (let item of _data["dokOrdners"])
                    this.dokOrdners!.push(DokOrdner.fromJS(item));
            }
            if (Array.isArray(_data["dokumentes"])) {
                this.dokumentes = [] as any;
                for (let item of _data["dokumentes"])
                    this.dokumentes!.push(Dokumente.fromJS(item));
            }
            if (Array.isArray(_data["ebenens"])) {
                this.ebenens = [] as any;
                for (let item of _data["ebenens"])
                    this.ebenens!.push(Ebenen.fromJS(item));
            }
            if (Array.isArray(_data["gliederungs"])) {
                this.gliederungs = [] as any;
                for (let item of _data["gliederungs"])
                    this.gliederungs!.push(Gliederung.fromJS(item));
            }
            if (Array.isArray(_data["gliederungsebenens"])) {
                this.gliederungsebenens = [] as any;
                for (let item of _data["gliederungsebenens"])
                    this.gliederungsebenens!.push(Gliederungsebenen.fromJS(item));
            }
            if (Array.isArray(_data["gruppierungs"])) {
                this.gruppierungs = [] as any;
                for (let item of _data["gruppierungs"])
                    this.gruppierungs!.push(Gruppierung.fromJS(item));
            }
            if (Array.isArray(_data["gruppierungsebenens"])) {
                this.gruppierungsebenens = [] as any;
                for (let item of _data["gruppierungsebenens"])
                    this.gruppierungsebenens!.push(Gruppierungsebenen.fromJS(item));
            }
            if (Array.isArray(_data["gzebenes"])) {
                this.gzebenes = [] as any;
                for (let item of _data["gzebenes"])
                    this.gzebenes!.push(Gzebene.fromJS(item));
            }
            if (Array.isArray(_data["haushaltsstellenDoppisches"])) {
                this.haushaltsstellenDoppisches = [] as any;
                for (let item of _data["haushaltsstellenDoppisches"])
                    this.haushaltsstellenDoppisches!.push(HaushaltsstellenDoppisch.fromJS(item));
            }
            if (Array.isArray(_data["haushaltsstellens"])) {
                this.haushaltsstellens = [] as any;
                for (let item of _data["haushaltsstellens"])
                    this.haushaltsstellens!.push(Haushaltsstellen.fromJS(item));
            }
            if (Array.isArray(_data["kennzahlens"])) {
                this.kennzahlens = [] as any;
                for (let item of _data["kennzahlens"])
                    this.kennzahlens!.push(Kennzahlen.fromJS(item));
            }
            if (Array.isArray(_data["kontenebenens"])) {
                this.kontenebenens = [] as any;
                for (let item of _data["kontenebenens"])
                    this.kontenebenens!.push(Kontenebenen.fromJS(item));
            }
            if (Array.isArray(_data["kontenplans"])) {
                this.kontenplans = [] as any;
                for (let item of _data["kontenplans"])
                    this.kontenplans!.push(Kontenplan.fromJS(item));
            }
            this.kundeNavigation = _data["kundeNavigation"] ? Kunden.fromJS(_data["kundeNavigation"]) : <any>undefined;
            if (Array.isArray(_data["massnahmen"])) {
                this.massnahmen = [] as any;
                for (let item of _data["massnahmen"])
                    this.massnahmen!.push(Massnahman.fromJS(item));
            }
            if (Array.isArray(_data["massnahmenDoppisches"])) {
                this.massnahmenDoppisches = [] as any;
                for (let item of _data["massnahmenDoppisches"])
                    this.massnahmenDoppisches!.push(MassnahmenDoppisch.fromJS(item));
            }
            if (Array.isArray(_data["planstufens"])) {
                this.planstufens = [] as any;
                for (let item of _data["planstufens"])
                    this.planstufens!.push(Planstufen.fromJS(item));
            }
            if (Array.isArray(_data["produktebenens"])) {
                this.produktebenens = [] as any;
                for (let item of _data["produktebenens"])
                    this.produktebenens!.push(Produktebenen.fromJS(item));
            }
            if (Array.isArray(_data["produktes"])) {
                this.produktes = [] as any;
                for (let item of _data["produktes"])
                    this.produktes!.push(Produkte.fromJS(item));
            }
            if (Array.isArray(_data["textes"])) {
                this.textes = [] as any;
                for (let item of _data["textes"])
                    this.textes!.push(Texte.fromJS(item));
            }
            if (Array.isArray(_data["uhconfigs"])) {
                this.uhconfigs = [] as any;
                for (let item of _data["uhconfigs"])
                    this.uhconfigs!.push(Uhconfig.fromJS(item));
            }
            if (Array.isArray(_data["vbtabs"])) {
                this.vbtabs = [] as any;
                for (let item of _data["vbtabs"])
                    this.vbtabs!.push(Vbtab.fromJS(item));
            }
            this.wegweiserGemeinde = _data["wegweiserGemeinde"] ? WegweiserGemeinden.fromJS(_data["wegweiserGemeinde"]) : <any>undefined;
            this.guid = _data["guid"];
            this.kundenName = _data["kundenName"];
            this.bundesland = _data["bundesland"];
            this.jahr = _data["jahr"];
        }
    }

    static fromJS(data: any): GemeindeModel {
        data = typeof data === 'object' ? data : {};
        let result = new GemeindeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["name"] = this.name;
        data["buchungsart"] = this.buchungsart;
        data["inaktiv"] = this.inaktiv;
        data["pubMode"] = this.pubMode;
        data["sftpuser"] = this.sftpuser;
        data["sftphost"] = this.sftphost;
        data["sftppw"] = this.sftppw;
        data["importFormat"] = this.importFormat;
        data["gemeindetyp"] = this.gemeindetyp;
        data["keVglMg"] = this.keVglMg;
        data["keVglGt"] = this.keVglGt;
        data["wegweiserGemeindeId"] = this.wegweiserGemeindeId;
        data["mandant"] = this.mandant;
        data["hauptFtp"] = this.hauptFtp;
        if (Array.isArray(this.datensaetzes)) {
            data["datensaetzes"] = [];
            for (let item of this.datensaetzes)
                data["datensaetzes"].push(item.toJSON());
        }
        if (Array.isArray(this.dokOrdners)) {
            data["dokOrdners"] = [];
            for (let item of this.dokOrdners)
                data["dokOrdners"].push(item.toJSON());
        }
        if (Array.isArray(this.dokumentes)) {
            data["dokumentes"] = [];
            for (let item of this.dokumentes)
                data["dokumentes"].push(item.toJSON());
        }
        if (Array.isArray(this.ebenens)) {
            data["ebenens"] = [];
            for (let item of this.ebenens)
                data["ebenens"].push(item.toJSON());
        }
        if (Array.isArray(this.gliederungs)) {
            data["gliederungs"] = [];
            for (let item of this.gliederungs)
                data["gliederungs"].push(item.toJSON());
        }
        if (Array.isArray(this.gliederungsebenens)) {
            data["gliederungsebenens"] = [];
            for (let item of this.gliederungsebenens)
                data["gliederungsebenens"].push(item.toJSON());
        }
        if (Array.isArray(this.gruppierungs)) {
            data["gruppierungs"] = [];
            for (let item of this.gruppierungs)
                data["gruppierungs"].push(item.toJSON());
        }
        if (Array.isArray(this.gruppierungsebenens)) {
            data["gruppierungsebenens"] = [];
            for (let item of this.gruppierungsebenens)
                data["gruppierungsebenens"].push(item.toJSON());
        }
        if (Array.isArray(this.gzebenes)) {
            data["gzebenes"] = [];
            for (let item of this.gzebenes)
                data["gzebenes"].push(item.toJSON());
        }
        if (Array.isArray(this.haushaltsstellenDoppisches)) {
            data["haushaltsstellenDoppisches"] = [];
            for (let item of this.haushaltsstellenDoppisches)
                data["haushaltsstellenDoppisches"].push(item.toJSON());
        }
        if (Array.isArray(this.haushaltsstellens)) {
            data["haushaltsstellens"] = [];
            for (let item of this.haushaltsstellens)
                data["haushaltsstellens"].push(item.toJSON());
        }
        if (Array.isArray(this.kennzahlens)) {
            data["kennzahlens"] = [];
            for (let item of this.kennzahlens)
                data["kennzahlens"].push(item.toJSON());
        }
        if (Array.isArray(this.kontenebenens)) {
            data["kontenebenens"] = [];
            for (let item of this.kontenebenens)
                data["kontenebenens"].push(item.toJSON());
        }
        if (Array.isArray(this.kontenplans)) {
            data["kontenplans"] = [];
            for (let item of this.kontenplans)
                data["kontenplans"].push(item.toJSON());
        }
        data["kundeNavigation"] = this.kundeNavigation ? this.kundeNavigation.toJSON() : <any>undefined;
        if (Array.isArray(this.massnahmen)) {
            data["massnahmen"] = [];
            for (let item of this.massnahmen)
                data["massnahmen"].push(item.toJSON());
        }
        if (Array.isArray(this.massnahmenDoppisches)) {
            data["massnahmenDoppisches"] = [];
            for (let item of this.massnahmenDoppisches)
                data["massnahmenDoppisches"].push(item.toJSON());
        }
        if (Array.isArray(this.planstufens)) {
            data["planstufens"] = [];
            for (let item of this.planstufens)
                data["planstufens"].push(item.toJSON());
        }
        if (Array.isArray(this.produktebenens)) {
            data["produktebenens"] = [];
            for (let item of this.produktebenens)
                data["produktebenens"].push(item.toJSON());
        }
        if (Array.isArray(this.produktes)) {
            data["produktes"] = [];
            for (let item of this.produktes)
                data["produktes"].push(item.toJSON());
        }
        if (Array.isArray(this.textes)) {
            data["textes"] = [];
            for (let item of this.textes)
                data["textes"].push(item.toJSON());
        }
        if (Array.isArray(this.uhconfigs)) {
            data["uhconfigs"] = [];
            for (let item of this.uhconfigs)
                data["uhconfigs"].push(item.toJSON());
        }
        if (Array.isArray(this.vbtabs)) {
            data["vbtabs"] = [];
            for (let item of this.vbtabs)
                data["vbtabs"].push(item.toJSON());
        }
        data["wegweiserGemeinde"] = this.wegweiserGemeinde ? this.wegweiserGemeinde.toJSON() : <any>undefined;
        data["guid"] = this.guid;
        data["kundenName"] = this.kundenName;
        data["bundesland"] = this.bundesland;
        data["jahr"] = this.jahr;
        return data;
    }
}

export interface IGemeindeModel {
    kunde?: number;
    gemeinde?: number;
    name?: string | undefined;
    buchungsart?: number | undefined;
    inaktiv?: boolean | undefined;
    pubMode?: number | undefined;
    sftpuser?: string | undefined;
    sftphost?: string | undefined;
    sftppw?: string | undefined;
    importFormat?: number | undefined;
    gemeindetyp?: number | undefined;
    keVglMg?: boolean | undefined;
    keVglGt?: boolean | undefined;
    wegweiserGemeindeId?: number | undefined;
    mandant?: number | undefined;
    hauptFtp?: boolean | undefined;
    datensaetzes?: Datensaetze[] | undefined;
    dokOrdners?: DokOrdner[] | undefined;
    dokumentes?: Dokumente[] | undefined;
    ebenens?: Ebenen[] | undefined;
    gliederungs?: Gliederung[] | undefined;
    gliederungsebenens?: Gliederungsebenen[] | undefined;
    gruppierungs?: Gruppierung[] | undefined;
    gruppierungsebenens?: Gruppierungsebenen[] | undefined;
    gzebenes?: Gzebene[] | undefined;
    haushaltsstellenDoppisches?: HaushaltsstellenDoppisch[] | undefined;
    haushaltsstellens?: Haushaltsstellen[] | undefined;
    kennzahlens?: Kennzahlen[] | undefined;
    kontenebenens?: Kontenebenen[] | undefined;
    kontenplans?: Kontenplan[] | undefined;
    kundeNavigation?: Kunden;
    massnahmen?: Massnahman[] | undefined;
    massnahmenDoppisches?: MassnahmenDoppisch[] | undefined;
    planstufens?: Planstufen[] | undefined;
    produktebenens?: Produktebenen[] | undefined;
    produktes?: Produkte[] | undefined;
    textes?: Texte[] | undefined;
    uhconfigs?: Uhconfig[] | undefined;
    vbtabs?: Vbtab[] | undefined;
    wegweiserGemeinde?: WegweiserGemeinden;
    guid?: string | undefined;
    kundenName?: string | undefined;
    bundesland?: string | undefined;
    jahr?: number;
}

export class Gemeinden implements IGemeinden {
    kunde?: number;
    gemeinde?: number;
    name?: string | undefined;
    buchungsart?: number | undefined;
    inaktiv?: boolean | undefined;
    pubMode?: number | undefined;
    sftpuser?: string | undefined;
    sftphost?: string | undefined;
    sftppw?: string | undefined;
    importFormat?: number | undefined;
    gemeindetyp?: number | undefined;
    keVglMg?: boolean | undefined;
    keVglGt?: boolean | undefined;
    wegweiserGemeindeId?: number | undefined;
    mandant?: number | undefined;
    hauptFtp?: boolean | undefined;
    datensaetzes?: Datensaetze[] | undefined;
    dokOrdners?: DokOrdner[] | undefined;
    dokumentes?: Dokumente[] | undefined;
    ebenens?: Ebenen[] | undefined;
    gliederungs?: Gliederung[] | undefined;
    gliederungsebenens?: Gliederungsebenen[] | undefined;
    gruppierungs?: Gruppierung[] | undefined;
    gruppierungsebenens?: Gruppierungsebenen[] | undefined;
    gzebenes?: Gzebene[] | undefined;
    haushaltsstellenDoppisches?: HaushaltsstellenDoppisch[] | undefined;
    haushaltsstellens?: Haushaltsstellen[] | undefined;
    kennzahlens?: Kennzahlen[] | undefined;
    kontenebenens?: Kontenebenen[] | undefined;
    kontenplans?: Kontenplan[] | undefined;
    kundeNavigation?: Kunden;
    massnahmen?: Massnahman[] | undefined;
    massnahmenDoppisches?: MassnahmenDoppisch[] | undefined;
    planstufens?: Planstufen[] | undefined;
    produktebenens?: Produktebenen[] | undefined;
    produktes?: Produkte[] | undefined;
    textes?: Texte[] | undefined;
    uhconfigs?: Uhconfig[] | undefined;
    vbtabs?: Vbtab[] | undefined;
    wegweiserGemeinde?: WegweiserGemeinden;

    constructor(data?: IGemeinden) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.name = _data["name"];
            this.buchungsart = _data["buchungsart"];
            this.inaktiv = _data["inaktiv"];
            this.pubMode = _data["pubMode"];
            this.sftpuser = _data["sftpuser"];
            this.sftphost = _data["sftphost"];
            this.sftppw = _data["sftppw"];
            this.importFormat = _data["importFormat"];
            this.gemeindetyp = _data["gemeindetyp"];
            this.keVglMg = _data["keVglMg"];
            this.keVglGt = _data["keVglGt"];
            this.wegweiserGemeindeId = _data["wegweiserGemeindeId"];
            this.mandant = _data["mandant"];
            this.hauptFtp = _data["hauptFtp"];
            if (Array.isArray(_data["datensaetzes"])) {
                this.datensaetzes = [] as any;
                for (let item of _data["datensaetzes"])
                    this.datensaetzes!.push(Datensaetze.fromJS(item));
            }
            if (Array.isArray(_data["dokOrdners"])) {
                this.dokOrdners = [] as any;
                for (let item of _data["dokOrdners"])
                    this.dokOrdners!.push(DokOrdner.fromJS(item));
            }
            if (Array.isArray(_data["dokumentes"])) {
                this.dokumentes = [] as any;
                for (let item of _data["dokumentes"])
                    this.dokumentes!.push(Dokumente.fromJS(item));
            }
            if (Array.isArray(_data["ebenens"])) {
                this.ebenens = [] as any;
                for (let item of _data["ebenens"])
                    this.ebenens!.push(Ebenen.fromJS(item));
            }
            if (Array.isArray(_data["gliederungs"])) {
                this.gliederungs = [] as any;
                for (let item of _data["gliederungs"])
                    this.gliederungs!.push(Gliederung.fromJS(item));
            }
            if (Array.isArray(_data["gliederungsebenens"])) {
                this.gliederungsebenens = [] as any;
                for (let item of _data["gliederungsebenens"])
                    this.gliederungsebenens!.push(Gliederungsebenen.fromJS(item));
            }
            if (Array.isArray(_data["gruppierungs"])) {
                this.gruppierungs = [] as any;
                for (let item of _data["gruppierungs"])
                    this.gruppierungs!.push(Gruppierung.fromJS(item));
            }
            if (Array.isArray(_data["gruppierungsebenens"])) {
                this.gruppierungsebenens = [] as any;
                for (let item of _data["gruppierungsebenens"])
                    this.gruppierungsebenens!.push(Gruppierungsebenen.fromJS(item));
            }
            if (Array.isArray(_data["gzebenes"])) {
                this.gzebenes = [] as any;
                for (let item of _data["gzebenes"])
                    this.gzebenes!.push(Gzebene.fromJS(item));
            }
            if (Array.isArray(_data["haushaltsstellenDoppisches"])) {
                this.haushaltsstellenDoppisches = [] as any;
                for (let item of _data["haushaltsstellenDoppisches"])
                    this.haushaltsstellenDoppisches!.push(HaushaltsstellenDoppisch.fromJS(item));
            }
            if (Array.isArray(_data["haushaltsstellens"])) {
                this.haushaltsstellens = [] as any;
                for (let item of _data["haushaltsstellens"])
                    this.haushaltsstellens!.push(Haushaltsstellen.fromJS(item));
            }
            if (Array.isArray(_data["kennzahlens"])) {
                this.kennzahlens = [] as any;
                for (let item of _data["kennzahlens"])
                    this.kennzahlens!.push(Kennzahlen.fromJS(item));
            }
            if (Array.isArray(_data["kontenebenens"])) {
                this.kontenebenens = [] as any;
                for (let item of _data["kontenebenens"])
                    this.kontenebenens!.push(Kontenebenen.fromJS(item));
            }
            if (Array.isArray(_data["kontenplans"])) {
                this.kontenplans = [] as any;
                for (let item of _data["kontenplans"])
                    this.kontenplans!.push(Kontenplan.fromJS(item));
            }
            this.kundeNavigation = _data["kundeNavigation"] ? Kunden.fromJS(_data["kundeNavigation"]) : <any>undefined;
            if (Array.isArray(_data["massnahmen"])) {
                this.massnahmen = [] as any;
                for (let item of _data["massnahmen"])
                    this.massnahmen!.push(Massnahman.fromJS(item));
            }
            if (Array.isArray(_data["massnahmenDoppisches"])) {
                this.massnahmenDoppisches = [] as any;
                for (let item of _data["massnahmenDoppisches"])
                    this.massnahmenDoppisches!.push(MassnahmenDoppisch.fromJS(item));
            }
            if (Array.isArray(_data["planstufens"])) {
                this.planstufens = [] as any;
                for (let item of _data["planstufens"])
                    this.planstufens!.push(Planstufen.fromJS(item));
            }
            if (Array.isArray(_data["produktebenens"])) {
                this.produktebenens = [] as any;
                for (let item of _data["produktebenens"])
                    this.produktebenens!.push(Produktebenen.fromJS(item));
            }
            if (Array.isArray(_data["produktes"])) {
                this.produktes = [] as any;
                for (let item of _data["produktes"])
                    this.produktes!.push(Produkte.fromJS(item));
            }
            if (Array.isArray(_data["textes"])) {
                this.textes = [] as any;
                for (let item of _data["textes"])
                    this.textes!.push(Texte.fromJS(item));
            }
            if (Array.isArray(_data["uhconfigs"])) {
                this.uhconfigs = [] as any;
                for (let item of _data["uhconfigs"])
                    this.uhconfigs!.push(Uhconfig.fromJS(item));
            }
            if (Array.isArray(_data["vbtabs"])) {
                this.vbtabs = [] as any;
                for (let item of _data["vbtabs"])
                    this.vbtabs!.push(Vbtab.fromJS(item));
            }
            this.wegweiserGemeinde = _data["wegweiserGemeinde"] ? WegweiserGemeinden.fromJS(_data["wegweiserGemeinde"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Gemeinden {
        data = typeof data === 'object' ? data : {};
        let result = new Gemeinden();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["name"] = this.name;
        data["buchungsart"] = this.buchungsart;
        data["inaktiv"] = this.inaktiv;
        data["pubMode"] = this.pubMode;
        data["sftpuser"] = this.sftpuser;
        data["sftphost"] = this.sftphost;
        data["sftppw"] = this.sftppw;
        data["importFormat"] = this.importFormat;
        data["gemeindetyp"] = this.gemeindetyp;
        data["keVglMg"] = this.keVglMg;
        data["keVglGt"] = this.keVglGt;
        data["wegweiserGemeindeId"] = this.wegweiserGemeindeId;
        data["mandant"] = this.mandant;
        data["hauptFtp"] = this.hauptFtp;
        if (Array.isArray(this.datensaetzes)) {
            data["datensaetzes"] = [];
            for (let item of this.datensaetzes)
                data["datensaetzes"].push(item.toJSON());
        }
        if (Array.isArray(this.dokOrdners)) {
            data["dokOrdners"] = [];
            for (let item of this.dokOrdners)
                data["dokOrdners"].push(item.toJSON());
        }
        if (Array.isArray(this.dokumentes)) {
            data["dokumentes"] = [];
            for (let item of this.dokumentes)
                data["dokumentes"].push(item.toJSON());
        }
        if (Array.isArray(this.ebenens)) {
            data["ebenens"] = [];
            for (let item of this.ebenens)
                data["ebenens"].push(item.toJSON());
        }
        if (Array.isArray(this.gliederungs)) {
            data["gliederungs"] = [];
            for (let item of this.gliederungs)
                data["gliederungs"].push(item.toJSON());
        }
        if (Array.isArray(this.gliederungsebenens)) {
            data["gliederungsebenens"] = [];
            for (let item of this.gliederungsebenens)
                data["gliederungsebenens"].push(item.toJSON());
        }
        if (Array.isArray(this.gruppierungs)) {
            data["gruppierungs"] = [];
            for (let item of this.gruppierungs)
                data["gruppierungs"].push(item.toJSON());
        }
        if (Array.isArray(this.gruppierungsebenens)) {
            data["gruppierungsebenens"] = [];
            for (let item of this.gruppierungsebenens)
                data["gruppierungsebenens"].push(item.toJSON());
        }
        if (Array.isArray(this.gzebenes)) {
            data["gzebenes"] = [];
            for (let item of this.gzebenes)
                data["gzebenes"].push(item.toJSON());
        }
        if (Array.isArray(this.haushaltsstellenDoppisches)) {
            data["haushaltsstellenDoppisches"] = [];
            for (let item of this.haushaltsstellenDoppisches)
                data["haushaltsstellenDoppisches"].push(item.toJSON());
        }
        if (Array.isArray(this.haushaltsstellens)) {
            data["haushaltsstellens"] = [];
            for (let item of this.haushaltsstellens)
                data["haushaltsstellens"].push(item.toJSON());
        }
        if (Array.isArray(this.kennzahlens)) {
            data["kennzahlens"] = [];
            for (let item of this.kennzahlens)
                data["kennzahlens"].push(item.toJSON());
        }
        if (Array.isArray(this.kontenebenens)) {
            data["kontenebenens"] = [];
            for (let item of this.kontenebenens)
                data["kontenebenens"].push(item.toJSON());
        }
        if (Array.isArray(this.kontenplans)) {
            data["kontenplans"] = [];
            for (let item of this.kontenplans)
                data["kontenplans"].push(item.toJSON());
        }
        data["kundeNavigation"] = this.kundeNavigation ? this.kundeNavigation.toJSON() : <any>undefined;
        if (Array.isArray(this.massnahmen)) {
            data["massnahmen"] = [];
            for (let item of this.massnahmen)
                data["massnahmen"].push(item.toJSON());
        }
        if (Array.isArray(this.massnahmenDoppisches)) {
            data["massnahmenDoppisches"] = [];
            for (let item of this.massnahmenDoppisches)
                data["massnahmenDoppisches"].push(item.toJSON());
        }
        if (Array.isArray(this.planstufens)) {
            data["planstufens"] = [];
            for (let item of this.planstufens)
                data["planstufens"].push(item.toJSON());
        }
        if (Array.isArray(this.produktebenens)) {
            data["produktebenens"] = [];
            for (let item of this.produktebenens)
                data["produktebenens"].push(item.toJSON());
        }
        if (Array.isArray(this.produktes)) {
            data["produktes"] = [];
            for (let item of this.produktes)
                data["produktes"].push(item.toJSON());
        }
        if (Array.isArray(this.textes)) {
            data["textes"] = [];
            for (let item of this.textes)
                data["textes"].push(item.toJSON());
        }
        if (Array.isArray(this.uhconfigs)) {
            data["uhconfigs"] = [];
            for (let item of this.uhconfigs)
                data["uhconfigs"].push(item.toJSON());
        }
        if (Array.isArray(this.vbtabs)) {
            data["vbtabs"] = [];
            for (let item of this.vbtabs)
                data["vbtabs"].push(item.toJSON());
        }
        data["wegweiserGemeinde"] = this.wegweiserGemeinde ? this.wegweiserGemeinde.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGemeinden {
    kunde?: number;
    gemeinde?: number;
    name?: string | undefined;
    buchungsart?: number | undefined;
    inaktiv?: boolean | undefined;
    pubMode?: number | undefined;
    sftpuser?: string | undefined;
    sftphost?: string | undefined;
    sftppw?: string | undefined;
    importFormat?: number | undefined;
    gemeindetyp?: number | undefined;
    keVglMg?: boolean | undefined;
    keVglGt?: boolean | undefined;
    wegweiserGemeindeId?: number | undefined;
    mandant?: number | undefined;
    hauptFtp?: boolean | undefined;
    datensaetzes?: Datensaetze[] | undefined;
    dokOrdners?: DokOrdner[] | undefined;
    dokumentes?: Dokumente[] | undefined;
    ebenens?: Ebenen[] | undefined;
    gliederungs?: Gliederung[] | undefined;
    gliederungsebenens?: Gliederungsebenen[] | undefined;
    gruppierungs?: Gruppierung[] | undefined;
    gruppierungsebenens?: Gruppierungsebenen[] | undefined;
    gzebenes?: Gzebene[] | undefined;
    haushaltsstellenDoppisches?: HaushaltsstellenDoppisch[] | undefined;
    haushaltsstellens?: Haushaltsstellen[] | undefined;
    kennzahlens?: Kennzahlen[] | undefined;
    kontenebenens?: Kontenebenen[] | undefined;
    kontenplans?: Kontenplan[] | undefined;
    kundeNavigation?: Kunden;
    massnahmen?: Massnahman[] | undefined;
    massnahmenDoppisches?: MassnahmenDoppisch[] | undefined;
    planstufens?: Planstufen[] | undefined;
    produktebenens?: Produktebenen[] | undefined;
    produktes?: Produkte[] | undefined;
    textes?: Texte[] | undefined;
    uhconfigs?: Uhconfig[] | undefined;
    vbtabs?: Vbtab[] | undefined;
    wegweiserGemeinde?: WegweiserGemeinden;
}

export enum GenericFontFamily {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export class Gliederung implements IGliederung {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    nummer?: number;
    bezeichnung?: string | undefined;
    loeschbar?: boolean;
    umbenennbar?: boolean;
    beschreibung?: string | undefined;
    geprueft?: boolean | undefined;
    stellenFmt?: number | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;

    constructor(data?: IGliederung) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.stellen = _data["stellen"];
            this.nummer = _data["nummer"];
            this.bezeichnung = _data["bezeichnung"];
            this.loeschbar = _data["loeschbar"];
            this.umbenennbar = _data["umbenennbar"];
            this.beschreibung = _data["beschreibung"];
            this.geprueft = _data["geprueft"];
            this.stellenFmt = _data["stellenFmt"];
            this.oeffentlich = _data["oeffentlich"];
            this.oeffentlichVerwaltung = _data["oeffentlichVerwaltung"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Gliederung {
        data = typeof data === 'object' ? data : {};
        let result = new Gliederung();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["stellen"] = this.stellen;
        data["nummer"] = this.nummer;
        data["bezeichnung"] = this.bezeichnung;
        data["loeschbar"] = this.loeschbar;
        data["umbenennbar"] = this.umbenennbar;
        data["beschreibung"] = this.beschreibung;
        data["geprueft"] = this.geprueft;
        data["stellenFmt"] = this.stellenFmt;
        data["oeffentlich"] = this.oeffentlich;
        data["oeffentlichVerwaltung"] = this.oeffentlichVerwaltung;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGliederung {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    nummer?: number;
    bezeichnung?: string | undefined;
    loeschbar?: boolean;
    umbenennbar?: boolean;
    beschreibung?: string | undefined;
    geprueft?: boolean | undefined;
    stellenFmt?: number | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;
}

export class GliederungsModel implements IGliederungsModel {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    nummer?: number;
    bezeichnung?: string | undefined;
    loeschbar?: boolean;
    umbenennbar?: boolean;
    beschreibung?: string | undefined;
    geprueft?: boolean | undefined;
    stellenFmt?: number | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;
    id?: number;
    nummerFmt?: string | undefined;

    constructor(data?: IGliederungsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.stellen = _data["stellen"];
            this.nummer = _data["nummer"];
            this.bezeichnung = _data["bezeichnung"];
            this.loeschbar = _data["loeschbar"];
            this.umbenennbar = _data["umbenennbar"];
            this.beschreibung = _data["beschreibung"];
            this.geprueft = _data["geprueft"];
            this.stellenFmt = _data["stellenFmt"];
            this.oeffentlich = _data["oeffentlich"];
            this.oeffentlichVerwaltung = _data["oeffentlichVerwaltung"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
            this.id = _data["id"];
            this.nummerFmt = _data["nummerFmt"];
        }
    }

    static fromJS(data: any): GliederungsModel {
        data = typeof data === 'object' ? data : {};
        let result = new GliederungsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["stellen"] = this.stellen;
        data["nummer"] = this.nummer;
        data["bezeichnung"] = this.bezeichnung;
        data["loeschbar"] = this.loeschbar;
        data["umbenennbar"] = this.umbenennbar;
        data["beschreibung"] = this.beschreibung;
        data["geprueft"] = this.geprueft;
        data["stellenFmt"] = this.stellenFmt;
        data["oeffentlich"] = this.oeffentlich;
        data["oeffentlichVerwaltung"] = this.oeffentlichVerwaltung;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["nummerFmt"] = this.nummerFmt;
        return data;
    }
}

export interface IGliederungsModel {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    nummer?: number;
    bezeichnung?: string | undefined;
    loeschbar?: boolean;
    umbenennbar?: boolean;
    beschreibung?: string | undefined;
    geprueft?: boolean | undefined;
    stellenFmt?: number | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;
    id?: number;
    nummerFmt?: string | undefined;
}

export class Gliederungsebenen implements IGliederungsebenen {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    bezeichnung?: string | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;

    constructor(data?: IGliederungsebenen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.stellen = _data["stellen"];
            this.bezeichnung = _data["bezeichnung"];
            this.oeffentlich = _data["oeffentlich"];
            this.oeffentlichVerwaltung = _data["oeffentlichVerwaltung"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Gliederungsebenen {
        data = typeof data === 'object' ? data : {};
        let result = new Gliederungsebenen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["stellen"] = this.stellen;
        data["bezeichnung"] = this.bezeichnung;
        data["oeffentlich"] = this.oeffentlich;
        data["oeffentlichVerwaltung"] = this.oeffentlichVerwaltung;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGliederungsebenen {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    bezeichnung?: string | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;
}

export class GliederungsebenenModel implements IGliederungsebenenModel {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    bezeichnung?: string | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;
    id?: number;

    constructor(data?: IGliederungsebenenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.stellen = _data["stellen"];
            this.bezeichnung = _data["bezeichnung"];
            this.oeffentlich = _data["oeffentlich"];
            this.oeffentlichVerwaltung = _data["oeffentlichVerwaltung"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GliederungsebenenModel {
        data = typeof data === 'object' ? data : {};
        let result = new GliederungsebenenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["stellen"] = this.stellen;
        data["bezeichnung"] = this.bezeichnung;
        data["oeffentlich"] = this.oeffentlich;
        data["oeffentlichVerwaltung"] = this.oeffentlichVerwaltung;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IGliederungsebenenModel {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    bezeichnung?: string | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;
    id?: number;
}

export enum GrafikTyp {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    __2 = -2,
}

export class Gruppierung implements IGruppierung {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    nummer?: number;
    bezeichnung?: string | undefined;
    loeschbar?: boolean;
    umbenennbar?: boolean;
    beschreibung?: string | undefined;
    geprueft?: boolean | undefined;
    stellenFmt?: number | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;

    constructor(data?: IGruppierung) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.stellen = _data["stellen"];
            this.nummer = _data["nummer"];
            this.bezeichnung = _data["bezeichnung"];
            this.loeschbar = _data["loeschbar"];
            this.umbenennbar = _data["umbenennbar"];
            this.beschreibung = _data["beschreibung"];
            this.geprueft = _data["geprueft"];
            this.stellenFmt = _data["stellenFmt"];
            this.oeffentlich = _data["oeffentlich"];
            this.oeffentlichVerwaltung = _data["oeffentlichVerwaltung"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Gruppierung {
        data = typeof data === 'object' ? data : {};
        let result = new Gruppierung();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["stellen"] = this.stellen;
        data["nummer"] = this.nummer;
        data["bezeichnung"] = this.bezeichnung;
        data["loeschbar"] = this.loeschbar;
        data["umbenennbar"] = this.umbenennbar;
        data["beschreibung"] = this.beschreibung;
        data["geprueft"] = this.geprueft;
        data["stellenFmt"] = this.stellenFmt;
        data["oeffentlich"] = this.oeffentlich;
        data["oeffentlichVerwaltung"] = this.oeffentlichVerwaltung;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGruppierung {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    nummer?: number;
    bezeichnung?: string | undefined;
    loeschbar?: boolean;
    umbenennbar?: boolean;
    beschreibung?: string | undefined;
    geprueft?: boolean | undefined;
    stellenFmt?: number | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;
}

export class Gruppierung2Text implements IGruppierung2Text {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    nummer?: number;
    textId?: number;
    order?: number | undefined;

    constructor(data?: IGruppierung2Text) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.stellen = _data["stellen"];
            this.nummer = _data["nummer"];
            this.textId = _data["textId"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): Gruppierung2Text {
        data = typeof data === 'object' ? data : {};
        let result = new Gruppierung2Text();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["stellen"] = this.stellen;
        data["nummer"] = this.nummer;
        data["textId"] = this.textId;
        data["order"] = this.order;
        return data;
    }
}

export interface IGruppierung2Text {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    nummer?: number;
    textId?: number;
    order?: number | undefined;
}

export class GruppierungsModel implements IGruppierungsModel {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    nummer?: number;
    bezeichnung?: string | undefined;
    loeschbar?: boolean;
    umbenennbar?: boolean;
    beschreibung?: string | undefined;
    geprueft?: boolean | undefined;
    stellenFmt?: number | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;
    id?: number;
    nummerFmt?: string | undefined;

    constructor(data?: IGruppierungsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.stellen = _data["stellen"];
            this.nummer = _data["nummer"];
            this.bezeichnung = _data["bezeichnung"];
            this.loeschbar = _data["loeschbar"];
            this.umbenennbar = _data["umbenennbar"];
            this.beschreibung = _data["beschreibung"];
            this.geprueft = _data["geprueft"];
            this.stellenFmt = _data["stellenFmt"];
            this.oeffentlich = _data["oeffentlich"];
            this.oeffentlichVerwaltung = _data["oeffentlichVerwaltung"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
            this.id = _data["id"];
            this.nummerFmt = _data["nummerFmt"];
        }
    }

    static fromJS(data: any): GruppierungsModel {
        data = typeof data === 'object' ? data : {};
        let result = new GruppierungsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["stellen"] = this.stellen;
        data["nummer"] = this.nummer;
        data["bezeichnung"] = this.bezeichnung;
        data["loeschbar"] = this.loeschbar;
        data["umbenennbar"] = this.umbenennbar;
        data["beschreibung"] = this.beschreibung;
        data["geprueft"] = this.geprueft;
        data["stellenFmt"] = this.stellenFmt;
        data["oeffentlich"] = this.oeffentlich;
        data["oeffentlichVerwaltung"] = this.oeffentlichVerwaltung;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["nummerFmt"] = this.nummerFmt;
        return data;
    }
}

export interface IGruppierungsModel {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    nummer?: number;
    bezeichnung?: string | undefined;
    loeschbar?: boolean;
    umbenennbar?: boolean;
    beschreibung?: string | undefined;
    geprueft?: boolean | undefined;
    stellenFmt?: number | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;
    id?: number;
    nummerFmt?: string | undefined;
}

export class Gruppierungsebenen implements IGruppierungsebenen {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    bezeichnung?: string | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;

    constructor(data?: IGruppierungsebenen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.stellen = _data["stellen"];
            this.bezeichnung = _data["bezeichnung"];
            this.oeffentlich = _data["oeffentlich"];
            this.oeffentlichVerwaltung = _data["oeffentlichVerwaltung"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Gruppierungsebenen {
        data = typeof data === 'object' ? data : {};
        let result = new Gruppierungsebenen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["stellen"] = this.stellen;
        data["bezeichnung"] = this.bezeichnung;
        data["oeffentlich"] = this.oeffentlich;
        data["oeffentlichVerwaltung"] = this.oeffentlichVerwaltung;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGruppierungsebenen {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    bezeichnung?: string | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;
}

export class GruppierungsebenenModel implements IGruppierungsebenenModel {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    bezeichnung?: string | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;
    id?: number;

    constructor(data?: IGruppierungsebenenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.stellen = _data["stellen"];
            this.bezeichnung = _data["bezeichnung"];
            this.oeffentlich = _data["oeffentlich"];
            this.oeffentlichVerwaltung = _data["oeffentlichVerwaltung"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GruppierungsebenenModel {
        data = typeof data === 'object' ? data : {};
        let result = new GruppierungsebenenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["stellen"] = this.stellen;
        data["bezeichnung"] = this.bezeichnung;
        data["oeffentlich"] = this.oeffentlich;
        data["oeffentlichVerwaltung"] = this.oeffentlichVerwaltung;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IGruppierungsebenenModel {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    bezeichnung?: string | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;
    id?: number;
}

export class Gzebene implements IGzebene {
    ebeneId?: string | undefined;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    istOberEbene?: boolean;
    oberebene?: string | undefined;
    order?: number | undefined;
    produkt?: string | undefined;
    gemeinden?: Gemeinden;

    constructor(data?: IGzebene) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ebeneId = _data["ebeneId"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.bezeichnung = _data["bezeichnung"];
            this.istOberEbene = _data["istOberEbene"];
            this.oberebene = _data["oberebene"];
            this.order = _data["order"];
            this.produkt = _data["produkt"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Gzebene {
        data = typeof data === 'object' ? data : {};
        let result = new Gzebene();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ebeneId"] = this.ebeneId;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["bezeichnung"] = this.bezeichnung;
        data["istOberEbene"] = this.istOberEbene;
        data["oberebene"] = this.oberebene;
        data["order"] = this.order;
        data["produkt"] = this.produkt;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGzebene {
    ebeneId?: string | undefined;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    istOberEbene?: boolean;
    oberebene?: string | undefined;
    order?: number | undefined;
    produkt?: string | undefined;
    gemeinden?: Gemeinden;
}

export class HHSPlanDoppischModel implements IHHSPlanDoppischModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    produkt?: number;
    konto?: number;
    bezeichnung?: string | undefined;
    produktText?: string | undefined;
    beschreibung?: string | undefined;
    beginnJahr?: number | undefined;
    endJahr?: number | undefined;
    manuell?: boolean | undefined;
    modifiziert?: boolean | undefined;
    produktEbene?: string | undefined;
    ansatzPjTerm?: string | undefined;
    kontoExtra?: string | undefined;
    gemeinden?: Gemeinden;
    readonly containsData?: boolean;
    massnahmen?: MNPlanDoppischModel[] | undefined;
    ebenen?: string[] | undefined;
    guid?: string | undefined;
    edit?: boolean;
    ergebnisVvvJ?: number;
    ergebnisVvJ?: number;
    ansatzVJ?: number;
    ergebnisVJ?: number;
    ansatzPj?: number;
    ansatzPjImp?: number;
    ansatzPjCalc?: number | undefined;
    ansatzPjDiff?: number | undefined;
    fp1?: number;
    fp2?: number;
    fp3?: number;
    fp4?: number;
    fp5?: number;
    fp6?: number;
    fp7?: number;
    fp8?: number;
    fp9?: number;
    fp10?: number;
    calcPlanErr?: string | undefined;
    ausgabe?: boolean;
    historie?: PlanHistorieModel[] | undefined;

    constructor(data?: IHHSPlanDoppischModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.produkt = _data["produkt"];
            this.konto = _data["konto"];
            this.bezeichnung = _data["bezeichnung"];
            this.produktText = _data["produktText"];
            this.beschreibung = _data["beschreibung"];
            this.beginnJahr = _data["beginnJahr"];
            this.endJahr = _data["endJahr"];
            this.manuell = _data["manuell"];
            this.modifiziert = _data["modifiziert"];
            this.produktEbene = _data["produktEbene"];
            this.ansatzPjTerm = _data["ansatzPjTerm"];
            this.kontoExtra = _data["kontoExtra"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
            (<any>this).containsData = _data["containsData"];
            if (Array.isArray(_data["massnahmen"])) {
                this.massnahmen = [] as any;
                for (let item of _data["massnahmen"])
                    this.massnahmen!.push(MNPlanDoppischModel.fromJS(item));
            }
            if (Array.isArray(_data["ebenen"])) {
                this.ebenen = [] as any;
                for (let item of _data["ebenen"])
                    this.ebenen!.push(item);
            }
            this.guid = _data["guid"];
            this.edit = _data["edit"];
            this.ergebnisVvvJ = _data["ergebnisVvvJ"];
            this.ergebnisVvJ = _data["ergebnisVvJ"];
            this.ansatzVJ = _data["ansatzVJ"];
            this.ergebnisVJ = _data["ergebnisVJ"];
            this.ansatzPj = _data["ansatzPj"];
            this.ansatzPjImp = _data["ansatzPjImp"];
            this.ansatzPjCalc = _data["ansatzPjCalc"];
            this.ansatzPjDiff = _data["ansatzPjDiff"];
            this.fp1 = _data["fp1"];
            this.fp2 = _data["fp2"];
            this.fp3 = _data["fp3"];
            this.fp4 = _data["fp4"];
            this.fp5 = _data["fp5"];
            this.fp6 = _data["fp6"];
            this.fp7 = _data["fp7"];
            this.fp8 = _data["fp8"];
            this.fp9 = _data["fp9"];
            this.fp10 = _data["fp10"];
            this.calcPlanErr = _data["calcPlanErr"];
            this.ausgabe = _data["ausgabe"];
            if (Array.isArray(_data["historie"])) {
                this.historie = [] as any;
                for (let item of _data["historie"])
                    this.historie!.push(PlanHistorieModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HHSPlanDoppischModel {
        data = typeof data === 'object' ? data : {};
        let result = new HHSPlanDoppischModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["produkt"] = this.produkt;
        data["konto"] = this.konto;
        data["bezeichnung"] = this.bezeichnung;
        data["produktText"] = this.produktText;
        data["beschreibung"] = this.beschreibung;
        data["beginnJahr"] = this.beginnJahr;
        data["endJahr"] = this.endJahr;
        data["manuell"] = this.manuell;
        data["modifiziert"] = this.modifiziert;
        data["produktEbene"] = this.produktEbene;
        data["ansatzPjTerm"] = this.ansatzPjTerm;
        data["kontoExtra"] = this.kontoExtra;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        data["containsData"] = this.containsData;
        if (Array.isArray(this.massnahmen)) {
            data["massnahmen"] = [];
            for (let item of this.massnahmen)
                data["massnahmen"].push(item.toJSON());
        }
        if (Array.isArray(this.ebenen)) {
            data["ebenen"] = [];
            for (let item of this.ebenen)
                data["ebenen"].push(item);
        }
        data["guid"] = this.guid;
        data["edit"] = this.edit;
        data["ergebnisVvvJ"] = this.ergebnisVvvJ;
        data["ergebnisVvJ"] = this.ergebnisVvJ;
        data["ansatzVJ"] = this.ansatzVJ;
        data["ergebnisVJ"] = this.ergebnisVJ;
        data["ansatzPj"] = this.ansatzPj;
        data["ansatzPjImp"] = this.ansatzPjImp;
        data["ansatzPjCalc"] = this.ansatzPjCalc;
        data["ansatzPjDiff"] = this.ansatzPjDiff;
        data["fp1"] = this.fp1;
        data["fp2"] = this.fp2;
        data["fp3"] = this.fp3;
        data["fp4"] = this.fp4;
        data["fp5"] = this.fp5;
        data["fp6"] = this.fp6;
        data["fp7"] = this.fp7;
        data["fp8"] = this.fp8;
        data["fp9"] = this.fp9;
        data["fp10"] = this.fp10;
        data["calcPlanErr"] = this.calcPlanErr;
        data["ausgabe"] = this.ausgabe;
        if (Array.isArray(this.historie)) {
            data["historie"] = [];
            for (let item of this.historie)
                data["historie"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHHSPlanDoppischModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    produkt?: number;
    konto?: number;
    bezeichnung?: string | undefined;
    produktText?: string | undefined;
    beschreibung?: string | undefined;
    beginnJahr?: number | undefined;
    endJahr?: number | undefined;
    manuell?: boolean | undefined;
    modifiziert?: boolean | undefined;
    produktEbene?: string | undefined;
    ansatzPjTerm?: string | undefined;
    kontoExtra?: string | undefined;
    gemeinden?: Gemeinden;
    containsData?: boolean;
    massnahmen?: MNPlanDoppischModel[] | undefined;
    ebenen?: string[] | undefined;
    guid?: string | undefined;
    edit?: boolean;
    ergebnisVvvJ?: number;
    ergebnisVvJ?: number;
    ansatzVJ?: number;
    ergebnisVJ?: number;
    ansatzPj?: number;
    ansatzPjImp?: number;
    ansatzPjCalc?: number | undefined;
    ansatzPjDiff?: number | undefined;
    fp1?: number;
    fp2?: number;
    fp3?: number;
    fp4?: number;
    fp5?: number;
    fp6?: number;
    fp7?: number;
    fp8?: number;
    fp9?: number;
    fp10?: number;
    calcPlanErr?: string | undefined;
    ausgabe?: boolean;
    historie?: PlanHistorieModel[] | undefined;
}

export class HHSPlanKameralModel implements IHHSPlanKameralModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    unterabschnitt?: number;
    massnahme?: number | undefined;
    untergruppe?: number;
    unterkonto?: number;
    bezeichnung?: string | undefined;
    uatext?: string | undefined;
    ugtext?: string | undefined;
    beschreibung?: string | undefined;
    beginnJahr?: number | undefined;
    endJahr?: number | undefined;
    uastellen?: number | undefined;
    ugstellen?: number | undefined;
    manuell?: boolean | undefined;
    modifiziert?: boolean | undefined;
    gemeinden?: Gemeinden;
    massnahmeNavigation?: Massnahman;
    readonly containsData?: boolean;
    guid?: string | undefined;
    edit?: boolean;
    ebenen?: string[] | undefined;
    ergebnisVvvJ?: number;
    ergebnisVvJ?: number;
    ansatzVJ?: number;
    ergebnisVJ?: number;
    ansatzPj?: number;
    fp1?: number;
    fp2?: number;
    fp3?: number;
    fp4?: number;
    fp5?: number;
    fp6?: number;
    fp7?: number;
    fp8?: number;
    fp9?: number;
    fp10?: number;
    calcPlanErr?: string | undefined;
    massnahmeNr?: number | undefined;

    constructor(data?: IHHSPlanKameralModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.unterabschnitt = _data["unterabschnitt"];
            this.massnahme = _data["massnahme"];
            this.untergruppe = _data["untergruppe"];
            this.unterkonto = _data["unterkonto"];
            this.bezeichnung = _data["bezeichnung"];
            this.uatext = _data["uatext"];
            this.ugtext = _data["ugtext"];
            this.beschreibung = _data["beschreibung"];
            this.beginnJahr = _data["beginnJahr"];
            this.endJahr = _data["endJahr"];
            this.uastellen = _data["uastellen"];
            this.ugstellen = _data["ugstellen"];
            this.manuell = _data["manuell"];
            this.modifiziert = _data["modifiziert"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
            this.massnahmeNavigation = _data["massnahmeNavigation"] ? Massnahman.fromJS(_data["massnahmeNavigation"]) : <any>undefined;
            (<any>this).containsData = _data["containsData"];
            this.guid = _data["guid"];
            this.edit = _data["edit"];
            if (Array.isArray(_data["ebenen"])) {
                this.ebenen = [] as any;
                for (let item of _data["ebenen"])
                    this.ebenen!.push(item);
            }
            this.ergebnisVvvJ = _data["ergebnisVvvJ"];
            this.ergebnisVvJ = _data["ergebnisVvJ"];
            this.ansatzVJ = _data["ansatzVJ"];
            this.ergebnisVJ = _data["ergebnisVJ"];
            this.ansatzPj = _data["ansatzPj"];
            this.fp1 = _data["fp1"];
            this.fp2 = _data["fp2"];
            this.fp3 = _data["fp3"];
            this.fp4 = _data["fp4"];
            this.fp5 = _data["fp5"];
            this.fp6 = _data["fp6"];
            this.fp7 = _data["fp7"];
            this.fp8 = _data["fp8"];
            this.fp9 = _data["fp9"];
            this.fp10 = _data["fp10"];
            this.calcPlanErr = _data["calcPlanErr"];
            this.massnahmeNr = _data["massnahmeNr"];
        }
    }

    static fromJS(data: any): HHSPlanKameralModel {
        data = typeof data === 'object' ? data : {};
        let result = new HHSPlanKameralModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["unterabschnitt"] = this.unterabschnitt;
        data["massnahme"] = this.massnahme;
        data["untergruppe"] = this.untergruppe;
        data["unterkonto"] = this.unterkonto;
        data["bezeichnung"] = this.bezeichnung;
        data["uatext"] = this.uatext;
        data["ugtext"] = this.ugtext;
        data["beschreibung"] = this.beschreibung;
        data["beginnJahr"] = this.beginnJahr;
        data["endJahr"] = this.endJahr;
        data["uastellen"] = this.uastellen;
        data["ugstellen"] = this.ugstellen;
        data["manuell"] = this.manuell;
        data["modifiziert"] = this.modifiziert;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        data["massnahmeNavigation"] = this.massnahmeNavigation ? this.massnahmeNavigation.toJSON() : <any>undefined;
        data["containsData"] = this.containsData;
        data["guid"] = this.guid;
        data["edit"] = this.edit;
        if (Array.isArray(this.ebenen)) {
            data["ebenen"] = [];
            for (let item of this.ebenen)
                data["ebenen"].push(item);
        }
        data["ergebnisVvvJ"] = this.ergebnisVvvJ;
        data["ergebnisVvJ"] = this.ergebnisVvJ;
        data["ansatzVJ"] = this.ansatzVJ;
        data["ergebnisVJ"] = this.ergebnisVJ;
        data["ansatzPj"] = this.ansatzPj;
        data["fp1"] = this.fp1;
        data["fp2"] = this.fp2;
        data["fp3"] = this.fp3;
        data["fp4"] = this.fp4;
        data["fp5"] = this.fp5;
        data["fp6"] = this.fp6;
        data["fp7"] = this.fp7;
        data["fp8"] = this.fp8;
        data["fp9"] = this.fp9;
        data["fp10"] = this.fp10;
        data["calcPlanErr"] = this.calcPlanErr;
        data["massnahmeNr"] = this.massnahmeNr;
        return data;
    }
}

export interface IHHSPlanKameralModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    unterabschnitt?: number;
    massnahme?: number | undefined;
    untergruppe?: number;
    unterkonto?: number;
    bezeichnung?: string | undefined;
    uatext?: string | undefined;
    ugtext?: string | undefined;
    beschreibung?: string | undefined;
    beginnJahr?: number | undefined;
    endJahr?: number | undefined;
    uastellen?: number | undefined;
    ugstellen?: number | undefined;
    manuell?: boolean | undefined;
    modifiziert?: boolean | undefined;
    gemeinden?: Gemeinden;
    massnahmeNavigation?: Massnahman;
    containsData?: boolean;
    guid?: string | undefined;
    edit?: boolean;
    ebenen?: string[] | undefined;
    ergebnisVvvJ?: number;
    ergebnisVvJ?: number;
    ansatzVJ?: number;
    ergebnisVJ?: number;
    ansatzPj?: number;
    fp1?: number;
    fp2?: number;
    fp3?: number;
    fp4?: number;
    fp5?: number;
    fp6?: number;
    fp7?: number;
    fp8?: number;
    fp9?: number;
    fp10?: number;
    calcPlanErr?: string | undefined;
    massnahmeNr?: number | undefined;
}

export class HREbene implements IHREbene {
    id?: string | undefined;
    isVMHH?: boolean;
    isHHS?: boolean;
    verbergen?: boolean;
    gesamtSumme?: boolean;
    unterabschnitt?: number;
    uaStellen?: number;
    produktEbene?: string | undefined;
    massnahme?: number | undefined;
    untergruppe?: number;
    ugStellen?: number;
    unterkonto?: number;
    bezeichnung?: string | undefined;
    uaText?: string | undefined;
    ugText?: string | undefined;
    beschreibung?: string | undefined;
    beginnJahr?: number | undefined;
    endJahr?: number | undefined;
    hrvJ_soll?: number;
    hrvJ_haben?: number;
    ahrvJ_soll?: number;
    ahrvJ_haben?: number;
    shrvJ_soll?: number;
    shrvJ_haben?: number;
    nhR_soll?: number;
    nhR_haben?: number;
    hrfJ_soll?: number;
    hrfJ_haben?: number;
    hrvJ_VW_soll?: number;
    hrvJ_VW_haben?: number;
    ahrvJ_VW_soll?: number;
    ahrvJ_VW_haben?: number;
    shrvJ_VW_soll?: number;
    shrvJ_VW_haben?: number;
    nhR_VW_soll?: number;
    nhR_VW_haben?: number;
    hrvJ_VM_soll?: number;
    hrvJ_VM_haben?: number;
    ahrvJ_VM_soll?: number;
    ahrvJ_VM_haben?: number;
    shrvJ_VM_soll?: number;
    shrvJ_VM_haben?: number;
    nhR_VM_soll?: number;
    nhR_VM_haben?: number;
    hrfJ_VM_soll?: number;
    hrfJ_VM_haben?: number;
    hrfJ_VW_soll?: number;
    hrfJ_VW_haben?: number;
    hrvJ_PJM1_soll?: number;
    hrvJ_PJM1_haben?: number;
    ahrvJ_PJM1_soll?: number;
    ahrvJ_PJM1_haben?: number;
    shrvJ_PJM1_soll?: number;
    shrvJ_PJM1_haben?: number;
    nhR_PJM1_soll?: number;
    nhR_PJM1_haben?: number;
    hrfJ_PJM1_soll?: number;
    hrfJ_PJM1_haben?: number;
    hrfJ_PJM1_VM_soll?: number;
    hrfJ_PJM1_VM_haben?: number;
    hrfJ_PJM1_VW_soll?: number;
    hrfJ_PJM1_VW_haben?: number;
    hrvJ_PJM2_soll?: number;
    hrvJ_PJM2_haben?: number;
    ahrvJ_PJM2_soll?: number;
    ahrvJ_PJM2_haben?: number;
    shrvJ_PJM2_soll?: number;
    shrvJ_PJM2_haben?: number;
    nhR_PJM2_soll?: number;
    nhR_PJM2_haben?: number;
    hrfJ_PJM2_soll?: number;
    hrfJ_PJM2_haben?: number;
    hrfJ_PJM2_VM_soll?: number;
    hrfJ_PJM2_VM_haben?: number;
    hrfJ_PJM2_VW_soll?: number;
    hrfJ_PJM2_VW_haben?: number;
    hrvJ_PJM3_soll?: number;
    hrvJ_PJM3_haben?: number;
    ahrvJ_PJM3_soll?: number;
    ahrvJ_PJM3_haben?: number;
    shrvJ_PJM3_soll?: number;
    shrvJ_PJM3_haben?: number;
    nhR_PJM3_soll?: number;
    nhR_PJM3_haben?: number;
    hrfJ_PJM3_soll?: number;
    hrfJ_PJM3_haben?: number;
    hrfJ_PJM3_VM_soll?: number;
    hrfJ_PJM3_VM_haben?: number;
    hrfJ_PJM3_VW_soll?: number;
    hrfJ_PJM3_VW_haben?: number;
    hrvJ_PJM4_soll?: number;
    hrvJ_PJM4_haben?: number;
    ahrvJ_PJM4_soll?: number;
    ahrvJ_PJM4_haben?: number;
    shrvJ_PJM4_soll?: number;
    shrvJ_PJM4_haben?: number;
    nhR_PJM4_soll?: number;
    nhR_PJM4_haben?: number;
    hrfJ_PJM4_soll?: number;
    hrfJ_PJM4_haben?: number;
    hrfJ_PJM4_VM_soll?: number;
    hrfJ_PJM4_VM_haben?: number;
    hrfJ_PJM4_VW_soll?: number;
    hrfJ_PJM4_VW_haben?: number;
    unterEbenen?: HREbene[] | undefined;
    jahre?: number[] | undefined;
    readonly containsData?: boolean;
    readonly containsEinnahmen?: boolean;
    readonly containsAusgaben?: boolean;
    istEinnahme?: boolean;

    constructor(data?: IHREbene) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isVMHH = _data["isVMHH"];
            this.isHHS = _data["isHHS"];
            this.verbergen = _data["verbergen"];
            this.gesamtSumme = _data["gesamtSumme"];
            this.unterabschnitt = _data["unterabschnitt"];
            this.uaStellen = _data["uaStellen"];
            this.produktEbene = _data["produktEbene"];
            this.massnahme = _data["massnahme"];
            this.untergruppe = _data["untergruppe"];
            this.ugStellen = _data["ugStellen"];
            this.unterkonto = _data["unterkonto"];
            this.bezeichnung = _data["bezeichnung"];
            this.uaText = _data["uaText"];
            this.ugText = _data["ugText"];
            this.beschreibung = _data["beschreibung"];
            this.beginnJahr = _data["beginnJahr"];
            this.endJahr = _data["endJahr"];
            this.hrvJ_soll = _data["hrvJ_soll"];
            this.hrvJ_haben = _data["hrvJ_haben"];
            this.ahrvJ_soll = _data["ahrvJ_soll"];
            this.ahrvJ_haben = _data["ahrvJ_haben"];
            this.shrvJ_soll = _data["shrvJ_soll"];
            this.shrvJ_haben = _data["shrvJ_haben"];
            this.nhR_soll = _data["nhR_soll"];
            this.nhR_haben = _data["nhR_haben"];
            this.hrfJ_soll = _data["hrfJ_soll"];
            this.hrfJ_haben = _data["hrfJ_haben"];
            this.hrvJ_VW_soll = _data["hrvJ_VW_soll"];
            this.hrvJ_VW_haben = _data["hrvJ_VW_haben"];
            this.ahrvJ_VW_soll = _data["ahrvJ_VW_soll"];
            this.ahrvJ_VW_haben = _data["ahrvJ_VW_haben"];
            this.shrvJ_VW_soll = _data["shrvJ_VW_soll"];
            this.shrvJ_VW_haben = _data["shrvJ_VW_haben"];
            this.nhR_VW_soll = _data["nhR_VW_soll"];
            this.nhR_VW_haben = _data["nhR_VW_haben"];
            this.hrvJ_VM_soll = _data["hrvJ_VM_soll"];
            this.hrvJ_VM_haben = _data["hrvJ_VM_haben"];
            this.ahrvJ_VM_soll = _data["ahrvJ_VM_soll"];
            this.ahrvJ_VM_haben = _data["ahrvJ_VM_haben"];
            this.shrvJ_VM_soll = _data["shrvJ_VM_soll"];
            this.shrvJ_VM_haben = _data["shrvJ_VM_haben"];
            this.nhR_VM_soll = _data["nhR_VM_soll"];
            this.nhR_VM_haben = _data["nhR_VM_haben"];
            this.hrfJ_VM_soll = _data["hrfJ_VM_soll"];
            this.hrfJ_VM_haben = _data["hrfJ_VM_haben"];
            this.hrfJ_VW_soll = _data["hrfJ_VW_soll"];
            this.hrfJ_VW_haben = _data["hrfJ_VW_haben"];
            this.hrvJ_PJM1_soll = _data["hrvJ_PJM1_soll"];
            this.hrvJ_PJM1_haben = _data["hrvJ_PJM1_haben"];
            this.ahrvJ_PJM1_soll = _data["ahrvJ_PJM1_soll"];
            this.ahrvJ_PJM1_haben = _data["ahrvJ_PJM1_haben"];
            this.shrvJ_PJM1_soll = _data["shrvJ_PJM1_soll"];
            this.shrvJ_PJM1_haben = _data["shrvJ_PJM1_haben"];
            this.nhR_PJM1_soll = _data["nhR_PJM1_soll"];
            this.nhR_PJM1_haben = _data["nhR_PJM1_haben"];
            this.hrfJ_PJM1_soll = _data["hrfJ_PJM1_soll"];
            this.hrfJ_PJM1_haben = _data["hrfJ_PJM1_haben"];
            this.hrfJ_PJM1_VM_soll = _data["hrfJ_PJM1_VM_soll"];
            this.hrfJ_PJM1_VM_haben = _data["hrfJ_PJM1_VM_haben"];
            this.hrfJ_PJM1_VW_soll = _data["hrfJ_PJM1_VW_soll"];
            this.hrfJ_PJM1_VW_haben = _data["hrfJ_PJM1_VW_haben"];
            this.hrvJ_PJM2_soll = _data["hrvJ_PJM2_soll"];
            this.hrvJ_PJM2_haben = _data["hrvJ_PJM2_haben"];
            this.ahrvJ_PJM2_soll = _data["ahrvJ_PJM2_soll"];
            this.ahrvJ_PJM2_haben = _data["ahrvJ_PJM2_haben"];
            this.shrvJ_PJM2_soll = _data["shrvJ_PJM2_soll"];
            this.shrvJ_PJM2_haben = _data["shrvJ_PJM2_haben"];
            this.nhR_PJM2_soll = _data["nhR_PJM2_soll"];
            this.nhR_PJM2_haben = _data["nhR_PJM2_haben"];
            this.hrfJ_PJM2_soll = _data["hrfJ_PJM2_soll"];
            this.hrfJ_PJM2_haben = _data["hrfJ_PJM2_haben"];
            this.hrfJ_PJM2_VM_soll = _data["hrfJ_PJM2_VM_soll"];
            this.hrfJ_PJM2_VM_haben = _data["hrfJ_PJM2_VM_haben"];
            this.hrfJ_PJM2_VW_soll = _data["hrfJ_PJM2_VW_soll"];
            this.hrfJ_PJM2_VW_haben = _data["hrfJ_PJM2_VW_haben"];
            this.hrvJ_PJM3_soll = _data["hrvJ_PJM3_soll"];
            this.hrvJ_PJM3_haben = _data["hrvJ_PJM3_haben"];
            this.ahrvJ_PJM3_soll = _data["ahrvJ_PJM3_soll"];
            this.ahrvJ_PJM3_haben = _data["ahrvJ_PJM3_haben"];
            this.shrvJ_PJM3_soll = _data["shrvJ_PJM3_soll"];
            this.shrvJ_PJM3_haben = _data["shrvJ_PJM3_haben"];
            this.nhR_PJM3_soll = _data["nhR_PJM3_soll"];
            this.nhR_PJM3_haben = _data["nhR_PJM3_haben"];
            this.hrfJ_PJM3_soll = _data["hrfJ_PJM3_soll"];
            this.hrfJ_PJM3_haben = _data["hrfJ_PJM3_haben"];
            this.hrfJ_PJM3_VM_soll = _data["hrfJ_PJM3_VM_soll"];
            this.hrfJ_PJM3_VM_haben = _data["hrfJ_PJM3_VM_haben"];
            this.hrfJ_PJM3_VW_soll = _data["hrfJ_PJM3_VW_soll"];
            this.hrfJ_PJM3_VW_haben = _data["hrfJ_PJM3_VW_haben"];
            this.hrvJ_PJM4_soll = _data["hrvJ_PJM4_soll"];
            this.hrvJ_PJM4_haben = _data["hrvJ_PJM4_haben"];
            this.ahrvJ_PJM4_soll = _data["ahrvJ_PJM4_soll"];
            this.ahrvJ_PJM4_haben = _data["ahrvJ_PJM4_haben"];
            this.shrvJ_PJM4_soll = _data["shrvJ_PJM4_soll"];
            this.shrvJ_PJM4_haben = _data["shrvJ_PJM4_haben"];
            this.nhR_PJM4_soll = _data["nhR_PJM4_soll"];
            this.nhR_PJM4_haben = _data["nhR_PJM4_haben"];
            this.hrfJ_PJM4_soll = _data["hrfJ_PJM4_soll"];
            this.hrfJ_PJM4_haben = _data["hrfJ_PJM4_haben"];
            this.hrfJ_PJM4_VM_soll = _data["hrfJ_PJM4_VM_soll"];
            this.hrfJ_PJM4_VM_haben = _data["hrfJ_PJM4_VM_haben"];
            this.hrfJ_PJM4_VW_soll = _data["hrfJ_PJM4_VW_soll"];
            this.hrfJ_PJM4_VW_haben = _data["hrfJ_PJM4_VW_haben"];
            if (Array.isArray(_data["unterEbenen"])) {
                this.unterEbenen = [] as any;
                for (let item of _data["unterEbenen"])
                    this.unterEbenen!.push(HREbene.fromJS(item));
            }
            if (Array.isArray(_data["jahre"])) {
                this.jahre = [] as any;
                for (let item of _data["jahre"])
                    this.jahre!.push(item);
            }
            (<any>this).containsData = _data["containsData"];
            (<any>this).containsEinnahmen = _data["containsEinnahmen"];
            (<any>this).containsAusgaben = _data["containsAusgaben"];
            this.istEinnahme = _data["istEinnahme"];
        }
    }

    static fromJS(data: any): HREbene {
        data = typeof data === 'object' ? data : {};
        let result = new HREbene();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isVMHH"] = this.isVMHH;
        data["isHHS"] = this.isHHS;
        data["verbergen"] = this.verbergen;
        data["gesamtSumme"] = this.gesamtSumme;
        data["unterabschnitt"] = this.unterabschnitt;
        data["uaStellen"] = this.uaStellen;
        data["produktEbene"] = this.produktEbene;
        data["massnahme"] = this.massnahme;
        data["untergruppe"] = this.untergruppe;
        data["ugStellen"] = this.ugStellen;
        data["unterkonto"] = this.unterkonto;
        data["bezeichnung"] = this.bezeichnung;
        data["uaText"] = this.uaText;
        data["ugText"] = this.ugText;
        data["beschreibung"] = this.beschreibung;
        data["beginnJahr"] = this.beginnJahr;
        data["endJahr"] = this.endJahr;
        data["hrvJ_soll"] = this.hrvJ_soll;
        data["hrvJ_haben"] = this.hrvJ_haben;
        data["ahrvJ_soll"] = this.ahrvJ_soll;
        data["ahrvJ_haben"] = this.ahrvJ_haben;
        data["shrvJ_soll"] = this.shrvJ_soll;
        data["shrvJ_haben"] = this.shrvJ_haben;
        data["nhR_soll"] = this.nhR_soll;
        data["nhR_haben"] = this.nhR_haben;
        data["hrfJ_soll"] = this.hrfJ_soll;
        data["hrfJ_haben"] = this.hrfJ_haben;
        data["hrvJ_VW_soll"] = this.hrvJ_VW_soll;
        data["hrvJ_VW_haben"] = this.hrvJ_VW_haben;
        data["ahrvJ_VW_soll"] = this.ahrvJ_VW_soll;
        data["ahrvJ_VW_haben"] = this.ahrvJ_VW_haben;
        data["shrvJ_VW_soll"] = this.shrvJ_VW_soll;
        data["shrvJ_VW_haben"] = this.shrvJ_VW_haben;
        data["nhR_VW_soll"] = this.nhR_VW_soll;
        data["nhR_VW_haben"] = this.nhR_VW_haben;
        data["hrvJ_VM_soll"] = this.hrvJ_VM_soll;
        data["hrvJ_VM_haben"] = this.hrvJ_VM_haben;
        data["ahrvJ_VM_soll"] = this.ahrvJ_VM_soll;
        data["ahrvJ_VM_haben"] = this.ahrvJ_VM_haben;
        data["shrvJ_VM_soll"] = this.shrvJ_VM_soll;
        data["shrvJ_VM_haben"] = this.shrvJ_VM_haben;
        data["nhR_VM_soll"] = this.nhR_VM_soll;
        data["nhR_VM_haben"] = this.nhR_VM_haben;
        data["hrfJ_VM_soll"] = this.hrfJ_VM_soll;
        data["hrfJ_VM_haben"] = this.hrfJ_VM_haben;
        data["hrfJ_VW_soll"] = this.hrfJ_VW_soll;
        data["hrfJ_VW_haben"] = this.hrfJ_VW_haben;
        data["hrvJ_PJM1_soll"] = this.hrvJ_PJM1_soll;
        data["hrvJ_PJM1_haben"] = this.hrvJ_PJM1_haben;
        data["ahrvJ_PJM1_soll"] = this.ahrvJ_PJM1_soll;
        data["ahrvJ_PJM1_haben"] = this.ahrvJ_PJM1_haben;
        data["shrvJ_PJM1_soll"] = this.shrvJ_PJM1_soll;
        data["shrvJ_PJM1_haben"] = this.shrvJ_PJM1_haben;
        data["nhR_PJM1_soll"] = this.nhR_PJM1_soll;
        data["nhR_PJM1_haben"] = this.nhR_PJM1_haben;
        data["hrfJ_PJM1_soll"] = this.hrfJ_PJM1_soll;
        data["hrfJ_PJM1_haben"] = this.hrfJ_PJM1_haben;
        data["hrfJ_PJM1_VM_soll"] = this.hrfJ_PJM1_VM_soll;
        data["hrfJ_PJM1_VM_haben"] = this.hrfJ_PJM1_VM_haben;
        data["hrfJ_PJM1_VW_soll"] = this.hrfJ_PJM1_VW_soll;
        data["hrfJ_PJM1_VW_haben"] = this.hrfJ_PJM1_VW_haben;
        data["hrvJ_PJM2_soll"] = this.hrvJ_PJM2_soll;
        data["hrvJ_PJM2_haben"] = this.hrvJ_PJM2_haben;
        data["ahrvJ_PJM2_soll"] = this.ahrvJ_PJM2_soll;
        data["ahrvJ_PJM2_haben"] = this.ahrvJ_PJM2_haben;
        data["shrvJ_PJM2_soll"] = this.shrvJ_PJM2_soll;
        data["shrvJ_PJM2_haben"] = this.shrvJ_PJM2_haben;
        data["nhR_PJM2_soll"] = this.nhR_PJM2_soll;
        data["nhR_PJM2_haben"] = this.nhR_PJM2_haben;
        data["hrfJ_PJM2_soll"] = this.hrfJ_PJM2_soll;
        data["hrfJ_PJM2_haben"] = this.hrfJ_PJM2_haben;
        data["hrfJ_PJM2_VM_soll"] = this.hrfJ_PJM2_VM_soll;
        data["hrfJ_PJM2_VM_haben"] = this.hrfJ_PJM2_VM_haben;
        data["hrfJ_PJM2_VW_soll"] = this.hrfJ_PJM2_VW_soll;
        data["hrfJ_PJM2_VW_haben"] = this.hrfJ_PJM2_VW_haben;
        data["hrvJ_PJM3_soll"] = this.hrvJ_PJM3_soll;
        data["hrvJ_PJM3_haben"] = this.hrvJ_PJM3_haben;
        data["ahrvJ_PJM3_soll"] = this.ahrvJ_PJM3_soll;
        data["ahrvJ_PJM3_haben"] = this.ahrvJ_PJM3_haben;
        data["shrvJ_PJM3_soll"] = this.shrvJ_PJM3_soll;
        data["shrvJ_PJM3_haben"] = this.shrvJ_PJM3_haben;
        data["nhR_PJM3_soll"] = this.nhR_PJM3_soll;
        data["nhR_PJM3_haben"] = this.nhR_PJM3_haben;
        data["hrfJ_PJM3_soll"] = this.hrfJ_PJM3_soll;
        data["hrfJ_PJM3_haben"] = this.hrfJ_PJM3_haben;
        data["hrfJ_PJM3_VM_soll"] = this.hrfJ_PJM3_VM_soll;
        data["hrfJ_PJM3_VM_haben"] = this.hrfJ_PJM3_VM_haben;
        data["hrfJ_PJM3_VW_soll"] = this.hrfJ_PJM3_VW_soll;
        data["hrfJ_PJM3_VW_haben"] = this.hrfJ_PJM3_VW_haben;
        data["hrvJ_PJM4_soll"] = this.hrvJ_PJM4_soll;
        data["hrvJ_PJM4_haben"] = this.hrvJ_PJM4_haben;
        data["ahrvJ_PJM4_soll"] = this.ahrvJ_PJM4_soll;
        data["ahrvJ_PJM4_haben"] = this.ahrvJ_PJM4_haben;
        data["shrvJ_PJM4_soll"] = this.shrvJ_PJM4_soll;
        data["shrvJ_PJM4_haben"] = this.shrvJ_PJM4_haben;
        data["nhR_PJM4_soll"] = this.nhR_PJM4_soll;
        data["nhR_PJM4_haben"] = this.nhR_PJM4_haben;
        data["hrfJ_PJM4_soll"] = this.hrfJ_PJM4_soll;
        data["hrfJ_PJM4_haben"] = this.hrfJ_PJM4_haben;
        data["hrfJ_PJM4_VM_soll"] = this.hrfJ_PJM4_VM_soll;
        data["hrfJ_PJM4_VM_haben"] = this.hrfJ_PJM4_VM_haben;
        data["hrfJ_PJM4_VW_soll"] = this.hrfJ_PJM4_VW_soll;
        data["hrfJ_PJM4_VW_haben"] = this.hrfJ_PJM4_VW_haben;
        if (Array.isArray(this.unterEbenen)) {
            data["unterEbenen"] = [];
            for (let item of this.unterEbenen)
                data["unterEbenen"].push(item.toJSON());
        }
        if (Array.isArray(this.jahre)) {
            data["jahre"] = [];
            for (let item of this.jahre)
                data["jahre"].push(item);
        }
        data["containsData"] = this.containsData;
        data["containsEinnahmen"] = this.containsEinnahmen;
        data["containsAusgaben"] = this.containsAusgaben;
        data["istEinnahme"] = this.istEinnahme;
        return data;
    }
}

export interface IHREbene {
    id?: string | undefined;
    isVMHH?: boolean;
    isHHS?: boolean;
    verbergen?: boolean;
    gesamtSumme?: boolean;
    unterabschnitt?: number;
    uaStellen?: number;
    produktEbene?: string | undefined;
    massnahme?: number | undefined;
    untergruppe?: number;
    ugStellen?: number;
    unterkonto?: number;
    bezeichnung?: string | undefined;
    uaText?: string | undefined;
    ugText?: string | undefined;
    beschreibung?: string | undefined;
    beginnJahr?: number | undefined;
    endJahr?: number | undefined;
    hrvJ_soll?: number;
    hrvJ_haben?: number;
    ahrvJ_soll?: number;
    ahrvJ_haben?: number;
    shrvJ_soll?: number;
    shrvJ_haben?: number;
    nhR_soll?: number;
    nhR_haben?: number;
    hrfJ_soll?: number;
    hrfJ_haben?: number;
    hrvJ_VW_soll?: number;
    hrvJ_VW_haben?: number;
    ahrvJ_VW_soll?: number;
    ahrvJ_VW_haben?: number;
    shrvJ_VW_soll?: number;
    shrvJ_VW_haben?: number;
    nhR_VW_soll?: number;
    nhR_VW_haben?: number;
    hrvJ_VM_soll?: number;
    hrvJ_VM_haben?: number;
    ahrvJ_VM_soll?: number;
    ahrvJ_VM_haben?: number;
    shrvJ_VM_soll?: number;
    shrvJ_VM_haben?: number;
    nhR_VM_soll?: number;
    nhR_VM_haben?: number;
    hrfJ_VM_soll?: number;
    hrfJ_VM_haben?: number;
    hrfJ_VW_soll?: number;
    hrfJ_VW_haben?: number;
    hrvJ_PJM1_soll?: number;
    hrvJ_PJM1_haben?: number;
    ahrvJ_PJM1_soll?: number;
    ahrvJ_PJM1_haben?: number;
    shrvJ_PJM1_soll?: number;
    shrvJ_PJM1_haben?: number;
    nhR_PJM1_soll?: number;
    nhR_PJM1_haben?: number;
    hrfJ_PJM1_soll?: number;
    hrfJ_PJM1_haben?: number;
    hrfJ_PJM1_VM_soll?: number;
    hrfJ_PJM1_VM_haben?: number;
    hrfJ_PJM1_VW_soll?: number;
    hrfJ_PJM1_VW_haben?: number;
    hrvJ_PJM2_soll?: number;
    hrvJ_PJM2_haben?: number;
    ahrvJ_PJM2_soll?: number;
    ahrvJ_PJM2_haben?: number;
    shrvJ_PJM2_soll?: number;
    shrvJ_PJM2_haben?: number;
    nhR_PJM2_soll?: number;
    nhR_PJM2_haben?: number;
    hrfJ_PJM2_soll?: number;
    hrfJ_PJM2_haben?: number;
    hrfJ_PJM2_VM_soll?: number;
    hrfJ_PJM2_VM_haben?: number;
    hrfJ_PJM2_VW_soll?: number;
    hrfJ_PJM2_VW_haben?: number;
    hrvJ_PJM3_soll?: number;
    hrvJ_PJM3_haben?: number;
    ahrvJ_PJM3_soll?: number;
    ahrvJ_PJM3_haben?: number;
    shrvJ_PJM3_soll?: number;
    shrvJ_PJM3_haben?: number;
    nhR_PJM3_soll?: number;
    nhR_PJM3_haben?: number;
    hrfJ_PJM3_soll?: number;
    hrfJ_PJM3_haben?: number;
    hrfJ_PJM3_VM_soll?: number;
    hrfJ_PJM3_VM_haben?: number;
    hrfJ_PJM3_VW_soll?: number;
    hrfJ_PJM3_VW_haben?: number;
    hrvJ_PJM4_soll?: number;
    hrvJ_PJM4_haben?: number;
    ahrvJ_PJM4_soll?: number;
    ahrvJ_PJM4_haben?: number;
    shrvJ_PJM4_soll?: number;
    shrvJ_PJM4_haben?: number;
    nhR_PJM4_soll?: number;
    nhR_PJM4_haben?: number;
    hrfJ_PJM4_soll?: number;
    hrfJ_PJM4_haben?: number;
    hrfJ_PJM4_VM_soll?: number;
    hrfJ_PJM4_VM_haben?: number;
    hrfJ_PJM4_VW_soll?: number;
    hrfJ_PJM4_VW_haben?: number;
    unterEbenen?: HREbene[] | undefined;
    jahre?: number[] | undefined;
    containsData?: boolean;
    containsEinnahmen?: boolean;
    containsAusgaben?: boolean;
    istEinnahme?: boolean;
}

export class HaushaltFilterRequestDoppik implements IHaushaltFilterRequestDoppik {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    plantyp?: number;
    planstufe?: number;
    uhConfig?: number;
    ausgaben?: boolean;
    ergebnis?: boolean;
    inkludierteKonten?: string | undefined;
    exkludierteKonten?: string | undefined;
    subtraktionsKonten?: string | undefined;
    produkt?: string | undefined;
    ebene?: string | undefined;
    massnahme?: string | undefined;
    verwaltungsAnsicht?: boolean;
    produktTexte?: Texte[] | undefined;
    produkt2Text?: Produkt2Text[] | undefined;

    constructor(data?: IHaushaltFilterRequestDoppik) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.plantyp = _data["plantyp"];
            this.planstufe = _data["planstufe"];
            this.uhConfig = _data["uhConfig"];
            this.ausgaben = _data["ausgaben"];
            this.ergebnis = _data["ergebnis"];
            this.inkludierteKonten = _data["inkludierteKonten"];
            this.exkludierteKonten = _data["exkludierteKonten"];
            this.subtraktionsKonten = _data["subtraktionsKonten"];
            this.produkt = _data["produkt"];
            this.ebene = _data["ebene"];
            this.massnahme = _data["massnahme"];
            this.verwaltungsAnsicht = _data["verwaltungsAnsicht"];
            if (Array.isArray(_data["produktTexte"])) {
                this.produktTexte = [] as any;
                for (let item of _data["produktTexte"])
                    this.produktTexte!.push(Texte.fromJS(item));
            }
            if (Array.isArray(_data["produkt2Text"])) {
                this.produkt2Text = [] as any;
                for (let item of _data["produkt2Text"])
                    this.produkt2Text!.push(Produkt2Text.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HaushaltFilterRequestDoppik {
        data = typeof data === 'object' ? data : {};
        let result = new HaushaltFilterRequestDoppik();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["plantyp"] = this.plantyp;
        data["planstufe"] = this.planstufe;
        data["uhConfig"] = this.uhConfig;
        data["ausgaben"] = this.ausgaben;
        data["ergebnis"] = this.ergebnis;
        data["inkludierteKonten"] = this.inkludierteKonten;
        data["exkludierteKonten"] = this.exkludierteKonten;
        data["subtraktionsKonten"] = this.subtraktionsKonten;
        data["produkt"] = this.produkt;
        data["ebene"] = this.ebene;
        data["massnahme"] = this.massnahme;
        data["verwaltungsAnsicht"] = this.verwaltungsAnsicht;
        if (Array.isArray(this.produktTexte)) {
            data["produktTexte"] = [];
            for (let item of this.produktTexte)
                data["produktTexte"].push(item.toJSON());
        }
        if (Array.isArray(this.produkt2Text)) {
            data["produkt2Text"] = [];
            for (let item of this.produkt2Text)
                data["produkt2Text"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHaushaltFilterRequestDoppik {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    plantyp?: number;
    planstufe?: number;
    uhConfig?: number;
    ausgaben?: boolean;
    ergebnis?: boolean;
    inkludierteKonten?: string | undefined;
    exkludierteKonten?: string | undefined;
    subtraktionsKonten?: string | undefined;
    produkt?: string | undefined;
    ebene?: string | undefined;
    massnahme?: string | undefined;
    verwaltungsAnsicht?: boolean;
    produktTexte?: Texte[] | undefined;
    produkt2Text?: Produkt2Text[] | undefined;
}

export class HaushaltRequest implements IHaushaltRequest {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    plantyp?: number;
    planstufe?: number;
    uhConfig?: number;
    haushaltsart?: number | undefined;
    uaFilter?: string | undefined;
    ugFilter?: string | undefined;
    unterabschnitt?: number;
    uaStellen?: number;
    gruppe?: number;
    ugStellen?: number;
    sonderUAEbene?: boolean;
    sonderUGEbene?: boolean;
    gruppen?: number[] | undefined;
    ignorierteGruppen?: number[] | undefined;
    ebene?: string | undefined;
    multiEbenen?: boolean;
    nurOberebenen?: boolean;
    includeFilteredResults?: boolean;
    filterGruppen?: string[] | undefined;
    unterkonto?: string | undefined;
    massnahme?: string | undefined;
    verwaltungsAnsicht?: boolean;
    grTexte?: Texte[] | undefined;
    gR2Text?: Gruppierung2Text[] | undefined;
    attrEbenen?: Ebenen[] | undefined;
    hH2Ebene?: Haushaltsstelle2Ebene[] | undefined;
    attrEbene?: Ebenen;

    constructor(data?: IHaushaltRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.plantyp = _data["plantyp"];
            this.planstufe = _data["planstufe"];
            this.uhConfig = _data["uhConfig"];
            this.haushaltsart = _data["haushaltsart"];
            this.uaFilter = _data["uaFilter"];
            this.ugFilter = _data["ugFilter"];
            this.unterabschnitt = _data["unterabschnitt"];
            this.uaStellen = _data["uaStellen"];
            this.gruppe = _data["gruppe"];
            this.ugStellen = _data["ugStellen"];
            this.sonderUAEbene = _data["sonderUAEbene"];
            this.sonderUGEbene = _data["sonderUGEbene"];
            if (Array.isArray(_data["gruppen"])) {
                this.gruppen = [] as any;
                for (let item of _data["gruppen"])
                    this.gruppen!.push(item);
            }
            if (Array.isArray(_data["ignorierteGruppen"])) {
                this.ignorierteGruppen = [] as any;
                for (let item of _data["ignorierteGruppen"])
                    this.ignorierteGruppen!.push(item);
            }
            this.ebene = _data["ebene"];
            this.multiEbenen = _data["multiEbenen"];
            this.nurOberebenen = _data["nurOberebenen"];
            this.includeFilteredResults = _data["includeFilteredResults"];
            if (Array.isArray(_data["filterGruppen"])) {
                this.filterGruppen = [] as any;
                for (let item of _data["filterGruppen"])
                    this.filterGruppen!.push(item);
            }
            this.unterkonto = _data["unterkonto"];
            this.massnahme = _data["massnahme"];
            this.verwaltungsAnsicht = _data["verwaltungsAnsicht"];
            if (Array.isArray(_data["grTexte"])) {
                this.grTexte = [] as any;
                for (let item of _data["grTexte"])
                    this.grTexte!.push(Texte.fromJS(item));
            }
            if (Array.isArray(_data["gR2Text"])) {
                this.gR2Text = [] as any;
                for (let item of _data["gR2Text"])
                    this.gR2Text!.push(Gruppierung2Text.fromJS(item));
            }
            if (Array.isArray(_data["attrEbenen"])) {
                this.attrEbenen = [] as any;
                for (let item of _data["attrEbenen"])
                    this.attrEbenen!.push(Ebenen.fromJS(item));
            }
            if (Array.isArray(_data["hH2Ebene"])) {
                this.hH2Ebene = [] as any;
                for (let item of _data["hH2Ebene"])
                    this.hH2Ebene!.push(Haushaltsstelle2Ebene.fromJS(item));
            }
            this.attrEbene = _data["attrEbene"] ? Ebenen.fromJS(_data["attrEbene"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HaushaltRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HaushaltRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["plantyp"] = this.plantyp;
        data["planstufe"] = this.planstufe;
        data["uhConfig"] = this.uhConfig;
        data["haushaltsart"] = this.haushaltsart;
        data["uaFilter"] = this.uaFilter;
        data["ugFilter"] = this.ugFilter;
        data["unterabschnitt"] = this.unterabschnitt;
        data["uaStellen"] = this.uaStellen;
        data["gruppe"] = this.gruppe;
        data["ugStellen"] = this.ugStellen;
        data["sonderUAEbene"] = this.sonderUAEbene;
        data["sonderUGEbene"] = this.sonderUGEbene;
        if (Array.isArray(this.gruppen)) {
            data["gruppen"] = [];
            for (let item of this.gruppen)
                data["gruppen"].push(item);
        }
        if (Array.isArray(this.ignorierteGruppen)) {
            data["ignorierteGruppen"] = [];
            for (let item of this.ignorierteGruppen)
                data["ignorierteGruppen"].push(item);
        }
        data["ebene"] = this.ebene;
        data["multiEbenen"] = this.multiEbenen;
        data["nurOberebenen"] = this.nurOberebenen;
        data["includeFilteredResults"] = this.includeFilteredResults;
        if (Array.isArray(this.filterGruppen)) {
            data["filterGruppen"] = [];
            for (let item of this.filterGruppen)
                data["filterGruppen"].push(item);
        }
        data["unterkonto"] = this.unterkonto;
        data["massnahme"] = this.massnahme;
        data["verwaltungsAnsicht"] = this.verwaltungsAnsicht;
        if (Array.isArray(this.grTexte)) {
            data["grTexte"] = [];
            for (let item of this.grTexte)
                data["grTexte"].push(item.toJSON());
        }
        if (Array.isArray(this.gR2Text)) {
            data["gR2Text"] = [];
            for (let item of this.gR2Text)
                data["gR2Text"].push(item.toJSON());
        }
        if (Array.isArray(this.attrEbenen)) {
            data["attrEbenen"] = [];
            for (let item of this.attrEbenen)
                data["attrEbenen"].push(item.toJSON());
        }
        if (Array.isArray(this.hH2Ebene)) {
            data["hH2Ebene"] = [];
            for (let item of this.hH2Ebene)
                data["hH2Ebene"].push(item.toJSON());
        }
        data["attrEbene"] = this.attrEbene ? this.attrEbene.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHaushaltRequest {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    plantyp?: number;
    planstufe?: number;
    uhConfig?: number;
    haushaltsart?: number | undefined;
    uaFilter?: string | undefined;
    ugFilter?: string | undefined;
    unterabschnitt?: number;
    uaStellen?: number;
    gruppe?: number;
    ugStellen?: number;
    sonderUAEbene?: boolean;
    sonderUGEbene?: boolean;
    gruppen?: number[] | undefined;
    ignorierteGruppen?: number[] | undefined;
    ebene?: string | undefined;
    multiEbenen?: boolean;
    nurOberebenen?: boolean;
    includeFilteredResults?: boolean;
    filterGruppen?: string[] | undefined;
    unterkonto?: string | undefined;
    massnahme?: string | undefined;
    verwaltungsAnsicht?: boolean;
    grTexte?: Texte[] | undefined;
    gR2Text?: Gruppierung2Text[] | undefined;
    attrEbenen?: Ebenen[] | undefined;
    hH2Ebene?: Haushaltsstelle2Ebene[] | undefined;
    attrEbene?: Ebenen;
}

export class HaushaltRequestDoppik implements IHaushaltRequestDoppik {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    plantyp?: number;
    planstufe?: number;
    uhConfig?: number;
    summenTyp?: number;
    produkt?: number;
    produktStellen?: number;
    konto?: number;
    kontoStellen?: number;
    konten?: number[] | undefined;
    ignorierteKonten?: number[] | undefined;
    multiEbenen?: boolean;
    ebene?: string | undefined;
    nurOberebenen?: boolean;
    includeFilteredResults?: boolean;
    verwaltungsAnsicht?: boolean;
    kontenTexte?: Texte[] | undefined;
    konten2Text?: Konto2Text[] | undefined;
    produktTexte?: Texte[] | undefined;
    produkt2Text?: Produkt2Text[] | undefined;
    attrEbenen?: Ebenen[] | undefined;
    hH2Ebene?: Haushaltsstelle2EbeneDoppisch[] | undefined;
    attrEbene?: Ebenen;

    constructor(data?: IHaushaltRequestDoppik) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.plantyp = _data["plantyp"];
            this.planstufe = _data["planstufe"];
            this.uhConfig = _data["uhConfig"];
            this.summenTyp = _data["summenTyp"];
            this.produkt = _data["produkt"];
            this.produktStellen = _data["produktStellen"];
            this.konto = _data["konto"];
            this.kontoStellen = _data["kontoStellen"];
            if (Array.isArray(_data["konten"])) {
                this.konten = [] as any;
                for (let item of _data["konten"])
                    this.konten!.push(item);
            }
            if (Array.isArray(_data["ignorierteKonten"])) {
                this.ignorierteKonten = [] as any;
                for (let item of _data["ignorierteKonten"])
                    this.ignorierteKonten!.push(item);
            }
            this.multiEbenen = _data["multiEbenen"];
            this.ebene = _data["ebene"];
            this.nurOberebenen = _data["nurOberebenen"];
            this.includeFilteredResults = _data["includeFilteredResults"];
            this.verwaltungsAnsicht = _data["verwaltungsAnsicht"];
            if (Array.isArray(_data["kontenTexte"])) {
                this.kontenTexte = [] as any;
                for (let item of _data["kontenTexte"])
                    this.kontenTexte!.push(Texte.fromJS(item));
            }
            if (Array.isArray(_data["konten2Text"])) {
                this.konten2Text = [] as any;
                for (let item of _data["konten2Text"])
                    this.konten2Text!.push(Konto2Text.fromJS(item));
            }
            if (Array.isArray(_data["produktTexte"])) {
                this.produktTexte = [] as any;
                for (let item of _data["produktTexte"])
                    this.produktTexte!.push(Texte.fromJS(item));
            }
            if (Array.isArray(_data["produkt2Text"])) {
                this.produkt2Text = [] as any;
                for (let item of _data["produkt2Text"])
                    this.produkt2Text!.push(Produkt2Text.fromJS(item));
            }
            if (Array.isArray(_data["attrEbenen"])) {
                this.attrEbenen = [] as any;
                for (let item of _data["attrEbenen"])
                    this.attrEbenen!.push(Ebenen.fromJS(item));
            }
            if (Array.isArray(_data["hH2Ebene"])) {
                this.hH2Ebene = [] as any;
                for (let item of _data["hH2Ebene"])
                    this.hH2Ebene!.push(Haushaltsstelle2EbeneDoppisch.fromJS(item));
            }
            this.attrEbene = _data["attrEbene"] ? Ebenen.fromJS(_data["attrEbene"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HaushaltRequestDoppik {
        data = typeof data === 'object' ? data : {};
        let result = new HaushaltRequestDoppik();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["plantyp"] = this.plantyp;
        data["planstufe"] = this.planstufe;
        data["uhConfig"] = this.uhConfig;
        data["summenTyp"] = this.summenTyp;
        data["produkt"] = this.produkt;
        data["produktStellen"] = this.produktStellen;
        data["konto"] = this.konto;
        data["kontoStellen"] = this.kontoStellen;
        if (Array.isArray(this.konten)) {
            data["konten"] = [];
            for (let item of this.konten)
                data["konten"].push(item);
        }
        if (Array.isArray(this.ignorierteKonten)) {
            data["ignorierteKonten"] = [];
            for (let item of this.ignorierteKonten)
                data["ignorierteKonten"].push(item);
        }
        data["multiEbenen"] = this.multiEbenen;
        data["ebene"] = this.ebene;
        data["nurOberebenen"] = this.nurOberebenen;
        data["includeFilteredResults"] = this.includeFilteredResults;
        data["verwaltungsAnsicht"] = this.verwaltungsAnsicht;
        if (Array.isArray(this.kontenTexte)) {
            data["kontenTexte"] = [];
            for (let item of this.kontenTexte)
                data["kontenTexte"].push(item.toJSON());
        }
        if (Array.isArray(this.konten2Text)) {
            data["konten2Text"] = [];
            for (let item of this.konten2Text)
                data["konten2Text"].push(item.toJSON());
        }
        if (Array.isArray(this.produktTexte)) {
            data["produktTexte"] = [];
            for (let item of this.produktTexte)
                data["produktTexte"].push(item.toJSON());
        }
        if (Array.isArray(this.produkt2Text)) {
            data["produkt2Text"] = [];
            for (let item of this.produkt2Text)
                data["produkt2Text"].push(item.toJSON());
        }
        if (Array.isArray(this.attrEbenen)) {
            data["attrEbenen"] = [];
            for (let item of this.attrEbenen)
                data["attrEbenen"].push(item.toJSON());
        }
        if (Array.isArray(this.hH2Ebene)) {
            data["hH2Ebene"] = [];
            for (let item of this.hH2Ebene)
                data["hH2Ebene"].push(item.toJSON());
        }
        data["attrEbene"] = this.attrEbene ? this.attrEbene.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHaushaltRequestDoppik {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    plantyp?: number;
    planstufe?: number;
    uhConfig?: number;
    summenTyp?: number;
    produkt?: number;
    produktStellen?: number;
    konto?: number;
    kontoStellen?: number;
    konten?: number[] | undefined;
    ignorierteKonten?: number[] | undefined;
    multiEbenen?: boolean;
    ebene?: string | undefined;
    nurOberebenen?: boolean;
    includeFilteredResults?: boolean;
    verwaltungsAnsicht?: boolean;
    kontenTexte?: Texte[] | undefined;
    konten2Text?: Konto2Text[] | undefined;
    produktTexte?: Texte[] | undefined;
    produkt2Text?: Produkt2Text[] | undefined;
    attrEbenen?: Ebenen[] | undefined;
    hH2Ebene?: Haushaltsstelle2EbeneDoppisch[] | undefined;
    attrEbene?: Ebenen;
}

export class HaushaltSummenRequest implements IHaushaltSummenRequest {
    summenTyp?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    plantyp?: number;
    planstufe?: number;
    uhConfig?: number;
    produkt?: string | undefined;
    produktFilter?: string | undefined;
    ebene?: string | undefined;
    verwaltungsAnsicht?: boolean;

    constructor(data?: IHaushaltSummenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summenTyp = _data["summenTyp"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.plantyp = _data["plantyp"];
            this.planstufe = _data["planstufe"];
            this.uhConfig = _data["uhConfig"];
            this.produkt = _data["produkt"];
            this.produktFilter = _data["produktFilter"];
            this.ebene = _data["ebene"];
            this.verwaltungsAnsicht = _data["verwaltungsAnsicht"];
        }
    }

    static fromJS(data: any): HaushaltSummenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HaushaltSummenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summenTyp"] = this.summenTyp;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["plantyp"] = this.plantyp;
        data["planstufe"] = this.planstufe;
        data["uhConfig"] = this.uhConfig;
        data["produkt"] = this.produkt;
        data["produktFilter"] = this.produktFilter;
        data["ebene"] = this.ebene;
        data["verwaltungsAnsicht"] = this.verwaltungsAnsicht;
        return data;
    }
}

export interface IHaushaltSummenRequest {
    summenTyp?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    plantyp?: number;
    planstufe?: number;
    uhConfig?: number;
    produkt?: string | undefined;
    produktFilter?: string | undefined;
    ebene?: string | undefined;
    verwaltungsAnsicht?: boolean;
}

export class HaushaltSummiert implements IHaushaltSummiert {
    readonly containsData?: boolean;
    bezZeilen?: string | undefined;
    jahre?: number[] | undefined;
    hasVJErg?: boolean;
    zeilen?: HaushaltsZeile[] | undefined;
    grafiken?: HaushaltsGrafik[] | undefined;

    constructor(data?: IHaushaltSummiert) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).containsData = _data["containsData"];
            this.bezZeilen = _data["bezZeilen"];
            if (Array.isArray(_data["jahre"])) {
                this.jahre = [] as any;
                for (let item of _data["jahre"])
                    this.jahre!.push(item);
            }
            this.hasVJErg = _data["hasVJErg"];
            if (Array.isArray(_data["zeilen"])) {
                this.zeilen = [] as any;
                for (let item of _data["zeilen"])
                    this.zeilen!.push(HaushaltsZeile.fromJS(item));
            }
            if (Array.isArray(_data["grafiken"])) {
                this.grafiken = [] as any;
                for (let item of _data["grafiken"])
                    this.grafiken!.push(HaushaltsGrafik.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HaushaltSummiert {
        data = typeof data === 'object' ? data : {};
        let result = new HaushaltSummiert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["containsData"] = this.containsData;
        data["bezZeilen"] = this.bezZeilen;
        if (Array.isArray(this.jahre)) {
            data["jahre"] = [];
            for (let item of this.jahre)
                data["jahre"].push(item);
        }
        data["hasVJErg"] = this.hasVJErg;
        if (Array.isArray(this.zeilen)) {
            data["zeilen"] = [];
            for (let item of this.zeilen)
                data["zeilen"].push(item.toJSON());
        }
        if (Array.isArray(this.grafiken)) {
            data["grafiken"] = [];
            for (let item of this.grafiken)
                data["grafiken"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHaushaltSummiert {
    containsData?: boolean;
    bezZeilen?: string | undefined;
    jahre?: number[] | undefined;
    hasVJErg?: boolean;
    zeilen?: HaushaltsZeile[] | undefined;
    grafiken?: HaushaltsGrafik[] | undefined;
}

export class HaushaltsEbene implements IHaushaltsEbene {
    id?: string | undefined;
    jahre?: number[] | undefined;
    isHHS?: boolean;
    hasVJErg?: boolean;
    verbergen?: boolean;
    ebenenNr?: number | undefined;
    ebenenStellen?: number | undefined;
    ebene?: Ebenen;
    unterabschnitt?: number;
    uaStellen?: number;
    massnahme?: number | undefined;
    untergruppe?: number;
    ugStellen?: number;
    unterkonto?: number;
    sonderUAEbene?: boolean;
    sonderUGEbene?: boolean;
    bezeichnung?: string | undefined;
    uaText?: string | undefined;
    abschnittText?: string | undefined;
    ugText?: string | undefined;
    beschreibung?: string | undefined;
    suchText?: string | undefined;
    toolTip?: string | undefined;
    beginnJahr?: number | undefined;
    endJahr?: number | undefined;
    ergebnisVvvJ_soll?: number;
    ergebnisVvvJ_haben?: number;
    ergebnisVvJ_soll?: number;
    ergebnisVvJ_haben?: number;
    ansatzVJ_soll?: number;
    ansatzVJ_haben?: number;
    ansatzPj_soll?: number;
    ansatzPj_haben?: number;
    ansatzPj1_soll?: number;
    ansatzPj1_haben?: number;
    fp1_soll?: number;
    fp1_haben?: number;
    fp2_soll?: number;
    fp2_haben?: number;
    fp3_soll?: number;
    fp3_haben?: number;
    fp4_soll?: number;
    fp4_haben?: number;
    fp5_soll?: number;
    fp5_haben?: number;
    fp6_soll?: number;
    fp6_haben?: number;
    fp7_soll?: number;
    fp7_haben?: number;
    fp8_soll?: number;
    fp8_haben?: number;
    fp9_soll?: number;
    fp9_haben?: number;
    fp10_soll?: number;
    fp10_haben?: number;
    investiert_soll?: number;
    investiert_haben?: number;
    investiertGesamt_soll?: number;
    investiertGesamt_haben?: number;
    ve_soll?: number;
    ve_haben?: number;
    veFj1_soll?: number;
    veFj1_haben?: number;
    veFj2_soll?: number;
    veFj2_haben?: number;
    veFj3_soll?: number;
    veFj3_haben?: number;
    veFj4_soll?: number;
    veFj4_haben?: number;
    veFj5_soll?: number;
    veFj5_haben?: number;
    ansatzPj_soll_vgl?: number;
    ansatzPj_haben_vgl?: number;
    fp1_soll_vgl?: number;
    fp1_haben_vgl?: number;
    fp2_soll_vgl?: number;
    fp2_haben_vgl?: number;
    fp3_soll_vgl?: number;
    fp3_haben_vgl?: number;
    fp4_soll_vgl?: number;
    fp4_haben_vgl?: number;
    ergebnisPJ_soll?: number;
    ergebnisPJ_haben?: number;
    ansatzPJfort_soll?: number;
    ansatzPJfort_haben?: number;
    ergebnisPJM1_soll?: number;
    ergebnisPJM1_haben?: number;
    ergebnisPJM2_soll?: number;
    ergebnisPJM2_haben?: number;
    ergebnisPJM3_soll?: number;
    ergebnisPJM3_haben?: number;
    ergebnisPJM4_soll?: number;
    ergebnisPJM4_haben?: number;
    aenderungPJ_soll?: number;
    aenderungPJ_haben?: number;
    ergebnisPJ_soll_vgl?: number;
    ergebnisPJ_haben_vgl?: number;
    ansatzPJfort_soll_vgl?: number;
    ansatzPJfort_haben_vgl?: number;
    aenderungPJ_soll_vgl?: number;
    aenderungPJ_haben_vgl?: number;
    istAo_haben?: number;
    istAo_soll?: number;
    verfuegt_haben?: number;
    verfuegbar_soll?: number;
    verfuegbar_haben?: number;
    verfuegt_soll?: number;
    progAuto_haben?: number;
    progAuto_soll?: number;
    progMan_haben?: number | undefined;
    progMan_soll?: number | undefined;
    hasProgMan?: number;
    progKomm?: string | undefined;
    pkTip?: string | undefined;
    hhrest_haben?: number;
    abgHhrest_haben?: number;
    seAoHhre_haben?: number;
    auftragHr_haben?: number;
    aosollVj_haben?: number;
    aoHrHu_haben?: number;
    ansatz_haben?: number;
    nachtrag_haben?: number;
    sollueber_haben?: number;
    ueplApl_haben?: number;
    seAoSoll_haben?: number;
    auftraeg_haben?: number;
    aosollLfd_haben?: number;
    dauerbelege_haben?: number;
    aoSollHu_haben?: number;
    hhrest_soll?: number;
    abgHhrest_soll?: number;
    seAoHhre_soll?: number;
    auftragHr_soll?: number;
    aosollVj_soll?: number;
    aoHrHu_soll?: number;
    ansatz_soll?: number;
    nachtrag_soll?: number;
    sollueber_soll?: number;
    ueplApl_soll?: number;
    seAoSoll_soll?: number;
    auftraeg_soll?: number;
    aosollLfd_soll?: number;
    dauerbelege_soll?: number;
    aoSollHu_soll?: number;
    jahrTips?: { [key: string]: string; } | undefined;
    unterEbenen?: HaushaltsEbene[] | undefined;
    filter?: HaushaltsEbene;
    selected?: boolean;
    texte?: Texte[] | undefined;
    readonly containsData?: boolean;
    readonly containsEinnahmen?: boolean;
    readonly containsAusgaben?: boolean;
    readonly istEinnahme?: boolean;

    constructor(data?: IHaushaltsEbene) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["jahre"])) {
                this.jahre = [] as any;
                for (let item of _data["jahre"])
                    this.jahre!.push(item);
            }
            this.isHHS = _data["isHHS"];
            this.hasVJErg = _data["hasVJErg"];
            this.verbergen = _data["verbergen"];
            this.ebenenNr = _data["ebenenNr"];
            this.ebenenStellen = _data["ebenenStellen"];
            this.ebene = _data["ebene"] ? Ebenen.fromJS(_data["ebene"]) : <any>undefined;
            this.unterabschnitt = _data["unterabschnitt"];
            this.uaStellen = _data["uaStellen"];
            this.massnahme = _data["massnahme"];
            this.untergruppe = _data["untergruppe"];
            this.ugStellen = _data["ugStellen"];
            this.unterkonto = _data["unterkonto"];
            this.sonderUAEbene = _data["sonderUAEbene"];
            this.sonderUGEbene = _data["sonderUGEbene"];
            this.bezeichnung = _data["bezeichnung"];
            this.uaText = _data["uaText"];
            this.abschnittText = _data["abschnittText"];
            this.ugText = _data["ugText"];
            this.beschreibung = _data["beschreibung"];
            this.suchText = _data["suchText"];
            this.toolTip = _data["toolTip"];
            this.beginnJahr = _data["beginnJahr"];
            this.endJahr = _data["endJahr"];
            this.ergebnisVvvJ_soll = _data["ergebnisVvvJ_soll"];
            this.ergebnisVvvJ_haben = _data["ergebnisVvvJ_haben"];
            this.ergebnisVvJ_soll = _data["ergebnisVvJ_soll"];
            this.ergebnisVvJ_haben = _data["ergebnisVvJ_haben"];
            this.ansatzVJ_soll = _data["ansatzVJ_soll"];
            this.ansatzVJ_haben = _data["ansatzVJ_haben"];
            this.ansatzPj_soll = _data["ansatzPj_soll"];
            this.ansatzPj_haben = _data["ansatzPj_haben"];
            this.ansatzPj1_soll = _data["ansatzPj1_soll"];
            this.ansatzPj1_haben = _data["ansatzPj1_haben"];
            this.fp1_soll = _data["fp1_soll"];
            this.fp1_haben = _data["fp1_haben"];
            this.fp2_soll = _data["fp2_soll"];
            this.fp2_haben = _data["fp2_haben"];
            this.fp3_soll = _data["fp3_soll"];
            this.fp3_haben = _data["fp3_haben"];
            this.fp4_soll = _data["fp4_soll"];
            this.fp4_haben = _data["fp4_haben"];
            this.fp5_soll = _data["fp5_soll"];
            this.fp5_haben = _data["fp5_haben"];
            this.fp6_soll = _data["fp6_soll"];
            this.fp6_haben = _data["fp6_haben"];
            this.fp7_soll = _data["fp7_soll"];
            this.fp7_haben = _data["fp7_haben"];
            this.fp8_soll = _data["fp8_soll"];
            this.fp8_haben = _data["fp8_haben"];
            this.fp9_soll = _data["fp9_soll"];
            this.fp9_haben = _data["fp9_haben"];
            this.fp10_soll = _data["fp10_soll"];
            this.fp10_haben = _data["fp10_haben"];
            this.investiert_soll = _data["investiert_soll"];
            this.investiert_haben = _data["investiert_haben"];
            this.investiertGesamt_soll = _data["investiertGesamt_soll"];
            this.investiertGesamt_haben = _data["investiertGesamt_haben"];
            this.ve_soll = _data["ve_soll"];
            this.ve_haben = _data["ve_haben"];
            this.veFj1_soll = _data["veFj1_soll"];
            this.veFj1_haben = _data["veFj1_haben"];
            this.veFj2_soll = _data["veFj2_soll"];
            this.veFj2_haben = _data["veFj2_haben"];
            this.veFj3_soll = _data["veFj3_soll"];
            this.veFj3_haben = _data["veFj3_haben"];
            this.veFj4_soll = _data["veFj4_soll"];
            this.veFj4_haben = _data["veFj4_haben"];
            this.veFj5_soll = _data["veFj5_soll"];
            this.veFj5_haben = _data["veFj5_haben"];
            this.ansatzPj_soll_vgl = _data["ansatzPj_soll_vgl"];
            this.ansatzPj_haben_vgl = _data["ansatzPj_haben_vgl"];
            this.fp1_soll_vgl = _data["fp1_soll_vgl"];
            this.fp1_haben_vgl = _data["fp1_haben_vgl"];
            this.fp2_soll_vgl = _data["fp2_soll_vgl"];
            this.fp2_haben_vgl = _data["fp2_haben_vgl"];
            this.fp3_soll_vgl = _data["fp3_soll_vgl"];
            this.fp3_haben_vgl = _data["fp3_haben_vgl"];
            this.fp4_soll_vgl = _data["fp4_soll_vgl"];
            this.fp4_haben_vgl = _data["fp4_haben_vgl"];
            this.ergebnisPJ_soll = _data["ergebnisPJ_soll"];
            this.ergebnisPJ_haben = _data["ergebnisPJ_haben"];
            this.ansatzPJfort_soll = _data["ansatzPJfort_soll"];
            this.ansatzPJfort_haben = _data["ansatzPJfort_haben"];
            this.ergebnisPJM1_soll = _data["ergebnisPJM1_soll"];
            this.ergebnisPJM1_haben = _data["ergebnisPJM1_haben"];
            this.ergebnisPJM2_soll = _data["ergebnisPJM2_soll"];
            this.ergebnisPJM2_haben = _data["ergebnisPJM2_haben"];
            this.ergebnisPJM3_soll = _data["ergebnisPJM3_soll"];
            this.ergebnisPJM3_haben = _data["ergebnisPJM3_haben"];
            this.ergebnisPJM4_soll = _data["ergebnisPJM4_soll"];
            this.ergebnisPJM4_haben = _data["ergebnisPJM4_haben"];
            this.aenderungPJ_soll = _data["aenderungPJ_soll"];
            this.aenderungPJ_haben = _data["aenderungPJ_haben"];
            this.ergebnisPJ_soll_vgl = _data["ergebnisPJ_soll_vgl"];
            this.ergebnisPJ_haben_vgl = _data["ergebnisPJ_haben_vgl"];
            this.ansatzPJfort_soll_vgl = _data["ansatzPJfort_soll_vgl"];
            this.ansatzPJfort_haben_vgl = _data["ansatzPJfort_haben_vgl"];
            this.aenderungPJ_soll_vgl = _data["aenderungPJ_soll_vgl"];
            this.aenderungPJ_haben_vgl = _data["aenderungPJ_haben_vgl"];
            this.istAo_haben = _data["istAo_haben"];
            this.istAo_soll = _data["istAo_soll"];
            this.verfuegt_haben = _data["verfuegt_haben"];
            this.verfuegbar_soll = _data["verfuegbar_soll"];
            this.verfuegbar_haben = _data["verfuegbar_haben"];
            this.verfuegt_soll = _data["verfuegt_soll"];
            this.progAuto_haben = _data["progAuto_haben"];
            this.progAuto_soll = _data["progAuto_soll"];
            this.progMan_haben = _data["progMan_haben"];
            this.progMan_soll = _data["progMan_soll"];
            this.hasProgMan = _data["hasProgMan"];
            this.progKomm = _data["progKomm"];
            this.pkTip = _data["pkTip"];
            this.hhrest_haben = _data["hhrest_haben"];
            this.abgHhrest_haben = _data["abgHhrest_haben"];
            this.seAoHhre_haben = _data["seAoHhre_haben"];
            this.auftragHr_haben = _data["auftragHr_haben"];
            this.aosollVj_haben = _data["aosollVj_haben"];
            this.aoHrHu_haben = _data["aoHrHu_haben"];
            this.ansatz_haben = _data["ansatz_haben"];
            this.nachtrag_haben = _data["nachtrag_haben"];
            this.sollueber_haben = _data["sollueber_haben"];
            this.ueplApl_haben = _data["ueplApl_haben"];
            this.seAoSoll_haben = _data["seAoSoll_haben"];
            this.auftraeg_haben = _data["auftraeg_haben"];
            this.aosollLfd_haben = _data["aosollLfd_haben"];
            this.dauerbelege_haben = _data["dauerbelege_haben"];
            this.aoSollHu_haben = _data["aoSollHu_haben"];
            this.hhrest_soll = _data["hhrest_soll"];
            this.abgHhrest_soll = _data["abgHhrest_soll"];
            this.seAoHhre_soll = _data["seAoHhre_soll"];
            this.auftragHr_soll = _data["auftragHr_soll"];
            this.aosollVj_soll = _data["aosollVj_soll"];
            this.aoHrHu_soll = _data["aoHrHu_soll"];
            this.ansatz_soll = _data["ansatz_soll"];
            this.nachtrag_soll = _data["nachtrag_soll"];
            this.sollueber_soll = _data["sollueber_soll"];
            this.ueplApl_soll = _data["ueplApl_soll"];
            this.seAoSoll_soll = _data["seAoSoll_soll"];
            this.auftraeg_soll = _data["auftraeg_soll"];
            this.aosollLfd_soll = _data["aosollLfd_soll"];
            this.dauerbelege_soll = _data["dauerbelege_soll"];
            this.aoSollHu_soll = _data["aoSollHu_soll"];
            if (_data["jahrTips"]) {
                this.jahrTips = {} as any;
                for (let key in _data["jahrTips"]) {
                    if (_data["jahrTips"].hasOwnProperty(key))
                        (<any>this.jahrTips)![key] = _data["jahrTips"][key];
                }
            }
            if (Array.isArray(_data["unterEbenen"])) {
                this.unterEbenen = [] as any;
                for (let item of _data["unterEbenen"])
                    this.unterEbenen!.push(HaushaltsEbene.fromJS(item));
            }
            this.filter = _data["filter"] ? HaushaltsEbene.fromJS(_data["filter"]) : <any>undefined;
            this.selected = _data["selected"];
            if (Array.isArray(_data["texte"])) {
                this.texte = [] as any;
                for (let item of _data["texte"])
                    this.texte!.push(Texte.fromJS(item));
            }
            (<any>this).containsData = _data["containsData"];
            (<any>this).containsEinnahmen = _data["containsEinnahmen"];
            (<any>this).containsAusgaben = _data["containsAusgaben"];
            (<any>this).istEinnahme = _data["istEinnahme"];
        }
    }

    static fromJS(data: any): HaushaltsEbene {
        data = typeof data === 'object' ? data : {};
        let result = new HaushaltsEbene();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.jahre)) {
            data["jahre"] = [];
            for (let item of this.jahre)
                data["jahre"].push(item);
        }
        data["isHHS"] = this.isHHS;
        data["hasVJErg"] = this.hasVJErg;
        data["verbergen"] = this.verbergen;
        data["ebenenNr"] = this.ebenenNr;
        data["ebenenStellen"] = this.ebenenStellen;
        data["ebene"] = this.ebene ? this.ebene.toJSON() : <any>undefined;
        data["unterabschnitt"] = this.unterabschnitt;
        data["uaStellen"] = this.uaStellen;
        data["massnahme"] = this.massnahme;
        data["untergruppe"] = this.untergruppe;
        data["ugStellen"] = this.ugStellen;
        data["unterkonto"] = this.unterkonto;
        data["sonderUAEbene"] = this.sonderUAEbene;
        data["sonderUGEbene"] = this.sonderUGEbene;
        data["bezeichnung"] = this.bezeichnung;
        data["uaText"] = this.uaText;
        data["abschnittText"] = this.abschnittText;
        data["ugText"] = this.ugText;
        data["beschreibung"] = this.beschreibung;
        data["suchText"] = this.suchText;
        data["toolTip"] = this.toolTip;
        data["beginnJahr"] = this.beginnJahr;
        data["endJahr"] = this.endJahr;
        data["ergebnisVvvJ_soll"] = this.ergebnisVvvJ_soll;
        data["ergebnisVvvJ_haben"] = this.ergebnisVvvJ_haben;
        data["ergebnisVvJ_soll"] = this.ergebnisVvJ_soll;
        data["ergebnisVvJ_haben"] = this.ergebnisVvJ_haben;
        data["ansatzVJ_soll"] = this.ansatzVJ_soll;
        data["ansatzVJ_haben"] = this.ansatzVJ_haben;
        data["ansatzPj_soll"] = this.ansatzPj_soll;
        data["ansatzPj_haben"] = this.ansatzPj_haben;
        data["ansatzPj1_soll"] = this.ansatzPj1_soll;
        data["ansatzPj1_haben"] = this.ansatzPj1_haben;
        data["fp1_soll"] = this.fp1_soll;
        data["fp1_haben"] = this.fp1_haben;
        data["fp2_soll"] = this.fp2_soll;
        data["fp2_haben"] = this.fp2_haben;
        data["fp3_soll"] = this.fp3_soll;
        data["fp3_haben"] = this.fp3_haben;
        data["fp4_soll"] = this.fp4_soll;
        data["fp4_haben"] = this.fp4_haben;
        data["fp5_soll"] = this.fp5_soll;
        data["fp5_haben"] = this.fp5_haben;
        data["fp6_soll"] = this.fp6_soll;
        data["fp6_haben"] = this.fp6_haben;
        data["fp7_soll"] = this.fp7_soll;
        data["fp7_haben"] = this.fp7_haben;
        data["fp8_soll"] = this.fp8_soll;
        data["fp8_haben"] = this.fp8_haben;
        data["fp9_soll"] = this.fp9_soll;
        data["fp9_haben"] = this.fp9_haben;
        data["fp10_soll"] = this.fp10_soll;
        data["fp10_haben"] = this.fp10_haben;
        data["investiert_soll"] = this.investiert_soll;
        data["investiert_haben"] = this.investiert_haben;
        data["investiertGesamt_soll"] = this.investiertGesamt_soll;
        data["investiertGesamt_haben"] = this.investiertGesamt_haben;
        data["ve_soll"] = this.ve_soll;
        data["ve_haben"] = this.ve_haben;
        data["veFj1_soll"] = this.veFj1_soll;
        data["veFj1_haben"] = this.veFj1_haben;
        data["veFj2_soll"] = this.veFj2_soll;
        data["veFj2_haben"] = this.veFj2_haben;
        data["veFj3_soll"] = this.veFj3_soll;
        data["veFj3_haben"] = this.veFj3_haben;
        data["veFj4_soll"] = this.veFj4_soll;
        data["veFj4_haben"] = this.veFj4_haben;
        data["veFj5_soll"] = this.veFj5_soll;
        data["veFj5_haben"] = this.veFj5_haben;
        data["ansatzPj_soll_vgl"] = this.ansatzPj_soll_vgl;
        data["ansatzPj_haben_vgl"] = this.ansatzPj_haben_vgl;
        data["fp1_soll_vgl"] = this.fp1_soll_vgl;
        data["fp1_haben_vgl"] = this.fp1_haben_vgl;
        data["fp2_soll_vgl"] = this.fp2_soll_vgl;
        data["fp2_haben_vgl"] = this.fp2_haben_vgl;
        data["fp3_soll_vgl"] = this.fp3_soll_vgl;
        data["fp3_haben_vgl"] = this.fp3_haben_vgl;
        data["fp4_soll_vgl"] = this.fp4_soll_vgl;
        data["fp4_haben_vgl"] = this.fp4_haben_vgl;
        data["ergebnisPJ_soll"] = this.ergebnisPJ_soll;
        data["ergebnisPJ_haben"] = this.ergebnisPJ_haben;
        data["ansatzPJfort_soll"] = this.ansatzPJfort_soll;
        data["ansatzPJfort_haben"] = this.ansatzPJfort_haben;
        data["ergebnisPJM1_soll"] = this.ergebnisPJM1_soll;
        data["ergebnisPJM1_haben"] = this.ergebnisPJM1_haben;
        data["ergebnisPJM2_soll"] = this.ergebnisPJM2_soll;
        data["ergebnisPJM2_haben"] = this.ergebnisPJM2_haben;
        data["ergebnisPJM3_soll"] = this.ergebnisPJM3_soll;
        data["ergebnisPJM3_haben"] = this.ergebnisPJM3_haben;
        data["ergebnisPJM4_soll"] = this.ergebnisPJM4_soll;
        data["ergebnisPJM4_haben"] = this.ergebnisPJM4_haben;
        data["aenderungPJ_soll"] = this.aenderungPJ_soll;
        data["aenderungPJ_haben"] = this.aenderungPJ_haben;
        data["ergebnisPJ_soll_vgl"] = this.ergebnisPJ_soll_vgl;
        data["ergebnisPJ_haben_vgl"] = this.ergebnisPJ_haben_vgl;
        data["ansatzPJfort_soll_vgl"] = this.ansatzPJfort_soll_vgl;
        data["ansatzPJfort_haben_vgl"] = this.ansatzPJfort_haben_vgl;
        data["aenderungPJ_soll_vgl"] = this.aenderungPJ_soll_vgl;
        data["aenderungPJ_haben_vgl"] = this.aenderungPJ_haben_vgl;
        data["istAo_haben"] = this.istAo_haben;
        data["istAo_soll"] = this.istAo_soll;
        data["verfuegt_haben"] = this.verfuegt_haben;
        data["verfuegbar_soll"] = this.verfuegbar_soll;
        data["verfuegbar_haben"] = this.verfuegbar_haben;
        data["verfuegt_soll"] = this.verfuegt_soll;
        data["progAuto_haben"] = this.progAuto_haben;
        data["progAuto_soll"] = this.progAuto_soll;
        data["progMan_haben"] = this.progMan_haben;
        data["progMan_soll"] = this.progMan_soll;
        data["hasProgMan"] = this.hasProgMan;
        data["progKomm"] = this.progKomm;
        data["pkTip"] = this.pkTip;
        data["hhrest_haben"] = this.hhrest_haben;
        data["abgHhrest_haben"] = this.abgHhrest_haben;
        data["seAoHhre_haben"] = this.seAoHhre_haben;
        data["auftragHr_haben"] = this.auftragHr_haben;
        data["aosollVj_haben"] = this.aosollVj_haben;
        data["aoHrHu_haben"] = this.aoHrHu_haben;
        data["ansatz_haben"] = this.ansatz_haben;
        data["nachtrag_haben"] = this.nachtrag_haben;
        data["sollueber_haben"] = this.sollueber_haben;
        data["ueplApl_haben"] = this.ueplApl_haben;
        data["seAoSoll_haben"] = this.seAoSoll_haben;
        data["auftraeg_haben"] = this.auftraeg_haben;
        data["aosollLfd_haben"] = this.aosollLfd_haben;
        data["dauerbelege_haben"] = this.dauerbelege_haben;
        data["aoSollHu_haben"] = this.aoSollHu_haben;
        data["hhrest_soll"] = this.hhrest_soll;
        data["abgHhrest_soll"] = this.abgHhrest_soll;
        data["seAoHhre_soll"] = this.seAoHhre_soll;
        data["auftragHr_soll"] = this.auftragHr_soll;
        data["aosollVj_soll"] = this.aosollVj_soll;
        data["aoHrHu_soll"] = this.aoHrHu_soll;
        data["ansatz_soll"] = this.ansatz_soll;
        data["nachtrag_soll"] = this.nachtrag_soll;
        data["sollueber_soll"] = this.sollueber_soll;
        data["ueplApl_soll"] = this.ueplApl_soll;
        data["seAoSoll_soll"] = this.seAoSoll_soll;
        data["auftraeg_soll"] = this.auftraeg_soll;
        data["aosollLfd_soll"] = this.aosollLfd_soll;
        data["dauerbelege_soll"] = this.dauerbelege_soll;
        data["aoSollHu_soll"] = this.aoSollHu_soll;
        if (this.jahrTips) {
            data["jahrTips"] = {};
            for (let key in this.jahrTips) {
                if (this.jahrTips.hasOwnProperty(key))
                    (<any>data["jahrTips"])[key] = (<any>this.jahrTips)[key];
            }
        }
        if (Array.isArray(this.unterEbenen)) {
            data["unterEbenen"] = [];
            for (let item of this.unterEbenen)
                data["unterEbenen"].push(item.toJSON());
        }
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["selected"] = this.selected;
        if (Array.isArray(this.texte)) {
            data["texte"] = [];
            for (let item of this.texte)
                data["texte"].push(item.toJSON());
        }
        data["containsData"] = this.containsData;
        data["containsEinnahmen"] = this.containsEinnahmen;
        data["containsAusgaben"] = this.containsAusgaben;
        data["istEinnahme"] = this.istEinnahme;
        return data;
    }
}

export interface IHaushaltsEbene {
    id?: string | undefined;
    jahre?: number[] | undefined;
    isHHS?: boolean;
    hasVJErg?: boolean;
    verbergen?: boolean;
    ebenenNr?: number | undefined;
    ebenenStellen?: number | undefined;
    ebene?: Ebenen;
    unterabschnitt?: number;
    uaStellen?: number;
    massnahme?: number | undefined;
    untergruppe?: number;
    ugStellen?: number;
    unterkonto?: number;
    sonderUAEbene?: boolean;
    sonderUGEbene?: boolean;
    bezeichnung?: string | undefined;
    uaText?: string | undefined;
    abschnittText?: string | undefined;
    ugText?: string | undefined;
    beschreibung?: string | undefined;
    suchText?: string | undefined;
    toolTip?: string | undefined;
    beginnJahr?: number | undefined;
    endJahr?: number | undefined;
    ergebnisVvvJ_soll?: number;
    ergebnisVvvJ_haben?: number;
    ergebnisVvJ_soll?: number;
    ergebnisVvJ_haben?: number;
    ansatzVJ_soll?: number;
    ansatzVJ_haben?: number;
    ansatzPj_soll?: number;
    ansatzPj_haben?: number;
    ansatzPj1_soll?: number;
    ansatzPj1_haben?: number;
    fp1_soll?: number;
    fp1_haben?: number;
    fp2_soll?: number;
    fp2_haben?: number;
    fp3_soll?: number;
    fp3_haben?: number;
    fp4_soll?: number;
    fp4_haben?: number;
    fp5_soll?: number;
    fp5_haben?: number;
    fp6_soll?: number;
    fp6_haben?: number;
    fp7_soll?: number;
    fp7_haben?: number;
    fp8_soll?: number;
    fp8_haben?: number;
    fp9_soll?: number;
    fp9_haben?: number;
    fp10_soll?: number;
    fp10_haben?: number;
    investiert_soll?: number;
    investiert_haben?: number;
    investiertGesamt_soll?: number;
    investiertGesamt_haben?: number;
    ve_soll?: number;
    ve_haben?: number;
    veFj1_soll?: number;
    veFj1_haben?: number;
    veFj2_soll?: number;
    veFj2_haben?: number;
    veFj3_soll?: number;
    veFj3_haben?: number;
    veFj4_soll?: number;
    veFj4_haben?: number;
    veFj5_soll?: number;
    veFj5_haben?: number;
    ansatzPj_soll_vgl?: number;
    ansatzPj_haben_vgl?: number;
    fp1_soll_vgl?: number;
    fp1_haben_vgl?: number;
    fp2_soll_vgl?: number;
    fp2_haben_vgl?: number;
    fp3_soll_vgl?: number;
    fp3_haben_vgl?: number;
    fp4_soll_vgl?: number;
    fp4_haben_vgl?: number;
    ergebnisPJ_soll?: number;
    ergebnisPJ_haben?: number;
    ansatzPJfort_soll?: number;
    ansatzPJfort_haben?: number;
    ergebnisPJM1_soll?: number;
    ergebnisPJM1_haben?: number;
    ergebnisPJM2_soll?: number;
    ergebnisPJM2_haben?: number;
    ergebnisPJM3_soll?: number;
    ergebnisPJM3_haben?: number;
    ergebnisPJM4_soll?: number;
    ergebnisPJM4_haben?: number;
    aenderungPJ_soll?: number;
    aenderungPJ_haben?: number;
    ergebnisPJ_soll_vgl?: number;
    ergebnisPJ_haben_vgl?: number;
    ansatzPJfort_soll_vgl?: number;
    ansatzPJfort_haben_vgl?: number;
    aenderungPJ_soll_vgl?: number;
    aenderungPJ_haben_vgl?: number;
    istAo_haben?: number;
    istAo_soll?: number;
    verfuegt_haben?: number;
    verfuegbar_soll?: number;
    verfuegbar_haben?: number;
    verfuegt_soll?: number;
    progAuto_haben?: number;
    progAuto_soll?: number;
    progMan_haben?: number | undefined;
    progMan_soll?: number | undefined;
    hasProgMan?: number;
    progKomm?: string | undefined;
    pkTip?: string | undefined;
    hhrest_haben?: number;
    abgHhrest_haben?: number;
    seAoHhre_haben?: number;
    auftragHr_haben?: number;
    aosollVj_haben?: number;
    aoHrHu_haben?: number;
    ansatz_haben?: number;
    nachtrag_haben?: number;
    sollueber_haben?: number;
    ueplApl_haben?: number;
    seAoSoll_haben?: number;
    auftraeg_haben?: number;
    aosollLfd_haben?: number;
    dauerbelege_haben?: number;
    aoSollHu_haben?: number;
    hhrest_soll?: number;
    abgHhrest_soll?: number;
    seAoHhre_soll?: number;
    auftragHr_soll?: number;
    aosollVj_soll?: number;
    aoHrHu_soll?: number;
    ansatz_soll?: number;
    nachtrag_soll?: number;
    sollueber_soll?: number;
    ueplApl_soll?: number;
    seAoSoll_soll?: number;
    auftraeg_soll?: number;
    aosollLfd_soll?: number;
    dauerbelege_soll?: number;
    aoSollHu_soll?: number;
    jahrTips?: { [key: string]: string; } | undefined;
    unterEbenen?: HaushaltsEbene[] | undefined;
    filter?: HaushaltsEbene;
    selected?: boolean;
    texte?: Texte[] | undefined;
    containsData?: boolean;
    containsEinnahmen?: boolean;
    containsAusgaben?: boolean;
    istEinnahme?: boolean;
}

export class HaushaltsEbeneDoppik implements IHaushaltsEbeneDoppik {
    cacheLoc?: string | undefined;
    id?: string | undefined;
    hasVJErg?: boolean;
    verbergen?: boolean;
    ebenenNr?: number | undefined;
    ebenenStellen?: number | undefined;
    ebenen?: string[] | undefined;
    produkt?: number;
    produktStellen?: number;
    produktEbene?: string | undefined;
    massnahme?: string | undefined;
    investNr?: string | undefined;
    bestandsKonto?: string | undefined;
    bestandsKontoText?: string | undefined;
    isErfolgsKonto?: boolean;
    investPos?: number;
    investPosText?: string | undefined;
    teilhaushalt?: string | undefined;
    konto?: number;
    kontoStellen?: number;
    bezeichnung?: string | undefined;
    produktText?: string | undefined;
    kontoText?: string | undefined;
    beschreibung?: string | undefined;
    beginnJahr?: number | undefined;
    endJahr?: number | undefined;
    ergebnisVvvJ_soll?: number;
    ergebnisVvvJ_haben?: number;
    ergebnisVvJ_soll?: number;
    ergebnisVvJ_haben?: number;
    ansatzVJ_soll?: number;
    ansatzVJ_haben?: number;
    ansatzPj_soll?: number;
    ansatzPj_haben?: number;
    ansatzPj1_soll?: number;
    ansatzPj1_haben?: number;
    fp1_soll?: number;
    fp1_haben?: number;
    fp2_soll?: number;
    fp2_haben?: number;
    fp3_soll?: number;
    fp3_haben?: number;
    fp4_soll?: number;
    fp4_haben?: number;
    fp5_soll?: number;
    fp5_haben?: number;
    fp6_soll?: number;
    fp6_haben?: number;
    fp7_soll?: number;
    fp7_haben?: number;
    fp8_soll?: number;
    fp8_haben?: number;
    fp9_soll?: number;
    fp9_haben?: number;
    fp10_soll?: number;
    fp10_haben?: number;
    investiert_soll?: number;
    investiert_haben?: number;
    investiertGesamt_soll?: number;
    investiertGesamt_haben?: number;
    ve_soll?: number;
    ve_haben?: number;
    veFj1_soll?: number;
    veFj1_haben?: number;
    veFj2_soll?: number;
    veFj2_haben?: number;
    veFj3_soll?: number;
    veFj3_haben?: number;
    veFj4_soll?: number;
    veFj4_haben?: number;
    veFj5_soll?: number;
    veFj5_haben?: number;
    ve1_soll?: number;
    ve1_haben?: number;
    ve1Fj1_soll?: number;
    ve1Fj1_haben?: number;
    ve1Fj2_soll?: number;
    ve1Fj2_haben?: number;
    ve1Fj3_soll?: number;
    ve1Fj3_haben?: number;
    ve1Fj4_soll?: number;
    ve1Fj4_haben?: number;
    ve1Fj5_soll?: number;
    ve1Fj5_haben?: number;
    ergebnisPJ_soll?: number;
    ergebnisPJ_haben?: number;
    verfuegtPJ_soll?: number;
    verfuegtPJ_haben?: number;
    ansatzPJfort_soll?: number;
    ansatzPJfort_haben?: number;
    ergebnisPJM1_soll?: number;
    ergebnisPJM1_haben?: number;
    ergebnisPJM2_soll?: number;
    ergebnisPJM2_haben?: number;
    ergebnisPJM3_soll?: number;
    ergebnisPJM3_haben?: number;
    ergebnisPJM4_soll?: number;
    ergebnisPJM4_haben?: number;
    aenderungPJ_soll?: number;
    aenderungPJ_haben?: number;
    hhrest_haben?: number;
    abgHhrest_haben?: number;
    seAoHhre_haben?: number;
    auftragHr_haben?: number;
    aosollVj_haben?: number;
    aoHrHu_haben?: number;
    ansatz_haben?: number;
    nachtrag_haben?: number;
    sollueber_haben?: number;
    ueplApl_haben?: number;
    seAoSoll_haben?: number;
    auftraeg_haben?: number;
    aosollLfd_haben?: number;
    dauerbelege_haben?: number;
    aoSollHu_haben?: number;
    hhrest_soll?: number;
    abgHhrest_soll?: number;
    seAoHhre_soll?: number;
    auftragHr_soll?: number;
    aosollVj_soll?: number;
    aoHrHu_soll?: number;
    ansatz_soll?: number;
    nachtrag_soll?: number;
    sollueber_soll?: number;
    ueplApl_soll?: number;
    seAoSoll_soll?: number;
    auftraeg_soll?: number;
    aosollLfd_soll?: number;
    dauerbelege_soll?: number;
    aoSollHu_soll?: number;
    ergebnisPJ_passiva?: number;
    ergebnisPJ_aktiva?: number;
    ansatzPJfort_passiva?: number;
    ansatzPJfort_aktiva?: number;
    ergebnisPJM1_passiva?: number;
    ergebnisPJM1_aktiva?: number;
    ergebnisPJM2_passiva?: number;
    ergebnisPJM2_aktiva?: number;
    ergebnisPJM3_passiva?: number;
    ergebnisPJM3_aktiva?: number;
    ergebnisPJM4_passiva?: number;
    ergebnisPJM4_aktiva?: number;
    aenderungPJ_passiva?: number;
    aenderungPJ_aktiva?: number;
    unterEbenen?: HaushaltsEbeneDoppik[] | undefined;
    filter?: HaushaltsEbeneDoppik;
    texte?: Texte[] | undefined;
    readonly containsData?: boolean;
    readonly containsEinnahmen?: boolean;
    readonly containsAusgaben?: boolean;

    constructor(data?: IHaushaltsEbeneDoppik) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cacheLoc = _data["cacheLoc"];
            this.id = _data["id"];
            this.hasVJErg = _data["hasVJErg"];
            this.verbergen = _data["verbergen"];
            this.ebenenNr = _data["ebenenNr"];
            this.ebenenStellen = _data["ebenenStellen"];
            if (Array.isArray(_data["ebenen"])) {
                this.ebenen = [] as any;
                for (let item of _data["ebenen"])
                    this.ebenen!.push(item);
            }
            this.produkt = _data["produkt"];
            this.produktStellen = _data["produktStellen"];
            this.produktEbene = _data["produktEbene"];
            this.massnahme = _data["massnahme"];
            this.investNr = _data["investNr"];
            this.bestandsKonto = _data["bestandsKonto"];
            this.bestandsKontoText = _data["bestandsKontoText"];
            this.isErfolgsKonto = _data["isErfolgsKonto"];
            this.investPos = _data["investPos"];
            this.investPosText = _data["investPosText"];
            this.teilhaushalt = _data["teilhaushalt"];
            this.konto = _data["konto"];
            this.kontoStellen = _data["kontoStellen"];
            this.bezeichnung = _data["bezeichnung"];
            this.produktText = _data["produktText"];
            this.kontoText = _data["kontoText"];
            this.beschreibung = _data["beschreibung"];
            this.beginnJahr = _data["beginnJahr"];
            this.endJahr = _data["endJahr"];
            this.ergebnisVvvJ_soll = _data["ergebnisVvvJ_soll"];
            this.ergebnisVvvJ_haben = _data["ergebnisVvvJ_haben"];
            this.ergebnisVvJ_soll = _data["ergebnisVvJ_soll"];
            this.ergebnisVvJ_haben = _data["ergebnisVvJ_haben"];
            this.ansatzVJ_soll = _data["ansatzVJ_soll"];
            this.ansatzVJ_haben = _data["ansatzVJ_haben"];
            this.ansatzPj_soll = _data["ansatzPj_soll"];
            this.ansatzPj_haben = _data["ansatzPj_haben"];
            this.ansatzPj1_soll = _data["ansatzPj1_soll"];
            this.ansatzPj1_haben = _data["ansatzPj1_haben"];
            this.fp1_soll = _data["fp1_soll"];
            this.fp1_haben = _data["fp1_haben"];
            this.fp2_soll = _data["fp2_soll"];
            this.fp2_haben = _data["fp2_haben"];
            this.fp3_soll = _data["fp3_soll"];
            this.fp3_haben = _data["fp3_haben"];
            this.fp4_soll = _data["fp4_soll"];
            this.fp4_haben = _data["fp4_haben"];
            this.fp5_soll = _data["fp5_soll"];
            this.fp5_haben = _data["fp5_haben"];
            this.fp6_soll = _data["fp6_soll"];
            this.fp6_haben = _data["fp6_haben"];
            this.fp7_soll = _data["fp7_soll"];
            this.fp7_haben = _data["fp7_haben"];
            this.fp8_soll = _data["fp8_soll"];
            this.fp8_haben = _data["fp8_haben"];
            this.fp9_soll = _data["fp9_soll"];
            this.fp9_haben = _data["fp9_haben"];
            this.fp10_soll = _data["fp10_soll"];
            this.fp10_haben = _data["fp10_haben"];
            this.investiert_soll = _data["investiert_soll"];
            this.investiert_haben = _data["investiert_haben"];
            this.investiertGesamt_soll = _data["investiertGesamt_soll"];
            this.investiertGesamt_haben = _data["investiertGesamt_haben"];
            this.ve_soll = _data["ve_soll"];
            this.ve_haben = _data["ve_haben"];
            this.veFj1_soll = _data["veFj1_soll"];
            this.veFj1_haben = _data["veFj1_haben"];
            this.veFj2_soll = _data["veFj2_soll"];
            this.veFj2_haben = _data["veFj2_haben"];
            this.veFj3_soll = _data["veFj3_soll"];
            this.veFj3_haben = _data["veFj3_haben"];
            this.veFj4_soll = _data["veFj4_soll"];
            this.veFj4_haben = _data["veFj4_haben"];
            this.veFj5_soll = _data["veFj5_soll"];
            this.veFj5_haben = _data["veFj5_haben"];
            this.ve1_soll = _data["ve1_soll"];
            this.ve1_haben = _data["ve1_haben"];
            this.ve1Fj1_soll = _data["ve1Fj1_soll"];
            this.ve1Fj1_haben = _data["ve1Fj1_haben"];
            this.ve1Fj2_soll = _data["ve1Fj2_soll"];
            this.ve1Fj2_haben = _data["ve1Fj2_haben"];
            this.ve1Fj3_soll = _data["ve1Fj3_soll"];
            this.ve1Fj3_haben = _data["ve1Fj3_haben"];
            this.ve1Fj4_soll = _data["ve1Fj4_soll"];
            this.ve1Fj4_haben = _data["ve1Fj4_haben"];
            this.ve1Fj5_soll = _data["ve1Fj5_soll"];
            this.ve1Fj5_haben = _data["ve1Fj5_haben"];
            this.ergebnisPJ_soll = _data["ergebnisPJ_soll"];
            this.ergebnisPJ_haben = _data["ergebnisPJ_haben"];
            this.verfuegtPJ_soll = _data["verfuegtPJ_soll"];
            this.verfuegtPJ_haben = _data["verfuegtPJ_haben"];
            this.ansatzPJfort_soll = _data["ansatzPJfort_soll"];
            this.ansatzPJfort_haben = _data["ansatzPJfort_haben"];
            this.ergebnisPJM1_soll = _data["ergebnisPJM1_soll"];
            this.ergebnisPJM1_haben = _data["ergebnisPJM1_haben"];
            this.ergebnisPJM2_soll = _data["ergebnisPJM2_soll"];
            this.ergebnisPJM2_haben = _data["ergebnisPJM2_haben"];
            this.ergebnisPJM3_soll = _data["ergebnisPJM3_soll"];
            this.ergebnisPJM3_haben = _data["ergebnisPJM3_haben"];
            this.ergebnisPJM4_soll = _data["ergebnisPJM4_soll"];
            this.ergebnisPJM4_haben = _data["ergebnisPJM4_haben"];
            this.aenderungPJ_soll = _data["aenderungPJ_soll"];
            this.aenderungPJ_haben = _data["aenderungPJ_haben"];
            this.hhrest_haben = _data["hhrest_haben"];
            this.abgHhrest_haben = _data["abgHhrest_haben"];
            this.seAoHhre_haben = _data["seAoHhre_haben"];
            this.auftragHr_haben = _data["auftragHr_haben"];
            this.aosollVj_haben = _data["aosollVj_haben"];
            this.aoHrHu_haben = _data["aoHrHu_haben"];
            this.ansatz_haben = _data["ansatz_haben"];
            this.nachtrag_haben = _data["nachtrag_haben"];
            this.sollueber_haben = _data["sollueber_haben"];
            this.ueplApl_haben = _data["ueplApl_haben"];
            this.seAoSoll_haben = _data["seAoSoll_haben"];
            this.auftraeg_haben = _data["auftraeg_haben"];
            this.aosollLfd_haben = _data["aosollLfd_haben"];
            this.dauerbelege_haben = _data["dauerbelege_haben"];
            this.aoSollHu_haben = _data["aoSollHu_haben"];
            this.hhrest_soll = _data["hhrest_soll"];
            this.abgHhrest_soll = _data["abgHhrest_soll"];
            this.seAoHhre_soll = _data["seAoHhre_soll"];
            this.auftragHr_soll = _data["auftragHr_soll"];
            this.aosollVj_soll = _data["aosollVj_soll"];
            this.aoHrHu_soll = _data["aoHrHu_soll"];
            this.ansatz_soll = _data["ansatz_soll"];
            this.nachtrag_soll = _data["nachtrag_soll"];
            this.sollueber_soll = _data["sollueber_soll"];
            this.ueplApl_soll = _data["ueplApl_soll"];
            this.seAoSoll_soll = _data["seAoSoll_soll"];
            this.auftraeg_soll = _data["auftraeg_soll"];
            this.aosollLfd_soll = _data["aosollLfd_soll"];
            this.dauerbelege_soll = _data["dauerbelege_soll"];
            this.aoSollHu_soll = _data["aoSollHu_soll"];
            this.ergebnisPJ_passiva = _data["ergebnisPJ_passiva"];
            this.ergebnisPJ_aktiva = _data["ergebnisPJ_aktiva"];
            this.ansatzPJfort_passiva = _data["ansatzPJfort_passiva"];
            this.ansatzPJfort_aktiva = _data["ansatzPJfort_aktiva"];
            this.ergebnisPJM1_passiva = _data["ergebnisPJM1_passiva"];
            this.ergebnisPJM1_aktiva = _data["ergebnisPJM1_aktiva"];
            this.ergebnisPJM2_passiva = _data["ergebnisPJM2_passiva"];
            this.ergebnisPJM2_aktiva = _data["ergebnisPJM2_aktiva"];
            this.ergebnisPJM3_passiva = _data["ergebnisPJM3_passiva"];
            this.ergebnisPJM3_aktiva = _data["ergebnisPJM3_aktiva"];
            this.ergebnisPJM4_passiva = _data["ergebnisPJM4_passiva"];
            this.ergebnisPJM4_aktiva = _data["ergebnisPJM4_aktiva"];
            this.aenderungPJ_passiva = _data["aenderungPJ_passiva"];
            this.aenderungPJ_aktiva = _data["aenderungPJ_aktiva"];
            if (Array.isArray(_data["unterEbenen"])) {
                this.unterEbenen = [] as any;
                for (let item of _data["unterEbenen"])
                    this.unterEbenen!.push(HaushaltsEbeneDoppik.fromJS(item));
            }
            this.filter = _data["filter"] ? HaushaltsEbeneDoppik.fromJS(_data["filter"]) : <any>undefined;
            if (Array.isArray(_data["texte"])) {
                this.texte = [] as any;
                for (let item of _data["texte"])
                    this.texte!.push(Texte.fromJS(item));
            }
            (<any>this).containsData = _data["containsData"];
            (<any>this).containsEinnahmen = _data["containsEinnahmen"];
            (<any>this).containsAusgaben = _data["containsAusgaben"];
        }
    }

    static fromJS(data: any): HaushaltsEbeneDoppik {
        data = typeof data === 'object' ? data : {};
        let result = new HaushaltsEbeneDoppik();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cacheLoc"] = this.cacheLoc;
        data["id"] = this.id;
        data["hasVJErg"] = this.hasVJErg;
        data["verbergen"] = this.verbergen;
        data["ebenenNr"] = this.ebenenNr;
        data["ebenenStellen"] = this.ebenenStellen;
        if (Array.isArray(this.ebenen)) {
            data["ebenen"] = [];
            for (let item of this.ebenen)
                data["ebenen"].push(item);
        }
        data["produkt"] = this.produkt;
        data["produktStellen"] = this.produktStellen;
        data["produktEbene"] = this.produktEbene;
        data["massnahme"] = this.massnahme;
        data["investNr"] = this.investNr;
        data["bestandsKonto"] = this.bestandsKonto;
        data["bestandsKontoText"] = this.bestandsKontoText;
        data["isErfolgsKonto"] = this.isErfolgsKonto;
        data["investPos"] = this.investPos;
        data["investPosText"] = this.investPosText;
        data["teilhaushalt"] = this.teilhaushalt;
        data["konto"] = this.konto;
        data["kontoStellen"] = this.kontoStellen;
        data["bezeichnung"] = this.bezeichnung;
        data["produktText"] = this.produktText;
        data["kontoText"] = this.kontoText;
        data["beschreibung"] = this.beschreibung;
        data["beginnJahr"] = this.beginnJahr;
        data["endJahr"] = this.endJahr;
        data["ergebnisVvvJ_soll"] = this.ergebnisVvvJ_soll;
        data["ergebnisVvvJ_haben"] = this.ergebnisVvvJ_haben;
        data["ergebnisVvJ_soll"] = this.ergebnisVvJ_soll;
        data["ergebnisVvJ_haben"] = this.ergebnisVvJ_haben;
        data["ansatzVJ_soll"] = this.ansatzVJ_soll;
        data["ansatzVJ_haben"] = this.ansatzVJ_haben;
        data["ansatzPj_soll"] = this.ansatzPj_soll;
        data["ansatzPj_haben"] = this.ansatzPj_haben;
        data["ansatzPj1_soll"] = this.ansatzPj1_soll;
        data["ansatzPj1_haben"] = this.ansatzPj1_haben;
        data["fp1_soll"] = this.fp1_soll;
        data["fp1_haben"] = this.fp1_haben;
        data["fp2_soll"] = this.fp2_soll;
        data["fp2_haben"] = this.fp2_haben;
        data["fp3_soll"] = this.fp3_soll;
        data["fp3_haben"] = this.fp3_haben;
        data["fp4_soll"] = this.fp4_soll;
        data["fp4_haben"] = this.fp4_haben;
        data["fp5_soll"] = this.fp5_soll;
        data["fp5_haben"] = this.fp5_haben;
        data["fp6_soll"] = this.fp6_soll;
        data["fp6_haben"] = this.fp6_haben;
        data["fp7_soll"] = this.fp7_soll;
        data["fp7_haben"] = this.fp7_haben;
        data["fp8_soll"] = this.fp8_soll;
        data["fp8_haben"] = this.fp8_haben;
        data["fp9_soll"] = this.fp9_soll;
        data["fp9_haben"] = this.fp9_haben;
        data["fp10_soll"] = this.fp10_soll;
        data["fp10_haben"] = this.fp10_haben;
        data["investiert_soll"] = this.investiert_soll;
        data["investiert_haben"] = this.investiert_haben;
        data["investiertGesamt_soll"] = this.investiertGesamt_soll;
        data["investiertGesamt_haben"] = this.investiertGesamt_haben;
        data["ve_soll"] = this.ve_soll;
        data["ve_haben"] = this.ve_haben;
        data["veFj1_soll"] = this.veFj1_soll;
        data["veFj1_haben"] = this.veFj1_haben;
        data["veFj2_soll"] = this.veFj2_soll;
        data["veFj2_haben"] = this.veFj2_haben;
        data["veFj3_soll"] = this.veFj3_soll;
        data["veFj3_haben"] = this.veFj3_haben;
        data["veFj4_soll"] = this.veFj4_soll;
        data["veFj4_haben"] = this.veFj4_haben;
        data["veFj5_soll"] = this.veFj5_soll;
        data["veFj5_haben"] = this.veFj5_haben;
        data["ve1_soll"] = this.ve1_soll;
        data["ve1_haben"] = this.ve1_haben;
        data["ve1Fj1_soll"] = this.ve1Fj1_soll;
        data["ve1Fj1_haben"] = this.ve1Fj1_haben;
        data["ve1Fj2_soll"] = this.ve1Fj2_soll;
        data["ve1Fj2_haben"] = this.ve1Fj2_haben;
        data["ve1Fj3_soll"] = this.ve1Fj3_soll;
        data["ve1Fj3_haben"] = this.ve1Fj3_haben;
        data["ve1Fj4_soll"] = this.ve1Fj4_soll;
        data["ve1Fj4_haben"] = this.ve1Fj4_haben;
        data["ve1Fj5_soll"] = this.ve1Fj5_soll;
        data["ve1Fj5_haben"] = this.ve1Fj5_haben;
        data["ergebnisPJ_soll"] = this.ergebnisPJ_soll;
        data["ergebnisPJ_haben"] = this.ergebnisPJ_haben;
        data["verfuegtPJ_soll"] = this.verfuegtPJ_soll;
        data["verfuegtPJ_haben"] = this.verfuegtPJ_haben;
        data["ansatzPJfort_soll"] = this.ansatzPJfort_soll;
        data["ansatzPJfort_haben"] = this.ansatzPJfort_haben;
        data["ergebnisPJM1_soll"] = this.ergebnisPJM1_soll;
        data["ergebnisPJM1_haben"] = this.ergebnisPJM1_haben;
        data["ergebnisPJM2_soll"] = this.ergebnisPJM2_soll;
        data["ergebnisPJM2_haben"] = this.ergebnisPJM2_haben;
        data["ergebnisPJM3_soll"] = this.ergebnisPJM3_soll;
        data["ergebnisPJM3_haben"] = this.ergebnisPJM3_haben;
        data["ergebnisPJM4_soll"] = this.ergebnisPJM4_soll;
        data["ergebnisPJM4_haben"] = this.ergebnisPJM4_haben;
        data["aenderungPJ_soll"] = this.aenderungPJ_soll;
        data["aenderungPJ_haben"] = this.aenderungPJ_haben;
        data["hhrest_haben"] = this.hhrest_haben;
        data["abgHhrest_haben"] = this.abgHhrest_haben;
        data["seAoHhre_haben"] = this.seAoHhre_haben;
        data["auftragHr_haben"] = this.auftragHr_haben;
        data["aosollVj_haben"] = this.aosollVj_haben;
        data["aoHrHu_haben"] = this.aoHrHu_haben;
        data["ansatz_haben"] = this.ansatz_haben;
        data["nachtrag_haben"] = this.nachtrag_haben;
        data["sollueber_haben"] = this.sollueber_haben;
        data["ueplApl_haben"] = this.ueplApl_haben;
        data["seAoSoll_haben"] = this.seAoSoll_haben;
        data["auftraeg_haben"] = this.auftraeg_haben;
        data["aosollLfd_haben"] = this.aosollLfd_haben;
        data["dauerbelege_haben"] = this.dauerbelege_haben;
        data["aoSollHu_haben"] = this.aoSollHu_haben;
        data["hhrest_soll"] = this.hhrest_soll;
        data["abgHhrest_soll"] = this.abgHhrest_soll;
        data["seAoHhre_soll"] = this.seAoHhre_soll;
        data["auftragHr_soll"] = this.auftragHr_soll;
        data["aosollVj_soll"] = this.aosollVj_soll;
        data["aoHrHu_soll"] = this.aoHrHu_soll;
        data["ansatz_soll"] = this.ansatz_soll;
        data["nachtrag_soll"] = this.nachtrag_soll;
        data["sollueber_soll"] = this.sollueber_soll;
        data["ueplApl_soll"] = this.ueplApl_soll;
        data["seAoSoll_soll"] = this.seAoSoll_soll;
        data["auftraeg_soll"] = this.auftraeg_soll;
        data["aosollLfd_soll"] = this.aosollLfd_soll;
        data["dauerbelege_soll"] = this.dauerbelege_soll;
        data["aoSollHu_soll"] = this.aoSollHu_soll;
        data["ergebnisPJ_passiva"] = this.ergebnisPJ_passiva;
        data["ergebnisPJ_aktiva"] = this.ergebnisPJ_aktiva;
        data["ansatzPJfort_passiva"] = this.ansatzPJfort_passiva;
        data["ansatzPJfort_aktiva"] = this.ansatzPJfort_aktiva;
        data["ergebnisPJM1_passiva"] = this.ergebnisPJM1_passiva;
        data["ergebnisPJM1_aktiva"] = this.ergebnisPJM1_aktiva;
        data["ergebnisPJM2_passiva"] = this.ergebnisPJM2_passiva;
        data["ergebnisPJM2_aktiva"] = this.ergebnisPJM2_aktiva;
        data["ergebnisPJM3_passiva"] = this.ergebnisPJM3_passiva;
        data["ergebnisPJM3_aktiva"] = this.ergebnisPJM3_aktiva;
        data["ergebnisPJM4_passiva"] = this.ergebnisPJM4_passiva;
        data["ergebnisPJM4_aktiva"] = this.ergebnisPJM4_aktiva;
        data["aenderungPJ_passiva"] = this.aenderungPJ_passiva;
        data["aenderungPJ_aktiva"] = this.aenderungPJ_aktiva;
        if (Array.isArray(this.unterEbenen)) {
            data["unterEbenen"] = [];
            for (let item of this.unterEbenen)
                data["unterEbenen"].push(item.toJSON());
        }
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        if (Array.isArray(this.texte)) {
            data["texte"] = [];
            for (let item of this.texte)
                data["texte"].push(item.toJSON());
        }
        data["containsData"] = this.containsData;
        data["containsEinnahmen"] = this.containsEinnahmen;
        data["containsAusgaben"] = this.containsAusgaben;
        return data;
    }
}

export interface IHaushaltsEbeneDoppik {
    cacheLoc?: string | undefined;
    id?: string | undefined;
    hasVJErg?: boolean;
    verbergen?: boolean;
    ebenenNr?: number | undefined;
    ebenenStellen?: number | undefined;
    ebenen?: string[] | undefined;
    produkt?: number;
    produktStellen?: number;
    produktEbene?: string | undefined;
    massnahme?: string | undefined;
    investNr?: string | undefined;
    bestandsKonto?: string | undefined;
    bestandsKontoText?: string | undefined;
    isErfolgsKonto?: boolean;
    investPos?: number;
    investPosText?: string | undefined;
    teilhaushalt?: string | undefined;
    konto?: number;
    kontoStellen?: number;
    bezeichnung?: string | undefined;
    produktText?: string | undefined;
    kontoText?: string | undefined;
    beschreibung?: string | undefined;
    beginnJahr?: number | undefined;
    endJahr?: number | undefined;
    ergebnisVvvJ_soll?: number;
    ergebnisVvvJ_haben?: number;
    ergebnisVvJ_soll?: number;
    ergebnisVvJ_haben?: number;
    ansatzVJ_soll?: number;
    ansatzVJ_haben?: number;
    ansatzPj_soll?: number;
    ansatzPj_haben?: number;
    ansatzPj1_soll?: number;
    ansatzPj1_haben?: number;
    fp1_soll?: number;
    fp1_haben?: number;
    fp2_soll?: number;
    fp2_haben?: number;
    fp3_soll?: number;
    fp3_haben?: number;
    fp4_soll?: number;
    fp4_haben?: number;
    fp5_soll?: number;
    fp5_haben?: number;
    fp6_soll?: number;
    fp6_haben?: number;
    fp7_soll?: number;
    fp7_haben?: number;
    fp8_soll?: number;
    fp8_haben?: number;
    fp9_soll?: number;
    fp9_haben?: number;
    fp10_soll?: number;
    fp10_haben?: number;
    investiert_soll?: number;
    investiert_haben?: number;
    investiertGesamt_soll?: number;
    investiertGesamt_haben?: number;
    ve_soll?: number;
    ve_haben?: number;
    veFj1_soll?: number;
    veFj1_haben?: number;
    veFj2_soll?: number;
    veFj2_haben?: number;
    veFj3_soll?: number;
    veFj3_haben?: number;
    veFj4_soll?: number;
    veFj4_haben?: number;
    veFj5_soll?: number;
    veFj5_haben?: number;
    ve1_soll?: number;
    ve1_haben?: number;
    ve1Fj1_soll?: number;
    ve1Fj1_haben?: number;
    ve1Fj2_soll?: number;
    ve1Fj2_haben?: number;
    ve1Fj3_soll?: number;
    ve1Fj3_haben?: number;
    ve1Fj4_soll?: number;
    ve1Fj4_haben?: number;
    ve1Fj5_soll?: number;
    ve1Fj5_haben?: number;
    ergebnisPJ_soll?: number;
    ergebnisPJ_haben?: number;
    verfuegtPJ_soll?: number;
    verfuegtPJ_haben?: number;
    ansatzPJfort_soll?: number;
    ansatzPJfort_haben?: number;
    ergebnisPJM1_soll?: number;
    ergebnisPJM1_haben?: number;
    ergebnisPJM2_soll?: number;
    ergebnisPJM2_haben?: number;
    ergebnisPJM3_soll?: number;
    ergebnisPJM3_haben?: number;
    ergebnisPJM4_soll?: number;
    ergebnisPJM4_haben?: number;
    aenderungPJ_soll?: number;
    aenderungPJ_haben?: number;
    hhrest_haben?: number;
    abgHhrest_haben?: number;
    seAoHhre_haben?: number;
    auftragHr_haben?: number;
    aosollVj_haben?: number;
    aoHrHu_haben?: number;
    ansatz_haben?: number;
    nachtrag_haben?: number;
    sollueber_haben?: number;
    ueplApl_haben?: number;
    seAoSoll_haben?: number;
    auftraeg_haben?: number;
    aosollLfd_haben?: number;
    dauerbelege_haben?: number;
    aoSollHu_haben?: number;
    hhrest_soll?: number;
    abgHhrest_soll?: number;
    seAoHhre_soll?: number;
    auftragHr_soll?: number;
    aosollVj_soll?: number;
    aoHrHu_soll?: number;
    ansatz_soll?: number;
    nachtrag_soll?: number;
    sollueber_soll?: number;
    ueplApl_soll?: number;
    seAoSoll_soll?: number;
    auftraeg_soll?: number;
    aosollLfd_soll?: number;
    dauerbelege_soll?: number;
    aoSollHu_soll?: number;
    ergebnisPJ_passiva?: number;
    ergebnisPJ_aktiva?: number;
    ansatzPJfort_passiva?: number;
    ansatzPJfort_aktiva?: number;
    ergebnisPJM1_passiva?: number;
    ergebnisPJM1_aktiva?: number;
    ergebnisPJM2_passiva?: number;
    ergebnisPJM2_aktiva?: number;
    ergebnisPJM3_passiva?: number;
    ergebnisPJM3_aktiva?: number;
    ergebnisPJM4_passiva?: number;
    ergebnisPJM4_aktiva?: number;
    aenderungPJ_passiva?: number;
    aenderungPJ_aktiva?: number;
    unterEbenen?: HaushaltsEbeneDoppik[] | undefined;
    filter?: HaushaltsEbeneDoppik;
    texte?: Texte[] | undefined;
    containsData?: boolean;
    containsEinnahmen?: boolean;
    containsAusgaben?: boolean;
}

export class HaushaltsGrafik implements IHaushaltsGrafik {
    typ?: GrafikTyp;
    anzeigeBedingung?: string | undefined;
    anzeigen?: boolean;
    jahr?: number;
    bezeichnung?: string | undefined;
    reihen?: Reihe[] | undefined;
    unterGrafiken?: HaushaltsGrafik[] | undefined;

    constructor(data?: IHaushaltsGrafik) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typ = _data["typ"];
            this.anzeigeBedingung = _data["anzeigeBedingung"];
            this.anzeigen = _data["anzeigen"];
            this.jahr = _data["jahr"];
            this.bezeichnung = _data["bezeichnung"];
            if (Array.isArray(_data["reihen"])) {
                this.reihen = [] as any;
                for (let item of _data["reihen"])
                    this.reihen!.push(Reihe.fromJS(item));
            }
            if (Array.isArray(_data["unterGrafiken"])) {
                this.unterGrafiken = [] as any;
                for (let item of _data["unterGrafiken"])
                    this.unterGrafiken!.push(HaushaltsGrafik.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HaushaltsGrafik {
        data = typeof data === 'object' ? data : {};
        let result = new HaushaltsGrafik();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typ"] = this.typ;
        data["anzeigeBedingung"] = this.anzeigeBedingung;
        data["anzeigen"] = this.anzeigen;
        data["jahr"] = this.jahr;
        data["bezeichnung"] = this.bezeichnung;
        if (Array.isArray(this.reihen)) {
            data["reihen"] = [];
            for (let item of this.reihen)
                data["reihen"].push(item.toJSON());
        }
        if (Array.isArray(this.unterGrafiken)) {
            data["unterGrafiken"] = [];
            for (let item of this.unterGrafiken)
                data["unterGrafiken"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHaushaltsGrafik {
    typ?: GrafikTyp;
    anzeigeBedingung?: string | undefined;
    anzeigen?: boolean;
    jahr?: number;
    bezeichnung?: string | undefined;
    reihen?: Reihe[] | undefined;
    unterGrafiken?: HaushaltsGrafik[] | undefined;
}

export class HaushaltsHiearchieDoppik implements IHaushaltsHiearchieDoppik {
    id?: string | undefined;
    containsData?: boolean;
    jahre?: number[] | undefined;
    hasVJErg?: boolean;
    ausgaben?: boolean;
    ergebnis?: boolean;
    inkludierteKonten?: string | undefined;
    exkludierteKonten?: string | undefined;
    subtraktionsKonten?: string | undefined;
    verbergen?: boolean;
    ebene?: Ebenen;
    ebenenId?: string | undefined;
    ebenenNr?: number | undefined;
    ebenenStellen?: number | undefined;
    produkt?: number;
    produktStellen?: number;
    konto?: number;
    kontoStellen?: number;
    bezeichnung?: string | undefined;
    produktText?: string | undefined;
    kontoText?: string | undefined;
    beschreibung?: string | undefined;
    beginnJahr?: number | undefined;
    endJahr?: number | undefined;
    summenHH?: HaushaltSummiert;
    unterEbenen?: HaushaltsHiearchieDoppik[] | undefined;
    filter?: HaushaltsSummeDoppik;
    selected?: boolean;
    texte?: Texte[] | undefined;

    constructor(data?: IHaushaltsHiearchieDoppik) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.containsData = _data["containsData"];
            if (Array.isArray(_data["jahre"])) {
                this.jahre = [] as any;
                for (let item of _data["jahre"])
                    this.jahre!.push(item);
            }
            this.hasVJErg = _data["hasVJErg"];
            this.ausgaben = _data["ausgaben"];
            this.ergebnis = _data["ergebnis"];
            this.inkludierteKonten = _data["inkludierteKonten"];
            this.exkludierteKonten = _data["exkludierteKonten"];
            this.subtraktionsKonten = _data["subtraktionsKonten"];
            this.verbergen = _data["verbergen"];
            this.ebene = _data["ebene"] ? Ebenen.fromJS(_data["ebene"]) : <any>undefined;
            this.ebenenId = _data["ebenenId"];
            this.ebenenNr = _data["ebenenNr"];
            this.ebenenStellen = _data["ebenenStellen"];
            this.produkt = _data["produkt"];
            this.produktStellen = _data["produktStellen"];
            this.konto = _data["konto"];
            this.kontoStellen = _data["kontoStellen"];
            this.bezeichnung = _data["bezeichnung"];
            this.produktText = _data["produktText"];
            this.kontoText = _data["kontoText"];
            this.beschreibung = _data["beschreibung"];
            this.beginnJahr = _data["beginnJahr"];
            this.endJahr = _data["endJahr"];
            this.summenHH = _data["summenHH"] ? HaushaltSummiert.fromJS(_data["summenHH"]) : <any>undefined;
            if (Array.isArray(_data["unterEbenen"])) {
                this.unterEbenen = [] as any;
                for (let item of _data["unterEbenen"])
                    this.unterEbenen!.push(HaushaltsHiearchieDoppik.fromJS(item));
            }
            this.filter = _data["filter"] ? HaushaltsSummeDoppik.fromJS(_data["filter"]) : <any>undefined;
            this.selected = _data["selected"];
            if (Array.isArray(_data["texte"])) {
                this.texte = [] as any;
                for (let item of _data["texte"])
                    this.texte!.push(Texte.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HaushaltsHiearchieDoppik {
        data = typeof data === 'object' ? data : {};
        let result = new HaushaltsHiearchieDoppik();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["containsData"] = this.containsData;
        if (Array.isArray(this.jahre)) {
            data["jahre"] = [];
            for (let item of this.jahre)
                data["jahre"].push(item);
        }
        data["hasVJErg"] = this.hasVJErg;
        data["ausgaben"] = this.ausgaben;
        data["ergebnis"] = this.ergebnis;
        data["inkludierteKonten"] = this.inkludierteKonten;
        data["exkludierteKonten"] = this.exkludierteKonten;
        data["subtraktionsKonten"] = this.subtraktionsKonten;
        data["verbergen"] = this.verbergen;
        data["ebene"] = this.ebene ? this.ebene.toJSON() : <any>undefined;
        data["ebenenId"] = this.ebenenId;
        data["ebenenNr"] = this.ebenenNr;
        data["ebenenStellen"] = this.ebenenStellen;
        data["produkt"] = this.produkt;
        data["produktStellen"] = this.produktStellen;
        data["konto"] = this.konto;
        data["kontoStellen"] = this.kontoStellen;
        data["bezeichnung"] = this.bezeichnung;
        data["produktText"] = this.produktText;
        data["kontoText"] = this.kontoText;
        data["beschreibung"] = this.beschreibung;
        data["beginnJahr"] = this.beginnJahr;
        data["endJahr"] = this.endJahr;
        data["summenHH"] = this.summenHH ? this.summenHH.toJSON() : <any>undefined;
        if (Array.isArray(this.unterEbenen)) {
            data["unterEbenen"] = [];
            for (let item of this.unterEbenen)
                data["unterEbenen"].push(item.toJSON());
        }
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["selected"] = this.selected;
        if (Array.isArray(this.texte)) {
            data["texte"] = [];
            for (let item of this.texte)
                data["texte"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHaushaltsHiearchieDoppik {
    id?: string | undefined;
    containsData?: boolean;
    jahre?: number[] | undefined;
    hasVJErg?: boolean;
    ausgaben?: boolean;
    ergebnis?: boolean;
    inkludierteKonten?: string | undefined;
    exkludierteKonten?: string | undefined;
    subtraktionsKonten?: string | undefined;
    verbergen?: boolean;
    ebene?: Ebenen;
    ebenenId?: string | undefined;
    ebenenNr?: number | undefined;
    ebenenStellen?: number | undefined;
    produkt?: number;
    produktStellen?: number;
    konto?: number;
    kontoStellen?: number;
    bezeichnung?: string | undefined;
    produktText?: string | undefined;
    kontoText?: string | undefined;
    beschreibung?: string | undefined;
    beginnJahr?: number | undefined;
    endJahr?: number | undefined;
    summenHH?: HaushaltSummiert;
    unterEbenen?: HaushaltsHiearchieDoppik[] | undefined;
    filter?: HaushaltsSummeDoppik;
    selected?: boolean;
    texte?: Texte[] | undefined;
}

export class HaushaltsSetting implements IHaushaltsSetting {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    sucheInHhaufgaben?: boolean;
    sucheInHhkonten?: boolean;
    hhstellenOeffentlich?: boolean | undefined;
    hhinvert?: string | undefined;
    hhstellenOeffentlichVerwaltung?: boolean | undefined;
    sucheInMnAufgaben?: boolean | undefined;
    ukalsMnVw?: boolean | undefined;
    ukalsMnVm?: boolean | undefined;
    erlNichtJr?: boolean | undefined;
    erlNichtHp?: boolean | undefined;

    constructor(data?: IHaushaltsSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.sucheInHhaufgaben = _data["sucheInHhaufgaben"];
            this.sucheInHhkonten = _data["sucheInHhkonten"];
            this.hhstellenOeffentlich = _data["hhstellenOeffentlich"];
            this.hhinvert = _data["hhinvert"];
            this.hhstellenOeffentlichVerwaltung = _data["hhstellenOeffentlichVerwaltung"];
            this.sucheInMnAufgaben = _data["sucheInMnAufgaben"];
            this.ukalsMnVw = _data["ukalsMnVw"];
            this.ukalsMnVm = _data["ukalsMnVm"];
            this.erlNichtJr = _data["erlNichtJr"];
            this.erlNichtHp = _data["erlNichtHp"];
        }
    }

    static fromJS(data: any): HaushaltsSetting {
        data = typeof data === 'object' ? data : {};
        let result = new HaushaltsSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["sucheInHhaufgaben"] = this.sucheInHhaufgaben;
        data["sucheInHhkonten"] = this.sucheInHhkonten;
        data["hhstellenOeffentlich"] = this.hhstellenOeffentlich;
        data["hhinvert"] = this.hhinvert;
        data["hhstellenOeffentlichVerwaltung"] = this.hhstellenOeffentlichVerwaltung;
        data["sucheInMnAufgaben"] = this.sucheInMnAufgaben;
        data["ukalsMnVw"] = this.ukalsMnVw;
        data["ukalsMnVm"] = this.ukalsMnVm;
        data["erlNichtJr"] = this.erlNichtJr;
        data["erlNichtHp"] = this.erlNichtHp;
        return data;
    }
}

export interface IHaushaltsSetting {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    sucheInHhaufgaben?: boolean;
    sucheInHhkonten?: boolean;
    hhstellenOeffentlich?: boolean | undefined;
    hhinvert?: string | undefined;
    hhstellenOeffentlichVerwaltung?: boolean | undefined;
    sucheInMnAufgaben?: boolean | undefined;
    ukalsMnVw?: boolean | undefined;
    ukalsMnVm?: boolean | undefined;
    erlNichtJr?: boolean | undefined;
    erlNichtHp?: boolean | undefined;
}

export class HaushaltsSummeDoppik implements IHaushaltsSummeDoppik {
    id?: string | undefined;
    readonly containsData?: boolean;
    ausgaben?: boolean;
    ergebnis?: boolean;
    verbergen?: boolean;
    ebenenNr?: number | undefined;
    ebenenStellen?: number | undefined;
    produkt?: number;
    produktStellen?: number;
    produktEbene?: string | undefined;
    investNr?: string | undefined;
    konto?: number;
    kontoStellen?: number;
    bezeichnung?: string | undefined;
    produktText?: string | undefined;
    kontoText?: string | undefined;
    beschreibung?: string | undefined;
    beginnJahr?: number | undefined;
    endJahr?: number | undefined;
    ergebnisVvvJ?: number;
    ergebnisVvJ?: number;
    ansatzVJ?: number;
    ansatzPj?: number;
    ansatzPj1?: number;
    fp1?: number;
    fp2?: number;
    fp3?: number;
    fp4?: number;
    fp5?: number;
    fp6?: number;
    fp7?: number;
    fp8?: number;
    fp9?: number;
    fp10?: number;
    ansatzPj_vgl?: number;
    fp1_vgl?: number;
    fp2_vgl?: number;
    fp3_vgl?: number;
    fp4_vgl?: number;
    ergebnisPJ?: number;
    aenderungPJ?: number;
    ansatzPJfort?: number;
    ergebnisPJM1?: number;
    ergebnisPJM2?: number;
    ergebnisPJM3?: number;
    ergebnisPJM4?: number;
    unterEbenen?: HaushaltsSummeDoppik[] | undefined;
    filter?: HaushaltsSummeDoppik;
    texte?: Texte[] | undefined;
    ansatzPJfortPJM1?: number;
    verfuegtPJM1?: number;
    istAo?: number;
    verfuegt?: number;
    verfuegbar?: number;
    progAuto?: number;
    progMan?: number | undefined;
    hasProgMan?: number;
    progKomm?: string | undefined;
    pkTip?: string | undefined;
    hhrest?: number;
    abgHhrest?: number;
    seAoHhre?: number;
    auftragHr?: number;
    aosollVj?: number;
    aoHrHu?: number;
    ansatz?: number;
    nachtrag?: number;
    sollueber?: number;
    ueplApl?: number;
    seAoSoll?: number;
    auftraeg?: number;
    aosollLfd?: number;
    dauerbelege?: number;
    aoSollHu?: number;
    planHistorie?: PlanHistorieModel[] | undefined;
    planHistorieVgl?: PlanHistorieModel[] | undefined;

    constructor(data?: IHaushaltsSummeDoppik) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            (<any>this).containsData = _data["containsData"];
            this.ausgaben = _data["ausgaben"];
            this.ergebnis = _data["ergebnis"];
            this.verbergen = _data["verbergen"];
            this.ebenenNr = _data["ebenenNr"];
            this.ebenenStellen = _data["ebenenStellen"];
            this.produkt = _data["produkt"];
            this.produktStellen = _data["produktStellen"];
            this.produktEbene = _data["produktEbene"];
            this.investNr = _data["investNr"];
            this.konto = _data["konto"];
            this.kontoStellen = _data["kontoStellen"];
            this.bezeichnung = _data["bezeichnung"];
            this.produktText = _data["produktText"];
            this.kontoText = _data["kontoText"];
            this.beschreibung = _data["beschreibung"];
            this.beginnJahr = _data["beginnJahr"];
            this.endJahr = _data["endJahr"];
            this.ergebnisVvvJ = _data["ergebnisVvvJ"];
            this.ergebnisVvJ = _data["ergebnisVvJ"];
            this.ansatzVJ = _data["ansatzVJ"];
            this.ansatzPj = _data["ansatzPj"];
            this.ansatzPj1 = _data["ansatzPj1"];
            this.fp1 = _data["fp1"];
            this.fp2 = _data["fp2"];
            this.fp3 = _data["fp3"];
            this.fp4 = _data["fp4"];
            this.fp5 = _data["fp5"];
            this.fp6 = _data["fp6"];
            this.fp7 = _data["fp7"];
            this.fp8 = _data["fp8"];
            this.fp9 = _data["fp9"];
            this.fp10 = _data["fp10"];
            this.ansatzPj_vgl = _data["ansatzPj_vgl"];
            this.fp1_vgl = _data["fp1_vgl"];
            this.fp2_vgl = _data["fp2_vgl"];
            this.fp3_vgl = _data["fp3_vgl"];
            this.fp4_vgl = _data["fp4_vgl"];
            this.ergebnisPJ = _data["ergebnisPJ"];
            this.aenderungPJ = _data["aenderungPJ"];
            this.ansatzPJfort = _data["ansatzPJfort"];
            this.ergebnisPJM1 = _data["ergebnisPJM1"];
            this.ergebnisPJM2 = _data["ergebnisPJM2"];
            this.ergebnisPJM3 = _data["ergebnisPJM3"];
            this.ergebnisPJM4 = _data["ergebnisPJM4"];
            if (Array.isArray(_data["unterEbenen"])) {
                this.unterEbenen = [] as any;
                for (let item of _data["unterEbenen"])
                    this.unterEbenen!.push(HaushaltsSummeDoppik.fromJS(item));
            }
            this.filter = _data["filter"] ? HaushaltsSummeDoppik.fromJS(_data["filter"]) : <any>undefined;
            if (Array.isArray(_data["texte"])) {
                this.texte = [] as any;
                for (let item of _data["texte"])
                    this.texte!.push(Texte.fromJS(item));
            }
            this.ansatzPJfortPJM1 = _data["ansatzPJfortPJM1"];
            this.verfuegtPJM1 = _data["verfuegtPJM1"];
            this.istAo = _data["istAo"];
            this.verfuegt = _data["verfuegt"];
            this.verfuegbar = _data["verfuegbar"];
            this.progAuto = _data["progAuto"];
            this.progMan = _data["progMan"];
            this.hasProgMan = _data["hasProgMan"];
            this.progKomm = _data["progKomm"];
            this.pkTip = _data["pkTip"];
            this.hhrest = _data["hhrest"];
            this.abgHhrest = _data["abgHhrest"];
            this.seAoHhre = _data["seAoHhre"];
            this.auftragHr = _data["auftragHr"];
            this.aosollVj = _data["aosollVj"];
            this.aoHrHu = _data["aoHrHu"];
            this.ansatz = _data["ansatz"];
            this.nachtrag = _data["nachtrag"];
            this.sollueber = _data["sollueber"];
            this.ueplApl = _data["ueplApl"];
            this.seAoSoll = _data["seAoSoll"];
            this.auftraeg = _data["auftraeg"];
            this.aosollLfd = _data["aosollLfd"];
            this.dauerbelege = _data["dauerbelege"];
            this.aoSollHu = _data["aoSollHu"];
            if (Array.isArray(_data["planHistorie"])) {
                this.planHistorie = [] as any;
                for (let item of _data["planHistorie"])
                    this.planHistorie!.push(PlanHistorieModel.fromJS(item));
            }
            if (Array.isArray(_data["planHistorieVgl"])) {
                this.planHistorieVgl = [] as any;
                for (let item of _data["planHistorieVgl"])
                    this.planHistorieVgl!.push(PlanHistorieModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HaushaltsSummeDoppik {
        data = typeof data === 'object' ? data : {};
        let result = new HaushaltsSummeDoppik();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["containsData"] = this.containsData;
        data["ausgaben"] = this.ausgaben;
        data["ergebnis"] = this.ergebnis;
        data["verbergen"] = this.verbergen;
        data["ebenenNr"] = this.ebenenNr;
        data["ebenenStellen"] = this.ebenenStellen;
        data["produkt"] = this.produkt;
        data["produktStellen"] = this.produktStellen;
        data["produktEbene"] = this.produktEbene;
        data["investNr"] = this.investNr;
        data["konto"] = this.konto;
        data["kontoStellen"] = this.kontoStellen;
        data["bezeichnung"] = this.bezeichnung;
        data["produktText"] = this.produktText;
        data["kontoText"] = this.kontoText;
        data["beschreibung"] = this.beschreibung;
        data["beginnJahr"] = this.beginnJahr;
        data["endJahr"] = this.endJahr;
        data["ergebnisVvvJ"] = this.ergebnisVvvJ;
        data["ergebnisVvJ"] = this.ergebnisVvJ;
        data["ansatzVJ"] = this.ansatzVJ;
        data["ansatzPj"] = this.ansatzPj;
        data["ansatzPj1"] = this.ansatzPj1;
        data["fp1"] = this.fp1;
        data["fp2"] = this.fp2;
        data["fp3"] = this.fp3;
        data["fp4"] = this.fp4;
        data["fp5"] = this.fp5;
        data["fp6"] = this.fp6;
        data["fp7"] = this.fp7;
        data["fp8"] = this.fp8;
        data["fp9"] = this.fp9;
        data["fp10"] = this.fp10;
        data["ansatzPj_vgl"] = this.ansatzPj_vgl;
        data["fp1_vgl"] = this.fp1_vgl;
        data["fp2_vgl"] = this.fp2_vgl;
        data["fp3_vgl"] = this.fp3_vgl;
        data["fp4_vgl"] = this.fp4_vgl;
        data["ergebnisPJ"] = this.ergebnisPJ;
        data["aenderungPJ"] = this.aenderungPJ;
        data["ansatzPJfort"] = this.ansatzPJfort;
        data["ergebnisPJM1"] = this.ergebnisPJM1;
        data["ergebnisPJM2"] = this.ergebnisPJM2;
        data["ergebnisPJM3"] = this.ergebnisPJM3;
        data["ergebnisPJM4"] = this.ergebnisPJM4;
        if (Array.isArray(this.unterEbenen)) {
            data["unterEbenen"] = [];
            for (let item of this.unterEbenen)
                data["unterEbenen"].push(item.toJSON());
        }
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        if (Array.isArray(this.texte)) {
            data["texte"] = [];
            for (let item of this.texte)
                data["texte"].push(item.toJSON());
        }
        data["ansatzPJfortPJM1"] = this.ansatzPJfortPJM1;
        data["verfuegtPJM1"] = this.verfuegtPJM1;
        data["istAo"] = this.istAo;
        data["verfuegt"] = this.verfuegt;
        data["verfuegbar"] = this.verfuegbar;
        data["progAuto"] = this.progAuto;
        data["progMan"] = this.progMan;
        data["hasProgMan"] = this.hasProgMan;
        data["progKomm"] = this.progKomm;
        data["pkTip"] = this.pkTip;
        data["hhrest"] = this.hhrest;
        data["abgHhrest"] = this.abgHhrest;
        data["seAoHhre"] = this.seAoHhre;
        data["auftragHr"] = this.auftragHr;
        data["aosollVj"] = this.aosollVj;
        data["aoHrHu"] = this.aoHrHu;
        data["ansatz"] = this.ansatz;
        data["nachtrag"] = this.nachtrag;
        data["sollueber"] = this.sollueber;
        data["ueplApl"] = this.ueplApl;
        data["seAoSoll"] = this.seAoSoll;
        data["auftraeg"] = this.auftraeg;
        data["aosollLfd"] = this.aosollLfd;
        data["dauerbelege"] = this.dauerbelege;
        data["aoSollHu"] = this.aoSollHu;
        if (Array.isArray(this.planHistorie)) {
            data["planHistorie"] = [];
            for (let item of this.planHistorie)
                data["planHistorie"].push(item.toJSON());
        }
        if (Array.isArray(this.planHistorieVgl)) {
            data["planHistorieVgl"] = [];
            for (let item of this.planHistorieVgl)
                data["planHistorieVgl"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHaushaltsSummeDoppik {
    id?: string | undefined;
    containsData?: boolean;
    ausgaben?: boolean;
    ergebnis?: boolean;
    verbergen?: boolean;
    ebenenNr?: number | undefined;
    ebenenStellen?: number | undefined;
    produkt?: number;
    produktStellen?: number;
    produktEbene?: string | undefined;
    investNr?: string | undefined;
    konto?: number;
    kontoStellen?: number;
    bezeichnung?: string | undefined;
    produktText?: string | undefined;
    kontoText?: string | undefined;
    beschreibung?: string | undefined;
    beginnJahr?: number | undefined;
    endJahr?: number | undefined;
    ergebnisVvvJ?: number;
    ergebnisVvJ?: number;
    ansatzVJ?: number;
    ansatzPj?: number;
    ansatzPj1?: number;
    fp1?: number;
    fp2?: number;
    fp3?: number;
    fp4?: number;
    fp5?: number;
    fp6?: number;
    fp7?: number;
    fp8?: number;
    fp9?: number;
    fp10?: number;
    ansatzPj_vgl?: number;
    fp1_vgl?: number;
    fp2_vgl?: number;
    fp3_vgl?: number;
    fp4_vgl?: number;
    ergebnisPJ?: number;
    aenderungPJ?: number;
    ansatzPJfort?: number;
    ergebnisPJM1?: number;
    ergebnisPJM2?: number;
    ergebnisPJM3?: number;
    ergebnisPJM4?: number;
    unterEbenen?: HaushaltsSummeDoppik[] | undefined;
    filter?: HaushaltsSummeDoppik;
    texte?: Texte[] | undefined;
    ansatzPJfortPJM1?: number;
    verfuegtPJM1?: number;
    istAo?: number;
    verfuegt?: number;
    verfuegbar?: number;
    progAuto?: number;
    progMan?: number | undefined;
    hasProgMan?: number;
    progKomm?: string | undefined;
    pkTip?: string | undefined;
    hhrest?: number;
    abgHhrest?: number;
    seAoHhre?: number;
    auftragHr?: number;
    aosollVj?: number;
    aoHrHu?: number;
    ansatz?: number;
    nachtrag?: number;
    sollueber?: number;
    ueplApl?: number;
    seAoSoll?: number;
    auftraeg?: number;
    aosollLfd?: number;
    dauerbelege?: number;
    aoSollHu?: number;
    planHistorie?: PlanHistorieModel[] | undefined;
    planHistorieVgl?: PlanHistorieModel[] | undefined;
}

export class HaushaltsSummenTemplate implements IHaushaltsSummenTemplate {
    bezZeilen?: string | undefined;
    zeilen?: HaushaltsZeilenTemplate[] | undefined;
    grafiken?: HaushaltsGrafik[] | undefined;

    constructor(data?: IHaushaltsSummenTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bezZeilen = _data["bezZeilen"];
            if (Array.isArray(_data["zeilen"])) {
                this.zeilen = [] as any;
                for (let item of _data["zeilen"])
                    this.zeilen!.push(HaushaltsZeilenTemplate.fromJS(item));
            }
            if (Array.isArray(_data["grafiken"])) {
                this.grafiken = [] as any;
                for (let item of _data["grafiken"])
                    this.grafiken!.push(HaushaltsGrafik.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HaushaltsSummenTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new HaushaltsSummenTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bezZeilen"] = this.bezZeilen;
        if (Array.isArray(this.zeilen)) {
            data["zeilen"] = [];
            for (let item of this.zeilen)
                data["zeilen"].push(item.toJSON());
        }
        if (Array.isArray(this.grafiken)) {
            data["grafiken"] = [];
            for (let item of this.grafiken)
                data["grafiken"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHaushaltsSummenTemplate {
    bezZeilen?: string | undefined;
    zeilen?: HaushaltsZeilenTemplate[] | undefined;
    grafiken?: HaushaltsGrafik[] | undefined;
}

export class HaushaltsTemplate implements IHaushaltsTemplate {
    id?: number;
    typ?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    bundesland?: string | undefined;
    haushalt?: HaushaltsSummenTemplate;

    constructor(data?: IHaushaltsTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.typ = _data["typ"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.bezeichnung = _data["bezeichnung"];
            this.bundesland = _data["bundesland"];
            this.haushalt = _data["haushalt"] ? HaushaltsSummenTemplate.fromJS(_data["haushalt"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HaushaltsTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new HaushaltsTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["typ"] = this.typ;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["bezeichnung"] = this.bezeichnung;
        data["bundesland"] = this.bundesland;
        data["haushalt"] = this.haushalt ? this.haushalt.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHaushaltsTemplate {
    id?: number;
    typ?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    bundesland?: string | undefined;
    haushalt?: HaushaltsSummenTemplate;
}

export class HaushaltsZeile implements IHaushaltsZeile {
    id?: string | undefined;
    readonly containsData?: boolean;
    readonly hasChanged?: boolean;
    details?: HaushaltsZeilenDetails;
    changeFlag?: boolean;
    zeile?: string | undefined;
    verbergen?: boolean;
    bezeichnung?: string | undefined;
    opZeichen?: string | undefined;
    unterzeilen?: string[] | undefined;
    benutzteZeilen?: string[] | undefined;
    summenZeile?: boolean;
    summenTiefe?: number;
    ausgaben?: boolean;
    ergebnisVvvJ?: number;
    ergebnisVvJ?: number;
    ansatzVJ?: number;
    ansatzPj?: number;
    ansatzPj1?: number;
    fp1?: number;
    fp2?: number;
    fp3?: number;
    fp4?: number;
    fp5?: number;
    fp6?: number;
    fp7?: number;
    fp8?: number;
    fp9?: number;
    fp10?: number;
    ansatzPj_vgl?: number;
    fp1_vgl?: number;
    fp2_vgl?: number;
    fp3_vgl?: number;
    fp4_vgl?: number;
    ergebnisPJ?: number;
    ansatzPJfort?: number;
    ergebnisPJM1?: number;
    ergebnisPJM2?: number;
    ergebnisPJM3?: number;
    ergebnisPJM4?: number;
    restePJ?: number;
    aenderungPJ?: number;
    istAo?: number;
    verfuegt?: number;
    verfuegbar?: number;
    progAuto?: number;
    progMan?: number | undefined;
    hasProgMan?: number;
    ansatzPJfortPJM1?: number;
    verfuegtPJM1?: number;
    hhrest?: number;
    abgHhrest?: number;
    seAoHhre?: number;
    auftragHr?: number;
    aosollVj?: number;
    aoHrHu?: number;
    ansatz?: number;
    nachtrag?: number;
    sollueber?: number;
    ueplApl?: number;
    seAoSoll?: number;
    auftraeg?: number;
    aosollLfd?: number;
    dauerbelege?: number;
    aoSollHu?: number;
    pseudoKontenTyp?: string | undefined;

    constructor(data?: IHaushaltsZeile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            (<any>this).containsData = _data["containsData"];
            (<any>this).hasChanged = _data["hasChanged"];
            this.details = _data["details"] ? HaushaltsZeilenDetails.fromJS(_data["details"]) : <any>undefined;
            this.changeFlag = _data["changeFlag"];
            this.zeile = _data["zeile"];
            this.verbergen = _data["verbergen"];
            this.bezeichnung = _data["bezeichnung"];
            this.opZeichen = _data["opZeichen"];
            if (Array.isArray(_data["unterzeilen"])) {
                this.unterzeilen = [] as any;
                for (let item of _data["unterzeilen"])
                    this.unterzeilen!.push(item);
            }
            if (Array.isArray(_data["benutzteZeilen"])) {
                this.benutzteZeilen = [] as any;
                for (let item of _data["benutzteZeilen"])
                    this.benutzteZeilen!.push(item);
            }
            this.summenZeile = _data["summenZeile"];
            this.summenTiefe = _data["summenTiefe"];
            this.ausgaben = _data["ausgaben"];
            this.ergebnisVvvJ = _data["ergebnisVvvJ"];
            this.ergebnisVvJ = _data["ergebnisVvJ"];
            this.ansatzVJ = _data["ansatzVJ"];
            this.ansatzPj = _data["ansatzPj"];
            this.ansatzPj1 = _data["ansatzPj1"];
            this.fp1 = _data["fp1"];
            this.fp2 = _data["fp2"];
            this.fp3 = _data["fp3"];
            this.fp4 = _data["fp4"];
            this.fp5 = _data["fp5"];
            this.fp6 = _data["fp6"];
            this.fp7 = _data["fp7"];
            this.fp8 = _data["fp8"];
            this.fp9 = _data["fp9"];
            this.fp10 = _data["fp10"];
            this.ansatzPj_vgl = _data["ansatzPj_vgl"];
            this.fp1_vgl = _data["fp1_vgl"];
            this.fp2_vgl = _data["fp2_vgl"];
            this.fp3_vgl = _data["fp3_vgl"];
            this.fp4_vgl = _data["fp4_vgl"];
            this.ergebnisPJ = _data["ergebnisPJ"];
            this.ansatzPJfort = _data["ansatzPJfort"];
            this.ergebnisPJM1 = _data["ergebnisPJM1"];
            this.ergebnisPJM2 = _data["ergebnisPJM2"];
            this.ergebnisPJM3 = _data["ergebnisPJM3"];
            this.ergebnisPJM4 = _data["ergebnisPJM4"];
            this.restePJ = _data["restePJ"];
            this.aenderungPJ = _data["aenderungPJ"];
            this.istAo = _data["istAo"];
            this.verfuegt = _data["verfuegt"];
            this.verfuegbar = _data["verfuegbar"];
            this.progAuto = _data["progAuto"];
            this.progMan = _data["progMan"];
            this.hasProgMan = _data["hasProgMan"];
            this.ansatzPJfortPJM1 = _data["ansatzPJfortPJM1"];
            this.verfuegtPJM1 = _data["verfuegtPJM1"];
            this.hhrest = _data["hhrest"];
            this.abgHhrest = _data["abgHhrest"];
            this.seAoHhre = _data["seAoHhre"];
            this.auftragHr = _data["auftragHr"];
            this.aosollVj = _data["aosollVj"];
            this.aoHrHu = _data["aoHrHu"];
            this.ansatz = _data["ansatz"];
            this.nachtrag = _data["nachtrag"];
            this.sollueber = _data["sollueber"];
            this.ueplApl = _data["ueplApl"];
            this.seAoSoll = _data["seAoSoll"];
            this.auftraeg = _data["auftraeg"];
            this.aosollLfd = _data["aosollLfd"];
            this.dauerbelege = _data["dauerbelege"];
            this.aoSollHu = _data["aoSollHu"];
            this.pseudoKontenTyp = _data["pseudoKontenTyp"];
        }
    }

    static fromJS(data: any): HaushaltsZeile {
        data = typeof data === 'object' ? data : {};
        let result = new HaushaltsZeile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["containsData"] = this.containsData;
        data["hasChanged"] = this.hasChanged;
        data["details"] = this.details ? this.details.toJSON() : <any>undefined;
        data["changeFlag"] = this.changeFlag;
        data["zeile"] = this.zeile;
        data["verbergen"] = this.verbergen;
        data["bezeichnung"] = this.bezeichnung;
        data["opZeichen"] = this.opZeichen;
        if (Array.isArray(this.unterzeilen)) {
            data["unterzeilen"] = [];
            for (let item of this.unterzeilen)
                data["unterzeilen"].push(item);
        }
        if (Array.isArray(this.benutzteZeilen)) {
            data["benutzteZeilen"] = [];
            for (let item of this.benutzteZeilen)
                data["benutzteZeilen"].push(item);
        }
        data["summenZeile"] = this.summenZeile;
        data["summenTiefe"] = this.summenTiefe;
        data["ausgaben"] = this.ausgaben;
        data["ergebnisVvvJ"] = this.ergebnisVvvJ;
        data["ergebnisVvJ"] = this.ergebnisVvJ;
        data["ansatzVJ"] = this.ansatzVJ;
        data["ansatzPj"] = this.ansatzPj;
        data["ansatzPj1"] = this.ansatzPj1;
        data["fp1"] = this.fp1;
        data["fp2"] = this.fp2;
        data["fp3"] = this.fp3;
        data["fp4"] = this.fp4;
        data["fp5"] = this.fp5;
        data["fp6"] = this.fp6;
        data["fp7"] = this.fp7;
        data["fp8"] = this.fp8;
        data["fp9"] = this.fp9;
        data["fp10"] = this.fp10;
        data["ansatzPj_vgl"] = this.ansatzPj_vgl;
        data["fp1_vgl"] = this.fp1_vgl;
        data["fp2_vgl"] = this.fp2_vgl;
        data["fp3_vgl"] = this.fp3_vgl;
        data["fp4_vgl"] = this.fp4_vgl;
        data["ergebnisPJ"] = this.ergebnisPJ;
        data["ansatzPJfort"] = this.ansatzPJfort;
        data["ergebnisPJM1"] = this.ergebnisPJM1;
        data["ergebnisPJM2"] = this.ergebnisPJM2;
        data["ergebnisPJM3"] = this.ergebnisPJM3;
        data["ergebnisPJM4"] = this.ergebnisPJM4;
        data["restePJ"] = this.restePJ;
        data["aenderungPJ"] = this.aenderungPJ;
        data["istAo"] = this.istAo;
        data["verfuegt"] = this.verfuegt;
        data["verfuegbar"] = this.verfuegbar;
        data["progAuto"] = this.progAuto;
        data["progMan"] = this.progMan;
        data["hasProgMan"] = this.hasProgMan;
        data["ansatzPJfortPJM1"] = this.ansatzPJfortPJM1;
        data["verfuegtPJM1"] = this.verfuegtPJM1;
        data["hhrest"] = this.hhrest;
        data["abgHhrest"] = this.abgHhrest;
        data["seAoHhre"] = this.seAoHhre;
        data["auftragHr"] = this.auftragHr;
        data["aosollVj"] = this.aosollVj;
        data["aoHrHu"] = this.aoHrHu;
        data["ansatz"] = this.ansatz;
        data["nachtrag"] = this.nachtrag;
        data["sollueber"] = this.sollueber;
        data["ueplApl"] = this.ueplApl;
        data["seAoSoll"] = this.seAoSoll;
        data["auftraeg"] = this.auftraeg;
        data["aosollLfd"] = this.aosollLfd;
        data["dauerbelege"] = this.dauerbelege;
        data["aoSollHu"] = this.aoSollHu;
        data["pseudoKontenTyp"] = this.pseudoKontenTyp;
        return data;
    }
}

export interface IHaushaltsZeile {
    id?: string | undefined;
    containsData?: boolean;
    hasChanged?: boolean;
    details?: HaushaltsZeilenDetails;
    changeFlag?: boolean;
    zeile?: string | undefined;
    verbergen?: boolean;
    bezeichnung?: string | undefined;
    opZeichen?: string | undefined;
    unterzeilen?: string[] | undefined;
    benutzteZeilen?: string[] | undefined;
    summenZeile?: boolean;
    summenTiefe?: number;
    ausgaben?: boolean;
    ergebnisVvvJ?: number;
    ergebnisVvJ?: number;
    ansatzVJ?: number;
    ansatzPj?: number;
    ansatzPj1?: number;
    fp1?: number;
    fp2?: number;
    fp3?: number;
    fp4?: number;
    fp5?: number;
    fp6?: number;
    fp7?: number;
    fp8?: number;
    fp9?: number;
    fp10?: number;
    ansatzPj_vgl?: number;
    fp1_vgl?: number;
    fp2_vgl?: number;
    fp3_vgl?: number;
    fp4_vgl?: number;
    ergebnisPJ?: number;
    ansatzPJfort?: number;
    ergebnisPJM1?: number;
    ergebnisPJM2?: number;
    ergebnisPJM3?: number;
    ergebnisPJM4?: number;
    restePJ?: number;
    aenderungPJ?: number;
    istAo?: number;
    verfuegt?: number;
    verfuegbar?: number;
    progAuto?: number;
    progMan?: number | undefined;
    hasProgMan?: number;
    ansatzPJfortPJM1?: number;
    verfuegtPJM1?: number;
    hhrest?: number;
    abgHhrest?: number;
    seAoHhre?: number;
    auftragHr?: number;
    aosollVj?: number;
    aoHrHu?: number;
    ansatz?: number;
    nachtrag?: number;
    sollueber?: number;
    ueplApl?: number;
    seAoSoll?: number;
    auftraeg?: number;
    aosollLfd?: number;
    dauerbelege?: number;
    aoSollHu?: number;
    pseudoKontenTyp?: string | undefined;
}

export class HaushaltsZeilenDetails implements IHaushaltsZeilenDetails {
    id?: string | undefined;
    readonly containsData?: boolean;
    readonly hasChanged?: boolean;
    ausgaben?: boolean;
    unterEbenen?: HaushaltsZeilenDetails[] | undefined;
    produkt?: number;
    produktStellen?: number;
    produktEbene?: string | undefined;
    investNr?: string | undefined;
    konto?: number;
    kontoStellen?: number;
    bezeichnung?: string | undefined;
    produktText?: string | undefined;
    kontoText?: string | undefined;
    beschreibung?: string | undefined;
    suchText?: string | undefined;
    changeFlag?: boolean;
    ergebnisVvvJ?: number;
    ergebnisVvJ?: number;
    ansatzVJ?: number;
    ansatzPj?: number;
    ansatzPj1?: number;
    fp1?: number;
    fp2?: number;
    fp3?: number;
    fp4?: number;
    fp5?: number;
    fp6?: number;
    fp7?: number;
    fp8?: number;
    fp9?: number;
    fp10?: number;
    ansatzPj_vgl?: number;
    fp1_vgl?: number;
    fp2_vgl?: number;
    fp3_vgl?: number;
    fp4_vgl?: number;
    ergebnisPJ?: number;
    ansatzPJfort?: number;
    ergebnisPJM1?: number;
    ergebnisPJM2?: number;
    ergebnisPJM3?: number;
    ergebnisPJM4?: number;
    aenderungPJ?: number;
    istAo?: number;
    verfuegt?: number;
    verfuegbar?: number;
    progAuto?: number;
    progAuto1?: number;
    progMan?: number | undefined;
    hasProgMan?: number;
    progKomm?: string | undefined;
    pkTip?: string | undefined;
    ansatzPJfortPJM1?: number;
    verfuegtPJM1?: number;
    hhrest?: number;
    abgHhrest?: number;
    seAoHhre?: number;
    auftragHr?: number;
    aosollVj?: number;
    aoHrHu?: number;
    ansatz?: number;
    nachtrag?: number;
    sollueber?: number;
    ueplApl?: number;
    seAoSoll?: number;
    auftraeg?: number;
    aosollLfd?: number;
    dauerbelege?: number;
    aoSollHu?: number;
    jahrTips?: { [key: string]: string; } | undefined;
    planHistorie?: PlanHistorieModel[] | undefined;
    planHistorieVgl?: PlanHistorieModel[] | undefined;

    constructor(data?: IHaushaltsZeilenDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            (<any>this).containsData = _data["containsData"];
            (<any>this).hasChanged = _data["hasChanged"];
            this.ausgaben = _data["ausgaben"];
            if (Array.isArray(_data["unterEbenen"])) {
                this.unterEbenen = [] as any;
                for (let item of _data["unterEbenen"])
                    this.unterEbenen!.push(HaushaltsZeilenDetails.fromJS(item));
            }
            this.produkt = _data["produkt"];
            this.produktStellen = _data["produktStellen"];
            this.produktEbene = _data["produktEbene"];
            this.investNr = _data["investNr"];
            this.konto = _data["konto"];
            this.kontoStellen = _data["kontoStellen"];
            this.bezeichnung = _data["bezeichnung"];
            this.produktText = _data["produktText"];
            this.kontoText = _data["kontoText"];
            this.beschreibung = _data["beschreibung"];
            this.suchText = _data["suchText"];
            this.changeFlag = _data["changeFlag"];
            this.ergebnisVvvJ = _data["ergebnisVvvJ"];
            this.ergebnisVvJ = _data["ergebnisVvJ"];
            this.ansatzVJ = _data["ansatzVJ"];
            this.ansatzPj = _data["ansatzPj"];
            this.ansatzPj1 = _data["ansatzPj1"];
            this.fp1 = _data["fp1"];
            this.fp2 = _data["fp2"];
            this.fp3 = _data["fp3"];
            this.fp4 = _data["fp4"];
            this.fp5 = _data["fp5"];
            this.fp6 = _data["fp6"];
            this.fp7 = _data["fp7"];
            this.fp8 = _data["fp8"];
            this.fp9 = _data["fp9"];
            this.fp10 = _data["fp10"];
            this.ansatzPj_vgl = _data["ansatzPj_vgl"];
            this.fp1_vgl = _data["fp1_vgl"];
            this.fp2_vgl = _data["fp2_vgl"];
            this.fp3_vgl = _data["fp3_vgl"];
            this.fp4_vgl = _data["fp4_vgl"];
            this.ergebnisPJ = _data["ergebnisPJ"];
            this.ansatzPJfort = _data["ansatzPJfort"];
            this.ergebnisPJM1 = _data["ergebnisPJM1"];
            this.ergebnisPJM2 = _data["ergebnisPJM2"];
            this.ergebnisPJM3 = _data["ergebnisPJM3"];
            this.ergebnisPJM4 = _data["ergebnisPJM4"];
            this.aenderungPJ = _data["aenderungPJ"];
            this.istAo = _data["istAo"];
            this.verfuegt = _data["verfuegt"];
            this.verfuegbar = _data["verfuegbar"];
            this.progAuto = _data["progAuto"];
            this.progAuto1 = _data["progAuto1"];
            this.progMan = _data["progMan"];
            this.hasProgMan = _data["hasProgMan"];
            this.progKomm = _data["progKomm"];
            this.pkTip = _data["pkTip"];
            this.ansatzPJfortPJM1 = _data["ansatzPJfortPJM1"];
            this.verfuegtPJM1 = _data["verfuegtPJM1"];
            this.hhrest = _data["hhrest"];
            this.abgHhrest = _data["abgHhrest"];
            this.seAoHhre = _data["seAoHhre"];
            this.auftragHr = _data["auftragHr"];
            this.aosollVj = _data["aosollVj"];
            this.aoHrHu = _data["aoHrHu"];
            this.ansatz = _data["ansatz"];
            this.nachtrag = _data["nachtrag"];
            this.sollueber = _data["sollueber"];
            this.ueplApl = _data["ueplApl"];
            this.seAoSoll = _data["seAoSoll"];
            this.auftraeg = _data["auftraeg"];
            this.aosollLfd = _data["aosollLfd"];
            this.dauerbelege = _data["dauerbelege"];
            this.aoSollHu = _data["aoSollHu"];
            if (_data["jahrTips"]) {
                this.jahrTips = {} as any;
                for (let key in _data["jahrTips"]) {
                    if (_data["jahrTips"].hasOwnProperty(key))
                        (<any>this.jahrTips)![key] = _data["jahrTips"][key];
                }
            }
            if (Array.isArray(_data["planHistorie"])) {
                this.planHistorie = [] as any;
                for (let item of _data["planHistorie"])
                    this.planHistorie!.push(PlanHistorieModel.fromJS(item));
            }
            if (Array.isArray(_data["planHistorieVgl"])) {
                this.planHistorieVgl = [] as any;
                for (let item of _data["planHistorieVgl"])
                    this.planHistorieVgl!.push(PlanHistorieModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HaushaltsZeilenDetails {
        data = typeof data === 'object' ? data : {};
        let result = new HaushaltsZeilenDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["containsData"] = this.containsData;
        data["hasChanged"] = this.hasChanged;
        data["ausgaben"] = this.ausgaben;
        if (Array.isArray(this.unterEbenen)) {
            data["unterEbenen"] = [];
            for (let item of this.unterEbenen)
                data["unterEbenen"].push(item.toJSON());
        }
        data["produkt"] = this.produkt;
        data["produktStellen"] = this.produktStellen;
        data["produktEbene"] = this.produktEbene;
        data["investNr"] = this.investNr;
        data["konto"] = this.konto;
        data["kontoStellen"] = this.kontoStellen;
        data["bezeichnung"] = this.bezeichnung;
        data["produktText"] = this.produktText;
        data["kontoText"] = this.kontoText;
        data["beschreibung"] = this.beschreibung;
        data["suchText"] = this.suchText;
        data["changeFlag"] = this.changeFlag;
        data["ergebnisVvvJ"] = this.ergebnisVvvJ;
        data["ergebnisVvJ"] = this.ergebnisVvJ;
        data["ansatzVJ"] = this.ansatzVJ;
        data["ansatzPj"] = this.ansatzPj;
        data["ansatzPj1"] = this.ansatzPj1;
        data["fp1"] = this.fp1;
        data["fp2"] = this.fp2;
        data["fp3"] = this.fp3;
        data["fp4"] = this.fp4;
        data["fp5"] = this.fp5;
        data["fp6"] = this.fp6;
        data["fp7"] = this.fp7;
        data["fp8"] = this.fp8;
        data["fp9"] = this.fp9;
        data["fp10"] = this.fp10;
        data["ansatzPj_vgl"] = this.ansatzPj_vgl;
        data["fp1_vgl"] = this.fp1_vgl;
        data["fp2_vgl"] = this.fp2_vgl;
        data["fp3_vgl"] = this.fp3_vgl;
        data["fp4_vgl"] = this.fp4_vgl;
        data["ergebnisPJ"] = this.ergebnisPJ;
        data["ansatzPJfort"] = this.ansatzPJfort;
        data["ergebnisPJM1"] = this.ergebnisPJM1;
        data["ergebnisPJM2"] = this.ergebnisPJM2;
        data["ergebnisPJM3"] = this.ergebnisPJM3;
        data["ergebnisPJM4"] = this.ergebnisPJM4;
        data["aenderungPJ"] = this.aenderungPJ;
        data["istAo"] = this.istAo;
        data["verfuegt"] = this.verfuegt;
        data["verfuegbar"] = this.verfuegbar;
        data["progAuto"] = this.progAuto;
        data["progAuto1"] = this.progAuto1;
        data["progMan"] = this.progMan;
        data["hasProgMan"] = this.hasProgMan;
        data["progKomm"] = this.progKomm;
        data["pkTip"] = this.pkTip;
        data["ansatzPJfortPJM1"] = this.ansatzPJfortPJM1;
        data["verfuegtPJM1"] = this.verfuegtPJM1;
        data["hhrest"] = this.hhrest;
        data["abgHhrest"] = this.abgHhrest;
        data["seAoHhre"] = this.seAoHhre;
        data["auftragHr"] = this.auftragHr;
        data["aosollVj"] = this.aosollVj;
        data["aoHrHu"] = this.aoHrHu;
        data["ansatz"] = this.ansatz;
        data["nachtrag"] = this.nachtrag;
        data["sollueber"] = this.sollueber;
        data["ueplApl"] = this.ueplApl;
        data["seAoSoll"] = this.seAoSoll;
        data["auftraeg"] = this.auftraeg;
        data["aosollLfd"] = this.aosollLfd;
        data["dauerbelege"] = this.dauerbelege;
        data["aoSollHu"] = this.aoSollHu;
        if (this.jahrTips) {
            data["jahrTips"] = {};
            for (let key in this.jahrTips) {
                if (this.jahrTips.hasOwnProperty(key))
                    (<any>data["jahrTips"])[key] = (<any>this.jahrTips)[key];
            }
        }
        if (Array.isArray(this.planHistorie)) {
            data["planHistorie"] = [];
            for (let item of this.planHistorie)
                data["planHistorie"].push(item.toJSON());
        }
        if (Array.isArray(this.planHistorieVgl)) {
            data["planHistorieVgl"] = [];
            for (let item of this.planHistorieVgl)
                data["planHistorieVgl"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHaushaltsZeilenDetails {
    id?: string | undefined;
    containsData?: boolean;
    hasChanged?: boolean;
    ausgaben?: boolean;
    unterEbenen?: HaushaltsZeilenDetails[] | undefined;
    produkt?: number;
    produktStellen?: number;
    produktEbene?: string | undefined;
    investNr?: string | undefined;
    konto?: number;
    kontoStellen?: number;
    bezeichnung?: string | undefined;
    produktText?: string | undefined;
    kontoText?: string | undefined;
    beschreibung?: string | undefined;
    suchText?: string | undefined;
    changeFlag?: boolean;
    ergebnisVvvJ?: number;
    ergebnisVvJ?: number;
    ansatzVJ?: number;
    ansatzPj?: number;
    ansatzPj1?: number;
    fp1?: number;
    fp2?: number;
    fp3?: number;
    fp4?: number;
    fp5?: number;
    fp6?: number;
    fp7?: number;
    fp8?: number;
    fp9?: number;
    fp10?: number;
    ansatzPj_vgl?: number;
    fp1_vgl?: number;
    fp2_vgl?: number;
    fp3_vgl?: number;
    fp4_vgl?: number;
    ergebnisPJ?: number;
    ansatzPJfort?: number;
    ergebnisPJM1?: number;
    ergebnisPJM2?: number;
    ergebnisPJM3?: number;
    ergebnisPJM4?: number;
    aenderungPJ?: number;
    istAo?: number;
    verfuegt?: number;
    verfuegbar?: number;
    progAuto?: number;
    progAuto1?: number;
    progMan?: number | undefined;
    hasProgMan?: number;
    progKomm?: string | undefined;
    pkTip?: string | undefined;
    ansatzPJfortPJM1?: number;
    verfuegtPJM1?: number;
    hhrest?: number;
    abgHhrest?: number;
    seAoHhre?: number;
    auftragHr?: number;
    aosollVj?: number;
    aoHrHu?: number;
    ansatz?: number;
    nachtrag?: number;
    sollueber?: number;
    ueplApl?: number;
    seAoSoll?: number;
    auftraeg?: number;
    aosollLfd?: number;
    dauerbelege?: number;
    aoSollHu?: number;
    jahrTips?: { [key: string]: string; } | undefined;
    planHistorie?: PlanHistorieModel[] | undefined;
    planHistorieVgl?: PlanHistorieModel[] | undefined;
}

export class HaushaltsZeilenTemplate implements IHaushaltsZeilenTemplate {
    id?: string | undefined;
    zeilenId?: string | undefined;
    zeile?: string | undefined;
    verbergen?: boolean;
    keineDetails?: boolean;
    bezeichnung?: string | undefined;
    opZeichen?: string | undefined;
    unterzeilen?: string[] | undefined;
    untertemplates?: HaushaltsZeilenTemplate[] | undefined;
    summenTiefe?: number;
    ausgaben?: boolean;
    ergebnis?: boolean;
    inkludierteKonten?: string | undefined;
    exkludierteKonten?: string | undefined;
    subtraktionsKonten?: string | undefined;
    datenSatzTyp?: number;
    produkt?: string | undefined;
    berechnung?: string | undefined;
    pseudoKontenTyp?: string | undefined;

    constructor(data?: IHaushaltsZeilenTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.zeilenId = _data["zeilenId"];
            this.zeile = _data["zeile"];
            this.verbergen = _data["verbergen"];
            this.keineDetails = _data["keineDetails"];
            this.bezeichnung = _data["bezeichnung"];
            this.opZeichen = _data["opZeichen"];
            if (Array.isArray(_data["unterzeilen"])) {
                this.unterzeilen = [] as any;
                for (let item of _data["unterzeilen"])
                    this.unterzeilen!.push(item);
            }
            if (Array.isArray(_data["untertemplates"])) {
                this.untertemplates = [] as any;
                for (let item of _data["untertemplates"])
                    this.untertemplates!.push(HaushaltsZeilenTemplate.fromJS(item));
            }
            this.summenTiefe = _data["summenTiefe"];
            this.ausgaben = _data["ausgaben"];
            this.ergebnis = _data["ergebnis"];
            this.inkludierteKonten = _data["inkludierteKonten"];
            this.exkludierteKonten = _data["exkludierteKonten"];
            this.subtraktionsKonten = _data["subtraktionsKonten"];
            this.datenSatzTyp = _data["datenSatzTyp"];
            this.produkt = _data["produkt"];
            this.berechnung = _data["berechnung"];
            this.pseudoKontenTyp = _data["pseudoKontenTyp"];
        }
    }

    static fromJS(data: any): HaushaltsZeilenTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new HaushaltsZeilenTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["zeilenId"] = this.zeilenId;
        data["zeile"] = this.zeile;
        data["verbergen"] = this.verbergen;
        data["keineDetails"] = this.keineDetails;
        data["bezeichnung"] = this.bezeichnung;
        data["opZeichen"] = this.opZeichen;
        if (Array.isArray(this.unterzeilen)) {
            data["unterzeilen"] = [];
            for (let item of this.unterzeilen)
                data["unterzeilen"].push(item);
        }
        if (Array.isArray(this.untertemplates)) {
            data["untertemplates"] = [];
            for (let item of this.untertemplates)
                data["untertemplates"].push(item.toJSON());
        }
        data["summenTiefe"] = this.summenTiefe;
        data["ausgaben"] = this.ausgaben;
        data["ergebnis"] = this.ergebnis;
        data["inkludierteKonten"] = this.inkludierteKonten;
        data["exkludierteKonten"] = this.exkludierteKonten;
        data["subtraktionsKonten"] = this.subtraktionsKonten;
        data["datenSatzTyp"] = this.datenSatzTyp;
        data["produkt"] = this.produkt;
        data["berechnung"] = this.berechnung;
        data["pseudoKontenTyp"] = this.pseudoKontenTyp;
        return data;
    }
}

export interface IHaushaltsZeilenTemplate {
    id?: string | undefined;
    zeilenId?: string | undefined;
    zeile?: string | undefined;
    verbergen?: boolean;
    keineDetails?: boolean;
    bezeichnung?: string | undefined;
    opZeichen?: string | undefined;
    unterzeilen?: string[] | undefined;
    untertemplates?: HaushaltsZeilenTemplate[] | undefined;
    summenTiefe?: number;
    ausgaben?: boolean;
    ergebnis?: boolean;
    inkludierteKonten?: string | undefined;
    exkludierteKonten?: string | undefined;
    subtraktionsKonten?: string | undefined;
    datenSatzTyp?: number;
    produkt?: string | undefined;
    berechnung?: string | undefined;
    pseudoKontenTyp?: string | undefined;
}

export class HaushaltsdatenJrdoppisch implements IHaushaltsdatenJrdoppisch {
    haushaltsstelle?: number;
    plantyp?: number;
    planstufe?: number;
    haushaltsart?: number;
    ergebnisPjm4?: number | undefined;
    ergebnisPjm3?: number | undefined;
    ergebnisPjm2?: number | undefined;
    ergebnisPjm1?: number | undefined;
    ergebnisPj?: number;
    ansatzPjFort?: number;
    aenderungPj?: number;
    krVj?: number;
    krAbgangVj?: number;
    krIstVj?: number;
    krNeuPj?: number;
    krVortragFj?: number;
    hrVj?: number;
    hrAbgangVj?: number;
    hrSollVj?: number;
    hrNeuPj?: number;
    hrVortragFj?: number;
    krVjPjm4?: number | undefined;
    krAbgangVjPjm4?: number | undefined;
    krIstVjPjm4?: number | undefined;
    krNeuPjPjm4?: number | undefined;
    krVortragFjPjm4?: number | undefined;
    hrVjPjm4?: number | undefined;
    hrAbgangVjPjm4?: number | undefined;
    hrSollVjPjm4?: number | undefined;
    hrNeuPjPjm4?: number | undefined;
    hrVortragFjPjm4?: number | undefined;
    krVjPjm3?: number | undefined;
    krAbgangVjPjm3?: number | undefined;
    krIstVjPjm3?: number | undefined;
    krNeuPjPjm3?: number | undefined;
    krVortragFjPjm3?: number | undefined;
    hrVjPjm3?: number | undefined;
    hrAbgangVjPjm3?: number | undefined;
    hrSollVjPjm3?: number | undefined;
    hrNeuPjPjm3?: number | undefined;
    hrVortragFjPjm3?: number | undefined;
    krVjPjm2?: number | undefined;
    krAbgangVjPjm2?: number | undefined;
    krIstVjPjm2?: number | undefined;
    krNeuPjPjm2?: number | undefined;
    krVortragFjPjm2?: number | undefined;
    hrVjPjm2?: number | undefined;
    hrAbgangVjPjm2?: number | undefined;
    hrSollVjPjm2?: number | undefined;
    hrNeuPjPjm2?: number | undefined;
    hrVortragFjPjm2?: number | undefined;
    krVjPjm1?: number | undefined;
    krAbgangVjPjm1?: number | undefined;
    krIstVjPjm1?: number | undefined;
    krNeuPjPjm1?: number | undefined;
    krVortragFjPjm1?: number | undefined;
    hrVjPjm1?: number | undefined;
    hrAbgangVjPjm1?: number | undefined;
    hrSollVjPjm1?: number | undefined;
    hrNeuPjPjm1?: number | undefined;
    hrVortragFjPjm1?: number | undefined;
    ansatz?: number | undefined;
    nachtrag?: number | undefined;
    sollueber?: number | undefined;
    ueplApl?: number | undefined;
    aosollLfd?: number | undefined;
    neueRestePj?: number | undefined;

    constructor(data?: IHaushaltsdatenJrdoppisch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.haushaltsstelle = _data["haushaltsstelle"];
            this.plantyp = _data["plantyp"];
            this.planstufe = _data["planstufe"];
            this.haushaltsart = _data["haushaltsart"];
            this.ergebnisPjm4 = _data["ergebnisPjm4"];
            this.ergebnisPjm3 = _data["ergebnisPjm3"];
            this.ergebnisPjm2 = _data["ergebnisPjm2"];
            this.ergebnisPjm1 = _data["ergebnisPjm1"];
            this.ergebnisPj = _data["ergebnisPj"];
            this.ansatzPjFort = _data["ansatzPjFort"];
            this.aenderungPj = _data["aenderungPj"];
            this.krVj = _data["krVj"];
            this.krAbgangVj = _data["krAbgangVj"];
            this.krIstVj = _data["krIstVj"];
            this.krNeuPj = _data["krNeuPj"];
            this.krVortragFj = _data["krVortragFj"];
            this.hrVj = _data["hrVj"];
            this.hrAbgangVj = _data["hrAbgangVj"];
            this.hrSollVj = _data["hrSollVj"];
            this.hrNeuPj = _data["hrNeuPj"];
            this.hrVortragFj = _data["hrVortragFj"];
            this.krVjPjm4 = _data["krVjPjm4"];
            this.krAbgangVjPjm4 = _data["krAbgangVjPjm4"];
            this.krIstVjPjm4 = _data["krIstVjPjm4"];
            this.krNeuPjPjm4 = _data["krNeuPjPjm4"];
            this.krVortragFjPjm4 = _data["krVortragFjPjm4"];
            this.hrVjPjm4 = _data["hrVjPjm4"];
            this.hrAbgangVjPjm4 = _data["hrAbgangVjPjm4"];
            this.hrSollVjPjm4 = _data["hrSollVjPjm4"];
            this.hrNeuPjPjm4 = _data["hrNeuPjPjm4"];
            this.hrVortragFjPjm4 = _data["hrVortragFjPjm4"];
            this.krVjPjm3 = _data["krVjPjm3"];
            this.krAbgangVjPjm3 = _data["krAbgangVjPjm3"];
            this.krIstVjPjm3 = _data["krIstVjPjm3"];
            this.krNeuPjPjm3 = _data["krNeuPjPjm3"];
            this.krVortragFjPjm3 = _data["krVortragFjPjm3"];
            this.hrVjPjm3 = _data["hrVjPjm3"];
            this.hrAbgangVjPjm3 = _data["hrAbgangVjPjm3"];
            this.hrSollVjPjm3 = _data["hrSollVjPjm3"];
            this.hrNeuPjPjm3 = _data["hrNeuPjPjm3"];
            this.hrVortragFjPjm3 = _data["hrVortragFjPjm3"];
            this.krVjPjm2 = _data["krVjPjm2"];
            this.krAbgangVjPjm2 = _data["krAbgangVjPjm2"];
            this.krIstVjPjm2 = _data["krIstVjPjm2"];
            this.krNeuPjPjm2 = _data["krNeuPjPjm2"];
            this.krVortragFjPjm2 = _data["krVortragFjPjm2"];
            this.hrVjPjm2 = _data["hrVjPjm2"];
            this.hrAbgangVjPjm2 = _data["hrAbgangVjPjm2"];
            this.hrSollVjPjm2 = _data["hrSollVjPjm2"];
            this.hrNeuPjPjm2 = _data["hrNeuPjPjm2"];
            this.hrVortragFjPjm2 = _data["hrVortragFjPjm2"];
            this.krVjPjm1 = _data["krVjPjm1"];
            this.krAbgangVjPjm1 = _data["krAbgangVjPjm1"];
            this.krIstVjPjm1 = _data["krIstVjPjm1"];
            this.krNeuPjPjm1 = _data["krNeuPjPjm1"];
            this.krVortragFjPjm1 = _data["krVortragFjPjm1"];
            this.hrVjPjm1 = _data["hrVjPjm1"];
            this.hrAbgangVjPjm1 = _data["hrAbgangVjPjm1"];
            this.hrSollVjPjm1 = _data["hrSollVjPjm1"];
            this.hrNeuPjPjm1 = _data["hrNeuPjPjm1"];
            this.hrVortragFjPjm1 = _data["hrVortragFjPjm1"];
            this.ansatz = _data["ansatz"];
            this.nachtrag = _data["nachtrag"];
            this.sollueber = _data["sollueber"];
            this.ueplApl = _data["ueplApl"];
            this.aosollLfd = _data["aosollLfd"];
            this.neueRestePj = _data["neueRestePj"];
        }
    }

    static fromJS(data: any): HaushaltsdatenJrdoppisch {
        data = typeof data === 'object' ? data : {};
        let result = new HaushaltsdatenJrdoppisch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["haushaltsstelle"] = this.haushaltsstelle;
        data["plantyp"] = this.plantyp;
        data["planstufe"] = this.planstufe;
        data["haushaltsart"] = this.haushaltsart;
        data["ergebnisPjm4"] = this.ergebnisPjm4;
        data["ergebnisPjm3"] = this.ergebnisPjm3;
        data["ergebnisPjm2"] = this.ergebnisPjm2;
        data["ergebnisPjm1"] = this.ergebnisPjm1;
        data["ergebnisPj"] = this.ergebnisPj;
        data["ansatzPjFort"] = this.ansatzPjFort;
        data["aenderungPj"] = this.aenderungPj;
        data["krVj"] = this.krVj;
        data["krAbgangVj"] = this.krAbgangVj;
        data["krIstVj"] = this.krIstVj;
        data["krNeuPj"] = this.krNeuPj;
        data["krVortragFj"] = this.krVortragFj;
        data["hrVj"] = this.hrVj;
        data["hrAbgangVj"] = this.hrAbgangVj;
        data["hrSollVj"] = this.hrSollVj;
        data["hrNeuPj"] = this.hrNeuPj;
        data["hrVortragFj"] = this.hrVortragFj;
        data["krVjPjm4"] = this.krVjPjm4;
        data["krAbgangVjPjm4"] = this.krAbgangVjPjm4;
        data["krIstVjPjm4"] = this.krIstVjPjm4;
        data["krNeuPjPjm4"] = this.krNeuPjPjm4;
        data["krVortragFjPjm4"] = this.krVortragFjPjm4;
        data["hrVjPjm4"] = this.hrVjPjm4;
        data["hrAbgangVjPjm4"] = this.hrAbgangVjPjm4;
        data["hrSollVjPjm4"] = this.hrSollVjPjm4;
        data["hrNeuPjPjm4"] = this.hrNeuPjPjm4;
        data["hrVortragFjPjm4"] = this.hrVortragFjPjm4;
        data["krVjPjm3"] = this.krVjPjm3;
        data["krAbgangVjPjm3"] = this.krAbgangVjPjm3;
        data["krIstVjPjm3"] = this.krIstVjPjm3;
        data["krNeuPjPjm3"] = this.krNeuPjPjm3;
        data["krVortragFjPjm3"] = this.krVortragFjPjm3;
        data["hrVjPjm3"] = this.hrVjPjm3;
        data["hrAbgangVjPjm3"] = this.hrAbgangVjPjm3;
        data["hrSollVjPjm3"] = this.hrSollVjPjm3;
        data["hrNeuPjPjm3"] = this.hrNeuPjPjm3;
        data["hrVortragFjPjm3"] = this.hrVortragFjPjm3;
        data["krVjPjm2"] = this.krVjPjm2;
        data["krAbgangVjPjm2"] = this.krAbgangVjPjm2;
        data["krIstVjPjm2"] = this.krIstVjPjm2;
        data["krNeuPjPjm2"] = this.krNeuPjPjm2;
        data["krVortragFjPjm2"] = this.krVortragFjPjm2;
        data["hrVjPjm2"] = this.hrVjPjm2;
        data["hrAbgangVjPjm2"] = this.hrAbgangVjPjm2;
        data["hrSollVjPjm2"] = this.hrSollVjPjm2;
        data["hrNeuPjPjm2"] = this.hrNeuPjPjm2;
        data["hrVortragFjPjm2"] = this.hrVortragFjPjm2;
        data["krVjPjm1"] = this.krVjPjm1;
        data["krAbgangVjPjm1"] = this.krAbgangVjPjm1;
        data["krIstVjPjm1"] = this.krIstVjPjm1;
        data["krNeuPjPjm1"] = this.krNeuPjPjm1;
        data["krVortragFjPjm1"] = this.krVortragFjPjm1;
        data["hrVjPjm1"] = this.hrVjPjm1;
        data["hrAbgangVjPjm1"] = this.hrAbgangVjPjm1;
        data["hrSollVjPjm1"] = this.hrSollVjPjm1;
        data["hrNeuPjPjm1"] = this.hrNeuPjPjm1;
        data["hrVortragFjPjm1"] = this.hrVortragFjPjm1;
        data["ansatz"] = this.ansatz;
        data["nachtrag"] = this.nachtrag;
        data["sollueber"] = this.sollueber;
        data["ueplApl"] = this.ueplApl;
        data["aosollLfd"] = this.aosollLfd;
        data["neueRestePj"] = this.neueRestePj;
        return data;
    }
}

export interface IHaushaltsdatenJrdoppisch {
    haushaltsstelle?: number;
    plantyp?: number;
    planstufe?: number;
    haushaltsart?: number;
    ergebnisPjm4?: number | undefined;
    ergebnisPjm3?: number | undefined;
    ergebnisPjm2?: number | undefined;
    ergebnisPjm1?: number | undefined;
    ergebnisPj?: number;
    ansatzPjFort?: number;
    aenderungPj?: number;
    krVj?: number;
    krAbgangVj?: number;
    krIstVj?: number;
    krNeuPj?: number;
    krVortragFj?: number;
    hrVj?: number;
    hrAbgangVj?: number;
    hrSollVj?: number;
    hrNeuPj?: number;
    hrVortragFj?: number;
    krVjPjm4?: number | undefined;
    krAbgangVjPjm4?: number | undefined;
    krIstVjPjm4?: number | undefined;
    krNeuPjPjm4?: number | undefined;
    krVortragFjPjm4?: number | undefined;
    hrVjPjm4?: number | undefined;
    hrAbgangVjPjm4?: number | undefined;
    hrSollVjPjm4?: number | undefined;
    hrNeuPjPjm4?: number | undefined;
    hrVortragFjPjm4?: number | undefined;
    krVjPjm3?: number | undefined;
    krAbgangVjPjm3?: number | undefined;
    krIstVjPjm3?: number | undefined;
    krNeuPjPjm3?: number | undefined;
    krVortragFjPjm3?: number | undefined;
    hrVjPjm3?: number | undefined;
    hrAbgangVjPjm3?: number | undefined;
    hrSollVjPjm3?: number | undefined;
    hrNeuPjPjm3?: number | undefined;
    hrVortragFjPjm3?: number | undefined;
    krVjPjm2?: number | undefined;
    krAbgangVjPjm2?: number | undefined;
    krIstVjPjm2?: number | undefined;
    krNeuPjPjm2?: number | undefined;
    krVortragFjPjm2?: number | undefined;
    hrVjPjm2?: number | undefined;
    hrAbgangVjPjm2?: number | undefined;
    hrSollVjPjm2?: number | undefined;
    hrNeuPjPjm2?: number | undefined;
    hrVortragFjPjm2?: number | undefined;
    krVjPjm1?: number | undefined;
    krAbgangVjPjm1?: number | undefined;
    krIstVjPjm1?: number | undefined;
    krNeuPjPjm1?: number | undefined;
    krVortragFjPjm1?: number | undefined;
    hrVjPjm1?: number | undefined;
    hrAbgangVjPjm1?: number | undefined;
    hrSollVjPjm1?: number | undefined;
    hrNeuPjPjm1?: number | undefined;
    hrVortragFjPjm1?: number | undefined;
    ansatz?: number | undefined;
    nachtrag?: number | undefined;
    sollueber?: number | undefined;
    ueplApl?: number | undefined;
    aosollLfd?: number | undefined;
    neueRestePj?: number | undefined;
}

export class HaushaltsdatenJrkameral implements IHaushaltsdatenJrkameral {
    haushaltsstelle?: number;
    plantyp?: number;
    planstufe?: number;
    haushaltsart?: number;
    ergebnisPjm4?: number | undefined;
    ergebnisPjm3?: number | undefined;
    ergebnisPjm2?: number | undefined;
    ergebnisPjm1?: number | undefined;
    ergebnisPj?: number;
    ansatzPjFort?: number;
    aenderungPj?: number;
    krVj?: number;
    krAbgangVj?: number;
    krIstVj?: number;
    krNeuPj?: number;
    krVortragFj?: number;
    hrVj?: number;
    hrAbgangVj?: number;
    hrSollVj?: number;
    hrNeuPj?: number;
    hrVortragFj?: number;
    krVjPjm4?: number | undefined;
    krAbgangVjPjm4?: number | undefined;
    krIstVjPjm4?: number | undefined;
    krNeuPjPjm4?: number | undefined;
    krVortragFjPjm4?: number | undefined;
    hrVjPjm4?: number | undefined;
    hrAbgangVjPjm4?: number | undefined;
    hrSollVjPjm4?: number | undefined;
    hrNeuPjPjm4?: number | undefined;
    hrVortragFjPjm4?: number | undefined;
    krVjPjm3?: number | undefined;
    krAbgangVjPjm3?: number | undefined;
    krIstVjPjm3?: number | undefined;
    krNeuPjPjm3?: number | undefined;
    krVortragFjPjm3?: number | undefined;
    hrVjPjm3?: number | undefined;
    hrAbgangVjPjm3?: number | undefined;
    hrSollVjPjm3?: number | undefined;
    hrNeuPjPjm3?: number | undefined;
    hrVortragFjPjm3?: number | undefined;
    krVjPjm2?: number | undefined;
    krAbgangVjPjm2?: number | undefined;
    krIstVjPjm2?: number | undefined;
    krNeuPjPjm2?: number | undefined;
    krVortragFjPjm2?: number | undefined;
    hrVjPjm2?: number | undefined;
    hrAbgangVjPjm2?: number | undefined;
    hrSollVjPjm2?: number | undefined;
    hrNeuPjPjm2?: number | undefined;
    hrVortragFjPjm2?: number | undefined;
    krVjPjm1?: number | undefined;
    krAbgangVjPjm1?: number | undefined;
    krIstVjPjm1?: number | undefined;
    krNeuPjPjm1?: number | undefined;
    krVortragFjPjm1?: number | undefined;
    hrVjPjm1?: number | undefined;
    hrAbgangVjPjm1?: number | undefined;
    hrSollVjPjm1?: number | undefined;
    hrNeuPjPjm1?: number | undefined;
    hrVortragFjPjm1?: number | undefined;
    ansatz?: number | undefined;
    nachtrag?: number | undefined;
    sollueber?: number | undefined;
    ueplApl?: number | undefined;
    aosollLfd?: number | undefined;

    constructor(data?: IHaushaltsdatenJrkameral) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.haushaltsstelle = _data["haushaltsstelle"];
            this.plantyp = _data["plantyp"];
            this.planstufe = _data["planstufe"];
            this.haushaltsart = _data["haushaltsart"];
            this.ergebnisPjm4 = _data["ergebnisPjm4"];
            this.ergebnisPjm3 = _data["ergebnisPjm3"];
            this.ergebnisPjm2 = _data["ergebnisPjm2"];
            this.ergebnisPjm1 = _data["ergebnisPjm1"];
            this.ergebnisPj = _data["ergebnisPj"];
            this.ansatzPjFort = _data["ansatzPjFort"];
            this.aenderungPj = _data["aenderungPj"];
            this.krVj = _data["krVj"];
            this.krAbgangVj = _data["krAbgangVj"];
            this.krIstVj = _data["krIstVj"];
            this.krNeuPj = _data["krNeuPj"];
            this.krVortragFj = _data["krVortragFj"];
            this.hrVj = _data["hrVj"];
            this.hrAbgangVj = _data["hrAbgangVj"];
            this.hrSollVj = _data["hrSollVj"];
            this.hrNeuPj = _data["hrNeuPj"];
            this.hrVortragFj = _data["hrVortragFj"];
            this.krVjPjm4 = _data["krVjPjm4"];
            this.krAbgangVjPjm4 = _data["krAbgangVjPjm4"];
            this.krIstVjPjm4 = _data["krIstVjPjm4"];
            this.krNeuPjPjm4 = _data["krNeuPjPjm4"];
            this.krVortragFjPjm4 = _data["krVortragFjPjm4"];
            this.hrVjPjm4 = _data["hrVjPjm4"];
            this.hrAbgangVjPjm4 = _data["hrAbgangVjPjm4"];
            this.hrSollVjPjm4 = _data["hrSollVjPjm4"];
            this.hrNeuPjPjm4 = _data["hrNeuPjPjm4"];
            this.hrVortragFjPjm4 = _data["hrVortragFjPjm4"];
            this.krVjPjm3 = _data["krVjPjm3"];
            this.krAbgangVjPjm3 = _data["krAbgangVjPjm3"];
            this.krIstVjPjm3 = _data["krIstVjPjm3"];
            this.krNeuPjPjm3 = _data["krNeuPjPjm3"];
            this.krVortragFjPjm3 = _data["krVortragFjPjm3"];
            this.hrVjPjm3 = _data["hrVjPjm3"];
            this.hrAbgangVjPjm3 = _data["hrAbgangVjPjm3"];
            this.hrSollVjPjm3 = _data["hrSollVjPjm3"];
            this.hrNeuPjPjm3 = _data["hrNeuPjPjm3"];
            this.hrVortragFjPjm3 = _data["hrVortragFjPjm3"];
            this.krVjPjm2 = _data["krVjPjm2"];
            this.krAbgangVjPjm2 = _data["krAbgangVjPjm2"];
            this.krIstVjPjm2 = _data["krIstVjPjm2"];
            this.krNeuPjPjm2 = _data["krNeuPjPjm2"];
            this.krVortragFjPjm2 = _data["krVortragFjPjm2"];
            this.hrVjPjm2 = _data["hrVjPjm2"];
            this.hrAbgangVjPjm2 = _data["hrAbgangVjPjm2"];
            this.hrSollVjPjm2 = _data["hrSollVjPjm2"];
            this.hrNeuPjPjm2 = _data["hrNeuPjPjm2"];
            this.hrVortragFjPjm2 = _data["hrVortragFjPjm2"];
            this.krVjPjm1 = _data["krVjPjm1"];
            this.krAbgangVjPjm1 = _data["krAbgangVjPjm1"];
            this.krIstVjPjm1 = _data["krIstVjPjm1"];
            this.krNeuPjPjm1 = _data["krNeuPjPjm1"];
            this.krVortragFjPjm1 = _data["krVortragFjPjm1"];
            this.hrVjPjm1 = _data["hrVjPjm1"];
            this.hrAbgangVjPjm1 = _data["hrAbgangVjPjm1"];
            this.hrSollVjPjm1 = _data["hrSollVjPjm1"];
            this.hrNeuPjPjm1 = _data["hrNeuPjPjm1"];
            this.hrVortragFjPjm1 = _data["hrVortragFjPjm1"];
            this.ansatz = _data["ansatz"];
            this.nachtrag = _data["nachtrag"];
            this.sollueber = _data["sollueber"];
            this.ueplApl = _data["ueplApl"];
            this.aosollLfd = _data["aosollLfd"];
        }
    }

    static fromJS(data: any): HaushaltsdatenJrkameral {
        data = typeof data === 'object' ? data : {};
        let result = new HaushaltsdatenJrkameral();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["haushaltsstelle"] = this.haushaltsstelle;
        data["plantyp"] = this.plantyp;
        data["planstufe"] = this.planstufe;
        data["haushaltsart"] = this.haushaltsart;
        data["ergebnisPjm4"] = this.ergebnisPjm4;
        data["ergebnisPjm3"] = this.ergebnisPjm3;
        data["ergebnisPjm2"] = this.ergebnisPjm2;
        data["ergebnisPjm1"] = this.ergebnisPjm1;
        data["ergebnisPj"] = this.ergebnisPj;
        data["ansatzPjFort"] = this.ansatzPjFort;
        data["aenderungPj"] = this.aenderungPj;
        data["krVj"] = this.krVj;
        data["krAbgangVj"] = this.krAbgangVj;
        data["krIstVj"] = this.krIstVj;
        data["krNeuPj"] = this.krNeuPj;
        data["krVortragFj"] = this.krVortragFj;
        data["hrVj"] = this.hrVj;
        data["hrAbgangVj"] = this.hrAbgangVj;
        data["hrSollVj"] = this.hrSollVj;
        data["hrNeuPj"] = this.hrNeuPj;
        data["hrVortragFj"] = this.hrVortragFj;
        data["krVjPjm4"] = this.krVjPjm4;
        data["krAbgangVjPjm4"] = this.krAbgangVjPjm4;
        data["krIstVjPjm4"] = this.krIstVjPjm4;
        data["krNeuPjPjm4"] = this.krNeuPjPjm4;
        data["krVortragFjPjm4"] = this.krVortragFjPjm4;
        data["hrVjPjm4"] = this.hrVjPjm4;
        data["hrAbgangVjPjm4"] = this.hrAbgangVjPjm4;
        data["hrSollVjPjm4"] = this.hrSollVjPjm4;
        data["hrNeuPjPjm4"] = this.hrNeuPjPjm4;
        data["hrVortragFjPjm4"] = this.hrVortragFjPjm4;
        data["krVjPjm3"] = this.krVjPjm3;
        data["krAbgangVjPjm3"] = this.krAbgangVjPjm3;
        data["krIstVjPjm3"] = this.krIstVjPjm3;
        data["krNeuPjPjm3"] = this.krNeuPjPjm3;
        data["krVortragFjPjm3"] = this.krVortragFjPjm3;
        data["hrVjPjm3"] = this.hrVjPjm3;
        data["hrAbgangVjPjm3"] = this.hrAbgangVjPjm3;
        data["hrSollVjPjm3"] = this.hrSollVjPjm3;
        data["hrNeuPjPjm3"] = this.hrNeuPjPjm3;
        data["hrVortragFjPjm3"] = this.hrVortragFjPjm3;
        data["krVjPjm2"] = this.krVjPjm2;
        data["krAbgangVjPjm2"] = this.krAbgangVjPjm2;
        data["krIstVjPjm2"] = this.krIstVjPjm2;
        data["krNeuPjPjm2"] = this.krNeuPjPjm2;
        data["krVortragFjPjm2"] = this.krVortragFjPjm2;
        data["hrVjPjm2"] = this.hrVjPjm2;
        data["hrAbgangVjPjm2"] = this.hrAbgangVjPjm2;
        data["hrSollVjPjm2"] = this.hrSollVjPjm2;
        data["hrNeuPjPjm2"] = this.hrNeuPjPjm2;
        data["hrVortragFjPjm2"] = this.hrVortragFjPjm2;
        data["krVjPjm1"] = this.krVjPjm1;
        data["krAbgangVjPjm1"] = this.krAbgangVjPjm1;
        data["krIstVjPjm1"] = this.krIstVjPjm1;
        data["krNeuPjPjm1"] = this.krNeuPjPjm1;
        data["krVortragFjPjm1"] = this.krVortragFjPjm1;
        data["hrVjPjm1"] = this.hrVjPjm1;
        data["hrAbgangVjPjm1"] = this.hrAbgangVjPjm1;
        data["hrSollVjPjm1"] = this.hrSollVjPjm1;
        data["hrNeuPjPjm1"] = this.hrNeuPjPjm1;
        data["hrVortragFjPjm1"] = this.hrVortragFjPjm1;
        data["ansatz"] = this.ansatz;
        data["nachtrag"] = this.nachtrag;
        data["sollueber"] = this.sollueber;
        data["ueplApl"] = this.ueplApl;
        data["aosollLfd"] = this.aosollLfd;
        return data;
    }
}

export interface IHaushaltsdatenJrkameral {
    haushaltsstelle?: number;
    plantyp?: number;
    planstufe?: number;
    haushaltsart?: number;
    ergebnisPjm4?: number | undefined;
    ergebnisPjm3?: number | undefined;
    ergebnisPjm2?: number | undefined;
    ergebnisPjm1?: number | undefined;
    ergebnisPj?: number;
    ansatzPjFort?: number;
    aenderungPj?: number;
    krVj?: number;
    krAbgangVj?: number;
    krIstVj?: number;
    krNeuPj?: number;
    krVortragFj?: number;
    hrVj?: number;
    hrAbgangVj?: number;
    hrSollVj?: number;
    hrNeuPj?: number;
    hrVortragFj?: number;
    krVjPjm4?: number | undefined;
    krAbgangVjPjm4?: number | undefined;
    krIstVjPjm4?: number | undefined;
    krNeuPjPjm4?: number | undefined;
    krVortragFjPjm4?: number | undefined;
    hrVjPjm4?: number | undefined;
    hrAbgangVjPjm4?: number | undefined;
    hrSollVjPjm4?: number | undefined;
    hrNeuPjPjm4?: number | undefined;
    hrVortragFjPjm4?: number | undefined;
    krVjPjm3?: number | undefined;
    krAbgangVjPjm3?: number | undefined;
    krIstVjPjm3?: number | undefined;
    krNeuPjPjm3?: number | undefined;
    krVortragFjPjm3?: number | undefined;
    hrVjPjm3?: number | undefined;
    hrAbgangVjPjm3?: number | undefined;
    hrSollVjPjm3?: number | undefined;
    hrNeuPjPjm3?: number | undefined;
    hrVortragFjPjm3?: number | undefined;
    krVjPjm2?: number | undefined;
    krAbgangVjPjm2?: number | undefined;
    krIstVjPjm2?: number | undefined;
    krNeuPjPjm2?: number | undefined;
    krVortragFjPjm2?: number | undefined;
    hrVjPjm2?: number | undefined;
    hrAbgangVjPjm2?: number | undefined;
    hrSollVjPjm2?: number | undefined;
    hrNeuPjPjm2?: number | undefined;
    hrVortragFjPjm2?: number | undefined;
    krVjPjm1?: number | undefined;
    krAbgangVjPjm1?: number | undefined;
    krIstVjPjm1?: number | undefined;
    krNeuPjPjm1?: number | undefined;
    krVortragFjPjm1?: number | undefined;
    hrVjPjm1?: number | undefined;
    hrAbgangVjPjm1?: number | undefined;
    hrSollVjPjm1?: number | undefined;
    hrNeuPjPjm1?: number | undefined;
    hrVortragFjPjm1?: number | undefined;
    ansatz?: number | undefined;
    nachtrag?: number | undefined;
    sollueber?: number | undefined;
    ueplApl?: number | undefined;
    aosollLfd?: number | undefined;
}

export class HaushaltsdatenUhdoppisch implements IHaushaltsdatenUhdoppisch {
    haushaltsstelle?: number;
    plantyp?: number;
    planstufe?: number;
    hhrest?: number;
    abgHhrest?: number;
    seAoHhre?: number;
    auftragHr?: number;
    aosollVj?: number;
    aoHrHu?: number;
    ansatz?: number;
    nachtrag?: number;
    sollueber?: number;
    ueplApl?: number;
    seAoSoll?: number;
    auftraeg?: number;
    aosollLfd?: number;
    aoSollHu?: number;
    soll?: boolean;
    istAo?: number | undefined;
    kr?: number | undefined;
    istKr?: number | undefined;
    dauerbelege?: number | undefined;
    ergebnisPjm1?: number | undefined;
    ergebnisPjm2?: number | undefined;
    ergebnisPjm3?: number | undefined;
    ergebnisPjm4?: number | undefined;

    constructor(data?: IHaushaltsdatenUhdoppisch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.haushaltsstelle = _data["haushaltsstelle"];
            this.plantyp = _data["plantyp"];
            this.planstufe = _data["planstufe"];
            this.hhrest = _data["hhrest"];
            this.abgHhrest = _data["abgHhrest"];
            this.seAoHhre = _data["seAoHhre"];
            this.auftragHr = _data["auftragHr"];
            this.aosollVj = _data["aosollVj"];
            this.aoHrHu = _data["aoHrHu"];
            this.ansatz = _data["ansatz"];
            this.nachtrag = _data["nachtrag"];
            this.sollueber = _data["sollueber"];
            this.ueplApl = _data["ueplApl"];
            this.seAoSoll = _data["seAoSoll"];
            this.auftraeg = _data["auftraeg"];
            this.aosollLfd = _data["aosollLfd"];
            this.aoSollHu = _data["aoSollHu"];
            this.soll = _data["soll"];
            this.istAo = _data["istAo"];
            this.kr = _data["kr"];
            this.istKr = _data["istKr"];
            this.dauerbelege = _data["dauerbelege"];
            this.ergebnisPjm1 = _data["ergebnisPjm1"];
            this.ergebnisPjm2 = _data["ergebnisPjm2"];
            this.ergebnisPjm3 = _data["ergebnisPjm3"];
            this.ergebnisPjm4 = _data["ergebnisPjm4"];
        }
    }

    static fromJS(data: any): HaushaltsdatenUhdoppisch {
        data = typeof data === 'object' ? data : {};
        let result = new HaushaltsdatenUhdoppisch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["haushaltsstelle"] = this.haushaltsstelle;
        data["plantyp"] = this.plantyp;
        data["planstufe"] = this.planstufe;
        data["hhrest"] = this.hhrest;
        data["abgHhrest"] = this.abgHhrest;
        data["seAoHhre"] = this.seAoHhre;
        data["auftragHr"] = this.auftragHr;
        data["aosollVj"] = this.aosollVj;
        data["aoHrHu"] = this.aoHrHu;
        data["ansatz"] = this.ansatz;
        data["nachtrag"] = this.nachtrag;
        data["sollueber"] = this.sollueber;
        data["ueplApl"] = this.ueplApl;
        data["seAoSoll"] = this.seAoSoll;
        data["auftraeg"] = this.auftraeg;
        data["aosollLfd"] = this.aosollLfd;
        data["aoSollHu"] = this.aoSollHu;
        data["soll"] = this.soll;
        data["istAo"] = this.istAo;
        data["kr"] = this.kr;
        data["istKr"] = this.istKr;
        data["dauerbelege"] = this.dauerbelege;
        data["ergebnisPjm1"] = this.ergebnisPjm1;
        data["ergebnisPjm2"] = this.ergebnisPjm2;
        data["ergebnisPjm3"] = this.ergebnisPjm3;
        data["ergebnisPjm4"] = this.ergebnisPjm4;
        return data;
    }
}

export interface IHaushaltsdatenUhdoppisch {
    haushaltsstelle?: number;
    plantyp?: number;
    planstufe?: number;
    hhrest?: number;
    abgHhrest?: number;
    seAoHhre?: number;
    auftragHr?: number;
    aosollVj?: number;
    aoHrHu?: number;
    ansatz?: number;
    nachtrag?: number;
    sollueber?: number;
    ueplApl?: number;
    seAoSoll?: number;
    auftraeg?: number;
    aosollLfd?: number;
    aoSollHu?: number;
    soll?: boolean;
    istAo?: number | undefined;
    kr?: number | undefined;
    istKr?: number | undefined;
    dauerbelege?: number | undefined;
    ergebnisPjm1?: number | undefined;
    ergebnisPjm2?: number | undefined;
    ergebnisPjm3?: number | undefined;
    ergebnisPjm4?: number | undefined;
}

export class HaushaltsdatenUhkameral implements IHaushaltsdatenUhkameral {
    haushaltsstelle?: number;
    plantyp?: number;
    planstufe?: number;
    hhrest?: number;
    abgHhrest?: number;
    seAoHhre?: number;
    auftragHr?: number;
    aosollVj?: number;
    aoHrHu?: number;
    ansatz?: number;
    nachtrag?: number;
    sollueber?: number;
    ueplApl?: number;
    seAoSoll?: number;
    auftraeg?: number;
    aosollLfd?: number;
    aoSollHu?: number;
    istAo?: number | undefined;
    kr?: number | undefined;
    istKr?: number | undefined;
    dauerbelege?: number | undefined;
    ergebnisPjm1?: number | undefined;
    ergebnisPjm2?: number | undefined;
    ergebnisPjm3?: number | undefined;
    ergebnisPjm4?: number | undefined;

    constructor(data?: IHaushaltsdatenUhkameral) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.haushaltsstelle = _data["haushaltsstelle"];
            this.plantyp = _data["plantyp"];
            this.planstufe = _data["planstufe"];
            this.hhrest = _data["hhrest"];
            this.abgHhrest = _data["abgHhrest"];
            this.seAoHhre = _data["seAoHhre"];
            this.auftragHr = _data["auftragHr"];
            this.aosollVj = _data["aosollVj"];
            this.aoHrHu = _data["aoHrHu"];
            this.ansatz = _data["ansatz"];
            this.nachtrag = _data["nachtrag"];
            this.sollueber = _data["sollueber"];
            this.ueplApl = _data["ueplApl"];
            this.seAoSoll = _data["seAoSoll"];
            this.auftraeg = _data["auftraeg"];
            this.aosollLfd = _data["aosollLfd"];
            this.aoSollHu = _data["aoSollHu"];
            this.istAo = _data["istAo"];
            this.kr = _data["kr"];
            this.istKr = _data["istKr"];
            this.dauerbelege = _data["dauerbelege"];
            this.ergebnisPjm1 = _data["ergebnisPjm1"];
            this.ergebnisPjm2 = _data["ergebnisPjm2"];
            this.ergebnisPjm3 = _data["ergebnisPjm3"];
            this.ergebnisPjm4 = _data["ergebnisPjm4"];
        }
    }

    static fromJS(data: any): HaushaltsdatenUhkameral {
        data = typeof data === 'object' ? data : {};
        let result = new HaushaltsdatenUhkameral();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["haushaltsstelle"] = this.haushaltsstelle;
        data["plantyp"] = this.plantyp;
        data["planstufe"] = this.planstufe;
        data["hhrest"] = this.hhrest;
        data["abgHhrest"] = this.abgHhrest;
        data["seAoHhre"] = this.seAoHhre;
        data["auftragHr"] = this.auftragHr;
        data["aosollVj"] = this.aosollVj;
        data["aoHrHu"] = this.aoHrHu;
        data["ansatz"] = this.ansatz;
        data["nachtrag"] = this.nachtrag;
        data["sollueber"] = this.sollueber;
        data["ueplApl"] = this.ueplApl;
        data["seAoSoll"] = this.seAoSoll;
        data["auftraeg"] = this.auftraeg;
        data["aosollLfd"] = this.aosollLfd;
        data["aoSollHu"] = this.aoSollHu;
        data["istAo"] = this.istAo;
        data["kr"] = this.kr;
        data["istKr"] = this.istKr;
        data["dauerbelege"] = this.dauerbelege;
        data["ergebnisPjm1"] = this.ergebnisPjm1;
        data["ergebnisPjm2"] = this.ergebnisPjm2;
        data["ergebnisPjm3"] = this.ergebnisPjm3;
        data["ergebnisPjm4"] = this.ergebnisPjm4;
        return data;
    }
}

export interface IHaushaltsdatenUhkameral {
    haushaltsstelle?: number;
    plantyp?: number;
    planstufe?: number;
    hhrest?: number;
    abgHhrest?: number;
    seAoHhre?: number;
    auftragHr?: number;
    aosollVj?: number;
    aoHrHu?: number;
    ansatz?: number;
    nachtrag?: number;
    sollueber?: number;
    ueplApl?: number;
    seAoSoll?: number;
    auftraeg?: number;
    aosollLfd?: number;
    aoSollHu?: number;
    istAo?: number | undefined;
    kr?: number | undefined;
    istKr?: number | undefined;
    dauerbelege?: number | undefined;
    ergebnisPjm1?: number | undefined;
    ergebnisPjm2?: number | undefined;
    ergebnisPjm3?: number | undefined;
    ergebnisPjm4?: number | undefined;
}

export class Haushaltsstelle2Ebene implements IHaushaltsstelle2Ebene {
    haushaltsstelle?: number;
    ebenenId?: string | undefined;
    jahr?: number;

    constructor(data?: IHaushaltsstelle2Ebene) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.haushaltsstelle = _data["haushaltsstelle"];
            this.ebenenId = _data["ebenenId"];
            this.jahr = _data["jahr"];
        }
    }

    static fromJS(data: any): Haushaltsstelle2Ebene {
        data = typeof data === 'object' ? data : {};
        let result = new Haushaltsstelle2Ebene();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["haushaltsstelle"] = this.haushaltsstelle;
        data["ebenenId"] = this.ebenenId;
        data["jahr"] = this.jahr;
        return data;
    }
}

export interface IHaushaltsstelle2Ebene {
    haushaltsstelle?: number;
    ebenenId?: string | undefined;
    jahr?: number;
}

export class Haushaltsstelle2EbeneDoppisch implements IHaushaltsstelle2EbeneDoppisch {
    haushaltsstelle?: number;
    ebenenId?: string | undefined;
    jahr?: number;

    constructor(data?: IHaushaltsstelle2EbeneDoppisch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.haushaltsstelle = _data["haushaltsstelle"];
            this.ebenenId = _data["ebenenId"];
            this.jahr = _data["jahr"];
        }
    }

    static fromJS(data: any): Haushaltsstelle2EbeneDoppisch {
        data = typeof data === 'object' ? data : {};
        let result = new Haushaltsstelle2EbeneDoppisch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["haushaltsstelle"] = this.haushaltsstelle;
        data["ebenenId"] = this.ebenenId;
        data["jahr"] = this.jahr;
        return data;
    }
}

export interface IHaushaltsstelle2EbeneDoppisch {
    haushaltsstelle?: number;
    ebenenId?: string | undefined;
    jahr?: number;
}

export class HaushaltsstelleKameralModel implements IHaushaltsstelleKameralModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    unterabschnitt?: number;
    massnahme?: number | undefined;
    untergruppe?: number;
    unterkonto?: number;
    bezeichnung?: string | undefined;
    uatext?: string | undefined;
    ugtext?: string | undefined;
    beschreibung?: string | undefined;
    beginnJahr?: number | undefined;
    endJahr?: number | undefined;
    uastellen?: number | undefined;
    ugstellen?: number | undefined;
    manuell?: boolean | undefined;
    modifiziert?: boolean | undefined;
    gemeinden?: Gemeinden;
    massnahmeNavigation?: Massnahman;
    massnahmeObj?: Massnahman;

    constructor(data?: IHaushaltsstelleKameralModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.unterabschnitt = _data["unterabschnitt"];
            this.massnahme = _data["massnahme"];
            this.untergruppe = _data["untergruppe"];
            this.unterkonto = _data["unterkonto"];
            this.bezeichnung = _data["bezeichnung"];
            this.uatext = _data["uatext"];
            this.ugtext = _data["ugtext"];
            this.beschreibung = _data["beschreibung"];
            this.beginnJahr = _data["beginnJahr"];
            this.endJahr = _data["endJahr"];
            this.uastellen = _data["uastellen"];
            this.ugstellen = _data["ugstellen"];
            this.manuell = _data["manuell"];
            this.modifiziert = _data["modifiziert"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
            this.massnahmeNavigation = _data["massnahmeNavigation"] ? Massnahman.fromJS(_data["massnahmeNavigation"]) : <any>undefined;
            this.massnahmeObj = _data["massnahmeObj"] ? Massnahman.fromJS(_data["massnahmeObj"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HaushaltsstelleKameralModel {
        data = typeof data === 'object' ? data : {};
        let result = new HaushaltsstelleKameralModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["unterabschnitt"] = this.unterabschnitt;
        data["massnahme"] = this.massnahme;
        data["untergruppe"] = this.untergruppe;
        data["unterkonto"] = this.unterkonto;
        data["bezeichnung"] = this.bezeichnung;
        data["uatext"] = this.uatext;
        data["ugtext"] = this.ugtext;
        data["beschreibung"] = this.beschreibung;
        data["beginnJahr"] = this.beginnJahr;
        data["endJahr"] = this.endJahr;
        data["uastellen"] = this.uastellen;
        data["ugstellen"] = this.ugstellen;
        data["manuell"] = this.manuell;
        data["modifiziert"] = this.modifiziert;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        data["massnahmeNavigation"] = this.massnahmeNavigation ? this.massnahmeNavigation.toJSON() : <any>undefined;
        data["massnahmeObj"] = this.massnahmeObj ? this.massnahmeObj.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHaushaltsstelleKameralModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    unterabschnitt?: number;
    massnahme?: number | undefined;
    untergruppe?: number;
    unterkonto?: number;
    bezeichnung?: string | undefined;
    uatext?: string | undefined;
    ugtext?: string | undefined;
    beschreibung?: string | undefined;
    beginnJahr?: number | undefined;
    endJahr?: number | undefined;
    uastellen?: number | undefined;
    ugstellen?: number | undefined;
    manuell?: boolean | undefined;
    modifiziert?: boolean | undefined;
    gemeinden?: Gemeinden;
    massnahmeNavigation?: Massnahman;
    massnahmeObj?: Massnahman;
}

export class Haushaltsstellen implements IHaushaltsstellen {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    unterabschnitt?: number;
    massnahme?: number | undefined;
    untergruppe?: number;
    unterkonto?: number;
    bezeichnung?: string | undefined;
    uatext?: string | undefined;
    ugtext?: string | undefined;
    beschreibung?: string | undefined;
    beginnJahr?: number | undefined;
    endJahr?: number | undefined;
    uastellen?: number | undefined;
    ugstellen?: number | undefined;
    manuell?: boolean | undefined;
    modifiziert?: boolean | undefined;
    gemeinden?: Gemeinden;
    massnahmeNavigation?: Massnahman;

    constructor(data?: IHaushaltsstellen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.unterabschnitt = _data["unterabschnitt"];
            this.massnahme = _data["massnahme"];
            this.untergruppe = _data["untergruppe"];
            this.unterkonto = _data["unterkonto"];
            this.bezeichnung = _data["bezeichnung"];
            this.uatext = _data["uatext"];
            this.ugtext = _data["ugtext"];
            this.beschreibung = _data["beschreibung"];
            this.beginnJahr = _data["beginnJahr"];
            this.endJahr = _data["endJahr"];
            this.uastellen = _data["uastellen"];
            this.ugstellen = _data["ugstellen"];
            this.manuell = _data["manuell"];
            this.modifiziert = _data["modifiziert"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
            this.massnahmeNavigation = _data["massnahmeNavigation"] ? Massnahman.fromJS(_data["massnahmeNavigation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Haushaltsstellen {
        data = typeof data === 'object' ? data : {};
        let result = new Haushaltsstellen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["unterabschnitt"] = this.unterabschnitt;
        data["massnahme"] = this.massnahme;
        data["untergruppe"] = this.untergruppe;
        data["unterkonto"] = this.unterkonto;
        data["bezeichnung"] = this.bezeichnung;
        data["uatext"] = this.uatext;
        data["ugtext"] = this.ugtext;
        data["beschreibung"] = this.beschreibung;
        data["beginnJahr"] = this.beginnJahr;
        data["endJahr"] = this.endJahr;
        data["uastellen"] = this.uastellen;
        data["ugstellen"] = this.ugstellen;
        data["manuell"] = this.manuell;
        data["modifiziert"] = this.modifiziert;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        data["massnahmeNavigation"] = this.massnahmeNavigation ? this.massnahmeNavigation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHaushaltsstellen {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    unterabschnitt?: number;
    massnahme?: number | undefined;
    untergruppe?: number;
    unterkonto?: number;
    bezeichnung?: string | undefined;
    uatext?: string | undefined;
    ugtext?: string | undefined;
    beschreibung?: string | undefined;
    beginnJahr?: number | undefined;
    endJahr?: number | undefined;
    uastellen?: number | undefined;
    ugstellen?: number | undefined;
    manuell?: boolean | undefined;
    modifiziert?: boolean | undefined;
    gemeinden?: Gemeinden;
    massnahmeNavigation?: Massnahman;
}

export class HaushaltsstellenDoppisch implements IHaushaltsstellenDoppisch {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    produkt?: number;
    konto?: number;
    bezeichnung?: string | undefined;
    produktText?: string | undefined;
    beschreibung?: string | undefined;
    beginnJahr?: number | undefined;
    endJahr?: number | undefined;
    manuell?: boolean | undefined;
    modifiziert?: boolean | undefined;
    produktEbene?: string | undefined;
    ansatzPjTerm?: string | undefined;
    kontoExtra?: string | undefined;
    gemeinden?: Gemeinden;

    constructor(data?: IHaushaltsstellenDoppisch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.produkt = _data["produkt"];
            this.konto = _data["konto"];
            this.bezeichnung = _data["bezeichnung"];
            this.produktText = _data["produktText"];
            this.beschreibung = _data["beschreibung"];
            this.beginnJahr = _data["beginnJahr"];
            this.endJahr = _data["endJahr"];
            this.manuell = _data["manuell"];
            this.modifiziert = _data["modifiziert"];
            this.produktEbene = _data["produktEbene"];
            this.ansatzPjTerm = _data["ansatzPjTerm"];
            this.kontoExtra = _data["kontoExtra"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HaushaltsstellenDoppisch {
        data = typeof data === 'object' ? data : {};
        let result = new HaushaltsstellenDoppisch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["produkt"] = this.produkt;
        data["konto"] = this.konto;
        data["bezeichnung"] = this.bezeichnung;
        data["produktText"] = this.produktText;
        data["beschreibung"] = this.beschreibung;
        data["beginnJahr"] = this.beginnJahr;
        data["endJahr"] = this.endJahr;
        data["manuell"] = this.manuell;
        data["modifiziert"] = this.modifiziert;
        data["produktEbene"] = this.produktEbene;
        data["ansatzPjTerm"] = this.ansatzPjTerm;
        data["kontoExtra"] = this.kontoExtra;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHaushaltsstellenDoppisch {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    produkt?: number;
    konto?: number;
    bezeichnung?: string | undefined;
    produktText?: string | undefined;
    beschreibung?: string | undefined;
    beginnJahr?: number | undefined;
    endJahr?: number | undefined;
    manuell?: boolean | undefined;
    modifiziert?: boolean | undefined;
    produktEbene?: string | undefined;
    ansatzPjTerm?: string | undefined;
    kontoExtra?: string | undefined;
    gemeinden?: Gemeinden;
}

export class Hilfe implements IHilfe {
    id?: number;
    bezeichnung?: string | undefined;
    buchungsart?: number;
    typ?: number;
    url?: string | undefined;
    order?: number | undefined;

    constructor(data?: IHilfe) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
            this.buchungsart = _data["buchungsart"];
            this.typ = _data["typ"];
            this.url = _data["url"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): Hilfe {
        data = typeof data === 'object' ? data : {};
        let result = new Hilfe();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        data["buchungsart"] = this.buchungsart;
        data["typ"] = this.typ;
        data["url"] = this.url;
        data["order"] = this.order;
        return data;
    }
}

export interface IHilfe {
    id?: number;
    bezeichnung?: string | undefined;
    buchungsart?: number;
    typ?: number;
    url?: string | undefined;
    order?: number | undefined;
}

export class Hpsetting implements IHpsetting {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    vjergInFortSchr?: boolean | undefined;

    constructor(data?: IHpsetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.vjergInFortSchr = _data["vjergInFortSchr"];
        }
    }

    static fromJS(data: any): Hpsetting {
        data = typeof data === 'object' ? data : {};
        let result = new Hpsetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["vjergInFortSchr"] = this.vjergInFortSchr;
        return data;
    }
}

export interface IHpsetting {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    vjergInFortSchr?: boolean | undefined;
}

export class ICellContent implements IICellContent {

    constructor(data?: IICellContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ICellContent {
        data = typeof data === 'object' ? data : {};
        let result = new ICellContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IICellContent {
}

export class ImportFormate implements IImportFormate {
    id?: number;
    bezeichnung?: string | undefined;
    export?: boolean | undefined;

    constructor(data?: IImportFormate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
            this.export = _data["export"];
        }
    }

    static fromJS(data: any): ImportFormate {
        data = typeof data === 'object' ? data : {};
        let result = new ImportFormate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        data["export"] = this.export;
        return data;
    }
}

export interface IImportFormate {
    id?: number;
    bezeichnung?: string | undefined;
    export?: boolean | undefined;
}

export class ImportHHDResult implements IImportHHDResult {
    numHHStellen?: number;
    missingHHS?: string[] | undefined;
    ignoredRows?: number[] | undefined;

    constructor(data?: IImportHHDResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numHHStellen = _data["numHHStellen"];
            if (Array.isArray(_data["missingHHS"])) {
                this.missingHHS = [] as any;
                for (let item of _data["missingHHS"])
                    this.missingHHS!.push(item);
            }
            if (Array.isArray(_data["ignoredRows"])) {
                this.ignoredRows = [] as any;
                for (let item of _data["ignoredRows"])
                    this.ignoredRows!.push(item);
            }
        }
    }

    static fromJS(data: any): ImportHHDResult {
        data = typeof data === 'object' ? data : {};
        let result = new ImportHHDResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numHHStellen"] = this.numHHStellen;
        if (Array.isArray(this.missingHHS)) {
            data["missingHHS"] = [];
            for (let item of this.missingHHS)
                data["missingHHS"].push(item);
        }
        if (Array.isArray(this.ignoredRows)) {
            data["ignoredRows"] = [];
            for (let item of this.ignoredRows)
                data["ignoredRows"].push(item);
        }
        return data;
    }
}

export interface IImportHHDResult {
    numHHStellen?: number;
    missingHHS?: string[] | undefined;
    ignoredRows?: number[] | undefined;
}

export class ImportHHSResult implements IImportHHSResult {
    numHHStellen?: number;
    missingGroups?: string[] | undefined;
    missingSegments?: string[] | undefined;

    constructor(data?: IImportHHSResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numHHStellen = _data["numHHStellen"];
            if (Array.isArray(_data["missingGroups"])) {
                this.missingGroups = [] as any;
                for (let item of _data["missingGroups"])
                    this.missingGroups!.push(item);
            }
            if (Array.isArray(_data["missingSegments"])) {
                this.missingSegments = [] as any;
                for (let item of _data["missingSegments"])
                    this.missingSegments!.push(item);
            }
        }
    }

    static fromJS(data: any): ImportHHSResult {
        data = typeof data === 'object' ? data : {};
        let result = new ImportHHSResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numHHStellen"] = this.numHHStellen;
        if (Array.isArray(this.missingGroups)) {
            data["missingGroups"] = [];
            for (let item of this.missingGroups)
                data["missingGroups"].push(item);
        }
        if (Array.isArray(this.missingSegments)) {
            data["missingSegments"] = [];
            for (let item of this.missingSegments)
                data["missingSegments"].push(item);
        }
        return data;
    }
}

export interface IImportHHSResult {
    numHHStellen?: number;
    missingGroups?: string[] | undefined;
    missingSegments?: string[] | undefined;
}

export class ImportHHSResultDoppisch implements IImportHHSResultDoppisch {
    numHHStellen?: number;
    fehlendeProdukte?: string[] | undefined;
    fehlendeKonten?: string[] | undefined;

    constructor(data?: IImportHHSResultDoppisch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numHHStellen = _data["numHHStellen"];
            if (Array.isArray(_data["fehlendeProdukte"])) {
                this.fehlendeProdukte = [] as any;
                for (let item of _data["fehlendeProdukte"])
                    this.fehlendeProdukte!.push(item);
            }
            if (Array.isArray(_data["fehlendeKonten"])) {
                this.fehlendeKonten = [] as any;
                for (let item of _data["fehlendeKonten"])
                    this.fehlendeKonten!.push(item);
            }
        }
    }

    static fromJS(data: any): ImportHHSResultDoppisch {
        data = typeof data === 'object' ? data : {};
        let result = new ImportHHSResultDoppisch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numHHStellen"] = this.numHHStellen;
        if (Array.isArray(this.fehlendeProdukte)) {
            data["fehlendeProdukte"] = [];
            for (let item of this.fehlendeProdukte)
                data["fehlendeProdukte"].push(item);
        }
        if (Array.isArray(this.fehlendeKonten)) {
            data["fehlendeKonten"] = [];
            for (let item of this.fehlendeKonten)
                data["fehlendeKonten"].push(item);
        }
        return data;
    }
}

export interface IImportHHSResultDoppisch {
    numHHStellen?: number;
    fehlendeProdukte?: string[] | undefined;
    fehlendeKonten?: string[] | undefined;
}

export class ImportSchedule implements IImportSchedule {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    plantyp?: number;
    stunde?: number;
    minute?: number;
    importFormat?: number;
    lastRun?: Date | undefined;
    aktiv?: boolean | undefined;
    createPs?: boolean | undefined;
    copyProg?: boolean | undefined;
    useHauptFtp?: boolean | undefined;

    constructor(data?: IImportSchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.plantyp = _data["plantyp"];
            this.stunde = _data["stunde"];
            this.minute = _data["minute"];
            this.importFormat = _data["importFormat"];
            this.lastRun = _data["lastRun"] ? new Date(_data["lastRun"].toString()) : <any>undefined;
            this.aktiv = _data["aktiv"];
            this.createPs = _data["createPs"];
            this.copyProg = _data["copyProg"];
            this.useHauptFtp = _data["useHauptFtp"];
        }
    }

    static fromJS(data: any): ImportSchedule {
        data = typeof data === 'object' ? data : {};
        let result = new ImportSchedule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["plantyp"] = this.plantyp;
        data["stunde"] = this.stunde;
        data["minute"] = this.minute;
        data["importFormat"] = this.importFormat;
        data["lastRun"] = this.lastRun ? this.lastRun.toISOString() : <any>undefined;
        data["aktiv"] = this.aktiv;
        data["createPs"] = this.createPs;
        data["copyProg"] = this.copyProg;
        data["useHauptFtp"] = this.useHauptFtp;
        return data;
    }
}

export interface IImportSchedule {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    plantyp?: number;
    stunde?: number;
    minute?: number;
    importFormat?: number;
    lastRun?: Date | undefined;
    aktiv?: boolean | undefined;
    createPs?: boolean | undefined;
    copyProg?: boolean | undefined;
    useHauptFtp?: boolean | undefined;
}

export class ImportWegweiserKommuneDataRequest implements IImportWegweiserKommuneDataRequest {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    overwriteExisting?: boolean;
    indicatorIds?: number[] | undefined;

    constructor(data?: IImportWegweiserKommuneDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.overwriteExisting = _data["overwriteExisting"];
            if (Array.isArray(_data["indicatorIds"])) {
                this.indicatorIds = [] as any;
                for (let item of _data["indicatorIds"])
                    this.indicatorIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ImportWegweiserKommuneDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportWegweiserKommuneDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["overwriteExisting"] = this.overwriteExisting;
        if (Array.isArray(this.indicatorIds)) {
            data["indicatorIds"] = [];
            for (let item of this.indicatorIds)
                data["indicatorIds"].push(item);
        }
        return data;
    }
}

export interface IImportWegweiserKommuneDataRequest {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    overwriteExisting?: boolean;
    indicatorIds?: number[] | undefined;
}

export class IndicatorValueDto implements IIndicatorValueDto {
    xValue?: number | undefined;
    yValue?: number | undefined;
    label?: string | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    constructor(data?: IIndicatorValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.xValue = _data["xValue"];
            this.yValue = _data["yValue"];
            this.label = _data["label"];
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): IndicatorValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new IndicatorValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["xValue"] = this.xValue;
        data["yValue"] = this.yValue;
        data["label"] = this.label;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IIndicatorValueDto {
    xValue?: number | undefined;
    yValue?: number | undefined;
    label?: string | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;
}

export class IndikatorDto implements IIndikatorDto {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    explanation?: string | undefined;
    calculation?: string | undefined;
    topics?: string[] | undefined;
    unit?: string | undefined;
    yearsAvailable?: number[] | undefined;
    friendlyUrl?: string | undefined;

    constructor(data?: IIndikatorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.explanation = _data["explanation"];
            this.calculation = _data["calculation"];
            if (Array.isArray(_data["topics"])) {
                this.topics = [] as any;
                for (let item of _data["topics"])
                    this.topics!.push(item);
            }
            this.unit = _data["unit"];
            if (Array.isArray(_data["yearsAvailable"])) {
                this.yearsAvailable = [] as any;
                for (let item of _data["yearsAvailable"])
                    this.yearsAvailable!.push(item);
            }
            this.friendlyUrl = _data["friendlyUrl"];
        }
    }

    static fromJS(data: any): IndikatorDto {
        data = typeof data === 'object' ? data : {};
        let result = new IndikatorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["explanation"] = this.explanation;
        data["calculation"] = this.calculation;
        if (Array.isArray(this.topics)) {
            data["topics"] = [];
            for (let item of this.topics)
                data["topics"].push(item);
        }
        data["unit"] = this.unit;
        if (Array.isArray(this.yearsAvailable)) {
            data["yearsAvailable"] = [];
            for (let item of this.yearsAvailable)
                data["yearsAvailable"].push(item);
        }
        data["friendlyUrl"] = this.friendlyUrl;
        return data;
    }
}

export interface IIndikatorDto {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    explanation?: string | undefined;
    calculation?: string | undefined;
    topics?: string[] | undefined;
    unit?: string | undefined;
    yearsAvailable?: number[] | undefined;
    friendlyUrl?: string | undefined;
}

export class InterneDokumente implements IInterneDokumente {
    kunde?: number;
    gemeinde?: number;
    fileName?: string | undefined;
    status?: number | undefined;
    wordFileName?: string | undefined;
    error?: string | undefined;

    constructor(data?: IInterneDokumente) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.fileName = _data["fileName"];
            this.status = _data["status"];
            this.wordFileName = _data["wordFileName"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): InterneDokumente {
        data = typeof data === 'object' ? data : {};
        let result = new InterneDokumente();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["fileName"] = this.fileName;
        data["status"] = this.status;
        data["wordFileName"] = this.wordFileName;
        data["error"] = this.error;
        return data;
    }
}

export interface IInterneDokumente {
    kunde?: number;
    gemeinde?: number;
    fileName?: string | undefined;
    status?: number | undefined;
    wordFileName?: string | undefined;
    error?: string | undefined;
}

export class InvestEinstellungen implements IInvestEinstellungen {
    breite?: number;
    nurWesentliche?: boolean;
    mitWerten?: boolean;
    ohneSummenZeilen?: boolean;
    leerZeile?: boolean;
    investZeileFett?: boolean;
    vjErg?: boolean;
    filterJahre?: number;
    filterWert?: number;
    erlaeuterungen?: boolean;
    erlaeuterungenMN?: boolean;
    inklusiveAnsatzFortDetails?: boolean;

    constructor(data?: IInvestEinstellungen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breite = _data["breite"];
            this.nurWesentliche = _data["nurWesentliche"];
            this.mitWerten = _data["mitWerten"];
            this.ohneSummenZeilen = _data["ohneSummenZeilen"];
            this.leerZeile = _data["leerZeile"];
            this.investZeileFett = _data["investZeileFett"];
            this.vjErg = _data["vjErg"];
            this.filterJahre = _data["filterJahre"];
            this.filterWert = _data["filterWert"];
            this.erlaeuterungen = _data["erlaeuterungen"];
            this.erlaeuterungenMN = _data["erlaeuterungenMN"];
            this.inklusiveAnsatzFortDetails = _data["inklusiveAnsatzFortDetails"];
        }
    }

    static fromJS(data: any): InvestEinstellungen {
        data = typeof data === 'object' ? data : {};
        let result = new InvestEinstellungen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breite"] = this.breite;
        data["nurWesentliche"] = this.nurWesentliche;
        data["mitWerten"] = this.mitWerten;
        data["ohneSummenZeilen"] = this.ohneSummenZeilen;
        data["leerZeile"] = this.leerZeile;
        data["investZeileFett"] = this.investZeileFett;
        data["vjErg"] = this.vjErg;
        data["filterJahre"] = this.filterJahre;
        data["filterWert"] = this.filterWert;
        data["erlaeuterungen"] = this.erlaeuterungen;
        data["erlaeuterungenMN"] = this.erlaeuterungenMN;
        data["inklusiveAnsatzFortDetails"] = this.inklusiveAnsatzFortDetails;
        return data;
    }
}

export interface IInvestEinstellungen {
    breite?: number;
    nurWesentliche?: boolean;
    mitWerten?: boolean;
    ohneSummenZeilen?: boolean;
    leerZeile?: boolean;
    investZeileFett?: boolean;
    vjErg?: boolean;
    filterJahre?: number;
    filterWert?: number;
    erlaeuterungen?: boolean;
    erlaeuterungenMN?: boolean;
    inklusiveAnsatzFortDetails?: boolean;
}

export class InvestSetting implements IInvestSetting {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    spalten?: string | undefined;
    veimmer?: boolean | undefined;
    gaimmer?: boolean | undefined;
    startJahrSumHp?: number | undefined;
    endJahrSumHp?: number | undefined;
    vjergInSum?: boolean | undefined;
    startJahrSumUh?: number | undefined;
    endJahrSumUh?: number | undefined;
    mitVerfuegt?: boolean | undefined;
    startJahrSumJr?: number | undefined;
    spaltenbezeichnung?: string | undefined;

    constructor(data?: IInvestSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.spalten = _data["spalten"];
            this.veimmer = _data["veimmer"];
            this.gaimmer = _data["gaimmer"];
            this.startJahrSumHp = _data["startJahrSumHp"];
            this.endJahrSumHp = _data["endJahrSumHp"];
            this.vjergInSum = _data["vjergInSum"];
            this.startJahrSumUh = _data["startJahrSumUh"];
            this.endJahrSumUh = _data["endJahrSumUh"];
            this.mitVerfuegt = _data["mitVerfuegt"];
            this.startJahrSumJr = _data["startJahrSumJr"];
            this.spaltenbezeichnung = _data["spaltenbezeichnung"];
        }
    }

    static fromJS(data: any): InvestSetting {
        data = typeof data === 'object' ? data : {};
        let result = new InvestSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["spalten"] = this.spalten;
        data["veimmer"] = this.veimmer;
        data["gaimmer"] = this.gaimmer;
        data["startJahrSumHp"] = this.startJahrSumHp;
        data["endJahrSumHp"] = this.endJahrSumHp;
        data["vjergInSum"] = this.vjergInSum;
        data["startJahrSumUh"] = this.startJahrSumUh;
        data["endJahrSumUh"] = this.endJahrSumUh;
        data["mitVerfuegt"] = this.mitVerfuegt;
        data["startJahrSumJr"] = this.startJahrSumJr;
        data["spaltenbezeichnung"] = this.spaltenbezeichnung;
        return data;
    }
}

export interface IInvestSetting {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    spalten?: string | undefined;
    veimmer?: boolean | undefined;
    gaimmer?: boolean | undefined;
    startJahrSumHp?: number | undefined;
    endJahrSumHp?: number | undefined;
    vjergInSum?: boolean | undefined;
    startJahrSumUh?: number | undefined;
    endJahrSumUh?: number | undefined;
    mitVerfuegt?: boolean | undefined;
    startJahrSumJr?: number | undefined;
    spaltenbezeichnung?: string | undefined;
}

export class InvestSettingModel implements IInvestSettingModel {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    spalten?: string | undefined;
    veimmer?: boolean | undefined;
    gaimmer?: boolean | undefined;
    startJahrSumHp?: number | undefined;
    endJahrSumHp?: number | undefined;
    vjergInSum?: boolean | undefined;
    startJahrSumUh?: number | undefined;
    endJahrSumUh?: number | undefined;
    mitVerfuegt?: boolean | undefined;
    startJahrSumJr?: number | undefined;
    spaltenbezeichnung?: string | undefined;
    spaltenBezMap?: { [key: string]: string; } | undefined;

    constructor(data?: IInvestSettingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.spalten = _data["spalten"];
            this.veimmer = _data["veimmer"];
            this.gaimmer = _data["gaimmer"];
            this.startJahrSumHp = _data["startJahrSumHp"];
            this.endJahrSumHp = _data["endJahrSumHp"];
            this.vjergInSum = _data["vjergInSum"];
            this.startJahrSumUh = _data["startJahrSumUh"];
            this.endJahrSumUh = _data["endJahrSumUh"];
            this.mitVerfuegt = _data["mitVerfuegt"];
            this.startJahrSumJr = _data["startJahrSumJr"];
            this.spaltenbezeichnung = _data["spaltenbezeichnung"];
            if (_data["spaltenBezMap"]) {
                this.spaltenBezMap = {} as any;
                for (let key in _data["spaltenBezMap"]) {
                    if (_data["spaltenBezMap"].hasOwnProperty(key))
                        (<any>this.spaltenBezMap)![key] = _data["spaltenBezMap"][key];
                }
            }
        }
    }

    static fromJS(data: any): InvestSettingModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvestSettingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["spalten"] = this.spalten;
        data["veimmer"] = this.veimmer;
        data["gaimmer"] = this.gaimmer;
        data["startJahrSumHp"] = this.startJahrSumHp;
        data["endJahrSumHp"] = this.endJahrSumHp;
        data["vjergInSum"] = this.vjergInSum;
        data["startJahrSumUh"] = this.startJahrSumUh;
        data["endJahrSumUh"] = this.endJahrSumUh;
        data["mitVerfuegt"] = this.mitVerfuegt;
        data["startJahrSumJr"] = this.startJahrSumJr;
        data["spaltenbezeichnung"] = this.spaltenbezeichnung;
        if (this.spaltenBezMap) {
            data["spaltenBezMap"] = {};
            for (let key in this.spaltenBezMap) {
                if (this.spaltenBezMap.hasOwnProperty(key))
                    (<any>data["spaltenBezMap"])[key] = (<any>this.spaltenBezMap)[key];
            }
        }
        return data;
    }
}

export interface IInvestSettingModel {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    spalten?: string | undefined;
    veimmer?: boolean | undefined;
    gaimmer?: boolean | undefined;
    startJahrSumHp?: number | undefined;
    endJahrSumHp?: number | undefined;
    vjergInSum?: boolean | undefined;
    startJahrSumUh?: number | undefined;
    endJahrSumUh?: number | undefined;
    mitVerfuegt?: boolean | undefined;
    startJahrSumJr?: number | undefined;
    spaltenbezeichnung?: string | undefined;
    spaltenBezMap?: { [key: string]: string; } | undefined;
}

export class Investitionen implements IInvestitionen {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    strasse?: string | undefined;
    hausnummer?: string | undefined;
    plz?: string | undefined;
    ort?: string | undefined;
    ortsteil?: string | undefined;
    vermoegensart?: number;
    vermoegenstyp?: number;
    wesentlich?: boolean;
    gesamtbedarf?: number | undefined;
    gesamtzuwendungen?: number | undefined;
    bisherVerausgabt?: number | undefined;
    bisherVereinnahmt?: number | undefined;
    veGesamt?: number | undefined;
    veFj1?: number | undefined;
    veFj2?: number | undefined;
    veFj3?: number | undefined;
    veFj4?: number | undefined;
    veFj5?: number | undefined;
    investitionsart?: number | undefined;
    beginnJahr?: number | undefined;
    massnahme?: number | undefined;
    abschnitt?: number | undefined;
    vePj?: number | undefined;
    nichtHp?: boolean | undefined;
    nichtJr?: boolean | undefined;
    nichtUh?: boolean | undefined;
    uaPrText?: string | undefined;
    ve1Gesamt?: number | undefined;
    ve1Fj1?: number | undefined;
    ve1Fj2?: number | undefined;
    ve1Fj3?: number | undefined;
    ve1Fj4?: number | undefined;
    ve1Fj5?: number | undefined;

    constructor(data?: IInvestitionen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.bezeichnung = _data["bezeichnung"];
            this.strasse = _data["strasse"];
            this.hausnummer = _data["hausnummer"];
            this.plz = _data["plz"];
            this.ort = _data["ort"];
            this.ortsteil = _data["ortsteil"];
            this.vermoegensart = _data["vermoegensart"];
            this.vermoegenstyp = _data["vermoegenstyp"];
            this.wesentlich = _data["wesentlich"];
            this.gesamtbedarf = _data["gesamtbedarf"];
            this.gesamtzuwendungen = _data["gesamtzuwendungen"];
            this.bisherVerausgabt = _data["bisherVerausgabt"];
            this.bisherVereinnahmt = _data["bisherVereinnahmt"];
            this.veGesamt = _data["veGesamt"];
            this.veFj1 = _data["veFj1"];
            this.veFj2 = _data["veFj2"];
            this.veFj3 = _data["veFj3"];
            this.veFj4 = _data["veFj4"];
            this.veFj5 = _data["veFj5"];
            this.investitionsart = _data["investitionsart"];
            this.beginnJahr = _data["beginnJahr"];
            this.massnahme = _data["massnahme"];
            this.abschnitt = _data["abschnitt"];
            this.vePj = _data["vePj"];
            this.nichtHp = _data["nichtHp"];
            this.nichtJr = _data["nichtJr"];
            this.nichtUh = _data["nichtUh"];
            this.uaPrText = _data["uaPrText"];
            this.ve1Gesamt = _data["ve1Gesamt"];
            this.ve1Fj1 = _data["ve1Fj1"];
            this.ve1Fj2 = _data["ve1Fj2"];
            this.ve1Fj3 = _data["ve1Fj3"];
            this.ve1Fj4 = _data["ve1Fj4"];
            this.ve1Fj5 = _data["ve1Fj5"];
        }
    }

    static fromJS(data: any): Investitionen {
        data = typeof data === 'object' ? data : {};
        let result = new Investitionen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["bezeichnung"] = this.bezeichnung;
        data["strasse"] = this.strasse;
        data["hausnummer"] = this.hausnummer;
        data["plz"] = this.plz;
        data["ort"] = this.ort;
        data["ortsteil"] = this.ortsteil;
        data["vermoegensart"] = this.vermoegensart;
        data["vermoegenstyp"] = this.vermoegenstyp;
        data["wesentlich"] = this.wesentlich;
        data["gesamtbedarf"] = this.gesamtbedarf;
        data["gesamtzuwendungen"] = this.gesamtzuwendungen;
        data["bisherVerausgabt"] = this.bisherVerausgabt;
        data["bisherVereinnahmt"] = this.bisherVereinnahmt;
        data["veGesamt"] = this.veGesamt;
        data["veFj1"] = this.veFj1;
        data["veFj2"] = this.veFj2;
        data["veFj3"] = this.veFj3;
        data["veFj4"] = this.veFj4;
        data["veFj5"] = this.veFj5;
        data["investitionsart"] = this.investitionsart;
        data["beginnJahr"] = this.beginnJahr;
        data["massnahme"] = this.massnahme;
        data["abschnitt"] = this.abschnitt;
        data["vePj"] = this.vePj;
        data["nichtHp"] = this.nichtHp;
        data["nichtJr"] = this.nichtJr;
        data["nichtUh"] = this.nichtUh;
        data["uaPrText"] = this.uaPrText;
        data["ve1Gesamt"] = this.ve1Gesamt;
        data["ve1Fj1"] = this.ve1Fj1;
        data["ve1Fj2"] = this.ve1Fj2;
        data["ve1Fj3"] = this.ve1Fj3;
        data["ve1Fj4"] = this.ve1Fj4;
        data["ve1Fj5"] = this.ve1Fj5;
        return data;
    }
}

export interface IInvestitionen {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    strasse?: string | undefined;
    hausnummer?: string | undefined;
    plz?: string | undefined;
    ort?: string | undefined;
    ortsteil?: string | undefined;
    vermoegensart?: number;
    vermoegenstyp?: number;
    wesentlich?: boolean;
    gesamtbedarf?: number | undefined;
    gesamtzuwendungen?: number | undefined;
    bisherVerausgabt?: number | undefined;
    bisherVereinnahmt?: number | undefined;
    veGesamt?: number | undefined;
    veFj1?: number | undefined;
    veFj2?: number | undefined;
    veFj3?: number | undefined;
    veFj4?: number | undefined;
    veFj5?: number | undefined;
    investitionsart?: number | undefined;
    beginnJahr?: number | undefined;
    massnahme?: number | undefined;
    abschnitt?: number | undefined;
    vePj?: number | undefined;
    nichtHp?: boolean | undefined;
    nichtJr?: boolean | undefined;
    nichtUh?: boolean | undefined;
    uaPrText?: string | undefined;
    ve1Gesamt?: number | undefined;
    ve1Fj1?: number | undefined;
    ve1Fj2?: number | undefined;
    ve1Fj3?: number | undefined;
    ve1Fj4?: number | undefined;
    ve1Fj5?: number | undefined;
}

export class InvestitionsEbene implements IInvestitionsEbene {
    ausgabe?: boolean;
    ebene?: HaushaltsEbene;

    constructor(data?: IInvestitionsEbene) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ausgabe = _data["ausgabe"];
            this.ebene = _data["ebene"] ? HaushaltsEbene.fromJS(_data["ebene"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InvestitionsEbene {
        data = typeof data === 'object' ? data : {};
        let result = new InvestitionsEbene();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ausgabe"] = this.ausgabe;
        data["ebene"] = this.ebene ? this.ebene.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInvestitionsEbene {
    ausgabe?: boolean;
    ebene?: HaushaltsEbene;
}

export class InvestitionsEbeneDoppik implements IInvestitionsEbeneDoppik {
    ausgabe?: boolean;
    ebene?: HaushaltsEbeneDoppik;

    constructor(data?: IInvestitionsEbeneDoppik) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ausgabe = _data["ausgabe"];
            this.ebene = _data["ebene"] ? HaushaltsEbeneDoppik.fromJS(_data["ebene"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InvestitionsEbeneDoppik {
        data = typeof data === 'object' ? data : {};
        let result = new InvestitionsEbeneDoppik();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ausgabe"] = this.ausgabe;
        data["ebene"] = this.ebene ? this.ebene.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInvestitionsEbeneDoppik {
    ausgabe?: boolean;
    ebene?: HaushaltsEbeneDoppik;
}

export class InvestitionsHHStelleDoppisch implements IInvestitionsHHStelleDoppisch {
    readonly id?: string | undefined;
    haushaltsstelle?: HaushaltsstellenDoppisch;
    massnahme?: MassnahmenDoppisch;
    readonly produkt?: number;
    readonly konto?: number;
    ergebnisVvvJ?: number | undefined;
    ergebnisVvJ?: number | undefined;
    ansatzVJ?: number | undefined;
    ansatzPj?: number | undefined;
    fp1?: number | undefined;
    fp2?: number | undefined;
    fp3?: number | undefined;
    fp4?: number | undefined;
    fp5?: number | undefined;
    fp6?: number | undefined;
    fp7?: number | undefined;
    fp8?: number | undefined;
    fp9?: number | undefined;
    fp10?: number | undefined;

    constructor(data?: IInvestitionsHHStelleDoppisch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            this.haushaltsstelle = _data["haushaltsstelle"] ? HaushaltsstellenDoppisch.fromJS(_data["haushaltsstelle"]) : <any>undefined;
            this.massnahme = _data["massnahme"] ? MassnahmenDoppisch.fromJS(_data["massnahme"]) : <any>undefined;
            (<any>this).produkt = _data["produkt"];
            (<any>this).konto = _data["konto"];
            this.ergebnisVvvJ = _data["ergebnisVvvJ"];
            this.ergebnisVvJ = _data["ergebnisVvJ"];
            this.ansatzVJ = _data["ansatzVJ"];
            this.ansatzPj = _data["ansatzPj"];
            this.fp1 = _data["fp1"];
            this.fp2 = _data["fp2"];
            this.fp3 = _data["fp3"];
            this.fp4 = _data["fp4"];
            this.fp5 = _data["fp5"];
            this.fp6 = _data["fp6"];
            this.fp7 = _data["fp7"];
            this.fp8 = _data["fp8"];
            this.fp9 = _data["fp9"];
            this.fp10 = _data["fp10"];
        }
    }

    static fromJS(data: any): InvestitionsHHStelleDoppisch {
        data = typeof data === 'object' ? data : {};
        let result = new InvestitionsHHStelleDoppisch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["haushaltsstelle"] = this.haushaltsstelle ? this.haushaltsstelle.toJSON() : <any>undefined;
        data["massnahme"] = this.massnahme ? this.massnahme.toJSON() : <any>undefined;
        data["produkt"] = this.produkt;
        data["konto"] = this.konto;
        data["ergebnisVvvJ"] = this.ergebnisVvvJ;
        data["ergebnisVvJ"] = this.ergebnisVvJ;
        data["ansatzVJ"] = this.ansatzVJ;
        data["ansatzPj"] = this.ansatzPj;
        data["fp1"] = this.fp1;
        data["fp2"] = this.fp2;
        data["fp3"] = this.fp3;
        data["fp4"] = this.fp4;
        data["fp5"] = this.fp5;
        data["fp6"] = this.fp6;
        data["fp7"] = this.fp7;
        data["fp8"] = this.fp8;
        data["fp9"] = this.fp9;
        data["fp10"] = this.fp10;
        return data;
    }
}

export interface IInvestitionsHHStelleDoppisch {
    id?: string | undefined;
    haushaltsstelle?: HaushaltsstellenDoppisch;
    massnahme?: MassnahmenDoppisch;
    produkt?: number;
    konto?: number;
    ergebnisVvvJ?: number | undefined;
    ergebnisVvJ?: number | undefined;
    ansatzVJ?: number | undefined;
    ansatzPj?: number | undefined;
    fp1?: number | undefined;
    fp2?: number | undefined;
    fp3?: number | undefined;
    fp4?: number | undefined;
    fp5?: number | undefined;
    fp6?: number | undefined;
    fp7?: number | undefined;
    fp8?: number | undefined;
    fp9?: number | undefined;
    fp10?: number | undefined;
}

export class InvestitionsModel implements IInvestitionsModel {
    investition?: Investitionen;
    texte?: Texte[] | undefined;
    summenEbene?: HaushaltsEbene;
    ebenen?: InvestitionsEbene[] | undefined;

    constructor(data?: IInvestitionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.investition = _data["investition"] ? Investitionen.fromJS(_data["investition"]) : <any>undefined;
            if (Array.isArray(_data["texte"])) {
                this.texte = [] as any;
                for (let item of _data["texte"])
                    this.texte!.push(Texte.fromJS(item));
            }
            this.summenEbene = _data["summenEbene"] ? HaushaltsEbene.fromJS(_data["summenEbene"]) : <any>undefined;
            if (Array.isArray(_data["ebenen"])) {
                this.ebenen = [] as any;
                for (let item of _data["ebenen"])
                    this.ebenen!.push(InvestitionsEbene.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvestitionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvestitionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["investition"] = this.investition ? this.investition.toJSON() : <any>undefined;
        if (Array.isArray(this.texte)) {
            data["texte"] = [];
            for (let item of this.texte)
                data["texte"].push(item.toJSON());
        }
        data["summenEbene"] = this.summenEbene ? this.summenEbene.toJSON() : <any>undefined;
        if (Array.isArray(this.ebenen)) {
            data["ebenen"] = [];
            for (let item of this.ebenen)
                data["ebenen"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInvestitionsModel {
    investition?: Investitionen;
    texte?: Texte[] | undefined;
    summenEbene?: HaushaltsEbene;
    ebenen?: InvestitionsEbene[] | undefined;
}

export class InvestitionsModelDoppik implements IInvestitionsModelDoppik {
    investition?: Investitionen;
    texte?: Texte[] | undefined;
    summenEbene?: HaushaltsEbeneDoppik;
    ebenen?: InvestitionsEbeneDoppik[] | undefined;

    constructor(data?: IInvestitionsModelDoppik) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.investition = _data["investition"] ? Investitionen.fromJS(_data["investition"]) : <any>undefined;
            if (Array.isArray(_data["texte"])) {
                this.texte = [] as any;
                for (let item of _data["texte"])
                    this.texte!.push(Texte.fromJS(item));
            }
            this.summenEbene = _data["summenEbene"] ? HaushaltsEbeneDoppik.fromJS(_data["summenEbene"]) : <any>undefined;
            if (Array.isArray(_data["ebenen"])) {
                this.ebenen = [] as any;
                for (let item of _data["ebenen"])
                    this.ebenen!.push(InvestitionsEbeneDoppik.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvestitionsModelDoppik {
        data = typeof data === 'object' ? data : {};
        let result = new InvestitionsModelDoppik();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["investition"] = this.investition ? this.investition.toJSON() : <any>undefined;
        if (Array.isArray(this.texte)) {
            data["texte"] = [];
            for (let item of this.texte)
                data["texte"].push(item.toJSON());
        }
        data["summenEbene"] = this.summenEbene ? this.summenEbene.toJSON() : <any>undefined;
        if (Array.isArray(this.ebenen)) {
            data["ebenen"] = [];
            for (let item of this.ebenen)
                data["ebenen"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInvestitionsModelDoppik {
    investition?: Investitionen;
    texte?: Texte[] | undefined;
    summenEbene?: HaushaltsEbeneDoppik;
    ebenen?: InvestitionsEbeneDoppik[] | undefined;
}

export class Investitionsarten implements IInvestitionsarten {
    id?: number;
    bezeichnung?: string | undefined;

    constructor(data?: IInvestitionsarten) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
        }
    }

    static fromJS(data: any): Investitionsarten {
        data = typeof data === 'object' ? data : {};
        let result = new Investitionsarten();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        return data;
    }
}

export interface IInvestitionsarten {
    id?: number;
    bezeichnung?: string | undefined;
}

export class InvestmentHaushaltsstellen implements IInvestmentHaushaltsstellen {
    ausgabeHHs?: Haushaltsstellen[] | undefined;
    einnahmeHHs?: Haushaltsstellen[] | undefined;

    constructor(data?: IInvestmentHaushaltsstellen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ausgabeHHs"])) {
                this.ausgabeHHs = [] as any;
                for (let item of _data["ausgabeHHs"])
                    this.ausgabeHHs!.push(Haushaltsstellen.fromJS(item));
            }
            if (Array.isArray(_data["einnahmeHHs"])) {
                this.einnahmeHHs = [] as any;
                for (let item of _data["einnahmeHHs"])
                    this.einnahmeHHs!.push(Haushaltsstellen.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvestmentHaushaltsstellen {
        data = typeof data === 'object' ? data : {};
        let result = new InvestmentHaushaltsstellen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ausgabeHHs)) {
            data["ausgabeHHs"] = [];
            for (let item of this.ausgabeHHs)
                data["ausgabeHHs"].push(item.toJSON());
        }
        if (Array.isArray(this.einnahmeHHs)) {
            data["einnahmeHHs"] = [];
            for (let item of this.einnahmeHHs)
                data["einnahmeHHs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInvestmentHaushaltsstellen {
    ausgabeHHs?: Haushaltsstellen[] | undefined;
    einnahmeHHs?: Haushaltsstellen[] | undefined;
}

export class InvestmentHaushaltsstellenDoppisch implements IInvestmentHaushaltsstellenDoppisch {
    ausgabeHHs?: InvestitionsHHStelleDoppisch[] | undefined;
    einnahmeHHs?: InvestitionsHHStelleDoppisch[] | undefined;

    constructor(data?: IInvestmentHaushaltsstellenDoppisch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ausgabeHHs"])) {
                this.ausgabeHHs = [] as any;
                for (let item of _data["ausgabeHHs"])
                    this.ausgabeHHs!.push(InvestitionsHHStelleDoppisch.fromJS(item));
            }
            if (Array.isArray(_data["einnahmeHHs"])) {
                this.einnahmeHHs = [] as any;
                for (let item of _data["einnahmeHHs"])
                    this.einnahmeHHs!.push(InvestitionsHHStelleDoppisch.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvestmentHaushaltsstellenDoppisch {
        data = typeof data === 'object' ? data : {};
        let result = new InvestmentHaushaltsstellenDoppisch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ausgabeHHs)) {
            data["ausgabeHHs"] = [];
            for (let item of this.ausgabeHHs)
                data["ausgabeHHs"].push(item.toJSON());
        }
        if (Array.isArray(this.einnahmeHHs)) {
            data["einnahmeHHs"] = [];
            for (let item of this.einnahmeHHs)
                data["einnahmeHHs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInvestmentHaushaltsstellenDoppisch {
    ausgabeHHs?: InvestitionsHHStelleDoppisch[] | undefined;
    einnahmeHHs?: InvestitionsHHStelleDoppisch[] | undefined;
}

export class JRSettingModel implements IJRSettingModel {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    hreste?: boolean;
    kreste?: boolean;
    sumUk?: boolean | undefined;
    keineBilanzLeerZeilen?: boolean | undefined;
    bilanzPosMap?: string | undefined;
    textUebAufw?: string | undefined;
    textUebAusz?: string | undefined;
    exKonten?: string | undefined;
    hresteDiagrammeAus?: boolean | undefined;
    kresteDiagrammeAus?: boolean | undefined;
    hresteEinnahmen?: boolean | undefined;
    textUebErt?: string | undefined;
    textUebEinz?: string | undefined;
    mnInBilanz?: boolean | undefined;
    faInd?: boolean | undefined;
    faHhrvj?: boolean | undefined;
    faAbgHhrvj?: boolean | undefined;
    faAnsLfd?: boolean | undefined;
    faNachtrag?: boolean | undefined;
    faSollVer?: boolean | undefined;
    faUeplApl?: boolean | undefined;
    ergInd?: boolean | undefined;
    ergSolllfdAns?: boolean | undefined;
    ergAbgKrvj?: boolean | undefined;
    ergHhrneu?: boolean | undefined;
    ergAbgHhrvj?: boolean | undefined;
    hresteLeereSpaltenAus?: boolean | undefined;
    fortAnsMitUeplApl?: boolean | undefined;
    bilanzPosMapping?: Pos2Konto[] | undefined;

    constructor(data?: IJRSettingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.hreste = _data["hreste"];
            this.kreste = _data["kreste"];
            this.sumUk = _data["sumUk"];
            this.keineBilanzLeerZeilen = _data["keineBilanzLeerZeilen"];
            this.bilanzPosMap = _data["bilanzPosMap"];
            this.textUebAufw = _data["textUebAufw"];
            this.textUebAusz = _data["textUebAusz"];
            this.exKonten = _data["exKonten"];
            this.hresteDiagrammeAus = _data["hresteDiagrammeAus"];
            this.kresteDiagrammeAus = _data["kresteDiagrammeAus"];
            this.hresteEinnahmen = _data["hresteEinnahmen"];
            this.textUebErt = _data["textUebErt"];
            this.textUebEinz = _data["textUebEinz"];
            this.mnInBilanz = _data["mnInBilanz"];
            this.faInd = _data["faInd"];
            this.faHhrvj = _data["faHhrvj"];
            this.faAbgHhrvj = _data["faAbgHhrvj"];
            this.faAnsLfd = _data["faAnsLfd"];
            this.faNachtrag = _data["faNachtrag"];
            this.faSollVer = _data["faSollVer"];
            this.faUeplApl = _data["faUeplApl"];
            this.ergInd = _data["ergInd"];
            this.ergSolllfdAns = _data["ergSolllfdAns"];
            this.ergAbgKrvj = _data["ergAbgKrvj"];
            this.ergHhrneu = _data["ergHhrneu"];
            this.ergAbgHhrvj = _data["ergAbgHhrvj"];
            this.hresteLeereSpaltenAus = _data["hresteLeereSpaltenAus"];
            this.fortAnsMitUeplApl = _data["fortAnsMitUeplApl"];
            if (Array.isArray(_data["bilanzPosMapping"])) {
                this.bilanzPosMapping = [] as any;
                for (let item of _data["bilanzPosMapping"])
                    this.bilanzPosMapping!.push(Pos2Konto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): JRSettingModel {
        data = typeof data === 'object' ? data : {};
        let result = new JRSettingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["hreste"] = this.hreste;
        data["kreste"] = this.kreste;
        data["sumUk"] = this.sumUk;
        data["keineBilanzLeerZeilen"] = this.keineBilanzLeerZeilen;
        data["bilanzPosMap"] = this.bilanzPosMap;
        data["textUebAufw"] = this.textUebAufw;
        data["textUebAusz"] = this.textUebAusz;
        data["exKonten"] = this.exKonten;
        data["hresteDiagrammeAus"] = this.hresteDiagrammeAus;
        data["kresteDiagrammeAus"] = this.kresteDiagrammeAus;
        data["hresteEinnahmen"] = this.hresteEinnahmen;
        data["textUebErt"] = this.textUebErt;
        data["textUebEinz"] = this.textUebEinz;
        data["mnInBilanz"] = this.mnInBilanz;
        data["faInd"] = this.faInd;
        data["faHhrvj"] = this.faHhrvj;
        data["faAbgHhrvj"] = this.faAbgHhrvj;
        data["faAnsLfd"] = this.faAnsLfd;
        data["faNachtrag"] = this.faNachtrag;
        data["faSollVer"] = this.faSollVer;
        data["faUeplApl"] = this.faUeplApl;
        data["ergInd"] = this.ergInd;
        data["ergSolllfdAns"] = this.ergSolllfdAns;
        data["ergAbgKrvj"] = this.ergAbgKrvj;
        data["ergHhrneu"] = this.ergHhrneu;
        data["ergAbgHhrvj"] = this.ergAbgHhrvj;
        data["hresteLeereSpaltenAus"] = this.hresteLeereSpaltenAus;
        data["fortAnsMitUeplApl"] = this.fortAnsMitUeplApl;
        if (Array.isArray(this.bilanzPosMapping)) {
            data["bilanzPosMapping"] = [];
            for (let item of this.bilanzPosMapping)
                data["bilanzPosMapping"].push(item.toJSON());
        }
        return data;
    }
}

export interface IJRSettingModel {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    hreste?: boolean;
    kreste?: boolean;
    sumUk?: boolean | undefined;
    keineBilanzLeerZeilen?: boolean | undefined;
    bilanzPosMap?: string | undefined;
    textUebAufw?: string | undefined;
    textUebAusz?: string | undefined;
    exKonten?: string | undefined;
    hresteDiagrammeAus?: boolean | undefined;
    kresteDiagrammeAus?: boolean | undefined;
    hresteEinnahmen?: boolean | undefined;
    textUebErt?: string | undefined;
    textUebEinz?: string | undefined;
    mnInBilanz?: boolean | undefined;
    faInd?: boolean | undefined;
    faHhrvj?: boolean | undefined;
    faAbgHhrvj?: boolean | undefined;
    faAnsLfd?: boolean | undefined;
    faNachtrag?: boolean | undefined;
    faSollVer?: boolean | undefined;
    faUeplApl?: boolean | undefined;
    ergInd?: boolean | undefined;
    ergSolllfdAns?: boolean | undefined;
    ergAbgKrvj?: boolean | undefined;
    ergHhrneu?: boolean | undefined;
    ergAbgHhrvj?: boolean | undefined;
    hresteLeereSpaltenAus?: boolean | undefined;
    fortAnsMitUeplApl?: boolean | undefined;
    bilanzPosMapping?: Pos2Konto[] | undefined;
}

export class JahrModel implements IJahrModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;

    constructor(data?: IJahrModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.modul = _data["modul"];
            this.verwaltungsansicht = _data["verwaltungsansicht"];
        }
    }

    static fromJS(data: any): JahrModel {
        data = typeof data === 'object' ? data : {};
        let result = new JahrModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["modul"] = this.modul;
        data["verwaltungsansicht"] = this.verwaltungsansicht;
        return data;
    }
}

export interface IJahrModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
}

export class KREbene implements IKREbene {
    readonly id?: string | undefined;
    isVMHH?: boolean;
    isHHS?: boolean;
    verbergen?: boolean;
    gesamtSumme?: boolean;
    unterabschnitt?: number;
    produktEbene?: string | undefined;
    uaStellen?: number;
    massnahme?: number | undefined;
    untergruppe?: number;
    ugStellen?: number;
    unterkonto?: number;
    bezeichnung?: string | undefined;
    uaText?: string | undefined;
    ugText?: string | undefined;
    beschreibung?: string | undefined;
    beginnJahr?: number | undefined;
    endJahr?: number | undefined;
    krvJ_soll?: number;
    krvJ_haben?: number;
    akrvJ_soll?: number;
    akrvJ_haben?: number;
    ikrvJ_soll?: number;
    ikrvJ_haben?: number;
    nkR_soll?: number;
    nkR_haben?: number;
    krfJ_soll?: number;
    krfJ_haben?: number;
    krvJ_VW_soll?: number;
    krvJ_VW_haben?: number;
    akrvJ_VW_soll?: number;
    akrvJ_VW_haben?: number;
    ikrvJ_VW_soll?: number;
    ikrvJ_VW_haben?: number;
    nkR_VW_soll?: number;
    nkR_VW_haben?: number;
    krvJ_VM_soll?: number;
    krvJ_VM_haben?: number;
    akrvJ_VM_soll?: number;
    akrvJ_VM_haben?: number;
    ikrvJ_VM_soll?: number;
    ikrvJ_VM_haben?: number;
    nkR_VM_soll?: number;
    nkR_VM_haben?: number;
    krfJ_VM_soll?: number;
    krfJ_VM_haben?: number;
    krfJ_VW_soll?: number;
    krfJ_VW_haben?: number;
    krvJ_PJM1_soll?: number;
    krvJ_PJM1_haben?: number;
    akrvJ_PJM1_soll?: number;
    akrvJ_PJM1_haben?: number;
    ikrvJ_PJM1_soll?: number;
    ikrvJ_PJM1_haben?: number;
    nkR_PJM1_soll?: number;
    nkR_PJM1_haben?: number;
    krfJ_PJM1_soll?: number;
    krfJ_PJM1_haben?: number;
    krfJ_PJM1_VM_soll?: number;
    krfJ_PJM1_VM_haben?: number;
    krfJ_PJM1_VW_soll?: number;
    krfJ_PJM1_VW_haben?: number;
    krvJ_PJM2_soll?: number;
    krvJ_PJM2_haben?: number;
    akrvJ_PJM2_soll?: number;
    akrvJ_PJM2_haben?: number;
    ikrvJ_PJM2_soll?: number;
    ikrvJ_PJM2_haben?: number;
    nkR_PJM2_soll?: number;
    nkR_PJM2_haben?: number;
    krfJ_PJM2_soll?: number;
    krfJ_PJM2_haben?: number;
    krfJ_PJM2_VM_soll?: number;
    krfJ_PJM2_VM_haben?: number;
    krfJ_PJM2_VW_soll?: number;
    krfJ_PJM2_VW_haben?: number;
    krvJ_PJM3_soll?: number;
    krvJ_PJM3_haben?: number;
    akrvJ_PJM3_soll?: number;
    akrvJ_PJM3_haben?: number;
    ikrvJ_PJM3_soll?: number;
    ikrvJ_PJM3_haben?: number;
    nkR_PJM3_soll?: number;
    nkR_PJM3_haben?: number;
    krfJ_PJM3_soll?: number;
    krfJ_PJM3_haben?: number;
    krfJ_PJM3_VM_soll?: number;
    krfJ_PJM3_VM_haben?: number;
    krfJ_PJM3_VW_soll?: number;
    krfJ_PJM3_VW_haben?: number;
    krvJ_PJM4_soll?: number;
    krvJ_PJM4_haben?: number;
    akrvJ_PJM4_soll?: number;
    akrvJ_PJM4_haben?: number;
    ikrvJ_PJM4_soll?: number;
    ikrvJ_PJM4_haben?: number;
    nkR_PJM4_soll?: number;
    nkR_PJM4_haben?: number;
    krfJ_PJM4_soll?: number;
    krfJ_PJM4_haben?: number;
    krfJ_PJM4_VM_soll?: number;
    krfJ_PJM4_VM_haben?: number;
    krfJ_PJM4_VW_soll?: number;
    krfJ_PJM4_VW_haben?: number;
    unterEbenen?: KREbene[] | undefined;
    jahre?: number[] | undefined;
    istEinnahme?: boolean;

    constructor(data?: IKREbene) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            this.isVMHH = _data["isVMHH"];
            this.isHHS = _data["isHHS"];
            this.verbergen = _data["verbergen"];
            this.gesamtSumme = _data["gesamtSumme"];
            this.unterabschnitt = _data["unterabschnitt"];
            this.produktEbene = _data["produktEbene"];
            this.uaStellen = _data["uaStellen"];
            this.massnahme = _data["massnahme"];
            this.untergruppe = _data["untergruppe"];
            this.ugStellen = _data["ugStellen"];
            this.unterkonto = _data["unterkonto"];
            this.bezeichnung = _data["bezeichnung"];
            this.uaText = _data["uaText"];
            this.ugText = _data["ugText"];
            this.beschreibung = _data["beschreibung"];
            this.beginnJahr = _data["beginnJahr"];
            this.endJahr = _data["endJahr"];
            this.krvJ_soll = _data["krvJ_soll"];
            this.krvJ_haben = _data["krvJ_haben"];
            this.akrvJ_soll = _data["akrvJ_soll"];
            this.akrvJ_haben = _data["akrvJ_haben"];
            this.ikrvJ_soll = _data["ikrvJ_soll"];
            this.ikrvJ_haben = _data["ikrvJ_haben"];
            this.nkR_soll = _data["nkR_soll"];
            this.nkR_haben = _data["nkR_haben"];
            this.krfJ_soll = _data["krfJ_soll"];
            this.krfJ_haben = _data["krfJ_haben"];
            this.krvJ_VW_soll = _data["krvJ_VW_soll"];
            this.krvJ_VW_haben = _data["krvJ_VW_haben"];
            this.akrvJ_VW_soll = _data["akrvJ_VW_soll"];
            this.akrvJ_VW_haben = _data["akrvJ_VW_haben"];
            this.ikrvJ_VW_soll = _data["ikrvJ_VW_soll"];
            this.ikrvJ_VW_haben = _data["ikrvJ_VW_haben"];
            this.nkR_VW_soll = _data["nkR_VW_soll"];
            this.nkR_VW_haben = _data["nkR_VW_haben"];
            this.krvJ_VM_soll = _data["krvJ_VM_soll"];
            this.krvJ_VM_haben = _data["krvJ_VM_haben"];
            this.akrvJ_VM_soll = _data["akrvJ_VM_soll"];
            this.akrvJ_VM_haben = _data["akrvJ_VM_haben"];
            this.ikrvJ_VM_soll = _data["ikrvJ_VM_soll"];
            this.ikrvJ_VM_haben = _data["ikrvJ_VM_haben"];
            this.nkR_VM_soll = _data["nkR_VM_soll"];
            this.nkR_VM_haben = _data["nkR_VM_haben"];
            this.krfJ_VM_soll = _data["krfJ_VM_soll"];
            this.krfJ_VM_haben = _data["krfJ_VM_haben"];
            this.krfJ_VW_soll = _data["krfJ_VW_soll"];
            this.krfJ_VW_haben = _data["krfJ_VW_haben"];
            this.krvJ_PJM1_soll = _data["krvJ_PJM1_soll"];
            this.krvJ_PJM1_haben = _data["krvJ_PJM1_haben"];
            this.akrvJ_PJM1_soll = _data["akrvJ_PJM1_soll"];
            this.akrvJ_PJM1_haben = _data["akrvJ_PJM1_haben"];
            this.ikrvJ_PJM1_soll = _data["ikrvJ_PJM1_soll"];
            this.ikrvJ_PJM1_haben = _data["ikrvJ_PJM1_haben"];
            this.nkR_PJM1_soll = _data["nkR_PJM1_soll"];
            this.nkR_PJM1_haben = _data["nkR_PJM1_haben"];
            this.krfJ_PJM1_soll = _data["krfJ_PJM1_soll"];
            this.krfJ_PJM1_haben = _data["krfJ_PJM1_haben"];
            this.krfJ_PJM1_VM_soll = _data["krfJ_PJM1_VM_soll"];
            this.krfJ_PJM1_VM_haben = _data["krfJ_PJM1_VM_haben"];
            this.krfJ_PJM1_VW_soll = _data["krfJ_PJM1_VW_soll"];
            this.krfJ_PJM1_VW_haben = _data["krfJ_PJM1_VW_haben"];
            this.krvJ_PJM2_soll = _data["krvJ_PJM2_soll"];
            this.krvJ_PJM2_haben = _data["krvJ_PJM2_haben"];
            this.akrvJ_PJM2_soll = _data["akrvJ_PJM2_soll"];
            this.akrvJ_PJM2_haben = _data["akrvJ_PJM2_haben"];
            this.ikrvJ_PJM2_soll = _data["ikrvJ_PJM2_soll"];
            this.ikrvJ_PJM2_haben = _data["ikrvJ_PJM2_haben"];
            this.nkR_PJM2_soll = _data["nkR_PJM2_soll"];
            this.nkR_PJM2_haben = _data["nkR_PJM2_haben"];
            this.krfJ_PJM2_soll = _data["krfJ_PJM2_soll"];
            this.krfJ_PJM2_haben = _data["krfJ_PJM2_haben"];
            this.krfJ_PJM2_VM_soll = _data["krfJ_PJM2_VM_soll"];
            this.krfJ_PJM2_VM_haben = _data["krfJ_PJM2_VM_haben"];
            this.krfJ_PJM2_VW_soll = _data["krfJ_PJM2_VW_soll"];
            this.krfJ_PJM2_VW_haben = _data["krfJ_PJM2_VW_haben"];
            this.krvJ_PJM3_soll = _data["krvJ_PJM3_soll"];
            this.krvJ_PJM3_haben = _data["krvJ_PJM3_haben"];
            this.akrvJ_PJM3_soll = _data["akrvJ_PJM3_soll"];
            this.akrvJ_PJM3_haben = _data["akrvJ_PJM3_haben"];
            this.ikrvJ_PJM3_soll = _data["ikrvJ_PJM3_soll"];
            this.ikrvJ_PJM3_haben = _data["ikrvJ_PJM3_haben"];
            this.nkR_PJM3_soll = _data["nkR_PJM3_soll"];
            this.nkR_PJM3_haben = _data["nkR_PJM3_haben"];
            this.krfJ_PJM3_soll = _data["krfJ_PJM3_soll"];
            this.krfJ_PJM3_haben = _data["krfJ_PJM3_haben"];
            this.krfJ_PJM3_VM_soll = _data["krfJ_PJM3_VM_soll"];
            this.krfJ_PJM3_VM_haben = _data["krfJ_PJM3_VM_haben"];
            this.krfJ_PJM3_VW_soll = _data["krfJ_PJM3_VW_soll"];
            this.krfJ_PJM3_VW_haben = _data["krfJ_PJM3_VW_haben"];
            this.krvJ_PJM4_soll = _data["krvJ_PJM4_soll"];
            this.krvJ_PJM4_haben = _data["krvJ_PJM4_haben"];
            this.akrvJ_PJM4_soll = _data["akrvJ_PJM4_soll"];
            this.akrvJ_PJM4_haben = _data["akrvJ_PJM4_haben"];
            this.ikrvJ_PJM4_soll = _data["ikrvJ_PJM4_soll"];
            this.ikrvJ_PJM4_haben = _data["ikrvJ_PJM4_haben"];
            this.nkR_PJM4_soll = _data["nkR_PJM4_soll"];
            this.nkR_PJM4_haben = _data["nkR_PJM4_haben"];
            this.krfJ_PJM4_soll = _data["krfJ_PJM4_soll"];
            this.krfJ_PJM4_haben = _data["krfJ_PJM4_haben"];
            this.krfJ_PJM4_VM_soll = _data["krfJ_PJM4_VM_soll"];
            this.krfJ_PJM4_VM_haben = _data["krfJ_PJM4_VM_haben"];
            this.krfJ_PJM4_VW_soll = _data["krfJ_PJM4_VW_soll"];
            this.krfJ_PJM4_VW_haben = _data["krfJ_PJM4_VW_haben"];
            if (Array.isArray(_data["unterEbenen"])) {
                this.unterEbenen = [] as any;
                for (let item of _data["unterEbenen"])
                    this.unterEbenen!.push(KREbene.fromJS(item));
            }
            if (Array.isArray(_data["jahre"])) {
                this.jahre = [] as any;
                for (let item of _data["jahre"])
                    this.jahre!.push(item);
            }
            this.istEinnahme = _data["istEinnahme"];
        }
    }

    static fromJS(data: any): KREbene {
        data = typeof data === 'object' ? data : {};
        let result = new KREbene();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isVMHH"] = this.isVMHH;
        data["isHHS"] = this.isHHS;
        data["verbergen"] = this.verbergen;
        data["gesamtSumme"] = this.gesamtSumme;
        data["unterabschnitt"] = this.unterabschnitt;
        data["produktEbene"] = this.produktEbene;
        data["uaStellen"] = this.uaStellen;
        data["massnahme"] = this.massnahme;
        data["untergruppe"] = this.untergruppe;
        data["ugStellen"] = this.ugStellen;
        data["unterkonto"] = this.unterkonto;
        data["bezeichnung"] = this.bezeichnung;
        data["uaText"] = this.uaText;
        data["ugText"] = this.ugText;
        data["beschreibung"] = this.beschreibung;
        data["beginnJahr"] = this.beginnJahr;
        data["endJahr"] = this.endJahr;
        data["krvJ_soll"] = this.krvJ_soll;
        data["krvJ_haben"] = this.krvJ_haben;
        data["akrvJ_soll"] = this.akrvJ_soll;
        data["akrvJ_haben"] = this.akrvJ_haben;
        data["ikrvJ_soll"] = this.ikrvJ_soll;
        data["ikrvJ_haben"] = this.ikrvJ_haben;
        data["nkR_soll"] = this.nkR_soll;
        data["nkR_haben"] = this.nkR_haben;
        data["krfJ_soll"] = this.krfJ_soll;
        data["krfJ_haben"] = this.krfJ_haben;
        data["krvJ_VW_soll"] = this.krvJ_VW_soll;
        data["krvJ_VW_haben"] = this.krvJ_VW_haben;
        data["akrvJ_VW_soll"] = this.akrvJ_VW_soll;
        data["akrvJ_VW_haben"] = this.akrvJ_VW_haben;
        data["ikrvJ_VW_soll"] = this.ikrvJ_VW_soll;
        data["ikrvJ_VW_haben"] = this.ikrvJ_VW_haben;
        data["nkR_VW_soll"] = this.nkR_VW_soll;
        data["nkR_VW_haben"] = this.nkR_VW_haben;
        data["krvJ_VM_soll"] = this.krvJ_VM_soll;
        data["krvJ_VM_haben"] = this.krvJ_VM_haben;
        data["akrvJ_VM_soll"] = this.akrvJ_VM_soll;
        data["akrvJ_VM_haben"] = this.akrvJ_VM_haben;
        data["ikrvJ_VM_soll"] = this.ikrvJ_VM_soll;
        data["ikrvJ_VM_haben"] = this.ikrvJ_VM_haben;
        data["nkR_VM_soll"] = this.nkR_VM_soll;
        data["nkR_VM_haben"] = this.nkR_VM_haben;
        data["krfJ_VM_soll"] = this.krfJ_VM_soll;
        data["krfJ_VM_haben"] = this.krfJ_VM_haben;
        data["krfJ_VW_soll"] = this.krfJ_VW_soll;
        data["krfJ_VW_haben"] = this.krfJ_VW_haben;
        data["krvJ_PJM1_soll"] = this.krvJ_PJM1_soll;
        data["krvJ_PJM1_haben"] = this.krvJ_PJM1_haben;
        data["akrvJ_PJM1_soll"] = this.akrvJ_PJM1_soll;
        data["akrvJ_PJM1_haben"] = this.akrvJ_PJM1_haben;
        data["ikrvJ_PJM1_soll"] = this.ikrvJ_PJM1_soll;
        data["ikrvJ_PJM1_haben"] = this.ikrvJ_PJM1_haben;
        data["nkR_PJM1_soll"] = this.nkR_PJM1_soll;
        data["nkR_PJM1_haben"] = this.nkR_PJM1_haben;
        data["krfJ_PJM1_soll"] = this.krfJ_PJM1_soll;
        data["krfJ_PJM1_haben"] = this.krfJ_PJM1_haben;
        data["krfJ_PJM1_VM_soll"] = this.krfJ_PJM1_VM_soll;
        data["krfJ_PJM1_VM_haben"] = this.krfJ_PJM1_VM_haben;
        data["krfJ_PJM1_VW_soll"] = this.krfJ_PJM1_VW_soll;
        data["krfJ_PJM1_VW_haben"] = this.krfJ_PJM1_VW_haben;
        data["krvJ_PJM2_soll"] = this.krvJ_PJM2_soll;
        data["krvJ_PJM2_haben"] = this.krvJ_PJM2_haben;
        data["akrvJ_PJM2_soll"] = this.akrvJ_PJM2_soll;
        data["akrvJ_PJM2_haben"] = this.akrvJ_PJM2_haben;
        data["ikrvJ_PJM2_soll"] = this.ikrvJ_PJM2_soll;
        data["ikrvJ_PJM2_haben"] = this.ikrvJ_PJM2_haben;
        data["nkR_PJM2_soll"] = this.nkR_PJM2_soll;
        data["nkR_PJM2_haben"] = this.nkR_PJM2_haben;
        data["krfJ_PJM2_soll"] = this.krfJ_PJM2_soll;
        data["krfJ_PJM2_haben"] = this.krfJ_PJM2_haben;
        data["krfJ_PJM2_VM_soll"] = this.krfJ_PJM2_VM_soll;
        data["krfJ_PJM2_VM_haben"] = this.krfJ_PJM2_VM_haben;
        data["krfJ_PJM2_VW_soll"] = this.krfJ_PJM2_VW_soll;
        data["krfJ_PJM2_VW_haben"] = this.krfJ_PJM2_VW_haben;
        data["krvJ_PJM3_soll"] = this.krvJ_PJM3_soll;
        data["krvJ_PJM3_haben"] = this.krvJ_PJM3_haben;
        data["akrvJ_PJM3_soll"] = this.akrvJ_PJM3_soll;
        data["akrvJ_PJM3_haben"] = this.akrvJ_PJM3_haben;
        data["ikrvJ_PJM3_soll"] = this.ikrvJ_PJM3_soll;
        data["ikrvJ_PJM3_haben"] = this.ikrvJ_PJM3_haben;
        data["nkR_PJM3_soll"] = this.nkR_PJM3_soll;
        data["nkR_PJM3_haben"] = this.nkR_PJM3_haben;
        data["krfJ_PJM3_soll"] = this.krfJ_PJM3_soll;
        data["krfJ_PJM3_haben"] = this.krfJ_PJM3_haben;
        data["krfJ_PJM3_VM_soll"] = this.krfJ_PJM3_VM_soll;
        data["krfJ_PJM3_VM_haben"] = this.krfJ_PJM3_VM_haben;
        data["krfJ_PJM3_VW_soll"] = this.krfJ_PJM3_VW_soll;
        data["krfJ_PJM3_VW_haben"] = this.krfJ_PJM3_VW_haben;
        data["krvJ_PJM4_soll"] = this.krvJ_PJM4_soll;
        data["krvJ_PJM4_haben"] = this.krvJ_PJM4_haben;
        data["akrvJ_PJM4_soll"] = this.akrvJ_PJM4_soll;
        data["akrvJ_PJM4_haben"] = this.akrvJ_PJM4_haben;
        data["ikrvJ_PJM4_soll"] = this.ikrvJ_PJM4_soll;
        data["ikrvJ_PJM4_haben"] = this.ikrvJ_PJM4_haben;
        data["nkR_PJM4_soll"] = this.nkR_PJM4_soll;
        data["nkR_PJM4_haben"] = this.nkR_PJM4_haben;
        data["krfJ_PJM4_soll"] = this.krfJ_PJM4_soll;
        data["krfJ_PJM4_haben"] = this.krfJ_PJM4_haben;
        data["krfJ_PJM4_VM_soll"] = this.krfJ_PJM4_VM_soll;
        data["krfJ_PJM4_VM_haben"] = this.krfJ_PJM4_VM_haben;
        data["krfJ_PJM4_VW_soll"] = this.krfJ_PJM4_VW_soll;
        data["krfJ_PJM4_VW_haben"] = this.krfJ_PJM4_VW_haben;
        if (Array.isArray(this.unterEbenen)) {
            data["unterEbenen"] = [];
            for (let item of this.unterEbenen)
                data["unterEbenen"].push(item.toJSON());
        }
        if (Array.isArray(this.jahre)) {
            data["jahre"] = [];
            for (let item of this.jahre)
                data["jahre"].push(item);
        }
        data["istEinnahme"] = this.istEinnahme;
        return data;
    }
}

export interface IKREbene {
    id?: string | undefined;
    isVMHH?: boolean;
    isHHS?: boolean;
    verbergen?: boolean;
    gesamtSumme?: boolean;
    unterabschnitt?: number;
    produktEbene?: string | undefined;
    uaStellen?: number;
    massnahme?: number | undefined;
    untergruppe?: number;
    ugStellen?: number;
    unterkonto?: number;
    bezeichnung?: string | undefined;
    uaText?: string | undefined;
    ugText?: string | undefined;
    beschreibung?: string | undefined;
    beginnJahr?: number | undefined;
    endJahr?: number | undefined;
    krvJ_soll?: number;
    krvJ_haben?: number;
    akrvJ_soll?: number;
    akrvJ_haben?: number;
    ikrvJ_soll?: number;
    ikrvJ_haben?: number;
    nkR_soll?: number;
    nkR_haben?: number;
    krfJ_soll?: number;
    krfJ_haben?: number;
    krvJ_VW_soll?: number;
    krvJ_VW_haben?: number;
    akrvJ_VW_soll?: number;
    akrvJ_VW_haben?: number;
    ikrvJ_VW_soll?: number;
    ikrvJ_VW_haben?: number;
    nkR_VW_soll?: number;
    nkR_VW_haben?: number;
    krvJ_VM_soll?: number;
    krvJ_VM_haben?: number;
    akrvJ_VM_soll?: number;
    akrvJ_VM_haben?: number;
    ikrvJ_VM_soll?: number;
    ikrvJ_VM_haben?: number;
    nkR_VM_soll?: number;
    nkR_VM_haben?: number;
    krfJ_VM_soll?: number;
    krfJ_VM_haben?: number;
    krfJ_VW_soll?: number;
    krfJ_VW_haben?: number;
    krvJ_PJM1_soll?: number;
    krvJ_PJM1_haben?: number;
    akrvJ_PJM1_soll?: number;
    akrvJ_PJM1_haben?: number;
    ikrvJ_PJM1_soll?: number;
    ikrvJ_PJM1_haben?: number;
    nkR_PJM1_soll?: number;
    nkR_PJM1_haben?: number;
    krfJ_PJM1_soll?: number;
    krfJ_PJM1_haben?: number;
    krfJ_PJM1_VM_soll?: number;
    krfJ_PJM1_VM_haben?: number;
    krfJ_PJM1_VW_soll?: number;
    krfJ_PJM1_VW_haben?: number;
    krvJ_PJM2_soll?: number;
    krvJ_PJM2_haben?: number;
    akrvJ_PJM2_soll?: number;
    akrvJ_PJM2_haben?: number;
    ikrvJ_PJM2_soll?: number;
    ikrvJ_PJM2_haben?: number;
    nkR_PJM2_soll?: number;
    nkR_PJM2_haben?: number;
    krfJ_PJM2_soll?: number;
    krfJ_PJM2_haben?: number;
    krfJ_PJM2_VM_soll?: number;
    krfJ_PJM2_VM_haben?: number;
    krfJ_PJM2_VW_soll?: number;
    krfJ_PJM2_VW_haben?: number;
    krvJ_PJM3_soll?: number;
    krvJ_PJM3_haben?: number;
    akrvJ_PJM3_soll?: number;
    akrvJ_PJM3_haben?: number;
    ikrvJ_PJM3_soll?: number;
    ikrvJ_PJM3_haben?: number;
    nkR_PJM3_soll?: number;
    nkR_PJM3_haben?: number;
    krfJ_PJM3_soll?: number;
    krfJ_PJM3_haben?: number;
    krfJ_PJM3_VM_soll?: number;
    krfJ_PJM3_VM_haben?: number;
    krfJ_PJM3_VW_soll?: number;
    krfJ_PJM3_VW_haben?: number;
    krvJ_PJM4_soll?: number;
    krvJ_PJM4_haben?: number;
    akrvJ_PJM4_soll?: number;
    akrvJ_PJM4_haben?: number;
    ikrvJ_PJM4_soll?: number;
    ikrvJ_PJM4_haben?: number;
    nkR_PJM4_soll?: number;
    nkR_PJM4_haben?: number;
    krfJ_PJM4_soll?: number;
    krfJ_PJM4_haben?: number;
    krfJ_PJM4_VM_soll?: number;
    krfJ_PJM4_VM_haben?: number;
    krfJ_PJM4_VW_soll?: number;
    krfJ_PJM4_VW_haben?: number;
    unterEbenen?: KREbene[] | undefined;
    jahre?: number[] | undefined;
    istEinnahme?: boolean;
}

export class KSLPlusAskRequest implements IKSLPlusAskRequest {
    threadID?: string | undefined;
    frage?: string | undefined;
    thema?: string | undefined;
    subThema?: string | undefined;
    app?: string | undefined;

    constructor(data?: IKSLPlusAskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.threadID = _data["threadID"];
            this.frage = _data["frage"];
            this.thema = _data["thema"];
            this.subThema = _data["subThema"];
            this.app = _data["app"];
        }
    }

    static fromJS(data: any): KSLPlusAskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new KSLPlusAskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["threadID"] = this.threadID;
        data["frage"] = this.frage;
        data["thema"] = this.thema;
        data["subThema"] = this.subThema;
        data["app"] = this.app;
        return data;
    }
}

export interface IKSLPlusAskRequest {
    threadID?: string | undefined;
    frage?: string | undefined;
    thema?: string | undefined;
    subThema?: string | undefined;
    app?: string | undefined;
}

export enum KeepTogether {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class Kennzahl2Gzebene implements IKennzahl2Gzebene {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    kennzahlId?: string | undefined;
    gzebene?: string | undefined;
    nurVgl?: boolean;

    constructor(data?: IKennzahl2Gzebene) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.kennzahlId = _data["kennzahlId"];
            this.gzebene = _data["gzebene"];
            this.nurVgl = _data["nurVgl"];
        }
    }

    static fromJS(data: any): Kennzahl2Gzebene {
        data = typeof data === 'object' ? data : {};
        let result = new Kennzahl2Gzebene();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["kennzahlId"] = this.kennzahlId;
        data["gzebene"] = this.gzebene;
        data["nurVgl"] = this.nurVgl;
        return data;
    }
}

export interface IKennzahl2Gzebene {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    kennzahlId?: string | undefined;
    gzebene?: string | undefined;
    nurVgl?: boolean;
}

export class Kennzahl2Vbtab implements IKennzahl2Vbtab {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    kennzahlId?: string | undefined;
    vbtabId?: string | undefined;
    nurVgl?: boolean;

    constructor(data?: IKennzahl2Vbtab) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.kennzahlId = _data["kennzahlId"];
            this.vbtabId = _data["vbtabId"];
            this.nurVgl = _data["nurVgl"];
        }
    }

    static fromJS(data: any): Kennzahl2Vbtab {
        data = typeof data === 'object' ? data : {};
        let result = new Kennzahl2Vbtab();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["kennzahlId"] = this.kennzahlId;
        data["vbtabId"] = this.vbtabId;
        data["nurVgl"] = this.nurVgl;
        return data;
    }
}

export interface IKennzahl2Vbtab {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    kennzahlId?: string | undefined;
    vbtabId?: string | undefined;
    nurVgl?: boolean;
}

export class KennzahlModel implements IKennzahlModel {
    zeilen?: KennzahlZeilenErgebnis[] | undefined;
    kennzahl?: KennzahlenSubModel;
    jahre?: number[] | undefined;
    status?: string | undefined;
    jahr?: number;
    plantyp?: number;

    constructor(data?: IKennzahlModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["zeilen"])) {
                this.zeilen = [] as any;
                for (let item of _data["zeilen"])
                    this.zeilen!.push(KennzahlZeilenErgebnis.fromJS(item));
            }
            this.kennzahl = _data["kennzahl"] ? KennzahlenSubModel.fromJS(_data["kennzahl"]) : <any>undefined;
            if (Array.isArray(_data["jahre"])) {
                this.jahre = [] as any;
                for (let item of _data["jahre"])
                    this.jahre!.push(item);
            }
            this.status = _data["status"];
            this.jahr = _data["jahr"];
            this.plantyp = _data["plantyp"];
        }
    }

    static fromJS(data: any): KennzahlModel {
        data = typeof data === 'object' ? data : {};
        let result = new KennzahlModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.zeilen)) {
            data["zeilen"] = [];
            for (let item of this.zeilen)
                data["zeilen"].push(item.toJSON());
        }
        data["kennzahl"] = this.kennzahl ? this.kennzahl.toJSON() : <any>undefined;
        if (Array.isArray(this.jahre)) {
            data["jahre"] = [];
            for (let item of this.jahre)
                data["jahre"].push(item);
        }
        data["status"] = this.status;
        data["jahr"] = this.jahr;
        data["plantyp"] = this.plantyp;
        return data;
    }
}

export interface IKennzahlModel {
    zeilen?: KennzahlZeilenErgebnis[] | undefined;
    kennzahl?: KennzahlenSubModel;
    jahre?: number[] | undefined;
    status?: string | undefined;
    jahr?: number;
    plantyp?: number;
}

export class KennzahlRequest implements IKennzahlRequest {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    plantyp?: number;
    planstufe?: number;
    uhConfig?: number;
    kennzahl?: number;
    verwaltungsansicht?: boolean | undefined;
    produkt?: string | undefined;
    zeilen?: Kennzahlzeilen[] | undefined;

    constructor(data?: IKennzahlRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.plantyp = _data["plantyp"];
            this.planstufe = _data["planstufe"];
            this.uhConfig = _data["uhConfig"];
            this.kennzahl = _data["kennzahl"];
            this.verwaltungsansicht = _data["verwaltungsansicht"];
            this.produkt = _data["produkt"];
            if (Array.isArray(_data["zeilen"])) {
                this.zeilen = [] as any;
                for (let item of _data["zeilen"])
                    this.zeilen!.push(Kennzahlzeilen.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KennzahlRequest {
        data = typeof data === 'object' ? data : {};
        let result = new KennzahlRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["plantyp"] = this.plantyp;
        data["planstufe"] = this.planstufe;
        data["uhConfig"] = this.uhConfig;
        data["kennzahl"] = this.kennzahl;
        data["verwaltungsansicht"] = this.verwaltungsansicht;
        data["produkt"] = this.produkt;
        if (Array.isArray(this.zeilen)) {
            data["zeilen"] = [];
            for (let item of this.zeilen)
                data["zeilen"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKennzahlRequest {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    plantyp?: number;
    planstufe?: number;
    uhConfig?: number;
    kennzahl?: number;
    verwaltungsansicht?: boolean | undefined;
    produkt?: string | undefined;
    zeilen?: Kennzahlzeilen[] | undefined;
}

export class KennzahlWert implements IKennzahlWert {
    wert?: number | undefined;
    nk?: number | undefined;
    einheit?: string | undefined;
    kennzahl?: KennzahlenSubModel;
    kennzahlErg?: KennzahlModel;
    plantyp?: number;
    planstufe?: number;
    jahr?: number;
    kennzahlId?: number;

    constructor(data?: IKennzahlWert) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wert = _data["wert"];
            this.nk = _data["nk"];
            this.einheit = _data["einheit"];
            this.kennzahl = _data["kennzahl"] ? KennzahlenSubModel.fromJS(_data["kennzahl"]) : <any>undefined;
            this.kennzahlErg = _data["kennzahlErg"] ? KennzahlModel.fromJS(_data["kennzahlErg"]) : <any>undefined;
            this.plantyp = _data["plantyp"];
            this.planstufe = _data["planstufe"];
            this.jahr = _data["jahr"];
            this.kennzahlId = _data["kennzahlId"];
        }
    }

    static fromJS(data: any): KennzahlWert {
        data = typeof data === 'object' ? data : {};
        let result = new KennzahlWert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wert"] = this.wert;
        data["nk"] = this.nk;
        data["einheit"] = this.einheit;
        data["kennzahl"] = this.kennzahl ? this.kennzahl.toJSON() : <any>undefined;
        data["kennzahlErg"] = this.kennzahlErg ? this.kennzahlErg.toJSON() : <any>undefined;
        data["plantyp"] = this.plantyp;
        data["planstufe"] = this.planstufe;
        data["jahr"] = this.jahr;
        data["kennzahlId"] = this.kennzahlId;
        return data;
    }
}

export interface IKennzahlWert {
    wert?: number | undefined;
    nk?: number | undefined;
    einheit?: string | undefined;
    kennzahl?: KennzahlenSubModel;
    kennzahlErg?: KennzahlModel;
    plantyp?: number;
    planstufe?: number;
    jahr?: number;
    kennzahlId?: number;
}

export class KennzahlZeilenErgebnis implements IKennzahlZeilenErgebnis {
    id?: string | undefined;
    zeile?: KennzahlzeilenModel;
    bezeichnung?: string | undefined;
    ergebnisVvvJ?: number;
    ergebnisVvvJ_Z?: number | undefined;
    ergebnisVvJ?: number;
    ergebnisVvJ_Z?: number | undefined;
    ergebnisVJ?: number;
    ergebnisVJ_Z?: number | undefined;
    ergebnisPJ?: number;
    ergebnisPJ_Z?: number | undefined;
    ergebnisPJ1?: number;
    ergebnisPJ1_Z?: number | undefined;
    ergebnisFp1?: number;
    ergebnisFp1_Z?: number | undefined;
    ergebnisFp2?: number;
    ergebnisFp2_Z?: number | undefined;
    ergebnisFp3?: number;
    ergebnisFp3_Z?: number | undefined;
    ergebnisFp4?: number;
    ergebnisFp4_Z?: number | undefined;
    ergebnisFp5?: number;
    ergebnisFp5_Z?: number | undefined;
    ergebnisFp6?: number;
    ergebnisFp6_Z?: number | undefined;
    ergebnisFp7?: number;
    ergebnisFp7_Z?: number | undefined;
    ergebnisFp8?: number;
    ergebnisFp8_Z?: number | undefined;
    ergebnisFp9?: number;
    ergebnisFp9_Z?: number | undefined;
    ergebnisFp10?: number;
    ergebnisFp10_Z?: number | undefined;
    ergebnisPJM1?: number;
    ergebnisPJM1_Z?: number | undefined;
    ergebnisPJM2?: number;
    ergebnisPJM2_Z?: number | undefined;
    ergebnisPJM3?: number;
    ergebnisPJM3_Z?: number | undefined;
    ergebnisPJM4?: number;
    ergebnisPJM4_Z?: number | undefined;
    einheit?: string | undefined;
    darstellung?: number | undefined;
    zusatzangabe?: number | undefined;
    darstellungZusatzangabe?: number | undefined;
    bezeichnungZusatzangabe?: string | undefined;
    istErgebnisZeile?: boolean;

    constructor(data?: IKennzahlZeilenErgebnis) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.zeile = _data["zeile"] ? KennzahlzeilenModel.fromJS(_data["zeile"]) : <any>undefined;
            this.bezeichnung = _data["bezeichnung"];
            this.ergebnisVvvJ = _data["ergebnisVvvJ"];
            this.ergebnisVvvJ_Z = _data["ergebnisVvvJ_Z"];
            this.ergebnisVvJ = _data["ergebnisVvJ"];
            this.ergebnisVvJ_Z = _data["ergebnisVvJ_Z"];
            this.ergebnisVJ = _data["ergebnisVJ"];
            this.ergebnisVJ_Z = _data["ergebnisVJ_Z"];
            this.ergebnisPJ = _data["ergebnisPJ"];
            this.ergebnisPJ_Z = _data["ergebnisPJ_Z"];
            this.ergebnisPJ1 = _data["ergebnisPJ1"];
            this.ergebnisPJ1_Z = _data["ergebnisPJ1_Z"];
            this.ergebnisFp1 = _data["ergebnisFp1"];
            this.ergebnisFp1_Z = _data["ergebnisFp1_Z"];
            this.ergebnisFp2 = _data["ergebnisFp2"];
            this.ergebnisFp2_Z = _data["ergebnisFp2_Z"];
            this.ergebnisFp3 = _data["ergebnisFp3"];
            this.ergebnisFp3_Z = _data["ergebnisFp3_Z"];
            this.ergebnisFp4 = _data["ergebnisFp4"];
            this.ergebnisFp4_Z = _data["ergebnisFp4_Z"];
            this.ergebnisFp5 = _data["ergebnisFp5"];
            this.ergebnisFp5_Z = _data["ergebnisFp5_Z"];
            this.ergebnisFp6 = _data["ergebnisFp6"];
            this.ergebnisFp6_Z = _data["ergebnisFp6_Z"];
            this.ergebnisFp7 = _data["ergebnisFp7"];
            this.ergebnisFp7_Z = _data["ergebnisFp7_Z"];
            this.ergebnisFp8 = _data["ergebnisFp8"];
            this.ergebnisFp8_Z = _data["ergebnisFp8_Z"];
            this.ergebnisFp9 = _data["ergebnisFp9"];
            this.ergebnisFp9_Z = _data["ergebnisFp9_Z"];
            this.ergebnisFp10 = _data["ergebnisFp10"];
            this.ergebnisFp10_Z = _data["ergebnisFp10_Z"];
            this.ergebnisPJM1 = _data["ergebnisPJM1"];
            this.ergebnisPJM1_Z = _data["ergebnisPJM1_Z"];
            this.ergebnisPJM2 = _data["ergebnisPJM2"];
            this.ergebnisPJM2_Z = _data["ergebnisPJM2_Z"];
            this.ergebnisPJM3 = _data["ergebnisPJM3"];
            this.ergebnisPJM3_Z = _data["ergebnisPJM3_Z"];
            this.ergebnisPJM4 = _data["ergebnisPJM4"];
            this.ergebnisPJM4_Z = _data["ergebnisPJM4_Z"];
            this.einheit = _data["einheit"];
            this.darstellung = _data["darstellung"];
            this.zusatzangabe = _data["zusatzangabe"];
            this.darstellungZusatzangabe = _data["darstellungZusatzangabe"];
            this.bezeichnungZusatzangabe = _data["bezeichnungZusatzangabe"];
            this.istErgebnisZeile = _data["istErgebnisZeile"];
        }
    }

    static fromJS(data: any): KennzahlZeilenErgebnis {
        data = typeof data === 'object' ? data : {};
        let result = new KennzahlZeilenErgebnis();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["zeile"] = this.zeile ? this.zeile.toJSON() : <any>undefined;
        data["bezeichnung"] = this.bezeichnung;
        data["ergebnisVvvJ"] = this.ergebnisVvvJ;
        data["ergebnisVvvJ_Z"] = this.ergebnisVvvJ_Z;
        data["ergebnisVvJ"] = this.ergebnisVvJ;
        data["ergebnisVvJ_Z"] = this.ergebnisVvJ_Z;
        data["ergebnisVJ"] = this.ergebnisVJ;
        data["ergebnisVJ_Z"] = this.ergebnisVJ_Z;
        data["ergebnisPJ"] = this.ergebnisPJ;
        data["ergebnisPJ_Z"] = this.ergebnisPJ_Z;
        data["ergebnisPJ1"] = this.ergebnisPJ1;
        data["ergebnisPJ1_Z"] = this.ergebnisPJ1_Z;
        data["ergebnisFp1"] = this.ergebnisFp1;
        data["ergebnisFp1_Z"] = this.ergebnisFp1_Z;
        data["ergebnisFp2"] = this.ergebnisFp2;
        data["ergebnisFp2_Z"] = this.ergebnisFp2_Z;
        data["ergebnisFp3"] = this.ergebnisFp3;
        data["ergebnisFp3_Z"] = this.ergebnisFp3_Z;
        data["ergebnisFp4"] = this.ergebnisFp4;
        data["ergebnisFp4_Z"] = this.ergebnisFp4_Z;
        data["ergebnisFp5"] = this.ergebnisFp5;
        data["ergebnisFp5_Z"] = this.ergebnisFp5_Z;
        data["ergebnisFp6"] = this.ergebnisFp6;
        data["ergebnisFp6_Z"] = this.ergebnisFp6_Z;
        data["ergebnisFp7"] = this.ergebnisFp7;
        data["ergebnisFp7_Z"] = this.ergebnisFp7_Z;
        data["ergebnisFp8"] = this.ergebnisFp8;
        data["ergebnisFp8_Z"] = this.ergebnisFp8_Z;
        data["ergebnisFp9"] = this.ergebnisFp9;
        data["ergebnisFp9_Z"] = this.ergebnisFp9_Z;
        data["ergebnisFp10"] = this.ergebnisFp10;
        data["ergebnisFp10_Z"] = this.ergebnisFp10_Z;
        data["ergebnisPJM1"] = this.ergebnisPJM1;
        data["ergebnisPJM1_Z"] = this.ergebnisPJM1_Z;
        data["ergebnisPJM2"] = this.ergebnisPJM2;
        data["ergebnisPJM2_Z"] = this.ergebnisPJM2_Z;
        data["ergebnisPJM3"] = this.ergebnisPJM3;
        data["ergebnisPJM3_Z"] = this.ergebnisPJM3_Z;
        data["ergebnisPJM4"] = this.ergebnisPJM4;
        data["ergebnisPJM4_Z"] = this.ergebnisPJM4_Z;
        data["einheit"] = this.einheit;
        data["darstellung"] = this.darstellung;
        data["zusatzangabe"] = this.zusatzangabe;
        data["darstellungZusatzangabe"] = this.darstellungZusatzangabe;
        data["bezeichnungZusatzangabe"] = this.bezeichnungZusatzangabe;
        data["istErgebnisZeile"] = this.istErgebnisZeile;
        return data;
    }
}

export interface IKennzahlZeilenErgebnis {
    id?: string | undefined;
    zeile?: KennzahlzeilenModel;
    bezeichnung?: string | undefined;
    ergebnisVvvJ?: number;
    ergebnisVvvJ_Z?: number | undefined;
    ergebnisVvJ?: number;
    ergebnisVvJ_Z?: number | undefined;
    ergebnisVJ?: number;
    ergebnisVJ_Z?: number | undefined;
    ergebnisPJ?: number;
    ergebnisPJ_Z?: number | undefined;
    ergebnisPJ1?: number;
    ergebnisPJ1_Z?: number | undefined;
    ergebnisFp1?: number;
    ergebnisFp1_Z?: number | undefined;
    ergebnisFp2?: number;
    ergebnisFp2_Z?: number | undefined;
    ergebnisFp3?: number;
    ergebnisFp3_Z?: number | undefined;
    ergebnisFp4?: number;
    ergebnisFp4_Z?: number | undefined;
    ergebnisFp5?: number;
    ergebnisFp5_Z?: number | undefined;
    ergebnisFp6?: number;
    ergebnisFp6_Z?: number | undefined;
    ergebnisFp7?: number;
    ergebnisFp7_Z?: number | undefined;
    ergebnisFp8?: number;
    ergebnisFp8_Z?: number | undefined;
    ergebnisFp9?: number;
    ergebnisFp9_Z?: number | undefined;
    ergebnisFp10?: number;
    ergebnisFp10_Z?: number | undefined;
    ergebnisPJM1?: number;
    ergebnisPJM1_Z?: number | undefined;
    ergebnisPJM2?: number;
    ergebnisPJM2_Z?: number | undefined;
    ergebnisPJM3?: number;
    ergebnisPJM3_Z?: number | undefined;
    ergebnisPJM4?: number;
    ergebnisPJM4_Z?: number | undefined;
    einheit?: string | undefined;
    darstellung?: number | undefined;
    zusatzangabe?: number | undefined;
    darstellungZusatzangabe?: number | undefined;
    bezeichnungZusatzangabe?: string | undefined;
    istErgebnisZeile?: boolean;
}

export class Kennzahlen implements IKennzahlen {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    beschreibung?: string | undefined;
    darstellung?: number | undefined;
    bezeichnungDarstellung?: string | undefined;
    darstellungZusatzangaben?: number | undefined;
    bezeichnungDarstellungZusatzangaben?: string | undefined;
    nichtHp?: boolean | undefined;
    nichtJr?: boolean | undefined;
    bilanz?: boolean | undefined;
    order?: number | undefined;
    nichtUh?: boolean | undefined;
    produkt?: string | undefined;
    kztyp?: number | undefined;
    vergleichbar?: boolean | undefined;
    keZahlId?: string | undefined;
    erlTextVgl?: string | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;
    kennzahlzeilens?: Kennzahlzeilen[] | undefined;

    constructor(data?: IKennzahlen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.bezeichnung = _data["bezeichnung"];
            this.beschreibung = _data["beschreibung"];
            this.darstellung = _data["darstellung"];
            this.bezeichnungDarstellung = _data["bezeichnungDarstellung"];
            this.darstellungZusatzangaben = _data["darstellungZusatzangaben"];
            this.bezeichnungDarstellungZusatzangaben = _data["bezeichnungDarstellungZusatzangaben"];
            this.nichtHp = _data["nichtHp"];
            this.nichtJr = _data["nichtJr"];
            this.bilanz = _data["bilanz"];
            this.order = _data["order"];
            this.nichtUh = _data["nichtUh"];
            this.produkt = _data["produkt"];
            this.kztyp = _data["kztyp"];
            this.vergleichbar = _data["vergleichbar"];
            this.keZahlId = _data["keZahlId"];
            this.erlTextVgl = _data["erlTextVgl"];
            this.oeffentlich = _data["oeffentlich"];
            this.oeffentlichVerwaltung = _data["oeffentlichVerwaltung"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
            if (Array.isArray(_data["kennzahlzeilens"])) {
                this.kennzahlzeilens = [] as any;
                for (let item of _data["kennzahlzeilens"])
                    this.kennzahlzeilens!.push(Kennzahlzeilen.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Kennzahlen {
        data = typeof data === 'object' ? data : {};
        let result = new Kennzahlen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["bezeichnung"] = this.bezeichnung;
        data["beschreibung"] = this.beschreibung;
        data["darstellung"] = this.darstellung;
        data["bezeichnungDarstellung"] = this.bezeichnungDarstellung;
        data["darstellungZusatzangaben"] = this.darstellungZusatzangaben;
        data["bezeichnungDarstellungZusatzangaben"] = this.bezeichnungDarstellungZusatzangaben;
        data["nichtHp"] = this.nichtHp;
        data["nichtJr"] = this.nichtJr;
        data["bilanz"] = this.bilanz;
        data["order"] = this.order;
        data["nichtUh"] = this.nichtUh;
        data["produkt"] = this.produkt;
        data["kztyp"] = this.kztyp;
        data["vergleichbar"] = this.vergleichbar;
        data["keZahlId"] = this.keZahlId;
        data["erlTextVgl"] = this.erlTextVgl;
        data["oeffentlich"] = this.oeffentlich;
        data["oeffentlichVerwaltung"] = this.oeffentlichVerwaltung;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        if (Array.isArray(this.kennzahlzeilens)) {
            data["kennzahlzeilens"] = [];
            for (let item of this.kennzahlzeilens)
                data["kennzahlzeilens"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKennzahlen {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    beschreibung?: string | undefined;
    darstellung?: number | undefined;
    bezeichnungDarstellung?: string | undefined;
    darstellungZusatzangaben?: number | undefined;
    bezeichnungDarstellungZusatzangaben?: string | undefined;
    nichtHp?: boolean | undefined;
    nichtJr?: boolean | undefined;
    bilanz?: boolean | undefined;
    order?: number | undefined;
    nichtUh?: boolean | undefined;
    produkt?: string | undefined;
    kztyp?: number | undefined;
    vergleichbar?: boolean | undefined;
    keZahlId?: string | undefined;
    erlTextVgl?: string | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;
    kennzahlzeilens?: Kennzahlzeilen[] | undefined;
}

export class KennzahlenSubModel implements IKennzahlenSubModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    beschreibung?: string | undefined;
    darstellung?: number | undefined;
    bezeichnungDarstellung?: string | undefined;
    darstellungZusatzangaben?: number | undefined;
    bezeichnungDarstellungZusatzangaben?: string | undefined;
    nichtHp?: boolean | undefined;
    nichtJr?: boolean | undefined;
    bilanz?: boolean | undefined;
    order?: number | undefined;
    nichtUh?: boolean | undefined;
    produkt?: string | undefined;
    kztyp?: number | undefined;
    vergleichbar?: boolean | undefined;
    keZahlId?: string | undefined;
    erlTextVgl?: string | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;
    kennzahlzeilens?: Kennzahlzeilen[] | undefined;

    constructor(data?: IKennzahlenSubModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.bezeichnung = _data["bezeichnung"];
            this.beschreibung = _data["beschreibung"];
            this.darstellung = _data["darstellung"];
            this.bezeichnungDarstellung = _data["bezeichnungDarstellung"];
            this.darstellungZusatzangaben = _data["darstellungZusatzangaben"];
            this.bezeichnungDarstellungZusatzangaben = _data["bezeichnungDarstellungZusatzangaben"];
            this.nichtHp = _data["nichtHp"];
            this.nichtJr = _data["nichtJr"];
            this.bilanz = _data["bilanz"];
            this.order = _data["order"];
            this.nichtUh = _data["nichtUh"];
            this.produkt = _data["produkt"];
            this.kztyp = _data["kztyp"];
            this.vergleichbar = _data["vergleichbar"];
            this.keZahlId = _data["keZahlId"];
            this.erlTextVgl = _data["erlTextVgl"];
            this.oeffentlich = _data["oeffentlich"];
            this.oeffentlichVerwaltung = _data["oeffentlichVerwaltung"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
            if (Array.isArray(_data["kennzahlzeilens"])) {
                this.kennzahlzeilens = [] as any;
                for (let item of _data["kennzahlzeilens"])
                    this.kennzahlzeilens!.push(Kennzahlzeilen.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KennzahlenSubModel {
        data = typeof data === 'object' ? data : {};
        let result = new KennzahlenSubModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["bezeichnung"] = this.bezeichnung;
        data["beschreibung"] = this.beschreibung;
        data["darstellung"] = this.darstellung;
        data["bezeichnungDarstellung"] = this.bezeichnungDarstellung;
        data["darstellungZusatzangaben"] = this.darstellungZusatzangaben;
        data["bezeichnungDarstellungZusatzangaben"] = this.bezeichnungDarstellungZusatzangaben;
        data["nichtHp"] = this.nichtHp;
        data["nichtJr"] = this.nichtJr;
        data["bilanz"] = this.bilanz;
        data["order"] = this.order;
        data["nichtUh"] = this.nichtUh;
        data["produkt"] = this.produkt;
        data["kztyp"] = this.kztyp;
        data["vergleichbar"] = this.vergleichbar;
        data["keZahlId"] = this.keZahlId;
        data["erlTextVgl"] = this.erlTextVgl;
        data["oeffentlich"] = this.oeffentlich;
        data["oeffentlichVerwaltung"] = this.oeffentlichVerwaltung;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        if (Array.isArray(this.kennzahlzeilens)) {
            data["kennzahlzeilens"] = [];
            for (let item of this.kennzahlzeilens)
                data["kennzahlzeilens"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKennzahlenSubModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    beschreibung?: string | undefined;
    darstellung?: number | undefined;
    bezeichnungDarstellung?: string | undefined;
    darstellungZusatzangaben?: number | undefined;
    bezeichnungDarstellungZusatzangaben?: string | undefined;
    nichtHp?: boolean | undefined;
    nichtJr?: boolean | undefined;
    bilanz?: boolean | undefined;
    order?: number | undefined;
    nichtUh?: boolean | undefined;
    produkt?: string | undefined;
    kztyp?: number | undefined;
    vergleichbar?: boolean | undefined;
    keZahlId?: string | undefined;
    erlTextVgl?: string | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;
    kennzahlzeilens?: Kennzahlzeilen[] | undefined;
}

export class KennzahlenVergleichModel implements IKennzahlenVergleichModel {
    jahr?: number;
    gemeindeKennzahlen?: GemeindeKennzahlenModel[] | undefined;
    kennzahlenNamen?: string[] | undefined;
    kommunenTypen?: Kommunentypen[] | undefined;
    vergleichskreise?: Ktvergleichskreise[] | undefined;
    userSettings?: { [key: string]: UserKennzahlenVglSettingsModel; } | undefined;
    kunden?: KundenModel[] | undefined;

    constructor(data?: IKennzahlenVergleichModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jahr = _data["jahr"];
            if (Array.isArray(_data["gemeindeKennzahlen"])) {
                this.gemeindeKennzahlen = [] as any;
                for (let item of _data["gemeindeKennzahlen"])
                    this.gemeindeKennzahlen!.push(GemeindeKennzahlenModel.fromJS(item));
            }
            if (Array.isArray(_data["kennzahlenNamen"])) {
                this.kennzahlenNamen = [] as any;
                for (let item of _data["kennzahlenNamen"])
                    this.kennzahlenNamen!.push(item);
            }
            if (Array.isArray(_data["kommunenTypen"])) {
                this.kommunenTypen = [] as any;
                for (let item of _data["kommunenTypen"])
                    this.kommunenTypen!.push(Kommunentypen.fromJS(item));
            }
            if (Array.isArray(_data["vergleichskreise"])) {
                this.vergleichskreise = [] as any;
                for (let item of _data["vergleichskreise"])
                    this.vergleichskreise!.push(Ktvergleichskreise.fromJS(item));
            }
            if (_data["userSettings"]) {
                this.userSettings = {} as any;
                for (let key in _data["userSettings"]) {
                    if (_data["userSettings"].hasOwnProperty(key))
                        (<any>this.userSettings)![key] = _data["userSettings"][key] ? UserKennzahlenVglSettingsModel.fromJS(_data["userSettings"][key]) : new UserKennzahlenVglSettingsModel();
                }
            }
            if (Array.isArray(_data["kunden"])) {
                this.kunden = [] as any;
                for (let item of _data["kunden"])
                    this.kunden!.push(KundenModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KennzahlenVergleichModel {
        data = typeof data === 'object' ? data : {};
        let result = new KennzahlenVergleichModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jahr"] = this.jahr;
        if (Array.isArray(this.gemeindeKennzahlen)) {
            data["gemeindeKennzahlen"] = [];
            for (let item of this.gemeindeKennzahlen)
                data["gemeindeKennzahlen"].push(item.toJSON());
        }
        if (Array.isArray(this.kennzahlenNamen)) {
            data["kennzahlenNamen"] = [];
            for (let item of this.kennzahlenNamen)
                data["kennzahlenNamen"].push(item);
        }
        if (Array.isArray(this.kommunenTypen)) {
            data["kommunenTypen"] = [];
            for (let item of this.kommunenTypen)
                data["kommunenTypen"].push(item.toJSON());
        }
        if (Array.isArray(this.vergleichskreise)) {
            data["vergleichskreise"] = [];
            for (let item of this.vergleichskreise)
                data["vergleichskreise"].push(item.toJSON());
        }
        if (this.userSettings) {
            data["userSettings"] = {};
            for (let key in this.userSettings) {
                if (this.userSettings.hasOwnProperty(key))
                    (<any>data["userSettings"])[key] = this.userSettings[key] ? this.userSettings[key].toJSON() : <any>undefined;
            }
        }
        if (Array.isArray(this.kunden)) {
            data["kunden"] = [];
            for (let item of this.kunden)
                data["kunden"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKennzahlenVergleichModel {
    jahr?: number;
    gemeindeKennzahlen?: GemeindeKennzahlenModel[] | undefined;
    kennzahlenNamen?: string[] | undefined;
    kommunenTypen?: Kommunentypen[] | undefined;
    vergleichskreise?: Ktvergleichskreise[] | undefined;
    userSettings?: { [key: string]: UserKennzahlenVglSettingsModel; } | undefined;
    kunden?: KundenModel[] | undefined;
}

export class KennzahlenVergleichskreise implements IKennzahlenVergleichskreise {
    id?: number;
    bezeichnung?: string | undefined;
    bemerkung?: string | undefined;

    constructor(data?: IKennzahlenVergleichskreise) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
            this.bemerkung = _data["bemerkung"];
        }
    }

    static fromJS(data: any): KennzahlenVergleichskreise {
        data = typeof data === 'object' ? data : {};
        let result = new KennzahlenVergleichskreise();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        data["bemerkung"] = this.bemerkung;
        return data;
    }
}

export interface IKennzahlenVergleichskreise {
    id?: number;
    bezeichnung?: string | undefined;
    bemerkung?: string | undefined;
}

export class Kennzahlzeilen implements IKennzahlzeilen {
    id?: number;
    kennzahl?: number;
    bezeichnung?: string | undefined;
    istBerechnung?: boolean;
    inkludierteGruppen?: string | undefined;
    exkludierteGruppen?: string | undefined;
    berechnung?: string | undefined;
    darstellung?: number | undefined;
    zusatzangabe?: number | undefined;
    darstellungZusatzangabe?: number | undefined;
    order?: number | undefined;
    subtraktionsGruppen?: string | undefined;
    einheit?: string | undefined;
    bezeichnungZusatzangabe?: string | undefined;
    gliederung?: string | undefined;
    istErgebniszeile?: boolean | undefined;
    status?: string | undefined;
    ds?: string | undefined;
    nachkommastellen?: number | undefined;
    darstellungNavigation?: Diagrammtypen;
    darstellungZusatzangabeNavigation?: Diagrammtypen;
    kennzahlNavigation?: Kennzahlen;
    zusatzangabeNavigation?: Zusatzangaben;

    constructor(data?: IKennzahlzeilen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kennzahl = _data["kennzahl"];
            this.bezeichnung = _data["bezeichnung"];
            this.istBerechnung = _data["istBerechnung"];
            this.inkludierteGruppen = _data["inkludierteGruppen"];
            this.exkludierteGruppen = _data["exkludierteGruppen"];
            this.berechnung = _data["berechnung"];
            this.darstellung = _data["darstellung"];
            this.zusatzangabe = _data["zusatzangabe"];
            this.darstellungZusatzangabe = _data["darstellungZusatzangabe"];
            this.order = _data["order"];
            this.subtraktionsGruppen = _data["subtraktionsGruppen"];
            this.einheit = _data["einheit"];
            this.bezeichnungZusatzangabe = _data["bezeichnungZusatzangabe"];
            this.gliederung = _data["gliederung"];
            this.istErgebniszeile = _data["istErgebniszeile"];
            this.status = _data["status"];
            this.ds = _data["ds"];
            this.nachkommastellen = _data["nachkommastellen"];
            this.darstellungNavigation = _data["darstellungNavigation"] ? Diagrammtypen.fromJS(_data["darstellungNavigation"]) : <any>undefined;
            this.darstellungZusatzangabeNavigation = _data["darstellungZusatzangabeNavigation"] ? Diagrammtypen.fromJS(_data["darstellungZusatzangabeNavigation"]) : <any>undefined;
            this.kennzahlNavigation = _data["kennzahlNavigation"] ? Kennzahlen.fromJS(_data["kennzahlNavigation"]) : <any>undefined;
            this.zusatzangabeNavigation = _data["zusatzangabeNavigation"] ? Zusatzangaben.fromJS(_data["zusatzangabeNavigation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Kennzahlzeilen {
        data = typeof data === 'object' ? data : {};
        let result = new Kennzahlzeilen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kennzahl"] = this.kennzahl;
        data["bezeichnung"] = this.bezeichnung;
        data["istBerechnung"] = this.istBerechnung;
        data["inkludierteGruppen"] = this.inkludierteGruppen;
        data["exkludierteGruppen"] = this.exkludierteGruppen;
        data["berechnung"] = this.berechnung;
        data["darstellung"] = this.darstellung;
        data["zusatzangabe"] = this.zusatzangabe;
        data["darstellungZusatzangabe"] = this.darstellungZusatzangabe;
        data["order"] = this.order;
        data["subtraktionsGruppen"] = this.subtraktionsGruppen;
        data["einheit"] = this.einheit;
        data["bezeichnungZusatzangabe"] = this.bezeichnungZusatzangabe;
        data["gliederung"] = this.gliederung;
        data["istErgebniszeile"] = this.istErgebniszeile;
        data["status"] = this.status;
        data["ds"] = this.ds;
        data["nachkommastellen"] = this.nachkommastellen;
        data["darstellungNavigation"] = this.darstellungNavigation ? this.darstellungNavigation.toJSON() : <any>undefined;
        data["darstellungZusatzangabeNavigation"] = this.darstellungZusatzangabeNavigation ? this.darstellungZusatzangabeNavigation.toJSON() : <any>undefined;
        data["kennzahlNavigation"] = this.kennzahlNavigation ? this.kennzahlNavigation.toJSON() : <any>undefined;
        data["zusatzangabeNavigation"] = this.zusatzangabeNavigation ? this.zusatzangabeNavigation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IKennzahlzeilen {
    id?: number;
    kennzahl?: number;
    bezeichnung?: string | undefined;
    istBerechnung?: boolean;
    inkludierteGruppen?: string | undefined;
    exkludierteGruppen?: string | undefined;
    berechnung?: string | undefined;
    darstellung?: number | undefined;
    zusatzangabe?: number | undefined;
    darstellungZusatzangabe?: number | undefined;
    order?: number | undefined;
    subtraktionsGruppen?: string | undefined;
    einheit?: string | undefined;
    bezeichnungZusatzangabe?: string | undefined;
    gliederung?: string | undefined;
    istErgebniszeile?: boolean | undefined;
    status?: string | undefined;
    ds?: string | undefined;
    nachkommastellen?: number | undefined;
    darstellungNavigation?: Diagrammtypen;
    darstellungZusatzangabeNavigation?: Diagrammtypen;
    kennzahlNavigation?: Kennzahlen;
    zusatzangabeNavigation?: Zusatzangaben;
}

export class KennzahlzeilenModel implements IKennzahlzeilenModel {
    id?: number;
    kennzahl?: number;
    bezeichnung?: string | undefined;
    istBerechnung?: boolean;
    inkludierteGruppen?: string | undefined;
    exkludierteGruppen?: string | undefined;
    berechnung?: string | undefined;
    darstellung?: number | undefined;
    zusatzangabe?: number | undefined;
    darstellungZusatzangabe?: number | undefined;
    order?: number | undefined;
    subtraktionsGruppen?: string | undefined;
    einheit?: string | undefined;
    bezeichnungZusatzangabe?: string | undefined;
    gliederung?: string | undefined;
    istErgebniszeile?: boolean | undefined;
    status?: string | undefined;
    ds?: string | undefined;
    nachkommastellen?: number | undefined;
    darstellungNavigation?: Diagrammtypen;
    darstellungZusatzangabeNavigation?: Diagrammtypen;
    kennzahlNavigation?: Kennzahlen;
    zusatzangabeNavigation?: Zusatzangaben;

    constructor(data?: IKennzahlzeilenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kennzahl = _data["kennzahl"];
            this.bezeichnung = _data["bezeichnung"];
            this.istBerechnung = _data["istBerechnung"];
            this.inkludierteGruppen = _data["inkludierteGruppen"];
            this.exkludierteGruppen = _data["exkludierteGruppen"];
            this.berechnung = _data["berechnung"];
            this.darstellung = _data["darstellung"];
            this.zusatzangabe = _data["zusatzangabe"];
            this.darstellungZusatzangabe = _data["darstellungZusatzangabe"];
            this.order = _data["order"];
            this.subtraktionsGruppen = _data["subtraktionsGruppen"];
            this.einheit = _data["einheit"];
            this.bezeichnungZusatzangabe = _data["bezeichnungZusatzangabe"];
            this.gliederung = _data["gliederung"];
            this.istErgebniszeile = _data["istErgebniszeile"];
            this.status = _data["status"];
            this.ds = _data["ds"];
            this.nachkommastellen = _data["nachkommastellen"];
            this.darstellungNavigation = _data["darstellungNavigation"] ? Diagrammtypen.fromJS(_data["darstellungNavigation"]) : <any>undefined;
            this.darstellungZusatzangabeNavigation = _data["darstellungZusatzangabeNavigation"] ? Diagrammtypen.fromJS(_data["darstellungZusatzangabeNavigation"]) : <any>undefined;
            this.kennzahlNavigation = _data["kennzahlNavigation"] ? Kennzahlen.fromJS(_data["kennzahlNavigation"]) : <any>undefined;
            this.zusatzangabeNavigation = _data["zusatzangabeNavigation"] ? Zusatzangaben.fromJS(_data["zusatzangabeNavigation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): KennzahlzeilenModel {
        data = typeof data === 'object' ? data : {};
        let result = new KennzahlzeilenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kennzahl"] = this.kennzahl;
        data["bezeichnung"] = this.bezeichnung;
        data["istBerechnung"] = this.istBerechnung;
        data["inkludierteGruppen"] = this.inkludierteGruppen;
        data["exkludierteGruppen"] = this.exkludierteGruppen;
        data["berechnung"] = this.berechnung;
        data["darstellung"] = this.darstellung;
        data["zusatzangabe"] = this.zusatzangabe;
        data["darstellungZusatzangabe"] = this.darstellungZusatzangabe;
        data["order"] = this.order;
        data["subtraktionsGruppen"] = this.subtraktionsGruppen;
        data["einheit"] = this.einheit;
        data["bezeichnungZusatzangabe"] = this.bezeichnungZusatzangabe;
        data["gliederung"] = this.gliederung;
        data["istErgebniszeile"] = this.istErgebniszeile;
        data["status"] = this.status;
        data["ds"] = this.ds;
        data["nachkommastellen"] = this.nachkommastellen;
        data["darstellungNavigation"] = this.darstellungNavigation ? this.darstellungNavigation.toJSON() : <any>undefined;
        data["darstellungZusatzangabeNavigation"] = this.darstellungZusatzangabeNavigation ? this.darstellungZusatzangabeNavigation.toJSON() : <any>undefined;
        data["kennzahlNavigation"] = this.kennzahlNavigation ? this.kennzahlNavigation.toJSON() : <any>undefined;
        data["zusatzangabeNavigation"] = this.zusatzangabeNavigation ? this.zusatzangabeNavigation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IKennzahlzeilenModel {
    id?: number;
    kennzahl?: number;
    bezeichnung?: string | undefined;
    istBerechnung?: boolean;
    inkludierteGruppen?: string | undefined;
    exkludierteGruppen?: string | undefined;
    berechnung?: string | undefined;
    darstellung?: number | undefined;
    zusatzangabe?: number | undefined;
    darstellungZusatzangabe?: number | undefined;
    order?: number | undefined;
    subtraktionsGruppen?: string | undefined;
    einheit?: string | undefined;
    bezeichnungZusatzangabe?: string | undefined;
    gliederung?: string | undefined;
    istErgebniszeile?: boolean | undefined;
    status?: string | undefined;
    ds?: string | undefined;
    nachkommastellen?: number | undefined;
    darstellungNavigation?: Diagrammtypen;
    darstellungZusatzangabeNavigation?: Diagrammtypen;
    kennzahlNavigation?: Kennzahlen;
    zusatzangabeNavigation?: Zusatzangaben;
}

export class KibotDokumentHtmlModel implements IKibotDokumentHtmlModel {
    id?: number;
    titel?: string | undefined;
    menuPfad?: string | undefined;
    ursprungsdokument?: string | undefined;
    meta?: KibotDokumentMetaFeld[] | undefined;
    ebene?: number | undefined;
    nachId?: number;
    html?: string | undefined;
    stand?: string | undefined;

    constructor(data?: IKibotDokumentHtmlModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.titel = _data["titel"];
            this.menuPfad = _data["menuPfad"];
            this.ursprungsdokument = _data["ursprungsdokument"];
            if (Array.isArray(_data["meta"])) {
                this.meta = [] as any;
                for (let item of _data["meta"])
                    this.meta!.push(KibotDokumentMetaFeld.fromJS(item));
            }
            this.ebene = _data["ebene"];
            this.nachId = _data["nachId"];
            this.html = _data["html"];
            this.stand = _data["stand"];
        }
    }

    static fromJS(data: any): KibotDokumentHtmlModel {
        data = typeof data === 'object' ? data : {};
        let result = new KibotDokumentHtmlModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["titel"] = this.titel;
        data["menuPfad"] = this.menuPfad;
        data["ursprungsdokument"] = this.ursprungsdokument;
        if (Array.isArray(this.meta)) {
            data["meta"] = [];
            for (let item of this.meta)
                data["meta"].push(item.toJSON());
        }
        data["ebene"] = this.ebene;
        data["nachId"] = this.nachId;
        data["html"] = this.html;
        data["stand"] = this.stand;
        return data;
    }
}

export interface IKibotDokumentHtmlModel {
    id?: number;
    titel?: string | undefined;
    menuPfad?: string | undefined;
    ursprungsdokument?: string | undefined;
    meta?: KibotDokumentMetaFeld[] | undefined;
    ebene?: number | undefined;
    nachId?: number;
    html?: string | undefined;
    stand?: string | undefined;
}

export class KibotDokumentJobModel implements IKibotDokumentJobModel {
    id?: string;
    status?: number;
    progress?: number;
    statusText?: string | undefined;
    errorMessage?: string | undefined;
    bezeichnung?: string | undefined;
    tempFile?: string | undefined;
    menuPfad?: string | undefined;
    metaJson?: string | undefined;
    createdAt?: Date;
    startedAt?: Date | undefined;
    finishedAt?: Date | undefined;
    readonly statusStr?: string | undefined;
    documents?: KibotDokumentModel[] | undefined;

    constructor(data?: IKibotDokumentJobModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.progress = _data["progress"];
            this.statusText = _data["statusText"];
            this.errorMessage = _data["errorMessage"];
            this.bezeichnung = _data["bezeichnung"];
            this.tempFile = _data["tempFile"];
            this.menuPfad = _data["menuPfad"];
            this.metaJson = _data["metaJson"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>undefined;
            this.finishedAt = _data["finishedAt"] ? new Date(_data["finishedAt"].toString()) : <any>undefined;
            (<any>this).statusStr = _data["statusStr"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(KibotDokumentModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KibotDokumentJobModel {
        data = typeof data === 'object' ? data : {};
        let result = new KibotDokumentJobModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["progress"] = this.progress;
        data["statusText"] = this.statusText;
        data["errorMessage"] = this.errorMessage;
        data["bezeichnung"] = this.bezeichnung;
        data["tempFile"] = this.tempFile;
        data["menuPfad"] = this.menuPfad;
        data["metaJson"] = this.metaJson;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>undefined;
        data["finishedAt"] = this.finishedAt ? this.finishedAt.toISOString() : <any>undefined;
        data["statusStr"] = this.statusStr;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKibotDokumentJobModel {
    id?: string;
    status?: number;
    progress?: number;
    statusText?: string | undefined;
    errorMessage?: string | undefined;
    bezeichnung?: string | undefined;
    tempFile?: string | undefined;
    menuPfad?: string | undefined;
    metaJson?: string | undefined;
    createdAt?: Date;
    startedAt?: Date | undefined;
    finishedAt?: Date | undefined;
    statusStr?: string | undefined;
    documents?: KibotDokumentModel[] | undefined;
}

export class KibotDokumentMetaFeld implements IKibotDokumentMetaFeld {
    id?: number;
    feldname?: string | undefined;
    feldwert?: string | undefined;

    constructor(data?: IKibotDokumentMetaFeld) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.feldname = _data["feldname"];
            this.feldwert = _data["feldwert"];
        }
    }

    static fromJS(data: any): KibotDokumentMetaFeld {
        data = typeof data === 'object' ? data : {};
        let result = new KibotDokumentMetaFeld();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["feldname"] = this.feldname;
        data["feldwert"] = this.feldwert;
        return data;
    }
}

export interface IKibotDokumentMetaFeld {
    id?: number;
    feldname?: string | undefined;
    feldwert?: string | undefined;
}

export class KibotDokumentModel implements IKibotDokumentModel {
    id?: number;
    bezeichnung?: string | undefined;
    pfad?: string | undefined;
    menuPfad?: string | undefined;
    metaJson?: string | undefined;
    ursprungsdokument?: string | undefined;
    jobId?: string | undefined;
    enrichedText?: string | undefined;
    benutzteBilder?: string | undefined;
    indexStat?: number | undefined;
    ebene?: number | undefined;
    geaendertAm?: Date | undefined;
    geaendertVon?: string | undefined;
    reihenfolge?: number | undefined;
    meta?: KibotDokumentMetaFeld[] | undefined;

    constructor(data?: IKibotDokumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
            this.pfad = _data["pfad"];
            this.menuPfad = _data["menuPfad"];
            this.metaJson = _data["metaJson"];
            this.ursprungsdokument = _data["ursprungsdokument"];
            this.jobId = _data["jobId"];
            this.enrichedText = _data["enrichedText"];
            this.benutzteBilder = _data["benutzteBilder"];
            this.indexStat = _data["indexStat"];
            this.ebene = _data["ebene"];
            this.geaendertAm = _data["geaendertAm"] ? new Date(_data["geaendertAm"].toString()) : <any>undefined;
            this.geaendertVon = _data["geaendertVon"];
            this.reihenfolge = _data["reihenfolge"];
            if (Array.isArray(_data["meta"])) {
                this.meta = [] as any;
                for (let item of _data["meta"])
                    this.meta!.push(KibotDokumentMetaFeld.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KibotDokumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new KibotDokumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        data["pfad"] = this.pfad;
        data["menuPfad"] = this.menuPfad;
        data["metaJson"] = this.metaJson;
        data["ursprungsdokument"] = this.ursprungsdokument;
        data["jobId"] = this.jobId;
        data["enrichedText"] = this.enrichedText;
        data["benutzteBilder"] = this.benutzteBilder;
        data["indexStat"] = this.indexStat;
        data["ebene"] = this.ebene;
        data["geaendertAm"] = this.geaendertAm ? this.geaendertAm.toISOString() : <any>undefined;
        data["geaendertVon"] = this.geaendertVon;
        data["reihenfolge"] = this.reihenfolge;
        if (Array.isArray(this.meta)) {
            data["meta"] = [];
            for (let item of this.meta)
                data["meta"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKibotDokumentModel {
    id?: number;
    bezeichnung?: string | undefined;
    pfad?: string | undefined;
    menuPfad?: string | undefined;
    metaJson?: string | undefined;
    ursprungsdokument?: string | undefined;
    jobId?: string | undefined;
    enrichedText?: string | undefined;
    benutzteBilder?: string | undefined;
    indexStat?: number | undefined;
    ebene?: number | undefined;
    geaendertAm?: Date | undefined;
    geaendertVon?: string | undefined;
    reihenfolge?: number | undefined;
    meta?: KibotDokumentMetaFeld[] | undefined;
}

export class KommentarEmpfaengerModel implements IKommentarEmpfaengerModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    userId?: string | undefined;
    user?: AspNetUser;

    constructor(data?: IKommentarEmpfaengerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? AspNetUser.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): KommentarEmpfaengerModel {
        data = typeof data === 'object' ? data : {};
        let result = new KommentarEmpfaengerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IKommentarEmpfaengerModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    userId?: string | undefined;
    user?: AspNetUser;
}

export class KommentarModel implements IKommentarModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    userId?: string | undefined;
    datum?: Date;
    betreff?: string | undefined;
    text?: string | undefined;
    parent?: number | undefined;
    jahr?: number | undefined;
    planstufe?: number | undefined;
    plantyp?: number | undefined;
    childs?: KommentarModel[] | undefined;
    user?: AspNetUser;
    planstufenObj?: Planstufen;

    constructor(data?: IKommentarModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.userId = _data["userId"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
            this.betreff = _data["betreff"];
            this.text = _data["text"];
            this.parent = _data["parent"];
            this.jahr = _data["jahr"];
            this.planstufe = _data["planstufe"];
            this.plantyp = _data["plantyp"];
            if (Array.isArray(_data["childs"])) {
                this.childs = [] as any;
                for (let item of _data["childs"])
                    this.childs!.push(KommentarModel.fromJS(item));
            }
            this.user = _data["user"] ? AspNetUser.fromJS(_data["user"]) : <any>undefined;
            this.planstufenObj = _data["planstufenObj"] ? Planstufen.fromJS(_data["planstufenObj"]) : <any>undefined;
        }
    }

    static fromJS(data: any): KommentarModel {
        data = typeof data === 'object' ? data : {};
        let result = new KommentarModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["userId"] = this.userId;
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        data["betreff"] = this.betreff;
        data["text"] = this.text;
        data["parent"] = this.parent;
        data["jahr"] = this.jahr;
        data["planstufe"] = this.planstufe;
        data["plantyp"] = this.plantyp;
        if (Array.isArray(this.childs)) {
            data["childs"] = [];
            for (let item of this.childs)
                data["childs"].push(item.toJSON());
        }
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["planstufenObj"] = this.planstufenObj ? this.planstufenObj.toJSON() : <any>undefined;
        return data;
    }
}

export interface IKommentarModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    userId?: string | undefined;
    datum?: Date;
    betreff?: string | undefined;
    text?: string | undefined;
    parent?: number | undefined;
    jahr?: number | undefined;
    planstufe?: number | undefined;
    plantyp?: number | undefined;
    childs?: KommentarModel[] | undefined;
    user?: AspNetUser;
    planstufenObj?: Planstufen;
}

export class Kommentare implements IKommentare {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    userId?: string | undefined;
    datum?: Date;
    betreff?: string | undefined;
    text?: string | undefined;
    parent?: number | undefined;
    jahr?: number | undefined;
    planstufe?: number | undefined;
    plantyp?: number | undefined;

    constructor(data?: IKommentare) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.userId = _data["userId"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
            this.betreff = _data["betreff"];
            this.text = _data["text"];
            this.parent = _data["parent"];
            this.jahr = _data["jahr"];
            this.planstufe = _data["planstufe"];
            this.plantyp = _data["plantyp"];
        }
    }

    static fromJS(data: any): Kommentare {
        data = typeof data === 'object' ? data : {};
        let result = new Kommentare();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["userId"] = this.userId;
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        data["betreff"] = this.betreff;
        data["text"] = this.text;
        data["parent"] = this.parent;
        data["jahr"] = this.jahr;
        data["planstufe"] = this.planstufe;
        data["plantyp"] = this.plantyp;
        return data;
    }
}

export interface IKommentare {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    userId?: string | undefined;
    datum?: Date;
    betreff?: string | undefined;
    text?: string | undefined;
    parent?: number | undefined;
    jahr?: number | undefined;
    planstufe?: number | undefined;
    plantyp?: number | undefined;
}

export class Kommunentypen implements IKommunentypen {
    id?: number | undefined;
    bezeichnung?: string | undefined;

    constructor(data?: IKommunentypen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
        }
    }

    static fromJS(data: any): Kommunentypen {
        data = typeof data === 'object' ? data : {};
        let result = new Kommunentypen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        return data;
    }
}

export interface IKommunentypen {
    id?: number | undefined;
    bezeichnung?: string | undefined;
}

export class KontenModel implements IKontenModel {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    typ?: string | undefined;
    nummer?: number;
    bezeichnung?: string | undefined;
    loeschbar?: boolean;
    umbenennbar?: boolean;
    beschreibung?: string | undefined;
    geprueft?: boolean | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;
    id?: number;
    nummerFmt?: string | undefined;

    constructor(data?: IKontenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.stellen = _data["stellen"];
            this.typ = _data["typ"];
            this.nummer = _data["nummer"];
            this.bezeichnung = _data["bezeichnung"];
            this.loeschbar = _data["loeschbar"];
            this.umbenennbar = _data["umbenennbar"];
            this.beschreibung = _data["beschreibung"];
            this.geprueft = _data["geprueft"];
            this.oeffentlich = _data["oeffentlich"];
            this.oeffentlichVerwaltung = _data["oeffentlichVerwaltung"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
            this.id = _data["id"];
            this.nummerFmt = _data["nummerFmt"];
        }
    }

    static fromJS(data: any): KontenModel {
        data = typeof data === 'object' ? data : {};
        let result = new KontenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["stellen"] = this.stellen;
        data["typ"] = this.typ;
        data["nummer"] = this.nummer;
        data["bezeichnung"] = this.bezeichnung;
        data["loeschbar"] = this.loeschbar;
        data["umbenennbar"] = this.umbenennbar;
        data["beschreibung"] = this.beschreibung;
        data["geprueft"] = this.geprueft;
        data["oeffentlich"] = this.oeffentlich;
        data["oeffentlichVerwaltung"] = this.oeffentlichVerwaltung;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["nummerFmt"] = this.nummerFmt;
        return data;
    }
}

export interface IKontenModel {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    typ?: string | undefined;
    nummer?: number;
    bezeichnung?: string | undefined;
    loeschbar?: boolean;
    umbenennbar?: boolean;
    beschreibung?: string | undefined;
    geprueft?: boolean | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;
    id?: number;
    nummerFmt?: string | undefined;
}

export class Kontenebenen implements IKontenebenen {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    bezeichnung?: string | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;

    constructor(data?: IKontenebenen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.stellen = _data["stellen"];
            this.bezeichnung = _data["bezeichnung"];
            this.oeffentlich = _data["oeffentlich"];
            this.oeffentlichVerwaltung = _data["oeffentlichVerwaltung"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Kontenebenen {
        data = typeof data === 'object' ? data : {};
        let result = new Kontenebenen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["stellen"] = this.stellen;
        data["bezeichnung"] = this.bezeichnung;
        data["oeffentlich"] = this.oeffentlich;
        data["oeffentlichVerwaltung"] = this.oeffentlichVerwaltung;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        return data;
    }
}

export interface IKontenebenen {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    bezeichnung?: string | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;
}

export class KontenebenenModel implements IKontenebenenModel {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    bezeichnung?: string | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;
    id?: number;

    constructor(data?: IKontenebenenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.stellen = _data["stellen"];
            this.bezeichnung = _data["bezeichnung"];
            this.oeffentlich = _data["oeffentlich"];
            this.oeffentlichVerwaltung = _data["oeffentlichVerwaltung"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): KontenebenenModel {
        data = typeof data === 'object' ? data : {};
        let result = new KontenebenenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["stellen"] = this.stellen;
        data["bezeichnung"] = this.bezeichnung;
        data["oeffentlich"] = this.oeffentlich;
        data["oeffentlichVerwaltung"] = this.oeffentlichVerwaltung;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IKontenebenenModel {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    bezeichnung?: string | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;
    id?: number;
}

export class Kontenplan implements IKontenplan {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    typ?: string | undefined;
    nummer?: number;
    bezeichnung?: string | undefined;
    loeschbar?: boolean;
    umbenennbar?: boolean;
    beschreibung?: string | undefined;
    geprueft?: boolean | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;

    constructor(data?: IKontenplan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.stellen = _data["stellen"];
            this.typ = _data["typ"];
            this.nummer = _data["nummer"];
            this.bezeichnung = _data["bezeichnung"];
            this.loeschbar = _data["loeschbar"];
            this.umbenennbar = _data["umbenennbar"];
            this.beschreibung = _data["beschreibung"];
            this.geprueft = _data["geprueft"];
            this.oeffentlich = _data["oeffentlich"];
            this.oeffentlichVerwaltung = _data["oeffentlichVerwaltung"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Kontenplan {
        data = typeof data === 'object' ? data : {};
        let result = new Kontenplan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["stellen"] = this.stellen;
        data["typ"] = this.typ;
        data["nummer"] = this.nummer;
        data["bezeichnung"] = this.bezeichnung;
        data["loeschbar"] = this.loeschbar;
        data["umbenennbar"] = this.umbenennbar;
        data["beschreibung"] = this.beschreibung;
        data["geprueft"] = this.geprueft;
        data["oeffentlich"] = this.oeffentlich;
        data["oeffentlichVerwaltung"] = this.oeffentlichVerwaltung;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        return data;
    }
}

export interface IKontenplan {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    typ?: string | undefined;
    nummer?: number;
    bezeichnung?: string | undefined;
    loeschbar?: boolean;
    umbenennbar?: boolean;
    beschreibung?: string | undefined;
    geprueft?: boolean | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;
}

export class Konto2Text implements IKonto2Text {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    nummer?: number;
    textId?: number;
    order?: number | undefined;

    constructor(data?: IKonto2Text) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.stellen = _data["stellen"];
            this.nummer = _data["nummer"];
            this.textId = _data["textId"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): Konto2Text {
        data = typeof data === 'object' ? data : {};
        let result = new Konto2Text();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["stellen"] = this.stellen;
        data["nummer"] = this.nummer;
        data["textId"] = this.textId;
        data["order"] = this.order;
        return data;
    }
}

export interface IKonto2Text {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    nummer?: number;
    textId?: number;
    order?: number | undefined;
}

export class Ktvergleichskreise implements IKtvergleichskreise {
    kommunentyp?: number;
    bezeichnung?: string | undefined;
    id?: number;
    bundesland?: string | undefined;

    constructor(data?: IKtvergleichskreise) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kommunentyp = _data["kommunentyp"];
            this.bezeichnung = _data["bezeichnung"];
            this.id = _data["id"];
            this.bundesland = _data["bundesland"];
        }
    }

    static fromJS(data: any): Ktvergleichskreise {
        data = typeof data === 'object' ? data : {};
        let result = new Ktvergleichskreise();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kommunentyp"] = this.kommunentyp;
        data["bezeichnung"] = this.bezeichnung;
        data["id"] = this.id;
        data["bundesland"] = this.bundesland;
        return data;
    }
}

export interface IKtvergleichskreise {
    kommunentyp?: number;
    bezeichnung?: string | undefined;
    id?: number;
    bundesland?: string | undefined;
}

export class Kunden implements IKunden {
    kunde?: number;
    name?: string | undefined;
    bundesland?: string | undefined;
    kundentyp?: number | undefined;
    inaktiv?: boolean | undefined;
    code?: string | undefined;
    kibotAdmin?: boolean | undefined;
    kibotVisuHb?: boolean | undefined;
    kibotVisuHh?: boolean | undefined;
    kibotVisuHbVa?: boolean | undefined;
    kibotVisuHhVa?: boolean | undefined;
    gemeindens?: Gemeinden[] | undefined;

    constructor(data?: IKunden) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.name = _data["name"];
            this.bundesland = _data["bundesland"];
            this.kundentyp = _data["kundentyp"];
            this.inaktiv = _data["inaktiv"];
            this.code = _data["code"];
            this.kibotAdmin = _data["kibotAdmin"];
            this.kibotVisuHb = _data["kibotVisuHb"];
            this.kibotVisuHh = _data["kibotVisuHh"];
            this.kibotVisuHbVa = _data["kibotVisuHbVa"];
            this.kibotVisuHhVa = _data["kibotVisuHhVa"];
            if (Array.isArray(_data["gemeindens"])) {
                this.gemeindens = [] as any;
                for (let item of _data["gemeindens"])
                    this.gemeindens!.push(Gemeinden.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Kunden {
        data = typeof data === 'object' ? data : {};
        let result = new Kunden();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["name"] = this.name;
        data["bundesland"] = this.bundesland;
        data["kundentyp"] = this.kundentyp;
        data["inaktiv"] = this.inaktiv;
        data["code"] = this.code;
        data["kibotAdmin"] = this.kibotAdmin;
        data["kibotVisuHb"] = this.kibotVisuHb;
        data["kibotVisuHh"] = this.kibotVisuHh;
        data["kibotVisuHbVa"] = this.kibotVisuHbVa;
        data["kibotVisuHhVa"] = this.kibotVisuHhVa;
        if (Array.isArray(this.gemeindens)) {
            data["gemeindens"] = [];
            for (let item of this.gemeindens)
                data["gemeindens"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKunden {
    kunde?: number;
    name?: string | undefined;
    bundesland?: string | undefined;
    kundentyp?: number | undefined;
    inaktiv?: boolean | undefined;
    code?: string | undefined;
    kibotAdmin?: boolean | undefined;
    kibotVisuHb?: boolean | undefined;
    kibotVisuHh?: boolean | undefined;
    kibotVisuHbVa?: boolean | undefined;
    kibotVisuHhVa?: boolean | undefined;
    gemeindens?: Gemeinden[] | undefined;
}

export class KundenModel implements IKundenModel {
    kunde?: number;
    name?: string | undefined;
    bundesland?: string | undefined;
    kundentyp?: number | undefined;
    inaktiv?: boolean | undefined;
    code?: string | undefined;
    kibotAdmin?: boolean | undefined;
    kibotVisuHb?: boolean | undefined;
    kibotVisuHh?: boolean | undefined;
    kibotVisuHbVa?: boolean | undefined;
    kibotVisuHhVa?: boolean | undefined;
    gemeindens?: Gemeinden[] | undefined;
    guid?: string | undefined;
    kundenName?: string | undefined;

    constructor(data?: IKundenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.name = _data["name"];
            this.bundesland = _data["bundesland"];
            this.kundentyp = _data["kundentyp"];
            this.inaktiv = _data["inaktiv"];
            this.code = _data["code"];
            this.kibotAdmin = _data["kibotAdmin"];
            this.kibotVisuHb = _data["kibotVisuHb"];
            this.kibotVisuHh = _data["kibotVisuHh"];
            this.kibotVisuHbVa = _data["kibotVisuHbVa"];
            this.kibotVisuHhVa = _data["kibotVisuHhVa"];
            if (Array.isArray(_data["gemeindens"])) {
                this.gemeindens = [] as any;
                for (let item of _data["gemeindens"])
                    this.gemeindens!.push(Gemeinden.fromJS(item));
            }
            this.guid = _data["guid"];
            this.kundenName = _data["kundenName"];
        }
    }

    static fromJS(data: any): KundenModel {
        data = typeof data === 'object' ? data : {};
        let result = new KundenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["name"] = this.name;
        data["bundesland"] = this.bundesland;
        data["kundentyp"] = this.kundentyp;
        data["inaktiv"] = this.inaktiv;
        data["code"] = this.code;
        data["kibotAdmin"] = this.kibotAdmin;
        data["kibotVisuHb"] = this.kibotVisuHb;
        data["kibotVisuHh"] = this.kibotVisuHh;
        data["kibotVisuHbVa"] = this.kibotVisuHbVa;
        data["kibotVisuHhVa"] = this.kibotVisuHhVa;
        if (Array.isArray(this.gemeindens)) {
            data["gemeindens"] = [];
            for (let item of this.gemeindens)
                data["gemeindens"].push(item.toJSON());
        }
        data["guid"] = this.guid;
        data["kundenName"] = this.kundenName;
        return data;
    }
}

export interface IKundenModel {
    kunde?: number;
    name?: string | undefined;
    bundesland?: string | undefined;
    kundentyp?: number | undefined;
    inaktiv?: boolean | undefined;
    code?: string | undefined;
    kibotAdmin?: boolean | undefined;
    kibotVisuHb?: boolean | undefined;
    kibotVisuHh?: boolean | undefined;
    kibotVisuHbVa?: boolean | undefined;
    kibotVisuHhVa?: boolean | undefined;
    gemeindens?: Gemeinden[] | undefined;
    guid?: string | undefined;
    kundenName?: string | undefined;
}

export class Kundentypen implements IKundentypen {
    id?: number | undefined;
    bezeichnung?: string | undefined;
    vergleichskreis?: string | undefined;

    constructor(data?: IKundentypen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
            this.vergleichskreis = _data["vergleichskreis"];
        }
    }

    static fromJS(data: any): Kundentypen {
        data = typeof data === 'object' ? data : {};
        let result = new Kundentypen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        data["vergleichskreis"] = this.vergleichskreis;
        return data;
    }
}

export interface IKundentypen {
    id?: number | undefined;
    bezeichnung?: string | undefined;
    vergleichskreis?: string | undefined;
}

export class LbplatzhalterBetrachtungsTypenDoppisch implements ILbplatzhalterBetrachtungsTypenDoppisch {
    id?: string | undefined;
    bezeichnung?: string | undefined;

    constructor(data?: ILbplatzhalterBetrachtungsTypenDoppisch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
        }
    }

    static fromJS(data: any): LbplatzhalterBetrachtungsTypenDoppisch {
        data = typeof data === 'object' ? data : {};
        let result = new LbplatzhalterBetrachtungsTypenDoppisch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        return data;
    }
}

export interface ILbplatzhalterBetrachtungsTypenDoppisch {
    id?: string | undefined;
    bezeichnung?: string | undefined;
}

export class LbplatzhalterBetrachtungsTypenKameral implements ILbplatzhalterBetrachtungsTypenKameral {
    id?: string | undefined;
    bezeichnung?: string | undefined;

    constructor(data?: ILbplatzhalterBetrachtungsTypenKameral) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
        }
    }

    static fromJS(data: any): LbplatzhalterBetrachtungsTypenKameral {
        data = typeof data === 'object' ? data : {};
        let result = new LbplatzhalterBetrachtungsTypenKameral();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        return data;
    }
}

export interface ILbplatzhalterBetrachtungsTypenKameral {
    id?: string | undefined;
    bezeichnung?: string | undefined;
}

export class LbplatzhalterJahre implements ILbplatzhalterJahre {
    jahr?: number | undefined;
    bezeichnung?: string | undefined;

    constructor(data?: ILbplatzhalterJahre) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jahr = _data["jahr"];
            this.bezeichnung = _data["bezeichnung"];
        }
    }

    static fromJS(data: any): LbplatzhalterJahre {
        data = typeof data === 'object' ? data : {};
        let result = new LbplatzhalterJahre();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jahr"] = this.jahr;
        data["bezeichnung"] = this.bezeichnung;
        return data;
    }
}

export interface ILbplatzhalterJahre {
    jahr?: number | undefined;
    bezeichnung?: string | undefined;
}

export class LbplatzhalterTypenDoppisch implements ILbplatzhalterTypenDoppisch {
    id?: string | undefined;
    bezeichnung?: string | undefined;
    system?: boolean | undefined;

    constructor(data?: ILbplatzhalterTypenDoppisch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
            this.system = _data["system"];
        }
    }

    static fromJS(data: any): LbplatzhalterTypenDoppisch {
        data = typeof data === 'object' ? data : {};
        let result = new LbplatzhalterTypenDoppisch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        data["system"] = this.system;
        return data;
    }
}

export interface ILbplatzhalterTypenDoppisch {
    id?: string | undefined;
    bezeichnung?: string | undefined;
    system?: boolean | undefined;
}

export class LbplatzhalterTypenKameral implements ILbplatzhalterTypenKameral {
    id?: string | undefined;
    bezeichnung?: string | undefined;
    system?: boolean | undefined;

    constructor(data?: ILbplatzhalterTypenKameral) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
            this.system = _data["system"];
        }
    }

    static fromJS(data: any): LbplatzhalterTypenKameral {
        data = typeof data === 'object' ? data : {};
        let result = new LbplatzhalterTypenKameral();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        data["system"] = this.system;
        return data;
    }
}

export interface ILbplatzhalterTypenKameral {
    id?: string | undefined;
    bezeichnung?: string | undefined;
    system?: boolean | undefined;
}

export enum LineBreakType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum LineMode {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum LineStyle {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export enum LineType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class LoginModel implements ILoginModel {
    username!: string;
    password!: string;

    constructor(data?: ILoginModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoginModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export interface ILoginModel {
    username: string;
    password: string;
}

export class LoginResponse implements ILoginResponse {
    token?: string | undefined;
    refreshToken?: string | undefined;
    expiration?: Date;
    roles?: string[] | undefined;
    rechte?: string[] | undefined;
    customer?: number | undefined;
    customerName?: string | undefined;
    userName?: string | undefined;
    userId?: string | undefined;
    needNewPassword?: boolean | undefined;
    zuname?: string | undefined;
    vorname?: string | undefined;
    bundesland?: string | undefined;

    constructor(data?: ILoginResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.refreshToken = _data["refreshToken"];
            this.expiration = _data["expiration"] ? new Date(_data["expiration"].toString()) : <any>undefined;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["rechte"])) {
                this.rechte = [] as any;
                for (let item of _data["rechte"])
                    this.rechte!.push(item);
            }
            this.customer = _data["customer"];
            this.customerName = _data["customerName"];
            this.userName = _data["userName"];
            this.userId = _data["userId"];
            this.needNewPassword = _data["needNewPassword"];
            this.zuname = _data["zuname"];
            this.vorname = _data["vorname"];
            this.bundesland = _data["bundesland"];
        }
    }

    static fromJS(data: any): LoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["refreshToken"] = this.refreshToken;
        data["expiration"] = this.expiration ? this.expiration.toISOString() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.rechte)) {
            data["rechte"] = [];
            for (let item of this.rechte)
                data["rechte"].push(item);
        }
        data["customer"] = this.customer;
        data["customerName"] = this.customerName;
        data["userName"] = this.userName;
        data["userId"] = this.userId;
        data["needNewPassword"] = this.needNewPassword;
        data["zuname"] = this.zuname;
        data["vorname"] = this.vorname;
        data["bundesland"] = this.bundesland;
        return data;
    }
}

export interface ILoginResponse {
    token?: string | undefined;
    refreshToken?: string | undefined;
    expiration?: Date;
    roles?: string[] | undefined;
    rechte?: string[] | undefined;
    customer?: number | undefined;
    customerName?: string | undefined;
    userName?: string | undefined;
    userId?: string | undefined;
    needNewPassword?: boolean | undefined;
    zuname?: string | undefined;
    vorname?: string | undefined;
    bundesland?: string | undefined;
}

export class MNPlanDoppischModel implements IMNPlanDoppischModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    konto?: number;
    bestandsKonto?: string | undefined;
    investNr?: string | undefined;
    investPos?: number;
    produkt?: number;
    bezeichnung?: string | undefined;
    beschreibung?: string | undefined;
    beginDatum?: Date | undefined;
    endDatum?: Date | undefined;
    bestandsKontoText?: string | undefined;
    kurzbezeichnung?: string | undefined;
    suchtext?: string | undefined;
    investPosText?: string | undefined;
    teilhaushalt?: string | undefined;
    ansatzPjTerm?: string | undefined;
    kontoExtra?: string | undefined;
    gemeinden?: Gemeinden;
    readonly containsData?: boolean;
    haushaltsstelle?: number;
    guid?: string | undefined;
    edit?: boolean;
    ergebnisVvvJ?: number;
    ergebnisVvJ?: number;
    ansatzVJ?: number;
    ergebnisVJ?: number;
    ansatzPj?: number;
    ansatzPjImp?: number;
    ansatzPjDiff?: number | undefined;
    fp1?: number;
    fp2?: number;
    fp3?: number;
    fp4?: number;
    ansatzPjCalc?: number | undefined;
    fp5?: number;
    fp6?: number;
    fp7?: number;
    fp8?: number;
    fp9?: number;
    fp10?: number;
    calcPlanErr?: string | undefined;
    ausgabe?: boolean;
    historie?: PlanHistorieModel[] | undefined;

    constructor(data?: IMNPlanDoppischModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.konto = _data["konto"];
            this.bestandsKonto = _data["bestandsKonto"];
            this.investNr = _data["investNr"];
            this.investPos = _data["investPos"];
            this.produkt = _data["produkt"];
            this.bezeichnung = _data["bezeichnung"];
            this.beschreibung = _data["beschreibung"];
            this.beginDatum = _data["beginDatum"] ? new Date(_data["beginDatum"].toString()) : <any>undefined;
            this.endDatum = _data["endDatum"] ? new Date(_data["endDatum"].toString()) : <any>undefined;
            this.bestandsKontoText = _data["bestandsKontoText"];
            this.kurzbezeichnung = _data["kurzbezeichnung"];
            this.suchtext = _data["suchtext"];
            this.investPosText = _data["investPosText"];
            this.teilhaushalt = _data["teilhaushalt"];
            this.ansatzPjTerm = _data["ansatzPjTerm"];
            this.kontoExtra = _data["kontoExtra"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
            (<any>this).containsData = _data["containsData"];
            this.haushaltsstelle = _data["haushaltsstelle"];
            this.guid = _data["guid"];
            this.edit = _data["edit"];
            this.ergebnisVvvJ = _data["ergebnisVvvJ"];
            this.ergebnisVvJ = _data["ergebnisVvJ"];
            this.ansatzVJ = _data["ansatzVJ"];
            this.ergebnisVJ = _data["ergebnisVJ"];
            this.ansatzPj = _data["ansatzPj"];
            this.ansatzPjImp = _data["ansatzPjImp"];
            this.ansatzPjDiff = _data["ansatzPjDiff"];
            this.fp1 = _data["fp1"];
            this.fp2 = _data["fp2"];
            this.fp3 = _data["fp3"];
            this.fp4 = _data["fp4"];
            this.ansatzPjCalc = _data["ansatzPjCalc"];
            this.fp5 = _data["fp5"];
            this.fp6 = _data["fp6"];
            this.fp7 = _data["fp7"];
            this.fp8 = _data["fp8"];
            this.fp9 = _data["fp9"];
            this.fp10 = _data["fp10"];
            this.calcPlanErr = _data["calcPlanErr"];
            this.ausgabe = _data["ausgabe"];
            if (Array.isArray(_data["historie"])) {
                this.historie = [] as any;
                for (let item of _data["historie"])
                    this.historie!.push(PlanHistorieModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MNPlanDoppischModel {
        data = typeof data === 'object' ? data : {};
        let result = new MNPlanDoppischModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["konto"] = this.konto;
        data["bestandsKonto"] = this.bestandsKonto;
        data["investNr"] = this.investNr;
        data["investPos"] = this.investPos;
        data["produkt"] = this.produkt;
        data["bezeichnung"] = this.bezeichnung;
        data["beschreibung"] = this.beschreibung;
        data["beginDatum"] = this.beginDatum ? this.beginDatum.toISOString() : <any>undefined;
        data["endDatum"] = this.endDatum ? this.endDatum.toISOString() : <any>undefined;
        data["bestandsKontoText"] = this.bestandsKontoText;
        data["kurzbezeichnung"] = this.kurzbezeichnung;
        data["suchtext"] = this.suchtext;
        data["investPosText"] = this.investPosText;
        data["teilhaushalt"] = this.teilhaushalt;
        data["ansatzPjTerm"] = this.ansatzPjTerm;
        data["kontoExtra"] = this.kontoExtra;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        data["containsData"] = this.containsData;
        data["haushaltsstelle"] = this.haushaltsstelle;
        data["guid"] = this.guid;
        data["edit"] = this.edit;
        data["ergebnisVvvJ"] = this.ergebnisVvvJ;
        data["ergebnisVvJ"] = this.ergebnisVvJ;
        data["ansatzVJ"] = this.ansatzVJ;
        data["ergebnisVJ"] = this.ergebnisVJ;
        data["ansatzPj"] = this.ansatzPj;
        data["ansatzPjImp"] = this.ansatzPjImp;
        data["ansatzPjDiff"] = this.ansatzPjDiff;
        data["fp1"] = this.fp1;
        data["fp2"] = this.fp2;
        data["fp3"] = this.fp3;
        data["fp4"] = this.fp4;
        data["ansatzPjCalc"] = this.ansatzPjCalc;
        data["fp5"] = this.fp5;
        data["fp6"] = this.fp6;
        data["fp7"] = this.fp7;
        data["fp8"] = this.fp8;
        data["fp9"] = this.fp9;
        data["fp10"] = this.fp10;
        data["calcPlanErr"] = this.calcPlanErr;
        data["ausgabe"] = this.ausgabe;
        if (Array.isArray(this.historie)) {
            data["historie"] = [];
            for (let item of this.historie)
                data["historie"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMNPlanDoppischModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    konto?: number;
    bestandsKonto?: string | undefined;
    investNr?: string | undefined;
    investPos?: number;
    produkt?: number;
    bezeichnung?: string | undefined;
    beschreibung?: string | undefined;
    beginDatum?: Date | undefined;
    endDatum?: Date | undefined;
    bestandsKontoText?: string | undefined;
    kurzbezeichnung?: string | undefined;
    suchtext?: string | undefined;
    investPosText?: string | undefined;
    teilhaushalt?: string | undefined;
    ansatzPjTerm?: string | undefined;
    kontoExtra?: string | undefined;
    gemeinden?: Gemeinden;
    containsData?: boolean;
    haushaltsstelle?: number;
    guid?: string | undefined;
    edit?: boolean;
    ergebnisVvvJ?: number;
    ergebnisVvJ?: number;
    ansatzVJ?: number;
    ergebnisVJ?: number;
    ansatzPj?: number;
    ansatzPjImp?: number;
    ansatzPjDiff?: number | undefined;
    fp1?: number;
    fp2?: number;
    fp3?: number;
    fp4?: number;
    ansatzPjCalc?: number | undefined;
    fp5?: number;
    fp6?: number;
    fp7?: number;
    fp8?: number;
    fp9?: number;
    fp10?: number;
    calcPlanErr?: string | undefined;
    ausgabe?: boolean;
    historie?: PlanHistorieModel[] | undefined;
}

export class Massnahman implements IMassnahman {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    nr?: number;
    bezeichnung?: string | undefined;
    beschreibung?: string | undefined;
    unterabschnitt?: number | undefined;
    untergruppe?: number | undefined;
    gemeinden?: Gemeinden;
    haushaltsstellens?: Haushaltsstellen[] | undefined;

    constructor(data?: IMassnahman) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.nr = _data["nr"];
            this.bezeichnung = _data["bezeichnung"];
            this.beschreibung = _data["beschreibung"];
            this.unterabschnitt = _data["unterabschnitt"];
            this.untergruppe = _data["untergruppe"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
            if (Array.isArray(_data["haushaltsstellens"])) {
                this.haushaltsstellens = [] as any;
                for (let item of _data["haushaltsstellens"])
                    this.haushaltsstellens!.push(Haushaltsstellen.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Massnahman {
        data = typeof data === 'object' ? data : {};
        let result = new Massnahman();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["nr"] = this.nr;
        data["bezeichnung"] = this.bezeichnung;
        data["beschreibung"] = this.beschreibung;
        data["unterabschnitt"] = this.unterabschnitt;
        data["untergruppe"] = this.untergruppe;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        if (Array.isArray(this.haushaltsstellens)) {
            data["haushaltsstellens"] = [];
            for (let item of this.haushaltsstellens)
                data["haushaltsstellens"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMassnahman {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    nr?: number;
    bezeichnung?: string | undefined;
    beschreibung?: string | undefined;
    unterabschnitt?: number | undefined;
    untergruppe?: number | undefined;
    gemeinden?: Gemeinden;
    haushaltsstellens?: Haushaltsstellen[] | undefined;
}

export class MassnahmenDoppisch implements IMassnahmenDoppisch {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    konto?: number;
    bestandsKonto?: string | undefined;
    investNr?: string | undefined;
    investPos?: number;
    produkt?: number;
    bezeichnung?: string | undefined;
    beschreibung?: string | undefined;
    beginDatum?: Date | undefined;
    endDatum?: Date | undefined;
    bestandsKontoText?: string | undefined;
    kurzbezeichnung?: string | undefined;
    suchtext?: string | undefined;
    investPosText?: string | undefined;
    teilhaushalt?: string | undefined;
    ansatzPjTerm?: string | undefined;
    kontoExtra?: string | undefined;
    gemeinden?: Gemeinden;

    constructor(data?: IMassnahmenDoppisch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.konto = _data["konto"];
            this.bestandsKonto = _data["bestandsKonto"];
            this.investNr = _data["investNr"];
            this.investPos = _data["investPos"];
            this.produkt = _data["produkt"];
            this.bezeichnung = _data["bezeichnung"];
            this.beschreibung = _data["beschreibung"];
            this.beginDatum = _data["beginDatum"] ? new Date(_data["beginDatum"].toString()) : <any>undefined;
            this.endDatum = _data["endDatum"] ? new Date(_data["endDatum"].toString()) : <any>undefined;
            this.bestandsKontoText = _data["bestandsKontoText"];
            this.kurzbezeichnung = _data["kurzbezeichnung"];
            this.suchtext = _data["suchtext"];
            this.investPosText = _data["investPosText"];
            this.teilhaushalt = _data["teilhaushalt"];
            this.ansatzPjTerm = _data["ansatzPjTerm"];
            this.kontoExtra = _data["kontoExtra"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MassnahmenDoppisch {
        data = typeof data === 'object' ? data : {};
        let result = new MassnahmenDoppisch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["konto"] = this.konto;
        data["bestandsKonto"] = this.bestandsKonto;
        data["investNr"] = this.investNr;
        data["investPos"] = this.investPos;
        data["produkt"] = this.produkt;
        data["bezeichnung"] = this.bezeichnung;
        data["beschreibung"] = this.beschreibung;
        data["beginDatum"] = this.beginDatum ? this.beginDatum.toISOString() : <any>undefined;
        data["endDatum"] = this.endDatum ? this.endDatum.toISOString() : <any>undefined;
        data["bestandsKontoText"] = this.bestandsKontoText;
        data["kurzbezeichnung"] = this.kurzbezeichnung;
        data["suchtext"] = this.suchtext;
        data["investPosText"] = this.investPosText;
        data["teilhaushalt"] = this.teilhaushalt;
        data["ansatzPjTerm"] = this.ansatzPjTerm;
        data["kontoExtra"] = this.kontoExtra;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMassnahmenDoppisch {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    konto?: number;
    bestandsKonto?: string | undefined;
    investNr?: string | undefined;
    investPos?: number;
    produkt?: number;
    bezeichnung?: string | undefined;
    beschreibung?: string | undefined;
    beginDatum?: Date | undefined;
    endDatum?: Date | undefined;
    bestandsKontoText?: string | undefined;
    kurzbezeichnung?: string | undefined;
    suchtext?: string | undefined;
    investPosText?: string | undefined;
    teilhaushalt?: string | undefined;
    ansatzPjTerm?: string | undefined;
    kontoExtra?: string | undefined;
    gemeinden?: Gemeinden;
}

export class MassnahmendatenUhdoppisch implements IMassnahmendatenUhdoppisch {
    massnahme?: number;
    plantyp?: number;
    planstufe?: number;
    hhrest?: number;
    abgHhrest?: number;
    seAoHhre?: number;
    auftragHr?: number;
    aosollVj?: number;
    aoHrHu?: number;
    ansatz?: number;
    nachtrag?: number;
    sollueber?: number;
    ueplApl?: number;
    seAoSoll?: number;
    auftraeg?: number;
    aosollLfd?: number;
    aoSollHu?: number;
    soll?: boolean;
    istAo?: number | undefined;
    kr?: number | undefined;
    istKr?: number | undefined;
    dauerbelege?: number | undefined;
    ergebnisPjm1?: number | undefined;
    ergebnisPjm2?: number | undefined;
    ergebnisPjm3?: number | undefined;
    ergebnisPjm4?: number | undefined;

    constructor(data?: IMassnahmendatenUhdoppisch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.massnahme = _data["massnahme"];
            this.plantyp = _data["plantyp"];
            this.planstufe = _data["planstufe"];
            this.hhrest = _data["hhrest"];
            this.abgHhrest = _data["abgHhrest"];
            this.seAoHhre = _data["seAoHhre"];
            this.auftragHr = _data["auftragHr"];
            this.aosollVj = _data["aosollVj"];
            this.aoHrHu = _data["aoHrHu"];
            this.ansatz = _data["ansatz"];
            this.nachtrag = _data["nachtrag"];
            this.sollueber = _data["sollueber"];
            this.ueplApl = _data["ueplApl"];
            this.seAoSoll = _data["seAoSoll"];
            this.auftraeg = _data["auftraeg"];
            this.aosollLfd = _data["aosollLfd"];
            this.aoSollHu = _data["aoSollHu"];
            this.soll = _data["soll"];
            this.istAo = _data["istAo"];
            this.kr = _data["kr"];
            this.istKr = _data["istKr"];
            this.dauerbelege = _data["dauerbelege"];
            this.ergebnisPjm1 = _data["ergebnisPjm1"];
            this.ergebnisPjm2 = _data["ergebnisPjm2"];
            this.ergebnisPjm3 = _data["ergebnisPjm3"];
            this.ergebnisPjm4 = _data["ergebnisPjm4"];
        }
    }

    static fromJS(data: any): MassnahmendatenUhdoppisch {
        data = typeof data === 'object' ? data : {};
        let result = new MassnahmendatenUhdoppisch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["massnahme"] = this.massnahme;
        data["plantyp"] = this.plantyp;
        data["planstufe"] = this.planstufe;
        data["hhrest"] = this.hhrest;
        data["abgHhrest"] = this.abgHhrest;
        data["seAoHhre"] = this.seAoHhre;
        data["auftragHr"] = this.auftragHr;
        data["aosollVj"] = this.aosollVj;
        data["aoHrHu"] = this.aoHrHu;
        data["ansatz"] = this.ansatz;
        data["nachtrag"] = this.nachtrag;
        data["sollueber"] = this.sollueber;
        data["ueplApl"] = this.ueplApl;
        data["seAoSoll"] = this.seAoSoll;
        data["auftraeg"] = this.auftraeg;
        data["aosollLfd"] = this.aosollLfd;
        data["aoSollHu"] = this.aoSollHu;
        data["soll"] = this.soll;
        data["istAo"] = this.istAo;
        data["kr"] = this.kr;
        data["istKr"] = this.istKr;
        data["dauerbelege"] = this.dauerbelege;
        data["ergebnisPjm1"] = this.ergebnisPjm1;
        data["ergebnisPjm2"] = this.ergebnisPjm2;
        data["ergebnisPjm3"] = this.ergebnisPjm3;
        data["ergebnisPjm4"] = this.ergebnisPjm4;
        return data;
    }
}

export interface IMassnahmendatenUhdoppisch {
    massnahme?: number;
    plantyp?: number;
    planstufe?: number;
    hhrest?: number;
    abgHhrest?: number;
    seAoHhre?: number;
    auftragHr?: number;
    aosollVj?: number;
    aoHrHu?: number;
    ansatz?: number;
    nachtrag?: number;
    sollueber?: number;
    ueplApl?: number;
    seAoSoll?: number;
    auftraeg?: number;
    aosollLfd?: number;
    aoSollHu?: number;
    soll?: boolean;
    istAo?: number | undefined;
    kr?: number | undefined;
    istKr?: number | undefined;
    dauerbelege?: number | undefined;
    ergebnisPjm1?: number | undefined;
    ergebnisPjm2?: number | undefined;
    ergebnisPjm3?: number | undefined;
    ergebnisPjm4?: number | undefined;
}

export class ModifyUserModel implements IModifyUserModel {
    username!: string;
    customer?: number | undefined;
    roles?: string[] | undefined;
    zuname?: string | undefined;
    vorname?: string | undefined;

    constructor(data?: IModifyUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.customer = _data["customer"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.zuname = _data["zuname"];
            this.vorname = _data["vorname"];
        }
    }

    static fromJS(data: any): ModifyUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["customer"] = this.customer;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["zuname"] = this.zuname;
        data["vorname"] = this.vorname;
        return data;
    }
}

export interface IModifyUserModel {
    username: string;
    customer?: number | undefined;
    roles?: string[] | undefined;
    zuname?: string | undefined;
    vorname?: string | undefined;
}

export class ODTCellEigenschaftenModel implements IODTCellEigenschaftenModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    beschreibung?: string | undefined;
    textEigenschaften?: TextPropertiesModel;
    cellEigenschaften?: CellPropertiesModel;
    absatzEigenschaften?: ParagraphPropertiesModel;

    constructor(data?: IODTCellEigenschaftenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.bezeichnung = _data["bezeichnung"];
            this.beschreibung = _data["beschreibung"];
            this.textEigenschaften = _data["textEigenschaften"] ? TextPropertiesModel.fromJS(_data["textEigenschaften"]) : <any>undefined;
            this.cellEigenschaften = _data["cellEigenschaften"] ? CellPropertiesModel.fromJS(_data["cellEigenschaften"]) : <any>undefined;
            this.absatzEigenschaften = _data["absatzEigenschaften"] ? ParagraphPropertiesModel.fromJS(_data["absatzEigenschaften"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ODTCellEigenschaftenModel {
        data = typeof data === 'object' ? data : {};
        let result = new ODTCellEigenschaftenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["bezeichnung"] = this.bezeichnung;
        data["beschreibung"] = this.beschreibung;
        data["textEigenschaften"] = this.textEigenschaften ? this.textEigenschaften.toJSON() : <any>undefined;
        data["cellEigenschaften"] = this.cellEigenschaften ? this.cellEigenschaften.toJSON() : <any>undefined;
        data["absatzEigenschaften"] = this.absatzEigenschaften ? this.absatzEigenschaften.toJSON() : <any>undefined;
        return data;
    }
}

export interface IODTCellEigenschaftenModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    beschreibung?: string | undefined;
    textEigenschaften?: TextPropertiesModel;
    cellEigenschaften?: CellPropertiesModel;
    absatzEigenschaften?: ParagraphPropertiesModel;
}

export class Odteigenschaften implements IOdteigenschaften {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    typ?: number;
    bezeichnung?: string | undefined;
    eigenschaften?: string | undefined;
    beschreibung?: string | undefined;

    constructor(data?: IOdteigenschaften) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.typ = _data["typ"];
            this.bezeichnung = _data["bezeichnung"];
            this.eigenschaften = _data["eigenschaften"];
            this.beschreibung = _data["beschreibung"];
        }
    }

    static fromJS(data: any): Odteigenschaften {
        data = typeof data === 'object' ? data : {};
        let result = new Odteigenschaften();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["typ"] = this.typ;
        data["bezeichnung"] = this.bezeichnung;
        data["eigenschaften"] = this.eigenschaften;
        data["beschreibung"] = this.beschreibung;
        return data;
    }
}

export interface IOdteigenschaften {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    typ?: number;
    bezeichnung?: string | undefined;
    eigenschaften?: string | undefined;
    beschreibung?: string | undefined;
}

export class ParagraphPropertiesModel implements IParagraphPropertiesModel {
    textAlignment?: TextAlignment;
    fixedLineHeight?: string | undefined;
    minimumLineHeight?: Size;
    lineDistance?: Size;
    readonly tabStops?: TabStop[] | undefined;
    border?: Border;
    leftBorder?: Border;
    rightBorder?: Border;
    topBorder?: Border;
    bottomBorder?: Border;
    borderLineWidth?: BorderLineWidth;
    leftBorderLineWidth?: BorderLineWidth;
    rightBorderLineWidth?: BorderLineWidth;
    topBorderLineWidth?: BorderLineWidth;
    bottomBorderLineWidth?: BorderLineWidth;
    padding?: Size;
    leftPadding?: Size;
    rightPadding?: Size;
    topPadding?: Size;
    bottomPadding?: Size;
    margin?: Size;
    leftMargin?: Size;
    rightMargin?: Size;
    topMargin?: Size;
    bottomMargin?: Size;
    backgroundColor?: string | undefined;
    breakBefore?: Break;
    breakAfter?: Break;
    enableLineNumbering?: boolean;
    lineNumberStartValue?: number;
    writingMode?: WritingMode;
    keepTogether?: KeepTogether;
    keepWithNext?: KeepTogether;
    shadow?: string | undefined;
    useFontIndependentLineSpacing?: boolean;
    textAlignmentLastLine?: TextAlignmentLastLine;
    justifySingleWord?: boolean;
    widows?: number;
    orphans?: number;
    tabStopDistance?: Size;
    registerTrue?: boolean;
    textIndent?: Size;
    autoTextIndent?: boolean;
    textAutospace?: TextAutospace;
    punctuationWrap?: PunctuationWrap;
    lineBreak?: LineBreakType;
    autoWritingMode?: boolean;
    snapToLayoutGrid?: boolean;
    pageNumber?: string | undefined;
    backgroundImage?: BackgroundImage;

    constructor(data?: IParagraphPropertiesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.textAlignment = _data["textAlignment"];
            this.fixedLineHeight = _data["fixedLineHeight"];
            this.minimumLineHeight = _data["minimumLineHeight"] ? Size.fromJS(_data["minimumLineHeight"]) : <any>undefined;
            this.lineDistance = _data["lineDistance"] ? Size.fromJS(_data["lineDistance"]) : <any>undefined;
            if (Array.isArray(_data["tabStops"])) {
                (<any>this).tabStops = [] as any;
                for (let item of _data["tabStops"])
                    (<any>this).tabStops!.push(TabStop.fromJS(item));
            }
            this.border = _data["border"] ? Border.fromJS(_data["border"]) : <any>undefined;
            this.leftBorder = _data["leftBorder"] ? Border.fromJS(_data["leftBorder"]) : <any>undefined;
            this.rightBorder = _data["rightBorder"] ? Border.fromJS(_data["rightBorder"]) : <any>undefined;
            this.topBorder = _data["topBorder"] ? Border.fromJS(_data["topBorder"]) : <any>undefined;
            this.bottomBorder = _data["bottomBorder"] ? Border.fromJS(_data["bottomBorder"]) : <any>undefined;
            this.borderLineWidth = _data["borderLineWidth"] ? BorderLineWidth.fromJS(_data["borderLineWidth"]) : <any>undefined;
            this.leftBorderLineWidth = _data["leftBorderLineWidth"] ? BorderLineWidth.fromJS(_data["leftBorderLineWidth"]) : <any>undefined;
            this.rightBorderLineWidth = _data["rightBorderLineWidth"] ? BorderLineWidth.fromJS(_data["rightBorderLineWidth"]) : <any>undefined;
            this.topBorderLineWidth = _data["topBorderLineWidth"] ? BorderLineWidth.fromJS(_data["topBorderLineWidth"]) : <any>undefined;
            this.bottomBorderLineWidth = _data["bottomBorderLineWidth"] ? BorderLineWidth.fromJS(_data["bottomBorderLineWidth"]) : <any>undefined;
            this.padding = _data["padding"] ? Size.fromJS(_data["padding"]) : <any>undefined;
            this.leftPadding = _data["leftPadding"] ? Size.fromJS(_data["leftPadding"]) : <any>undefined;
            this.rightPadding = _data["rightPadding"] ? Size.fromJS(_data["rightPadding"]) : <any>undefined;
            this.topPadding = _data["topPadding"] ? Size.fromJS(_data["topPadding"]) : <any>undefined;
            this.bottomPadding = _data["bottomPadding"] ? Size.fromJS(_data["bottomPadding"]) : <any>undefined;
            this.margin = _data["margin"] ? Size.fromJS(_data["margin"]) : <any>undefined;
            this.leftMargin = _data["leftMargin"] ? Size.fromJS(_data["leftMargin"]) : <any>undefined;
            this.rightMargin = _data["rightMargin"] ? Size.fromJS(_data["rightMargin"]) : <any>undefined;
            this.topMargin = _data["topMargin"] ? Size.fromJS(_data["topMargin"]) : <any>undefined;
            this.bottomMargin = _data["bottomMargin"] ? Size.fromJS(_data["bottomMargin"]) : <any>undefined;
            this.backgroundColor = _data["backgroundColor"];
            this.breakBefore = _data["breakBefore"];
            this.breakAfter = _data["breakAfter"];
            this.enableLineNumbering = _data["enableLineNumbering"];
            this.lineNumberStartValue = _data["lineNumberStartValue"];
            this.writingMode = _data["writingMode"];
            this.keepTogether = _data["keepTogether"];
            this.keepWithNext = _data["keepWithNext"];
            this.shadow = _data["shadow"];
            this.useFontIndependentLineSpacing = _data["useFontIndependentLineSpacing"];
            this.textAlignmentLastLine = _data["textAlignmentLastLine"];
            this.justifySingleWord = _data["justifySingleWord"];
            this.widows = _data["widows"];
            this.orphans = _data["orphans"];
            this.tabStopDistance = _data["tabStopDistance"] ? Size.fromJS(_data["tabStopDistance"]) : <any>undefined;
            this.registerTrue = _data["registerTrue"];
            this.textIndent = _data["textIndent"] ? Size.fromJS(_data["textIndent"]) : <any>undefined;
            this.autoTextIndent = _data["autoTextIndent"];
            this.textAutospace = _data["textAutospace"];
            this.punctuationWrap = _data["punctuationWrap"];
            this.lineBreak = _data["lineBreak"];
            this.autoWritingMode = _data["autoWritingMode"];
            this.snapToLayoutGrid = _data["snapToLayoutGrid"];
            this.pageNumber = _data["pageNumber"];
            this.backgroundImage = _data["backgroundImage"] ? BackgroundImage.fromJS(_data["backgroundImage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ParagraphPropertiesModel {
        data = typeof data === 'object' ? data : {};
        let result = new ParagraphPropertiesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["textAlignment"] = this.textAlignment;
        data["fixedLineHeight"] = this.fixedLineHeight;
        data["minimumLineHeight"] = this.minimumLineHeight ? this.minimumLineHeight.toJSON() : <any>undefined;
        data["lineDistance"] = this.lineDistance ? this.lineDistance.toJSON() : <any>undefined;
        if (Array.isArray(this.tabStops)) {
            data["tabStops"] = [];
            for (let item of this.tabStops)
                data["tabStops"].push(item.toJSON());
        }
        data["border"] = this.border ? this.border.toJSON() : <any>undefined;
        data["leftBorder"] = this.leftBorder ? this.leftBorder.toJSON() : <any>undefined;
        data["rightBorder"] = this.rightBorder ? this.rightBorder.toJSON() : <any>undefined;
        data["topBorder"] = this.topBorder ? this.topBorder.toJSON() : <any>undefined;
        data["bottomBorder"] = this.bottomBorder ? this.bottomBorder.toJSON() : <any>undefined;
        data["borderLineWidth"] = this.borderLineWidth ? this.borderLineWidth.toJSON() : <any>undefined;
        data["leftBorderLineWidth"] = this.leftBorderLineWidth ? this.leftBorderLineWidth.toJSON() : <any>undefined;
        data["rightBorderLineWidth"] = this.rightBorderLineWidth ? this.rightBorderLineWidth.toJSON() : <any>undefined;
        data["topBorderLineWidth"] = this.topBorderLineWidth ? this.topBorderLineWidth.toJSON() : <any>undefined;
        data["bottomBorderLineWidth"] = this.bottomBorderLineWidth ? this.bottomBorderLineWidth.toJSON() : <any>undefined;
        data["padding"] = this.padding ? this.padding.toJSON() : <any>undefined;
        data["leftPadding"] = this.leftPadding ? this.leftPadding.toJSON() : <any>undefined;
        data["rightPadding"] = this.rightPadding ? this.rightPadding.toJSON() : <any>undefined;
        data["topPadding"] = this.topPadding ? this.topPadding.toJSON() : <any>undefined;
        data["bottomPadding"] = this.bottomPadding ? this.bottomPadding.toJSON() : <any>undefined;
        data["margin"] = this.margin ? this.margin.toJSON() : <any>undefined;
        data["leftMargin"] = this.leftMargin ? this.leftMargin.toJSON() : <any>undefined;
        data["rightMargin"] = this.rightMargin ? this.rightMargin.toJSON() : <any>undefined;
        data["topMargin"] = this.topMargin ? this.topMargin.toJSON() : <any>undefined;
        data["bottomMargin"] = this.bottomMargin ? this.bottomMargin.toJSON() : <any>undefined;
        data["backgroundColor"] = this.backgroundColor;
        data["breakBefore"] = this.breakBefore;
        data["breakAfter"] = this.breakAfter;
        data["enableLineNumbering"] = this.enableLineNumbering;
        data["lineNumberStartValue"] = this.lineNumberStartValue;
        data["writingMode"] = this.writingMode;
        data["keepTogether"] = this.keepTogether;
        data["keepWithNext"] = this.keepWithNext;
        data["shadow"] = this.shadow;
        data["useFontIndependentLineSpacing"] = this.useFontIndependentLineSpacing;
        data["textAlignmentLastLine"] = this.textAlignmentLastLine;
        data["justifySingleWord"] = this.justifySingleWord;
        data["widows"] = this.widows;
        data["orphans"] = this.orphans;
        data["tabStopDistance"] = this.tabStopDistance ? this.tabStopDistance.toJSON() : <any>undefined;
        data["registerTrue"] = this.registerTrue;
        data["textIndent"] = this.textIndent ? this.textIndent.toJSON() : <any>undefined;
        data["autoTextIndent"] = this.autoTextIndent;
        data["textAutospace"] = this.textAutospace;
        data["punctuationWrap"] = this.punctuationWrap;
        data["lineBreak"] = this.lineBreak;
        data["autoWritingMode"] = this.autoWritingMode;
        data["snapToLayoutGrid"] = this.snapToLayoutGrid;
        data["pageNumber"] = this.pageNumber;
        data["backgroundImage"] = this.backgroundImage ? this.backgroundImage.toJSON() : <any>undefined;
        return data;
    }
}

export interface IParagraphPropertiesModel {
    textAlignment?: TextAlignment;
    fixedLineHeight?: string | undefined;
    minimumLineHeight?: Size;
    lineDistance?: Size;
    tabStops?: TabStop[] | undefined;
    border?: Border;
    leftBorder?: Border;
    rightBorder?: Border;
    topBorder?: Border;
    bottomBorder?: Border;
    borderLineWidth?: BorderLineWidth;
    leftBorderLineWidth?: BorderLineWidth;
    rightBorderLineWidth?: BorderLineWidth;
    topBorderLineWidth?: BorderLineWidth;
    bottomBorderLineWidth?: BorderLineWidth;
    padding?: Size;
    leftPadding?: Size;
    rightPadding?: Size;
    topPadding?: Size;
    bottomPadding?: Size;
    margin?: Size;
    leftMargin?: Size;
    rightMargin?: Size;
    topMargin?: Size;
    bottomMargin?: Size;
    backgroundColor?: string | undefined;
    breakBefore?: Break;
    breakAfter?: Break;
    enableLineNumbering?: boolean;
    lineNumberStartValue?: number;
    writingMode?: WritingMode;
    keepTogether?: KeepTogether;
    keepWithNext?: KeepTogether;
    shadow?: string | undefined;
    useFontIndependentLineSpacing?: boolean;
    textAlignmentLastLine?: TextAlignmentLastLine;
    justifySingleWord?: boolean;
    widows?: number;
    orphans?: number;
    tabStopDistance?: Size;
    registerTrue?: boolean;
    textIndent?: Size;
    autoTextIndent?: boolean;
    textAutospace?: TextAutospace;
    punctuationWrap?: PunctuationWrap;
    lineBreak?: LineBreakType;
    autoWritingMode?: boolean;
    snapToLayoutGrid?: boolean;
    pageNumber?: string | undefined;
    backgroundImage?: BackgroundImage;
}

export class PlanHistorieModel implements IPlanHistorieModel {
    jahr?: number;
    datum?: Date;
    wert?: number;
    nutzer?: string | undefined;

    constructor(data?: IPlanHistorieModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jahr = _data["jahr"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
            this.wert = _data["wert"];
            this.nutzer = _data["nutzer"];
        }
    }

    static fromJS(data: any): PlanHistorieModel {
        data = typeof data === 'object' ? data : {};
        let result = new PlanHistorieModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jahr"] = this.jahr;
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        data["wert"] = this.wert;
        data["nutzer"] = this.nutzer;
        return data;
    }
}

export interface IPlanHistorieModel {
    jahr?: number;
    datum?: Date;
    wert?: number;
    nutzer?: string | undefined;
}

export class Planstufen implements IPlanstufen {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    plantyp?: number;
    planstufe?: number;
    oeffentlich?: boolean;
    datum?: Date;
    bezeichnung?: string | undefined;
    ueberschrift?: string | undefined;
    doppelhaushalt?: boolean | undefined;
    monat?: number | undefined;
    importFormat?: number | undefined;
    vvjvorl?: boolean | undefined;
    vergleichbar?: boolean | undefined;
    editierbar?: boolean | undefined;
    kommentierbar?: boolean | undefined;
    vorjahrVorlaeufig?: boolean | undefined;
    impVvjansatz?: boolean | undefined;
    vvjistAnatz?: boolean | undefined;
    keinePrognose?: boolean | undefined;
    keinVerfuegbarEinz?: boolean | undefined;
    fortAnsVjanz?: boolean | undefined;
    keineProgErrechnet?: boolean | undefined;
    vvjausJr?: boolean | undefined;
    gemeinden?: Gemeinden;

    constructor(data?: IPlanstufen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.plantyp = _data["plantyp"];
            this.planstufe = _data["planstufe"];
            this.oeffentlich = _data["oeffentlich"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
            this.bezeichnung = _data["bezeichnung"];
            this.ueberschrift = _data["ueberschrift"];
            this.doppelhaushalt = _data["doppelhaushalt"];
            this.monat = _data["monat"];
            this.importFormat = _data["importFormat"];
            this.vvjvorl = _data["vvjvorl"];
            this.vergleichbar = _data["vergleichbar"];
            this.editierbar = _data["editierbar"];
            this.kommentierbar = _data["kommentierbar"];
            this.vorjahrVorlaeufig = _data["vorjahrVorlaeufig"];
            this.impVvjansatz = _data["impVvjansatz"];
            this.vvjistAnatz = _data["vvjistAnatz"];
            this.keinePrognose = _data["keinePrognose"];
            this.keinVerfuegbarEinz = _data["keinVerfuegbarEinz"];
            this.fortAnsVjanz = _data["fortAnsVjanz"];
            this.keineProgErrechnet = _data["keineProgErrechnet"];
            this.vvjausJr = _data["vvjausJr"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Planstufen {
        data = typeof data === 'object' ? data : {};
        let result = new Planstufen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["plantyp"] = this.plantyp;
        data["planstufe"] = this.planstufe;
        data["oeffentlich"] = this.oeffentlich;
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        data["bezeichnung"] = this.bezeichnung;
        data["ueberschrift"] = this.ueberschrift;
        data["doppelhaushalt"] = this.doppelhaushalt;
        data["monat"] = this.monat;
        data["importFormat"] = this.importFormat;
        data["vvjvorl"] = this.vvjvorl;
        data["vergleichbar"] = this.vergleichbar;
        data["editierbar"] = this.editierbar;
        data["kommentierbar"] = this.kommentierbar;
        data["vorjahrVorlaeufig"] = this.vorjahrVorlaeufig;
        data["impVvjansatz"] = this.impVvjansatz;
        data["vvjistAnatz"] = this.vvjistAnatz;
        data["keinePrognose"] = this.keinePrognose;
        data["keinVerfuegbarEinz"] = this.keinVerfuegbarEinz;
        data["fortAnsVjanz"] = this.fortAnsVjanz;
        data["keineProgErrechnet"] = this.keineProgErrechnet;
        data["vvjausJr"] = this.vvjausJr;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPlanstufen {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    plantyp?: number;
    planstufe?: number;
    oeffentlich?: boolean;
    datum?: Date;
    bezeichnung?: string | undefined;
    ueberschrift?: string | undefined;
    doppelhaushalt?: boolean | undefined;
    monat?: number | undefined;
    importFormat?: number | undefined;
    vvjvorl?: boolean | undefined;
    vergleichbar?: boolean | undefined;
    editierbar?: boolean | undefined;
    kommentierbar?: boolean | undefined;
    vorjahrVorlaeufig?: boolean | undefined;
    impVvjansatz?: boolean | undefined;
    vvjistAnatz?: boolean | undefined;
    keinePrognose?: boolean | undefined;
    keinVerfuegbarEinz?: boolean | undefined;
    fortAnsVjanz?: boolean | undefined;
    keineProgErrechnet?: boolean | undefined;
    vvjausJr?: boolean | undefined;
    gemeinden?: Gemeinden;
}

export class PlanstufenHiddenTab implements IPlanstufenHiddenTab {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    plantyp?: number;
    planstufe?: number;
    typ?: number;
    ba?: boolean;
    va?: boolean;
    objectNumId?: number | undefined;
    objectStringId?: string | undefined;

    constructor(data?: IPlanstufenHiddenTab) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.plantyp = _data["plantyp"];
            this.planstufe = _data["planstufe"];
            this.typ = _data["typ"];
            this.ba = _data["ba"];
            this.va = _data["va"];
            this.objectNumId = _data["objectNumId"];
            this.objectStringId = _data["objectStringId"];
        }
    }

    static fromJS(data: any): PlanstufenHiddenTab {
        data = typeof data === 'object' ? data : {};
        let result = new PlanstufenHiddenTab();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["plantyp"] = this.plantyp;
        data["planstufe"] = this.planstufe;
        data["typ"] = this.typ;
        data["ba"] = this.ba;
        data["va"] = this.va;
        data["objectNumId"] = this.objectNumId;
        data["objectStringId"] = this.objectStringId;
        return data;
    }
}

export interface IPlanstufenHiddenTab {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    plantyp?: number;
    planstufe?: number;
    typ?: number;
    ba?: boolean;
    va?: boolean;
    objectNumId?: number | undefined;
    objectStringId?: string | undefined;
}

export class PlanstufenHiddenTabsModel implements IPlanstufenHiddenTabsModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    plantyp?: number;
    planstufe?: number;
    typ?: number;
    ba?: boolean;
    va?: boolean;
    objectNumId?: number | undefined;
    objectStringId?: string | undefined;
    bezeichnung?: string | undefined;

    constructor(data?: IPlanstufenHiddenTabsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.plantyp = _data["plantyp"];
            this.planstufe = _data["planstufe"];
            this.typ = _data["typ"];
            this.ba = _data["ba"];
            this.va = _data["va"];
            this.objectNumId = _data["objectNumId"];
            this.objectStringId = _data["objectStringId"];
            this.bezeichnung = _data["bezeichnung"];
        }
    }

    static fromJS(data: any): PlanstufenHiddenTabsModel {
        data = typeof data === 'object' ? data : {};
        let result = new PlanstufenHiddenTabsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["plantyp"] = this.plantyp;
        data["planstufe"] = this.planstufe;
        data["typ"] = this.typ;
        data["ba"] = this.ba;
        data["va"] = this.va;
        data["objectNumId"] = this.objectNumId;
        data["objectStringId"] = this.objectStringId;
        data["bezeichnung"] = this.bezeichnung;
        return data;
    }
}

export interface IPlanstufenHiddenTabsModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    plantyp?: number;
    planstufe?: number;
    typ?: number;
    ba?: boolean;
    va?: boolean;
    objectNumId?: number | undefined;
    objectStringId?: string | undefined;
    bezeichnung?: string | undefined;
}

export class Pos2Konto implements IPos2Konto {
    id?: string | undefined;
    passiva?: boolean;
    pos?: string | undefined;
    konto?: string | undefined;

    constructor(data?: IPos2Konto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.passiva = _data["passiva"];
            this.pos = _data["pos"];
            this.konto = _data["konto"];
        }
    }

    static fromJS(data: any): Pos2Konto {
        data = typeof data === 'object' ? data : {};
        let result = new Pos2Konto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["passiva"] = this.passiva;
        data["pos"] = this.pos;
        data["konto"] = this.konto;
        return data;
    }
}

export interface IPos2Konto {
    id?: string | undefined;
    passiva?: boolean;
    pos?: string | undefined;
    konto?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class Produkt2Text implements IProdukt2Text {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    nummer?: number;
    textId?: number;
    order?: number | undefined;

    constructor(data?: IProdukt2Text) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.stellen = _data["stellen"];
            this.nummer = _data["nummer"];
            this.textId = _data["textId"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): Produkt2Text {
        data = typeof data === 'object' ? data : {};
        let result = new Produkt2Text();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["stellen"] = this.stellen;
        data["nummer"] = this.nummer;
        data["textId"] = this.textId;
        data["order"] = this.order;
        return data;
    }
}

export interface IProdukt2Text {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    nummer?: number;
    textId?: number;
    order?: number | undefined;
}

export class ProduktModel implements IProduktModel {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    nummer?: number;
    bezeichnung?: string | undefined;
    loeschbar?: boolean;
    umbenennbar?: boolean;
    beschreibung?: string | undefined;
    geprueft?: boolean | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;
    id?: number;
    nummerFmt?: string | undefined;

    constructor(data?: IProduktModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.stellen = _data["stellen"];
            this.nummer = _data["nummer"];
            this.bezeichnung = _data["bezeichnung"];
            this.loeschbar = _data["loeschbar"];
            this.umbenennbar = _data["umbenennbar"];
            this.beschreibung = _data["beschreibung"];
            this.geprueft = _data["geprueft"];
            this.oeffentlich = _data["oeffentlich"];
            this.oeffentlichVerwaltung = _data["oeffentlichVerwaltung"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
            this.id = _data["id"];
            this.nummerFmt = _data["nummerFmt"];
        }
    }

    static fromJS(data: any): ProduktModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProduktModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["stellen"] = this.stellen;
        data["nummer"] = this.nummer;
        data["bezeichnung"] = this.bezeichnung;
        data["loeschbar"] = this.loeschbar;
        data["umbenennbar"] = this.umbenennbar;
        data["beschreibung"] = this.beschreibung;
        data["geprueft"] = this.geprueft;
        data["oeffentlich"] = this.oeffentlich;
        data["oeffentlichVerwaltung"] = this.oeffentlichVerwaltung;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["nummerFmt"] = this.nummerFmt;
        return data;
    }
}

export interface IProduktModel {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    nummer?: number;
    bezeichnung?: string | undefined;
    loeschbar?: boolean;
    umbenennbar?: boolean;
    beschreibung?: string | undefined;
    geprueft?: boolean | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;
    id?: number;
    nummerFmt?: string | undefined;
}

export class Produkte implements IProdukte {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    nummer?: number;
    bezeichnung?: string | undefined;
    loeschbar?: boolean;
    umbenennbar?: boolean;
    beschreibung?: string | undefined;
    geprueft?: boolean | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;

    constructor(data?: IProdukte) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.stellen = _data["stellen"];
            this.nummer = _data["nummer"];
            this.bezeichnung = _data["bezeichnung"];
            this.loeschbar = _data["loeschbar"];
            this.umbenennbar = _data["umbenennbar"];
            this.beschreibung = _data["beschreibung"];
            this.geprueft = _data["geprueft"];
            this.oeffentlich = _data["oeffentlich"];
            this.oeffentlichVerwaltung = _data["oeffentlichVerwaltung"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Produkte {
        data = typeof data === 'object' ? data : {};
        let result = new Produkte();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["stellen"] = this.stellen;
        data["nummer"] = this.nummer;
        data["bezeichnung"] = this.bezeichnung;
        data["loeschbar"] = this.loeschbar;
        data["umbenennbar"] = this.umbenennbar;
        data["beschreibung"] = this.beschreibung;
        data["geprueft"] = this.geprueft;
        data["oeffentlich"] = this.oeffentlich;
        data["oeffentlichVerwaltung"] = this.oeffentlichVerwaltung;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProdukte {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    nummer?: number;
    bezeichnung?: string | undefined;
    loeschbar?: boolean;
    umbenennbar?: boolean;
    beschreibung?: string | undefined;
    geprueft?: boolean | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;
}

export class Produktebenen implements IProduktebenen {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    bezeichnung?: string | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;

    constructor(data?: IProduktebenen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.stellen = _data["stellen"];
            this.bezeichnung = _data["bezeichnung"];
            this.oeffentlich = _data["oeffentlich"];
            this.oeffentlichVerwaltung = _data["oeffentlichVerwaltung"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Produktebenen {
        data = typeof data === 'object' ? data : {};
        let result = new Produktebenen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["stellen"] = this.stellen;
        data["bezeichnung"] = this.bezeichnung;
        data["oeffentlich"] = this.oeffentlich;
        data["oeffentlichVerwaltung"] = this.oeffentlichVerwaltung;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProduktebenen {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    bezeichnung?: string | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;
}

export class ProduktebenenModel implements IProduktebenenModel {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    bezeichnung?: string | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;
    id?: number;

    constructor(data?: IProduktebenenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.stellen = _data["stellen"];
            this.bezeichnung = _data["bezeichnung"];
            this.oeffentlich = _data["oeffentlich"];
            this.oeffentlichVerwaltung = _data["oeffentlichVerwaltung"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProduktebenenModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProduktebenenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["stellen"] = this.stellen;
        data["bezeichnung"] = this.bezeichnung;
        data["oeffentlich"] = this.oeffentlich;
        data["oeffentlichVerwaltung"] = this.oeffentlichVerwaltung;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IProduktebenenModel {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    stellen?: number;
    bezeichnung?: string | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    gemeinden?: Gemeinden;
    id?: number;
}

export class Prognosekurven implements IPrognosekurven {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    januar?: number | undefined;
    februar?: number | undefined;
    maerz?: number | undefined;
    mai?: number | undefined;
    april?: number | undefined;
    juni?: number | undefined;
    juli?: number | undefined;
    august?: number | undefined;
    september?: number | undefined;
    oktober?: number | undefined;
    november?: number | undefined;
    dezember?: number | undefined;
    valid?: boolean | undefined;

    constructor(data?: IPrognosekurven) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.bezeichnung = _data["bezeichnung"];
            this.januar = _data["januar"];
            this.februar = _data["februar"];
            this.maerz = _data["maerz"];
            this.mai = _data["mai"];
            this.april = _data["april"];
            this.juni = _data["juni"];
            this.juli = _data["juli"];
            this.august = _data["august"];
            this.september = _data["september"];
            this.oktober = _data["oktober"];
            this.november = _data["november"];
            this.dezember = _data["dezember"];
            this.valid = _data["valid"];
        }
    }

    static fromJS(data: any): Prognosekurven {
        data = typeof data === 'object' ? data : {};
        let result = new Prognosekurven();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["bezeichnung"] = this.bezeichnung;
        data["januar"] = this.januar;
        data["februar"] = this.februar;
        data["maerz"] = this.maerz;
        data["mai"] = this.mai;
        data["april"] = this.april;
        data["juni"] = this.juni;
        data["juli"] = this.juli;
        data["august"] = this.august;
        data["september"] = this.september;
        data["oktober"] = this.oktober;
        data["november"] = this.november;
        data["dezember"] = this.dezember;
        data["valid"] = this.valid;
        return data;
    }
}

export interface IPrognosekurven {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    januar?: number | undefined;
    februar?: number | undefined;
    maerz?: number | undefined;
    mai?: number | undefined;
    april?: number | undefined;
    juni?: number | undefined;
    juli?: number | undefined;
    august?: number | undefined;
    september?: number | undefined;
    oktober?: number | undefined;
    november?: number | undefined;
    dezember?: number | undefined;
    valid?: boolean | undefined;
}

export enum PunctuationWrap {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class PushABCModel implements IPushABCModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    quell?: Abcanalyse;

    constructor(data?: IPushABCModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.modul = _data["modul"];
            this.verwaltungsansicht = _data["verwaltungsansicht"];
            if (Array.isArray(_data["zielGemeinden"])) {
                this.zielGemeinden = [] as any;
                for (let item of _data["zielGemeinden"])
                    this.zielGemeinden!.push(GemeindeModel.fromJS(item));
            }
            if (Array.isArray(_data["zielBundeslaender"])) {
                this.zielBundeslaender = [] as any;
                for (let item of _data["zielBundeslaender"])
                    this.zielBundeslaender!.push(Bundeslaender.fromJS(item));
            }
            this.quell = _data["quell"] ? Abcanalyse.fromJS(_data["quell"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PushABCModel {
        data = typeof data === 'object' ? data : {};
        let result = new PushABCModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["modul"] = this.modul;
        data["verwaltungsansicht"] = this.verwaltungsansicht;
        if (Array.isArray(this.zielGemeinden)) {
            data["zielGemeinden"] = [];
            for (let item of this.zielGemeinden)
                data["zielGemeinden"].push(item.toJSON());
        }
        if (Array.isArray(this.zielBundeslaender)) {
            data["zielBundeslaender"] = [];
            for (let item of this.zielBundeslaender)
                data["zielBundeslaender"].push(item.toJSON());
        }
        data["quell"] = this.quell ? this.quell.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPushABCModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    quell?: Abcanalyse;
}

export class PushBerichtsvorlagenModel implements IPushBerichtsvorlagenModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    ueberschreiben?: boolean;
    quellList?: BerichtsvorlageModel[] | undefined;

    constructor(data?: IPushBerichtsvorlagenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.modul = _data["modul"];
            this.verwaltungsansicht = _data["verwaltungsansicht"];
            if (Array.isArray(_data["zielGemeinden"])) {
                this.zielGemeinden = [] as any;
                for (let item of _data["zielGemeinden"])
                    this.zielGemeinden!.push(GemeindeModel.fromJS(item));
            }
            if (Array.isArray(_data["zielBundeslaender"])) {
                this.zielBundeslaender = [] as any;
                for (let item of _data["zielBundeslaender"])
                    this.zielBundeslaender!.push(Bundeslaender.fromJS(item));
            }
            this.ueberschreiben = _data["ueberschreiben"];
            if (Array.isArray(_data["quellList"])) {
                this.quellList = [] as any;
                for (let item of _data["quellList"])
                    this.quellList!.push(BerichtsvorlageModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PushBerichtsvorlagenModel {
        data = typeof data === 'object' ? data : {};
        let result = new PushBerichtsvorlagenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["modul"] = this.modul;
        data["verwaltungsansicht"] = this.verwaltungsansicht;
        if (Array.isArray(this.zielGemeinden)) {
            data["zielGemeinden"] = [];
            for (let item of this.zielGemeinden)
                data["zielGemeinden"].push(item.toJSON());
        }
        if (Array.isArray(this.zielBundeslaender)) {
            data["zielBundeslaender"] = [];
            for (let item of this.zielBundeslaender)
                data["zielBundeslaender"].push(item.toJSON());
        }
        data["ueberschreiben"] = this.ueberschreiben;
        if (Array.isArray(this.quellList)) {
            data["quellList"] = [];
            for (let item of this.quellList)
                data["quellList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPushBerichtsvorlagenModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    ueberschreiben?: boolean;
    quellList?: BerichtsvorlageModel[] | undefined;
}

export class PushChangeSettingsModel implements IPushChangeSettingsModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    quell?: ChangeSetting;

    constructor(data?: IPushChangeSettingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.modul = _data["modul"];
            this.verwaltungsansicht = _data["verwaltungsansicht"];
            if (Array.isArray(_data["zielGemeinden"])) {
                this.zielGemeinden = [] as any;
                for (let item of _data["zielGemeinden"])
                    this.zielGemeinden!.push(GemeindeModel.fromJS(item));
            }
            if (Array.isArray(_data["zielBundeslaender"])) {
                this.zielBundeslaender = [] as any;
                for (let item of _data["zielBundeslaender"])
                    this.zielBundeslaender!.push(Bundeslaender.fromJS(item));
            }
            this.quell = _data["quell"] ? ChangeSetting.fromJS(_data["quell"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PushChangeSettingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new PushChangeSettingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["modul"] = this.modul;
        data["verwaltungsansicht"] = this.verwaltungsansicht;
        if (Array.isArray(this.zielGemeinden)) {
            data["zielGemeinden"] = [];
            for (let item of this.zielGemeinden)
                data["zielGemeinden"].push(item.toJSON());
        }
        if (Array.isArray(this.zielBundeslaender)) {
            data["zielBundeslaender"] = [];
            for (let item of this.zielBundeslaender)
                data["zielBundeslaender"].push(item.toJSON());
        }
        data["quell"] = this.quell ? this.quell.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPushChangeSettingsModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    quell?: ChangeSetting;
}

export class PushDSHP implements IPushDSHP {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    quell?: DarstellungHp;

    constructor(data?: IPushDSHP) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.modul = _data["modul"];
            this.verwaltungsansicht = _data["verwaltungsansicht"];
            if (Array.isArray(_data["zielGemeinden"])) {
                this.zielGemeinden = [] as any;
                for (let item of _data["zielGemeinden"])
                    this.zielGemeinden!.push(GemeindeModel.fromJS(item));
            }
            if (Array.isArray(_data["zielBundeslaender"])) {
                this.zielBundeslaender = [] as any;
                for (let item of _data["zielBundeslaender"])
                    this.zielBundeslaender!.push(Bundeslaender.fromJS(item));
            }
            this.quell = _data["quell"] ? DarstellungHp.fromJS(_data["quell"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PushDSHP {
        data = typeof data === 'object' ? data : {};
        let result = new PushDSHP();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["modul"] = this.modul;
        data["verwaltungsansicht"] = this.verwaltungsansicht;
        if (Array.isArray(this.zielGemeinden)) {
            data["zielGemeinden"] = [];
            for (let item of this.zielGemeinden)
                data["zielGemeinden"].push(item.toJSON());
        }
        if (Array.isArray(this.zielBundeslaender)) {
            data["zielBundeslaender"] = [];
            for (let item of this.zielBundeslaender)
                data["zielBundeslaender"].push(item.toJSON());
        }
        data["quell"] = this.quell ? this.quell.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPushDSHP {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    quell?: DarstellungHp;
}

export class PushDokumenteModel implements IPushDokumenteModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    ueberschreiben?: boolean;
    quellList?: Dokumente[] | undefined;

    constructor(data?: IPushDokumenteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.modul = _data["modul"];
            this.verwaltungsansicht = _data["verwaltungsansicht"];
            if (Array.isArray(_data["zielGemeinden"])) {
                this.zielGemeinden = [] as any;
                for (let item of _data["zielGemeinden"])
                    this.zielGemeinden!.push(GemeindeModel.fromJS(item));
            }
            if (Array.isArray(_data["zielBundeslaender"])) {
                this.zielBundeslaender = [] as any;
                for (let item of _data["zielBundeslaender"])
                    this.zielBundeslaender!.push(Bundeslaender.fromJS(item));
            }
            this.ueberschreiben = _data["ueberschreiben"];
            if (Array.isArray(_data["quellList"])) {
                this.quellList = [] as any;
                for (let item of _data["quellList"])
                    this.quellList!.push(Dokumente.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PushDokumenteModel {
        data = typeof data === 'object' ? data : {};
        let result = new PushDokumenteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["modul"] = this.modul;
        data["verwaltungsansicht"] = this.verwaltungsansicht;
        if (Array.isArray(this.zielGemeinden)) {
            data["zielGemeinden"] = [];
            for (let item of this.zielGemeinden)
                data["zielGemeinden"].push(item.toJSON());
        }
        if (Array.isArray(this.zielBundeslaender)) {
            data["zielBundeslaender"] = [];
            for (let item of this.zielBundeslaender)
                data["zielBundeslaender"].push(item.toJSON());
        }
        data["ueberschreiben"] = this.ueberschreiben;
        if (Array.isArray(this.quellList)) {
            data["quellList"] = [];
            for (let item of this.quellList)
                data["quellList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPushDokumenteModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    ueberschreiben?: boolean;
    quellList?: Dokumente[] | undefined;
}

export class PushEbenenModel implements IPushEbenenModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    ueberschreiben?: boolean;
    quellList?: Ebenen[] | undefined;

    constructor(data?: IPushEbenenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.modul = _data["modul"];
            this.verwaltungsansicht = _data["verwaltungsansicht"];
            if (Array.isArray(_data["zielGemeinden"])) {
                this.zielGemeinden = [] as any;
                for (let item of _data["zielGemeinden"])
                    this.zielGemeinden!.push(GemeindeModel.fromJS(item));
            }
            if (Array.isArray(_data["zielBundeslaender"])) {
                this.zielBundeslaender = [] as any;
                for (let item of _data["zielBundeslaender"])
                    this.zielBundeslaender!.push(Bundeslaender.fromJS(item));
            }
            this.ueberschreiben = _data["ueberschreiben"];
            if (Array.isArray(_data["quellList"])) {
                this.quellList = [] as any;
                for (let item of _data["quellList"])
                    this.quellList!.push(Ebenen.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PushEbenenModel {
        data = typeof data === 'object' ? data : {};
        let result = new PushEbenenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["modul"] = this.modul;
        data["verwaltungsansicht"] = this.verwaltungsansicht;
        if (Array.isArray(this.zielGemeinden)) {
            data["zielGemeinden"] = [];
            for (let item of this.zielGemeinden)
                data["zielGemeinden"].push(item.toJSON());
        }
        if (Array.isArray(this.zielBundeslaender)) {
            data["zielBundeslaender"] = [];
            for (let item of this.zielBundeslaender)
                data["zielBundeslaender"].push(item.toJSON());
        }
        data["ueberschreiben"] = this.ueberschreiben;
        if (Array.isArray(this.quellList)) {
            data["quellList"] = [];
            for (let item of this.quellList)
                data["quellList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPushEbenenModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    ueberschreiben?: boolean;
    quellList?: Ebenen[] | undefined;
}

export class PushFarbenModel implements IPushFarbenModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    ueberschreiben?: boolean;
    quellList?: Farben[] | undefined;

    constructor(data?: IPushFarbenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.modul = _data["modul"];
            this.verwaltungsansicht = _data["verwaltungsansicht"];
            if (Array.isArray(_data["zielGemeinden"])) {
                this.zielGemeinden = [] as any;
                for (let item of _data["zielGemeinden"])
                    this.zielGemeinden!.push(GemeindeModel.fromJS(item));
            }
            if (Array.isArray(_data["zielBundeslaender"])) {
                this.zielBundeslaender = [] as any;
                for (let item of _data["zielBundeslaender"])
                    this.zielBundeslaender!.push(Bundeslaender.fromJS(item));
            }
            this.ueberschreiben = _data["ueberschreiben"];
            if (Array.isArray(_data["quellList"])) {
                this.quellList = [] as any;
                for (let item of _data["quellList"])
                    this.quellList!.push(Farben.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PushFarbenModel {
        data = typeof data === 'object' ? data : {};
        let result = new PushFarbenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["modul"] = this.modul;
        data["verwaltungsansicht"] = this.verwaltungsansicht;
        if (Array.isArray(this.zielGemeinden)) {
            data["zielGemeinden"] = [];
            for (let item of this.zielGemeinden)
                data["zielGemeinden"].push(item.toJSON());
        }
        if (Array.isArray(this.zielBundeslaender)) {
            data["zielBundeslaender"] = [];
            for (let item of this.zielBundeslaender)
                data["zielBundeslaender"].push(item.toJSON());
        }
        data["ueberschreiben"] = this.ueberschreiben;
        if (Array.isArray(this.quellList)) {
            data["quellList"] = [];
            for (let item of this.quellList)
                data["quellList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPushFarbenModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    ueberschreiben?: boolean;
    quellList?: Farben[] | undefined;
}

export class PushGZEbenenModel implements IPushGZEbenenModel {
    ueberschreiben?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    quellDS?: Datensaetze[] | undefined;
    quellGZEbenen?: GZEbenenModel[] | undefined;

    constructor(data?: IPushGZEbenenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ueberschreiben = _data["ueberschreiben"];
            if (Array.isArray(_data["zielGemeinden"])) {
                this.zielGemeinden = [] as any;
                for (let item of _data["zielGemeinden"])
                    this.zielGemeinden!.push(GemeindeModel.fromJS(item));
            }
            if (Array.isArray(_data["quellDS"])) {
                this.quellDS = [] as any;
                for (let item of _data["quellDS"])
                    this.quellDS!.push(Datensaetze.fromJS(item));
            }
            if (Array.isArray(_data["quellGZEbenen"])) {
                this.quellGZEbenen = [] as any;
                for (let item of _data["quellGZEbenen"])
                    this.quellGZEbenen!.push(GZEbenenModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PushGZEbenenModel {
        data = typeof data === 'object' ? data : {};
        let result = new PushGZEbenenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ueberschreiben"] = this.ueberschreiben;
        if (Array.isArray(this.zielGemeinden)) {
            data["zielGemeinden"] = [];
            for (let item of this.zielGemeinden)
                data["zielGemeinden"].push(item.toJSON());
        }
        if (Array.isArray(this.quellDS)) {
            data["quellDS"] = [];
            for (let item of this.quellDS)
                data["quellDS"].push(item.toJSON());
        }
        if (Array.isArray(this.quellGZEbenen)) {
            data["quellGZEbenen"] = [];
            for (let item of this.quellGZEbenen)
                data["quellGZEbenen"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPushGZEbenenModel {
    ueberschreiben?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    quellDS?: Datensaetze[] | undefined;
    quellGZEbenen?: GZEbenenModel[] | undefined;
}

export class PushGliederungModel implements IPushGliederungModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    ueberschreiben?: boolean;
    quellList?: Gliederung[] | undefined;

    constructor(data?: IPushGliederungModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.modul = _data["modul"];
            this.verwaltungsansicht = _data["verwaltungsansicht"];
            if (Array.isArray(_data["zielGemeinden"])) {
                this.zielGemeinden = [] as any;
                for (let item of _data["zielGemeinden"])
                    this.zielGemeinden!.push(GemeindeModel.fromJS(item));
            }
            if (Array.isArray(_data["zielBundeslaender"])) {
                this.zielBundeslaender = [] as any;
                for (let item of _data["zielBundeslaender"])
                    this.zielBundeslaender!.push(Bundeslaender.fromJS(item));
            }
            this.ueberschreiben = _data["ueberschreiben"];
            if (Array.isArray(_data["quellList"])) {
                this.quellList = [] as any;
                for (let item of _data["quellList"])
                    this.quellList!.push(Gliederung.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PushGliederungModel {
        data = typeof data === 'object' ? data : {};
        let result = new PushGliederungModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["modul"] = this.modul;
        data["verwaltungsansicht"] = this.verwaltungsansicht;
        if (Array.isArray(this.zielGemeinden)) {
            data["zielGemeinden"] = [];
            for (let item of this.zielGemeinden)
                data["zielGemeinden"].push(item.toJSON());
        }
        if (Array.isArray(this.zielBundeslaender)) {
            data["zielBundeslaender"] = [];
            for (let item of this.zielBundeslaender)
                data["zielBundeslaender"].push(item.toJSON());
        }
        data["ueberschreiben"] = this.ueberschreiben;
        if (Array.isArray(this.quellList)) {
            data["quellList"] = [];
            for (let item of this.quellList)
                data["quellList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPushGliederungModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    ueberschreiben?: boolean;
    quellList?: Gliederung[] | undefined;
}

export class PushGruppierungModel implements IPushGruppierungModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    ueberschreiben?: boolean;
    quellList?: Gruppierung[] | undefined;

    constructor(data?: IPushGruppierungModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.modul = _data["modul"];
            this.verwaltungsansicht = _data["verwaltungsansicht"];
            if (Array.isArray(_data["zielGemeinden"])) {
                this.zielGemeinden = [] as any;
                for (let item of _data["zielGemeinden"])
                    this.zielGemeinden!.push(GemeindeModel.fromJS(item));
            }
            if (Array.isArray(_data["zielBundeslaender"])) {
                this.zielBundeslaender = [] as any;
                for (let item of _data["zielBundeslaender"])
                    this.zielBundeslaender!.push(Bundeslaender.fromJS(item));
            }
            this.ueberschreiben = _data["ueberschreiben"];
            if (Array.isArray(_data["quellList"])) {
                this.quellList = [] as any;
                for (let item of _data["quellList"])
                    this.quellList!.push(Gruppierung.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PushGruppierungModel {
        data = typeof data === 'object' ? data : {};
        let result = new PushGruppierungModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["modul"] = this.modul;
        data["verwaltungsansicht"] = this.verwaltungsansicht;
        if (Array.isArray(this.zielGemeinden)) {
            data["zielGemeinden"] = [];
            for (let item of this.zielGemeinden)
                data["zielGemeinden"].push(item.toJSON());
        }
        if (Array.isArray(this.zielBundeslaender)) {
            data["zielBundeslaender"] = [];
            for (let item of this.zielBundeslaender)
                data["zielBundeslaender"].push(item.toJSON());
        }
        data["ueberschreiben"] = this.ueberschreiben;
        if (Array.isArray(this.quellList)) {
            data["quellList"] = [];
            for (let item of this.quellList)
                data["quellList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPushGruppierungModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    ueberschreiben?: boolean;
    quellList?: Gruppierung[] | undefined;
}

export class PushHHSettingsModel implements IPushHHSettingsModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    quell?: HaushaltsSetting;

    constructor(data?: IPushHHSettingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.modul = _data["modul"];
            this.verwaltungsansicht = _data["verwaltungsansicht"];
            if (Array.isArray(_data["zielGemeinden"])) {
                this.zielGemeinden = [] as any;
                for (let item of _data["zielGemeinden"])
                    this.zielGemeinden!.push(GemeindeModel.fromJS(item));
            }
            if (Array.isArray(_data["zielBundeslaender"])) {
                this.zielBundeslaender = [] as any;
                for (let item of _data["zielBundeslaender"])
                    this.zielBundeslaender!.push(Bundeslaender.fromJS(item));
            }
            this.quell = _data["quell"] ? HaushaltsSetting.fromJS(_data["quell"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PushHHSettingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new PushHHSettingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["modul"] = this.modul;
        data["verwaltungsansicht"] = this.verwaltungsansicht;
        if (Array.isArray(this.zielGemeinden)) {
            data["zielGemeinden"] = [];
            for (let item of this.zielGemeinden)
                data["zielGemeinden"].push(item.toJSON());
        }
        if (Array.isArray(this.zielBundeslaender)) {
            data["zielBundeslaender"] = [];
            for (let item of this.zielBundeslaender)
                data["zielBundeslaender"].push(item.toJSON());
        }
        data["quell"] = this.quell ? this.quell.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPushHHSettingsModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    quell?: HaushaltsSetting;
}

export class PushInvestSettingsModel implements IPushInvestSettingsModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    quell?: InvestSetting;

    constructor(data?: IPushInvestSettingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.modul = _data["modul"];
            this.verwaltungsansicht = _data["verwaltungsansicht"];
            if (Array.isArray(_data["zielGemeinden"])) {
                this.zielGemeinden = [] as any;
                for (let item of _data["zielGemeinden"])
                    this.zielGemeinden!.push(GemeindeModel.fromJS(item));
            }
            if (Array.isArray(_data["zielBundeslaender"])) {
                this.zielBundeslaender = [] as any;
                for (let item of _data["zielBundeslaender"])
                    this.zielBundeslaender!.push(Bundeslaender.fromJS(item));
            }
            this.quell = _data["quell"] ? InvestSetting.fromJS(_data["quell"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PushInvestSettingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new PushInvestSettingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["modul"] = this.modul;
        data["verwaltungsansicht"] = this.verwaltungsansicht;
        if (Array.isArray(this.zielGemeinden)) {
            data["zielGemeinden"] = [];
            for (let item of this.zielGemeinden)
                data["zielGemeinden"].push(item.toJSON());
        }
        if (Array.isArray(this.zielBundeslaender)) {
            data["zielBundeslaender"] = [];
            for (let item of this.zielBundeslaender)
                data["zielBundeslaender"].push(item.toJSON());
        }
        data["quell"] = this.quell ? this.quell.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPushInvestSettingsModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    quell?: InvestSetting;
}

export class PushJRSettingsModel implements IPushJRSettingsModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    quell?: JRSettingModel;

    constructor(data?: IPushJRSettingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.modul = _data["modul"];
            this.verwaltungsansicht = _data["verwaltungsansicht"];
            if (Array.isArray(_data["zielGemeinden"])) {
                this.zielGemeinden = [] as any;
                for (let item of _data["zielGemeinden"])
                    this.zielGemeinden!.push(GemeindeModel.fromJS(item));
            }
            if (Array.isArray(_data["zielBundeslaender"])) {
                this.zielBundeslaender = [] as any;
                for (let item of _data["zielBundeslaender"])
                    this.zielBundeslaender!.push(Bundeslaender.fromJS(item));
            }
            this.quell = _data["quell"] ? JRSettingModel.fromJS(_data["quell"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PushJRSettingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new PushJRSettingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["modul"] = this.modul;
        data["verwaltungsansicht"] = this.verwaltungsansicht;
        if (Array.isArray(this.zielGemeinden)) {
            data["zielGemeinden"] = [];
            for (let item of this.zielGemeinden)
                data["zielGemeinden"].push(item.toJSON());
        }
        if (Array.isArray(this.zielBundeslaender)) {
            data["zielBundeslaender"] = [];
            for (let item of this.zielBundeslaender)
                data["zielBundeslaender"].push(item.toJSON());
        }
        data["quell"] = this.quell ? this.quell.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPushJRSettingsModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    quell?: JRSettingModel;
}

export class PushKennzahlenModel implements IPushKennzahlenModel {
    ueberschreiben?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    quellKEs?: Kennzahlen[] | undefined;

    constructor(data?: IPushKennzahlenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ueberschreiben = _data["ueberschreiben"];
            if (Array.isArray(_data["zielGemeinden"])) {
                this.zielGemeinden = [] as any;
                for (let item of _data["zielGemeinden"])
                    this.zielGemeinden!.push(GemeindeModel.fromJS(item));
            }
            if (Array.isArray(_data["quellKEs"])) {
                this.quellKEs = [] as any;
                for (let item of _data["quellKEs"])
                    this.quellKEs!.push(Kennzahlen.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PushKennzahlenModel {
        data = typeof data === 'object' ? data : {};
        let result = new PushKennzahlenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ueberschreiben"] = this.ueberschreiben;
        if (Array.isArray(this.zielGemeinden)) {
            data["zielGemeinden"] = [];
            for (let item of this.zielGemeinden)
                data["zielGemeinden"].push(item.toJSON());
        }
        if (Array.isArray(this.quellKEs)) {
            data["quellKEs"] = [];
            for (let item of this.quellKEs)
                data["quellKEs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPushKennzahlenModel {
    ueberschreiben?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    quellKEs?: Kennzahlen[] | undefined;
}

export class PushKoPrGrGlModel implements IPushKoPrGrGlModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    ueberschreiben?: boolean;

    constructor(data?: IPushKoPrGrGlModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.modul = _data["modul"];
            this.verwaltungsansicht = _data["verwaltungsansicht"];
            if (Array.isArray(_data["zielGemeinden"])) {
                this.zielGemeinden = [] as any;
                for (let item of _data["zielGemeinden"])
                    this.zielGemeinden!.push(GemeindeModel.fromJS(item));
            }
            if (Array.isArray(_data["zielBundeslaender"])) {
                this.zielBundeslaender = [] as any;
                for (let item of _data["zielBundeslaender"])
                    this.zielBundeslaender!.push(Bundeslaender.fromJS(item));
            }
            this.ueberschreiben = _data["ueberschreiben"];
        }
    }

    static fromJS(data: any): PushKoPrGrGlModel {
        data = typeof data === 'object' ? data : {};
        let result = new PushKoPrGrGlModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["modul"] = this.modul;
        data["verwaltungsansicht"] = this.verwaltungsansicht;
        if (Array.isArray(this.zielGemeinden)) {
            data["zielGemeinden"] = [];
            for (let item of this.zielGemeinden)
                data["zielGemeinden"].push(item.toJSON());
        }
        if (Array.isArray(this.zielBundeslaender)) {
            data["zielBundeslaender"] = [];
            for (let item of this.zielBundeslaender)
                data["zielBundeslaender"].push(item.toJSON());
        }
        data["ueberschreiben"] = this.ueberschreiben;
        return data;
    }
}

export interface IPushKoPrGrGlModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    ueberschreiben?: boolean;
}

export class PushKontenModel implements IPushKontenModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    ueberschreiben?: boolean;
    quellList?: Kontenplan[] | undefined;

    constructor(data?: IPushKontenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.modul = _data["modul"];
            this.verwaltungsansicht = _data["verwaltungsansicht"];
            if (Array.isArray(_data["zielGemeinden"])) {
                this.zielGemeinden = [] as any;
                for (let item of _data["zielGemeinden"])
                    this.zielGemeinden!.push(GemeindeModel.fromJS(item));
            }
            if (Array.isArray(_data["zielBundeslaender"])) {
                this.zielBundeslaender = [] as any;
                for (let item of _data["zielBundeslaender"])
                    this.zielBundeslaender!.push(Bundeslaender.fromJS(item));
            }
            this.ueberschreiben = _data["ueberschreiben"];
            if (Array.isArray(_data["quellList"])) {
                this.quellList = [] as any;
                for (let item of _data["quellList"])
                    this.quellList!.push(Kontenplan.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PushKontenModel {
        data = typeof data === 'object' ? data : {};
        let result = new PushKontenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["modul"] = this.modul;
        data["verwaltungsansicht"] = this.verwaltungsansicht;
        if (Array.isArray(this.zielGemeinden)) {
            data["zielGemeinden"] = [];
            for (let item of this.zielGemeinden)
                data["zielGemeinden"].push(item.toJSON());
        }
        if (Array.isArray(this.zielBundeslaender)) {
            data["zielBundeslaender"] = [];
            for (let item of this.zielBundeslaender)
                data["zielBundeslaender"].push(item.toJSON());
        }
        data["ueberschreiben"] = this.ueberschreiben;
        if (Array.isArray(this.quellList)) {
            data["quellList"] = [];
            for (let item of this.quellList)
                data["quellList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPushKontenModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    ueberschreiben?: boolean;
    quellList?: Kontenplan[] | undefined;
}

export class PushKontenSettingsModel implements IPushKontenSettingsModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    quell?: Bundeslaender;

    constructor(data?: IPushKontenSettingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.modul = _data["modul"];
            this.verwaltungsansicht = _data["verwaltungsansicht"];
            if (Array.isArray(_data["zielGemeinden"])) {
                this.zielGemeinden = [] as any;
                for (let item of _data["zielGemeinden"])
                    this.zielGemeinden!.push(GemeindeModel.fromJS(item));
            }
            if (Array.isArray(_data["zielBundeslaender"])) {
                this.zielBundeslaender = [] as any;
                for (let item of _data["zielBundeslaender"])
                    this.zielBundeslaender!.push(Bundeslaender.fromJS(item));
            }
            this.quell = _data["quell"] ? Bundeslaender.fromJS(_data["quell"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PushKontenSettingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new PushKontenSettingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["modul"] = this.modul;
        data["verwaltungsansicht"] = this.verwaltungsansicht;
        if (Array.isArray(this.zielGemeinden)) {
            data["zielGemeinden"] = [];
            for (let item of this.zielGemeinden)
                data["zielGemeinden"].push(item.toJSON());
        }
        if (Array.isArray(this.zielBundeslaender)) {
            data["zielBundeslaender"] = [];
            for (let item of this.zielBundeslaender)
                data["zielBundeslaender"].push(item.toJSON());
        }
        data["quell"] = this.quell ? this.quell.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPushKontenSettingsModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    quell?: Bundeslaender;
}

export class PushProdukteModel implements IPushProdukteModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    ueberschreiben?: boolean;
    quellList?: Produkte[] | undefined;

    constructor(data?: IPushProdukteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.modul = _data["modul"];
            this.verwaltungsansicht = _data["verwaltungsansicht"];
            if (Array.isArray(_data["zielGemeinden"])) {
                this.zielGemeinden = [] as any;
                for (let item of _data["zielGemeinden"])
                    this.zielGemeinden!.push(GemeindeModel.fromJS(item));
            }
            if (Array.isArray(_data["zielBundeslaender"])) {
                this.zielBundeslaender = [] as any;
                for (let item of _data["zielBundeslaender"])
                    this.zielBundeslaender!.push(Bundeslaender.fromJS(item));
            }
            this.ueberschreiben = _data["ueberschreiben"];
            if (Array.isArray(_data["quellList"])) {
                this.quellList = [] as any;
                for (let item of _data["quellList"])
                    this.quellList!.push(Produkte.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PushProdukteModel {
        data = typeof data === 'object' ? data : {};
        let result = new PushProdukteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["modul"] = this.modul;
        data["verwaltungsansicht"] = this.verwaltungsansicht;
        if (Array.isArray(this.zielGemeinden)) {
            data["zielGemeinden"] = [];
            for (let item of this.zielGemeinden)
                data["zielGemeinden"].push(item.toJSON());
        }
        if (Array.isArray(this.zielBundeslaender)) {
            data["zielBundeslaender"] = [];
            for (let item of this.zielBundeslaender)
                data["zielBundeslaender"].push(item.toJSON());
        }
        data["ueberschreiben"] = this.ueberschreiben;
        if (Array.isArray(this.quellList)) {
            data["quellList"] = [];
            for (let item of this.quellList)
                data["quellList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPushProdukteModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    ueberschreiben?: boolean;
    quellList?: Produkte[] | undefined;
}

export class PushPrognoseModelModel implements IPushPrognoseModelModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    ueberschreiben?: boolean;
    quellList?: UhConfigModel[] | undefined;

    constructor(data?: IPushPrognoseModelModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.modul = _data["modul"];
            this.verwaltungsansicht = _data["verwaltungsansicht"];
            if (Array.isArray(_data["zielGemeinden"])) {
                this.zielGemeinden = [] as any;
                for (let item of _data["zielGemeinden"])
                    this.zielGemeinden!.push(GemeindeModel.fromJS(item));
            }
            if (Array.isArray(_data["zielBundeslaender"])) {
                this.zielBundeslaender = [] as any;
                for (let item of _data["zielBundeslaender"])
                    this.zielBundeslaender!.push(Bundeslaender.fromJS(item));
            }
            this.ueberschreiben = _data["ueberschreiben"];
            if (Array.isArray(_data["quellList"])) {
                this.quellList = [] as any;
                for (let item of _data["quellList"])
                    this.quellList!.push(UhConfigModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PushPrognoseModelModel {
        data = typeof data === 'object' ? data : {};
        let result = new PushPrognoseModelModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["modul"] = this.modul;
        data["verwaltungsansicht"] = this.verwaltungsansicht;
        if (Array.isArray(this.zielGemeinden)) {
            data["zielGemeinden"] = [];
            for (let item of this.zielGemeinden)
                data["zielGemeinden"].push(item.toJSON());
        }
        if (Array.isArray(this.zielBundeslaender)) {
            data["zielBundeslaender"] = [];
            for (let item of this.zielBundeslaender)
                data["zielBundeslaender"].push(item.toJSON());
        }
        data["ueberschreiben"] = this.ueberschreiben;
        if (Array.isArray(this.quellList)) {
            data["quellList"] = [];
            for (let item of this.quellList)
                data["quellList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPushPrognoseModelModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    ueberschreiben?: boolean;
    quellList?: UhConfigModel[] | undefined;
}

export class PushPrognosekurvenModel implements IPushPrognosekurvenModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    ueberschreiben?: boolean;
    quellList?: Prognosekurven[] | undefined;

    constructor(data?: IPushPrognosekurvenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.modul = _data["modul"];
            this.verwaltungsansicht = _data["verwaltungsansicht"];
            if (Array.isArray(_data["zielGemeinden"])) {
                this.zielGemeinden = [] as any;
                for (let item of _data["zielGemeinden"])
                    this.zielGemeinden!.push(GemeindeModel.fromJS(item));
            }
            if (Array.isArray(_data["zielBundeslaender"])) {
                this.zielBundeslaender = [] as any;
                for (let item of _data["zielBundeslaender"])
                    this.zielBundeslaender!.push(Bundeslaender.fromJS(item));
            }
            this.ueberschreiben = _data["ueberschreiben"];
            if (Array.isArray(_data["quellList"])) {
                this.quellList = [] as any;
                for (let item of _data["quellList"])
                    this.quellList!.push(Prognosekurven.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PushPrognosekurvenModel {
        data = typeof data === 'object' ? data : {};
        let result = new PushPrognosekurvenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["modul"] = this.modul;
        data["verwaltungsansicht"] = this.verwaltungsansicht;
        if (Array.isArray(this.zielGemeinden)) {
            data["zielGemeinden"] = [];
            for (let item of this.zielGemeinden)
                data["zielGemeinden"].push(item.toJSON());
        }
        if (Array.isArray(this.zielBundeslaender)) {
            data["zielBundeslaender"] = [];
            for (let item of this.zielBundeslaender)
                data["zielBundeslaender"].push(item.toJSON());
        }
        data["ueberschreiben"] = this.ueberschreiben;
        if (Array.isArray(this.quellList)) {
            data["quellList"] = [];
            for (let item of this.quellList)
                data["quellList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPushPrognosekurvenModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    ueberschreiben?: boolean;
    quellList?: Prognosekurven[] | undefined;
}

export class PushPrognosekurvenZuweisungenModel implements IPushPrognosekurvenZuweisungenModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    ueberschreiben?: boolean;
    uhConfig?: number;

    constructor(data?: IPushPrognosekurvenZuweisungenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.modul = _data["modul"];
            this.verwaltungsansicht = _data["verwaltungsansicht"];
            if (Array.isArray(_data["zielGemeinden"])) {
                this.zielGemeinden = [] as any;
                for (let item of _data["zielGemeinden"])
                    this.zielGemeinden!.push(GemeindeModel.fromJS(item));
            }
            if (Array.isArray(_data["zielBundeslaender"])) {
                this.zielBundeslaender = [] as any;
                for (let item of _data["zielBundeslaender"])
                    this.zielBundeslaender!.push(Bundeslaender.fromJS(item));
            }
            this.ueberschreiben = _data["ueberschreiben"];
            this.uhConfig = _data["uhConfig"];
        }
    }

    static fromJS(data: any): PushPrognosekurvenZuweisungenModel {
        data = typeof data === 'object' ? data : {};
        let result = new PushPrognosekurvenZuweisungenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["modul"] = this.modul;
        data["verwaltungsansicht"] = this.verwaltungsansicht;
        if (Array.isArray(this.zielGemeinden)) {
            data["zielGemeinden"] = [];
            for (let item of this.zielGemeinden)
                data["zielGemeinden"].push(item.toJSON());
        }
        if (Array.isArray(this.zielBundeslaender)) {
            data["zielBundeslaender"] = [];
            for (let item of this.zielBundeslaender)
                data["zielBundeslaender"].push(item.toJSON());
        }
        data["ueberschreiben"] = this.ueberschreiben;
        data["uhConfig"] = this.uhConfig;
        return data;
    }
}

export interface IPushPrognosekurvenZuweisungenModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    ueberschreiben?: boolean;
    uhConfig?: number;
}

export class PushTemplateZeileninfoModel implements IPushTemplateZeileninfoModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    ueberschreiben?: boolean;
    quellList?: TemplateZeileninfoModel[] | undefined;

    constructor(data?: IPushTemplateZeileninfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.modul = _data["modul"];
            this.verwaltungsansicht = _data["verwaltungsansicht"];
            if (Array.isArray(_data["zielGemeinden"])) {
                this.zielGemeinden = [] as any;
                for (let item of _data["zielGemeinden"])
                    this.zielGemeinden!.push(GemeindeModel.fromJS(item));
            }
            if (Array.isArray(_data["zielBundeslaender"])) {
                this.zielBundeslaender = [] as any;
                for (let item of _data["zielBundeslaender"])
                    this.zielBundeslaender!.push(Bundeslaender.fromJS(item));
            }
            this.ueberschreiben = _data["ueberschreiben"];
            if (Array.isArray(_data["quellList"])) {
                this.quellList = [] as any;
                for (let item of _data["quellList"])
                    this.quellList!.push(TemplateZeileninfoModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PushTemplateZeileninfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new PushTemplateZeileninfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["modul"] = this.modul;
        data["verwaltungsansicht"] = this.verwaltungsansicht;
        if (Array.isArray(this.zielGemeinden)) {
            data["zielGemeinden"] = [];
            for (let item of this.zielGemeinden)
                data["zielGemeinden"].push(item.toJSON());
        }
        if (Array.isArray(this.zielBundeslaender)) {
            data["zielBundeslaender"] = [];
            for (let item of this.zielBundeslaender)
                data["zielBundeslaender"].push(item.toJSON());
        }
        data["ueberschreiben"] = this.ueberschreiben;
        if (Array.isArray(this.quellList)) {
            data["quellList"] = [];
            for (let item of this.quellList)
                data["quellList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPushTemplateZeileninfoModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    ueberschreiben?: boolean;
    quellList?: TemplateZeileninfoModel[] | undefined;
}

export class PushTexteModel implements IPushTexteModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    typen?: number[] | undefined;

    constructor(data?: IPushTexteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.modul = _data["modul"];
            this.verwaltungsansicht = _data["verwaltungsansicht"];
            if (Array.isArray(_data["zielGemeinden"])) {
                this.zielGemeinden = [] as any;
                for (let item of _data["zielGemeinden"])
                    this.zielGemeinden!.push(GemeindeModel.fromJS(item));
            }
            if (Array.isArray(_data["zielBundeslaender"])) {
                this.zielBundeslaender = [] as any;
                for (let item of _data["zielBundeslaender"])
                    this.zielBundeslaender!.push(Bundeslaender.fromJS(item));
            }
            if (Array.isArray(_data["typen"])) {
                this.typen = [] as any;
                for (let item of _data["typen"])
                    this.typen!.push(item);
            }
        }
    }

    static fromJS(data: any): PushTexteModel {
        data = typeof data === 'object' ? data : {};
        let result = new PushTexteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["modul"] = this.modul;
        data["verwaltungsansicht"] = this.verwaltungsansicht;
        if (Array.isArray(this.zielGemeinden)) {
            data["zielGemeinden"] = [];
            for (let item of this.zielGemeinden)
                data["zielGemeinden"].push(item.toJSON());
        }
        if (Array.isArray(this.zielBundeslaender)) {
            data["zielBundeslaender"] = [];
            for (let item of this.zielBundeslaender)
                data["zielBundeslaender"].push(item.toJSON());
        }
        if (Array.isArray(this.typen)) {
            data["typen"] = [];
            for (let item of this.typen)
                data["typen"].push(item);
        }
        return data;
    }
}

export interface IPushTexteModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    typen?: number[] | undefined;
}

export class PushTopEAModel implements IPushTopEAModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    ueberschreiben?: boolean;
    quellList?: TopEaflex[] | undefined;

    constructor(data?: IPushTopEAModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.modul = _data["modul"];
            this.verwaltungsansicht = _data["verwaltungsansicht"];
            if (Array.isArray(_data["zielGemeinden"])) {
                this.zielGemeinden = [] as any;
                for (let item of _data["zielGemeinden"])
                    this.zielGemeinden!.push(GemeindeModel.fromJS(item));
            }
            if (Array.isArray(_data["zielBundeslaender"])) {
                this.zielBundeslaender = [] as any;
                for (let item of _data["zielBundeslaender"])
                    this.zielBundeslaender!.push(Bundeslaender.fromJS(item));
            }
            this.ueberschreiben = _data["ueberschreiben"];
            if (Array.isArray(_data["quellList"])) {
                this.quellList = [] as any;
                for (let item of _data["quellList"])
                    this.quellList!.push(TopEaflex.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PushTopEAModel {
        data = typeof data === 'object' ? data : {};
        let result = new PushTopEAModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["modul"] = this.modul;
        data["verwaltungsansicht"] = this.verwaltungsansicht;
        if (Array.isArray(this.zielGemeinden)) {
            data["zielGemeinden"] = [];
            for (let item of this.zielGemeinden)
                data["zielGemeinden"].push(item.toJSON());
        }
        if (Array.isArray(this.zielBundeslaender)) {
            data["zielBundeslaender"] = [];
            for (let item of this.zielBundeslaender)
                data["zielBundeslaender"].push(item.toJSON());
        }
        data["ueberschreiben"] = this.ueberschreiben;
        if (Array.isArray(this.quellList)) {
            data["quellList"] = [];
            for (let item of this.quellList)
                data["quellList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPushTopEAModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    ueberschreiben?: boolean;
    quellList?: TopEaflex[] | undefined;
}

export class PushVBPlatzhalterDoppischModel implements IPushVBPlatzhalterDoppischModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    ueberschreiben?: boolean;
    alleLoeschen?: boolean;
    quellList?: VBPlatzhalterDoppischModel[] | undefined;

    constructor(data?: IPushVBPlatzhalterDoppischModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.modul = _data["modul"];
            this.verwaltungsansicht = _data["verwaltungsansicht"];
            if (Array.isArray(_data["zielGemeinden"])) {
                this.zielGemeinden = [] as any;
                for (let item of _data["zielGemeinden"])
                    this.zielGemeinden!.push(GemeindeModel.fromJS(item));
            }
            if (Array.isArray(_data["zielBundeslaender"])) {
                this.zielBundeslaender = [] as any;
                for (let item of _data["zielBundeslaender"])
                    this.zielBundeslaender!.push(Bundeslaender.fromJS(item));
            }
            this.ueberschreiben = _data["ueberschreiben"];
            this.alleLoeschen = _data["alleLoeschen"];
            if (Array.isArray(_data["quellList"])) {
                this.quellList = [] as any;
                for (let item of _data["quellList"])
                    this.quellList!.push(VBPlatzhalterDoppischModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PushVBPlatzhalterDoppischModel {
        data = typeof data === 'object' ? data : {};
        let result = new PushVBPlatzhalterDoppischModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["modul"] = this.modul;
        data["verwaltungsansicht"] = this.verwaltungsansicht;
        if (Array.isArray(this.zielGemeinden)) {
            data["zielGemeinden"] = [];
            for (let item of this.zielGemeinden)
                data["zielGemeinden"].push(item.toJSON());
        }
        if (Array.isArray(this.zielBundeslaender)) {
            data["zielBundeslaender"] = [];
            for (let item of this.zielBundeslaender)
                data["zielBundeslaender"].push(item.toJSON());
        }
        data["ueberschreiben"] = this.ueberschreiben;
        data["alleLoeschen"] = this.alleLoeschen;
        if (Array.isArray(this.quellList)) {
            data["quellList"] = [];
            for (let item of this.quellList)
                data["quellList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPushVBPlatzhalterDoppischModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    ueberschreiben?: boolean;
    alleLoeschen?: boolean;
    quellList?: VBPlatzhalterDoppischModel[] | undefined;
}

export class PushVBPlatzhalterKameralModel implements IPushVBPlatzhalterKameralModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    ueberschreiben?: boolean;
    alleLoeschen?: boolean;
    quellList?: VBPlatzhalterKameralModel[] | undefined;

    constructor(data?: IPushVBPlatzhalterKameralModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.modul = _data["modul"];
            this.verwaltungsansicht = _data["verwaltungsansicht"];
            if (Array.isArray(_data["zielGemeinden"])) {
                this.zielGemeinden = [] as any;
                for (let item of _data["zielGemeinden"])
                    this.zielGemeinden!.push(GemeindeModel.fromJS(item));
            }
            if (Array.isArray(_data["zielBundeslaender"])) {
                this.zielBundeslaender = [] as any;
                for (let item of _data["zielBundeslaender"])
                    this.zielBundeslaender!.push(Bundeslaender.fromJS(item));
            }
            this.ueberschreiben = _data["ueberschreiben"];
            this.alleLoeschen = _data["alleLoeschen"];
            if (Array.isArray(_data["quellList"])) {
                this.quellList = [] as any;
                for (let item of _data["quellList"])
                    this.quellList!.push(VBPlatzhalterKameralModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PushVBPlatzhalterKameralModel {
        data = typeof data === 'object' ? data : {};
        let result = new PushVBPlatzhalterKameralModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["modul"] = this.modul;
        data["verwaltungsansicht"] = this.verwaltungsansicht;
        if (Array.isArray(this.zielGemeinden)) {
            data["zielGemeinden"] = [];
            for (let item of this.zielGemeinden)
                data["zielGemeinden"].push(item.toJSON());
        }
        if (Array.isArray(this.zielBundeslaender)) {
            data["zielBundeslaender"] = [];
            for (let item of this.zielBundeslaender)
                data["zielBundeslaender"].push(item.toJSON());
        }
        data["ueberschreiben"] = this.ueberschreiben;
        data["alleLoeschen"] = this.alleLoeschen;
        if (Array.isArray(this.quellList)) {
            data["quellList"] = [];
            for (let item of this.quellList)
                data["quellList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPushVBPlatzhalterKameralModel {
    kunde?: number | undefined;
    gemeinde?: number;
    jahr?: number;
    modul?: number | undefined;
    verwaltungsansicht?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    zielBundeslaender?: Bundeslaender[] | undefined;
    ueberschreiben?: boolean;
    alleLoeschen?: boolean;
    quellList?: VBPlatzhalterKameralModel[] | undefined;
}

export class PushVBTabsModel implements IPushVBTabsModel {
    ueberschreiben?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    quellDS?: Datensaetze[] | undefined;
    quellVBTabs?: Vbtab[] | undefined;

    constructor(data?: IPushVBTabsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ueberschreiben = _data["ueberschreiben"];
            if (Array.isArray(_data["zielGemeinden"])) {
                this.zielGemeinden = [] as any;
                for (let item of _data["zielGemeinden"])
                    this.zielGemeinden!.push(GemeindeModel.fromJS(item));
            }
            if (Array.isArray(_data["quellDS"])) {
                this.quellDS = [] as any;
                for (let item of _data["quellDS"])
                    this.quellDS!.push(Datensaetze.fromJS(item));
            }
            if (Array.isArray(_data["quellVBTabs"])) {
                this.quellVBTabs = [] as any;
                for (let item of _data["quellVBTabs"])
                    this.quellVBTabs!.push(Vbtab.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PushVBTabsModel {
        data = typeof data === 'object' ? data : {};
        let result = new PushVBTabsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ueberschreiben"] = this.ueberschreiben;
        if (Array.isArray(this.zielGemeinden)) {
            data["zielGemeinden"] = [];
            for (let item of this.zielGemeinden)
                data["zielGemeinden"].push(item.toJSON());
        }
        if (Array.isArray(this.quellDS)) {
            data["quellDS"] = [];
            for (let item of this.quellDS)
                data["quellDS"].push(item.toJSON());
        }
        if (Array.isArray(this.quellVBTabs)) {
            data["quellVBTabs"] = [];
            for (let item of this.quellVBTabs)
                data["quellVBTabs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPushVBTabsModel {
    ueberschreiben?: boolean;
    zielGemeinden?: GemeindeModel[] | undefined;
    quellDS?: Datensaetze[] | undefined;
    quellVBTabs?: Vbtab[] | undefined;
}

export class RagAnswer implements IRagAnswer {
    threadID?: string | undefined;
    historieID?: number;
    titel?: string | undefined;
    answer?: string | undefined;
    confidence?: number;
    sources?: RagSource[] | undefined;

    constructor(data?: IRagAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.threadID = _data["threadID"];
            this.historieID = _data["historieID"];
            this.titel = _data["titel"];
            this.answer = _data["answer"];
            this.confidence = _data["confidence"];
            if (Array.isArray(_data["sources"])) {
                this.sources = [] as any;
                for (let item of _data["sources"])
                    this.sources!.push(RagSource.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RagAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new RagAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["threadID"] = this.threadID;
        data["historieID"] = this.historieID;
        data["titel"] = this.titel;
        data["answer"] = this.answer;
        data["confidence"] = this.confidence;
        if (Array.isArray(this.sources)) {
            data["sources"] = [];
            for (let item of this.sources)
                data["sources"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRagAnswer {
    threadID?: string | undefined;
    historieID?: number;
    titel?: string | undefined;
    answer?: string | undefined;
    confidence?: number;
    sources?: RagSource[] | undefined;
}

export class RagSource implements IRagSource {
    number?: number;
    title?: string | undefined;
    source?: string | undefined;

    constructor(data?: IRagSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.title = _data["title"];
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): RagSource {
        data = typeof data === 'object' ? data : {};
        let result = new RagSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["title"] = this.title;
        data["source"] = this.source;
        return data;
    }
}

export interface IRagSource {
    number?: number;
    title?: string | undefined;
    source?: string | undefined;
}

export class Rechte implements IRechte {
    id?: string | undefined;
    bezeichnung?: string | undefined;
    order?: number | undefined;

    constructor(data?: IRechte) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): Rechte {
        data = typeof data === 'object' ? data : {};
        let result = new Rechte();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        data["order"] = this.order;
        return data;
    }
}

export interface IRechte {
    id?: string | undefined;
    bezeichnung?: string | undefined;
    order?: number | undefined;
}

export class Rechte2Role implements IRechte2Role {
    id?: number;
    kunde?: number;
    role?: string | undefined;
    rechteId?: string | undefined;
    erlaubt?: boolean;

    constructor(data?: IRechte2Role) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.role = _data["role"];
            this.rechteId = _data["rechteId"];
            this.erlaubt = _data["erlaubt"];
        }
    }

    static fromJS(data: any): Rechte2Role {
        data = typeof data === 'object' ? data : {};
        let result = new Rechte2Role();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["role"] = this.role;
        data["rechteId"] = this.rechteId;
        data["erlaubt"] = this.erlaubt;
        return data;
    }
}

export interface IRechte2Role {
    id?: number;
    kunde?: number;
    role?: string | undefined;
    rechteId?: string | undefined;
    erlaubt?: boolean;
}

export class RedisKey implements IRedisKey {

    constructor(data?: IRedisKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): RedisKey {
        data = typeof data === 'object' ? data : {};
        let result = new RedisKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IRedisKey {
}

export class RefreshTokenModel implements IRefreshTokenModel {
    token?: string | undefined;
    refreshToken?: string | undefined;

    constructor(data?: IRefreshTokenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): RefreshTokenModel {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IRefreshTokenModel {
    token?: string | undefined;
    refreshToken?: string | undefined;
}

export class RegisterModel implements IRegisterModel {
    username!: string;
    email!: string;
    password?: string | undefined;
    customer?: number;
    roles?: string[] | undefined;
    zuname?: string | undefined;
    vorname?: string | undefined;

    constructor(data?: IRegisterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.customer = _data["customer"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.zuname = _data["zuname"];
            this.vorname = _data["vorname"];
        }
    }

    static fromJS(data: any): RegisterModel {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["email"] = this.email;
        data["password"] = this.password;
        data["customer"] = this.customer;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["zuname"] = this.zuname;
        data["vorname"] = this.vorname;
        return data;
    }
}

export interface IRegisterModel {
    username: string;
    email: string;
    password?: string | undefined;
    customer?: number;
    roles?: string[] | undefined;
    zuname?: string | undefined;
    vorname?: string | undefined;
}

export class RegisteredUserModel implements IRegisteredUserModel {
    userId?: string | undefined;
    username?: string | undefined;
    email?: string | undefined;
    customer?: number | undefined;
    roles?: string[] | undefined;
    zuname?: string | undefined;
    vorname?: string | undefined;

    constructor(data?: IRegisteredUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.username = _data["username"];
            this.email = _data["email"];
            this.customer = _data["customer"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.zuname = _data["zuname"];
            this.vorname = _data["vorname"];
        }
    }

    static fromJS(data: any): RegisteredUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new RegisteredUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["username"] = this.username;
        data["email"] = this.email;
        data["customer"] = this.customer;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["zuname"] = this.zuname;
        data["vorname"] = this.vorname;
        return data;
    }
}

export interface IRegisteredUserModel {
    userId?: string | undefined;
    username?: string | undefined;
    email?: string | undefined;
    customer?: number | undefined;
    roles?: string[] | undefined;
    zuname?: string | undefined;
    vorname?: string | undefined;
}

export class Reihe implements IReihe {
    zeile?: string | undefined;
    bezeichnung?: string | undefined;
    farbePos?: string | undefined;
    farbeNeg?: string | undefined;
    rahmenFarbe?: string | undefined;

    constructor(data?: IReihe) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zeile = _data["zeile"];
            this.bezeichnung = _data["bezeichnung"];
            this.farbePos = _data["farbePos"];
            this.farbeNeg = _data["farbeNeg"];
            this.rahmenFarbe = _data["rahmenFarbe"];
        }
    }

    static fromJS(data: any): Reihe {
        data = typeof data === 'object' ? data : {};
        let result = new Reihe();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zeile"] = this.zeile;
        data["bezeichnung"] = this.bezeichnung;
        data["farbePos"] = this.farbePos;
        data["farbeNeg"] = this.farbeNeg;
        data["rahmenFarbe"] = this.rahmenFarbe;
        return data;
    }
}

export interface IReihe {
    zeile?: string | undefined;
    bezeichnung?: string | undefined;
    farbePos?: string | undefined;
    farbeNeg?: string | undefined;
    rahmenFarbe?: string | undefined;
}

export enum Repetition {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class Request implements IRequest {
    id?: number;
    ip?: string | undefined;
    zeit?: Date;
    type?: string | undefined;
    kunde?: number | undefined;
    gemeinde?: number | undefined;
    jahr?: number | undefined;
    plantyp?: number | undefined;
    planstufe?: number | undefined;
    notes?: string | undefined;

    constructor(data?: IRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ip = _data["ip"];
            this.zeit = _data["zeit"] ? new Date(_data["zeit"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.plantyp = _data["plantyp"];
            this.planstufe = _data["planstufe"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): Request {
        data = typeof data === 'object' ? data : {};
        let result = new Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ip"] = this.ip;
        data["zeit"] = this.zeit ? this.zeit.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["plantyp"] = this.plantyp;
        data["planstufe"] = this.planstufe;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IRequest {
    id?: number;
    ip?: string | undefined;
    zeit?: Date;
    type?: string | undefined;
    kunde?: number | undefined;
    gemeinde?: number | undefined;
    jahr?: number | undefined;
    plantyp?: number | undefined;
    planstufe?: number | undefined;
    notes?: string | undefined;
}

export class ResetPasswordModel implements IResetPasswordModel {
    username!: string;
    newPassword!: string;
    token!: string;

    constructor(data?: IResetPasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.newPassword = _data["newPassword"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): ResetPasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["newPassword"] = this.newPassword;
        data["token"] = this.token;
        return data;
    }
}

export interface IResetPasswordModel {
    username: string;
    newPassword: string;
    token: string;
}

export class RestoreAnfrageModel implements IRestoreAnfrageModel {
    umfang?: number;
    gemeinde?: number | undefined;
    jahr?: number | undefined;
    elemente?: string[] | undefined;
    standId?: number | undefined;
    bestaetigung?: string | undefined;
    eintraege?: string[] | undefined;

    constructor(data?: IRestoreAnfrageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.umfang = _data["umfang"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            if (Array.isArray(_data["elemente"])) {
                this.elemente = [] as any;
                for (let item of _data["elemente"])
                    this.elemente!.push(item);
            }
            this.standId = _data["standId"];
            this.bestaetigung = _data["bestaetigung"];
            if (Array.isArray(_data["eintraege"])) {
                this.eintraege = [] as any;
                for (let item of _data["eintraege"])
                    this.eintraege!.push(item);
            }
        }
    }

    static fromJS(data: any): RestoreAnfrageModel {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreAnfrageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["umfang"] = this.umfang;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        if (Array.isArray(this.elemente)) {
            data["elemente"] = [];
            for (let item of this.elemente)
                data["elemente"].push(item);
        }
        data["standId"] = this.standId;
        data["bestaetigung"] = this.bestaetigung;
        if (Array.isArray(this.eintraege)) {
            data["eintraege"] = [];
            for (let item of this.eintraege)
                data["eintraege"].push(item);
        }
        return data;
    }
}

export interface IRestoreAnfrageModel {
    umfang?: number;
    gemeinde?: number | undefined;
    jahr?: number | undefined;
    elemente?: string[] | undefined;
    standId?: number | undefined;
    bestaetigung?: string | undefined;
    eintraege?: string[] | undefined;
}

export class RestoreDateiModel implements IRestoreDateiModel {
    name?: string | undefined;
    art?: number;
    bytesAktuell?: number;
    bytesSicherung?: number;

    constructor(data?: IRestoreDateiModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.art = _data["art"];
            this.bytesAktuell = _data["bytesAktuell"];
            this.bytesSicherung = _data["bytesSicherung"];
        }
    }

    static fromJS(data: any): RestoreDateiModel {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreDateiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["art"] = this.art;
        data["bytesAktuell"] = this.bytesAktuell;
        data["bytesSicherung"] = this.bytesSicherung;
        return data;
    }
}

export interface IRestoreDateiModel {
    name?: string | undefined;
    art?: number;
    bytesAktuell?: number;
    bytesSicherung?: number;
}

export class RestoreDateiVergleichModel implements IRestoreDateiVergleichModel {
    gleich?: number;
    zurueck?: number;
    geaendert?: number;
    neu?: number;
    ohneFassung?: number;
    dateien?: RestoreDateiModel[] | undefined;
    weitere?: number;

    constructor(data?: IRestoreDateiVergleichModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gleich = _data["gleich"];
            this.zurueck = _data["zurueck"];
            this.geaendert = _data["geaendert"];
            this.neu = _data["neu"];
            this.ohneFassung = _data["ohneFassung"];
            if (Array.isArray(_data["dateien"])) {
                this.dateien = [] as any;
                for (let item of _data["dateien"])
                    this.dateien!.push(RestoreDateiModel.fromJS(item));
            }
            this.weitere = _data["weitere"];
        }
    }

    static fromJS(data: any): RestoreDateiVergleichModel {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreDateiVergleichModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gleich"] = this.gleich;
        data["zurueck"] = this.zurueck;
        data["geaendert"] = this.geaendert;
        data["neu"] = this.neu;
        data["ohneFassung"] = this.ohneFassung;
        if (Array.isArray(this.dateien)) {
            data["dateien"] = [];
            for (let item of this.dateien)
                data["dateien"].push(item.toJSON());
        }
        data["weitere"] = this.weitere;
        return data;
    }
}

export interface IRestoreDateiVergleichModel {
    gleich?: number;
    zurueck?: number;
    geaendert?: number;
    neu?: number;
    ohneFassung?: number;
    dateien?: RestoreDateiModel[] | undefined;
    weitere?: number;
}

export class RestoreEintragModel implements IRestoreEintragModel {
    schluessel?: string | undefined;
    tabelle?: string | undefined;
    tabelleAnzeige?: string | undefined;
    bezeichnung?: string | undefined;
    zusatz?: string | undefined;
    art?: number;
    felder?: RestoreFeldModel[] | undefined;

    constructor(data?: IRestoreEintragModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.schluessel = _data["schluessel"];
            this.tabelle = _data["tabelle"];
            this.tabelleAnzeige = _data["tabelleAnzeige"];
            this.bezeichnung = _data["bezeichnung"];
            this.zusatz = _data["zusatz"];
            this.art = _data["art"];
            if (Array.isArray(_data["felder"])) {
                this.felder = [] as any;
                for (let item of _data["felder"])
                    this.felder!.push(RestoreFeldModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RestoreEintragModel {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreEintragModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schluessel"] = this.schluessel;
        data["tabelle"] = this.tabelle;
        data["tabelleAnzeige"] = this.tabelleAnzeige;
        data["bezeichnung"] = this.bezeichnung;
        data["zusatz"] = this.zusatz;
        data["art"] = this.art;
        if (Array.isArray(this.felder)) {
            data["felder"] = [];
            for (let item of this.felder)
                data["felder"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRestoreEintragModel {
    schluessel?: string | undefined;
    tabelle?: string | undefined;
    tabelleAnzeige?: string | undefined;
    bezeichnung?: string | undefined;
    zusatz?: string | undefined;
    art?: number;
    felder?: RestoreFeldModel[] | undefined;
}

export class RestoreFeldModel implements IRestoreFeldModel {
    feld?: string | undefined;
    aktuell?: string | undefined;
    sicherung?: string | undefined;

    constructor(data?: IRestoreFeldModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.feld = _data["feld"];
            this.aktuell = _data["aktuell"];
            this.sicherung = _data["sicherung"];
        }
    }

    static fromJS(data: any): RestoreFeldModel {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreFeldModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feld"] = this.feld;
        data["aktuell"] = this.aktuell;
        data["sicherung"] = this.sicherung;
        return data;
    }
}

export interface IRestoreFeldModel {
    feld?: string | undefined;
    aktuell?: string | undefined;
    sicherung?: string | undefined;
}

export class RestoreTabellenVergleichModel implements IRestoreTabellenVergleichModel {
    tabelle?: string | undefined;
    anzeige?: string | undefined;
    zeilenAktuell?: number;
    zeilenSicherung?: number;
    bytesAktuell?: number;
    bytesSicherung?: number;
    gleich?: number;
    zurueck?: number;
    verloren?: number;
    geaendert?: number;
    ohneEinzelvergleich?: boolean;
    technisch?: boolean;
    eintraege?: RestoreEintragModel[] | undefined;
    weitereEintraege?: number;

    constructor(data?: IRestoreTabellenVergleichModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tabelle = _data["tabelle"];
            this.anzeige = _data["anzeige"];
            this.zeilenAktuell = _data["zeilenAktuell"];
            this.zeilenSicherung = _data["zeilenSicherung"];
            this.bytesAktuell = _data["bytesAktuell"];
            this.bytesSicherung = _data["bytesSicherung"];
            this.gleich = _data["gleich"];
            this.zurueck = _data["zurueck"];
            this.verloren = _data["verloren"];
            this.geaendert = _data["geaendert"];
            this.ohneEinzelvergleich = _data["ohneEinzelvergleich"];
            this.technisch = _data["technisch"];
            if (Array.isArray(_data["eintraege"])) {
                this.eintraege = [] as any;
                for (let item of _data["eintraege"])
                    this.eintraege!.push(RestoreEintragModel.fromJS(item));
            }
            this.weitereEintraege = _data["weitereEintraege"];
        }
    }

    static fromJS(data: any): RestoreTabellenVergleichModel {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreTabellenVergleichModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tabelle"] = this.tabelle;
        data["anzeige"] = this.anzeige;
        data["zeilenAktuell"] = this.zeilenAktuell;
        data["zeilenSicherung"] = this.zeilenSicherung;
        data["bytesAktuell"] = this.bytesAktuell;
        data["bytesSicherung"] = this.bytesSicherung;
        data["gleich"] = this.gleich;
        data["zurueck"] = this.zurueck;
        data["verloren"] = this.verloren;
        data["geaendert"] = this.geaendert;
        data["ohneEinzelvergleich"] = this.ohneEinzelvergleich;
        data["technisch"] = this.technisch;
        if (Array.isArray(this.eintraege)) {
            data["eintraege"] = [];
            for (let item of this.eintraege)
                data["eintraege"].push(item.toJSON());
        }
        data["weitereEintraege"] = this.weitereEintraege;
        return data;
    }
}

export interface IRestoreTabellenVergleichModel {
    tabelle?: string | undefined;
    anzeige?: string | undefined;
    zeilenAktuell?: number;
    zeilenSicherung?: number;
    bytesAktuell?: number;
    bytesSicherung?: number;
    gleich?: number;
    zurueck?: number;
    verloren?: number;
    geaendert?: number;
    ohneEinzelvergleich?: boolean;
    technisch?: boolean;
    eintraege?: RestoreEintragModel[] | undefined;
    weitereEintraege?: number;
}

export class RestoreVorschauElementModel implements IRestoreVorschauElementModel {
    key?: string | undefined;
    anzeige?: string | undefined;
    gemeinde?: number | undefined;
    jahr?: number | undefined;
    zeilenAktuell?: number;
    zeilenSicherung?: number;
    tabellen?: number;
    uebersprungen?: string[] | undefined;
    dateien?: boolean;
    bytesAktuell?: number;
    bytesSicherung?: number;
    gleich?: number;
    zurueck?: number;
    verloren?: number;
    geaendert?: number;
    nurEintraege?: boolean;
    vergleich?: RestoreTabellenVergleichModel[] | undefined;
    dateiVergleich?: RestoreDateiVergleichModel;

    constructor(data?: IRestoreVorschauElementModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.anzeige = _data["anzeige"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.zeilenAktuell = _data["zeilenAktuell"];
            this.zeilenSicherung = _data["zeilenSicherung"];
            this.tabellen = _data["tabellen"];
            if (Array.isArray(_data["uebersprungen"])) {
                this.uebersprungen = [] as any;
                for (let item of _data["uebersprungen"])
                    this.uebersprungen!.push(item);
            }
            this.dateien = _data["dateien"];
            this.bytesAktuell = _data["bytesAktuell"];
            this.bytesSicherung = _data["bytesSicherung"];
            this.gleich = _data["gleich"];
            this.zurueck = _data["zurueck"];
            this.verloren = _data["verloren"];
            this.geaendert = _data["geaendert"];
            this.nurEintraege = _data["nurEintraege"];
            if (Array.isArray(_data["vergleich"])) {
                this.vergleich = [] as any;
                for (let item of _data["vergleich"])
                    this.vergleich!.push(RestoreTabellenVergleichModel.fromJS(item));
            }
            this.dateiVergleich = _data["dateiVergleich"] ? RestoreDateiVergleichModel.fromJS(_data["dateiVergleich"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RestoreVorschauElementModel {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreVorschauElementModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["anzeige"] = this.anzeige;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["zeilenAktuell"] = this.zeilenAktuell;
        data["zeilenSicherung"] = this.zeilenSicherung;
        data["tabellen"] = this.tabellen;
        if (Array.isArray(this.uebersprungen)) {
            data["uebersprungen"] = [];
            for (let item of this.uebersprungen)
                data["uebersprungen"].push(item);
        }
        data["dateien"] = this.dateien;
        data["bytesAktuell"] = this.bytesAktuell;
        data["bytesSicherung"] = this.bytesSicherung;
        data["gleich"] = this.gleich;
        data["zurueck"] = this.zurueck;
        data["verloren"] = this.verloren;
        data["geaendert"] = this.geaendert;
        data["nurEintraege"] = this.nurEintraege;
        if (Array.isArray(this.vergleich)) {
            data["vergleich"] = [];
            for (let item of this.vergleich)
                data["vergleich"].push(item.toJSON());
        }
        data["dateiVergleich"] = this.dateiVergleich ? this.dateiVergleich.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRestoreVorschauElementModel {
    key?: string | undefined;
    anzeige?: string | undefined;
    gemeinde?: number | undefined;
    jahr?: number | undefined;
    zeilenAktuell?: number;
    zeilenSicherung?: number;
    tabellen?: number;
    uebersprungen?: string[] | undefined;
    dateien?: boolean;
    bytesAktuell?: number;
    bytesSicherung?: number;
    gleich?: number;
    zurueck?: number;
    verloren?: number;
    geaendert?: number;
    nurEintraege?: boolean;
    vergleich?: RestoreTabellenVergleichModel[] | undefined;
    dateiVergleich?: RestoreDateiVergleichModel;
}

export class RestoreVorschauModel implements IRestoreVorschauModel {
    ausfuehrbar?: boolean;
    blockiert?: string | undefined;
    stand?: Date | undefined;
    standId?: number | undefined;
    ausPaket?: boolean;
    schemaSicherung?: string | undefined;
    schemaAktuell?: string | undefined;
    zeilenAktuell?: number;
    zeilenSicherung?: number;
    bytesAktuell?: number;
    bytesSicherung?: number;
    gleich?: number;
    zurueck?: number;
    verloren?: number;
    geaendert?: number;
    vergleichMoeglich?: boolean;
    dateienRestore?: boolean;
    dateiVergleich?: RestoreDateiVergleichModel;
    dateienOhneVergleich?: string | undefined;
    undoAblage?: string | undefined;
    kontoInSicherung?: boolean;
    elemente?: RestoreVorschauElementModel[] | undefined;
    warnungen?: string[] | undefined;
    hinweise?: string[] | undefined;
    neueGemeinden?: string[] | undefined;
    neueJahre?: string[] | undefined;
    neueBenutzer?: string[] | undefined;

    constructor(data?: IRestoreVorschauModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ausfuehrbar = _data["ausfuehrbar"];
            this.blockiert = _data["blockiert"];
            this.stand = _data["stand"] ? new Date(_data["stand"].toString()) : <any>undefined;
            this.standId = _data["standId"];
            this.ausPaket = _data["ausPaket"];
            this.schemaSicherung = _data["schemaSicherung"];
            this.schemaAktuell = _data["schemaAktuell"];
            this.zeilenAktuell = _data["zeilenAktuell"];
            this.zeilenSicherung = _data["zeilenSicherung"];
            this.bytesAktuell = _data["bytesAktuell"];
            this.bytesSicherung = _data["bytesSicherung"];
            this.gleich = _data["gleich"];
            this.zurueck = _data["zurueck"];
            this.verloren = _data["verloren"];
            this.geaendert = _data["geaendert"];
            this.vergleichMoeglich = _data["vergleichMoeglich"];
            this.dateienRestore = _data["dateienRestore"];
            this.dateiVergleich = _data["dateiVergleich"] ? RestoreDateiVergleichModel.fromJS(_data["dateiVergleich"]) : <any>undefined;
            this.dateienOhneVergleich = _data["dateienOhneVergleich"];
            this.undoAblage = _data["undoAblage"];
            this.kontoInSicherung = _data["kontoInSicherung"];
            if (Array.isArray(_data["elemente"])) {
                this.elemente = [] as any;
                for (let item of _data["elemente"])
                    this.elemente!.push(RestoreVorschauElementModel.fromJS(item));
            }
            if (Array.isArray(_data["warnungen"])) {
                this.warnungen = [] as any;
                for (let item of _data["warnungen"])
                    this.warnungen!.push(item);
            }
            if (Array.isArray(_data["hinweise"])) {
                this.hinweise = [] as any;
                for (let item of _data["hinweise"])
                    this.hinweise!.push(item);
            }
            if (Array.isArray(_data["neueGemeinden"])) {
                this.neueGemeinden = [] as any;
                for (let item of _data["neueGemeinden"])
                    this.neueGemeinden!.push(item);
            }
            if (Array.isArray(_data["neueJahre"])) {
                this.neueJahre = [] as any;
                for (let item of _data["neueJahre"])
                    this.neueJahre!.push(item);
            }
            if (Array.isArray(_data["neueBenutzer"])) {
                this.neueBenutzer = [] as any;
                for (let item of _data["neueBenutzer"])
                    this.neueBenutzer!.push(item);
            }
        }
    }

    static fromJS(data: any): RestoreVorschauModel {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreVorschauModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ausfuehrbar"] = this.ausfuehrbar;
        data["blockiert"] = this.blockiert;
        data["stand"] = this.stand ? this.stand.toISOString() : <any>undefined;
        data["standId"] = this.standId;
        data["ausPaket"] = this.ausPaket;
        data["schemaSicherung"] = this.schemaSicherung;
        data["schemaAktuell"] = this.schemaAktuell;
        data["zeilenAktuell"] = this.zeilenAktuell;
        data["zeilenSicherung"] = this.zeilenSicherung;
        data["bytesAktuell"] = this.bytesAktuell;
        data["bytesSicherung"] = this.bytesSicherung;
        data["gleich"] = this.gleich;
        data["zurueck"] = this.zurueck;
        data["verloren"] = this.verloren;
        data["geaendert"] = this.geaendert;
        data["vergleichMoeglich"] = this.vergleichMoeglich;
        data["dateienRestore"] = this.dateienRestore;
        data["dateiVergleich"] = this.dateiVergleich ? this.dateiVergleich.toJSON() : <any>undefined;
        data["dateienOhneVergleich"] = this.dateienOhneVergleich;
        data["undoAblage"] = this.undoAblage;
        data["kontoInSicherung"] = this.kontoInSicherung;
        if (Array.isArray(this.elemente)) {
            data["elemente"] = [];
            for (let item of this.elemente)
                data["elemente"].push(item.toJSON());
        }
        if (Array.isArray(this.warnungen)) {
            data["warnungen"] = [];
            for (let item of this.warnungen)
                data["warnungen"].push(item);
        }
        if (Array.isArray(this.hinweise)) {
            data["hinweise"] = [];
            for (let item of this.hinweise)
                data["hinweise"].push(item);
        }
        if (Array.isArray(this.neueGemeinden)) {
            data["neueGemeinden"] = [];
            for (let item of this.neueGemeinden)
                data["neueGemeinden"].push(item);
        }
        if (Array.isArray(this.neueJahre)) {
            data["neueJahre"] = [];
            for (let item of this.neueJahre)
                data["neueJahre"].push(item);
        }
        if (Array.isArray(this.neueBenutzer)) {
            data["neueBenutzer"] = [];
            for (let item of this.neueBenutzer)
                data["neueBenutzer"].push(item);
        }
        return data;
    }
}

export interface IRestoreVorschauModel {
    ausfuehrbar?: boolean;
    blockiert?: string | undefined;
    stand?: Date | undefined;
    standId?: number | undefined;
    ausPaket?: boolean;
    schemaSicherung?: string | undefined;
    schemaAktuell?: string | undefined;
    zeilenAktuell?: number;
    zeilenSicherung?: number;
    bytesAktuell?: number;
    bytesSicherung?: number;
    gleich?: number;
    zurueck?: number;
    verloren?: number;
    geaendert?: number;
    vergleichMoeglich?: boolean;
    dateienRestore?: boolean;
    dateiVergleich?: RestoreDateiVergleichModel;
    dateienOhneVergleich?: string | undefined;
    undoAblage?: string | undefined;
    kontoInSicherung?: boolean;
    elemente?: RestoreVorschauElementModel[] | undefined;
    warnungen?: string[] | undefined;
    hinweise?: string[] | undefined;
    neueGemeinden?: string[] | undefined;
    neueJahre?: string[] | undefined;
    neueBenutzer?: string[] | undefined;
}

export class RollbackRequest implements IRollbackRequest {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    ansicht?: number;
    targetVersion?: number;

    constructor(data?: IRollbackRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.ansicht = _data["ansicht"];
            this.targetVersion = _data["targetVersion"];
        }
    }

    static fromJS(data: any): RollbackRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RollbackRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["ansicht"] = this.ansicht;
        data["targetVersion"] = this.targetVersion;
        return data;
    }
}

export interface IRollbackRequest {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    ansicht?: number;
    targetVersion?: number;
}

export enum RotationAlignment {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class SaveDesignConfigRequest implements ISaveDesignConfigRequest {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    ansicht?: number;
    konfiguration?: DesignConfigModel;

    constructor(data?: ISaveDesignConfigRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.ansicht = _data["ansicht"];
            this.konfiguration = _data["konfiguration"] ? DesignConfigModel.fromJS(_data["konfiguration"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveDesignConfigRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveDesignConfigRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["ansicht"] = this.ansicht;
        data["konfiguration"] = this.konfiguration ? this.konfiguration.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveDesignConfigRequest {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    ansicht?: number;
    konfiguration?: DesignConfigModel;
}

export class SchemaStand implements ISchemaStand {
    backupKonfiguriert?: boolean;
    primaerLetzteMigration?: string | undefined;
    backupLetzteMigration?: string | undefined;
    primaerAusstehend?: number;
    backupAusstehend?: number;
    fehler?: string | undefined;
    readonly synchron?: boolean;

    constructor(data?: ISchemaStand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.backupKonfiguriert = _data["backupKonfiguriert"];
            this.primaerLetzteMigration = _data["primaerLetzteMigration"];
            this.backupLetzteMigration = _data["backupLetzteMigration"];
            this.primaerAusstehend = _data["primaerAusstehend"];
            this.backupAusstehend = _data["backupAusstehend"];
            this.fehler = _data["fehler"];
            (<any>this).synchron = _data["synchron"];
        }
    }

    static fromJS(data: any): SchemaStand {
        data = typeof data === 'object' ? data : {};
        let result = new SchemaStand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["backupKonfiguriert"] = this.backupKonfiguriert;
        data["primaerLetzteMigration"] = this.primaerLetzteMigration;
        data["backupLetzteMigration"] = this.backupLetzteMigration;
        data["primaerAusstehend"] = this.primaerAusstehend;
        data["backupAusstehend"] = this.backupAusstehend;
        data["fehler"] = this.fehler;
        data["synchron"] = this.synchron;
        return data;
    }
}

export interface ISchemaStand {
    backupKonfiguriert?: boolean;
    primaerLetzteMigration?: string | undefined;
    backupLetzteMigration?: string | undefined;
    primaerAusstehend?: number;
    backupAusstehend?: number;
    fehler?: string | undefined;
    synchron?: boolean;
}

export enum ScriptType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class SdgBerichtVorlageDto implements ISdgBerichtVorlageDto {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    name?: string | undefined;
    ausgewaehlt?: number[] | undefined;
    eigeneReihenfolge?: boolean;

    constructor(data?: ISdgBerichtVorlageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.name = _data["name"];
            if (Array.isArray(_data["ausgewaehlt"])) {
                this.ausgewaehlt = [] as any;
                for (let item of _data["ausgewaehlt"])
                    this.ausgewaehlt!.push(item);
            }
            this.eigeneReihenfolge = _data["eigeneReihenfolge"];
        }
    }

    static fromJS(data: any): SdgBerichtVorlageDto {
        data = typeof data === 'object' ? data : {};
        let result = new SdgBerichtVorlageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["name"] = this.name;
        if (Array.isArray(this.ausgewaehlt)) {
            data["ausgewaehlt"] = [];
            for (let item of this.ausgewaehlt)
                data["ausgewaehlt"].push(item);
        }
        data["eigeneReihenfolge"] = this.eigeneReihenfolge;
        return data;
    }
}

export interface ISdgBerichtVorlageDto {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    name?: string | undefined;
    ausgewaehlt?: number[] | undefined;
    eigeneReihenfolge?: boolean;
}

export class SdgDatenMetum implements ISdgDatenMetum {
    id?: number;
    datenId?: number;
    quelle?: string | undefined;
    bemerkung?: string | undefined;
    updatedAt?: Date | undefined;
    updatedBy?: string | undefined;
    daten?: Daten;

    constructor(data?: ISdgDatenMetum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.datenId = _data["datenId"];
            this.quelle = _data["quelle"];
            this.bemerkung = _data["bemerkung"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.daten = _data["daten"] ? Daten.fromJS(_data["daten"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SdgDatenMetum {
        data = typeof data === 'object' ? data : {};
        let result = new SdgDatenMetum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["datenId"] = this.datenId;
        data["quelle"] = this.quelle;
        data["bemerkung"] = this.bemerkung;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["daten"] = this.daten ? this.daten.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISdgDatenMetum {
    id?: number;
    datenId?: number;
    quelle?: string | undefined;
    bemerkung?: string | undefined;
    updatedAt?: Date | undefined;
    updatedBy?: string | undefined;
    daten?: Daten;
}

export class SdgEbene implements ISdgEbene {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    sdgNummer?: number;
    sdgBezeichnung?: string | undefined;
    teilzielNr?: string | undefined;
    teilzielText?: string | undefined;
    reihenfolge?: number | undefined;
    updatedAt?: Date | undefined;
    sdgIndikators?: SdgIndikator[] | undefined;

    constructor(data?: ISdgEbene) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.sdgNummer = _data["sdgNummer"];
            this.sdgBezeichnung = _data["sdgBezeichnung"];
            this.teilzielNr = _data["teilzielNr"];
            this.teilzielText = _data["teilzielText"];
            this.reihenfolge = _data["reihenfolge"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["sdgIndikators"])) {
                this.sdgIndikators = [] as any;
                for (let item of _data["sdgIndikators"])
                    this.sdgIndikators!.push(SdgIndikator.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SdgEbene {
        data = typeof data === 'object' ? data : {};
        let result = new SdgEbene();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["sdgNummer"] = this.sdgNummer;
        data["sdgBezeichnung"] = this.sdgBezeichnung;
        data["teilzielNr"] = this.teilzielNr;
        data["teilzielText"] = this.teilzielText;
        data["reihenfolge"] = this.reihenfolge;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        if (Array.isArray(this.sdgIndikators)) {
            data["sdgIndikators"] = [];
            for (let item of this.sdgIndikators)
                data["sdgIndikators"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISdgEbene {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    sdgNummer?: number;
    sdgBezeichnung?: string | undefined;
    teilzielNr?: string | undefined;
    teilzielText?: string | undefined;
    reihenfolge?: number | undefined;
    updatedAt?: Date | undefined;
    sdgIndikators?: SdgIndikator[] | undefined;
}

export class SdgEbeneDto implements ISdgEbeneDto {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    sdgNummer?: number;
    sdgBezeichnung?: string | undefined;
    teilzielNr?: string | undefined;
    teilzielText?: string | undefined;
    reihenfolge?: number | undefined;
    updatedAt?: Date | undefined;

    constructor(data?: ISdgEbeneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.sdgNummer = _data["sdgNummer"];
            this.sdgBezeichnung = _data["sdgBezeichnung"];
            this.teilzielNr = _data["teilzielNr"];
            this.teilzielText = _data["teilzielText"];
            this.reihenfolge = _data["reihenfolge"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SdgEbeneDto {
        data = typeof data === 'object' ? data : {};
        let result = new SdgEbeneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["sdgNummer"] = this.sdgNummer;
        data["sdgBezeichnung"] = this.sdgBezeichnung;
        data["teilzielNr"] = this.teilzielNr;
        data["teilzielText"] = this.teilzielText;
        data["reihenfolge"] = this.reihenfolge;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISdgEbeneDto {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    sdgNummer?: number;
    sdgBezeichnung?: string | undefined;
    teilzielNr?: string | undefined;
    teilzielText?: string | undefined;
    reihenfolge?: number | undefined;
    updatedAt?: Date | undefined;
}

export class SdgEingabewertLink implements ISdgEingabewertLink {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    bezeichnung?: string | undefined;
    datensatzId?: number;
    updatedAt?: Date | undefined;
    jahr?: number;
    datensatz?: Datensaetze;

    constructor(data?: ISdgEingabewertLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.bezeichnung = _data["bezeichnung"];
            this.datensatzId = _data["datensatzId"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.jahr = _data["jahr"];
            this.datensatz = _data["datensatz"] ? Datensaetze.fromJS(_data["datensatz"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SdgEingabewertLink {
        data = typeof data === 'object' ? data : {};
        let result = new SdgEingabewertLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["bezeichnung"] = this.bezeichnung;
        data["datensatzId"] = this.datensatzId;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["jahr"] = this.jahr;
        data["datensatz"] = this.datensatz ? this.datensatz.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISdgEingabewertLink {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    bezeichnung?: string | undefined;
    datensatzId?: number;
    updatedAt?: Date | undefined;
    jahr?: number;
    datensatz?: Datensaetze;
}

export class SdgEingabewertLinkDto implements ISdgEingabewertLinkDto {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    datensatzId?: number | undefined;

    constructor(data?: ISdgEingabewertLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.bezeichnung = _data["bezeichnung"];
            this.datensatzId = _data["datensatzId"];
        }
    }

    static fromJS(data: any): SdgEingabewertLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new SdgEingabewertLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["bezeichnung"] = this.bezeichnung;
        data["datensatzId"] = this.datensatzId;
        return data;
    }
}

export interface ISdgEingabewertLinkDto {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    datensatzId?: number | undefined;
}

export class SdgEingabewertSaveDto implements ISdgEingabewertSaveDto {
    kunde?: number;
    gemeinde?: number;
    anlageJahr?: number;
    bezeichnung?: string | undefined;
    jahr?: number;
    wert?: number | undefined;
    einheit?: string | undefined;

    constructor(data?: ISdgEingabewertSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.anlageJahr = _data["anlageJahr"];
            this.bezeichnung = _data["bezeichnung"];
            this.jahr = _data["jahr"];
            this.wert = _data["wert"];
            this.einheit = _data["einheit"];
        }
    }

    static fromJS(data: any): SdgEingabewertSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new SdgEingabewertSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["anlageJahr"] = this.anlageJahr;
        data["bezeichnung"] = this.bezeichnung;
        data["jahr"] = this.jahr;
        data["wert"] = this.wert;
        data["einheit"] = this.einheit;
        return data;
    }
}

export interface ISdgEingabewertSaveDto {
    kunde?: number;
    gemeinde?: number;
    anlageJahr?: number;
    bezeichnung?: string | undefined;
    jahr?: number;
    wert?: number | undefined;
    einheit?: string | undefined;
}

export class SdgEingabewertZeileDto implements ISdgEingabewertZeileDto {
    bezeichnung?: string | undefined;
    einheit?: string | undefined;
    datensatzId?: number | undefined;
    werteByJahr?: { [key: string]: number; } | undefined;
    indikatorNrs?: number[] | undefined;
    indikatorIds?: number[] | undefined;
    verknuepftDatensatzId?: number | undefined;
    verknuepftBezeichnung?: string | undefined;

    constructor(data?: ISdgEingabewertZeileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bezeichnung = _data["bezeichnung"];
            this.einheit = _data["einheit"];
            this.datensatzId = _data["datensatzId"];
            if (_data["werteByJahr"]) {
                this.werteByJahr = {} as any;
                for (let key in _data["werteByJahr"]) {
                    if (_data["werteByJahr"].hasOwnProperty(key))
                        (<any>this.werteByJahr)![key] = _data["werteByJahr"][key];
                }
            }
            if (Array.isArray(_data["indikatorNrs"])) {
                this.indikatorNrs = [] as any;
                for (let item of _data["indikatorNrs"])
                    this.indikatorNrs!.push(item);
            }
            if (Array.isArray(_data["indikatorIds"])) {
                this.indikatorIds = [] as any;
                for (let item of _data["indikatorIds"])
                    this.indikatorIds!.push(item);
            }
            this.verknuepftDatensatzId = _data["verknuepftDatensatzId"];
            this.verknuepftBezeichnung = _data["verknuepftBezeichnung"];
        }
    }

    static fromJS(data: any): SdgEingabewertZeileDto {
        data = typeof data === 'object' ? data : {};
        let result = new SdgEingabewertZeileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bezeichnung"] = this.bezeichnung;
        data["einheit"] = this.einheit;
        data["datensatzId"] = this.datensatzId;
        if (this.werteByJahr) {
            data["werteByJahr"] = {};
            for (let key in this.werteByJahr) {
                if (this.werteByJahr.hasOwnProperty(key))
                    (<any>data["werteByJahr"])[key] = (<any>this.werteByJahr)[key];
            }
        }
        if (Array.isArray(this.indikatorNrs)) {
            data["indikatorNrs"] = [];
            for (let item of this.indikatorNrs)
                data["indikatorNrs"].push(item);
        }
        if (Array.isArray(this.indikatorIds)) {
            data["indikatorIds"] = [];
            for (let item of this.indikatorIds)
                data["indikatorIds"].push(item);
        }
        data["verknuepftDatensatzId"] = this.verknuepftDatensatzId;
        data["verknuepftBezeichnung"] = this.verknuepftBezeichnung;
        return data;
    }
}

export interface ISdgEingabewertZeileDto {
    bezeichnung?: string | undefined;
    einheit?: string | undefined;
    datensatzId?: number | undefined;
    werteByJahr?: { [key: string]: number; } | undefined;
    indikatorNrs?: number[] | undefined;
    indikatorIds?: number[] | undefined;
    verknuepftDatensatzId?: number | undefined;
    verknuepftBezeichnung?: string | undefined;
}

export class SdgGrundzahlKandidatDto implements ISdgGrundzahlKandidatDto {
    id?: number;
    bezeichnung?: string | undefined;
    einheit?: string | undefined;
    ebeneId?: string | undefined;
    ebeneBezeichnung?: string | undefined;
    letzterWert?: number | undefined;
    letztesJahr?: number | undefined;
    istSdgEingabe?: boolean;

    constructor(data?: ISdgGrundzahlKandidatDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
            this.einheit = _data["einheit"];
            this.ebeneId = _data["ebeneId"];
            this.ebeneBezeichnung = _data["ebeneBezeichnung"];
            this.letzterWert = _data["letzterWert"];
            this.letztesJahr = _data["letztesJahr"];
            this.istSdgEingabe = _data["istSdgEingabe"];
        }
    }

    static fromJS(data: any): SdgGrundzahlKandidatDto {
        data = typeof data === 'object' ? data : {};
        let result = new SdgGrundzahlKandidatDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        data["einheit"] = this.einheit;
        data["ebeneId"] = this.ebeneId;
        data["ebeneBezeichnung"] = this.ebeneBezeichnung;
        data["letzterWert"] = this.letzterWert;
        data["letztesJahr"] = this.letztesJahr;
        data["istSdgEingabe"] = this.istSdgEingabe;
        return data;
    }
}

export interface ISdgGrundzahlKandidatDto {
    id?: number;
    bezeichnung?: string | undefined;
    einheit?: string | undefined;
    ebeneId?: string | undefined;
    ebeneBezeichnung?: string | undefined;
    letzterWert?: number | undefined;
    letztesJahr?: number | undefined;
    istSdgEingabe?: boolean;
}

export class SdgIndikator implements ISdgIndikator {
    id?: number;
    sdgEbeneId?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    indikatorNr?: number;
    bezeichnung?: string | undefined;
    herkunftIndikator?: string | undefined;
    inhaltlicheKompatibilitaet?: string | undefined;
    definitorischeKompatibilitaet?: string | undefined;
    bnk2?: string | undefined;
    berechnungsformelKlartext?: string | undefined;
    berechnungsformel?: string | undefined;
    validitaet?: string | undefined;
    verstaendlichkeit?: string | undefined;
    datenverfuegbarkeit?: string | undefined;
    datenqualitaet?: string | undefined;
    funktion?: string | undefined;
    typ?: string | undefined;
    einheit?: string | undefined;
    updatedAt?: Date | undefined;
    datensatzId?: number | undefined;
    multiplikator?: number;
    zielwert?: number | undefined;
    richtung?: string | undefined;
    schwelleProzent?: number | undefined;
    datensatz?: Datensaetze;
    sdgEbene?: SdgEbene;
    sdgIndikatorEingabes?: SdgIndikatorEingabe[] | undefined;

    constructor(data?: ISdgIndikator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sdgEbeneId = _data["sdgEbeneId"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.indikatorNr = _data["indikatorNr"];
            this.bezeichnung = _data["bezeichnung"];
            this.herkunftIndikator = _data["herkunftIndikator"];
            this.inhaltlicheKompatibilitaet = _data["inhaltlicheKompatibilitaet"];
            this.definitorischeKompatibilitaet = _data["definitorischeKompatibilitaet"];
            this.bnk2 = _data["bnk2"];
            this.berechnungsformelKlartext = _data["berechnungsformelKlartext"];
            this.berechnungsformel = _data["berechnungsformel"];
            this.validitaet = _data["validitaet"];
            this.verstaendlichkeit = _data["verstaendlichkeit"];
            this.datenverfuegbarkeit = _data["datenverfuegbarkeit"];
            this.datenqualitaet = _data["datenqualitaet"];
            this.funktion = _data["funktion"];
            this.typ = _data["typ"];
            this.einheit = _data["einheit"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.datensatzId = _data["datensatzId"];
            this.multiplikator = _data["multiplikator"];
            this.zielwert = _data["zielwert"];
            this.richtung = _data["richtung"];
            this.schwelleProzent = _data["schwelleProzent"];
            this.datensatz = _data["datensatz"] ? Datensaetze.fromJS(_data["datensatz"]) : <any>undefined;
            this.sdgEbene = _data["sdgEbene"] ? SdgEbene.fromJS(_data["sdgEbene"]) : <any>undefined;
            if (Array.isArray(_data["sdgIndikatorEingabes"])) {
                this.sdgIndikatorEingabes = [] as any;
                for (let item of _data["sdgIndikatorEingabes"])
                    this.sdgIndikatorEingabes!.push(SdgIndikatorEingabe.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SdgIndikator {
        data = typeof data === 'object' ? data : {};
        let result = new SdgIndikator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sdgEbeneId"] = this.sdgEbeneId;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["indikatorNr"] = this.indikatorNr;
        data["bezeichnung"] = this.bezeichnung;
        data["herkunftIndikator"] = this.herkunftIndikator;
        data["inhaltlicheKompatibilitaet"] = this.inhaltlicheKompatibilitaet;
        data["definitorischeKompatibilitaet"] = this.definitorischeKompatibilitaet;
        data["bnk2"] = this.bnk2;
        data["berechnungsformelKlartext"] = this.berechnungsformelKlartext;
        data["berechnungsformel"] = this.berechnungsformel;
        data["validitaet"] = this.validitaet;
        data["verstaendlichkeit"] = this.verstaendlichkeit;
        data["datenverfuegbarkeit"] = this.datenverfuegbarkeit;
        data["datenqualitaet"] = this.datenqualitaet;
        data["funktion"] = this.funktion;
        data["typ"] = this.typ;
        data["einheit"] = this.einheit;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["datensatzId"] = this.datensatzId;
        data["multiplikator"] = this.multiplikator;
        data["zielwert"] = this.zielwert;
        data["richtung"] = this.richtung;
        data["schwelleProzent"] = this.schwelleProzent;
        data["datensatz"] = this.datensatz ? this.datensatz.toJSON() : <any>undefined;
        data["sdgEbene"] = this.sdgEbene ? this.sdgEbene.toJSON() : <any>undefined;
        if (Array.isArray(this.sdgIndikatorEingabes)) {
            data["sdgIndikatorEingabes"] = [];
            for (let item of this.sdgIndikatorEingabes)
                data["sdgIndikatorEingabes"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISdgIndikator {
    id?: number;
    sdgEbeneId?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    indikatorNr?: number;
    bezeichnung?: string | undefined;
    herkunftIndikator?: string | undefined;
    inhaltlicheKompatibilitaet?: string | undefined;
    definitorischeKompatibilitaet?: string | undefined;
    bnk2?: string | undefined;
    berechnungsformelKlartext?: string | undefined;
    berechnungsformel?: string | undefined;
    validitaet?: string | undefined;
    verstaendlichkeit?: string | undefined;
    datenverfuegbarkeit?: string | undefined;
    datenqualitaet?: string | undefined;
    funktion?: string | undefined;
    typ?: string | undefined;
    einheit?: string | undefined;
    updatedAt?: Date | undefined;
    datensatzId?: number | undefined;
    multiplikator?: number;
    zielwert?: number | undefined;
    richtung?: string | undefined;
    schwelleProzent?: number | undefined;
    datensatz?: Datensaetze;
    sdgEbene?: SdgEbene;
    sdgIndikatorEingabes?: SdgIndikatorEingabe[] | undefined;
}

export class SdgIndikatorDto implements ISdgIndikatorDto {
    id?: number;
    sdgEbeneId?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    indikatorNr?: number;
    istKatalog?: boolean;
    bezeichnung?: string | undefined;
    herkunftIndikator?: string | undefined;
    inhaltlicheKompatibilitaet?: string | undefined;
    definitorischeKompatibilitaet?: string | undefined;
    bnk2?: string | undefined;
    berechnungsformelKlartext?: string | undefined;
    validitaet?: string | undefined;
    verstaendlichkeit?: string | undefined;
    datenverfuegbarkeit?: string | undefined;
    datenqualitaet?: string | undefined;
    funktion?: string | undefined;
    typ?: string | undefined;
    einheit?: string | undefined;
    updatedAt?: Date | undefined;
    berechnungsformel?: string | undefined;
    multiplikator?: number;
    zielwert?: number | undefined;
    richtung?: string | undefined;
    schwelleProzent?: number | undefined;
    eingaben?: SdgIndikatorEingabeDto[] | undefined;
    aktuellerWert?: number | undefined;
    aktuellesJahr?: number | undefined;
    werte?: { [key: string]: number; } | undefined;
    sdgNummer?: number | undefined;
    sdgBezeichnung?: string | undefined;
    teilzielNr?: string | undefined;

    constructor(data?: ISdgIndikatorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sdgEbeneId = _data["sdgEbeneId"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.indikatorNr = _data["indikatorNr"];
            this.istKatalog = _data["istKatalog"];
            this.bezeichnung = _data["bezeichnung"];
            this.herkunftIndikator = _data["herkunftIndikator"];
            this.inhaltlicheKompatibilitaet = _data["inhaltlicheKompatibilitaet"];
            this.definitorischeKompatibilitaet = _data["definitorischeKompatibilitaet"];
            this.bnk2 = _data["bnk2"];
            this.berechnungsformelKlartext = _data["berechnungsformelKlartext"];
            this.validitaet = _data["validitaet"];
            this.verstaendlichkeit = _data["verstaendlichkeit"];
            this.datenverfuegbarkeit = _data["datenverfuegbarkeit"];
            this.datenqualitaet = _data["datenqualitaet"];
            this.funktion = _data["funktion"];
            this.typ = _data["typ"];
            this.einheit = _data["einheit"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.berechnungsformel = _data["berechnungsformel"];
            this.multiplikator = _data["multiplikator"];
            this.zielwert = _data["zielwert"];
            this.richtung = _data["richtung"];
            this.schwelleProzent = _data["schwelleProzent"];
            if (Array.isArray(_data["eingaben"])) {
                this.eingaben = [] as any;
                for (let item of _data["eingaben"])
                    this.eingaben!.push(SdgIndikatorEingabeDto.fromJS(item));
            }
            this.aktuellerWert = _data["aktuellerWert"];
            this.aktuellesJahr = _data["aktuellesJahr"];
            if (_data["werte"]) {
                this.werte = {} as any;
                for (let key in _data["werte"]) {
                    if (_data["werte"].hasOwnProperty(key))
                        (<any>this.werte)![key] = _data["werte"][key];
                }
            }
            this.sdgNummer = _data["sdgNummer"];
            this.sdgBezeichnung = _data["sdgBezeichnung"];
            this.teilzielNr = _data["teilzielNr"];
        }
    }

    static fromJS(data: any): SdgIndikatorDto {
        data = typeof data === 'object' ? data : {};
        let result = new SdgIndikatorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sdgEbeneId"] = this.sdgEbeneId;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["indikatorNr"] = this.indikatorNr;
        data["istKatalog"] = this.istKatalog;
        data["bezeichnung"] = this.bezeichnung;
        data["herkunftIndikator"] = this.herkunftIndikator;
        data["inhaltlicheKompatibilitaet"] = this.inhaltlicheKompatibilitaet;
        data["definitorischeKompatibilitaet"] = this.definitorischeKompatibilitaet;
        data["bnk2"] = this.bnk2;
        data["berechnungsformelKlartext"] = this.berechnungsformelKlartext;
        data["validitaet"] = this.validitaet;
        data["verstaendlichkeit"] = this.verstaendlichkeit;
        data["datenverfuegbarkeit"] = this.datenverfuegbarkeit;
        data["datenqualitaet"] = this.datenqualitaet;
        data["funktion"] = this.funktion;
        data["typ"] = this.typ;
        data["einheit"] = this.einheit;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["berechnungsformel"] = this.berechnungsformel;
        data["multiplikator"] = this.multiplikator;
        data["zielwert"] = this.zielwert;
        data["richtung"] = this.richtung;
        data["schwelleProzent"] = this.schwelleProzent;
        if (Array.isArray(this.eingaben)) {
            data["eingaben"] = [];
            for (let item of this.eingaben)
                data["eingaben"].push(item.toJSON());
        }
        data["aktuellerWert"] = this.aktuellerWert;
        data["aktuellesJahr"] = this.aktuellesJahr;
        if (this.werte) {
            data["werte"] = {};
            for (let key in this.werte) {
                if (this.werte.hasOwnProperty(key))
                    (<any>data["werte"])[key] = (<any>this.werte)[key];
            }
        }
        data["sdgNummer"] = this.sdgNummer;
        data["sdgBezeichnung"] = this.sdgBezeichnung;
        data["teilzielNr"] = this.teilzielNr;
        return data;
    }
}

export interface ISdgIndikatorDto {
    id?: number;
    sdgEbeneId?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    indikatorNr?: number;
    istKatalog?: boolean;
    bezeichnung?: string | undefined;
    herkunftIndikator?: string | undefined;
    inhaltlicheKompatibilitaet?: string | undefined;
    definitorischeKompatibilitaet?: string | undefined;
    bnk2?: string | undefined;
    berechnungsformelKlartext?: string | undefined;
    validitaet?: string | undefined;
    verstaendlichkeit?: string | undefined;
    datenverfuegbarkeit?: string | undefined;
    datenqualitaet?: string | undefined;
    funktion?: string | undefined;
    typ?: string | undefined;
    einheit?: string | undefined;
    updatedAt?: Date | undefined;
    berechnungsformel?: string | undefined;
    multiplikator?: number;
    zielwert?: number | undefined;
    richtung?: string | undefined;
    schwelleProzent?: number | undefined;
    eingaben?: SdgIndikatorEingabeDto[] | undefined;
    aktuellerWert?: number | undefined;
    aktuellesJahr?: number | undefined;
    werte?: { [key: string]: number; } | undefined;
    sdgNummer?: number | undefined;
    sdgBezeichnung?: string | undefined;
    teilzielNr?: string | undefined;
}

export class SdgIndikatorEingabe implements ISdgIndikatorEingabe {
    id?: number;
    sdgIndikatorId?: number;
    datensatzId?: number;
    variable?: string | undefined;
    bezeichnung?: string | undefined;
    reihenfolge?: number;
    datensatz?: Datensaetze;
    sdgIndikator?: SdgIndikator;

    constructor(data?: ISdgIndikatorEingabe) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sdgIndikatorId = _data["sdgIndikatorId"];
            this.datensatzId = _data["datensatzId"];
            this.variable = _data["variable"];
            this.bezeichnung = _data["bezeichnung"];
            this.reihenfolge = _data["reihenfolge"];
            this.datensatz = _data["datensatz"] ? Datensaetze.fromJS(_data["datensatz"]) : <any>undefined;
            this.sdgIndikator = _data["sdgIndikator"] ? SdgIndikator.fromJS(_data["sdgIndikator"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SdgIndikatorEingabe {
        data = typeof data === 'object' ? data : {};
        let result = new SdgIndikatorEingabe();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sdgIndikatorId"] = this.sdgIndikatorId;
        data["datensatzId"] = this.datensatzId;
        data["variable"] = this.variable;
        data["bezeichnung"] = this.bezeichnung;
        data["reihenfolge"] = this.reihenfolge;
        data["datensatz"] = this.datensatz ? this.datensatz.toJSON() : <any>undefined;
        data["sdgIndikator"] = this.sdgIndikator ? this.sdgIndikator.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISdgIndikatorEingabe {
    id?: number;
    sdgIndikatorId?: number;
    datensatzId?: number;
    variable?: string | undefined;
    bezeichnung?: string | undefined;
    reihenfolge?: number;
    datensatz?: Datensaetze;
    sdgIndikator?: SdgIndikator;
}

export class SdgIndikatorEingabeDto implements ISdgIndikatorEingabeDto {
    id?: number;
    sdgIndikatorId?: number;
    datensatzId?: number;
    variable?: string | undefined;
    bezeichnung?: string | undefined;
    reihenfolge?: number;

    constructor(data?: ISdgIndikatorEingabeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sdgIndikatorId = _data["sdgIndikatorId"];
            this.datensatzId = _data["datensatzId"];
            this.variable = _data["variable"];
            this.bezeichnung = _data["bezeichnung"];
            this.reihenfolge = _data["reihenfolge"];
        }
    }

    static fromJS(data: any): SdgIndikatorEingabeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SdgIndikatorEingabeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sdgIndikatorId"] = this.sdgIndikatorId;
        data["datensatzId"] = this.datensatzId;
        data["variable"] = this.variable;
        data["bezeichnung"] = this.bezeichnung;
        data["reihenfolge"] = this.reihenfolge;
        return data;
    }
}

export interface ISdgIndikatorEingabeDto {
    id?: number;
    sdgIndikatorId?: number;
    datensatzId?: number;
    variable?: string | undefined;
    bezeichnung?: string | undefined;
    reihenfolge?: number;
}

export class SdgKonfigDto implements ISdgKonfigDto {
    kunde?: number;
    gemeinde?: number;
    bezeichnung?: string | undefined;
    druckBerechnung?: boolean;
    druckVerstaendlichkeit?: boolean;
    druckDatenverfuegbarkeit?: boolean;
    druckDatenqualitaet?: boolean;
    druckFunktion?: boolean;
    druckTyp?: boolean;
    druckDiagramme?: boolean;
    druckFortschreibung?: boolean;
    einleitung?: string | undefined;
    einleitungVorlage?: string | undefined;
    oeffentlichesJahr?: number | undefined;
    kurzname?: string | undefined;
    kurznameVorschlag?: string | undefined;

    constructor(data?: ISdgKonfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.bezeichnung = _data["bezeichnung"];
            this.druckBerechnung = _data["druckBerechnung"];
            this.druckVerstaendlichkeit = _data["druckVerstaendlichkeit"];
            this.druckDatenverfuegbarkeit = _data["druckDatenverfuegbarkeit"];
            this.druckDatenqualitaet = _data["druckDatenqualitaet"];
            this.druckFunktion = _data["druckFunktion"];
            this.druckTyp = _data["druckTyp"];
            this.druckDiagramme = _data["druckDiagramme"];
            this.druckFortschreibung = _data["druckFortschreibung"];
            this.einleitung = _data["einleitung"];
            this.einleitungVorlage = _data["einleitungVorlage"];
            this.oeffentlichesJahr = _data["oeffentlichesJahr"];
            this.kurzname = _data["kurzname"];
            this.kurznameVorschlag = _data["kurznameVorschlag"];
        }
    }

    static fromJS(data: any): SdgKonfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new SdgKonfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["bezeichnung"] = this.bezeichnung;
        data["druckBerechnung"] = this.druckBerechnung;
        data["druckVerstaendlichkeit"] = this.druckVerstaendlichkeit;
        data["druckDatenverfuegbarkeit"] = this.druckDatenverfuegbarkeit;
        data["druckDatenqualitaet"] = this.druckDatenqualitaet;
        data["druckFunktion"] = this.druckFunktion;
        data["druckTyp"] = this.druckTyp;
        data["druckDiagramme"] = this.druckDiagramme;
        data["druckFortschreibung"] = this.druckFortschreibung;
        data["einleitung"] = this.einleitung;
        data["einleitungVorlage"] = this.einleitungVorlage;
        data["oeffentlichesJahr"] = this.oeffentlichesJahr;
        data["kurzname"] = this.kurzname;
        data["kurznameVorschlag"] = this.kurznameVorschlag;
        return data;
    }
}

export interface ISdgKonfigDto {
    kunde?: number;
    gemeinde?: number;
    bezeichnung?: string | undefined;
    druckBerechnung?: boolean;
    druckVerstaendlichkeit?: boolean;
    druckDatenverfuegbarkeit?: boolean;
    druckDatenqualitaet?: boolean;
    druckFunktion?: boolean;
    druckTyp?: boolean;
    druckDiagramme?: boolean;
    druckFortschreibung?: boolean;
    einleitung?: string | undefined;
    einleitungVorlage?: string | undefined;
    oeffentlichesJahr?: number | undefined;
    kurzname?: string | undefined;
    kurznameVorschlag?: string | undefined;
}

export class SdgKopfDto implements ISdgKopfDto {
    gemeindeName?: string | undefined;
    wappenUrl?: string | undefined;
    stammdatenWappen?: boolean;
    sdgWappen?: SdgWappenInfoDto;
    sdgWappenGeprueft?: boolean;
    wappenAlternative?: string | undefined;
    zieleMitIndikatoren?: number;

    constructor(data?: ISdgKopfDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gemeindeName = _data["gemeindeName"];
            this.wappenUrl = _data["wappenUrl"];
            this.stammdatenWappen = _data["stammdatenWappen"];
            this.sdgWappen = _data["sdgWappen"] ? SdgWappenInfoDto.fromJS(_data["sdgWappen"]) : <any>undefined;
            this.sdgWappenGeprueft = _data["sdgWappenGeprueft"];
            this.wappenAlternative = _data["wappenAlternative"];
            this.zieleMitIndikatoren = _data["zieleMitIndikatoren"];
        }
    }

    static fromJS(data: any): SdgKopfDto {
        data = typeof data === 'object' ? data : {};
        let result = new SdgKopfDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gemeindeName"] = this.gemeindeName;
        data["wappenUrl"] = this.wappenUrl;
        data["stammdatenWappen"] = this.stammdatenWappen;
        data["sdgWappen"] = this.sdgWappen ? this.sdgWappen.toJSON() : <any>undefined;
        data["sdgWappenGeprueft"] = this.sdgWappenGeprueft;
        data["wappenAlternative"] = this.wappenAlternative;
        data["zieleMitIndikatoren"] = this.zieleMitIndikatoren;
        return data;
    }
}

export interface ISdgKopfDto {
    gemeindeName?: string | undefined;
    wappenUrl?: string | undefined;
    stammdatenWappen?: boolean;
    sdgWappen?: SdgWappenInfoDto;
    sdgWappenGeprueft?: boolean;
    wappenAlternative?: string | undefined;
    zieleMitIndikatoren?: number;
}

export class SdgMasterIndikator implements ISdgMasterIndikator {
    indikatorNr?: number;
    sdgNummer?: number;
    sdgBezeichnung?: string | undefined;
    teilzielNr?: string | undefined;
    teilzielText?: string | undefined;
    bezeichnung?: string | undefined;
    herkunftIndikator?: string | undefined;
    inhaltlicheKompatibilitaet?: string | undefined;
    definitorischeKompatibilitaet?: string | undefined;
    bnk2?: string | undefined;
    berechnungsformelKlartext?: string | undefined;
    validitaet?: string | undefined;
    verstaendlichkeit?: string | undefined;
    datenverfuegbarkeit?: string | undefined;
    datenqualitaet?: string | undefined;
    funktion?: string | undefined;
    typ?: string | undefined;
    einheit?: string | undefined;
    istStandard?: boolean;

    constructor(data?: ISdgMasterIndikator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.indikatorNr = _data["indikatorNr"];
            this.sdgNummer = _data["sdgNummer"];
            this.sdgBezeichnung = _data["sdgBezeichnung"];
            this.teilzielNr = _data["teilzielNr"];
            this.teilzielText = _data["teilzielText"];
            this.bezeichnung = _data["bezeichnung"];
            this.herkunftIndikator = _data["herkunftIndikator"];
            this.inhaltlicheKompatibilitaet = _data["inhaltlicheKompatibilitaet"];
            this.definitorischeKompatibilitaet = _data["definitorischeKompatibilitaet"];
            this.bnk2 = _data["bnk2"];
            this.berechnungsformelKlartext = _data["berechnungsformelKlartext"];
            this.validitaet = _data["validitaet"];
            this.verstaendlichkeit = _data["verstaendlichkeit"];
            this.datenverfuegbarkeit = _data["datenverfuegbarkeit"];
            this.datenqualitaet = _data["datenqualitaet"];
            this.funktion = _data["funktion"];
            this.typ = _data["typ"];
            this.einheit = _data["einheit"];
            this.istStandard = _data["istStandard"];
        }
    }

    static fromJS(data: any): SdgMasterIndikator {
        data = typeof data === 'object' ? data : {};
        let result = new SdgMasterIndikator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["indikatorNr"] = this.indikatorNr;
        data["sdgNummer"] = this.sdgNummer;
        data["sdgBezeichnung"] = this.sdgBezeichnung;
        data["teilzielNr"] = this.teilzielNr;
        data["teilzielText"] = this.teilzielText;
        data["bezeichnung"] = this.bezeichnung;
        data["herkunftIndikator"] = this.herkunftIndikator;
        data["inhaltlicheKompatibilitaet"] = this.inhaltlicheKompatibilitaet;
        data["definitorischeKompatibilitaet"] = this.definitorischeKompatibilitaet;
        data["bnk2"] = this.bnk2;
        data["berechnungsformelKlartext"] = this.berechnungsformelKlartext;
        data["validitaet"] = this.validitaet;
        data["verstaendlichkeit"] = this.verstaendlichkeit;
        data["datenverfuegbarkeit"] = this.datenverfuegbarkeit;
        data["datenqualitaet"] = this.datenqualitaet;
        data["funktion"] = this.funktion;
        data["typ"] = this.typ;
        data["einheit"] = this.einheit;
        data["istStandard"] = this.istStandard;
        return data;
    }
}

export interface ISdgMasterIndikator {
    indikatorNr?: number;
    sdgNummer?: number;
    sdgBezeichnung?: string | undefined;
    teilzielNr?: string | undefined;
    teilzielText?: string | undefined;
    bezeichnung?: string | undefined;
    herkunftIndikator?: string | undefined;
    inhaltlicheKompatibilitaet?: string | undefined;
    definitorischeKompatibilitaet?: string | undefined;
    bnk2?: string | undefined;
    berechnungsformelKlartext?: string | undefined;
    validitaet?: string | undefined;
    verstaendlichkeit?: string | undefined;
    datenverfuegbarkeit?: string | undefined;
    datenqualitaet?: string | undefined;
    funktion?: string | undefined;
    typ?: string | undefined;
    einheit?: string | undefined;
    istStandard?: boolean;
}

export enum SdgPickAktion {
    _0 = 0,
    _1 = 1,
}

export class SdgPickEingabeDto implements ISdgPickEingabeDto {
    variable?: string | undefined;
    bezeichnung?: string | undefined;
    aktion?: SdgPickAktion;
    datensatzId?: number | undefined;

    constructor(data?: ISdgPickEingabeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.variable = _data["variable"];
            this.bezeichnung = _data["bezeichnung"];
            this.aktion = _data["aktion"];
            this.datensatzId = _data["datensatzId"];
        }
    }

    static fromJS(data: any): SdgPickEingabeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SdgPickEingabeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["variable"] = this.variable;
        data["bezeichnung"] = this.bezeichnung;
        data["aktion"] = this.aktion;
        data["datensatzId"] = this.datensatzId;
        return data;
    }
}

export interface ISdgPickEingabeDto {
    variable?: string | undefined;
    bezeichnung?: string | undefined;
    aktion?: SdgPickAktion;
    datensatzId?: number | undefined;
}

export class SdgPickItemDto implements ISdgPickItemDto {
    indikatorNr?: number;
    eingaben?: SdgPickEingabeDto[] | undefined;

    constructor(data?: ISdgPickItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.indikatorNr = _data["indikatorNr"];
            if (Array.isArray(_data["eingaben"])) {
                this.eingaben = [] as any;
                for (let item of _data["eingaben"])
                    this.eingaben!.push(SdgPickEingabeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SdgPickItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SdgPickItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["indikatorNr"] = this.indikatorNr;
        if (Array.isArray(this.eingaben)) {
            data["eingaben"] = [];
            for (let item of this.eingaben)
                data["eingaben"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISdgPickItemDto {
    indikatorNr?: number;
    eingaben?: SdgPickEingabeDto[] | undefined;
}

export class SdgPraesentationZugangDto implements ISdgPraesentationZugangDto {
    anmeldungNoetig?: boolean;
    jahr?: number | undefined;
    jahre?: number[] | undefined;
    oeffentlicheJahre?: number[] | undefined;

    constructor(data?: ISdgPraesentationZugangDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.anmeldungNoetig = _data["anmeldungNoetig"];
            this.jahr = _data["jahr"];
            if (Array.isArray(_data["jahre"])) {
                this.jahre = [] as any;
                for (let item of _data["jahre"])
                    this.jahre!.push(item);
            }
            if (Array.isArray(_data["oeffentlicheJahre"])) {
                this.oeffentlicheJahre = [] as any;
                for (let item of _data["oeffentlicheJahre"])
                    this.oeffentlicheJahre!.push(item);
            }
        }
    }

    static fromJS(data: any): SdgPraesentationZugangDto {
        data = typeof data === 'object' ? data : {};
        let result = new SdgPraesentationZugangDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["anmeldungNoetig"] = this.anmeldungNoetig;
        data["jahr"] = this.jahr;
        if (Array.isArray(this.jahre)) {
            data["jahre"] = [];
            for (let item of this.jahre)
                data["jahre"].push(item);
        }
        if (Array.isArray(this.oeffentlicheJahre)) {
            data["oeffentlicheJahre"] = [];
            for (let item of this.oeffentlicheJahre)
                data["oeffentlicheJahre"].push(item);
        }
        return data;
    }
}

export interface ISdgPraesentationZugangDto {
    anmeldungNoetig?: boolean;
    jahr?: number | undefined;
    jahre?: number[] | undefined;
    oeffentlicheJahre?: number[] | undefined;
}

export class SdgReportDto implements ISdgReportDto {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    gemeindeName?: string | undefined;
    wappenUrl?: string | undefined;
    stammdatenWappen?: boolean;
    sdgWappen?: SdgWappenInfoDto;
    sdgWappenGeprueft?: boolean;
    wappenRechts?: boolean;
    wappenAlternative?: string | undefined;
    jahre?: number[] | undefined;
    konfig?: SdgKonfigDto;
    sdgGruppen?: SdgReportGruppeDto[] | undefined;

    constructor(data?: ISdgReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.gemeindeName = _data["gemeindeName"];
            this.wappenUrl = _data["wappenUrl"];
            this.stammdatenWappen = _data["stammdatenWappen"];
            this.sdgWappen = _data["sdgWappen"] ? SdgWappenInfoDto.fromJS(_data["sdgWappen"]) : <any>undefined;
            this.sdgWappenGeprueft = _data["sdgWappenGeprueft"];
            this.wappenRechts = _data["wappenRechts"];
            this.wappenAlternative = _data["wappenAlternative"];
            if (Array.isArray(_data["jahre"])) {
                this.jahre = [] as any;
                for (let item of _data["jahre"])
                    this.jahre!.push(item);
            }
            this.konfig = _data["konfig"] ? SdgKonfigDto.fromJS(_data["konfig"]) : <any>undefined;
            if (Array.isArray(_data["sdgGruppen"])) {
                this.sdgGruppen = [] as any;
                for (let item of _data["sdgGruppen"])
                    this.sdgGruppen!.push(SdgReportGruppeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SdgReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new SdgReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["gemeindeName"] = this.gemeindeName;
        data["wappenUrl"] = this.wappenUrl;
        data["stammdatenWappen"] = this.stammdatenWappen;
        data["sdgWappen"] = this.sdgWappen ? this.sdgWappen.toJSON() : <any>undefined;
        data["sdgWappenGeprueft"] = this.sdgWappenGeprueft;
        data["wappenRechts"] = this.wappenRechts;
        data["wappenAlternative"] = this.wappenAlternative;
        if (Array.isArray(this.jahre)) {
            data["jahre"] = [];
            for (let item of this.jahre)
                data["jahre"].push(item);
        }
        data["konfig"] = this.konfig ? this.konfig.toJSON() : <any>undefined;
        if (Array.isArray(this.sdgGruppen)) {
            data["sdgGruppen"] = [];
            for (let item of this.sdgGruppen)
                data["sdgGruppen"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISdgReportDto {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    gemeindeName?: string | undefined;
    wappenUrl?: string | undefined;
    stammdatenWappen?: boolean;
    sdgWappen?: SdgWappenInfoDto;
    sdgWappenGeprueft?: boolean;
    wappenRechts?: boolean;
    wappenAlternative?: string | undefined;
    jahre?: number[] | undefined;
    konfig?: SdgKonfigDto;
    sdgGruppen?: SdgReportGruppeDto[] | undefined;
}

export class SdgReportEingabewertDto implements ISdgReportEingabewertDto {
    variable?: string | undefined;
    bezeichnung?: string | undefined;
    einheit?: string | undefined;
    verknuepft?: boolean;
    werteByJahr?: { [key: string]: number; } | undefined;

    constructor(data?: ISdgReportEingabewertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.variable = _data["variable"];
            this.bezeichnung = _data["bezeichnung"];
            this.einheit = _data["einheit"];
            this.verknuepft = _data["verknuepft"];
            if (_data["werteByJahr"]) {
                this.werteByJahr = {} as any;
                for (let key in _data["werteByJahr"]) {
                    if (_data["werteByJahr"].hasOwnProperty(key))
                        (<any>this.werteByJahr)![key] = _data["werteByJahr"][key];
                }
            }
        }
    }

    static fromJS(data: any): SdgReportEingabewertDto {
        data = typeof data === 'object' ? data : {};
        let result = new SdgReportEingabewertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["variable"] = this.variable;
        data["bezeichnung"] = this.bezeichnung;
        data["einheit"] = this.einheit;
        data["verknuepft"] = this.verknuepft;
        if (this.werteByJahr) {
            data["werteByJahr"] = {};
            for (let key in this.werteByJahr) {
                if (this.werteByJahr.hasOwnProperty(key))
                    (<any>data["werteByJahr"])[key] = (<any>this.werteByJahr)[key];
            }
        }
        return data;
    }
}

export interface ISdgReportEingabewertDto {
    variable?: string | undefined;
    bezeichnung?: string | undefined;
    einheit?: string | undefined;
    verknuepft?: boolean;
    werteByJahr?: { [key: string]: number; } | undefined;
}

export class SdgReportGruppeDto implements ISdgReportGruppeDto {
    sdgNummer?: number;
    sdgBezeichnung?: string | undefined;
    teilziele?: SdgReportTeilzielDto[] | undefined;

    constructor(data?: ISdgReportGruppeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sdgNummer = _data["sdgNummer"];
            this.sdgBezeichnung = _data["sdgBezeichnung"];
            if (Array.isArray(_data["teilziele"])) {
                this.teilziele = [] as any;
                for (let item of _data["teilziele"])
                    this.teilziele!.push(SdgReportTeilzielDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SdgReportGruppeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SdgReportGruppeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sdgNummer"] = this.sdgNummer;
        data["sdgBezeichnung"] = this.sdgBezeichnung;
        if (Array.isArray(this.teilziele)) {
            data["teilziele"] = [];
            for (let item of this.teilziele)
                data["teilziele"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISdgReportGruppeDto {
    sdgNummer?: number;
    sdgBezeichnung?: string | undefined;
    teilziele?: SdgReportTeilzielDto[] | undefined;
}

export class SdgReportIndikatorDto implements ISdgReportIndikatorDto {
    id?: number;
    indikatorNr?: number;
    bezeichnung?: string | undefined;
    einheit?: string | undefined;
    werteByJahr?: { [key: string]: number; } | undefined;
    berechnungsformelKlartext?: string | undefined;
    validitaet?: string | undefined;
    verstaendlichkeit?: string | undefined;
    datenverfuegbarkeit?: string | undefined;
    datenqualitaet?: string | undefined;
    funktion?: string | undefined;
    typ?: string | undefined;
    zielwert?: number | undefined;
    richtung?: string | undefined;
    schwelleProzent?: number | undefined;
    status?: string | undefined;
    eingabewerte?: SdgReportEingabewertDto[] | undefined;

    constructor(data?: ISdgReportIndikatorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.indikatorNr = _data["indikatorNr"];
            this.bezeichnung = _data["bezeichnung"];
            this.einheit = _data["einheit"];
            if (_data["werteByJahr"]) {
                this.werteByJahr = {} as any;
                for (let key in _data["werteByJahr"]) {
                    if (_data["werteByJahr"].hasOwnProperty(key))
                        (<any>this.werteByJahr)![key] = _data["werteByJahr"][key];
                }
            }
            this.berechnungsformelKlartext = _data["berechnungsformelKlartext"];
            this.validitaet = _data["validitaet"];
            this.verstaendlichkeit = _data["verstaendlichkeit"];
            this.datenverfuegbarkeit = _data["datenverfuegbarkeit"];
            this.datenqualitaet = _data["datenqualitaet"];
            this.funktion = _data["funktion"];
            this.typ = _data["typ"];
            this.zielwert = _data["zielwert"];
            this.richtung = _data["richtung"];
            this.schwelleProzent = _data["schwelleProzent"];
            this.status = _data["status"];
            if (Array.isArray(_data["eingabewerte"])) {
                this.eingabewerte = [] as any;
                for (let item of _data["eingabewerte"])
                    this.eingabewerte!.push(SdgReportEingabewertDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SdgReportIndikatorDto {
        data = typeof data === 'object' ? data : {};
        let result = new SdgReportIndikatorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["indikatorNr"] = this.indikatorNr;
        data["bezeichnung"] = this.bezeichnung;
        data["einheit"] = this.einheit;
        if (this.werteByJahr) {
            data["werteByJahr"] = {};
            for (let key in this.werteByJahr) {
                if (this.werteByJahr.hasOwnProperty(key))
                    (<any>data["werteByJahr"])[key] = (<any>this.werteByJahr)[key];
            }
        }
        data["berechnungsformelKlartext"] = this.berechnungsformelKlartext;
        data["validitaet"] = this.validitaet;
        data["verstaendlichkeit"] = this.verstaendlichkeit;
        data["datenverfuegbarkeit"] = this.datenverfuegbarkeit;
        data["datenqualitaet"] = this.datenqualitaet;
        data["funktion"] = this.funktion;
        data["typ"] = this.typ;
        data["zielwert"] = this.zielwert;
        data["richtung"] = this.richtung;
        data["schwelleProzent"] = this.schwelleProzent;
        data["status"] = this.status;
        if (Array.isArray(this.eingabewerte)) {
            data["eingabewerte"] = [];
            for (let item of this.eingabewerte)
                data["eingabewerte"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISdgReportIndikatorDto {
    id?: number;
    indikatorNr?: number;
    bezeichnung?: string | undefined;
    einheit?: string | undefined;
    werteByJahr?: { [key: string]: number; } | undefined;
    berechnungsformelKlartext?: string | undefined;
    validitaet?: string | undefined;
    verstaendlichkeit?: string | undefined;
    datenverfuegbarkeit?: string | undefined;
    datenqualitaet?: string | undefined;
    funktion?: string | undefined;
    typ?: string | undefined;
    zielwert?: number | undefined;
    richtung?: string | undefined;
    schwelleProzent?: number | undefined;
    status?: string | undefined;
    eingabewerte?: SdgReportEingabewertDto[] | undefined;
}

export class SdgReportTeilzielDto implements ISdgReportTeilzielDto {
    teilzielNr?: string | undefined;
    teilzielText?: string | undefined;
    indikatoren?: SdgReportIndikatorDto[] | undefined;

    constructor(data?: ISdgReportTeilzielDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teilzielNr = _data["teilzielNr"];
            this.teilzielText = _data["teilzielText"];
            if (Array.isArray(_data["indikatoren"])) {
                this.indikatoren = [] as any;
                for (let item of _data["indikatoren"])
                    this.indikatoren!.push(SdgReportIndikatorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SdgReportTeilzielDto {
        data = typeof data === 'object' ? data : {};
        let result = new SdgReportTeilzielDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teilzielNr"] = this.teilzielNr;
        data["teilzielText"] = this.teilzielText;
        if (Array.isArray(this.indikatoren)) {
            data["indikatoren"] = [];
            for (let item of this.indikatoren)
                data["indikatoren"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISdgReportTeilzielDto {
    teilzielNr?: string | undefined;
    teilzielText?: string | undefined;
    indikatoren?: SdgReportIndikatorDto[] | undefined;
}

export class SdgWappenInfoDto implements ISdgWappenInfoDto {
    datei?: string | undefined;
    quelle?: string | undefined;
    artikel?: string | undefined;
    wikidataId?: string | undefined;
    lizenz?: string | undefined;
    urheber?: string | undefined;
    namensnennung?: boolean;
    contentType?: string | undefined;
    breite?: number;
    hoehe?: number;
    abgerufenAm?: Date;
    stand?: string | undefined;

    constructor(data?: ISdgWappenInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datei = _data["datei"];
            this.quelle = _data["quelle"];
            this.artikel = _data["artikel"];
            this.wikidataId = _data["wikidataId"];
            this.lizenz = _data["lizenz"];
            this.urheber = _data["urheber"];
            this.namensnennung = _data["namensnennung"];
            this.contentType = _data["contentType"];
            this.breite = _data["breite"];
            this.hoehe = _data["hoehe"];
            this.abgerufenAm = _data["abgerufenAm"] ? new Date(_data["abgerufenAm"].toString()) : <any>undefined;
            this.stand = _data["stand"];
        }
    }

    static fromJS(data: any): SdgWappenInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new SdgWappenInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datei"] = this.datei;
        data["quelle"] = this.quelle;
        data["artikel"] = this.artikel;
        data["wikidataId"] = this.wikidataId;
        data["lizenz"] = this.lizenz;
        data["urheber"] = this.urheber;
        data["namensnennung"] = this.namensnennung;
        data["contentType"] = this.contentType;
        data["breite"] = this.breite;
        data["hoehe"] = this.hoehe;
        data["abgerufenAm"] = this.abgerufenAm ? this.abgerufenAm.toISOString() : <any>undefined;
        data["stand"] = this.stand;
        return data;
    }
}

export interface ISdgWappenInfoDto {
    datei?: string | undefined;
    quelle?: string | undefined;
    artikel?: string | undefined;
    wikidataId?: string | undefined;
    lizenz?: string | undefined;
    urheber?: string | undefined;
    namensnennung?: boolean;
    contentType?: string | undefined;
    breite?: number;
    hoehe?: number;
    abgerufenAm?: Date;
    stand?: string | undefined;
}

export class SdgWappenKandidatDto implements ISdgWappenKandidatDto {
    wikidataId?: string | undefined;
    titel?: string | undefined;
    beschreibung?: string | undefined;
    artikel?: string | undefined;
    datei?: string | undefined;
    ags?: string | undefined;
    format?: string | undefined;
    breite?: number;
    hoehe?: number;
    lizenz?: string | undefined;
    urheber?: string | undefined;
    namensnennung?: boolean;
    quelle?: string | undefined;
    vorschau?: string | undefined;
    transparent?: boolean | undefined;
    empfohlen?: boolean;
    hinweis?: string | undefined;

    constructor(data?: ISdgWappenKandidatDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wikidataId = _data["wikidataId"];
            this.titel = _data["titel"];
            this.beschreibung = _data["beschreibung"];
            this.artikel = _data["artikel"];
            this.datei = _data["datei"];
            this.ags = _data["ags"];
            this.format = _data["format"];
            this.breite = _data["breite"];
            this.hoehe = _data["hoehe"];
            this.lizenz = _data["lizenz"];
            this.urheber = _data["urheber"];
            this.namensnennung = _data["namensnennung"];
            this.quelle = _data["quelle"];
            this.vorschau = _data["vorschau"];
            this.transparent = _data["transparent"];
            this.empfohlen = _data["empfohlen"];
            this.hinweis = _data["hinweis"];
        }
    }

    static fromJS(data: any): SdgWappenKandidatDto {
        data = typeof data === 'object' ? data : {};
        let result = new SdgWappenKandidatDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wikidataId"] = this.wikidataId;
        data["titel"] = this.titel;
        data["beschreibung"] = this.beschreibung;
        data["artikel"] = this.artikel;
        data["datei"] = this.datei;
        data["ags"] = this.ags;
        data["format"] = this.format;
        data["breite"] = this.breite;
        data["hoehe"] = this.hoehe;
        data["lizenz"] = this.lizenz;
        data["urheber"] = this.urheber;
        data["namensnennung"] = this.namensnennung;
        data["quelle"] = this.quelle;
        data["vorschau"] = this.vorschau;
        data["transparent"] = this.transparent;
        data["empfohlen"] = this.empfohlen;
        data["hinweis"] = this.hinweis;
        return data;
    }
}

export interface ISdgWappenKandidatDto {
    wikidataId?: string | undefined;
    titel?: string | undefined;
    beschreibung?: string | undefined;
    artikel?: string | undefined;
    datei?: string | undefined;
    ags?: string | undefined;
    format?: string | undefined;
    breite?: number;
    hoehe?: number;
    lizenz?: string | undefined;
    urheber?: string | undefined;
    namensnennung?: boolean;
    quelle?: string | undefined;
    vorschau?: string | undefined;
    transparent?: boolean | undefined;
    empfohlen?: boolean;
    hinweis?: string | undefined;
}

export class SdgWappenSucheDto implements ISdgWappenSucheDto {
    suchbegriff?: string | undefined;
    bundesland?: string | undefined;
    kandidaten?: SdgWappenKandidatDto[] | undefined;

    constructor(data?: ISdgWappenSucheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.suchbegriff = _data["suchbegriff"];
            this.bundesland = _data["bundesland"];
            if (Array.isArray(_data["kandidaten"])) {
                this.kandidaten = [] as any;
                for (let item of _data["kandidaten"])
                    this.kandidaten!.push(SdgWappenKandidatDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SdgWappenSucheDto {
        data = typeof data === 'object' ? data : {};
        let result = new SdgWappenSucheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["suchbegriff"] = this.suchbegriff;
        data["bundesland"] = this.bundesland;
        if (Array.isArray(this.kandidaten)) {
            data["kandidaten"] = [];
            for (let item of this.kandidaten)
                data["kandidaten"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISdgWappenSucheDto {
    suchbegriff?: string | undefined;
    bundesland?: string | undefined;
    kandidaten?: SdgWappenKandidatDto[] | undefined;
}

export class SdgWappenUebernahmeDto implements ISdgWappenUebernahmeDto {
    kunde?: number;
    gemeinde?: number;
    datei?: string | undefined;
    wikidataId?: string | undefined;
    artikel?: string | undefined;

    constructor(data?: ISdgWappenUebernahmeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.datei = _data["datei"];
            this.wikidataId = _data["wikidataId"];
            this.artikel = _data["artikel"];
        }
    }

    static fromJS(data: any): SdgWappenUebernahmeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SdgWappenUebernahmeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["datei"] = this.datei;
        data["wikidataId"] = this.wikidataId;
        data["artikel"] = this.artikel;
        return data;
    }
}

export interface ISdgWappenUebernahmeDto {
    kunde?: number;
    gemeinde?: number;
    datei?: string | undefined;
    wikidataId?: string | undefined;
    artikel?: string | undefined;
}

export class SetPlanVorschagTermsDoppischModel implements ISetPlanVorschagTermsDoppischModel {
    plantyp?: number;
    planstufe?: number;
    ansatzPjTerm?: string | undefined;
    hhspList?: HHSPlanDoppischModel[] | undefined;
    mnpList?: MNPlanDoppischModel[] | undefined;

    constructor(data?: ISetPlanVorschagTermsDoppischModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plantyp = _data["plantyp"];
            this.planstufe = _data["planstufe"];
            this.ansatzPjTerm = _data["ansatzPjTerm"];
            if (Array.isArray(_data["hhspList"])) {
                this.hhspList = [] as any;
                for (let item of _data["hhspList"])
                    this.hhspList!.push(HHSPlanDoppischModel.fromJS(item));
            }
            if (Array.isArray(_data["mnpList"])) {
                this.mnpList = [] as any;
                for (let item of _data["mnpList"])
                    this.mnpList!.push(MNPlanDoppischModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SetPlanVorschagTermsDoppischModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetPlanVorschagTermsDoppischModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plantyp"] = this.plantyp;
        data["planstufe"] = this.planstufe;
        data["ansatzPjTerm"] = this.ansatzPjTerm;
        if (Array.isArray(this.hhspList)) {
            data["hhspList"] = [];
            for (let item of this.hhspList)
                data["hhspList"].push(item.toJSON());
        }
        if (Array.isArray(this.mnpList)) {
            data["mnpList"] = [];
            for (let item of this.mnpList)
                data["mnpList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISetPlanVorschagTermsDoppischModel {
    plantyp?: number;
    planstufe?: number;
    ansatzPjTerm?: string | undefined;
    hhspList?: HHSPlanDoppischModel[] | undefined;
    mnpList?: MNPlanDoppischModel[] | undefined;
}

export class SettingsModel implements ISettingsModel {
    kiBotHandbuchBA?: boolean;
    kiBotHandbuchVA?: boolean;
    kiBotHaushaltBA?: boolean;
    kiBotHaushaltVA?: boolean;
    doppelhaushalt?: boolean;
    buchungsart?: number;
    bundesland?: string | undefined;
    berichtErstellenAnzeigen?: boolean;
    ttTexte?: TextModel[] | undefined;
    tabTexte?: TextModel[] | undefined;
    changeSettings?: ChangeSetting;
    hFarbePJ?: string | undefined;
    hFarbeSumPJ?: string | undefined;
    vFarbePJ?: string | undefined;
    hFarbeJR?: string | undefined;
    hFarbeSumJR?: string | undefined;
    vFarbeJR?: string | undefined;
    vvjVorl?: boolean;
    vvjIstAnsatz?: boolean;
    vorjahrVorlaeufig?: boolean;
    pjFarbenFuerBericht?: boolean;
    pjFarbenFuerHover?: boolean;
    jrFarbenFuerBericht?: boolean;
    jrFarbenFuerHover?: boolean;
    ansatzOhneDS?: boolean;
    vjErgAnzHp?: boolean;
    ansatzOhneDSFuerBericht?: boolean;
    nullAchseAnzeigen?: boolean;
    nullAchseAnzeigeFuerBericht?: boolean;
    trendlinieAnzeigen?: boolean;
    pvInBa?: boolean;
    pvInVa?: boolean;
    ve?: boolean;
    pvnurAenderungen?: boolean;
    pvmarkAenderungen?: boolean;
    pvvfarbeAenderung?: string | undefined;
    pvhfarbeAenderung?: string | undefined;
    keinePrognose?: boolean;
    keinePrognoseErrechnet?: boolean;
    keinVerfuegbarEinz?: boolean;
    fortAnsVJAnz?: boolean;
    ubWinTEUR?: boolean;
    nk?: number;
    waehrung?: string | undefined;
    jrvjAus?: boolean;
    tdText?: string | undefined;
    tdFontSize?: number;
    tdLegend?: string | undefined;
    tD3d?: boolean;
    jrSettings?: JRSettingModel;
    importFormat?: number;
    mitFinanzHH?: boolean;
    kundeName?: string | undefined;
    gemeindeName?: string | undefined;
    hhStellenOeffentlich?: boolean;
    historyVW?: boolean;
    hiddenTabs?: PlanstufenHiddenTab[] | undefined;
    farben?: { [key: string]: { [key: string]: string; }; } | undefined;
    tabellenBezeichner?: { [key: string]: string; } | undefined;

    constructor(data?: ISettingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kiBotHandbuchBA = _data["kiBotHandbuchBA"];
            this.kiBotHandbuchVA = _data["kiBotHandbuchVA"];
            this.kiBotHaushaltBA = _data["kiBotHaushaltBA"];
            this.kiBotHaushaltVA = _data["kiBotHaushaltVA"];
            this.doppelhaushalt = _data["doppelhaushalt"];
            this.buchungsart = _data["buchungsart"];
            this.bundesland = _data["bundesland"];
            this.berichtErstellenAnzeigen = _data["berichtErstellenAnzeigen"];
            if (Array.isArray(_data["ttTexte"])) {
                this.ttTexte = [] as any;
                for (let item of _data["ttTexte"])
                    this.ttTexte!.push(TextModel.fromJS(item));
            }
            if (Array.isArray(_data["tabTexte"])) {
                this.tabTexte = [] as any;
                for (let item of _data["tabTexte"])
                    this.tabTexte!.push(TextModel.fromJS(item));
            }
            this.changeSettings = _data["changeSettings"] ? ChangeSetting.fromJS(_data["changeSettings"]) : <any>undefined;
            this.hFarbePJ = _data["hFarbePJ"];
            this.hFarbeSumPJ = _data["hFarbeSumPJ"];
            this.vFarbePJ = _data["vFarbePJ"];
            this.hFarbeJR = _data["hFarbeJR"];
            this.hFarbeSumJR = _data["hFarbeSumJR"];
            this.vFarbeJR = _data["vFarbeJR"];
            this.vvjVorl = _data["vvjVorl"];
            this.vvjIstAnsatz = _data["vvjIstAnsatz"];
            this.vorjahrVorlaeufig = _data["vorjahrVorlaeufig"];
            this.pjFarbenFuerBericht = _data["pjFarbenFuerBericht"];
            this.pjFarbenFuerHover = _data["pjFarbenFuerHover"];
            this.jrFarbenFuerBericht = _data["jrFarbenFuerBericht"];
            this.jrFarbenFuerHover = _data["jrFarbenFuerHover"];
            this.ansatzOhneDS = _data["ansatzOhneDS"];
            this.vjErgAnzHp = _data["vjErgAnzHp"];
            this.ansatzOhneDSFuerBericht = _data["ansatzOhneDSFuerBericht"];
            this.nullAchseAnzeigen = _data["nullAchseAnzeigen"];
            this.nullAchseAnzeigeFuerBericht = _data["nullAchseAnzeigeFuerBericht"];
            this.trendlinieAnzeigen = _data["trendlinieAnzeigen"];
            this.pvInBa = _data["pvInBa"];
            this.pvInVa = _data["pvInVa"];
            this.ve = _data["ve"];
            this.pvnurAenderungen = _data["pvnurAenderungen"];
            this.pvmarkAenderungen = _data["pvmarkAenderungen"];
            this.pvvfarbeAenderung = _data["pvvfarbeAenderung"];
            this.pvhfarbeAenderung = _data["pvhfarbeAenderung"];
            this.keinePrognose = _data["keinePrognose"];
            this.keinePrognoseErrechnet = _data["keinePrognoseErrechnet"];
            this.keinVerfuegbarEinz = _data["keinVerfuegbarEinz"];
            this.fortAnsVJAnz = _data["fortAnsVJAnz"];
            this.ubWinTEUR = _data["ubWinTEUR"];
            this.nk = _data["nk"];
            this.waehrung = _data["waehrung"];
            this.jrvjAus = _data["jrvjAus"];
            this.tdText = _data["tdText"];
            this.tdFontSize = _data["tdFontSize"];
            this.tdLegend = _data["tdLegend"];
            this.tD3d = _data["tD3d"];
            this.jrSettings = _data["jrSettings"] ? JRSettingModel.fromJS(_data["jrSettings"]) : <any>undefined;
            this.importFormat = _data["importFormat"];
            this.mitFinanzHH = _data["mitFinanzHH"];
            this.kundeName = _data["kundeName"];
            this.gemeindeName = _data["gemeindeName"];
            this.hhStellenOeffentlich = _data["hhStellenOeffentlich"];
            this.historyVW = _data["historyVW"];
            if (Array.isArray(_data["hiddenTabs"])) {
                this.hiddenTabs = [] as any;
                for (let item of _data["hiddenTabs"])
                    this.hiddenTabs!.push(PlanstufenHiddenTab.fromJS(item));
            }
            if (_data["farben"]) {
                this.farben = {} as any;
                for (let key in _data["farben"]) {
                    if (_data["farben"].hasOwnProperty(key))
                        (<any>this.farben)![key] = _data["farben"][key];
                }
            }
            if (_data["tabellenBezeichner"]) {
                this.tabellenBezeichner = {} as any;
                for (let key in _data["tabellenBezeichner"]) {
                    if (_data["tabellenBezeichner"].hasOwnProperty(key))
                        (<any>this.tabellenBezeichner)![key] = _data["tabellenBezeichner"][key];
                }
            }
        }
    }

    static fromJS(data: any): SettingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new SettingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kiBotHandbuchBA"] = this.kiBotHandbuchBA;
        data["kiBotHandbuchVA"] = this.kiBotHandbuchVA;
        data["kiBotHaushaltBA"] = this.kiBotHaushaltBA;
        data["kiBotHaushaltVA"] = this.kiBotHaushaltVA;
        data["doppelhaushalt"] = this.doppelhaushalt;
        data["buchungsart"] = this.buchungsart;
        data["bundesland"] = this.bundesland;
        data["berichtErstellenAnzeigen"] = this.berichtErstellenAnzeigen;
        if (Array.isArray(this.ttTexte)) {
            data["ttTexte"] = [];
            for (let item of this.ttTexte)
                data["ttTexte"].push(item.toJSON());
        }
        if (Array.isArray(this.tabTexte)) {
            data["tabTexte"] = [];
            for (let item of this.tabTexte)
                data["tabTexte"].push(item.toJSON());
        }
        data["changeSettings"] = this.changeSettings ? this.changeSettings.toJSON() : <any>undefined;
        data["hFarbePJ"] = this.hFarbePJ;
        data["hFarbeSumPJ"] = this.hFarbeSumPJ;
        data["vFarbePJ"] = this.vFarbePJ;
        data["hFarbeJR"] = this.hFarbeJR;
        data["hFarbeSumJR"] = this.hFarbeSumJR;
        data["vFarbeJR"] = this.vFarbeJR;
        data["vvjVorl"] = this.vvjVorl;
        data["vvjIstAnsatz"] = this.vvjIstAnsatz;
        data["vorjahrVorlaeufig"] = this.vorjahrVorlaeufig;
        data["pjFarbenFuerBericht"] = this.pjFarbenFuerBericht;
        data["pjFarbenFuerHover"] = this.pjFarbenFuerHover;
        data["jrFarbenFuerBericht"] = this.jrFarbenFuerBericht;
        data["jrFarbenFuerHover"] = this.jrFarbenFuerHover;
        data["ansatzOhneDS"] = this.ansatzOhneDS;
        data["vjErgAnzHp"] = this.vjErgAnzHp;
        data["ansatzOhneDSFuerBericht"] = this.ansatzOhneDSFuerBericht;
        data["nullAchseAnzeigen"] = this.nullAchseAnzeigen;
        data["nullAchseAnzeigeFuerBericht"] = this.nullAchseAnzeigeFuerBericht;
        data["trendlinieAnzeigen"] = this.trendlinieAnzeigen;
        data["pvInBa"] = this.pvInBa;
        data["pvInVa"] = this.pvInVa;
        data["ve"] = this.ve;
        data["pvnurAenderungen"] = this.pvnurAenderungen;
        data["pvmarkAenderungen"] = this.pvmarkAenderungen;
        data["pvvfarbeAenderung"] = this.pvvfarbeAenderung;
        data["pvhfarbeAenderung"] = this.pvhfarbeAenderung;
        data["keinePrognose"] = this.keinePrognose;
        data["keinePrognoseErrechnet"] = this.keinePrognoseErrechnet;
        data["keinVerfuegbarEinz"] = this.keinVerfuegbarEinz;
        data["fortAnsVJAnz"] = this.fortAnsVJAnz;
        data["ubWinTEUR"] = this.ubWinTEUR;
        data["nk"] = this.nk;
        data["waehrung"] = this.waehrung;
        data["jrvjAus"] = this.jrvjAus;
        data["tdText"] = this.tdText;
        data["tdFontSize"] = this.tdFontSize;
        data["tdLegend"] = this.tdLegend;
        data["tD3d"] = this.tD3d;
        data["jrSettings"] = this.jrSettings ? this.jrSettings.toJSON() : <any>undefined;
        data["importFormat"] = this.importFormat;
        data["mitFinanzHH"] = this.mitFinanzHH;
        data["kundeName"] = this.kundeName;
        data["gemeindeName"] = this.gemeindeName;
        data["hhStellenOeffentlich"] = this.hhStellenOeffentlich;
        data["historyVW"] = this.historyVW;
        if (Array.isArray(this.hiddenTabs)) {
            data["hiddenTabs"] = [];
            for (let item of this.hiddenTabs)
                data["hiddenTabs"].push(item.toJSON());
        }
        if (this.farben) {
            data["farben"] = {};
            for (let key in this.farben) {
                if (this.farben.hasOwnProperty(key))
                    (<any>data["farben"])[key] = (<any>this.farben)[key];
            }
        }
        if (this.tabellenBezeichner) {
            data["tabellenBezeichner"] = {};
            for (let key in this.tabellenBezeichner) {
                if (this.tabellenBezeichner.hasOwnProperty(key))
                    (<any>data["tabellenBezeichner"])[key] = (<any>this.tabellenBezeichner)[key];
            }
        }
        return data;
    }
}

export interface ISettingsModel {
    kiBotHandbuchBA?: boolean;
    kiBotHandbuchVA?: boolean;
    kiBotHaushaltBA?: boolean;
    kiBotHaushaltVA?: boolean;
    doppelhaushalt?: boolean;
    buchungsart?: number;
    bundesland?: string | undefined;
    berichtErstellenAnzeigen?: boolean;
    ttTexte?: TextModel[] | undefined;
    tabTexte?: TextModel[] | undefined;
    changeSettings?: ChangeSetting;
    hFarbePJ?: string | undefined;
    hFarbeSumPJ?: string | undefined;
    vFarbePJ?: string | undefined;
    hFarbeJR?: string | undefined;
    hFarbeSumJR?: string | undefined;
    vFarbeJR?: string | undefined;
    vvjVorl?: boolean;
    vvjIstAnsatz?: boolean;
    vorjahrVorlaeufig?: boolean;
    pjFarbenFuerBericht?: boolean;
    pjFarbenFuerHover?: boolean;
    jrFarbenFuerBericht?: boolean;
    jrFarbenFuerHover?: boolean;
    ansatzOhneDS?: boolean;
    vjErgAnzHp?: boolean;
    ansatzOhneDSFuerBericht?: boolean;
    nullAchseAnzeigen?: boolean;
    nullAchseAnzeigeFuerBericht?: boolean;
    trendlinieAnzeigen?: boolean;
    pvInBa?: boolean;
    pvInVa?: boolean;
    ve?: boolean;
    pvnurAenderungen?: boolean;
    pvmarkAenderungen?: boolean;
    pvvfarbeAenderung?: string | undefined;
    pvhfarbeAenderung?: string | undefined;
    keinePrognose?: boolean;
    keinePrognoseErrechnet?: boolean;
    keinVerfuegbarEinz?: boolean;
    fortAnsVJAnz?: boolean;
    ubWinTEUR?: boolean;
    nk?: number;
    waehrung?: string | undefined;
    jrvjAus?: boolean;
    tdText?: string | undefined;
    tdFontSize?: number;
    tdLegend?: string | undefined;
    tD3d?: boolean;
    jrSettings?: JRSettingModel;
    importFormat?: number;
    mitFinanzHH?: boolean;
    kundeName?: string | undefined;
    gemeindeName?: string | undefined;
    hhStellenOeffentlich?: boolean;
    historyVW?: boolean;
    hiddenTabs?: PlanstufenHiddenTab[] | undefined;
    farben?: { [key: string]: { [key: string]: string; }; } | undefined;
    tabellenBezeichner?: { [key: string]: string; } | undefined;
}

export class Size implements ISize {
    value?: number;
    unit?: Unit;

    constructor(data?: ISize) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.unit = _data["unit"];
        }
    }

    static fromJS(data: any): Size {
        data = typeof data === 'object' ? data : {};
        let result = new Size();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["unit"] = this.unit;
        return data;
    }
}

export interface ISize {
    value?: number;
    unit?: Unit;
}

export class SpeicherortModel implements ISpeicherortModel {
    was?: string | undefined;
    ort?: string | undefined;
    hinweis?: string | undefined;
    inBenutzung?: boolean;

    constructor(data?: ISpeicherortModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.was = _data["was"];
            this.ort = _data["ort"];
            this.hinweis = _data["hinweis"];
            this.inBenutzung = _data["inBenutzung"];
        }
    }

    static fromJS(data: any): SpeicherortModel {
        data = typeof data === 'object' ? data : {};
        let result = new SpeicherortModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["was"] = this.was;
        data["ort"] = this.ort;
        data["hinweis"] = this.hinweis;
        data["inBenutzung"] = this.inBenutzung;
        return data;
    }
}

export interface ISpeicherortModel {
    was?: string | undefined;
    ort?: string | undefined;
    hinweis?: string | undefined;
    inBenutzung?: boolean;
}

export class SprachToken implements ISprachToken {
    token?: string | undefined;
    region?: string | undefined;

    constructor(data?: ISprachToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.region = _data["region"];
        }
    }

    static fromJS(data: any): SprachToken {
        data = typeof data === 'object' ? data : {};
        let result = new SprachToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["region"] = this.region;
        return data;
    }
}

export interface ISprachToken {
    token?: string | undefined;
    region?: string | undefined;
}

export class TabLevelColors implements ITabLevelColors {
    activeColor?: string | undefined;
    inactiveColor?: string | undefined;
    hoverColor?: string | undefined;
    activeBgColor?: string | undefined;
    inactiveBgColor?: string | undefined;
    hoverBgColor?: string | undefined;

    constructor(data?: ITabLevelColors) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeColor = _data["activeColor"];
            this.inactiveColor = _data["inactiveColor"];
            this.hoverColor = _data["hoverColor"];
            this.activeBgColor = _data["activeBgColor"];
            this.inactiveBgColor = _data["inactiveBgColor"];
            this.hoverBgColor = _data["hoverBgColor"];
        }
    }

    static fromJS(data: any): TabLevelColors {
        data = typeof data === 'object' ? data : {};
        let result = new TabLevelColors();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeColor"] = this.activeColor;
        data["inactiveColor"] = this.inactiveColor;
        data["hoverColor"] = this.hoverColor;
        data["activeBgColor"] = this.activeBgColor;
        data["inactiveBgColor"] = this.inactiveBgColor;
        data["hoverBgColor"] = this.hoverBgColor;
        return data;
    }
}

export interface ITabLevelColors {
    activeColor?: string | undefined;
    inactiveColor?: string | undefined;
    hoverColor?: string | undefined;
    activeBgColor?: string | undefined;
    inactiveBgColor?: string | undefined;
    hoverBgColor?: string | undefined;
}

export class TabStop implements ITabStop {
    position?: string | undefined;
    type?: TabStopType;
    delimiter?: string | undefined;
    leaderLineType?: LineType;
    leaderLineStyle?: LineStyle;
    leaderLineWidth?: string | undefined;
    leaderLineColor?: string | undefined;
    leaderText?: string | undefined;
    leaderTextStyle?: string | undefined;

    constructor(data?: ITabStop) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.position = _data["position"];
            this.type = _data["type"];
            this.delimiter = _data["delimiter"];
            this.leaderLineType = _data["leaderLineType"];
            this.leaderLineStyle = _data["leaderLineStyle"];
            this.leaderLineWidth = _data["leaderLineWidth"];
            this.leaderLineColor = _data["leaderLineColor"];
            this.leaderText = _data["leaderText"];
            this.leaderTextStyle = _data["leaderTextStyle"];
        }
    }

    static fromJS(data: any): TabStop {
        data = typeof data === 'object' ? data : {};
        let result = new TabStop();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["type"] = this.type;
        data["delimiter"] = this.delimiter;
        data["leaderLineType"] = this.leaderLineType;
        data["leaderLineStyle"] = this.leaderLineStyle;
        data["leaderLineWidth"] = this.leaderLineWidth;
        data["leaderLineColor"] = this.leaderLineColor;
        data["leaderText"] = this.leaderText;
        data["leaderTextStyle"] = this.leaderTextStyle;
        return data;
    }
}

export interface ITabStop {
    position?: string | undefined;
    type?: TabStopType;
    delimiter?: string | undefined;
    leaderLineType?: LineType;
    leaderLineStyle?: LineStyle;
    leaderLineWidth?: string | undefined;
    leaderLineColor?: string | undefined;
    leaderText?: string | undefined;
    leaderTextStyle?: string | undefined;
}

export enum TabStopType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class TabTextBezeichnungsOptionen implements ITabTextBezeichnungsOptionen {
    id?: number;
    bezeichnung?: string | undefined;
    text?: string | undefined;
    doppisch?: boolean;
    order?: number;

    constructor(data?: ITabTextBezeichnungsOptionen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
            this.text = _data["text"];
            this.doppisch = _data["doppisch"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): TabTextBezeichnungsOptionen {
        data = typeof data === 'object' ? data : {};
        let result = new TabTextBezeichnungsOptionen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        data["text"] = this.text;
        data["doppisch"] = this.doppisch;
        data["order"] = this.order;
        return data;
    }
}

export interface ITabTextBezeichnungsOptionen {
    id?: number;
    bezeichnung?: string | undefined;
    text?: string | undefined;
    doppisch?: boolean;
    order?: number;
}

export class TabellenBezeichner implements ITabellenBezeichner {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    typ?: number;
    bezeichnung?: string | undefined;
    altText?: string | undefined;

    constructor(data?: ITabellenBezeichner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.typ = _data["typ"];
            this.bezeichnung = _data["bezeichnung"];
            this.altText = _data["altText"];
        }
    }

    static fromJS(data: any): TabellenBezeichner {
        data = typeof data === 'object' ? data : {};
        let result = new TabellenBezeichner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["typ"] = this.typ;
        data["bezeichnung"] = this.bezeichnung;
        data["altText"] = this.altText;
        return data;
    }
}

export interface ITabellenBezeichner {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    typ?: number;
    bezeichnung?: string | undefined;
    altText?: string | undefined;
}

export class TabellenEinstellungen implements ITabellenEinstellungen {
    breite?: number;
    breiteSpalte1?: number;
    kopfzeile1Spalte1?: string | undefined;
    kopfzeile2Spalte1?: string | undefined;
    kopfzeile1?: string | undefined;
    kopfzeile2?: string | undefined;
    divisor?: number;
    keinDivEinw?: boolean;
    kopfzeile1Einw?: string | undefined;
    kopfzeile2Einw?: string | undefined;
    veraenderungsPfeil?: boolean;
    veraenderungProzent?: boolean;
    veraenderungAbs?: boolean;
    veraenderungAbsNurPj?: boolean;
    quote?: number;
    mitZeilenNr?: boolean;
    inklusiveAnsatzFort?: boolean;
    inklusiveAnsatzFortDetails?: boolean;
    inklusiveVerfuegt?: boolean;
    inklusiveVerfuegtRel?: boolean;
    inklusiveVerfuegbar?: boolean;
    inklusiveVerfuegbarRel?: boolean;
    inklusiveProgAuto?: boolean;
    inklusiveIstAO?: boolean;
    breiteKommentar?: number;
    inklusiveProgManKomm?: boolean;
    sortierung?: number;
    progManFilter?: number;
    topEAType?: number;
    vjErg?: boolean;
    fullHHSBez?: boolean;
    sumHHS?: boolean;
    filter?: number;
    filterGrenze?: number;
    freiGrenze?: number | undefined;
    showHHS?: boolean;
    erlaeuterungen?: boolean;
    nurAenderungen?: boolean;

    constructor(data?: ITabellenEinstellungen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breite = _data["breite"];
            this.breiteSpalte1 = _data["breiteSpalte1"];
            this.kopfzeile1Spalte1 = _data["kopfzeile1Spalte1"];
            this.kopfzeile2Spalte1 = _data["kopfzeile2Spalte1"];
            this.kopfzeile1 = _data["kopfzeile1"];
            this.kopfzeile2 = _data["kopfzeile2"];
            this.divisor = _data["divisor"];
            this.keinDivEinw = _data["keinDivEinw"];
            this.kopfzeile1Einw = _data["kopfzeile1Einw"];
            this.kopfzeile2Einw = _data["kopfzeile2Einw"];
            this.veraenderungsPfeil = _data["veraenderungsPfeil"];
            this.veraenderungProzent = _data["veraenderungProzent"];
            this.veraenderungAbs = _data["veraenderungAbs"];
            this.veraenderungAbsNurPj = _data["veraenderungAbsNurPj"];
            this.quote = _data["quote"];
            this.mitZeilenNr = _data["mitZeilenNr"];
            this.inklusiveAnsatzFort = _data["inklusiveAnsatzFort"];
            this.inklusiveAnsatzFortDetails = _data["inklusiveAnsatzFortDetails"];
            this.inklusiveVerfuegt = _data["inklusiveVerfuegt"];
            this.inklusiveVerfuegtRel = _data["inklusiveVerfuegtRel"];
            this.inklusiveVerfuegbar = _data["inklusiveVerfuegbar"];
            this.inklusiveVerfuegbarRel = _data["inklusiveVerfuegbarRel"];
            this.inklusiveProgAuto = _data["inklusiveProgAuto"];
            this.inklusiveIstAO = _data["inklusiveIstAO"];
            this.breiteKommentar = _data["breiteKommentar"];
            this.inklusiveProgManKomm = _data["inklusiveProgManKomm"];
            this.sortierung = _data["sortierung"];
            this.progManFilter = _data["progManFilter"];
            this.topEAType = _data["topEAType"];
            this.vjErg = _data["vjErg"];
            this.fullHHSBez = _data["fullHHSBez"];
            this.sumHHS = _data["sumHHS"];
            this.filter = _data["filter"];
            this.filterGrenze = _data["filterGrenze"];
            this.freiGrenze = _data["freiGrenze"];
            this.showHHS = _data["showHHS"];
            this.erlaeuterungen = _data["erlaeuterungen"];
            this.nurAenderungen = _data["nurAenderungen"];
        }
    }

    static fromJS(data: any): TabellenEinstellungen {
        data = typeof data === 'object' ? data : {};
        let result = new TabellenEinstellungen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breite"] = this.breite;
        data["breiteSpalte1"] = this.breiteSpalte1;
        data["kopfzeile1Spalte1"] = this.kopfzeile1Spalte1;
        data["kopfzeile2Spalte1"] = this.kopfzeile2Spalte1;
        data["kopfzeile1"] = this.kopfzeile1;
        data["kopfzeile2"] = this.kopfzeile2;
        data["divisor"] = this.divisor;
        data["keinDivEinw"] = this.keinDivEinw;
        data["kopfzeile1Einw"] = this.kopfzeile1Einw;
        data["kopfzeile2Einw"] = this.kopfzeile2Einw;
        data["veraenderungsPfeil"] = this.veraenderungsPfeil;
        data["veraenderungProzent"] = this.veraenderungProzent;
        data["veraenderungAbs"] = this.veraenderungAbs;
        data["veraenderungAbsNurPj"] = this.veraenderungAbsNurPj;
        data["quote"] = this.quote;
        data["mitZeilenNr"] = this.mitZeilenNr;
        data["inklusiveAnsatzFort"] = this.inklusiveAnsatzFort;
        data["inklusiveAnsatzFortDetails"] = this.inklusiveAnsatzFortDetails;
        data["inklusiveVerfuegt"] = this.inklusiveVerfuegt;
        data["inklusiveVerfuegtRel"] = this.inklusiveVerfuegtRel;
        data["inklusiveVerfuegbar"] = this.inklusiveVerfuegbar;
        data["inklusiveVerfuegbarRel"] = this.inklusiveVerfuegbarRel;
        data["inklusiveProgAuto"] = this.inklusiveProgAuto;
        data["inklusiveIstAO"] = this.inklusiveIstAO;
        data["breiteKommentar"] = this.breiteKommentar;
        data["inklusiveProgManKomm"] = this.inklusiveProgManKomm;
        data["sortierung"] = this.sortierung;
        data["progManFilter"] = this.progManFilter;
        data["topEAType"] = this.topEAType;
        data["vjErg"] = this.vjErg;
        data["fullHHSBez"] = this.fullHHSBez;
        data["sumHHS"] = this.sumHHS;
        data["filter"] = this.filter;
        data["filterGrenze"] = this.filterGrenze;
        data["freiGrenze"] = this.freiGrenze;
        data["showHHS"] = this.showHHS;
        data["erlaeuterungen"] = this.erlaeuterungen;
        data["nurAenderungen"] = this.nurAenderungen;
        return data;
    }
}

export interface ITabellenEinstellungen {
    breite?: number;
    breiteSpalte1?: number;
    kopfzeile1Spalte1?: string | undefined;
    kopfzeile2Spalte1?: string | undefined;
    kopfzeile1?: string | undefined;
    kopfzeile2?: string | undefined;
    divisor?: number;
    keinDivEinw?: boolean;
    kopfzeile1Einw?: string | undefined;
    kopfzeile2Einw?: string | undefined;
    veraenderungsPfeil?: boolean;
    veraenderungProzent?: boolean;
    veraenderungAbs?: boolean;
    veraenderungAbsNurPj?: boolean;
    quote?: number;
    mitZeilenNr?: boolean;
    inklusiveAnsatzFort?: boolean;
    inklusiveAnsatzFortDetails?: boolean;
    inklusiveVerfuegt?: boolean;
    inklusiveVerfuegtRel?: boolean;
    inklusiveVerfuegbar?: boolean;
    inklusiveVerfuegbarRel?: boolean;
    inklusiveProgAuto?: boolean;
    inklusiveIstAO?: boolean;
    breiteKommentar?: number;
    inklusiveProgManKomm?: boolean;
    sortierung?: number;
    progManFilter?: number;
    topEAType?: number;
    vjErg?: boolean;
    fullHHSBez?: boolean;
    sumHHS?: boolean;
    filter?: number;
    filterGrenze?: number;
    freiGrenze?: number | undefined;
    showHHS?: boolean;
    erlaeuterungen?: boolean;
    nurAenderungen?: boolean;
}

export class TabellenSpalte implements ITabellenSpalte {
    titel?: string | undefined;
    typ?: string | undefined;
    jahr?: number;
    vonJahr?: number;
    art?: string | undefined;
    einheit?: string | undefined;
    hauptreihe?: boolean;

    constructor(data?: ITabellenSpalte) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titel = _data["titel"];
            this.typ = _data["typ"];
            this.jahr = _data["jahr"];
            this.vonJahr = _data["vonJahr"];
            this.art = _data["art"];
            this.einheit = _data["einheit"];
            this.hauptreihe = _data["hauptreihe"];
        }
    }

    static fromJS(data: any): TabellenSpalte {
        data = typeof data === 'object' ? data : {};
        let result = new TabellenSpalte();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titel"] = this.titel;
        data["typ"] = this.typ;
        data["jahr"] = this.jahr;
        data["vonJahr"] = this.vonJahr;
        data["art"] = this.art;
        data["einheit"] = this.einheit;
        data["hauptreihe"] = this.hauptreihe;
        return data;
    }
}

export interface ITabellenSpalte {
    titel?: string | undefined;
    typ?: string | undefined;
    jahr?: number;
    vonJahr?: number;
    art?: string | undefined;
    einheit?: string | undefined;
    hauptreihe?: boolean;
}

export class TabellenZelle implements ITabellenZelle {
    wert?: number | undefined;
    text?: string | undefined;
    anzeige?: string | undefined;

    constructor(data?: ITabellenZelle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wert = _data["wert"];
            this.text = _data["text"];
            this.anzeige = _data["anzeige"];
        }
    }

    static fromJS(data: any): TabellenZelle {
        data = typeof data === 'object' ? data : {};
        let result = new TabellenZelle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wert"] = this.wert;
        data["text"] = this.text;
        data["anzeige"] = this.anzeige;
        return data;
    }
}

export interface ITabellenZelle {
    wert?: number | undefined;
    text?: string | undefined;
    anzeige?: string | undefined;
}

export class TemplateAbweichungen implements ITemplateAbweichungen {
    typ?: number;
    zeilenAbweichungen?: TemplateAbweichungenZeile[] | undefined;

    constructor(data?: ITemplateAbweichungen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typ = _data["typ"];
            if (Array.isArray(_data["zeilenAbweichungen"])) {
                this.zeilenAbweichungen = [] as any;
                for (let item of _data["zeilenAbweichungen"])
                    this.zeilenAbweichungen!.push(TemplateAbweichungenZeile.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TemplateAbweichungen {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateAbweichungen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typ"] = this.typ;
        if (Array.isArray(this.zeilenAbweichungen)) {
            data["zeilenAbweichungen"] = [];
            for (let item of this.zeilenAbweichungen)
                data["zeilenAbweichungen"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITemplateAbweichungen {
    typ?: number;
    zeilenAbweichungen?: TemplateAbweichungenZeile[] | undefined;
}

export class TemplateAbweichungenGemeinde implements ITemplateAbweichungenGemeinde {
    kunde?: number;
    kundenName?: string | undefined;
    gemeindenName?: string | undefined;
    gemeinde?: number;
    jahr?: number;
    bundesland?: string | undefined;
    abweichungen?: TemplateAbweichungen[] | undefined;

    constructor(data?: ITemplateAbweichungenGemeinde) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.kundenName = _data["kundenName"];
            this.gemeindenName = _data["gemeindenName"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.bundesland = _data["bundesland"];
            if (Array.isArray(_data["abweichungen"])) {
                this.abweichungen = [] as any;
                for (let item of _data["abweichungen"])
                    this.abweichungen!.push(TemplateAbweichungen.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TemplateAbweichungenGemeinde {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateAbweichungenGemeinde();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["kundenName"] = this.kundenName;
        data["gemeindenName"] = this.gemeindenName;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["bundesland"] = this.bundesland;
        if (Array.isArray(this.abweichungen)) {
            data["abweichungen"] = [];
            for (let item of this.abweichungen)
                data["abweichungen"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITemplateAbweichungenGemeinde {
    kunde?: number;
    kundenName?: string | undefined;
    gemeindenName?: string | undefined;
    gemeinde?: number;
    jahr?: number;
    bundesland?: string | undefined;
    abweichungen?: TemplateAbweichungen[] | undefined;
}

export class TemplateAbweichungenZeile implements ITemplateAbweichungenZeile {
    zeile?: string | undefined;
    zeilenTemplate?: HaushaltsZeilenTemplate;
    zeilenInfo?: TemplateZeilenInfo;

    constructor(data?: ITemplateAbweichungenZeile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zeile = _data["zeile"];
            this.zeilenTemplate = _data["zeilenTemplate"] ? HaushaltsZeilenTemplate.fromJS(_data["zeilenTemplate"]) : <any>undefined;
            this.zeilenInfo = _data["zeilenInfo"] ? TemplateZeilenInfo.fromJS(_data["zeilenInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TemplateAbweichungenZeile {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateAbweichungenZeile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zeile"] = this.zeile;
        data["zeilenTemplate"] = this.zeilenTemplate ? this.zeilenTemplate.toJSON() : <any>undefined;
        data["zeilenInfo"] = this.zeilenInfo ? this.zeilenInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITemplateAbweichungenZeile {
    zeile?: string | undefined;
    zeilenTemplate?: HaushaltsZeilenTemplate;
    zeilenInfo?: TemplateZeilenInfo;
}

export class TemplateKennzahlen implements ITemplateKennzahlen {
    id?: number;
    bezeichnung?: string | undefined;
    beschreibung?: string | undefined;
    darstellung?: number | undefined;
    bezeichnungDarstellung?: string | undefined;
    darstellungZusatzangaben?: number | undefined;
    bezeichnungDarstellungZusatzangaben?: string | undefined;
    bundesland?: string | undefined;
    buchungsart?: number | undefined;
    templateKennzahlzeilens?: TemplateKennzahlzeilen[] | undefined;

    constructor(data?: ITemplateKennzahlen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
            this.beschreibung = _data["beschreibung"];
            this.darstellung = _data["darstellung"];
            this.bezeichnungDarstellung = _data["bezeichnungDarstellung"];
            this.darstellungZusatzangaben = _data["darstellungZusatzangaben"];
            this.bezeichnungDarstellungZusatzangaben = _data["bezeichnungDarstellungZusatzangaben"];
            this.bundesland = _data["bundesland"];
            this.buchungsart = _data["buchungsart"];
            if (Array.isArray(_data["templateKennzahlzeilens"])) {
                this.templateKennzahlzeilens = [] as any;
                for (let item of _data["templateKennzahlzeilens"])
                    this.templateKennzahlzeilens!.push(TemplateKennzahlzeilen.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TemplateKennzahlen {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateKennzahlen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        data["beschreibung"] = this.beschreibung;
        data["darstellung"] = this.darstellung;
        data["bezeichnungDarstellung"] = this.bezeichnungDarstellung;
        data["darstellungZusatzangaben"] = this.darstellungZusatzangaben;
        data["bezeichnungDarstellungZusatzangaben"] = this.bezeichnungDarstellungZusatzangaben;
        data["bundesland"] = this.bundesland;
        data["buchungsart"] = this.buchungsart;
        if (Array.isArray(this.templateKennzahlzeilens)) {
            data["templateKennzahlzeilens"] = [];
            for (let item of this.templateKennzahlzeilens)
                data["templateKennzahlzeilens"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITemplateKennzahlen {
    id?: number;
    bezeichnung?: string | undefined;
    beschreibung?: string | undefined;
    darstellung?: number | undefined;
    bezeichnungDarstellung?: string | undefined;
    darstellungZusatzangaben?: number | undefined;
    bezeichnungDarstellungZusatzangaben?: string | undefined;
    bundesland?: string | undefined;
    buchungsart?: number | undefined;
    templateKennzahlzeilens?: TemplateKennzahlzeilen[] | undefined;
}

export class TemplateKennzahlzeilen implements ITemplateKennzahlzeilen {
    id?: number;
    kennzahl?: number;
    bezeichnung?: string | undefined;
    istBerechnung?: boolean;
    inkludierteGruppen?: string | undefined;
    exkludierteGruppen?: string | undefined;
    berechnung?: string | undefined;
    darstellung?: number | undefined;
    zusatzangabe?: number | undefined;
    darstellungZusatzangabe?: number | undefined;
    order?: number | undefined;
    subtraktionsGruppen?: string | undefined;
    einheit?: string | undefined;
    bezeichnungZusatzangabe?: string | undefined;
    gliederung?: string | undefined;
    istErgebniszeile?: boolean | undefined;
    darstellungNavigation?: Diagrammtypen;
    darstellungZusatzangabeNavigation?: Diagrammtypen;
    kennzahlNavigation?: TemplateKennzahlen;
    zusatzangabeNavigation?: Zusatzangaben;

    constructor(data?: ITemplateKennzahlzeilen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kennzahl = _data["kennzahl"];
            this.bezeichnung = _data["bezeichnung"];
            this.istBerechnung = _data["istBerechnung"];
            this.inkludierteGruppen = _data["inkludierteGruppen"];
            this.exkludierteGruppen = _data["exkludierteGruppen"];
            this.berechnung = _data["berechnung"];
            this.darstellung = _data["darstellung"];
            this.zusatzangabe = _data["zusatzangabe"];
            this.darstellungZusatzangabe = _data["darstellungZusatzangabe"];
            this.order = _data["order"];
            this.subtraktionsGruppen = _data["subtraktionsGruppen"];
            this.einheit = _data["einheit"];
            this.bezeichnungZusatzangabe = _data["bezeichnungZusatzangabe"];
            this.gliederung = _data["gliederung"];
            this.istErgebniszeile = _data["istErgebniszeile"];
            this.darstellungNavigation = _data["darstellungNavigation"] ? Diagrammtypen.fromJS(_data["darstellungNavigation"]) : <any>undefined;
            this.darstellungZusatzangabeNavigation = _data["darstellungZusatzangabeNavigation"] ? Diagrammtypen.fromJS(_data["darstellungZusatzangabeNavigation"]) : <any>undefined;
            this.kennzahlNavigation = _data["kennzahlNavigation"] ? TemplateKennzahlen.fromJS(_data["kennzahlNavigation"]) : <any>undefined;
            this.zusatzangabeNavigation = _data["zusatzangabeNavigation"] ? Zusatzangaben.fromJS(_data["zusatzangabeNavigation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TemplateKennzahlzeilen {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateKennzahlzeilen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kennzahl"] = this.kennzahl;
        data["bezeichnung"] = this.bezeichnung;
        data["istBerechnung"] = this.istBerechnung;
        data["inkludierteGruppen"] = this.inkludierteGruppen;
        data["exkludierteGruppen"] = this.exkludierteGruppen;
        data["berechnung"] = this.berechnung;
        data["darstellung"] = this.darstellung;
        data["zusatzangabe"] = this.zusatzangabe;
        data["darstellungZusatzangabe"] = this.darstellungZusatzangabe;
        data["order"] = this.order;
        data["subtraktionsGruppen"] = this.subtraktionsGruppen;
        data["einheit"] = this.einheit;
        data["bezeichnungZusatzangabe"] = this.bezeichnungZusatzangabe;
        data["gliederung"] = this.gliederung;
        data["istErgebniszeile"] = this.istErgebniszeile;
        data["darstellungNavigation"] = this.darstellungNavigation ? this.darstellungNavigation.toJSON() : <any>undefined;
        data["darstellungZusatzangabeNavigation"] = this.darstellungZusatzangabeNavigation ? this.darstellungZusatzangabeNavigation.toJSON() : <any>undefined;
        data["kennzahlNavigation"] = this.kennzahlNavigation ? this.kennzahlNavigation.toJSON() : <any>undefined;
        data["zusatzangabeNavigation"] = this.zusatzangabeNavigation ? this.zusatzangabeNavigation.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITemplateKennzahlzeilen {
    id?: number;
    kennzahl?: number;
    bezeichnung?: string | undefined;
    istBerechnung?: boolean;
    inkludierteGruppen?: string | undefined;
    exkludierteGruppen?: string | undefined;
    berechnung?: string | undefined;
    darstellung?: number | undefined;
    zusatzangabe?: number | undefined;
    darstellungZusatzangabe?: number | undefined;
    order?: number | undefined;
    subtraktionsGruppen?: string | undefined;
    einheit?: string | undefined;
    bezeichnungZusatzangabe?: string | undefined;
    gliederung?: string | undefined;
    istErgebniszeile?: boolean | undefined;
    darstellungNavigation?: Diagrammtypen;
    darstellungZusatzangabeNavigation?: Diagrammtypen;
    kennzahlNavigation?: TemplateKennzahlen;
    zusatzangabeNavigation?: Zusatzangaben;
}

export class TemplatePlatzhalter implements ITemplatePlatzhalter {
    id?: string | undefined;
    platzhalter?: string | undefined;
    text?: string | undefined;

    constructor(data?: ITemplatePlatzhalter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.platzhalter = _data["platzhalter"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): TemplatePlatzhalter {
        data = typeof data === 'object' ? data : {};
        let result = new TemplatePlatzhalter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["platzhalter"] = this.platzhalter;
        data["text"] = this.text;
        return data;
    }
}

export interface ITemplatePlatzhalter {
    id?: string | undefined;
    platzhalter?: string | undefined;
    text?: string | undefined;
}

export class TemplateZeilenInfo implements ITemplateZeilenInfo {
    id?: string | undefined;
    zeilenId?: string | undefined;
    zeile?: string | undefined;
    bezeichnung?: string | undefined;
    inkludierteKonten?: string | undefined;
    exkludierteKonten?: string | undefined;
    subtraktionsKonten?: string | undefined;
    berechnung?: string | undefined;
    datensatzTyp?: number;
    keineDetails?: boolean;
    verbergen?: boolean;
    verbergenErlauben?: boolean;
    verbergenOrg?: boolean;
    keineDetailsOrg?: boolean;
    ausgaben?: boolean | undefined;
    ausgabenOrg?: boolean;
    custom?: boolean;
    bezeichnungOrg?: string | undefined;
    inkludierteKontenOrg?: string | undefined;
    exkludierteKontenOrg?: string | undefined;
    subtraktionsKontenOrg?: string | undefined;
    berechnungOrg?: string | undefined;
    datensatzTypOrg?: number;

    constructor(data?: ITemplateZeilenInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.zeilenId = _data["zeilenId"];
            this.zeile = _data["zeile"];
            this.bezeichnung = _data["bezeichnung"];
            this.inkludierteKonten = _data["inkludierteKonten"];
            this.exkludierteKonten = _data["exkludierteKonten"];
            this.subtraktionsKonten = _data["subtraktionsKonten"];
            this.berechnung = _data["berechnung"];
            this.datensatzTyp = _data["datensatzTyp"];
            this.keineDetails = _data["keineDetails"];
            this.verbergen = _data["verbergen"];
            this.verbergenErlauben = _data["verbergenErlauben"];
            this.verbergenOrg = _data["verbergenOrg"];
            this.keineDetailsOrg = _data["keineDetailsOrg"];
            this.ausgaben = _data["ausgaben"];
            this.ausgabenOrg = _data["ausgabenOrg"];
            this.custom = _data["custom"];
            this.bezeichnungOrg = _data["bezeichnungOrg"];
            this.inkludierteKontenOrg = _data["inkludierteKontenOrg"];
            this.exkludierteKontenOrg = _data["exkludierteKontenOrg"];
            this.subtraktionsKontenOrg = _data["subtraktionsKontenOrg"];
            this.berechnungOrg = _data["berechnungOrg"];
            this.datensatzTypOrg = _data["datensatzTypOrg"];
        }
    }

    static fromJS(data: any): TemplateZeilenInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateZeilenInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["zeilenId"] = this.zeilenId;
        data["zeile"] = this.zeile;
        data["bezeichnung"] = this.bezeichnung;
        data["inkludierteKonten"] = this.inkludierteKonten;
        data["exkludierteKonten"] = this.exkludierteKonten;
        data["subtraktionsKonten"] = this.subtraktionsKonten;
        data["berechnung"] = this.berechnung;
        data["datensatzTyp"] = this.datensatzTyp;
        data["keineDetails"] = this.keineDetails;
        data["verbergen"] = this.verbergen;
        data["verbergenErlauben"] = this.verbergenErlauben;
        data["verbergenOrg"] = this.verbergenOrg;
        data["keineDetailsOrg"] = this.keineDetailsOrg;
        data["ausgaben"] = this.ausgaben;
        data["ausgabenOrg"] = this.ausgabenOrg;
        data["custom"] = this.custom;
        data["bezeichnungOrg"] = this.bezeichnungOrg;
        data["inkludierteKontenOrg"] = this.inkludierteKontenOrg;
        data["exkludierteKontenOrg"] = this.exkludierteKontenOrg;
        data["subtraktionsKontenOrg"] = this.subtraktionsKontenOrg;
        data["berechnungOrg"] = this.berechnungOrg;
        data["datensatzTypOrg"] = this.datensatzTypOrg;
        return data;
    }
}

export interface ITemplateZeilenInfo {
    id?: string | undefined;
    zeilenId?: string | undefined;
    zeile?: string | undefined;
    bezeichnung?: string | undefined;
    inkludierteKonten?: string | undefined;
    exkludierteKonten?: string | undefined;
    subtraktionsKonten?: string | undefined;
    berechnung?: string | undefined;
    datensatzTyp?: number;
    keineDetails?: boolean;
    verbergen?: boolean;
    verbergenErlauben?: boolean;
    verbergenOrg?: boolean;
    keineDetailsOrg?: boolean;
    ausgaben?: boolean | undefined;
    ausgabenOrg?: boolean;
    custom?: boolean;
    bezeichnungOrg?: string | undefined;
    inkludierteKontenOrg?: string | undefined;
    exkludierteKontenOrg?: string | undefined;
    subtraktionsKontenOrg?: string | undefined;
    berechnungOrg?: string | undefined;
    datensatzTypOrg?: number;
}

export class TemplateZeileninfoModel implements ITemplateZeileninfoModel {
    id?: number;
    bezeichnung?: string | undefined;

    constructor(data?: ITemplateZeileninfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
        }
    }

    static fromJS(data: any): TemplateZeileninfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateZeileninfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        return data;
    }
}

export interface ITemplateZeileninfoModel {
    id?: number;
    bezeichnung?: string | undefined;
}

export enum TextAlignment {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export enum TextAlignmentLastLine {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum TextAlignmentSource {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum TextAutospace {
    _0 = 0,
    _1 = 1,
}

export enum TextCombine {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class TextModel implements ITextModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    typ?: number;
    text?: string | undefined;
    bvansicht?: boolean | undefined;
    vwansicht?: boolean | undefined;
    hp?: boolean | undefined;
    jr?: boolean | undefined;
    ubw?: boolean | undefined;
    gemeinden?: Gemeinden;

    constructor(data?: ITextModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.bezeichnung = _data["bezeichnung"];
            this.typ = _data["typ"];
            this.text = _data["text"];
            this.bvansicht = _data["bvansicht"];
            this.vwansicht = _data["vwansicht"];
            this.hp = _data["hp"];
            this.jr = _data["jr"];
            this.ubw = _data["ubw"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TextModel {
        data = typeof data === 'object' ? data : {};
        let result = new TextModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["bezeichnung"] = this.bezeichnung;
        data["typ"] = this.typ;
        data["text"] = this.text;
        data["bvansicht"] = this.bvansicht;
        data["vwansicht"] = this.vwansicht;
        data["hp"] = this.hp;
        data["jr"] = this.jr;
        data["ubw"] = this.ubw;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITextModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    typ?: number;
    text?: string | undefined;
    bvansicht?: boolean | undefined;
    vwansicht?: boolean | undefined;
    hp?: boolean | undefined;
    jr?: boolean | undefined;
    ubw?: boolean | undefined;
    gemeinden?: Gemeinden;
}

export class TextPosition implements ITextPosition {
    verticalPosition?: string | undefined;
    fontHeight?: number;

    constructor(data?: ITextPosition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verticalPosition = _data["verticalPosition"];
            this.fontHeight = _data["fontHeight"];
        }
    }

    static fromJS(data: any): TextPosition {
        data = typeof data === 'object' ? data : {};
        let result = new TextPosition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verticalPosition"] = this.verticalPosition;
        data["fontHeight"] = this.fontHeight;
        return data;
    }
}

export interface ITextPosition {
    verticalPosition?: string | undefined;
    fontHeight?: number;
}

export class TextPropertiesModel implements ITextPropertiesModel {
    fontVariant?: FontVariant;
    textTransformation?: TextTransformation;
    color?: string | undefined;
    useWindowFontColor?: boolean;
    textOutline?: boolean;
    textLineThrough?: LineType;
    textLineThroughStyle?: LineStyle;
    textLineThroughWidth?: string | undefined;
    textLineThroughColor?: string | undefined;
    textLineThroughText?: string | undefined;
    textLineThroughTextStyle?: string | undefined;
    textPosition?: TextPosition;
    font?: string | undefined;
    asianFont?: string | undefined;
    complexFont?: string | undefined;
    fontStyle?: string | undefined;
    asianFontStyle?: string | undefined;
    complexFontStyle?: string | undefined;
    fontSize?: Size;
    asianFontSize?: Size;
    complexFontSize?: Size;
    relativeFontSize?: Size;
    relativeAsianFontSize?: Size;
    relativeComplexFontSize?: Size;
    country?: string | undefined;
    asianCountry?: string | undefined;
    complexCountry?: string | undefined;
    language?: string | undefined;
    asianLanguage?: string | undefined;
    complexLanguage?: string | undefined;
    fontCharacterSet?: string | undefined;
    asianFontCharacterSet?: string | undefined;
    complexFontCharacterSet?: string | undefined;
    fontPitch?: FontPitch;
    asianFontPitch?: FontPitch;
    complexFontPitch?: FontPitch;
    fontFamily?: string | undefined;
    asianFontFamily?: string | undefined;
    complexFontFamily?: string | undefined;
    fontWeight?: FontWeight;
    asianFontWeight?: FontWeight;
    complexFontWeight?: FontWeight;
    genericFontFamily?: GenericFontFamily;
    asianGenericFontFamily?: GenericFontFamily;
    complexGenericFontFamily?: GenericFontFamily;
    fontStyleType?: FontStyleType;
    asianFontStyleType?: FontStyleType;
    complexFontStyleType?: FontStyleType;
    backgroundColor?: string | undefined;
    shadow?: string | undefined;
    scriptType?: ScriptType;
    fontRelief?: FontRelief;
    underlineType?: UnderlineType;
    underlineStyle?: UnderlineStyle;
    underlineWordMode?: LineMode;
    underlineWidth?: string | undefined;
    underlineColor?: string | undefined;
    lineThroughWordMode?: LineMode;
    enableLetterKerning?: boolean;
    enableTextBlinking?: boolean;
    textCombine?: TextCombine;
    textCombineStartChar?: string;
    textCombineEndChar?: string;
    textRotationAngle?: number;
    textRotationScale?: TextRotationScale;
    enableHyphenation?: boolean;
    hyphenationRemainCharCount?: number;
    hyphenationPushCharCount?: number;
    isLetterSpacingNormal?: boolean;
    letterSpacing?: Size;
    textScale?: number;

    constructor(data?: ITextPropertiesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fontVariant = _data["fontVariant"];
            this.textTransformation = _data["textTransformation"];
            this.color = _data["color"];
            this.useWindowFontColor = _data["useWindowFontColor"];
            this.textOutline = _data["textOutline"];
            this.textLineThrough = _data["textLineThrough"];
            this.textLineThroughStyle = _data["textLineThroughStyle"];
            this.textLineThroughWidth = _data["textLineThroughWidth"];
            this.textLineThroughColor = _data["textLineThroughColor"];
            this.textLineThroughText = _data["textLineThroughText"];
            this.textLineThroughTextStyle = _data["textLineThroughTextStyle"];
            this.textPosition = _data["textPosition"] ? TextPosition.fromJS(_data["textPosition"]) : <any>undefined;
            this.font = _data["font"];
            this.asianFont = _data["asianFont"];
            this.complexFont = _data["complexFont"];
            this.fontStyle = _data["fontStyle"];
            this.asianFontStyle = _data["asianFontStyle"];
            this.complexFontStyle = _data["complexFontStyle"];
            this.fontSize = _data["fontSize"] ? Size.fromJS(_data["fontSize"]) : <any>undefined;
            this.asianFontSize = _data["asianFontSize"] ? Size.fromJS(_data["asianFontSize"]) : <any>undefined;
            this.complexFontSize = _data["complexFontSize"] ? Size.fromJS(_data["complexFontSize"]) : <any>undefined;
            this.relativeFontSize = _data["relativeFontSize"] ? Size.fromJS(_data["relativeFontSize"]) : <any>undefined;
            this.relativeAsianFontSize = _data["relativeAsianFontSize"] ? Size.fromJS(_data["relativeAsianFontSize"]) : <any>undefined;
            this.relativeComplexFontSize = _data["relativeComplexFontSize"] ? Size.fromJS(_data["relativeComplexFontSize"]) : <any>undefined;
            this.country = _data["country"];
            this.asianCountry = _data["asianCountry"];
            this.complexCountry = _data["complexCountry"];
            this.language = _data["language"];
            this.asianLanguage = _data["asianLanguage"];
            this.complexLanguage = _data["complexLanguage"];
            this.fontCharacterSet = _data["fontCharacterSet"];
            this.asianFontCharacterSet = _data["asianFontCharacterSet"];
            this.complexFontCharacterSet = _data["complexFontCharacterSet"];
            this.fontPitch = _data["fontPitch"];
            this.asianFontPitch = _data["asianFontPitch"];
            this.complexFontPitch = _data["complexFontPitch"];
            this.fontFamily = _data["fontFamily"];
            this.asianFontFamily = _data["asianFontFamily"];
            this.complexFontFamily = _data["complexFontFamily"];
            this.fontWeight = _data["fontWeight"];
            this.asianFontWeight = _data["asianFontWeight"];
            this.complexFontWeight = _data["complexFontWeight"];
            this.genericFontFamily = _data["genericFontFamily"];
            this.asianGenericFontFamily = _data["asianGenericFontFamily"];
            this.complexGenericFontFamily = _data["complexGenericFontFamily"];
            this.fontStyleType = _data["fontStyleType"];
            this.asianFontStyleType = _data["asianFontStyleType"];
            this.complexFontStyleType = _data["complexFontStyleType"];
            this.backgroundColor = _data["backgroundColor"];
            this.shadow = _data["shadow"];
            this.scriptType = _data["scriptType"];
            this.fontRelief = _data["fontRelief"];
            this.underlineType = _data["underlineType"];
            this.underlineStyle = _data["underlineStyle"];
            this.underlineWordMode = _data["underlineWordMode"];
            this.underlineWidth = _data["underlineWidth"];
            this.underlineColor = _data["underlineColor"];
            this.lineThroughWordMode = _data["lineThroughWordMode"];
            this.enableLetterKerning = _data["enableLetterKerning"];
            this.enableTextBlinking = _data["enableTextBlinking"];
            this.textCombine = _data["textCombine"];
            this.textCombineStartChar = _data["textCombineStartChar"];
            this.textCombineEndChar = _data["textCombineEndChar"];
            this.textRotationAngle = _data["textRotationAngle"];
            this.textRotationScale = _data["textRotationScale"];
            this.enableHyphenation = _data["enableHyphenation"];
            this.hyphenationRemainCharCount = _data["hyphenationRemainCharCount"];
            this.hyphenationPushCharCount = _data["hyphenationPushCharCount"];
            this.isLetterSpacingNormal = _data["isLetterSpacingNormal"];
            this.letterSpacing = _data["letterSpacing"] ? Size.fromJS(_data["letterSpacing"]) : <any>undefined;
            this.textScale = _data["textScale"];
        }
    }

    static fromJS(data: any): TextPropertiesModel {
        data = typeof data === 'object' ? data : {};
        let result = new TextPropertiesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fontVariant"] = this.fontVariant;
        data["textTransformation"] = this.textTransformation;
        data["color"] = this.color;
        data["useWindowFontColor"] = this.useWindowFontColor;
        data["textOutline"] = this.textOutline;
        data["textLineThrough"] = this.textLineThrough;
        data["textLineThroughStyle"] = this.textLineThroughStyle;
        data["textLineThroughWidth"] = this.textLineThroughWidth;
        data["textLineThroughColor"] = this.textLineThroughColor;
        data["textLineThroughText"] = this.textLineThroughText;
        data["textLineThroughTextStyle"] = this.textLineThroughTextStyle;
        data["textPosition"] = this.textPosition ? this.textPosition.toJSON() : <any>undefined;
        data["font"] = this.font;
        data["asianFont"] = this.asianFont;
        data["complexFont"] = this.complexFont;
        data["fontStyle"] = this.fontStyle;
        data["asianFontStyle"] = this.asianFontStyle;
        data["complexFontStyle"] = this.complexFontStyle;
        data["fontSize"] = this.fontSize ? this.fontSize.toJSON() : <any>undefined;
        data["asianFontSize"] = this.asianFontSize ? this.asianFontSize.toJSON() : <any>undefined;
        data["complexFontSize"] = this.complexFontSize ? this.complexFontSize.toJSON() : <any>undefined;
        data["relativeFontSize"] = this.relativeFontSize ? this.relativeFontSize.toJSON() : <any>undefined;
        data["relativeAsianFontSize"] = this.relativeAsianFontSize ? this.relativeAsianFontSize.toJSON() : <any>undefined;
        data["relativeComplexFontSize"] = this.relativeComplexFontSize ? this.relativeComplexFontSize.toJSON() : <any>undefined;
        data["country"] = this.country;
        data["asianCountry"] = this.asianCountry;
        data["complexCountry"] = this.complexCountry;
        data["language"] = this.language;
        data["asianLanguage"] = this.asianLanguage;
        data["complexLanguage"] = this.complexLanguage;
        data["fontCharacterSet"] = this.fontCharacterSet;
        data["asianFontCharacterSet"] = this.asianFontCharacterSet;
        data["complexFontCharacterSet"] = this.complexFontCharacterSet;
        data["fontPitch"] = this.fontPitch;
        data["asianFontPitch"] = this.asianFontPitch;
        data["complexFontPitch"] = this.complexFontPitch;
        data["fontFamily"] = this.fontFamily;
        data["asianFontFamily"] = this.asianFontFamily;
        data["complexFontFamily"] = this.complexFontFamily;
        data["fontWeight"] = this.fontWeight;
        data["asianFontWeight"] = this.asianFontWeight;
        data["complexFontWeight"] = this.complexFontWeight;
        data["genericFontFamily"] = this.genericFontFamily;
        data["asianGenericFontFamily"] = this.asianGenericFontFamily;
        data["complexGenericFontFamily"] = this.complexGenericFontFamily;
        data["fontStyleType"] = this.fontStyleType;
        data["asianFontStyleType"] = this.asianFontStyleType;
        data["complexFontStyleType"] = this.complexFontStyleType;
        data["backgroundColor"] = this.backgroundColor;
        data["shadow"] = this.shadow;
        data["scriptType"] = this.scriptType;
        data["fontRelief"] = this.fontRelief;
        data["underlineType"] = this.underlineType;
        data["underlineStyle"] = this.underlineStyle;
        data["underlineWordMode"] = this.underlineWordMode;
        data["underlineWidth"] = this.underlineWidth;
        data["underlineColor"] = this.underlineColor;
        data["lineThroughWordMode"] = this.lineThroughWordMode;
        data["enableLetterKerning"] = this.enableLetterKerning;
        data["enableTextBlinking"] = this.enableTextBlinking;
        data["textCombine"] = this.textCombine;
        data["textCombineStartChar"] = this.textCombineStartChar;
        data["textCombineEndChar"] = this.textCombineEndChar;
        data["textRotationAngle"] = this.textRotationAngle;
        data["textRotationScale"] = this.textRotationScale;
        data["enableHyphenation"] = this.enableHyphenation;
        data["hyphenationRemainCharCount"] = this.hyphenationRemainCharCount;
        data["hyphenationPushCharCount"] = this.hyphenationPushCharCount;
        data["isLetterSpacingNormal"] = this.isLetterSpacingNormal;
        data["letterSpacing"] = this.letterSpacing ? this.letterSpacing.toJSON() : <any>undefined;
        data["textScale"] = this.textScale;
        return data;
    }
}

export interface ITextPropertiesModel {
    fontVariant?: FontVariant;
    textTransformation?: TextTransformation;
    color?: string | undefined;
    useWindowFontColor?: boolean;
    textOutline?: boolean;
    textLineThrough?: LineType;
    textLineThroughStyle?: LineStyle;
    textLineThroughWidth?: string | undefined;
    textLineThroughColor?: string | undefined;
    textLineThroughText?: string | undefined;
    textLineThroughTextStyle?: string | undefined;
    textPosition?: TextPosition;
    font?: string | undefined;
    asianFont?: string | undefined;
    complexFont?: string | undefined;
    fontStyle?: string | undefined;
    asianFontStyle?: string | undefined;
    complexFontStyle?: string | undefined;
    fontSize?: Size;
    asianFontSize?: Size;
    complexFontSize?: Size;
    relativeFontSize?: Size;
    relativeAsianFontSize?: Size;
    relativeComplexFontSize?: Size;
    country?: string | undefined;
    asianCountry?: string | undefined;
    complexCountry?: string | undefined;
    language?: string | undefined;
    asianLanguage?: string | undefined;
    complexLanguage?: string | undefined;
    fontCharacterSet?: string | undefined;
    asianFontCharacterSet?: string | undefined;
    complexFontCharacterSet?: string | undefined;
    fontPitch?: FontPitch;
    asianFontPitch?: FontPitch;
    complexFontPitch?: FontPitch;
    fontFamily?: string | undefined;
    asianFontFamily?: string | undefined;
    complexFontFamily?: string | undefined;
    fontWeight?: FontWeight;
    asianFontWeight?: FontWeight;
    complexFontWeight?: FontWeight;
    genericFontFamily?: GenericFontFamily;
    asianGenericFontFamily?: GenericFontFamily;
    complexGenericFontFamily?: GenericFontFamily;
    fontStyleType?: FontStyleType;
    asianFontStyleType?: FontStyleType;
    complexFontStyleType?: FontStyleType;
    backgroundColor?: string | undefined;
    shadow?: string | undefined;
    scriptType?: ScriptType;
    fontRelief?: FontRelief;
    underlineType?: UnderlineType;
    underlineStyle?: UnderlineStyle;
    underlineWordMode?: LineMode;
    underlineWidth?: string | undefined;
    underlineColor?: string | undefined;
    lineThroughWordMode?: LineMode;
    enableLetterKerning?: boolean;
    enableTextBlinking?: boolean;
    textCombine?: TextCombine;
    textCombineStartChar?: string;
    textCombineEndChar?: string;
    textRotationAngle?: number;
    textRotationScale?: TextRotationScale;
    enableHyphenation?: boolean;
    hyphenationRemainCharCount?: number;
    hyphenationPushCharCount?: number;
    isLetterSpacingNormal?: boolean;
    letterSpacing?: Size;
    textScale?: number;
}

export enum TextRotationScale {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum TextTransformation {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class Texte implements ITexte {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    typ?: number;
    text?: string | undefined;
    bvansicht?: boolean | undefined;
    vwansicht?: boolean | undefined;
    hp?: boolean | undefined;
    jr?: boolean | undefined;
    ubw?: boolean | undefined;
    gemeinden?: Gemeinden;

    constructor(data?: ITexte) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.bezeichnung = _data["bezeichnung"];
            this.typ = _data["typ"];
            this.text = _data["text"];
            this.bvansicht = _data["bvansicht"];
            this.vwansicht = _data["vwansicht"];
            this.hp = _data["hp"];
            this.jr = _data["jr"];
            this.ubw = _data["ubw"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Texte {
        data = typeof data === 'object' ? data : {};
        let result = new Texte();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["bezeichnung"] = this.bezeichnung;
        data["typ"] = this.typ;
        data["text"] = this.text;
        data["bvansicht"] = this.bvansicht;
        data["vwansicht"] = this.vwansicht;
        data["hp"] = this.hp;
        data["jr"] = this.jr;
        data["ubw"] = this.ubw;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITexte {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    typ?: number;
    text?: string | undefined;
    bvansicht?: boolean | undefined;
    vwansicht?: boolean | undefined;
    hp?: boolean | undefined;
    jr?: boolean | undefined;
    ubw?: boolean | undefined;
    gemeinden?: Gemeinden;
}

export class Texttypen implements ITexttypen {
    id?: number | undefined;
    bezeichnung?: string | undefined;

    constructor(data?: ITexttypen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
        }
    }

    static fromJS(data: any): Texttypen {
        data = typeof data === 'object' ? data : {};
        let result = new Texttypen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        return data;
    }
}

export interface ITexttypen {
    id?: number | undefined;
    bezeichnung?: string | undefined;
}

export class TopEAResult implements ITopEAResult {
    negResults?: TopEAResultEbene[] | undefined;
    negResultAbs?: number;
    negResultRel?: number;
    negResultVH?: number;
    posResults?: TopEAResultEbene[] | undefined;
    posResultAbs?: number;
    posResultRel?: number;
    posResultVH?: number;
    anzahlHH?: number;
    bezeichnung?: string | undefined;
    vm?: boolean;
    minMehrEA?: boolean;
    stellen?: number;
    textOben?: string | undefined;
    textMitte?: string | undefined;
    textObenAE?: string | undefined;
    textMitteAE?: string | undefined;
    textObenAA?: string | undefined;
    textMitteAA?: string | undefined;
    farbeA?: string | undefined;
    farbeE?: string | undefined;
    farbeMinderA?: string | undefined;
    farbeMinderE?: string | undefined;
    farbeMehrA?: string | undefined;
    farbeMehrE?: string | undefined;
    attributName?: string | undefined;
    minderAResultsJR?: TopEAResultEbene[] | undefined;
    minderAResultAbsJR?: number;
    minderAResultRelJR?: number;
    minderAResultVHJR?: number;
    mehrAResultsJR?: TopEAResultEbene[] | undefined;
    mehrAResultAbsJR?: number;
    genPflichtig?: number | undefined;
    genPflichtigVH?: number | undefined;
    mehrAResultRelJR?: number;
    mehrAResultVHJR?: number;
    minderEResultsJR?: TopEAResultEbene[] | undefined;
    minderEResultAbsJR?: number;
    minderEResultRelJR?: number;
    minderEResultVHJR?: number;
    mehrEResultsJR?: TopEAResultEbene[] | undefined;
    mehrEResultAbsJR?: number;
    mehrEResultRelJR?: number;
    mehrEResultVHJR?: number;

    constructor(data?: ITopEAResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["negResults"])) {
                this.negResults = [] as any;
                for (let item of _data["negResults"])
                    this.negResults!.push(TopEAResultEbene.fromJS(item));
            }
            this.negResultAbs = _data["negResultAbs"];
            this.negResultRel = _data["negResultRel"];
            this.negResultVH = _data["negResultVH"];
            if (Array.isArray(_data["posResults"])) {
                this.posResults = [] as any;
                for (let item of _data["posResults"])
                    this.posResults!.push(TopEAResultEbene.fromJS(item));
            }
            this.posResultAbs = _data["posResultAbs"];
            this.posResultRel = _data["posResultRel"];
            this.posResultVH = _data["posResultVH"];
            this.anzahlHH = _data["anzahlHH"];
            this.bezeichnung = _data["bezeichnung"];
            this.vm = _data["vm"];
            this.minMehrEA = _data["minMehrEA"];
            this.stellen = _data["stellen"];
            this.textOben = _data["textOben"];
            this.textMitte = _data["textMitte"];
            this.textObenAE = _data["textObenAE"];
            this.textMitteAE = _data["textMitteAE"];
            this.textObenAA = _data["textObenAA"];
            this.textMitteAA = _data["textMitteAA"];
            this.farbeA = _data["farbeA"];
            this.farbeE = _data["farbeE"];
            this.farbeMinderA = _data["farbeMinderA"];
            this.farbeMinderE = _data["farbeMinderE"];
            this.farbeMehrA = _data["farbeMehrA"];
            this.farbeMehrE = _data["farbeMehrE"];
            this.attributName = _data["attributName"];
            if (Array.isArray(_data["minderAResultsJR"])) {
                this.minderAResultsJR = [] as any;
                for (let item of _data["minderAResultsJR"])
                    this.minderAResultsJR!.push(TopEAResultEbene.fromJS(item));
            }
            this.minderAResultAbsJR = _data["minderAResultAbsJR"];
            this.minderAResultRelJR = _data["minderAResultRelJR"];
            this.minderAResultVHJR = _data["minderAResultVHJR"];
            if (Array.isArray(_data["mehrAResultsJR"])) {
                this.mehrAResultsJR = [] as any;
                for (let item of _data["mehrAResultsJR"])
                    this.mehrAResultsJR!.push(TopEAResultEbene.fromJS(item));
            }
            this.mehrAResultAbsJR = _data["mehrAResultAbsJR"];
            this.genPflichtig = _data["genPflichtig"];
            this.genPflichtigVH = _data["genPflichtigVH"];
            this.mehrAResultRelJR = _data["mehrAResultRelJR"];
            this.mehrAResultVHJR = _data["mehrAResultVHJR"];
            if (Array.isArray(_data["minderEResultsJR"])) {
                this.minderEResultsJR = [] as any;
                for (let item of _data["minderEResultsJR"])
                    this.minderEResultsJR!.push(TopEAResultEbene.fromJS(item));
            }
            this.minderEResultAbsJR = _data["minderEResultAbsJR"];
            this.minderEResultRelJR = _data["minderEResultRelJR"];
            this.minderEResultVHJR = _data["minderEResultVHJR"];
            if (Array.isArray(_data["mehrEResultsJR"])) {
                this.mehrEResultsJR = [] as any;
                for (let item of _data["mehrEResultsJR"])
                    this.mehrEResultsJR!.push(TopEAResultEbene.fromJS(item));
            }
            this.mehrEResultAbsJR = _data["mehrEResultAbsJR"];
            this.mehrEResultRelJR = _data["mehrEResultRelJR"];
            this.mehrEResultVHJR = _data["mehrEResultVHJR"];
        }
    }

    static fromJS(data: any): TopEAResult {
        data = typeof data === 'object' ? data : {};
        let result = new TopEAResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.negResults)) {
            data["negResults"] = [];
            for (let item of this.negResults)
                data["negResults"].push(item.toJSON());
        }
        data["negResultAbs"] = this.negResultAbs;
        data["negResultRel"] = this.negResultRel;
        data["negResultVH"] = this.negResultVH;
        if (Array.isArray(this.posResults)) {
            data["posResults"] = [];
            for (let item of this.posResults)
                data["posResults"].push(item.toJSON());
        }
        data["posResultAbs"] = this.posResultAbs;
        data["posResultRel"] = this.posResultRel;
        data["posResultVH"] = this.posResultVH;
        data["anzahlHH"] = this.anzahlHH;
        data["bezeichnung"] = this.bezeichnung;
        data["vm"] = this.vm;
        data["minMehrEA"] = this.minMehrEA;
        data["stellen"] = this.stellen;
        data["textOben"] = this.textOben;
        data["textMitte"] = this.textMitte;
        data["textObenAE"] = this.textObenAE;
        data["textMitteAE"] = this.textMitteAE;
        data["textObenAA"] = this.textObenAA;
        data["textMitteAA"] = this.textMitteAA;
        data["farbeA"] = this.farbeA;
        data["farbeE"] = this.farbeE;
        data["farbeMinderA"] = this.farbeMinderA;
        data["farbeMinderE"] = this.farbeMinderE;
        data["farbeMehrA"] = this.farbeMehrA;
        data["farbeMehrE"] = this.farbeMehrE;
        data["attributName"] = this.attributName;
        if (Array.isArray(this.minderAResultsJR)) {
            data["minderAResultsJR"] = [];
            for (let item of this.minderAResultsJR)
                data["minderAResultsJR"].push(item.toJSON());
        }
        data["minderAResultAbsJR"] = this.minderAResultAbsJR;
        data["minderAResultRelJR"] = this.minderAResultRelJR;
        data["minderAResultVHJR"] = this.minderAResultVHJR;
        if (Array.isArray(this.mehrAResultsJR)) {
            data["mehrAResultsJR"] = [];
            for (let item of this.mehrAResultsJR)
                data["mehrAResultsJR"].push(item.toJSON());
        }
        data["mehrAResultAbsJR"] = this.mehrAResultAbsJR;
        data["genPflichtig"] = this.genPflichtig;
        data["genPflichtigVH"] = this.genPflichtigVH;
        data["mehrAResultRelJR"] = this.mehrAResultRelJR;
        data["mehrAResultVHJR"] = this.mehrAResultVHJR;
        if (Array.isArray(this.minderEResultsJR)) {
            data["minderEResultsJR"] = [];
            for (let item of this.minderEResultsJR)
                data["minderEResultsJR"].push(item.toJSON());
        }
        data["minderEResultAbsJR"] = this.minderEResultAbsJR;
        data["minderEResultRelJR"] = this.minderEResultRelJR;
        data["minderEResultVHJR"] = this.minderEResultVHJR;
        if (Array.isArray(this.mehrEResultsJR)) {
            data["mehrEResultsJR"] = [];
            for (let item of this.mehrEResultsJR)
                data["mehrEResultsJR"].push(item.toJSON());
        }
        data["mehrEResultAbsJR"] = this.mehrEResultAbsJR;
        data["mehrEResultRelJR"] = this.mehrEResultRelJR;
        data["mehrEResultVHJR"] = this.mehrEResultVHJR;
        return data;
    }
}

export interface ITopEAResult {
    negResults?: TopEAResultEbene[] | undefined;
    negResultAbs?: number;
    negResultRel?: number;
    negResultVH?: number;
    posResults?: TopEAResultEbene[] | undefined;
    posResultAbs?: number;
    posResultRel?: number;
    posResultVH?: number;
    anzahlHH?: number;
    bezeichnung?: string | undefined;
    vm?: boolean;
    minMehrEA?: boolean;
    stellen?: number;
    textOben?: string | undefined;
    textMitte?: string | undefined;
    textObenAE?: string | undefined;
    textMitteAE?: string | undefined;
    textObenAA?: string | undefined;
    textMitteAA?: string | undefined;
    farbeA?: string | undefined;
    farbeE?: string | undefined;
    farbeMinderA?: string | undefined;
    farbeMinderE?: string | undefined;
    farbeMehrA?: string | undefined;
    farbeMehrE?: string | undefined;
    attributName?: string | undefined;
    minderAResultsJR?: TopEAResultEbene[] | undefined;
    minderAResultAbsJR?: number;
    minderAResultRelJR?: number;
    minderAResultVHJR?: number;
    mehrAResultsJR?: TopEAResultEbene[] | undefined;
    mehrAResultAbsJR?: number;
    genPflichtig?: number | undefined;
    genPflichtigVH?: number | undefined;
    mehrAResultRelJR?: number;
    mehrAResultVHJR?: number;
    minderEResultsJR?: TopEAResultEbene[] | undefined;
    minderEResultAbsJR?: number;
    minderEResultRelJR?: number;
    minderEResultVHJR?: number;
    mehrEResultsJR?: TopEAResultEbene[] | undefined;
    mehrEResultAbsJR?: number;
    mehrEResultRelJR?: number;
    mehrEResultVHJR?: number;
}

export class TopEAResultEbene implements ITopEAResultEbene {
    readonly id?: string | undefined;
    ergebnis?: number;
    gesamtSoll?: number;
    aenderung?: number;
    rohDaten?: HaushaltsdatenJrkameral;
    rohDatenDoppisch?: HaushaltsdatenJrdoppisch;
    result?: number;
    genPflichtig?: number | undefined;
    resultRel?: number;
    hhFmt?: string | undefined;
    hhText?: string | undefined;
    hhBeschreibung?: string | undefined;
    attribut?: string | undefined;

    constructor(data?: ITopEAResultEbene) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            this.ergebnis = _data["ergebnis"];
            this.gesamtSoll = _data["gesamtSoll"];
            this.aenderung = _data["aenderung"];
            this.rohDaten = _data["rohDaten"] ? HaushaltsdatenJrkameral.fromJS(_data["rohDaten"]) : <any>undefined;
            this.rohDatenDoppisch = _data["rohDatenDoppisch"] ? HaushaltsdatenJrdoppisch.fromJS(_data["rohDatenDoppisch"]) : <any>undefined;
            this.result = _data["result"];
            this.genPflichtig = _data["genPflichtig"];
            this.resultRel = _data["resultRel"];
            this.hhFmt = _data["hhFmt"];
            this.hhText = _data["hhText"];
            this.hhBeschreibung = _data["hhBeschreibung"];
            this.attribut = _data["attribut"];
        }
    }

    static fromJS(data: any): TopEAResultEbene {
        data = typeof data === 'object' ? data : {};
        let result = new TopEAResultEbene();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ergebnis"] = this.ergebnis;
        data["gesamtSoll"] = this.gesamtSoll;
        data["aenderung"] = this.aenderung;
        data["rohDaten"] = this.rohDaten ? this.rohDaten.toJSON() : <any>undefined;
        data["rohDatenDoppisch"] = this.rohDatenDoppisch ? this.rohDatenDoppisch.toJSON() : <any>undefined;
        data["result"] = this.result;
        data["genPflichtig"] = this.genPflichtig;
        data["resultRel"] = this.resultRel;
        data["hhFmt"] = this.hhFmt;
        data["hhText"] = this.hhText;
        data["hhBeschreibung"] = this.hhBeschreibung;
        data["attribut"] = this.attribut;
        return data;
    }
}

export interface ITopEAResultEbene {
    id?: string | undefined;
    ergebnis?: number;
    gesamtSoll?: number;
    aenderung?: number;
    rohDaten?: HaushaltsdatenJrkameral;
    rohDatenDoppisch?: HaushaltsdatenJrdoppisch;
    result?: number;
    genPflichtig?: number | undefined;
    resultRel?: number;
    hhFmt?: string | undefined;
    hhText?: string | undefined;
    hhBeschreibung?: string | undefined;
    attribut?: string | undefined;
}

export class TopEa implements ITopEa {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    anzeigen?: boolean;
    textOben?: string | undefined;
    textMitte?: string | undefined;
    farbeE?: string | undefined;
    farbeA?: string | undefined;
    exkludiert?: string | undefined;
    anzeigenJr?: boolean | undefined;
    textObenJr?: string | undefined;
    textMitteJr?: string | undefined;
    textObenAejr?: string | undefined;
    textMitteAejr?: string | undefined;
    textObenAajr?: string | undefined;
    textMitteAajr?: string | undefined;
    farbeEjr?: string | undefined;
    farbeAjr?: string | undefined;
    exkludiertJr?: string | undefined;
    farbeMinderEjr?: string | undefined;
    farbeMinderAjr?: string | undefined;
    farbeMehrEjr?: string | undefined;
    farbeMehrAjr?: string | undefined;
    anzeigenJrVm?: boolean | undefined;
    textObenJrVm?: string | undefined;
    textMitteJrVm?: string | undefined;
    textObenAejrVm?: string | undefined;
    textMitteAejrVm?: string | undefined;
    textObenAajrVm?: string | undefined;
    textMitteAajrVm?: string | undefined;
    farbeEjrVm?: string | undefined;
    farbeAjrVm?: string | undefined;
    exkludiertJrVm?: string | undefined;
    farbeMinderEjrVm?: string | undefined;
    farbeMinderAjrVm?: string | undefined;
    farbeMehrEjrVm?: string | undefined;
    farbeMehrAjrVm?: string | undefined;
    anzeigenUh?: boolean | undefined;
    textObenUh?: string | undefined;
    textMitteUh?: string | undefined;
    textObenAeuh?: string | undefined;
    textMitteAeuh?: string | undefined;
    textObenAauh?: string | undefined;
    textMitteAauh?: string | undefined;
    farbeEuh?: string | undefined;
    farbeAuh?: string | undefined;
    exkludiertUh?: string | undefined;
    farbeMinderEuh?: string | undefined;
    farbeMinderAuh?: string | undefined;
    farbeMehrEuh?: string | undefined;
    farbeMehrAuh?: string | undefined;
    anzeigenVm?: boolean | undefined;
    textObenVm?: string | undefined;
    textMitteVm?: string | undefined;
    farbeEVm?: string | undefined;
    farbeAVm?: string | undefined;
    exkludiertVm?: string | undefined;
    anzeigenUhVm?: boolean | undefined;
    textObenUhVm?: string | undefined;
    textMitteUhVm?: string | undefined;
    textObenAeuhVm?: string | undefined;
    textMitteAeuhVm?: string | undefined;
    textObenAauhVm?: string | undefined;
    textMitteAauhVm?: string | undefined;
    farbeEuhVm?: string | undefined;
    farbeAuhVm?: string | undefined;
    exkludiertUhVm?: string | undefined;
    farbeMinderEuhVm?: string | undefined;
    farbeMinderAuhVm?: string | undefined;
    farbeMehrEuhVm?: string | undefined;
    farbeMehrAuhVm?: string | undefined;
    numberRows?: number | undefined;
    numberRowsJr?: number | undefined;
    numberRowsUh?: number | undefined;
    numberRowsVm?: number | undefined;
    numberRowsJrVm?: number | undefined;
    numberRowsUhVm?: number | undefined;

    constructor(data?: ITopEa) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.anzeigen = _data["anzeigen"];
            this.textOben = _data["textOben"];
            this.textMitte = _data["textMitte"];
            this.farbeE = _data["farbeE"];
            this.farbeA = _data["farbeA"];
            this.exkludiert = _data["exkludiert"];
            this.anzeigenJr = _data["anzeigenJr"];
            this.textObenJr = _data["textObenJr"];
            this.textMitteJr = _data["textMitteJr"];
            this.textObenAejr = _data["textObenAejr"];
            this.textMitteAejr = _data["textMitteAejr"];
            this.textObenAajr = _data["textObenAajr"];
            this.textMitteAajr = _data["textMitteAajr"];
            this.farbeEjr = _data["farbeEjr"];
            this.farbeAjr = _data["farbeAjr"];
            this.exkludiertJr = _data["exkludiertJr"];
            this.farbeMinderEjr = _data["farbeMinderEjr"];
            this.farbeMinderAjr = _data["farbeMinderAjr"];
            this.farbeMehrEjr = _data["farbeMehrEjr"];
            this.farbeMehrAjr = _data["farbeMehrAjr"];
            this.anzeigenJrVm = _data["anzeigenJrVm"];
            this.textObenJrVm = _data["textObenJrVm"];
            this.textMitteJrVm = _data["textMitteJrVm"];
            this.textObenAejrVm = _data["textObenAejrVm"];
            this.textMitteAejrVm = _data["textMitteAejrVm"];
            this.textObenAajrVm = _data["textObenAajrVm"];
            this.textMitteAajrVm = _data["textMitteAajrVm"];
            this.farbeEjrVm = _data["farbeEjrVm"];
            this.farbeAjrVm = _data["farbeAjrVm"];
            this.exkludiertJrVm = _data["exkludiertJrVm"];
            this.farbeMinderEjrVm = _data["farbeMinderEjrVm"];
            this.farbeMinderAjrVm = _data["farbeMinderAjrVm"];
            this.farbeMehrEjrVm = _data["farbeMehrEjrVm"];
            this.farbeMehrAjrVm = _data["farbeMehrAjrVm"];
            this.anzeigenUh = _data["anzeigenUh"];
            this.textObenUh = _data["textObenUh"];
            this.textMitteUh = _data["textMitteUh"];
            this.textObenAeuh = _data["textObenAeuh"];
            this.textMitteAeuh = _data["textMitteAeuh"];
            this.textObenAauh = _data["textObenAauh"];
            this.textMitteAauh = _data["textMitteAauh"];
            this.farbeEuh = _data["farbeEuh"];
            this.farbeAuh = _data["farbeAuh"];
            this.exkludiertUh = _data["exkludiertUh"];
            this.farbeMinderEuh = _data["farbeMinderEuh"];
            this.farbeMinderAuh = _data["farbeMinderAuh"];
            this.farbeMehrEuh = _data["farbeMehrEuh"];
            this.farbeMehrAuh = _data["farbeMehrAuh"];
            this.anzeigenVm = _data["anzeigenVm"];
            this.textObenVm = _data["textObenVm"];
            this.textMitteVm = _data["textMitteVm"];
            this.farbeEVm = _data["farbeEVm"];
            this.farbeAVm = _data["farbeAVm"];
            this.exkludiertVm = _data["exkludiertVm"];
            this.anzeigenUhVm = _data["anzeigenUhVm"];
            this.textObenUhVm = _data["textObenUhVm"];
            this.textMitteUhVm = _data["textMitteUhVm"];
            this.textObenAeuhVm = _data["textObenAeuhVm"];
            this.textMitteAeuhVm = _data["textMitteAeuhVm"];
            this.textObenAauhVm = _data["textObenAauhVm"];
            this.textMitteAauhVm = _data["textMitteAauhVm"];
            this.farbeEuhVm = _data["farbeEuhVm"];
            this.farbeAuhVm = _data["farbeAuhVm"];
            this.exkludiertUhVm = _data["exkludiertUhVm"];
            this.farbeMinderEuhVm = _data["farbeMinderEuhVm"];
            this.farbeMinderAuhVm = _data["farbeMinderAuhVm"];
            this.farbeMehrEuhVm = _data["farbeMehrEuhVm"];
            this.farbeMehrAuhVm = _data["farbeMehrAuhVm"];
            this.numberRows = _data["numberRows"];
            this.numberRowsJr = _data["numberRowsJr"];
            this.numberRowsUh = _data["numberRowsUh"];
            this.numberRowsVm = _data["numberRowsVm"];
            this.numberRowsJrVm = _data["numberRowsJrVm"];
            this.numberRowsUhVm = _data["numberRowsUhVm"];
        }
    }

    static fromJS(data: any): TopEa {
        data = typeof data === 'object' ? data : {};
        let result = new TopEa();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["anzeigen"] = this.anzeigen;
        data["textOben"] = this.textOben;
        data["textMitte"] = this.textMitte;
        data["farbeE"] = this.farbeE;
        data["farbeA"] = this.farbeA;
        data["exkludiert"] = this.exkludiert;
        data["anzeigenJr"] = this.anzeigenJr;
        data["textObenJr"] = this.textObenJr;
        data["textMitteJr"] = this.textMitteJr;
        data["textObenAejr"] = this.textObenAejr;
        data["textMitteAejr"] = this.textMitteAejr;
        data["textObenAajr"] = this.textObenAajr;
        data["textMitteAajr"] = this.textMitteAajr;
        data["farbeEjr"] = this.farbeEjr;
        data["farbeAjr"] = this.farbeAjr;
        data["exkludiertJr"] = this.exkludiertJr;
        data["farbeMinderEjr"] = this.farbeMinderEjr;
        data["farbeMinderAjr"] = this.farbeMinderAjr;
        data["farbeMehrEjr"] = this.farbeMehrEjr;
        data["farbeMehrAjr"] = this.farbeMehrAjr;
        data["anzeigenJrVm"] = this.anzeigenJrVm;
        data["textObenJrVm"] = this.textObenJrVm;
        data["textMitteJrVm"] = this.textMitteJrVm;
        data["textObenAejrVm"] = this.textObenAejrVm;
        data["textMitteAejrVm"] = this.textMitteAejrVm;
        data["textObenAajrVm"] = this.textObenAajrVm;
        data["textMitteAajrVm"] = this.textMitteAajrVm;
        data["farbeEjrVm"] = this.farbeEjrVm;
        data["farbeAjrVm"] = this.farbeAjrVm;
        data["exkludiertJrVm"] = this.exkludiertJrVm;
        data["farbeMinderEjrVm"] = this.farbeMinderEjrVm;
        data["farbeMinderAjrVm"] = this.farbeMinderAjrVm;
        data["farbeMehrEjrVm"] = this.farbeMehrEjrVm;
        data["farbeMehrAjrVm"] = this.farbeMehrAjrVm;
        data["anzeigenUh"] = this.anzeigenUh;
        data["textObenUh"] = this.textObenUh;
        data["textMitteUh"] = this.textMitteUh;
        data["textObenAeuh"] = this.textObenAeuh;
        data["textMitteAeuh"] = this.textMitteAeuh;
        data["textObenAauh"] = this.textObenAauh;
        data["textMitteAauh"] = this.textMitteAauh;
        data["farbeEuh"] = this.farbeEuh;
        data["farbeAuh"] = this.farbeAuh;
        data["exkludiertUh"] = this.exkludiertUh;
        data["farbeMinderEuh"] = this.farbeMinderEuh;
        data["farbeMinderAuh"] = this.farbeMinderAuh;
        data["farbeMehrEuh"] = this.farbeMehrEuh;
        data["farbeMehrAuh"] = this.farbeMehrAuh;
        data["anzeigenVm"] = this.anzeigenVm;
        data["textObenVm"] = this.textObenVm;
        data["textMitteVm"] = this.textMitteVm;
        data["farbeEVm"] = this.farbeEVm;
        data["farbeAVm"] = this.farbeAVm;
        data["exkludiertVm"] = this.exkludiertVm;
        data["anzeigenUhVm"] = this.anzeigenUhVm;
        data["textObenUhVm"] = this.textObenUhVm;
        data["textMitteUhVm"] = this.textMitteUhVm;
        data["textObenAeuhVm"] = this.textObenAeuhVm;
        data["textMitteAeuhVm"] = this.textMitteAeuhVm;
        data["textObenAauhVm"] = this.textObenAauhVm;
        data["textMitteAauhVm"] = this.textMitteAauhVm;
        data["farbeEuhVm"] = this.farbeEuhVm;
        data["farbeAuhVm"] = this.farbeAuhVm;
        data["exkludiertUhVm"] = this.exkludiertUhVm;
        data["farbeMinderEuhVm"] = this.farbeMinderEuhVm;
        data["farbeMinderAuhVm"] = this.farbeMinderAuhVm;
        data["farbeMehrEuhVm"] = this.farbeMehrEuhVm;
        data["farbeMehrAuhVm"] = this.farbeMehrAuhVm;
        data["numberRows"] = this.numberRows;
        data["numberRowsJr"] = this.numberRowsJr;
        data["numberRowsUh"] = this.numberRowsUh;
        data["numberRowsVm"] = this.numberRowsVm;
        data["numberRowsJrVm"] = this.numberRowsJrVm;
        data["numberRowsUhVm"] = this.numberRowsUhVm;
        return data;
    }
}

export interface ITopEa {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    anzeigen?: boolean;
    textOben?: string | undefined;
    textMitte?: string | undefined;
    farbeE?: string | undefined;
    farbeA?: string | undefined;
    exkludiert?: string | undefined;
    anzeigenJr?: boolean | undefined;
    textObenJr?: string | undefined;
    textMitteJr?: string | undefined;
    textObenAejr?: string | undefined;
    textMitteAejr?: string | undefined;
    textObenAajr?: string | undefined;
    textMitteAajr?: string | undefined;
    farbeEjr?: string | undefined;
    farbeAjr?: string | undefined;
    exkludiertJr?: string | undefined;
    farbeMinderEjr?: string | undefined;
    farbeMinderAjr?: string | undefined;
    farbeMehrEjr?: string | undefined;
    farbeMehrAjr?: string | undefined;
    anzeigenJrVm?: boolean | undefined;
    textObenJrVm?: string | undefined;
    textMitteJrVm?: string | undefined;
    textObenAejrVm?: string | undefined;
    textMitteAejrVm?: string | undefined;
    textObenAajrVm?: string | undefined;
    textMitteAajrVm?: string | undefined;
    farbeEjrVm?: string | undefined;
    farbeAjrVm?: string | undefined;
    exkludiertJrVm?: string | undefined;
    farbeMinderEjrVm?: string | undefined;
    farbeMinderAjrVm?: string | undefined;
    farbeMehrEjrVm?: string | undefined;
    farbeMehrAjrVm?: string | undefined;
    anzeigenUh?: boolean | undefined;
    textObenUh?: string | undefined;
    textMitteUh?: string | undefined;
    textObenAeuh?: string | undefined;
    textMitteAeuh?: string | undefined;
    textObenAauh?: string | undefined;
    textMitteAauh?: string | undefined;
    farbeEuh?: string | undefined;
    farbeAuh?: string | undefined;
    exkludiertUh?: string | undefined;
    farbeMinderEuh?: string | undefined;
    farbeMinderAuh?: string | undefined;
    farbeMehrEuh?: string | undefined;
    farbeMehrAuh?: string | undefined;
    anzeigenVm?: boolean | undefined;
    textObenVm?: string | undefined;
    textMitteVm?: string | undefined;
    farbeEVm?: string | undefined;
    farbeAVm?: string | undefined;
    exkludiertVm?: string | undefined;
    anzeigenUhVm?: boolean | undefined;
    textObenUhVm?: string | undefined;
    textMitteUhVm?: string | undefined;
    textObenAeuhVm?: string | undefined;
    textMitteAeuhVm?: string | undefined;
    textObenAauhVm?: string | undefined;
    textMitteAauhVm?: string | undefined;
    farbeEuhVm?: string | undefined;
    farbeAuhVm?: string | undefined;
    exkludiertUhVm?: string | undefined;
    farbeMinderEuhVm?: string | undefined;
    farbeMinderAuhVm?: string | undefined;
    farbeMehrEuhVm?: string | undefined;
    farbeMehrAuhVm?: string | undefined;
    numberRows?: number | undefined;
    numberRowsJr?: number | undefined;
    numberRowsUh?: number | undefined;
    numberRowsVm?: number | undefined;
    numberRowsJrVm?: number | undefined;
    numberRowsUhVm?: number | undefined;
}

export class TopEaflex implements ITopEaflex {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    modul?: number;
    stellen?: number;
    textOben?: string | undefined;
    textMitte?: string | undefined;
    textObenAe?: string | undefined;
    textMitteAe?: string | undefined;
    textObenAa?: string | undefined;
    textMitteAa?: string | undefined;
    farbeE?: string | undefined;
    farbeA?: string | undefined;
    exkludiert?: string | undefined;
    farbeMinderE?: string | undefined;
    farbeMinderA?: string | undefined;
    farbeMehrE?: string | undefined;
    farbeMehrA?: string | undefined;
    numberRows?: number | undefined;
    bezeichnung?: string | undefined;
    order?: number | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    vm?: boolean | undefined;
    attrCol?: string | undefined;
    minMehrEa?: boolean | undefined;
    freiGrenze?: number | undefined;

    constructor(data?: ITopEaflex) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.modul = _data["modul"];
            this.stellen = _data["stellen"];
            this.textOben = _data["textOben"];
            this.textMitte = _data["textMitte"];
            this.textObenAe = _data["textObenAe"];
            this.textMitteAe = _data["textMitteAe"];
            this.textObenAa = _data["textObenAa"];
            this.textMitteAa = _data["textMitteAa"];
            this.farbeE = _data["farbeE"];
            this.farbeA = _data["farbeA"];
            this.exkludiert = _data["exkludiert"];
            this.farbeMinderE = _data["farbeMinderE"];
            this.farbeMinderA = _data["farbeMinderA"];
            this.farbeMehrE = _data["farbeMehrE"];
            this.farbeMehrA = _data["farbeMehrA"];
            this.numberRows = _data["numberRows"];
            this.bezeichnung = _data["bezeichnung"];
            this.order = _data["order"];
            this.oeffentlich = _data["oeffentlich"];
            this.oeffentlichVerwaltung = _data["oeffentlichVerwaltung"];
            this.vm = _data["vm"];
            this.attrCol = _data["attrCol"];
            this.minMehrEa = _data["minMehrEa"];
            this.freiGrenze = _data["freiGrenze"];
        }
    }

    static fromJS(data: any): TopEaflex {
        data = typeof data === 'object' ? data : {};
        let result = new TopEaflex();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["modul"] = this.modul;
        data["stellen"] = this.stellen;
        data["textOben"] = this.textOben;
        data["textMitte"] = this.textMitte;
        data["textObenAe"] = this.textObenAe;
        data["textMitteAe"] = this.textMitteAe;
        data["textObenAa"] = this.textObenAa;
        data["textMitteAa"] = this.textMitteAa;
        data["farbeE"] = this.farbeE;
        data["farbeA"] = this.farbeA;
        data["exkludiert"] = this.exkludiert;
        data["farbeMinderE"] = this.farbeMinderE;
        data["farbeMinderA"] = this.farbeMinderA;
        data["farbeMehrE"] = this.farbeMehrE;
        data["farbeMehrA"] = this.farbeMehrA;
        data["numberRows"] = this.numberRows;
        data["bezeichnung"] = this.bezeichnung;
        data["order"] = this.order;
        data["oeffentlich"] = this.oeffentlich;
        data["oeffentlichVerwaltung"] = this.oeffentlichVerwaltung;
        data["vm"] = this.vm;
        data["attrCol"] = this.attrCol;
        data["minMehrEa"] = this.minMehrEa;
        data["freiGrenze"] = this.freiGrenze;
        return data;
    }
}

export interface ITopEaflex {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    modul?: number;
    stellen?: number;
    textOben?: string | undefined;
    textMitte?: string | undefined;
    textObenAe?: string | undefined;
    textMitteAe?: string | undefined;
    textObenAa?: string | undefined;
    textMitteAa?: string | undefined;
    farbeE?: string | undefined;
    farbeA?: string | undefined;
    exkludiert?: string | undefined;
    farbeMinderE?: string | undefined;
    farbeMinderA?: string | undefined;
    farbeMehrE?: string | undefined;
    farbeMehrA?: string | undefined;
    numberRows?: number | undefined;
    bezeichnung?: string | undefined;
    order?: number | undefined;
    oeffentlich?: boolean | undefined;
    oeffentlichVerwaltung?: boolean | undefined;
    vm?: boolean | undefined;
    attrCol?: string | undefined;
    minMehrEa?: boolean | undefined;
    freiGrenze?: number | undefined;
}

export class TransferAnfrageModel implements ITransferAnfrageModel {
    zielKunde?: number;
    zuordnungen?: TransferZuordnungModel[] | undefined;
    schritte?: string[] | undefined;
    bestaetigung?: string | undefined;

    constructor(data?: ITransferAnfrageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zielKunde = _data["zielKunde"];
            if (Array.isArray(_data["zuordnungen"])) {
                this.zuordnungen = [] as any;
                for (let item of _data["zuordnungen"])
                    this.zuordnungen!.push(TransferZuordnungModel.fromJS(item));
            }
            if (Array.isArray(_data["schritte"])) {
                this.schritte = [] as any;
                for (let item of _data["schritte"])
                    this.schritte!.push(item);
            }
            this.bestaetigung = _data["bestaetigung"];
        }
    }

    static fromJS(data: any): TransferAnfrageModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransferAnfrageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zielKunde"] = this.zielKunde;
        if (Array.isArray(this.zuordnungen)) {
            data["zuordnungen"] = [];
            for (let item of this.zuordnungen)
                data["zuordnungen"].push(item.toJSON());
        }
        if (Array.isArray(this.schritte)) {
            data["schritte"] = [];
            for (let item of this.schritte)
                data["schritte"].push(item);
        }
        data["bestaetigung"] = this.bestaetigung;
        return data;
    }
}

export interface ITransferAnfrageModel {
    zielKunde?: number;
    zuordnungen?: TransferZuordnungModel[] | undefined;
    schritte?: string[] | undefined;
    bestaetigung?: string | undefined;
}

export class TransferDesignRequest implements ITransferDesignRequest {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    zielGemeinden?: number[] | undefined;

    constructor(data?: ITransferDesignRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            if (Array.isArray(_data["zielGemeinden"])) {
                this.zielGemeinden = [] as any;
                for (let item of _data["zielGemeinden"])
                    this.zielGemeinden!.push(item);
            }
        }
    }

    static fromJS(data: any): TransferDesignRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TransferDesignRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        if (Array.isArray(this.zielGemeinden)) {
            data["zielGemeinden"] = [];
            for (let item of this.zielGemeinden)
                data["zielGemeinden"].push(item);
        }
        return data;
    }
}

export interface ITransferDesignRequest {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    zielGemeinden?: number[] | undefined;
}

export class TransferSchrittModel implements ITransferSchrittModel {
    key?: string | undefined;
    anzeige?: string | undefined;
    beschreibung?: string | undefined;
    nurGemeinde?: boolean;
    reihenfolge?: number;

    constructor(data?: ITransferSchrittModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.anzeige = _data["anzeige"];
            this.beschreibung = _data["beschreibung"];
            this.nurGemeinde = _data["nurGemeinde"];
            this.reihenfolge = _data["reihenfolge"];
        }
    }

    static fromJS(data: any): TransferSchrittModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransferSchrittModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["anzeige"] = this.anzeige;
        data["beschreibung"] = this.beschreibung;
        data["nurGemeinde"] = this.nurGemeinde;
        data["reihenfolge"] = this.reihenfolge;
        return data;
    }
}

export interface ITransferSchrittModel {
    key?: string | undefined;
    anzeige?: string | undefined;
    beschreibung?: string | undefined;
    nurGemeinde?: boolean;
    reihenfolge?: number;
}

export class TransferVorschauModel implements ITransferVorschauModel {
    quellKunde?: number;
    quellName?: string | undefined;
    zielKunde?: number;
    zielName?: string | undefined;
    ausfuehrbar?: boolean;
    blockiert?: string | undefined;
    schritte?: TransferVorschauSchrittModel[] | undefined;
    zielGemeinden?: number[] | undefined;

    constructor(data?: ITransferVorschauModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quellKunde = _data["quellKunde"];
            this.quellName = _data["quellName"];
            this.zielKunde = _data["zielKunde"];
            this.zielName = _data["zielName"];
            this.ausfuehrbar = _data["ausfuehrbar"];
            this.blockiert = _data["blockiert"];
            if (Array.isArray(_data["schritte"])) {
                this.schritte = [] as any;
                for (let item of _data["schritte"])
                    this.schritte!.push(TransferVorschauSchrittModel.fromJS(item));
            }
            if (Array.isArray(_data["zielGemeinden"])) {
                this.zielGemeinden = [] as any;
                for (let item of _data["zielGemeinden"])
                    this.zielGemeinden!.push(item);
            }
        }
    }

    static fromJS(data: any): TransferVorschauModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransferVorschauModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quellKunde"] = this.quellKunde;
        data["quellName"] = this.quellName;
        data["zielKunde"] = this.zielKunde;
        data["zielName"] = this.zielName;
        data["ausfuehrbar"] = this.ausfuehrbar;
        data["blockiert"] = this.blockiert;
        if (Array.isArray(this.schritte)) {
            data["schritte"] = [];
            for (let item of this.schritte)
                data["schritte"].push(item.toJSON());
        }
        if (Array.isArray(this.zielGemeinden)) {
            data["zielGemeinden"] = [];
            for (let item of this.zielGemeinden)
                data["zielGemeinden"].push(item);
        }
        return data;
    }
}

export interface ITransferVorschauModel {
    quellKunde?: number;
    quellName?: string | undefined;
    zielKunde?: number;
    zielName?: string | undefined;
    ausfuehrbar?: boolean;
    blockiert?: string | undefined;
    schritte?: TransferVorschauSchrittModel[] | undefined;
    zielGemeinden?: number[] | undefined;
}

export class TransferVorschauSchrittModel implements ITransferVorschauSchrittModel {
    key?: string | undefined;
    anzeige?: string | undefined;
    quellGemeinde?: number;
    quellJahr?: number | undefined;
    zielGemeinde?: number;
    zielJahr?: number | undefined;
    quellZeilen?: number;
    zielZeilen?: number;
    machbar?: boolean;
    hinweis?: string | undefined;

    constructor(data?: ITransferVorschauSchrittModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.anzeige = _data["anzeige"];
            this.quellGemeinde = _data["quellGemeinde"];
            this.quellJahr = _data["quellJahr"];
            this.zielGemeinde = _data["zielGemeinde"];
            this.zielJahr = _data["zielJahr"];
            this.quellZeilen = _data["quellZeilen"];
            this.zielZeilen = _data["zielZeilen"];
            this.machbar = _data["machbar"];
            this.hinweis = _data["hinweis"];
        }
    }

    static fromJS(data: any): TransferVorschauSchrittModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransferVorschauSchrittModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["anzeige"] = this.anzeige;
        data["quellGemeinde"] = this.quellGemeinde;
        data["quellJahr"] = this.quellJahr;
        data["zielGemeinde"] = this.zielGemeinde;
        data["zielJahr"] = this.zielJahr;
        data["quellZeilen"] = this.quellZeilen;
        data["zielZeilen"] = this.zielZeilen;
        data["machbar"] = this.machbar;
        data["hinweis"] = this.hinweis;
        return data;
    }
}

export interface ITransferVorschauSchrittModel {
    key?: string | undefined;
    anzeige?: string | undefined;
    quellGemeinde?: number;
    quellJahr?: number | undefined;
    zielGemeinde?: number;
    zielJahr?: number | undefined;
    quellZeilen?: number;
    zielZeilen?: number;
    machbar?: boolean;
    hinweis?: string | undefined;
}

export class TransferZielGemeindeModel implements ITransferZielGemeindeModel {
    gemeinde?: number;
    name?: string | undefined;
    buchungsart?: number;
    inaktiv?: boolean;
    jahre?: number[] | undefined;

    constructor(data?: ITransferZielGemeindeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gemeinde = _data["gemeinde"];
            this.name = _data["name"];
            this.buchungsart = _data["buchungsart"];
            this.inaktiv = _data["inaktiv"];
            if (Array.isArray(_data["jahre"])) {
                this.jahre = [] as any;
                for (let item of _data["jahre"])
                    this.jahre!.push(item);
            }
        }
    }

    static fromJS(data: any): TransferZielGemeindeModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransferZielGemeindeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gemeinde"] = this.gemeinde;
        data["name"] = this.name;
        data["buchungsart"] = this.buchungsart;
        data["inaktiv"] = this.inaktiv;
        if (Array.isArray(this.jahre)) {
            data["jahre"] = [];
            for (let item of this.jahre)
                data["jahre"].push(item);
        }
        return data;
    }
}

export interface ITransferZielGemeindeModel {
    gemeinde?: number;
    name?: string | undefined;
    buchungsart?: number;
    inaktiv?: boolean;
    jahre?: number[] | undefined;
}

export class TransferZielModel implements ITransferZielModel {
    kunde?: number;
    name?: string | undefined;
    bundesland?: string | undefined;
    gemeinden?: TransferZielGemeindeModel[] | undefined;

    constructor(data?: ITransferZielModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.name = _data["name"];
            this.bundesland = _data["bundesland"];
            if (Array.isArray(_data["gemeinden"])) {
                this.gemeinden = [] as any;
                for (let item of _data["gemeinden"])
                    this.gemeinden!.push(TransferZielGemeindeModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransferZielModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransferZielModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["name"] = this.name;
        data["bundesland"] = this.bundesland;
        if (Array.isArray(this.gemeinden)) {
            data["gemeinden"] = [];
            for (let item of this.gemeinden)
                data["gemeinden"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITransferZielModel {
    kunde?: number;
    name?: string | undefined;
    bundesland?: string | undefined;
    gemeinden?: TransferZielGemeindeModel[] | undefined;
}

export class TransferZuordnungModel implements ITransferZuordnungModel {
    quellGemeinde?: number;
    quellJahr?: number;
    zielGemeinde?: number;
    zielJahr?: number;

    constructor(data?: ITransferZuordnungModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quellGemeinde = _data["quellGemeinde"];
            this.quellJahr = _data["quellJahr"];
            this.zielGemeinde = _data["zielGemeinde"];
            this.zielJahr = _data["zielJahr"];
        }
    }

    static fromJS(data: any): TransferZuordnungModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransferZuordnungModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quellGemeinde"] = this.quellGemeinde;
        data["quellJahr"] = this.quellJahr;
        data["zielGemeinde"] = this.zielGemeinde;
        data["zielJahr"] = this.zielJahr;
        return data;
    }
}

export interface ITransferZuordnungModel {
    quellGemeinde?: number;
    quellJahr?: number;
    zielGemeinde?: number;
    zielJahr?: number;
}

export class UHHSDoppischModel implements IUHHSDoppischModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    produkt?: number;
    konto?: number;
    bezeichnung?: string | undefined;
    produktText?: string | undefined;
    beschreibung?: string | undefined;
    beginnJahr?: number | undefined;
    endJahr?: number | undefined;
    manuell?: boolean | undefined;
    modifiziert?: boolean | undefined;
    produktEbene?: string | undefined;
    ansatzPjTerm?: string | undefined;
    kontoExtra?: string | undefined;
    gemeinden?: Gemeinden;
    readonly containsData?: boolean;
    massnahmen?: UHMNDoppischModel[] | undefined;
    ebenen?: string[] | undefined;
    guid?: string | undefined;
    edit?: boolean;
    isFinHH?: boolean;
    soll?: boolean;
    prognosekurve?: number;
    progsekurveTip?: string | undefined;
    fortAnsatzPJM1?: number;
    verfuegtPJM1?: number;
    istAo?: number;
    fortAnsatz?: number;
    verfuegt?: number;
    verfuegbar?: number;
    progAuto?: number;
    progAutoMehrGenPfl?: number;
    progAuto1?: number;
    progMan?: number | undefined;
    progManMehrGenPfl?: number;
    progManErr?: string | undefined;
    hasProgMan?: number;
    progKommentar?: string | undefined;
    progKommOeffentlich?: boolean;
    aenderungPJ?: number;
    ergebnis_PJM4?: number;
    ergebnis_PJM3?: number;
    ergebnis_PJM2?: number;
    ergebnis_PJM1?: number;
    rohDaten?: HaushaltsdatenUhdoppisch;

    constructor(data?: IUHHSDoppischModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.produkt = _data["produkt"];
            this.konto = _data["konto"];
            this.bezeichnung = _data["bezeichnung"];
            this.produktText = _data["produktText"];
            this.beschreibung = _data["beschreibung"];
            this.beginnJahr = _data["beginnJahr"];
            this.endJahr = _data["endJahr"];
            this.manuell = _data["manuell"];
            this.modifiziert = _data["modifiziert"];
            this.produktEbene = _data["produktEbene"];
            this.ansatzPjTerm = _data["ansatzPjTerm"];
            this.kontoExtra = _data["kontoExtra"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
            (<any>this).containsData = _data["containsData"];
            if (Array.isArray(_data["massnahmen"])) {
                this.massnahmen = [] as any;
                for (let item of _data["massnahmen"])
                    this.massnahmen!.push(UHMNDoppischModel.fromJS(item));
            }
            if (Array.isArray(_data["ebenen"])) {
                this.ebenen = [] as any;
                for (let item of _data["ebenen"])
                    this.ebenen!.push(item);
            }
            this.guid = _data["guid"];
            this.edit = _data["edit"];
            this.isFinHH = _data["isFinHH"];
            this.soll = _data["soll"];
            this.prognosekurve = _data["prognosekurve"];
            this.progsekurveTip = _data["progsekurveTip"];
            this.fortAnsatzPJM1 = _data["fortAnsatzPJM1"];
            this.verfuegtPJM1 = _data["verfuegtPJM1"];
            this.istAo = _data["istAo"];
            this.fortAnsatz = _data["fortAnsatz"];
            this.verfuegt = _data["verfuegt"];
            this.verfuegbar = _data["verfuegbar"];
            this.progAuto = _data["progAuto"];
            this.progAutoMehrGenPfl = _data["progAutoMehrGenPfl"];
            this.progAuto1 = _data["progAuto1"];
            this.progMan = _data["progMan"];
            this.progManMehrGenPfl = _data["progManMehrGenPfl"];
            this.progManErr = _data["progManErr"];
            this.hasProgMan = _data["hasProgMan"];
            this.progKommentar = _data["progKommentar"];
            this.progKommOeffentlich = _data["progKommOeffentlich"];
            this.aenderungPJ = _data["aenderungPJ"];
            this.ergebnis_PJM4 = _data["ergebnis_PJM4"];
            this.ergebnis_PJM3 = _data["ergebnis_PJM3"];
            this.ergebnis_PJM2 = _data["ergebnis_PJM2"];
            this.ergebnis_PJM1 = _data["ergebnis_PJM1"];
            this.rohDaten = _data["rohDaten"] ? HaushaltsdatenUhdoppisch.fromJS(_data["rohDaten"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UHHSDoppischModel {
        data = typeof data === 'object' ? data : {};
        let result = new UHHSDoppischModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["produkt"] = this.produkt;
        data["konto"] = this.konto;
        data["bezeichnung"] = this.bezeichnung;
        data["produktText"] = this.produktText;
        data["beschreibung"] = this.beschreibung;
        data["beginnJahr"] = this.beginnJahr;
        data["endJahr"] = this.endJahr;
        data["manuell"] = this.manuell;
        data["modifiziert"] = this.modifiziert;
        data["produktEbene"] = this.produktEbene;
        data["ansatzPjTerm"] = this.ansatzPjTerm;
        data["kontoExtra"] = this.kontoExtra;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        data["containsData"] = this.containsData;
        if (Array.isArray(this.massnahmen)) {
            data["massnahmen"] = [];
            for (let item of this.massnahmen)
                data["massnahmen"].push(item.toJSON());
        }
        if (Array.isArray(this.ebenen)) {
            data["ebenen"] = [];
            for (let item of this.ebenen)
                data["ebenen"].push(item);
        }
        data["guid"] = this.guid;
        data["edit"] = this.edit;
        data["isFinHH"] = this.isFinHH;
        data["soll"] = this.soll;
        data["prognosekurve"] = this.prognosekurve;
        data["progsekurveTip"] = this.progsekurveTip;
        data["fortAnsatzPJM1"] = this.fortAnsatzPJM1;
        data["verfuegtPJM1"] = this.verfuegtPJM1;
        data["istAo"] = this.istAo;
        data["fortAnsatz"] = this.fortAnsatz;
        data["verfuegt"] = this.verfuegt;
        data["verfuegbar"] = this.verfuegbar;
        data["progAuto"] = this.progAuto;
        data["progAutoMehrGenPfl"] = this.progAutoMehrGenPfl;
        data["progAuto1"] = this.progAuto1;
        data["progMan"] = this.progMan;
        data["progManMehrGenPfl"] = this.progManMehrGenPfl;
        data["progManErr"] = this.progManErr;
        data["hasProgMan"] = this.hasProgMan;
        data["progKommentar"] = this.progKommentar;
        data["progKommOeffentlich"] = this.progKommOeffentlich;
        data["aenderungPJ"] = this.aenderungPJ;
        data["ergebnis_PJM4"] = this.ergebnis_PJM4;
        data["ergebnis_PJM3"] = this.ergebnis_PJM3;
        data["ergebnis_PJM2"] = this.ergebnis_PJM2;
        data["ergebnis_PJM1"] = this.ergebnis_PJM1;
        data["rohDaten"] = this.rohDaten ? this.rohDaten.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUHHSDoppischModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    produkt?: number;
    konto?: number;
    bezeichnung?: string | undefined;
    produktText?: string | undefined;
    beschreibung?: string | undefined;
    beginnJahr?: number | undefined;
    endJahr?: number | undefined;
    manuell?: boolean | undefined;
    modifiziert?: boolean | undefined;
    produktEbene?: string | undefined;
    ansatzPjTerm?: string | undefined;
    kontoExtra?: string | undefined;
    gemeinden?: Gemeinden;
    containsData?: boolean;
    massnahmen?: UHMNDoppischModel[] | undefined;
    ebenen?: string[] | undefined;
    guid?: string | undefined;
    edit?: boolean;
    isFinHH?: boolean;
    soll?: boolean;
    prognosekurve?: number;
    progsekurveTip?: string | undefined;
    fortAnsatzPJM1?: number;
    verfuegtPJM1?: number;
    istAo?: number;
    fortAnsatz?: number;
    verfuegt?: number;
    verfuegbar?: number;
    progAuto?: number;
    progAutoMehrGenPfl?: number;
    progAuto1?: number;
    progMan?: number | undefined;
    progManMehrGenPfl?: number;
    progManErr?: string | undefined;
    hasProgMan?: number;
    progKommentar?: string | undefined;
    progKommOeffentlich?: boolean;
    aenderungPJ?: number;
    ergebnis_PJM4?: number;
    ergebnis_PJM3?: number;
    ergebnis_PJM2?: number;
    ergebnis_PJM1?: number;
    rohDaten?: HaushaltsdatenUhdoppisch;
}

export class UHHSKameralModel implements IUHHSKameralModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    unterabschnitt?: number;
    massnahme?: number | undefined;
    untergruppe?: number;
    unterkonto?: number;
    bezeichnung?: string | undefined;
    uatext?: string | undefined;
    ugtext?: string | undefined;
    beschreibung?: string | undefined;
    beginnJahr?: number | undefined;
    endJahr?: number | undefined;
    uastellen?: number | undefined;
    ugstellen?: number | undefined;
    manuell?: boolean | undefined;
    modifiziert?: boolean | undefined;
    gemeinden?: Gemeinden;
    massnahmeNavigation?: Massnahman;
    readonly containsData?: boolean;
    guid?: string | undefined;
    ebenen?: string[] | undefined;
    edit?: boolean;
    prognosekurve?: number;
    progsekurveTip?: string | undefined;
    istAo?: number;
    fortAnsatz?: number;
    verfuegt?: number;
    verfuegbar?: number;
    progAuto?: number;
    progAutoMehrGenPfl?: number;
    progAuto1?: number;
    progMan?: number | undefined;
    progManMehrGenPfl?: number;
    progManErr?: string | undefined;
    hasProgMan?: number;
    progKommentar?: string | undefined;
    progKommOeffentlich?: boolean;
    massnahmeNr?: number | undefined;
    aenderungPJ?: number;
    ergebnis_PJM4?: number;
    ergebnis_PJM3?: number;
    ergebnis_PJM2?: number;
    ergebnis_PJM1?: number;
    rohDaten?: HaushaltsdatenUhkameral;

    constructor(data?: IUHHSKameralModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.unterabschnitt = _data["unterabschnitt"];
            this.massnahme = _data["massnahme"];
            this.untergruppe = _data["untergruppe"];
            this.unterkonto = _data["unterkonto"];
            this.bezeichnung = _data["bezeichnung"];
            this.uatext = _data["uatext"];
            this.ugtext = _data["ugtext"];
            this.beschreibung = _data["beschreibung"];
            this.beginnJahr = _data["beginnJahr"];
            this.endJahr = _data["endJahr"];
            this.uastellen = _data["uastellen"];
            this.ugstellen = _data["ugstellen"];
            this.manuell = _data["manuell"];
            this.modifiziert = _data["modifiziert"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
            this.massnahmeNavigation = _data["massnahmeNavigation"] ? Massnahman.fromJS(_data["massnahmeNavigation"]) : <any>undefined;
            (<any>this).containsData = _data["containsData"];
            this.guid = _data["guid"];
            if (Array.isArray(_data["ebenen"])) {
                this.ebenen = [] as any;
                for (let item of _data["ebenen"])
                    this.ebenen!.push(item);
            }
            this.edit = _data["edit"];
            this.prognosekurve = _data["prognosekurve"];
            this.progsekurveTip = _data["progsekurveTip"];
            this.istAo = _data["istAo"];
            this.fortAnsatz = _data["fortAnsatz"];
            this.verfuegt = _data["verfuegt"];
            this.verfuegbar = _data["verfuegbar"];
            this.progAuto = _data["progAuto"];
            this.progAutoMehrGenPfl = _data["progAutoMehrGenPfl"];
            this.progAuto1 = _data["progAuto1"];
            this.progMan = _data["progMan"];
            this.progManMehrGenPfl = _data["progManMehrGenPfl"];
            this.progManErr = _data["progManErr"];
            this.hasProgMan = _data["hasProgMan"];
            this.progKommentar = _data["progKommentar"];
            this.progKommOeffentlich = _data["progKommOeffentlich"];
            this.massnahmeNr = _data["massnahmeNr"];
            this.aenderungPJ = _data["aenderungPJ"];
            this.ergebnis_PJM4 = _data["ergebnis_PJM4"];
            this.ergebnis_PJM3 = _data["ergebnis_PJM3"];
            this.ergebnis_PJM2 = _data["ergebnis_PJM2"];
            this.ergebnis_PJM1 = _data["ergebnis_PJM1"];
            this.rohDaten = _data["rohDaten"] ? HaushaltsdatenUhkameral.fromJS(_data["rohDaten"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UHHSKameralModel {
        data = typeof data === 'object' ? data : {};
        let result = new UHHSKameralModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["unterabschnitt"] = this.unterabschnitt;
        data["massnahme"] = this.massnahme;
        data["untergruppe"] = this.untergruppe;
        data["unterkonto"] = this.unterkonto;
        data["bezeichnung"] = this.bezeichnung;
        data["uatext"] = this.uatext;
        data["ugtext"] = this.ugtext;
        data["beschreibung"] = this.beschreibung;
        data["beginnJahr"] = this.beginnJahr;
        data["endJahr"] = this.endJahr;
        data["uastellen"] = this.uastellen;
        data["ugstellen"] = this.ugstellen;
        data["manuell"] = this.manuell;
        data["modifiziert"] = this.modifiziert;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        data["massnahmeNavigation"] = this.massnahmeNavigation ? this.massnahmeNavigation.toJSON() : <any>undefined;
        data["containsData"] = this.containsData;
        data["guid"] = this.guid;
        if (Array.isArray(this.ebenen)) {
            data["ebenen"] = [];
            for (let item of this.ebenen)
                data["ebenen"].push(item);
        }
        data["edit"] = this.edit;
        data["prognosekurve"] = this.prognosekurve;
        data["progsekurveTip"] = this.progsekurveTip;
        data["istAo"] = this.istAo;
        data["fortAnsatz"] = this.fortAnsatz;
        data["verfuegt"] = this.verfuegt;
        data["verfuegbar"] = this.verfuegbar;
        data["progAuto"] = this.progAuto;
        data["progAutoMehrGenPfl"] = this.progAutoMehrGenPfl;
        data["progAuto1"] = this.progAuto1;
        data["progMan"] = this.progMan;
        data["progManMehrGenPfl"] = this.progManMehrGenPfl;
        data["progManErr"] = this.progManErr;
        data["hasProgMan"] = this.hasProgMan;
        data["progKommentar"] = this.progKommentar;
        data["progKommOeffentlich"] = this.progKommOeffentlich;
        data["massnahmeNr"] = this.massnahmeNr;
        data["aenderungPJ"] = this.aenderungPJ;
        data["ergebnis_PJM4"] = this.ergebnis_PJM4;
        data["ergebnis_PJM3"] = this.ergebnis_PJM3;
        data["ergebnis_PJM2"] = this.ergebnis_PJM2;
        data["ergebnis_PJM1"] = this.ergebnis_PJM1;
        data["rohDaten"] = this.rohDaten ? this.rohDaten.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUHHSKameralModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    unterabschnitt?: number;
    massnahme?: number | undefined;
    untergruppe?: number;
    unterkonto?: number;
    bezeichnung?: string | undefined;
    uatext?: string | undefined;
    ugtext?: string | undefined;
    beschreibung?: string | undefined;
    beginnJahr?: number | undefined;
    endJahr?: number | undefined;
    uastellen?: number | undefined;
    ugstellen?: number | undefined;
    manuell?: boolean | undefined;
    modifiziert?: boolean | undefined;
    gemeinden?: Gemeinden;
    massnahmeNavigation?: Massnahman;
    containsData?: boolean;
    guid?: string | undefined;
    ebenen?: string[] | undefined;
    edit?: boolean;
    prognosekurve?: number;
    progsekurveTip?: string | undefined;
    istAo?: number;
    fortAnsatz?: number;
    verfuegt?: number;
    verfuegbar?: number;
    progAuto?: number;
    progAutoMehrGenPfl?: number;
    progAuto1?: number;
    progMan?: number | undefined;
    progManMehrGenPfl?: number;
    progManErr?: string | undefined;
    hasProgMan?: number;
    progKommentar?: string | undefined;
    progKommOeffentlich?: boolean;
    massnahmeNr?: number | undefined;
    aenderungPJ?: number;
    ergebnis_PJM4?: number;
    ergebnis_PJM3?: number;
    ergebnis_PJM2?: number;
    ergebnis_PJM1?: number;
    rohDaten?: HaushaltsdatenUhkameral;
}

export class UHMNDoppischModel implements IUHMNDoppischModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    konto?: number;
    bestandsKonto?: string | undefined;
    investNr?: string | undefined;
    investPos?: number;
    produkt?: number;
    bezeichnung?: string | undefined;
    beschreibung?: string | undefined;
    beginDatum?: Date | undefined;
    endDatum?: Date | undefined;
    bestandsKontoText?: string | undefined;
    kurzbezeichnung?: string | undefined;
    suchtext?: string | undefined;
    investPosText?: string | undefined;
    teilhaushalt?: string | undefined;
    ansatzPjTerm?: string | undefined;
    kontoExtra?: string | undefined;
    gemeinden?: Gemeinden;
    readonly containsData?: boolean;
    guid?: string | undefined;
    edit?: boolean;
    isFinHH?: boolean;
    soll?: boolean;
    prognosekurve?: number;
    progsekurveTip?: string | undefined;
    fortAnsatzPJM1?: number;
    verfuegtPJM1?: number;
    istAo?: number;
    fortAnsatz?: number;
    verfuegt?: number;
    verfuegbar?: number;
    progAuto?: number;
    progAuto1?: number;
    progMan?: number | undefined;
    progManErr?: string | undefined;
    hasProgMan?: number;
    progKommentar?: string | undefined;
    progKommOeffentlich?: boolean;
    aenderungPJ?: number;
    ergebnis_PJM4?: number;
    ergebnis_PJM3?: number;
    ergebnis_PJM2?: number;
    ergebnis_PJM1?: number;
    rohDaten?: MassnahmendatenUhdoppisch;

    constructor(data?: IUHMNDoppischModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.konto = _data["konto"];
            this.bestandsKonto = _data["bestandsKonto"];
            this.investNr = _data["investNr"];
            this.investPos = _data["investPos"];
            this.produkt = _data["produkt"];
            this.bezeichnung = _data["bezeichnung"];
            this.beschreibung = _data["beschreibung"];
            this.beginDatum = _data["beginDatum"] ? new Date(_data["beginDatum"].toString()) : <any>undefined;
            this.endDatum = _data["endDatum"] ? new Date(_data["endDatum"].toString()) : <any>undefined;
            this.bestandsKontoText = _data["bestandsKontoText"];
            this.kurzbezeichnung = _data["kurzbezeichnung"];
            this.suchtext = _data["suchtext"];
            this.investPosText = _data["investPosText"];
            this.teilhaushalt = _data["teilhaushalt"];
            this.ansatzPjTerm = _data["ansatzPjTerm"];
            this.kontoExtra = _data["kontoExtra"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
            (<any>this).containsData = _data["containsData"];
            this.guid = _data["guid"];
            this.edit = _data["edit"];
            this.isFinHH = _data["isFinHH"];
            this.soll = _data["soll"];
            this.prognosekurve = _data["prognosekurve"];
            this.progsekurveTip = _data["progsekurveTip"];
            this.fortAnsatzPJM1 = _data["fortAnsatzPJM1"];
            this.verfuegtPJM1 = _data["verfuegtPJM1"];
            this.istAo = _data["istAo"];
            this.fortAnsatz = _data["fortAnsatz"];
            this.verfuegt = _data["verfuegt"];
            this.verfuegbar = _data["verfuegbar"];
            this.progAuto = _data["progAuto"];
            this.progAuto1 = _data["progAuto1"];
            this.progMan = _data["progMan"];
            this.progManErr = _data["progManErr"];
            this.hasProgMan = _data["hasProgMan"];
            this.progKommentar = _data["progKommentar"];
            this.progKommOeffentlich = _data["progKommOeffentlich"];
            this.aenderungPJ = _data["aenderungPJ"];
            this.ergebnis_PJM4 = _data["ergebnis_PJM4"];
            this.ergebnis_PJM3 = _data["ergebnis_PJM3"];
            this.ergebnis_PJM2 = _data["ergebnis_PJM2"];
            this.ergebnis_PJM1 = _data["ergebnis_PJM1"];
            this.rohDaten = _data["rohDaten"] ? MassnahmendatenUhdoppisch.fromJS(_data["rohDaten"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UHMNDoppischModel {
        data = typeof data === 'object' ? data : {};
        let result = new UHMNDoppischModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["konto"] = this.konto;
        data["bestandsKonto"] = this.bestandsKonto;
        data["investNr"] = this.investNr;
        data["investPos"] = this.investPos;
        data["produkt"] = this.produkt;
        data["bezeichnung"] = this.bezeichnung;
        data["beschreibung"] = this.beschreibung;
        data["beginDatum"] = this.beginDatum ? this.beginDatum.toISOString() : <any>undefined;
        data["endDatum"] = this.endDatum ? this.endDatum.toISOString() : <any>undefined;
        data["bestandsKontoText"] = this.bestandsKontoText;
        data["kurzbezeichnung"] = this.kurzbezeichnung;
        data["suchtext"] = this.suchtext;
        data["investPosText"] = this.investPosText;
        data["teilhaushalt"] = this.teilhaushalt;
        data["ansatzPjTerm"] = this.ansatzPjTerm;
        data["kontoExtra"] = this.kontoExtra;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        data["containsData"] = this.containsData;
        data["guid"] = this.guid;
        data["edit"] = this.edit;
        data["isFinHH"] = this.isFinHH;
        data["soll"] = this.soll;
        data["prognosekurve"] = this.prognosekurve;
        data["progsekurveTip"] = this.progsekurveTip;
        data["fortAnsatzPJM1"] = this.fortAnsatzPJM1;
        data["verfuegtPJM1"] = this.verfuegtPJM1;
        data["istAo"] = this.istAo;
        data["fortAnsatz"] = this.fortAnsatz;
        data["verfuegt"] = this.verfuegt;
        data["verfuegbar"] = this.verfuegbar;
        data["progAuto"] = this.progAuto;
        data["progAuto1"] = this.progAuto1;
        data["progMan"] = this.progMan;
        data["progManErr"] = this.progManErr;
        data["hasProgMan"] = this.hasProgMan;
        data["progKommentar"] = this.progKommentar;
        data["progKommOeffentlich"] = this.progKommOeffentlich;
        data["aenderungPJ"] = this.aenderungPJ;
        data["ergebnis_PJM4"] = this.ergebnis_PJM4;
        data["ergebnis_PJM3"] = this.ergebnis_PJM3;
        data["ergebnis_PJM2"] = this.ergebnis_PJM2;
        data["ergebnis_PJM1"] = this.ergebnis_PJM1;
        data["rohDaten"] = this.rohDaten ? this.rohDaten.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUHMNDoppischModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    konto?: number;
    bestandsKonto?: string | undefined;
    investNr?: string | undefined;
    investPos?: number;
    produkt?: number;
    bezeichnung?: string | undefined;
    beschreibung?: string | undefined;
    beginDatum?: Date | undefined;
    endDatum?: Date | undefined;
    bestandsKontoText?: string | undefined;
    kurzbezeichnung?: string | undefined;
    suchtext?: string | undefined;
    investPosText?: string | undefined;
    teilhaushalt?: string | undefined;
    ansatzPjTerm?: string | undefined;
    kontoExtra?: string | undefined;
    gemeinden?: Gemeinden;
    containsData?: boolean;
    guid?: string | undefined;
    edit?: boolean;
    isFinHH?: boolean;
    soll?: boolean;
    prognosekurve?: number;
    progsekurveTip?: string | undefined;
    fortAnsatzPJM1?: number;
    verfuegtPJM1?: number;
    istAo?: number;
    fortAnsatz?: number;
    verfuegt?: number;
    verfuegbar?: number;
    progAuto?: number;
    progAuto1?: number;
    progMan?: number | undefined;
    progManErr?: string | undefined;
    hasProgMan?: number;
    progKommentar?: string | undefined;
    progKommOeffentlich?: boolean;
    aenderungPJ?: number;
    ergebnis_PJM4?: number;
    ergebnis_PJM3?: number;
    ergebnis_PJM2?: number;
    ergebnis_PJM1?: number;
    rohDaten?: MassnahmendatenUhdoppisch;
}

export class Ubwsetting implements IUbwsetting {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    pmRoundE?: number;
    pmRoundEbetrag?: number;
    pmRoundA?: number;
    pmRoundAbetrag?: number;
    haagZr?: string | undefined;
    haagEr?: string | undefined;
    haagZvVonVw?: string | undefined;
    haagZvZumVw?: string | undefined;
    haagAuto?: boolean | undefined;
    haagZvVonVm?: string | undefined;
    haagZvZumVm?: string | undefined;
    haagKt?: string | undefined;
    haagPmKommentar?: string | undefined;

    constructor(data?: IUbwsetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.pmRoundE = _data["pmRoundE"];
            this.pmRoundEbetrag = _data["pmRoundEbetrag"];
            this.pmRoundA = _data["pmRoundA"];
            this.pmRoundAbetrag = _data["pmRoundAbetrag"];
            this.haagZr = _data["haagZr"];
            this.haagEr = _data["haagEr"];
            this.haagZvVonVw = _data["haagZvVonVw"];
            this.haagZvZumVw = _data["haagZvZumVw"];
            this.haagAuto = _data["haagAuto"];
            this.haagZvVonVm = _data["haagZvVonVm"];
            this.haagZvZumVm = _data["haagZvZumVm"];
            this.haagKt = _data["haagKt"];
            this.haagPmKommentar = _data["haagPmKommentar"];
        }
    }

    static fromJS(data: any): Ubwsetting {
        data = typeof data === 'object' ? data : {};
        let result = new Ubwsetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["pmRoundE"] = this.pmRoundE;
        data["pmRoundEbetrag"] = this.pmRoundEbetrag;
        data["pmRoundA"] = this.pmRoundA;
        data["pmRoundAbetrag"] = this.pmRoundAbetrag;
        data["haagZr"] = this.haagZr;
        data["haagEr"] = this.haagEr;
        data["haagZvVonVw"] = this.haagZvVonVw;
        data["haagZvZumVw"] = this.haagZvZumVw;
        data["haagAuto"] = this.haagAuto;
        data["haagZvVonVm"] = this.haagZvVonVm;
        data["haagZvZumVm"] = this.haagZvZumVm;
        data["haagKt"] = this.haagKt;
        data["haagPmKommentar"] = this.haagPmKommentar;
        return data;
    }
}

export interface IUbwsetting {
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    pmRoundE?: number;
    pmRoundEbetrag?: number;
    pmRoundA?: number;
    pmRoundAbetrag?: number;
    haagZr?: string | undefined;
    haagEr?: string | undefined;
    haagZvVonVw?: string | undefined;
    haagZvZumVw?: string | undefined;
    haagAuto?: boolean | undefined;
    haagZvVonVm?: string | undefined;
    haagZvZumVm?: string | undefined;
    haagKt?: string | undefined;
    haagPmKommentar?: string | undefined;
}

export class UhConfigModel implements IUhConfigModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    beschreibung?: string | undefined;
    fortAnsatzSpalten?: string | undefined;
    verfuegtSpalten?: string | undefined;
    bilanzKonten?: boolean | undefined;
    ergKonten?: boolean | undefined;
    finKonten?: boolean | undefined;
    progBerechnung?: number | undefined;
    hfarbeProgMan?: string | undefined;
    vfarbeProgMan?: string | undefined;
    progIsVerfuegtWennGsnull?: boolean | undefined;
    verfuegtSpaltenFin?: string | undefined;
    verfuegtFinName?: string | undefined;
    verfuegt4ProgSpalten?: string | undefined;
    verfuegt4ProgSpaltenFin?: string | undefined;
    verfuegt4ProgTerm?: string | undefined;
    verfuegt4ProgTermFin?: string | undefined;
    gemeinden?: Gemeinden;
    fortAnsatzSpaltenDic?: { [key: string]: boolean; } | undefined;
    verfuegtSpaltenDic?: { [key: string]: boolean; } | undefined;
    verfuegtSpaltenFinDic?: { [key: string]: boolean; } | undefined;
    verfuegtSpalten4ProgDic?: { [key: string]: boolean; } | undefined;
    verfuegtSpalten4ProgFinDic?: { [key: string]: boolean; } | undefined;

    constructor(data?: IUhConfigModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.bezeichnung = _data["bezeichnung"];
            this.beschreibung = _data["beschreibung"];
            this.fortAnsatzSpalten = _data["fortAnsatzSpalten"];
            this.verfuegtSpalten = _data["verfuegtSpalten"];
            this.bilanzKonten = _data["bilanzKonten"];
            this.ergKonten = _data["ergKonten"];
            this.finKonten = _data["finKonten"];
            this.progBerechnung = _data["progBerechnung"];
            this.hfarbeProgMan = _data["hfarbeProgMan"];
            this.vfarbeProgMan = _data["vfarbeProgMan"];
            this.progIsVerfuegtWennGsnull = _data["progIsVerfuegtWennGsnull"];
            this.verfuegtSpaltenFin = _data["verfuegtSpaltenFin"];
            this.verfuegtFinName = _data["verfuegtFinName"];
            this.verfuegt4ProgSpalten = _data["verfuegt4ProgSpalten"];
            this.verfuegt4ProgSpaltenFin = _data["verfuegt4ProgSpaltenFin"];
            this.verfuegt4ProgTerm = _data["verfuegt4ProgTerm"];
            this.verfuegt4ProgTermFin = _data["verfuegt4ProgTermFin"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
            if (_data["fortAnsatzSpaltenDic"]) {
                this.fortAnsatzSpaltenDic = {} as any;
                for (let key in _data["fortAnsatzSpaltenDic"]) {
                    if (_data["fortAnsatzSpaltenDic"].hasOwnProperty(key))
                        (<any>this.fortAnsatzSpaltenDic)![key] = _data["fortAnsatzSpaltenDic"][key];
                }
            }
            if (_data["verfuegtSpaltenDic"]) {
                this.verfuegtSpaltenDic = {} as any;
                for (let key in _data["verfuegtSpaltenDic"]) {
                    if (_data["verfuegtSpaltenDic"].hasOwnProperty(key))
                        (<any>this.verfuegtSpaltenDic)![key] = _data["verfuegtSpaltenDic"][key];
                }
            }
            if (_data["verfuegtSpaltenFinDic"]) {
                this.verfuegtSpaltenFinDic = {} as any;
                for (let key in _data["verfuegtSpaltenFinDic"]) {
                    if (_data["verfuegtSpaltenFinDic"].hasOwnProperty(key))
                        (<any>this.verfuegtSpaltenFinDic)![key] = _data["verfuegtSpaltenFinDic"][key];
                }
            }
            if (_data["verfuegtSpalten4ProgDic"]) {
                this.verfuegtSpalten4ProgDic = {} as any;
                for (let key in _data["verfuegtSpalten4ProgDic"]) {
                    if (_data["verfuegtSpalten4ProgDic"].hasOwnProperty(key))
                        (<any>this.verfuegtSpalten4ProgDic)![key] = _data["verfuegtSpalten4ProgDic"][key];
                }
            }
            if (_data["verfuegtSpalten4ProgFinDic"]) {
                this.verfuegtSpalten4ProgFinDic = {} as any;
                for (let key in _data["verfuegtSpalten4ProgFinDic"]) {
                    if (_data["verfuegtSpalten4ProgFinDic"].hasOwnProperty(key))
                        (<any>this.verfuegtSpalten4ProgFinDic)![key] = _data["verfuegtSpalten4ProgFinDic"][key];
                }
            }
        }
    }

    static fromJS(data: any): UhConfigModel {
        data = typeof data === 'object' ? data : {};
        let result = new UhConfigModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["bezeichnung"] = this.bezeichnung;
        data["beschreibung"] = this.beschreibung;
        data["fortAnsatzSpalten"] = this.fortAnsatzSpalten;
        data["verfuegtSpalten"] = this.verfuegtSpalten;
        data["bilanzKonten"] = this.bilanzKonten;
        data["ergKonten"] = this.ergKonten;
        data["finKonten"] = this.finKonten;
        data["progBerechnung"] = this.progBerechnung;
        data["hfarbeProgMan"] = this.hfarbeProgMan;
        data["vfarbeProgMan"] = this.vfarbeProgMan;
        data["progIsVerfuegtWennGsnull"] = this.progIsVerfuegtWennGsnull;
        data["verfuegtSpaltenFin"] = this.verfuegtSpaltenFin;
        data["verfuegtFinName"] = this.verfuegtFinName;
        data["verfuegt4ProgSpalten"] = this.verfuegt4ProgSpalten;
        data["verfuegt4ProgSpaltenFin"] = this.verfuegt4ProgSpaltenFin;
        data["verfuegt4ProgTerm"] = this.verfuegt4ProgTerm;
        data["verfuegt4ProgTermFin"] = this.verfuegt4ProgTermFin;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        if (this.fortAnsatzSpaltenDic) {
            data["fortAnsatzSpaltenDic"] = {};
            for (let key in this.fortAnsatzSpaltenDic) {
                if (this.fortAnsatzSpaltenDic.hasOwnProperty(key))
                    (<any>data["fortAnsatzSpaltenDic"])[key] = (<any>this.fortAnsatzSpaltenDic)[key];
            }
        }
        if (this.verfuegtSpaltenDic) {
            data["verfuegtSpaltenDic"] = {};
            for (let key in this.verfuegtSpaltenDic) {
                if (this.verfuegtSpaltenDic.hasOwnProperty(key))
                    (<any>data["verfuegtSpaltenDic"])[key] = (<any>this.verfuegtSpaltenDic)[key];
            }
        }
        if (this.verfuegtSpaltenFinDic) {
            data["verfuegtSpaltenFinDic"] = {};
            for (let key in this.verfuegtSpaltenFinDic) {
                if (this.verfuegtSpaltenFinDic.hasOwnProperty(key))
                    (<any>data["verfuegtSpaltenFinDic"])[key] = (<any>this.verfuegtSpaltenFinDic)[key];
            }
        }
        if (this.verfuegtSpalten4ProgDic) {
            data["verfuegtSpalten4ProgDic"] = {};
            for (let key in this.verfuegtSpalten4ProgDic) {
                if (this.verfuegtSpalten4ProgDic.hasOwnProperty(key))
                    (<any>data["verfuegtSpalten4ProgDic"])[key] = (<any>this.verfuegtSpalten4ProgDic)[key];
            }
        }
        if (this.verfuegtSpalten4ProgFinDic) {
            data["verfuegtSpalten4ProgFinDic"] = {};
            for (let key in this.verfuegtSpalten4ProgFinDic) {
                if (this.verfuegtSpalten4ProgFinDic.hasOwnProperty(key))
                    (<any>data["verfuegtSpalten4ProgFinDic"])[key] = (<any>this.verfuegtSpalten4ProgFinDic)[key];
            }
        }
        return data;
    }
}

export interface IUhConfigModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    beschreibung?: string | undefined;
    fortAnsatzSpalten?: string | undefined;
    verfuegtSpalten?: string | undefined;
    bilanzKonten?: boolean | undefined;
    ergKonten?: boolean | undefined;
    finKonten?: boolean | undefined;
    progBerechnung?: number | undefined;
    hfarbeProgMan?: string | undefined;
    vfarbeProgMan?: string | undefined;
    progIsVerfuegtWennGsnull?: boolean | undefined;
    verfuegtSpaltenFin?: string | undefined;
    verfuegtFinName?: string | undefined;
    verfuegt4ProgSpalten?: string | undefined;
    verfuegt4ProgSpaltenFin?: string | undefined;
    verfuegt4ProgTerm?: string | undefined;
    verfuegt4ProgTermFin?: string | undefined;
    gemeinden?: Gemeinden;
    fortAnsatzSpaltenDic?: { [key: string]: boolean; } | undefined;
    verfuegtSpaltenDic?: { [key: string]: boolean; } | undefined;
    verfuegtSpaltenFinDic?: { [key: string]: boolean; } | undefined;
    verfuegtSpalten4ProgDic?: { [key: string]: boolean; } | undefined;
    verfuegtSpalten4ProgFinDic?: { [key: string]: boolean; } | undefined;
}

export class Uhconfig implements IUhconfig {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    beschreibung?: string | undefined;
    fortAnsatzSpalten?: string | undefined;
    verfuegtSpalten?: string | undefined;
    bilanzKonten?: boolean | undefined;
    ergKonten?: boolean | undefined;
    finKonten?: boolean | undefined;
    progBerechnung?: number | undefined;
    hfarbeProgMan?: string | undefined;
    vfarbeProgMan?: string | undefined;
    progIsVerfuegtWennGsnull?: boolean | undefined;
    verfuegtSpaltenFin?: string | undefined;
    verfuegtFinName?: string | undefined;
    verfuegt4ProgSpalten?: string | undefined;
    verfuegt4ProgSpaltenFin?: string | undefined;
    verfuegt4ProgTerm?: string | undefined;
    verfuegt4ProgTermFin?: string | undefined;
    gemeinden?: Gemeinden;

    constructor(data?: IUhconfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.bezeichnung = _data["bezeichnung"];
            this.beschreibung = _data["beschreibung"];
            this.fortAnsatzSpalten = _data["fortAnsatzSpalten"];
            this.verfuegtSpalten = _data["verfuegtSpalten"];
            this.bilanzKonten = _data["bilanzKonten"];
            this.ergKonten = _data["ergKonten"];
            this.finKonten = _data["finKonten"];
            this.progBerechnung = _data["progBerechnung"];
            this.hfarbeProgMan = _data["hfarbeProgMan"];
            this.vfarbeProgMan = _data["vfarbeProgMan"];
            this.progIsVerfuegtWennGsnull = _data["progIsVerfuegtWennGsnull"];
            this.verfuegtSpaltenFin = _data["verfuegtSpaltenFin"];
            this.verfuegtFinName = _data["verfuegtFinName"];
            this.verfuegt4ProgSpalten = _data["verfuegt4ProgSpalten"];
            this.verfuegt4ProgSpaltenFin = _data["verfuegt4ProgSpaltenFin"];
            this.verfuegt4ProgTerm = _data["verfuegt4ProgTerm"];
            this.verfuegt4ProgTermFin = _data["verfuegt4ProgTermFin"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Uhconfig {
        data = typeof data === 'object' ? data : {};
        let result = new Uhconfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["bezeichnung"] = this.bezeichnung;
        data["beschreibung"] = this.beschreibung;
        data["fortAnsatzSpalten"] = this.fortAnsatzSpalten;
        data["verfuegtSpalten"] = this.verfuegtSpalten;
        data["bilanzKonten"] = this.bilanzKonten;
        data["ergKonten"] = this.ergKonten;
        data["finKonten"] = this.finKonten;
        data["progBerechnung"] = this.progBerechnung;
        data["hfarbeProgMan"] = this.hfarbeProgMan;
        data["vfarbeProgMan"] = this.vfarbeProgMan;
        data["progIsVerfuegtWennGsnull"] = this.progIsVerfuegtWennGsnull;
        data["verfuegtSpaltenFin"] = this.verfuegtSpaltenFin;
        data["verfuegtFinName"] = this.verfuegtFinName;
        data["verfuegt4ProgSpalten"] = this.verfuegt4ProgSpalten;
        data["verfuegt4ProgSpaltenFin"] = this.verfuegt4ProgSpaltenFin;
        data["verfuegt4ProgTerm"] = this.verfuegt4ProgTerm;
        data["verfuegt4ProgTermFin"] = this.verfuegt4ProgTermFin;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUhconfig {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    beschreibung?: string | undefined;
    fortAnsatzSpalten?: string | undefined;
    verfuegtSpalten?: string | undefined;
    bilanzKonten?: boolean | undefined;
    ergKonten?: boolean | undefined;
    finKonten?: boolean | undefined;
    progBerechnung?: number | undefined;
    hfarbeProgMan?: string | undefined;
    vfarbeProgMan?: string | undefined;
    progIsVerfuegtWennGsnull?: boolean | undefined;
    verfuegtSpaltenFin?: string | undefined;
    verfuegtFinName?: string | undefined;
    verfuegt4ProgSpalten?: string | undefined;
    verfuegt4ProgSpaltenFin?: string | undefined;
    verfuegt4ProgTerm?: string | undefined;
    verfuegt4ProgTermFin?: string | undefined;
    gemeinden?: Gemeinden;
}

export class UhplatzhalterBetrachtungsTypenDoppisch implements IUhplatzhalterBetrachtungsTypenDoppisch {
    id?: string | undefined;
    bezeichnung?: string | undefined;

    constructor(data?: IUhplatzhalterBetrachtungsTypenDoppisch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
        }
    }

    static fromJS(data: any): UhplatzhalterBetrachtungsTypenDoppisch {
        data = typeof data === 'object' ? data : {};
        let result = new UhplatzhalterBetrachtungsTypenDoppisch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        return data;
    }
}

export interface IUhplatzhalterBetrachtungsTypenDoppisch {
    id?: string | undefined;
    bezeichnung?: string | undefined;
}

export class UhplatzhalterBetrachtungsTypenKameral implements IUhplatzhalterBetrachtungsTypenKameral {
    id?: string | undefined;
    bezeichnung?: string | undefined;

    constructor(data?: IUhplatzhalterBetrachtungsTypenKameral) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
        }
    }

    static fromJS(data: any): UhplatzhalterBetrachtungsTypenKameral {
        data = typeof data === 'object' ? data : {};
        let result = new UhplatzhalterBetrachtungsTypenKameral();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        return data;
    }
}

export interface IUhplatzhalterBetrachtungsTypenKameral {
    id?: string | undefined;
    bezeichnung?: string | undefined;
}

export class UhplatzhalterJahre implements IUhplatzhalterJahre {
    jahr?: number | undefined;
    bezeichnung?: string | undefined;

    constructor(data?: IUhplatzhalterJahre) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jahr = _data["jahr"];
            this.bezeichnung = _data["bezeichnung"];
        }
    }

    static fromJS(data: any): UhplatzhalterJahre {
        data = typeof data === 'object' ? data : {};
        let result = new UhplatzhalterJahre();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jahr"] = this.jahr;
        data["bezeichnung"] = this.bezeichnung;
        return data;
    }
}

export interface IUhplatzhalterJahre {
    jahr?: number | undefined;
    bezeichnung?: string | undefined;
}

export class UhplatzhalterTypenDoppisch implements IUhplatzhalterTypenDoppisch {
    id?: string | undefined;
    bezeichnung?: string | undefined;
    system?: boolean | undefined;

    constructor(data?: IUhplatzhalterTypenDoppisch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
            this.system = _data["system"];
        }
    }

    static fromJS(data: any): UhplatzhalterTypenDoppisch {
        data = typeof data === 'object' ? data : {};
        let result = new UhplatzhalterTypenDoppisch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        data["system"] = this.system;
        return data;
    }
}

export interface IUhplatzhalterTypenDoppisch {
    id?: string | undefined;
    bezeichnung?: string | undefined;
    system?: boolean | undefined;
}

export class UhplatzhalterTypenKameral implements IUhplatzhalterTypenKameral {
    id?: string | undefined;
    bezeichnung?: string | undefined;
    system?: boolean | undefined;

    constructor(data?: IUhplatzhalterTypenKameral) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
            this.system = _data["system"];
        }
    }

    static fromJS(data: any): UhplatzhalterTypenKameral {
        data = typeof data === 'object' ? data : {};
        let result = new UhplatzhalterTypenKameral();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        data["system"] = this.system;
        return data;
    }
}

export interface IUhplatzhalterTypenKameral {
    id?: string | undefined;
    bezeichnung?: string | undefined;
    system?: boolean | undefined;
}

export class Umbuchungen implements IUmbuchungen {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    quellKonten?: string | undefined;
    bedingung?: number;
    negieren?: boolean;
    zielKonto?: string | undefined;
    order?: number | undefined;

    constructor(data?: IUmbuchungen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.quellKonten = _data["quellKonten"];
            this.bedingung = _data["bedingung"];
            this.negieren = _data["negieren"];
            this.zielKonto = _data["zielKonto"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): Umbuchungen {
        data = typeof data === 'object' ? data : {};
        let result = new Umbuchungen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["quellKonten"] = this.quellKonten;
        data["bedingung"] = this.bedingung;
        data["negieren"] = this.negieren;
        data["zielKonto"] = this.zielKonto;
        data["order"] = this.order;
        return data;
    }
}

export interface IUmbuchungen {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    quellKonten?: string | undefined;
    bedingung?: number;
    negieren?: boolean;
    zielKonto?: string | undefined;
    order?: number | undefined;
}

export enum UnderlineStyle {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export enum UnderlineType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum Unit {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class UniversalPlatzhalterBetrachtungsTypenDoppisch implements IUniversalPlatzhalterBetrachtungsTypenDoppisch {
    id?: string | undefined;
    bezeichnung?: string | undefined;

    constructor(data?: IUniversalPlatzhalterBetrachtungsTypenDoppisch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
        }
    }

    static fromJS(data: any): UniversalPlatzhalterBetrachtungsTypenDoppisch {
        data = typeof data === 'object' ? data : {};
        let result = new UniversalPlatzhalterBetrachtungsTypenDoppisch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        return data;
    }
}

export interface IUniversalPlatzhalterBetrachtungsTypenDoppisch {
    id?: string | undefined;
    bezeichnung?: string | undefined;
}

export class UniversalPlatzhalterJahre implements IUniversalPlatzhalterJahre {
    jahr?: number | undefined;
    bezeichnung?: string | undefined;

    constructor(data?: IUniversalPlatzhalterJahre) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jahr = _data["jahr"];
            this.bezeichnung = _data["bezeichnung"];
        }
    }

    static fromJS(data: any): UniversalPlatzhalterJahre {
        data = typeof data === 'object' ? data : {};
        let result = new UniversalPlatzhalterJahre();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jahr"] = this.jahr;
        data["bezeichnung"] = this.bezeichnung;
        return data;
    }
}

export interface IUniversalPlatzhalterJahre {
    jahr?: number | undefined;
    bezeichnung?: string | undefined;
}

export class UniversalPlatzhalterTypenDoppisch implements IUniversalPlatzhalterTypenDoppisch {
    id?: string | undefined;
    bezeichnung?: string | undefined;

    constructor(data?: IUniversalPlatzhalterTypenDoppisch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
        }
    }

    static fromJS(data: any): UniversalPlatzhalterTypenDoppisch {
        data = typeof data === 'object' ? data : {};
        let result = new UniversalPlatzhalterTypenDoppisch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        return data;
    }
}

export interface IUniversalPlatzhalterTypenDoppisch {
    id?: string | undefined;
    bezeichnung?: string | undefined;
}

export class Upload implements IUpload {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    plantyp?: number | undefined;
    planstufe?: number | undefined;
    userId?: string | undefined;
    datum?: Date;
    orgDateiName?: string | undefined;
    dateiname?: string | undefined;
    importFormat?: number;
    typ?: number;
    status?: number | undefined;
    ergebnis?: string | undefined;

    constructor(data?: IUpload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.plantyp = _data["plantyp"];
            this.planstufe = _data["planstufe"];
            this.userId = _data["userId"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
            this.orgDateiName = _data["orgDateiName"];
            this.dateiname = _data["dateiname"];
            this.importFormat = _data["importFormat"];
            this.typ = _data["typ"];
            this.status = _data["status"];
            this.ergebnis = _data["ergebnis"];
        }
    }

    static fromJS(data: any): Upload {
        data = typeof data === 'object' ? data : {};
        let result = new Upload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["plantyp"] = this.plantyp;
        data["planstufe"] = this.planstufe;
        data["userId"] = this.userId;
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        data["orgDateiName"] = this.orgDateiName;
        data["dateiname"] = this.dateiname;
        data["importFormat"] = this.importFormat;
        data["typ"] = this.typ;
        data["status"] = this.status;
        data["ergebnis"] = this.ergebnis;
        return data;
    }
}

export interface IUpload {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    plantyp?: number | undefined;
    planstufe?: number | undefined;
    userId?: string | undefined;
    datum?: Date;
    orgDateiName?: string | undefined;
    dateiname?: string | undefined;
    importFormat?: number;
    typ?: number;
    status?: number | undefined;
    ergebnis?: string | undefined;
}

export class User2AmtModel implements IUser2AmtModel {
    gemeinde?: Gemeinden;
    amt?: Ebenen;
    jahr?: number;
    set?: boolean;
    bereitsZugewiesen?: boolean;
    id?: string | undefined;

    constructor(data?: IUser2AmtModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gemeinde = _data["gemeinde"] ? Gemeinden.fromJS(_data["gemeinde"]) : <any>undefined;
            this.amt = _data["amt"] ? Ebenen.fromJS(_data["amt"]) : <any>undefined;
            this.jahr = _data["jahr"];
            this.set = _data["set"];
            this.bereitsZugewiesen = _data["bereitsZugewiesen"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): User2AmtModel {
        data = typeof data === 'object' ? data : {};
        let result = new User2AmtModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gemeinde"] = this.gemeinde ? this.gemeinde.toJSON() : <any>undefined;
        data["amt"] = this.amt ? this.amt.toJSON() : <any>undefined;
        data["jahr"] = this.jahr;
        data["set"] = this.set;
        data["bereitsZugewiesen"] = this.bereitsZugewiesen;
        data["id"] = this.id;
        return data;
    }
}

export interface IUser2AmtModel {
    gemeinde?: Gemeinden;
    amt?: Ebenen;
    jahr?: number;
    set?: boolean;
    bereitsZugewiesen?: boolean;
    id?: string | undefined;
}

export class UserKennzahlenVglSettingsModel implements IUserKennzahlenVglSettingsModel {
    kennzahlenSpalten?: string[] | undefined;
    weitereSpalten?: string[] | undefined;
    bundeslaender?: string[] | undefined;
    gemeindearten?: number[] | undefined;
    buchungsstile?: string[] | undefined;
    einwohner?: string[] | undefined;

    constructor(data?: IUserKennzahlenVglSettingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["kennzahlenSpalten"])) {
                this.kennzahlenSpalten = [] as any;
                for (let item of _data["kennzahlenSpalten"])
                    this.kennzahlenSpalten!.push(item);
            }
            if (Array.isArray(_data["weitereSpalten"])) {
                this.weitereSpalten = [] as any;
                for (let item of _data["weitereSpalten"])
                    this.weitereSpalten!.push(item);
            }
            if (Array.isArray(_data["bundeslaender"])) {
                this.bundeslaender = [] as any;
                for (let item of _data["bundeslaender"])
                    this.bundeslaender!.push(item);
            }
            if (Array.isArray(_data["gemeindearten"])) {
                this.gemeindearten = [] as any;
                for (let item of _data["gemeindearten"])
                    this.gemeindearten!.push(item);
            }
            if (Array.isArray(_data["buchungsstile"])) {
                this.buchungsstile = [] as any;
                for (let item of _data["buchungsstile"])
                    this.buchungsstile!.push(item);
            }
            if (Array.isArray(_data["einwohner"])) {
                this.einwohner = [] as any;
                for (let item of _data["einwohner"])
                    this.einwohner!.push(item);
            }
        }
    }

    static fromJS(data: any): UserKennzahlenVglSettingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserKennzahlenVglSettingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.kennzahlenSpalten)) {
            data["kennzahlenSpalten"] = [];
            for (let item of this.kennzahlenSpalten)
                data["kennzahlenSpalten"].push(item);
        }
        if (Array.isArray(this.weitereSpalten)) {
            data["weitereSpalten"] = [];
            for (let item of this.weitereSpalten)
                data["weitereSpalten"].push(item);
        }
        if (Array.isArray(this.bundeslaender)) {
            data["bundeslaender"] = [];
            for (let item of this.bundeslaender)
                data["bundeslaender"].push(item);
        }
        if (Array.isArray(this.gemeindearten)) {
            data["gemeindearten"] = [];
            for (let item of this.gemeindearten)
                data["gemeindearten"].push(item);
        }
        if (Array.isArray(this.buchungsstile)) {
            data["buchungsstile"] = [];
            for (let item of this.buchungsstile)
                data["buchungsstile"].push(item);
        }
        if (Array.isArray(this.einwohner)) {
            data["einwohner"] = [];
            for (let item of this.einwohner)
                data["einwohner"].push(item);
        }
        return data;
    }
}

export interface IUserKennzahlenVglSettingsModel {
    kennzahlenSpalten?: string[] | undefined;
    weitereSpalten?: string[] | undefined;
    bundeslaender?: string[] | undefined;
    gemeindearten?: number[] | undefined;
    buchungsstile?: string[] | undefined;
    einwohner?: string[] | undefined;
}

export class VBDataDefinitionDoppisch implements IVBDataDefinitionDoppisch {
    id?: string | undefined;
    bezeichnung?: string | undefined;
    inkludierteGruppen?: string | undefined;
    exkludierteGruppen?: string | undefined;
    subtraktionsGruppen?: string | undefined;
    massnahme?: string | undefined;
    zeile?: string | undefined;
    zeileId?: string | undefined;
    produkt?: string | undefined;
    ebene?: string | undefined;
    berechnung?: string | undefined;
    farbe?: string | undefined;
    datenTab?: string | undefined;
    refID?: string | undefined;
    nachkommastellen?: number | undefined;
    summe?: boolean;
    ausgestellt?: boolean;
    ausgestellteSektoren?: string | undefined;
    order?: number;
    stellen?: number;
    htmlText?: string | undefined;
    wordDocRef?: string | undefined;
    jahr2HtmlText?: { [key: string]: string; } | undefined;
    jahr2WordDocRef?: { [key: string]: string; } | undefined;

    constructor(data?: IVBDataDefinitionDoppisch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
            this.inkludierteGruppen = _data["inkludierteGruppen"];
            this.exkludierteGruppen = _data["exkludierteGruppen"];
            this.subtraktionsGruppen = _data["subtraktionsGruppen"];
            this.massnahme = _data["massnahme"];
            this.zeile = _data["zeile"];
            this.zeileId = _data["zeileId"];
            this.produkt = _data["produkt"];
            this.ebene = _data["ebene"];
            this.berechnung = _data["berechnung"];
            this.farbe = _data["farbe"];
            this.datenTab = _data["datenTab"];
            this.refID = _data["refID"];
            this.nachkommastellen = _data["nachkommastellen"];
            this.summe = _data["summe"];
            this.ausgestellt = _data["ausgestellt"];
            this.ausgestellteSektoren = _data["ausgestellteSektoren"];
            this.order = _data["order"];
            this.stellen = _data["stellen"];
            this.htmlText = _data["htmlText"];
            this.wordDocRef = _data["wordDocRef"];
            if (_data["jahr2HtmlText"]) {
                this.jahr2HtmlText = {} as any;
                for (let key in _data["jahr2HtmlText"]) {
                    if (_data["jahr2HtmlText"].hasOwnProperty(key))
                        (<any>this.jahr2HtmlText)![key] = _data["jahr2HtmlText"][key];
                }
            }
            if (_data["jahr2WordDocRef"]) {
                this.jahr2WordDocRef = {} as any;
                for (let key in _data["jahr2WordDocRef"]) {
                    if (_data["jahr2WordDocRef"].hasOwnProperty(key))
                        (<any>this.jahr2WordDocRef)![key] = _data["jahr2WordDocRef"][key];
                }
            }
        }
    }

    static fromJS(data: any): VBDataDefinitionDoppisch {
        data = typeof data === 'object' ? data : {};
        let result = new VBDataDefinitionDoppisch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        data["inkludierteGruppen"] = this.inkludierteGruppen;
        data["exkludierteGruppen"] = this.exkludierteGruppen;
        data["subtraktionsGruppen"] = this.subtraktionsGruppen;
        data["massnahme"] = this.massnahme;
        data["zeile"] = this.zeile;
        data["zeileId"] = this.zeileId;
        data["produkt"] = this.produkt;
        data["ebene"] = this.ebene;
        data["berechnung"] = this.berechnung;
        data["farbe"] = this.farbe;
        data["datenTab"] = this.datenTab;
        data["refID"] = this.refID;
        data["nachkommastellen"] = this.nachkommastellen;
        data["summe"] = this.summe;
        data["ausgestellt"] = this.ausgestellt;
        data["ausgestellteSektoren"] = this.ausgestellteSektoren;
        data["order"] = this.order;
        data["stellen"] = this.stellen;
        data["htmlText"] = this.htmlText;
        data["wordDocRef"] = this.wordDocRef;
        if (this.jahr2HtmlText) {
            data["jahr2HtmlText"] = {};
            for (let key in this.jahr2HtmlText) {
                if (this.jahr2HtmlText.hasOwnProperty(key))
                    (<any>data["jahr2HtmlText"])[key] = (<any>this.jahr2HtmlText)[key];
            }
        }
        if (this.jahr2WordDocRef) {
            data["jahr2WordDocRef"] = {};
            for (let key in this.jahr2WordDocRef) {
                if (this.jahr2WordDocRef.hasOwnProperty(key))
                    (<any>data["jahr2WordDocRef"])[key] = (<any>this.jahr2WordDocRef)[key];
            }
        }
        return data;
    }
}

export interface IVBDataDefinitionDoppisch {
    id?: string | undefined;
    bezeichnung?: string | undefined;
    inkludierteGruppen?: string | undefined;
    exkludierteGruppen?: string | undefined;
    subtraktionsGruppen?: string | undefined;
    massnahme?: string | undefined;
    zeile?: string | undefined;
    zeileId?: string | undefined;
    produkt?: string | undefined;
    ebene?: string | undefined;
    berechnung?: string | undefined;
    farbe?: string | undefined;
    datenTab?: string | undefined;
    refID?: string | undefined;
    nachkommastellen?: number | undefined;
    summe?: boolean;
    ausgestellt?: boolean;
    ausgestellteSektoren?: string | undefined;
    order?: number;
    stellen?: number;
    htmlText?: string | undefined;
    wordDocRef?: string | undefined;
    jahr2HtmlText?: { [key: string]: string; } | undefined;
    jahr2WordDocRef?: { [key: string]: string; } | undefined;
}

export class VBDataDefinitionKameral implements IVBDataDefinitionKameral {
    id?: string | undefined;
    bezeichnung?: string | undefined;
    inkludierteGruppen?: string | undefined;
    exkludierteGruppen?: string | undefined;
    subtraktionsGruppen?: string | undefined;
    massnahme?: string | undefined;
    unterkonto?: string | undefined;
    gliederung?: string | undefined;
    ebene?: string | undefined;
    berechnung?: string | undefined;
    farbe?: string | undefined;
    datenTab?: string | undefined;
    refID?: string | undefined;
    nachkommastellen?: number | undefined;
    summe?: boolean;
    ausgestellt?: boolean;
    ausgestellteSektoren?: string | undefined;
    order?: number;
    stellen?: number;
    htmlText?: string | undefined;
    wordDocRef?: string | undefined;
    jahr2HtmlText?: { [key: string]: string; } | undefined;
    jahr2WordDocRef?: { [key: string]: string; } | undefined;

    constructor(data?: IVBDataDefinitionKameral) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
            this.inkludierteGruppen = _data["inkludierteGruppen"];
            this.exkludierteGruppen = _data["exkludierteGruppen"];
            this.subtraktionsGruppen = _data["subtraktionsGruppen"];
            this.massnahme = _data["massnahme"];
            this.unterkonto = _data["unterkonto"];
            this.gliederung = _data["gliederung"];
            this.ebene = _data["ebene"];
            this.berechnung = _data["berechnung"];
            this.farbe = _data["farbe"];
            this.datenTab = _data["datenTab"];
            this.refID = _data["refID"];
            this.nachkommastellen = _data["nachkommastellen"];
            this.summe = _data["summe"];
            this.ausgestellt = _data["ausgestellt"];
            this.ausgestellteSektoren = _data["ausgestellteSektoren"];
            this.order = _data["order"];
            this.stellen = _data["stellen"];
            this.htmlText = _data["htmlText"];
            this.wordDocRef = _data["wordDocRef"];
            if (_data["jahr2HtmlText"]) {
                this.jahr2HtmlText = {} as any;
                for (let key in _data["jahr2HtmlText"]) {
                    if (_data["jahr2HtmlText"].hasOwnProperty(key))
                        (<any>this.jahr2HtmlText)![key] = _data["jahr2HtmlText"][key];
                }
            }
            if (_data["jahr2WordDocRef"]) {
                this.jahr2WordDocRef = {} as any;
                for (let key in _data["jahr2WordDocRef"]) {
                    if (_data["jahr2WordDocRef"].hasOwnProperty(key))
                        (<any>this.jahr2WordDocRef)![key] = _data["jahr2WordDocRef"][key];
                }
            }
        }
    }

    static fromJS(data: any): VBDataDefinitionKameral {
        data = typeof data === 'object' ? data : {};
        let result = new VBDataDefinitionKameral();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        data["inkludierteGruppen"] = this.inkludierteGruppen;
        data["exkludierteGruppen"] = this.exkludierteGruppen;
        data["subtraktionsGruppen"] = this.subtraktionsGruppen;
        data["massnahme"] = this.massnahme;
        data["unterkonto"] = this.unterkonto;
        data["gliederung"] = this.gliederung;
        data["ebene"] = this.ebene;
        data["berechnung"] = this.berechnung;
        data["farbe"] = this.farbe;
        data["datenTab"] = this.datenTab;
        data["refID"] = this.refID;
        data["nachkommastellen"] = this.nachkommastellen;
        data["summe"] = this.summe;
        data["ausgestellt"] = this.ausgestellt;
        data["ausgestellteSektoren"] = this.ausgestellteSektoren;
        data["order"] = this.order;
        data["stellen"] = this.stellen;
        data["htmlText"] = this.htmlText;
        data["wordDocRef"] = this.wordDocRef;
        if (this.jahr2HtmlText) {
            data["jahr2HtmlText"] = {};
            for (let key in this.jahr2HtmlText) {
                if (this.jahr2HtmlText.hasOwnProperty(key))
                    (<any>data["jahr2HtmlText"])[key] = (<any>this.jahr2HtmlText)[key];
            }
        }
        if (this.jahr2WordDocRef) {
            data["jahr2WordDocRef"] = {};
            for (let key in this.jahr2WordDocRef) {
                if (this.jahr2WordDocRef.hasOwnProperty(key))
                    (<any>data["jahr2WordDocRef"])[key] = (<any>this.jahr2WordDocRef)[key];
            }
        }
        return data;
    }
}

export interface IVBDataDefinitionKameral {
    id?: string | undefined;
    bezeichnung?: string | undefined;
    inkludierteGruppen?: string | undefined;
    exkludierteGruppen?: string | undefined;
    subtraktionsGruppen?: string | undefined;
    massnahme?: string | undefined;
    unterkonto?: string | undefined;
    gliederung?: string | undefined;
    ebene?: string | undefined;
    berechnung?: string | undefined;
    farbe?: string | undefined;
    datenTab?: string | undefined;
    refID?: string | undefined;
    nachkommastellen?: number | undefined;
    summe?: boolean;
    ausgestellt?: boolean;
    ausgestellteSektoren?: string | undefined;
    order?: number;
    stellen?: number;
    htmlText?: string | undefined;
    wordDocRef?: string | undefined;
    jahr2HtmlText?: { [key: string]: string; } | undefined;
    jahr2WordDocRef?: { [key: string]: string; } | undefined;
}

export class VBPlatzhalterDoppischModel implements IVBPlatzhalterDoppischModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    bezeichnung?: string | undefined;
    variable?: string | undefined;
    jahr?: number | undefined;
    nachkommastellen?: number | undefined;
    betrachtungsTyp?: string | undefined;
    platzhalterTyp?: string | undefined;
    bildEinstellungen?: string | undefined;
    anzahlJahre?: number | undefined;
    tabellenEinstellungen?: string | undefined;
    code?: number | undefined;
    definition?: string | undefined;
    investEinstellungen?: string | undefined;
    berichttyp?: number | undefined;
    test?: number | undefined;
    plantyp?: number | undefined;
    vgl?: boolean | undefined;
    bundesland?: string | undefined;
    erlTextDarstellung?: number | undefined;
    bildEinstellungenObj?: BildEinstellungen;
    tabellenEinstellungenObj?: TabellenEinstellungen;
    investEinstellungenObj?: InvestEinstellungen;
    defUeberschrieben?: string | undefined;
    datenDefintionenUeberschrieben?: VBDataDefinitionDoppisch[] | undefined;
    datenDefintionen?: VBDataDefinitionDoppisch[] | undefined;
    readonly datenDefintionenFinal?: VBDataDefinitionDoppisch[] | undefined;
    cellMap?: { [key: string]: VBPlatzhalterDoppischModel; } | undefined;
    cell?: Cell;

    constructor(data?: IVBPlatzhalterDoppischModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.bezeichnung = _data["bezeichnung"];
            this.variable = _data["variable"];
            this.jahr = _data["jahr"];
            this.nachkommastellen = _data["nachkommastellen"];
            this.betrachtungsTyp = _data["betrachtungsTyp"];
            this.platzhalterTyp = _data["platzhalterTyp"];
            this.bildEinstellungen = _data["bildEinstellungen"];
            this.anzahlJahre = _data["anzahlJahre"];
            this.tabellenEinstellungen = _data["tabellenEinstellungen"];
            this.code = _data["code"];
            this.definition = _data["definition"];
            this.investEinstellungen = _data["investEinstellungen"];
            this.berichttyp = _data["berichttyp"];
            this.test = _data["test"];
            this.plantyp = _data["plantyp"];
            this.vgl = _data["vgl"];
            this.bundesland = _data["bundesland"];
            this.erlTextDarstellung = _data["erlTextDarstellung"];
            this.bildEinstellungenObj = _data["bildEinstellungenObj"] ? BildEinstellungen.fromJS(_data["bildEinstellungenObj"]) : <any>undefined;
            this.tabellenEinstellungenObj = _data["tabellenEinstellungenObj"] ? TabellenEinstellungen.fromJS(_data["tabellenEinstellungenObj"]) : <any>undefined;
            this.investEinstellungenObj = _data["investEinstellungenObj"] ? InvestEinstellungen.fromJS(_data["investEinstellungenObj"]) : <any>undefined;
            this.defUeberschrieben = _data["defUeberschrieben"];
            if (Array.isArray(_data["datenDefintionenUeberschrieben"])) {
                this.datenDefintionenUeberschrieben = [] as any;
                for (let item of _data["datenDefintionenUeberschrieben"])
                    this.datenDefintionenUeberschrieben!.push(VBDataDefinitionDoppisch.fromJS(item));
            }
            if (Array.isArray(_data["datenDefintionen"])) {
                this.datenDefintionen = [] as any;
                for (let item of _data["datenDefintionen"])
                    this.datenDefintionen!.push(VBDataDefinitionDoppisch.fromJS(item));
            }
            if (Array.isArray(_data["datenDefintionenFinal"])) {
                (<any>this).datenDefintionenFinal = [] as any;
                for (let item of _data["datenDefintionenFinal"])
                    (<any>this).datenDefintionenFinal!.push(VBDataDefinitionDoppisch.fromJS(item));
            }
            if (_data["cellMap"]) {
                this.cellMap = {} as any;
                for (let key in _data["cellMap"]) {
                    if (_data["cellMap"].hasOwnProperty(key))
                        (<any>this.cellMap)![key] = _data["cellMap"][key] ? VBPlatzhalterDoppischModel.fromJS(_data["cellMap"][key]) : new VBPlatzhalterDoppischModel();
                }
            }
            this.cell = _data["cell"] ? Cell.fromJS(_data["cell"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VBPlatzhalterDoppischModel {
        data = typeof data === 'object' ? data : {};
        let result = new VBPlatzhalterDoppischModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["bezeichnung"] = this.bezeichnung;
        data["variable"] = this.variable;
        data["jahr"] = this.jahr;
        data["nachkommastellen"] = this.nachkommastellen;
        data["betrachtungsTyp"] = this.betrachtungsTyp;
        data["platzhalterTyp"] = this.platzhalterTyp;
        data["bildEinstellungen"] = this.bildEinstellungen;
        data["anzahlJahre"] = this.anzahlJahre;
        data["tabellenEinstellungen"] = this.tabellenEinstellungen;
        data["code"] = this.code;
        data["definition"] = this.definition;
        data["investEinstellungen"] = this.investEinstellungen;
        data["berichttyp"] = this.berichttyp;
        data["test"] = this.test;
        data["plantyp"] = this.plantyp;
        data["vgl"] = this.vgl;
        data["bundesland"] = this.bundesland;
        data["erlTextDarstellung"] = this.erlTextDarstellung;
        data["bildEinstellungenObj"] = this.bildEinstellungenObj ? this.bildEinstellungenObj.toJSON() : <any>undefined;
        data["tabellenEinstellungenObj"] = this.tabellenEinstellungenObj ? this.tabellenEinstellungenObj.toJSON() : <any>undefined;
        data["investEinstellungenObj"] = this.investEinstellungenObj ? this.investEinstellungenObj.toJSON() : <any>undefined;
        data["defUeberschrieben"] = this.defUeberschrieben;
        if (Array.isArray(this.datenDefintionenUeberschrieben)) {
            data["datenDefintionenUeberschrieben"] = [];
            for (let item of this.datenDefintionenUeberschrieben)
                data["datenDefintionenUeberschrieben"].push(item.toJSON());
        }
        if (Array.isArray(this.datenDefintionen)) {
            data["datenDefintionen"] = [];
            for (let item of this.datenDefintionen)
                data["datenDefintionen"].push(item.toJSON());
        }
        if (Array.isArray(this.datenDefintionenFinal)) {
            data["datenDefintionenFinal"] = [];
            for (let item of this.datenDefintionenFinal)
                data["datenDefintionenFinal"].push(item.toJSON());
        }
        if (this.cellMap) {
            data["cellMap"] = {};
            for (let key in this.cellMap) {
                if (this.cellMap.hasOwnProperty(key))
                    (<any>data["cellMap"])[key] = this.cellMap[key] ? this.cellMap[key].toJSON() : <any>undefined;
            }
        }
        data["cell"] = this.cell ? this.cell.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVBPlatzhalterDoppischModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    bezeichnung?: string | undefined;
    variable?: string | undefined;
    jahr?: number | undefined;
    nachkommastellen?: number | undefined;
    betrachtungsTyp?: string | undefined;
    platzhalterTyp?: string | undefined;
    bildEinstellungen?: string | undefined;
    anzahlJahre?: number | undefined;
    tabellenEinstellungen?: string | undefined;
    code?: number | undefined;
    definition?: string | undefined;
    investEinstellungen?: string | undefined;
    berichttyp?: number | undefined;
    test?: number | undefined;
    plantyp?: number | undefined;
    vgl?: boolean | undefined;
    bundesland?: string | undefined;
    erlTextDarstellung?: number | undefined;
    bildEinstellungenObj?: BildEinstellungen;
    tabellenEinstellungenObj?: TabellenEinstellungen;
    investEinstellungenObj?: InvestEinstellungen;
    defUeberschrieben?: string | undefined;
    datenDefintionenUeberschrieben?: VBDataDefinitionDoppisch[] | undefined;
    datenDefintionen?: VBDataDefinitionDoppisch[] | undefined;
    datenDefintionenFinal?: VBDataDefinitionDoppisch[] | undefined;
    cellMap?: { [key: string]: VBPlatzhalterDoppischModel; } | undefined;
    cell?: Cell;
}

export class VBPlatzhalterKameralModel implements IVBPlatzhalterKameralModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    bezeichnung?: string | undefined;
    variable?: string | undefined;
    jahr?: number | undefined;
    nachkommastellen?: number | undefined;
    betrachtungsTyp?: string | undefined;
    platzhalterTyp?: string | undefined;
    bildEinstellungen?: string | undefined;
    anzahlJahre?: number | undefined;
    tabellenEinstellungen?: string | undefined;
    code?: number | undefined;
    definition?: string | undefined;
    investEinstellungen?: string | undefined;
    berichttyp?: number | undefined;
    test?: number | undefined;
    vgl?: boolean | undefined;
    bundesland?: string | undefined;
    erlTextDarstellung?: number | undefined;
    bildEinstellungenObj?: BildEinstellungen;
    tabellenEinstellungenObj?: TabellenEinstellungen;
    investEinstellungenObj?: InvestEinstellungen;
    defUeberschrieben?: string | undefined;
    datenDefintionenUeberschrieben?: VBDataDefinitionKameral[] | undefined;
    datenDefintionen?: VBDataDefinitionKameral[] | undefined;
    readonly datenDefintionenFinal?: VBDataDefinitionKameral[] | undefined;
    cellMap?: { [key: string]: VBPlatzhalterKameralModel; } | undefined;
    cell?: Cell;

    constructor(data?: IVBPlatzhalterKameralModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.bezeichnung = _data["bezeichnung"];
            this.variable = _data["variable"];
            this.jahr = _data["jahr"];
            this.nachkommastellen = _data["nachkommastellen"];
            this.betrachtungsTyp = _data["betrachtungsTyp"];
            this.platzhalterTyp = _data["platzhalterTyp"];
            this.bildEinstellungen = _data["bildEinstellungen"];
            this.anzahlJahre = _data["anzahlJahre"];
            this.tabellenEinstellungen = _data["tabellenEinstellungen"];
            this.code = _data["code"];
            this.definition = _data["definition"];
            this.investEinstellungen = _data["investEinstellungen"];
            this.berichttyp = _data["berichttyp"];
            this.test = _data["test"];
            this.vgl = _data["vgl"];
            this.bundesland = _data["bundesland"];
            this.erlTextDarstellung = _data["erlTextDarstellung"];
            this.bildEinstellungenObj = _data["bildEinstellungenObj"] ? BildEinstellungen.fromJS(_data["bildEinstellungenObj"]) : <any>undefined;
            this.tabellenEinstellungenObj = _data["tabellenEinstellungenObj"] ? TabellenEinstellungen.fromJS(_data["tabellenEinstellungenObj"]) : <any>undefined;
            this.investEinstellungenObj = _data["investEinstellungenObj"] ? InvestEinstellungen.fromJS(_data["investEinstellungenObj"]) : <any>undefined;
            this.defUeberschrieben = _data["defUeberschrieben"];
            if (Array.isArray(_data["datenDefintionenUeberschrieben"])) {
                this.datenDefintionenUeberschrieben = [] as any;
                for (let item of _data["datenDefintionenUeberschrieben"])
                    this.datenDefintionenUeberschrieben!.push(VBDataDefinitionKameral.fromJS(item));
            }
            if (Array.isArray(_data["datenDefintionen"])) {
                this.datenDefintionen = [] as any;
                for (let item of _data["datenDefintionen"])
                    this.datenDefintionen!.push(VBDataDefinitionKameral.fromJS(item));
            }
            if (Array.isArray(_data["datenDefintionenFinal"])) {
                (<any>this).datenDefintionenFinal = [] as any;
                for (let item of _data["datenDefintionenFinal"])
                    (<any>this).datenDefintionenFinal!.push(VBDataDefinitionKameral.fromJS(item));
            }
            if (_data["cellMap"]) {
                this.cellMap = {} as any;
                for (let key in _data["cellMap"]) {
                    if (_data["cellMap"].hasOwnProperty(key))
                        (<any>this.cellMap)![key] = _data["cellMap"][key] ? VBPlatzhalterKameralModel.fromJS(_data["cellMap"][key]) : new VBPlatzhalterKameralModel();
                }
            }
            this.cell = _data["cell"] ? Cell.fromJS(_data["cell"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VBPlatzhalterKameralModel {
        data = typeof data === 'object' ? data : {};
        let result = new VBPlatzhalterKameralModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["bezeichnung"] = this.bezeichnung;
        data["variable"] = this.variable;
        data["jahr"] = this.jahr;
        data["nachkommastellen"] = this.nachkommastellen;
        data["betrachtungsTyp"] = this.betrachtungsTyp;
        data["platzhalterTyp"] = this.platzhalterTyp;
        data["bildEinstellungen"] = this.bildEinstellungen;
        data["anzahlJahre"] = this.anzahlJahre;
        data["tabellenEinstellungen"] = this.tabellenEinstellungen;
        data["code"] = this.code;
        data["definition"] = this.definition;
        data["investEinstellungen"] = this.investEinstellungen;
        data["berichttyp"] = this.berichttyp;
        data["test"] = this.test;
        data["vgl"] = this.vgl;
        data["bundesland"] = this.bundesland;
        data["erlTextDarstellung"] = this.erlTextDarstellung;
        data["bildEinstellungenObj"] = this.bildEinstellungenObj ? this.bildEinstellungenObj.toJSON() : <any>undefined;
        data["tabellenEinstellungenObj"] = this.tabellenEinstellungenObj ? this.tabellenEinstellungenObj.toJSON() : <any>undefined;
        data["investEinstellungenObj"] = this.investEinstellungenObj ? this.investEinstellungenObj.toJSON() : <any>undefined;
        data["defUeberschrieben"] = this.defUeberschrieben;
        if (Array.isArray(this.datenDefintionenUeberschrieben)) {
            data["datenDefintionenUeberschrieben"] = [];
            for (let item of this.datenDefintionenUeberschrieben)
                data["datenDefintionenUeberschrieben"].push(item.toJSON());
        }
        if (Array.isArray(this.datenDefintionen)) {
            data["datenDefintionen"] = [];
            for (let item of this.datenDefintionen)
                data["datenDefintionen"].push(item.toJSON());
        }
        if (Array.isArray(this.datenDefintionenFinal)) {
            data["datenDefintionenFinal"] = [];
            for (let item of this.datenDefintionenFinal)
                data["datenDefintionenFinal"].push(item.toJSON());
        }
        if (this.cellMap) {
            data["cellMap"] = {};
            for (let key in this.cellMap) {
                if (this.cellMap.hasOwnProperty(key))
                    (<any>data["cellMap"])[key] = this.cellMap[key] ? this.cellMap[key].toJSON() : <any>undefined;
            }
        }
        data["cell"] = this.cell ? this.cell.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVBPlatzhalterKameralModel {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    bezeichnung?: string | undefined;
    variable?: string | undefined;
    jahr?: number | undefined;
    nachkommastellen?: number | undefined;
    betrachtungsTyp?: string | undefined;
    platzhalterTyp?: string | undefined;
    bildEinstellungen?: string | undefined;
    anzahlJahre?: number | undefined;
    tabellenEinstellungen?: string | undefined;
    code?: number | undefined;
    definition?: string | undefined;
    investEinstellungen?: string | undefined;
    berichttyp?: number | undefined;
    test?: number | undefined;
    vgl?: boolean | undefined;
    bundesland?: string | undefined;
    erlTextDarstellung?: number | undefined;
    bildEinstellungenObj?: BildEinstellungen;
    tabellenEinstellungenObj?: TabellenEinstellungen;
    investEinstellungenObj?: InvestEinstellungen;
    defUeberschrieben?: string | undefined;
    datenDefintionenUeberschrieben?: VBDataDefinitionKameral[] | undefined;
    datenDefintionen?: VBDataDefinitionKameral[] | undefined;
    datenDefintionenFinal?: VBDataDefinitionKameral[] | undefined;
    cellMap?: { [key: string]: VBPlatzhalterKameralModel; } | undefined;
    cell?: Cell;
}

export class VbplatzhalterBetrachtungsTypenDoppisch implements IVbplatzhalterBetrachtungsTypenDoppisch {
    id?: string | undefined;
    bezeichnung?: string | undefined;

    constructor(data?: IVbplatzhalterBetrachtungsTypenDoppisch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
        }
    }

    static fromJS(data: any): VbplatzhalterBetrachtungsTypenDoppisch {
        data = typeof data === 'object' ? data : {};
        let result = new VbplatzhalterBetrachtungsTypenDoppisch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        return data;
    }
}

export interface IVbplatzhalterBetrachtungsTypenDoppisch {
    id?: string | undefined;
    bezeichnung?: string | undefined;
}

export class VbplatzhalterBetrachtungsTypenKameral implements IVbplatzhalterBetrachtungsTypenKameral {
    id?: string | undefined;
    bezeichnung?: string | undefined;

    constructor(data?: IVbplatzhalterBetrachtungsTypenKameral) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
        }
    }

    static fromJS(data: any): VbplatzhalterBetrachtungsTypenKameral {
        data = typeof data === 'object' ? data : {};
        let result = new VbplatzhalterBetrachtungsTypenKameral();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        return data;
    }
}

export interface IVbplatzhalterBetrachtungsTypenKameral {
    id?: string | undefined;
    bezeichnung?: string | undefined;
}

export class VbplatzhalterJahre implements IVbplatzhalterJahre {
    jahr?: number | undefined;
    bezeichnung?: string | undefined;

    constructor(data?: IVbplatzhalterJahre) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jahr = _data["jahr"];
            this.bezeichnung = _data["bezeichnung"];
        }
    }

    static fromJS(data: any): VbplatzhalterJahre {
        data = typeof data === 'object' ? data : {};
        let result = new VbplatzhalterJahre();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jahr"] = this.jahr;
        data["bezeichnung"] = this.bezeichnung;
        return data;
    }
}

export interface IVbplatzhalterJahre {
    jahr?: number | undefined;
    bezeichnung?: string | undefined;
}

export class VbplatzhalterTypenDoppisch implements IVbplatzhalterTypenDoppisch {
    id?: string | undefined;
    bezeichnung?: string | undefined;
    system?: boolean | undefined;

    constructor(data?: IVbplatzhalterTypenDoppisch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
            this.system = _data["system"];
        }
    }

    static fromJS(data: any): VbplatzhalterTypenDoppisch {
        data = typeof data === 'object' ? data : {};
        let result = new VbplatzhalterTypenDoppisch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        data["system"] = this.system;
        return data;
    }
}

export interface IVbplatzhalterTypenDoppisch {
    id?: string | undefined;
    bezeichnung?: string | undefined;
    system?: boolean | undefined;
}

export class VbplatzhalterTypenKameral implements IVbplatzhalterTypenKameral {
    id?: string | undefined;
    bezeichnung?: string | undefined;
    system?: boolean | undefined;

    constructor(data?: IVbplatzhalterTypenKameral) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
            this.system = _data["system"];
        }
    }

    static fromJS(data: any): VbplatzhalterTypenKameral {
        data = typeof data === 'object' ? data : {};
        let result = new VbplatzhalterTypenKameral();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        data["system"] = this.system;
        return data;
    }
}

export interface IVbplatzhalterTypenKameral {
    id?: string | undefined;
    bezeichnung?: string | undefined;
    system?: boolean | undefined;
}

export class VbplatzhalterZuordnungDoppisch implements IVbplatzhalterZuordnungDoppisch {
    id?: number;
    textPlatzhalterId?: number;
    zielPlatzhalterId?: number;
    kunde?: number;
    gemeinde?: number;

    constructor(data?: IVbplatzhalterZuordnungDoppisch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.textPlatzhalterId = _data["textPlatzhalterId"];
            this.zielPlatzhalterId = _data["zielPlatzhalterId"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
        }
    }

    static fromJS(data: any): VbplatzhalterZuordnungDoppisch {
        data = typeof data === 'object' ? data : {};
        let result = new VbplatzhalterZuordnungDoppisch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["textPlatzhalterId"] = this.textPlatzhalterId;
        data["zielPlatzhalterId"] = this.zielPlatzhalterId;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        return data;
    }
}

export interface IVbplatzhalterZuordnungDoppisch {
    id?: number;
    textPlatzhalterId?: number;
    zielPlatzhalterId?: number;
    kunde?: number;
    gemeinde?: number;
}

export class VbplatzhalterZuordnungKameral implements IVbplatzhalterZuordnungKameral {
    id?: number;
    textPlatzhalterId?: number;
    zielPlatzhalterId?: number;
    kunde?: number;
    gemeinde?: number;

    constructor(data?: IVbplatzhalterZuordnungKameral) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.textPlatzhalterId = _data["textPlatzhalterId"];
            this.zielPlatzhalterId = _data["zielPlatzhalterId"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
        }
    }

    static fromJS(data: any): VbplatzhalterZuordnungKameral {
        data = typeof data === 'object' ? data : {};
        let result = new VbplatzhalterZuordnungKameral();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["textPlatzhalterId"] = this.textPlatzhalterId;
        data["zielPlatzhalterId"] = this.zielPlatzhalterId;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        return data;
    }
}

export interface IVbplatzhalterZuordnungKameral {
    id?: number;
    textPlatzhalterId?: number;
    zielPlatzhalterId?: number;
    kunde?: number;
    gemeinde?: number;
}

export class Vbtab implements IVbtab {
    tabId?: string | undefined;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    istOberTab?: boolean;
    obertab?: string | undefined;
    tabTyp?: number;
    order?: number | undefined;
    axis1Bezeichnung?: string | undefined;
    axis2Bezeichnung?: string | undefined;
    nichtHp?: boolean | undefined;
    nichtJr?: boolean | undefined;
    gemeinden?: Gemeinden;

    constructor(data?: IVbtab) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tabId = _data["tabId"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.jahr = _data["jahr"];
            this.bezeichnung = _data["bezeichnung"];
            this.istOberTab = _data["istOberTab"];
            this.obertab = _data["obertab"];
            this.tabTyp = _data["tabTyp"];
            this.order = _data["order"];
            this.axis1Bezeichnung = _data["axis1Bezeichnung"];
            this.axis2Bezeichnung = _data["axis2Bezeichnung"];
            this.nichtHp = _data["nichtHp"];
            this.nichtJr = _data["nichtJr"];
            this.gemeinden = _data["gemeinden"] ? Gemeinden.fromJS(_data["gemeinden"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Vbtab {
        data = typeof data === 'object' ? data : {};
        let result = new Vbtab();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tabId"] = this.tabId;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["jahr"] = this.jahr;
        data["bezeichnung"] = this.bezeichnung;
        data["istOberTab"] = this.istOberTab;
        data["obertab"] = this.obertab;
        data["tabTyp"] = this.tabTyp;
        data["order"] = this.order;
        data["axis1Bezeichnung"] = this.axis1Bezeichnung;
        data["axis2Bezeichnung"] = this.axis2Bezeichnung;
        data["nichtHp"] = this.nichtHp;
        data["nichtJr"] = this.nichtJr;
        data["gemeinden"] = this.gemeinden ? this.gemeinden.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVbtab {
    tabId?: string | undefined;
    kunde?: number;
    gemeinde?: number;
    jahr?: number;
    bezeichnung?: string | undefined;
    istOberTab?: boolean;
    obertab?: string | undefined;
    tabTyp?: number;
    order?: number | undefined;
    axis1Bezeichnung?: string | undefined;
    axis2Bezeichnung?: string | undefined;
    nichtHp?: boolean | undefined;
    nichtJr?: boolean | undefined;
    gemeinden?: Gemeinden;
}

export class VbtabTypen implements IVbtabTypen {
    id?: number | undefined;
    bezeichnung?: string | undefined;
    ordnungszahl?: number | undefined;

    constructor(data?: IVbtabTypen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
            this.ordnungszahl = _data["ordnungszahl"];
        }
    }

    static fromJS(data: any): VbtabTypen {
        data = typeof data === 'object' ? data : {};
        let result = new VbtabTypen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        data["ordnungszahl"] = this.ordnungszahl;
        return data;
    }
}

export interface IVbtabTypen {
    id?: number | undefined;
    bezeichnung?: string | undefined;
    ordnungszahl?: number | undefined;
}

export class VbtabTypenDoppisch implements IVbtabTypenDoppisch {
    id?: number | undefined;
    bezeichnung?: string | undefined;
    ordnungszahl?: number | undefined;

    constructor(data?: IVbtabTypenDoppisch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
            this.ordnungszahl = _data["ordnungszahl"];
        }
    }

    static fromJS(data: any): VbtabTypenDoppisch {
        data = typeof data === 'object' ? data : {};
        let result = new VbtabTypenDoppisch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        data["ordnungszahl"] = this.ordnungszahl;
        return data;
    }
}

export interface IVbtabTypenDoppisch {
    id?: number | undefined;
    bezeichnung?: string | undefined;
    ordnungszahl?: number | undefined;
}

export class Vermoegensart implements IVermoegensart {
    id?: number;
    bezeichnung?: string | undefined;
    ausgaben?: boolean;
    vermoegenstypen?: Vermoegenstypen[] | undefined;

    constructor(data?: IVermoegensart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
            this.ausgaben = _data["ausgaben"];
            if (Array.isArray(_data["vermoegenstypen"])) {
                this.vermoegenstypen = [] as any;
                for (let item of _data["vermoegenstypen"])
                    this.vermoegenstypen!.push(Vermoegenstypen.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Vermoegensart {
        data = typeof data === 'object' ? data : {};
        let result = new Vermoegensart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        data["ausgaben"] = this.ausgaben;
        if (Array.isArray(this.vermoegenstypen)) {
            data["vermoegenstypen"] = [];
            for (let item of this.vermoegenstypen)
                data["vermoegenstypen"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVermoegensart {
    id?: number;
    bezeichnung?: string | undefined;
    ausgaben?: boolean;
    vermoegenstypen?: Vermoegenstypen[] | undefined;
}

export class VermoegensartDoppisch implements IVermoegensartDoppisch {
    id?: number;
    bezeichnung?: string | undefined;
    ausgaben?: boolean;
    vermoegenstypen?: VermoegenstypenDoppisch[] | undefined;

    constructor(data?: IVermoegensartDoppisch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
            this.ausgaben = _data["ausgaben"];
            if (Array.isArray(_data["vermoegenstypen"])) {
                this.vermoegenstypen = [] as any;
                for (let item of _data["vermoegenstypen"])
                    this.vermoegenstypen!.push(VermoegenstypenDoppisch.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VermoegensartDoppisch {
        data = typeof data === 'object' ? data : {};
        let result = new VermoegensartDoppisch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        data["ausgaben"] = this.ausgaben;
        if (Array.isArray(this.vermoegenstypen)) {
            data["vermoegenstypen"] = [];
            for (let item of this.vermoegenstypen)
                data["vermoegenstypen"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVermoegensartDoppisch {
    id?: number;
    bezeichnung?: string | undefined;
    ausgaben?: boolean;
    vermoegenstypen?: VermoegenstypenDoppisch[] | undefined;
}

export class Vermoegenstypen implements IVermoegenstypen {
    id?: number;
    bezeichnung?: string | undefined;
    ausgaben?: boolean;
    vermoegensart?: number;

    constructor(data?: IVermoegenstypen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
            this.ausgaben = _data["ausgaben"];
            this.vermoegensart = _data["vermoegensart"];
        }
    }

    static fromJS(data: any): Vermoegenstypen {
        data = typeof data === 'object' ? data : {};
        let result = new Vermoegenstypen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        data["ausgaben"] = this.ausgaben;
        data["vermoegensart"] = this.vermoegensart;
        return data;
    }
}

export interface IVermoegenstypen {
    id?: number;
    bezeichnung?: string | undefined;
    ausgaben?: boolean;
    vermoegensart?: number;
}

export class VermoegenstypenDoppisch implements IVermoegenstypenDoppisch {
    id?: number;
    bundesland?: string | undefined;
    bezeichnung?: string | undefined;
    ausgaben?: boolean;
    vermoegensart?: number;

    constructor(data?: IVermoegenstypenDoppisch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bundesland = _data["bundesland"];
            this.bezeichnung = _data["bezeichnung"];
            this.ausgaben = _data["ausgaben"];
            this.vermoegensart = _data["vermoegensart"];
        }
    }

    static fromJS(data: any): VermoegenstypenDoppisch {
        data = typeof data === 'object' ? data : {};
        let result = new VermoegenstypenDoppisch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bundesland"] = this.bundesland;
        data["bezeichnung"] = this.bezeichnung;
        data["ausgaben"] = this.ausgaben;
        data["vermoegensart"] = this.vermoegensart;
        return data;
    }
}

export interface IVermoegenstypenDoppisch {
    id?: number;
    bundesland?: string | undefined;
    bezeichnung?: string | undefined;
    ausgaben?: boolean;
    vermoegensart?: number;
}

export enum VerticalGlyphOrientation {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class WegweiserGemeinden implements IWegweiserGemeinden {
    id?: number;
    name?: string | undefined;
    friendlyUrl?: string | undefined;
    wegweiserId?: number | undefined;
    gemeindens?: Gemeinden[] | undefined;

    constructor(data?: IWegweiserGemeinden) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.friendlyUrl = _data["friendlyUrl"];
            this.wegweiserId = _data["wegweiserId"];
            if (Array.isArray(_data["gemeindens"])) {
                this.gemeindens = [] as any;
                for (let item of _data["gemeindens"])
                    this.gemeindens!.push(Gemeinden.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WegweiserGemeinden {
        data = typeof data === 'object' ? data : {};
        let result = new WegweiserGemeinden();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["friendlyUrl"] = this.friendlyUrl;
        data["wegweiserId"] = this.wegweiserId;
        if (Array.isArray(this.gemeindens)) {
            data["gemeindens"] = [];
            for (let item of this.gemeindens)
                data["gemeindens"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWegweiserGemeinden {
    id?: number;
    name?: string | undefined;
    friendlyUrl?: string | undefined;
    wegweiserId?: number | undefined;
    gemeindens?: Gemeinden[] | undefined;
}

export class WegweiserIndikator implements IWegweiserIndikator {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    unit?: string | undefined;
    friendlyUrl?: string | undefined;
    wegweiserId?: number | undefined;
    calculation?: string | undefined;
    topics?: string | undefined;
    prognose?: boolean | undefined;
    datensaetzes?: Datensaetze[] | undefined;
    wegweiserVerfuegbareIndikatorens?: WegweiserVerfuegbareIndikatoren[] | undefined;

    constructor(data?: IWegweiserIndikator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.unit = _data["unit"];
            this.friendlyUrl = _data["friendlyUrl"];
            this.wegweiserId = _data["wegweiserId"];
            this.calculation = _data["calculation"];
            this.topics = _data["topics"];
            this.prognose = _data["prognose"];
            if (Array.isArray(_data["datensaetzes"])) {
                this.datensaetzes = [] as any;
                for (let item of _data["datensaetzes"])
                    this.datensaetzes!.push(Datensaetze.fromJS(item));
            }
            if (Array.isArray(_data["wegweiserVerfuegbareIndikatorens"])) {
                this.wegweiserVerfuegbareIndikatorens = [] as any;
                for (let item of _data["wegweiserVerfuegbareIndikatorens"])
                    this.wegweiserVerfuegbareIndikatorens!.push(WegweiserVerfuegbareIndikatoren.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WegweiserIndikator {
        data = typeof data === 'object' ? data : {};
        let result = new WegweiserIndikator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["unit"] = this.unit;
        data["friendlyUrl"] = this.friendlyUrl;
        data["wegweiserId"] = this.wegweiserId;
        data["calculation"] = this.calculation;
        data["topics"] = this.topics;
        data["prognose"] = this.prognose;
        if (Array.isArray(this.datensaetzes)) {
            data["datensaetzes"] = [];
            for (let item of this.datensaetzes)
                data["datensaetzes"].push(item.toJSON());
        }
        if (Array.isArray(this.wegweiserVerfuegbareIndikatorens)) {
            data["wegweiserVerfuegbareIndikatorens"] = [];
            for (let item of this.wegweiserVerfuegbareIndikatorens)
                data["wegweiserVerfuegbareIndikatorens"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWegweiserIndikator {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    unit?: string | undefined;
    friendlyUrl?: string | undefined;
    wegweiserId?: number | undefined;
    calculation?: string | undefined;
    topics?: string | undefined;
    prognose?: boolean | undefined;
    datensaetzes?: Datensaetze[] | undefined;
    wegweiserVerfuegbareIndikatorens?: WegweiserVerfuegbareIndikatoren[] | undefined;
}

export class WegweiserVerfuegbareIndikatoren implements IWegweiserVerfuegbareIndikatoren {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    indikatorId?: number;
    gefundenAm?: Date;
    indikator?: WegweiserIndikator;

    constructor(data?: IWegweiserVerfuegbareIndikatoren) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kunde = _data["kunde"];
            this.gemeinde = _data["gemeinde"];
            this.indikatorId = _data["indikatorId"];
            this.gefundenAm = _data["gefundenAm"] ? new Date(_data["gefundenAm"].toString()) : <any>undefined;
            this.indikator = _data["indikator"] ? WegweiserIndikator.fromJS(_data["indikator"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WegweiserVerfuegbareIndikatoren {
        data = typeof data === 'object' ? data : {};
        let result = new WegweiserVerfuegbareIndikatoren();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kunde"] = this.kunde;
        data["gemeinde"] = this.gemeinde;
        data["indikatorId"] = this.indikatorId;
        data["gefundenAm"] = this.gefundenAm ? this.gefundenAm.toISOString() : <any>undefined;
        data["indikator"] = this.indikator ? this.indikator.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWegweiserVerfuegbareIndikatoren {
    id?: number;
    kunde?: number;
    gemeinde?: number;
    indikatorId?: number;
    gefundenAm?: Date;
    indikator?: WegweiserIndikator;
}

export enum WritingMode {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
}

export class Zusatzangaben implements IZusatzangaben {
    id?: number;
    bezeichnung?: string | undefined;
    kennzahlzeilens?: Kennzahlzeilen[] | undefined;
    templateKennzahlzeilens?: TemplateKennzahlzeilen[] | undefined;

    constructor(data?: IZusatzangaben) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bezeichnung = _data["bezeichnung"];
            if (Array.isArray(_data["kennzahlzeilens"])) {
                this.kennzahlzeilens = [] as any;
                for (let item of _data["kennzahlzeilens"])
                    this.kennzahlzeilens!.push(Kennzahlzeilen.fromJS(item));
            }
            if (Array.isArray(_data["templateKennzahlzeilens"])) {
                this.templateKennzahlzeilens = [] as any;
                for (let item of _data["templateKennzahlzeilens"])
                    this.templateKennzahlzeilens!.push(TemplateKennzahlzeilen.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Zusatzangaben {
        data = typeof data === 'object' ? data : {};
        let result = new Zusatzangaben();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bezeichnung"] = this.bezeichnung;
        if (Array.isArray(this.kennzahlzeilens)) {
            data["kennzahlzeilens"] = [];
            for (let item of this.kennzahlzeilens)
                data["kennzahlzeilens"].push(item.toJSON());
        }
        if (Array.isArray(this.templateKennzahlzeilens)) {
            data["templateKennzahlzeilens"] = [];
            for (let item of this.templateKennzahlzeilens)
                data["templateKennzahlzeilens"].push(item.toJSON());
        }
        return data;
    }
}

export interface IZusatzangaben {
    id?: number;
    bezeichnung?: string | undefined;
    kennzahlzeilens?: Kennzahlzeilen[] | undefined;
    templateKennzahlzeilens?: TemplateKennzahlzeilen[] | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}